// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../webfonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../webfonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../webfonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../webfonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../webfonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../webfonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../webfonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../webfonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../webfonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("images/ui-icons_444444_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("images/ui-icons_555555_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("images/ui-icons_ffffff_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("images/ui-icons_777620_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("images/ui-icons_cc0000_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("images/ui-icons_777777_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2300acac%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ff5b57%27 viewBox=%27-2 -2 7 7%27%3e%3cpath stroke=%27%23ff5b57%27 d=%27M0 0l3 3m0-3L0 3%27/%3e%3ccircle r=%27.5%27/%3e%3ccircle cx=%273%27 r=%27.5%27/%3e%3ccircle cy=%273%27 r=%27.5%27/%3e%3ccircle cx=%273%27 cy=%273%27 r=%27.5%27/%3e%3c/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23FFFFFF%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23FFFFFF%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 strokeWidth=%272%27 strokeLinecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 strokeWidth=%272%27 strokeLinecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23FFFFFF%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23FFFFFF%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("images/cover-sidebar-user.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("images/cover-sidebar.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("images/cover-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("images/coming-soon.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("images/error-page-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("images/profile-cover.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * animate.css -https://daneden.github.io/animate.css/
 * Version - 3.7.2
 * Licensed under the MIT license - http://opensource.org/licenses/MIT
 *
 * Copyright (c) 2019 Daniel Eden
 */
@-webkit-keyframes bounce {
  0%,
  20%,
  53%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  40%,
  43% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}

@keyframes bounce {
  0%,
  20%,
  53%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  40%,
  43% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}

@-webkit-keyframes flash {
  0%,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

@keyframes flash {
  0%,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

@-webkit-keyframes pulse {
  0%,
  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
}

@keyframes pulse {
  0%,
  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
}

@-webkit-keyframes rubberBand {
  0%,
  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
}

@keyframes rubberBand {
  0%,
  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
}

@-webkit-keyframes shake {
  0%,
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  0%,
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@-webkit-keyframes headShake {
  0%,
  50% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  6.5% {
    -webkit-transform: translateX(-6px) rotateY(-9deg);
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    -webkit-transform: translateX(5px) rotateY(7deg);
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    -webkit-transform: translateX(-3px) rotateY(-5deg);
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    -webkit-transform: translateX(2px) rotateY(3deg);
    transform: translateX(2px) rotateY(3deg);
  }
}

@keyframes headShake {
  0%,
  50% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  6.5% {
    -webkit-transform: translateX(-6px) rotateY(-9deg);
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    -webkit-transform: translateX(5px) rotateY(7deg);
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    -webkit-transform: translateX(-3px) rotateY(-5deg);
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    -webkit-transform: translateX(2px) rotateY(3deg);
    transform: translateX(2px) rotateY(3deg);
  }
}

@-webkit-keyframes swing {
  20% {
    -webkit-transform: rotate(15deg);
    transform: rotate(15deg);
  }

  40% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }

  60% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }

  80% {
    -webkit-transform: rotate(-5deg);
    transform: rotate(-5deg);
  }

  to {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@keyframes swing {
  20% {
    -webkit-transform: rotate(15deg);
    transform: rotate(15deg);
  }

  40% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }

  60% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }

  80% {
    -webkit-transform: rotate(-5deg);
    transform: rotate(-5deg);
  }

  to {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@-webkit-keyframes tada {
  0%,
  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
  }
}

@keyframes tada {
  0%,
  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
  }
}

@-webkit-keyframes wobble {
  0%,
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  15% {
    -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
    transform: translate3d(-25%, 0, 0) rotate(-5deg);
  }

  30% {
    -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
    transform: translate3d(20%, 0, 0) rotate(3deg);
  }

  45% {
    -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
    transform: translate3d(-15%, 0, 0) rotate(-3deg);
  }

  60% {
    -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
    transform: translate3d(10%, 0, 0) rotate(2deg);
  }

  75% {
    -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
    transform: translate3d(-5%, 0, 0) rotate(-1deg);
  }
}

@keyframes wobble {
  0%,
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  15% {
    -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
    transform: translate3d(-25%, 0, 0) rotate(-5deg);
  }

  30% {
    -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
    transform: translate3d(20%, 0, 0) rotate(3deg);
  }

  45% {
    -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
    transform: translate3d(-15%, 0, 0) rotate(-3deg);
  }

  60% {
    -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
    transform: translate3d(10%, 0, 0) rotate(2deg);
  }

  75% {
    -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
    transform: translate3d(-5%, 0, 0) rotate(-1deg);
  }
}

@-webkit-keyframes jello {
  0%,
  11.1%,
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  22.2% {
    -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }

  33.3% {
    -webkit-transform: skewX(6.25deg) skewY(6.25deg);
    transform: skewX(6.25deg) skewY(6.25deg);
  }

  44.4% {
    -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }

  55.5% {
    -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }

  66.6% {
    -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }

  77.7% {
    -webkit-transform: skewX(0.39062deg) skewY(0.39062deg);
    transform: skewX(0.39062deg) skewY(0.39062deg);
  }

  88.8% {
    -webkit-transform: skewX(-0.19531deg) skewY(-0.19531deg);
    transform: skewX(-0.19531deg) skewY(-0.19531deg);
  }
}

@keyframes jello {
  0%,
  11.1%,
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  22.2% {
    -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }

  33.3% {
    -webkit-transform: skewX(6.25deg) skewY(6.25deg);
    transform: skewX(6.25deg) skewY(6.25deg);
  }

  44.4% {
    -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }

  55.5% {
    -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }

  66.6% {
    -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }

  77.7% {
    -webkit-transform: skewX(0.39062deg) skewY(0.39062deg);
    transform: skewX(0.39062deg) skewY(0.39062deg);
  }

  88.8% {
    -webkit-transform: skewX(-0.19531deg) skewY(-0.19531deg);
    transform: skewX(-0.19531deg) skewY(-0.19531deg);
  }
}

@-webkit-keyframes heartBeat {
  0%,
  28%,
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  14%,
  42% {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
  }
}

@keyframes heartBeat {
  0%,
  28%,
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  14%,
  42% {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
  }
}

@-webkit-keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

@-webkit-keyframes bounceInDown {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes bounceInDown {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes bounceInLeft {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(-3000px, 0, 0);
    transform: translate3d(-3000px, 0, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(25px, 0, 0);
    transform: translate3d(25px, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes bounceInLeft {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(-3000px, 0, 0);
    transform: translate3d(-3000px, 0, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(25px, 0, 0);
    transform: translate3d(25px, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes bounceInRight {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(3000px, 0, 0);
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(-25px, 0, 0);
    transform: translate3d(-25px, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(-5px, 0, 0);
    transform: translate3d(-5px, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes bounceInRight {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(3000px, 0, 0);
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(-25px, 0, 0);
    transform: translate3d(-25px, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(-5px, 0, 0);
    transform: translate3d(-5px, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes bounceInUp {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes bounceInUp {
  0%,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes bounceOut {
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
}

@keyframes bounceOut {
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
}

@-webkit-keyframes bounceOutDown {
  20% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  40%,
  45% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }
}

@keyframes bounceOutDown {
  20% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  40%,
  45% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }
}

@-webkit-keyframes bounceOutLeft {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }
}

@keyframes bounceOutLeft {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }
}

@-webkit-keyframes bounceOutRight {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(-20px, 0, 0);
    transform: translate3d(-20px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }
}

@keyframes bounceOutRight {
  20% {
    opacity: 1;
    -webkit-transform: translate3d(-20px, 0, 0);
    transform: translate3d(-20px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }
}

@-webkit-keyframes bounceOutUp {
  20% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  40%,
  45% {
    opacity: 1;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes bounceOutUp {
  20% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  40%,
  45% {
    opacity: 1;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0);
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInDownBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInDownBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInRightBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInRightBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@-webkit-keyframes fadeOutDown {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

@-webkit-keyframes fadeOutDownBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }
}

@keyframes fadeOutDownBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }
}

@-webkit-keyframes fadeOutLeft {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes fadeOutLeft {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@-webkit-keyframes fadeOutLeftBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }
}

@keyframes fadeOutLeftBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }
}

@-webkit-keyframes fadeOutRight {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes fadeOutRight {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@-webkit-keyframes fadeOutRightBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }
}

@keyframes fadeOutRightBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }
}

@-webkit-keyframes fadeOutUp {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
}

@keyframes fadeOutUp {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
}

@-webkit-keyframes fadeOutUpBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes fadeOutUpBig {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(0, -2000px, 0);
    transform: translate3d(0, -2000px, 0);
  }
}

@-webkit-keyframes flip {
  0% {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(0)
      rotateY(-1turn);
    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  40% {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)
      rotateY(-190deg);
    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  50% {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)
      rotateY(-170deg);
    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  80% {
    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95)
      translateZ(0) rotateY(0deg);
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translateZ(0)
      rotateY(0deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  to {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
}

@keyframes flip {
  0% {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(0)
      rotateY(-1turn);
    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  40% {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)
      rotateY(-190deg);
    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  50% {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)
      rotateY(-170deg);
    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  80% {
    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95)
      translateZ(0) rotateY(0deg);
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translateZ(0)
      rotateY(0deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  to {
    -webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
}

@-webkit-keyframes flipInX {
  0% {
    -webkit-transform: perspective(400px) rotateX(90deg);
    transform: perspective(400px) rotateX(90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotateX(-20deg);
    transform: perspective(400px) rotateX(-20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotateX(10deg);
    transform: perspective(400px) rotateX(10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotateX(-5deg);
    transform: perspective(400px) rotateX(-5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}

@keyframes flipInX {
  0% {
    -webkit-transform: perspective(400px) rotateX(90deg);
    transform: perspective(400px) rotateX(90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotateX(-20deg);
    transform: perspective(400px) rotateX(-20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotateX(10deg);
    transform: perspective(400px) rotateX(10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotateX(-5deg);
    transform: perspective(400px) rotateX(-5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}

@-webkit-keyframes flipInY {
  0% {
    -webkit-transform: perspective(400px) rotateY(90deg);
    transform: perspective(400px) rotateY(90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotateY(-20deg);
    transform: perspective(400px) rotateY(-20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotateY(10deg);
    transform: perspective(400px) rotateY(10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotateY(-5deg);
    transform: perspective(400px) rotateY(-5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}

@keyframes flipInY {
  0% {
    -webkit-transform: perspective(400px) rotateY(90deg);
    transform: perspective(400px) rotateY(90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotateY(-20deg);
    transform: perspective(400px) rotateY(-20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotateY(10deg);
    transform: perspective(400px) rotateY(10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotateY(-5deg);
    transform: perspective(400px) rotateY(-5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}

@-webkit-keyframes flipOutX {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }

  30% {
    -webkit-transform: perspective(400px) rotateX(-20deg);
    transform: perspective(400px) rotateX(-20deg);
    opacity: 1;
  }

  to {
    -webkit-transform: perspective(400px) rotateX(90deg);
    transform: perspective(400px) rotateX(90deg);
    opacity: 0;
  }
}

@keyframes flipOutX {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }

  30% {
    -webkit-transform: perspective(400px) rotateX(-20deg);
    transform: perspective(400px) rotateX(-20deg);
    opacity: 1;
  }

  to {
    -webkit-transform: perspective(400px) rotateX(90deg);
    transform: perspective(400px) rotateX(90deg);
    opacity: 0;
  }
}

@-webkit-keyframes flipOutY {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }

  30% {
    -webkit-transform: perspective(400px) rotateY(-15deg);
    transform: perspective(400px) rotateY(-15deg);
    opacity: 1;
  }

  to {
    -webkit-transform: perspective(400px) rotateY(90deg);
    transform: perspective(400px) rotateY(90deg);
    opacity: 0;
  }
}

@keyframes flipOutY {
  0% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }

  30% {
    -webkit-transform: perspective(400px) rotateY(-15deg);
    transform: perspective(400px) rotateY(-15deg);
    opacity: 1;
  }

  to {
    -webkit-transform: perspective(400px) rotateY(90deg);
    transform: perspective(400px) rotateY(90deg);
    opacity: 0;
  }
}

@-webkit-keyframes lightSpeedIn {
  0% {
    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0;
  }

  60% {
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: skewX(-5deg);
    transform: skewX(-5deg);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes lightSpeedIn {
  0% {
    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0;
  }

  60% {
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: skewX(-5deg);
    transform: skewX(-5deg);
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes lightSpeedOut {
  0% {
    opacity: 1;
  }

  to {
    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0;
  }
}

@keyframes lightSpeedOut {
  0% {
    opacity: 1;
  }

  to {
    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0;
  }
}

@-webkit-keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate(-200deg);
    transform: rotate(-200deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate(-200deg);
    transform: rotate(-200deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@-webkit-keyframes rotateInDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes rotateInDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@-webkit-keyframes rotateInDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes rotateInDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@-webkit-keyframes rotateInUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes rotateInUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@-webkit-keyframes rotateInUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes rotateInUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    opacity: 0;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@-webkit-keyframes rotateOut {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate(200deg);
    transform: rotate(200deg);
    opacity: 0;
  }
}

@keyframes rotateOut {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate(200deg);
    transform: rotate(200deg);
    opacity: 0;
  }
}

@-webkit-keyframes rotateOutDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0;
  }
}

@keyframes rotateOutDownLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0;
  }
}

@-webkit-keyframes rotateOutDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0;
  }
}

@keyframes rotateOutDownRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0;
  }
}

@-webkit-keyframes rotateOutUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0;
  }
}

@keyframes rotateOutUpLeft {
  0% {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0;
  }
}

@-webkit-keyframes rotateOutUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    opacity: 0;
  }
}

@keyframes rotateOutUpRight {
  0% {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    opacity: 1;
  }

  to {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    opacity: 0;
  }
}

@-webkit-keyframes hinge {
  0% {
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
  }

  20%,
  60% {
    -webkit-transform: rotate(80deg);
    transform: rotate(80deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
  }

  40%,
  80% {
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    opacity: 1;
  }

  to {
    -webkit-transform: translate3d(0, 700px, 0);
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
}

@keyframes hinge {
  0% {
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
  }

  20%,
  60% {
    -webkit-transform: rotate(80deg);
    transform: rotate(80deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
  }

  40%,
  80% {
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    opacity: 1;
  }

  to {
    -webkit-transform: translate3d(0, 700px, 0);
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
}

@-webkit-keyframes jackInTheBox {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.1) rotate(30deg);
    transform: scale(0.1) rotate(30deg);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
  }

  50% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }

  70% {
    -webkit-transform: rotate(3deg);
    transform: rotate(3deg);
  }

  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes jackInTheBox {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.1) rotate(30deg);
    transform: scale(0.1) rotate(30deg);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
  }

  50% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }

  70% {
    -webkit-transform: rotate(3deg);
    transform: rotate(3deg);
  }

  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@-webkit-keyframes rollIn {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
    transform: translate3d(-100%, 0, 0) rotate(-120deg);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes rollIn {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
    transform: translate3d(-100%, 0, 0) rotate(-120deg);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes rollOut {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
    transform: translate3d(100%, 0, 0) rotate(120deg);
  }
}

@keyframes rollOut {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
    transform: translate3d(100%, 0, 0) rotate(120deg);
  }
}

@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@-webkit-keyframes zoomInDown {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@keyframes zoomInDown {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@-webkit-keyframes zoomInLeft {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@keyframes zoomInLeft {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@-webkit-keyframes zoomInRight {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@keyframes zoomInRight {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@-webkit-keyframes zoomInUp {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@keyframes zoomInUp {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@-webkit-keyframes zoomOut {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}

@keyframes zoomOut {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}

@-webkit-keyframes zoomOutDown {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@keyframes zoomOutDown {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@-webkit-keyframes zoomOutLeft {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);
    transform: scale(0.1) translate3d(-2000px, 0, 0);
    -webkit-transform-origin: left center;
    transform-origin: left center;
  }
}

@keyframes zoomOutLeft {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);
    transform: scale(0.1) translate3d(-2000px, 0, 0);
    -webkit-transform-origin: left center;
    transform-origin: left center;
  }
}

@-webkit-keyframes zoomOutRight {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);
    transform: scale(0.1) translate3d(2000px, 0, 0);
    -webkit-transform-origin: right center;
    transform-origin: right center;
  }
}

@keyframes zoomOutRight {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }

  to {
    opacity: 0;
    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);
    transform: scale(0.1) translate3d(2000px, 0, 0);
    -webkit-transform-origin: right center;
    transform-origin: right center;
  }
}

@-webkit-keyframes zoomOutUp {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@keyframes zoomOutUp {
  40% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}

@-webkit-keyframes slideInDown {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes slideInDown {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes slideInLeft {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes slideInLeft {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes slideInRight {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes slideInRight {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes slideInUp {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@keyframes slideInUp {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

@-webkit-keyframes slideOutDown {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

@keyframes slideOutDown {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

@-webkit-keyframes slideOutLeft {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes slideOutLeft {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@-webkit-keyframes slideOutRight {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes slideOutRight {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@-webkit-keyframes slideOutUp {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
}

@keyframes slideOutUp {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
}

.bounce {
  -webkit-animation-name: bounce;
  animation-name: bounce;
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
}

.flash {
  -webkit-animation-name: flash;
  animation-name: flash;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
}

.rubberBand {
  -webkit-animation-name: rubberBand;
  animation-name: rubberBand;
}

.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}

.headShake {
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-name: headShake;
  animation-name: headShake;
}

.swing {
  -webkit-transform-origin: top center;
  transform-origin: top center;
  -webkit-animation-name: swing;
  animation-name: swing;
}

.tada {
  -webkit-animation-name: tada;
  animation-name: tada;
}

.wobble {
  -webkit-animation-name: wobble;
  animation-name: wobble;
}

.jello {
  -webkit-animation-name: jello;
  animation-name: jello;
  -webkit-transform-origin: center;
  transform-origin: center;
}

.heartBeat {
  -webkit-animation-name: heartBeat;
  animation-name: heartBeat;
  -webkit-animation-duration: 1.3s;
  animation-duration: 1.3s;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.bounceIn {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
}

.bounceInDown {
  -webkit-animation-name: bounceInDown;
  animation-name: bounceInDown;
}

.bounceInLeft {
  -webkit-animation-name: bounceInLeft;
  animation-name: bounceInLeft;
}

.bounceInRight {
  -webkit-animation-name: bounceInRight;
  animation-name: bounceInRight;
}

.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}

.bounceOut {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-name: bounceOut;
  animation-name: bounceOut;
}

.bounceOutDown {
  -webkit-animation-name: bounceOutDown;
  animation-name: bounceOutDown;
}

.bounceOutLeft {
  -webkit-animation-name: bounceOutLeft;
  animation-name: bounceOutLeft;
}

.bounceOutRight {
  -webkit-animation-name: bounceOutRight;
  animation-name: bounceOutRight;
}

.bounceOutUp {
  -webkit-animation-name: bounceOutUp;
  animation-name: bounceOutUp;
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
}

.fadeInDownBig {
  -webkit-animation-name: fadeInDownBig;
  animation-name: fadeInDownBig;
}

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

.fadeInLeftBig {
  -webkit-animation-name: fadeInLeftBig;
  animation-name: fadeInLeftBig;
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

.fadeInRightBig {
  -webkit-animation-name: fadeInRightBig;
  animation-name: fadeInRightBig;
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}

.fadeInUpBig {
  -webkit-animation-name: fadeInUpBig;
  animation-name: fadeInUpBig;
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown;
  animation-name: fadeOutDown;
}

.fadeOutDownBig {
  -webkit-animation-name: fadeOutDownBig;
  animation-name: fadeOutDownBig;
}

.fadeOutLeft {
  -webkit-animation-name: fadeOutLeft;
  animation-name: fadeOutLeft;
}

.fadeOutLeftBig {
  -webkit-animation-name: fadeOutLeftBig;
  animation-name: fadeOutLeftBig;
}

.fadeOutRight {
  -webkit-animation-name: fadeOutRight;
  animation-name: fadeOutRight;
}

.fadeOutRightBig {
  -webkit-animation-name: fadeOutRightBig;
  animation-name: fadeOutRightBig;
}

.fadeOutUp {
  -webkit-animation-name: fadeOutUp;
  animation-name: fadeOutUp;
}

.fadeOutUpBig {
  -webkit-animation-name: fadeOutUpBig;
  animation-name: fadeOutUpBig;
}

.animated.flip {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  -webkit-animation-name: flip;
  animation-name: flip;
}

.flipInX,
.flipInY,
.flipOutX,
.flipOutY {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipInX;
  animation-name: flipInX;
}

.flipInY,
.flipOutX,
.flipOutY {
  -webkit-animation-name: flipInY;
  animation-name: flipInY;
}

.flipOutX,
.flipOutY {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-name: flipOutX;
  animation-name: flipOutX;
}

.flipOutY {
  -webkit-animation-name: flipOutY;
  animation-name: flipOutY;
}

.lightSpeedIn {
  -webkit-animation-name: lightSpeedIn;
  animation-name: lightSpeedIn;
  -webkit-animation-timing-function: ease-out;
  animation-timing-function: ease-out;
}

.lightSpeedOut {
  -webkit-animation-name: lightSpeedOut;
  animation-name: lightSpeedOut;
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

.rotateIn {
  -webkit-animation-name: rotateIn;
  animation-name: rotateIn;
}

.rotateInDownLeft {
  -webkit-animation-name: rotateInDownLeft;
  animation-name: rotateInDownLeft;
}

.rotateInDownRight {
  -webkit-animation-name: rotateInDownRight;
  animation-name: rotateInDownRight;
}

.rotateInUpLeft {
  -webkit-animation-name: rotateInUpLeft;
  animation-name: rotateInUpLeft;
}

.rotateInUpRight {
  -webkit-animation-name: rotateInUpRight;
  animation-name: rotateInUpRight;
}

.rotateOut {
  -webkit-animation-name: rotateOut;
  animation-name: rotateOut;
}

.rotateOutDownLeft {
  -webkit-animation-name: rotateOutDownLeft;
  animation-name: rotateOutDownLeft;
}

.rotateOutDownRight {
  -webkit-animation-name: rotateOutDownRight;
  animation-name: rotateOutDownRight;
}

.rotateOutUpLeft {
  -webkit-animation-name: rotateOutUpLeft;
  animation-name: rotateOutUpLeft;
}

.rotateOutUpRight {
  -webkit-animation-name: rotateOutUpRight;
  animation-name: rotateOutUpRight;
}

.hinge {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-name: hinge;
  animation-name: hinge;
}

.jackInTheBox {
  -webkit-animation-name: jackInTheBox;
  animation-name: jackInTheBox;
}

.rollIn {
  -webkit-animation-name: rollIn;
  animation-name: rollIn;
}

.rollOut {
  -webkit-animation-name: rollOut;
  animation-name: rollOut;
}

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}

.zoomInDown {
  -webkit-animation-name: zoomInDown;
  animation-name: zoomInDown;
}

.zoomInLeft {
  -webkit-animation-name: zoomInLeft;
  animation-name: zoomInLeft;
}

.zoomInRight {
  -webkit-animation-name: zoomInRight;
  animation-name: zoomInRight;
}

.zoomInUp {
  -webkit-animation-name: zoomInUp;
  animation-name: zoomInUp;
}

.zoomOut {
  -webkit-animation-name: zoomOut;
  animation-name: zoomOut;
}

.zoomOutDown {
  -webkit-animation-name: zoomOutDown;
  animation-name: zoomOutDown;
}

.zoomOutLeft {
  -webkit-animation-name: zoomOutLeft;
  animation-name: zoomOutLeft;
}

.zoomOutRight {
  -webkit-animation-name: zoomOutRight;
  animation-name: zoomOutRight;
}

.zoomOutUp {
  -webkit-animation-name: zoomOutUp;
  animation-name: zoomOutUp;
}

.slideInDown {
  -webkit-animation-name: slideInDown;
  animation-name: slideInDown;
}

.slideInLeft {
  -webkit-animation-name: slideInLeft;
  animation-name: slideInLeft;
}

.slideInRight {
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight;
}

.slideInUp {
  -webkit-animation-name: slideInUp;
  animation-name: slideInUp;
}

.slideOutDown {
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
}

.slideOutLeft {
  -webkit-animation-name: slideOutLeft;
  animation-name: slideOutLeft;
}

.slideOutRight {
  -webkit-animation-name: slideOutRight;
  animation-name: slideOutRight;
}

.slideOutUp {
  -webkit-animation-name: slideOutUp;
  animation-name: slideOutUp;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.animated.delay-1s {
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}

.animated.delay-2s {
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
}

.animated.delay-3s {
  -webkit-animation-delay: 3s;
  animation-delay: 3s;
}

.animated.delay-4s {
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
}

.animated.delay-5s {
  -webkit-animation-delay: 5s;
  animation-delay: 5s;
}

.animated.fast {
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
}

.animated.faster {
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
}

.animated.slow {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.animated.slower {
  -webkit-animation-duration: 3s;
  animation-duration: 3s;
}

@media (prefers-reduced-motion: reduce), (print) {
  .animated {
    -webkit-animation-duration: 1ms !important;
    animation-duration: 1ms !important;
    -webkit-transition-duration: 1ms !important;
    transition-duration: 1ms !important;
    -webkit-animation-iteration-count: 1 !important;
    animation-iteration-count: 1 !important;
  }
}

/*!
 * Font Awesome Free 5.10.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: 0.08em solid #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fab.fa-pull-left,
.fal.fa-pull-left,
.far.fa-pull-left,
.fas.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right,
.fab.fa-pull-right,
.fal.fa-pull-right,
.far.fa-pull-right,
.fas.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  -webkit-animation: fa-spin 2s linear infinite;
  animation: fa-spin 2s linear infinite;
}

.fa-pulse {
  -webkit-animation: fa-spin 1s steps(8) infinite;
  animation: fa-spin 1s steps(8) infinite;
}

.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.fa-flip-vertical {
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical,
.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1);
  transform: scale(-1);
}

:root .fa-flip-both,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-rotate-90 {
  -webkit-filter: none;
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-ad:before {
  content: "\\f641";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-card:before {
  content: "\\f2bb";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adobe:before {
  content: "\\f778";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-air-freshener:before {
  content: "\\f5d0";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-allergies:before {
  content: "\\f461";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angry:before {
  content: "\\f556";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-ankh:before {
  content: "\\f644";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-alt:before {
  content: "\\f5d1";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-archway:before {
  content: "\\f557";
}

.fa-arrow-alt-circle-down:before {
  content: "\\f358";
}

.fa-arrow-alt-circle-left:before {
  content: "\\f359";
}

.fa-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-arrows-alt-h:before {
  content: "\\f337";
}

.fa-arrows-alt-v:before {
  content: "\\f338";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-atlas:before {
  content: "\\f558";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-atom:before {
  content: "\\f5d2";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-award:before {
  content: "\\f559";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-baby:before {
  content: "\\f77c";
}

.fa-baby-carriage:before {
  content: "\\f77d";
}

.fa-backspace:before {
  content: "\\f55a";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-bacon:before {
  content: "\\f7e5";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-balance-scale-left:before {
  content: "\\f515";
}

.fa-balance-scale-right:before {
  content: "\\f516";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-band-aid:before {
  content: "\\f462";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-bars:before {
  content: "\\f0c9";
}

.fa-baseball-ball:before {
  content: "\\f433";
}

.fa-basketball-ball:before {
  content: "\\f434";
}

.fa-bath:before {
  content: "\\f2cd";
}

.fa-battery-empty:before {
  content: "\\f244";
}

.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-bed:before {
  content: "\\f236";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bezier-curve:before {
  content: "\\f55b";
}

.fa-bible:before {
  content: "\\f647";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-biking:before {
  content: "\\f84a";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-biohazard:before {
  content: "\\f780";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blender:before {
  content: "\\f517";
}

.fa-blender-phone:before {
  content: "\\f6b6";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-blog:before {
  content: "\\f781";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-bolt:before {
  content: "\\f0e7";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-bone:before {
  content: "\\f5d7";
}

.fa-bong:before {
  content: "\\f55c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-book-dead:before {
  content: "\\f6b7";
}

.fa-book-medical:before {
  content: "\\f7e6";
}

.fa-book-open:before {
  content: "\\f518";
}

.fa-book-reader:before {
  content: "\\f5da";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-border-all:before {
  content: "\\f84c";
}

.fa-border-none:before {
  content: "\\f850";
}

.fa-border-style:before {
  content: "\\f853";
}

.fa-bowling-ball:before {
  content: "\\f436";
}

.fa-box:before {
  content: "\\f466";
}

.fa-box-open:before {
  content: "\\f49e";
}

.fa-boxes:before {
  content: "\\f468";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-brain:before {
  content: "\\f5dc";
}

.fa-bread-slice:before {
  content: "\\f7ec";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-briefcase-medical:before {
  content: "\\f469";
}

.fa-broadcast-tower:before {
  content: "\\f519";
}

.fa-broom:before {
  content: "\\f51a";
}

.fa-brush:before {
  content: "\\f55d";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-burn:before {
  content: "\\f46a";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-bus-alt:before {
  content: "\\f55e";
}

.fa-business-time:before {
  content: "\\f64a";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-calendar:before {
  content: "\\f133";
}

.fa-calendar-alt:before {
  content: "\\f073";
}

.fa-calendar-check:before {
  content: "\\f274";
}

.fa-calendar-day:before {
  content: "\\f783";
}

.fa-calendar-minus:before {
  content: "\\f272";
}

.fa-calendar-plus:before {
  content: "\\f271";
}

.fa-calendar-times:before {
  content: "\\f273";
}

.fa-calendar-week:before {
  content: "\\f784";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-campground:before {
  content: "\\f6bb";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-candy-cane:before {
  content: "\\f786";
}

.fa-cannabis:before {
  content: "\\f55f";
}

.fa-capsules:before {
  content: "\\f46b";
}

.fa-car:before {
  content: "\\f1b9";
}

.fa-car-alt:before {
  content: "\\f5de";
}

.fa-car-battery:before {
  content: "\\f5df";
}

.fa-car-crash:before {
  content: "\\f5e1";
}

.fa-car-side:before {
  content: "\\f5e4";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-caret-square-down:before {
  content: "\\f150";
}

.fa-caret-square-left:before {
  content: "\\f191";
}

.fa-caret-square-right:before {
  content: "\\f152";
}

.fa-caret-square-up:before {
  content: "\\f151";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-carrot:before {
  content: "\\f787";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cash-register:before {
  content: "\\f788";
}

.fa-cat:before {
  content: "\\f6be";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-chair:before {
  content: "\\f6c0";
}

.fa-chalkboard:before {
  content: "\\f51b";
}

.fa-chalkboard-teacher:before {
  content: "\\f51c";
}

.fa-charging-station:before {
  content: "\\f5e7";
}

.fa-chart-area:before {
  content: "\\f1fe";
}

.fa-chart-bar:before {
  content: "\\f080";
}

.fa-chart-line:before {
  content: "\\f201";
}

.fa-chart-pie:before {
  content: "\\f200";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-check-double:before {
  content: "\\f560";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-cheese:before {
  content: "\\f7ef";
}

.fa-chess:before {
  content: "\\f439";
}

.fa-chess-bishop:before {
  content: "\\f43a";
}

.fa-chess-board:before {
  content: "\\f43c";
}

.fa-chess-king:before {
  content: "\\f43f";
}

.fa-chess-knight:before {
  content: "\\f441";
}

.fa-chess-pawn:before {
  content: "\\f443";
}

.fa-chess-queen:before {
  content: "\\f445";
}

.fa-chess-rook:before {
  content: "\\f447";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-church:before {
  content: "\\f51d";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-circle-notch:before {
  content: "\\f1ce";
}

.fa-city:before {
  content: "\\f64f";
}

.fa-clinic-medical:before {
  content: "\\f7f2";
}

.fa-clipboard:before {
  content: "\\f328";
}

.fa-clipboard-check:before {
  content: "\\f46c";
}

.fa-clipboard-list:before {
  content: "\\f46d";
}

.fa-clock:before {
  content: "\\f017";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-closed-captioning:before {
  content: "\\f20a";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-cloud-download-alt:before {
  content: "\\f381";
}

.fa-cloud-meatball:before {
  content: "\\f73b";
}

.fa-cloud-moon:before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain:before {
  content: "\\f73c";
}

.fa-cloud-rain:before {
  content: "\\f73d";
}

.fa-cloud-showers-heavy:before {
  content: "\\f740";
}

.fa-cloud-sun:before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain:before {
  content: "\\f743";
}

.fa-cloud-upload-alt:before {
  content: "\\f382";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cocktail:before {
  content: "\\f561";
}

.fa-code:before {
  content: "\\f121";
}

.fa-code-branch:before {
  content: "\\f126";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cog:before {
  content: "\\f013";
}

.fa-cogs:before {
  content: "\\f085";
}

.fa-coins:before {
  content: "\\f51e";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-comment-alt:before {
  content: "\\f27a";
}

.fa-comment-dollar:before {
  content: "\\f651";
}

.fa-comment-dots:before {
  content: "\\f4ad";
}

.fa-comment-medical:before {
  content: "\\f7f5";
}

.fa-comment-slash:before {
  content: "\\f4b3";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-comments-dollar:before {
  content: "\\f653";
}

.fa-compact-disc:before {
  content: "\\f51f";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-compress-arrows-alt:before {
  content: "\\f78c";
}

.fa-concierge-bell:before {
  content: "\\f562";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cookie:before {
  content: "\\f563";
}

.fa-cookie-bite:before {
  content: "\\f564";
}

.fa-copy:before {
  content: "\\f0c5";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-couch:before {
  content: "\\f4b8";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-crop-alt:before {
  content: "\\f565";
}

.fa-cross:before {
  content: "\\f654";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-crow:before {
  content: "\\f520";
}

.fa-crown:before {
  content: "\\f521";
}

.fa-crutch:before {
  content: "\\f7f7";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-cut:before {
  content: "\\f0c4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-deaf:before {
  content: "\\f2a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-democrat:before {
  content: "\\f747";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dharmachakra:before {
  content: "\\f655";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diagnoses:before {
  content: "\\f470";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-dice:before {
  content: "\\f522";
}

.fa-dice-d20:before {
  content: "\\f6cf";
}

.fa-dice-d6:before {
  content: "\\f6d1";
}

.fa-dice-five:before {
  content: "\\f523";
}

.fa-dice-four:before {
  content: "\\f524";
}

.fa-dice-one:before {
  content: "\\f525";
}

.fa-dice-six:before {
  content: "\\f526";
}

.fa-dice-three:before {
  content: "\\f527";
}

.fa-dice-two:before {
  content: "\\f528";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-digital-tachograph:before {
  content: "\\f566";
}

.fa-directions:before {
  content: "\\f5eb";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-divide:before {
  content: "\\f529";
}

.fa-dizzy:before {
  content: "\\f567";
}

.fa-dna:before {
  content: "\\f471";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-dog:before {
  content: "\\f6d3";
}

.fa-dollar-sign:before {
  content: "\\f155";
}

.fa-dolly:before {
  content: "\\f472";
}

.fa-dolly-flatbed:before {
  content: "\\f474";
}

.fa-donate:before {
  content: "\\f4b9";
}

.fa-door-closed:before {
  content: "\\f52a";
}

.fa-door-open:before {
  content: "\\f52b";
}

.fa-dot-circle:before {
  content: "\\f192";
}

.fa-dove:before {
  content: "\\f4ba";
}

.fa-download:before {
  content: "\\f019";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-drafting-compass:before {
  content: "\\f568";
}

.fa-dragon:before {
  content: "\\f6d5";
}

.fa-draw-polygon:before {
  content: "\\f5ee";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drum:before {
  content: "\\f569";
}

.fa-drum-steelpan:before {
  content: "\\f56a";
}

.fa-drumstick-bite:before {
  content: "\\f6d7";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dumbbell:before {
  content: "\\f44b";
}

.fa-dumpster:before {
  content: "\\f793";
}

.fa-dumpster-fire:before {
  content: "\\f794";
}

.fa-dungeon:before {
  content: "\\f6d9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edit:before {
  content: "\\f044";
}

.fa-egg:before {
  content: "\\f7fb";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-text:before {
  content: "\\f658";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-equals:before {
  content: "\\f52c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-ethernet:before {
  content: "\\f796";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-euro-sign:before {
  content: "\\f153";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-exchange-alt:before {
  content: "\\f362";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-expand-arrows-alt:before {
  content: "\\f31e";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-external-link-alt:before {
  content: "\\f35d";
}

.fa-external-link-square-alt:before {
  content: "\\f360";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-dropper:before {
  content: "\\f1fb";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fan:before {
  content: "\\f863";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-feather:before {
  content: "\\f52d";
}

.fa-feather-alt:before {
  content: "\\f56b";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-female:before {
  content: "\\f182";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-alt:before {
  content: "\\f15c";
}

.fa-file-archive:before {
  content: "\\f1c6";
}

.fa-file-audio:before {
  content: "\\f1c7";
}

.fa-file-code:before {
  content: "\\f1c9";
}

.fa-file-contract:before {
  content: "\\f56c";
}

.fa-file-csv:before {
  content: "\\f6dd";
}

.fa-file-download:before {
  content: "\\f56d";
}

.fa-file-excel:before {
  content: "\\f1c3";
}

.fa-file-export:before {
  content: "\\f56e";
}

.fa-file-image:before {
  content: "\\f1c5";
}

.fa-file-import:before {
  content: "\\f56f";
}

.fa-file-invoice:before {
  content: "\\f570";
}

.fa-file-invoice-dollar:before {
  content: "\\f571";
}

.fa-file-medical:before {
  content: "\\f477";
}

.fa-file-medical-alt:before {
  content: "\\f478";
}

.fa-file-pdf:before {
  content: "\\f1c1";
}

.fa-file-powerpoint:before {
  content: "\\f1c4";
}

.fa-file-prescription:before {
  content: "\\f572";
}

.fa-file-signature:before {
  content: "\\f573";
}

.fa-file-upload:before {
  content: "\\f574";
}

.fa-file-video:before {
  content: "\\f1c8";
}

.fa-file-word:before {
  content: "\\f1c2";
}

.fa-fill:before {
  content: "\\f575";
}

.fa-fill-drip:before {
  content: "\\f576";
}

.fa-film:before {
  content: "\\f008";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-fingerprint:before {
  content: "\\f577";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-fire-alt:before {
  content: "\\f7e4";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-first-aid:before {
  content: "\\f479";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-fish:before {
  content: "\\f578";
}

.fa-fist-raised:before {
  content: "\\f6de";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-flag-usa:before {
  content: "\\f74d";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-flushed:before {
  content: "\\f579";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-minus:before {
  content: "\\f65d";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-folder-plus:before {
  content: "\\f65e";
}

.fa-font:before {
  content: "\\f031";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-font-awesome-flag:before {
  content: "\\f425";
}

.fa-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-football-ball:before {
  content: "\\f44e";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-frog:before {
  content: "\\f52e";
}

.fa-frown:before {
  content: "\\f119";
}

.fa-frown-open:before {
  content: "\\f57a";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-funnel-dollar:before {
  content: "\\f662";
}

.fa-futbol:before {
  content: "\\f1e3";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-gas-pump:before {
  content: "\\f52f";
}

.fa-gavel:before {
  content: "\\f0e3";
}

.fa-gem:before {
  content: "\\f3a5";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-ghost:before {
  content: "\\f6e2";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-gifts:before {
  content: "\\f79c";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glass-cheers:before {
  content: "\\f79f";
}

.fa-glass-martini:before {
  content: "\\f000";
}

.fa-glass-martini-alt:before {
  content: "\\f57b";
}

.fa-glass-whiskey:before {
  content: "\\f7a0";
}

.fa-glasses:before {
  content: "\\f530";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-globe-africa:before {
  content: "\\f57c";
}

.fa-globe-americas:before {
  content: "\\f57d";
}

.fa-globe-asia:before {
  content: "\\f57e";
}

.fa-globe-europe:before {
  content: "\\f7a2";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golf-ball:before {
  content: "\\f450";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gopuram:before {
  content: "\\f664";
}

.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-greater-than:before {
  content: "\\f531";
}

.fa-greater-than-equal:before {
  content: "\\f532";
}

.fa-grimace:before {
  content: "\\f57f";
}

.fa-grin:before {
  content: "\\f580";
}

.fa-grin-alt:before {
  content: "\\f581";
}

.fa-grin-beam:before {
  content: "\\f582";
}

.fa-grin-beam-sweat:before {
  content: "\\f583";
}

.fa-grin-hearts:before {
  content: "\\f584";
}

.fa-grin-squint:before {
  content: "\\f585";
}

.fa-grin-squint-tears:before {
  content: "\\f586";
}

.fa-grin-stars:before {
  content: "\\f587";
}

.fa-grin-tears:before {
  content: "\\f588";
}

.fa-grin-tongue:before {
  content: "\\f589";
}

.fa-grin-tongue-squint:before {
  content: "\\f58a";
}

.fa-grin-tongue-wink:before {
  content: "\\f58b";
}

.fa-grin-wink:before {
  content: "\\f58c";
}

.fa-grip-horizontal:before {
  content: "\\f58d";
}

.fa-grip-lines:before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical:before {
  content: "\\f7a5";
}

.fa-grip-vertical:before {
  content: "\\f58e";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guitar:before {
  content: "\\f7a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hamburger:before {
  content: "\\f805";
}

.fa-hammer:before {
  content: "\\f6e3";
}

.fa-hamsa:before {
  content: "\\f665";
}

.fa-hand-holding:before {
  content: "\\f4bd";
}

.fa-hand-holding-heart:before {
  content: "\\f4be";
}

.fa-hand-holding-usd:before {
  content: "\\f4c0";
}

.fa-hand-lizard:before {
  content: "\\f258";
}

.fa-hand-middle-finger:before {
  content: "\\f806";
}

.fa-hand-paper:before {
  content: "\\f256";
}

.fa-hand-peace:before {
  content: "\\f25b";
}

.fa-hand-point-down:before {
  content: "\\f0a7";
}

.fa-hand-point-left:before {
  content: "\\f0a5";
}

.fa-hand-point-right:before {
  content: "\\f0a4";
}

.fa-hand-point-up:before {
  content: "\\f0a6";
}

.fa-hand-pointer:before {
  content: "\\f25a";
}

.fa-hand-rock:before {
  content: "\\f255";
}

.fa-hand-scissors:before {
  content: "\\f257";
}

.fa-hand-spock:before {
  content: "\\f259";
}

.fa-hands:before {
  content: "\\f4c2";
}

.fa-hands-helping:before {
  content: "\\f4c4";
}

.fa-handshake:before {
  content: "\\f2b5";
}

.fa-hanukiah:before {
  content: "\\f6e6";
}

.fa-hard-hat:before {
  content: "\\f807";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-hat-wizard:before {
  content: "\\f6e8";
}

.fa-haykal:before {
  content: "\\f666";
}

.fa-hdd:before {
  content: "\\f0a0";
}

.fa-heading:before {
  content: "\\f1dc";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-headphones-alt:before {
  content: "\\f58f";
}

.fa-headset:before {
  content: "\\f590";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-heart-broken:before {
  content: "\\f7a9";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-helicopter:before {
  content: "\\f533";
}

.fa-highlighter:before {
  content: "\\f591";
}

.fa-hiking:before {
  content: "\\f6ec";
}

.fa-hippo:before {
  content: "\\f6ed";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-hockey-puck:before {
  content: "\\f453";
}

.fa-holly-berry:before {
  content: "\\f7aa";
}

.fa-home:before {
  content: "\\f015";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-horse:before {
  content: "\\f6f0";
}

.fa-horse-head:before {
  content: "\\f7ab";
}

.fa-hospital:before {
  content: "\\f0f8";
}

.fa-hospital-alt:before {
  content: "\\f47d";
}

.fa-hospital-symbol:before {
  content: "\\f47e";
}

.fa-hot-tub:before {
  content: "\\f593";
}

.fa-hotdog:before {
  content: "\\f80f";
}

.fa-hotel:before {
  content: "\\f594";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-house-damage:before {
  content: "\\f6f1";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-hryvnia:before {
  content: "\\f6f2";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-ice-cream:before {
  content: "\\f810";
}

.fa-icicles:before {
  content: "\\f7ad";
}

.fa-icons:before {
  content: "\\f86d";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-id-card:before {
  content: "\\f2c2";
}

.fa-id-card-alt:before {
  content: "\\f47f";
}

.fa-igloo:before {
  content: "\\f7ae";
}

.fa-image:before {
  content: "\\f03e";
}

.fa-images:before {
  content: "\\f302";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-infinity:before {
  content: "\\f534";
}

.fa-info:before {
  content: "\\f129";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi:before {
  content: "\\f669";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joint:before {
  content: "\\f595";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-journal-whills:before {
  content: "\\f66a";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaaba:before {
  content: "\\f66b";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-key:before {
  content: "\\f084";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keyboard:before {
  content: "\\f11c";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-khanda:before {
  content: "\\f66d";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-kiss:before {
  content: "\\f596";
}

.fa-kiss-beam:before {
  content: "\\f597";
}

.fa-kiss-wink-heart:before {
  content: "\\f598";
}

.fa-kiwi-bird:before {
  content: "\\f535";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-landmark:before {
  content: "\\f66f";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-laptop-code:before {
  content: "\\f5fc";
}

.fa-laptop-medical:before {
  content: "\\f812";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-laugh:before {
  content: "\\f599";
}

.fa-laugh-beam:before {
  content: "\\f59a";
}

.fa-laugh-squint:before {
  content: "\\f59b";
}

.fa-laugh-wink:before {
  content: "\\f59c";
}

.fa-layer-group:before {
  content: "\\f5fd";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-lemon:before {
  content: "\\f094";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-less-than:before {
  content: "\\f536";
}

.fa-less-than-equal:before {
  content: "\\f537";
}

.fa-level-down-alt:before {
  content: "\\f3be";
}

.fa-level-up-alt:before {
  content: "\\f3bf";
}

.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-lightbulb:before {
  content: "\\f0eb";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-link:before {
  content: "\\f0c1";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lira-sign:before {
  content: "\\f195";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-lock-open:before {
  content: "\\f3c1";
}

.fa-long-arrow-alt-down:before {
  content: "\\f309";
}

.fa-long-arrow-alt-left:before {
  content: "\\f30a";
}

.fa-long-arrow-alt-right:before {
  content: "\\f30b";
}

.fa-long-arrow-alt-up:before {
  content: "\\f30c";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-luggage-cart:before {
  content: "\\f59d";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-mail-bulk:before {
  content: "\\f674";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-male:before {
  content: "\\f183";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-map:before {
  content: "\\f279";
}

.fa-map-marked:before {
  content: "\\f59f";
}

.fa-map-marked-alt:before {
  content: "\\f5a0";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-map-marker-alt:before {
  content: "\\f3c5";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-marker:before {
  content: "\\f5a1";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mask:before {
  content: "\\f6fa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-medal:before {
  content: "\\f5a2";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f3c7";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-meh:before {
  content: "\\f11a";
}

.fa-meh-blank:before {
  content: "\\f5a4";
}

.fa-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.fa-memory:before {
  content: "\\f538";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-menorah:before {
  content: "\\f676";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-meteor:before {
  content: "\\f753";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-alt:before {
  content: "\\f3c9";
}

.fa-microphone-alt-slash:before {
  content: "\\f539";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-microscope:before {
  content: "\\f610";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-mitten:before {
  content: "\\f7b5";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-mobile:before {
  content: "\\f10b";
}

.fa-mobile-alt:before {
  content: "\\f3cd";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-money-bill:before {
  content: "\\f0d6";
}

.fa-money-bill-alt:before {
  content: "\\f3d1";
}

.fa-money-bill-wave:before {
  content: "\\f53a";
}

.fa-money-bill-wave-alt:before {
  content: "\\f53b";
}

.fa-money-check:before {
  content: "\\f53c";
}

.fa-money-check-alt:before {
  content: "\\f53d";
}

.fa-monument:before {
  content: "\\f5a6";
}

.fa-moon:before {
  content: "\\f186";
}

.fa-mortar-pestle:before {
  content: "\\f5a7";
}

.fa-mosque:before {
  content: "\\f678";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-mountain:before {
  content: "\\f6fc";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-mug-hot:before {
  content: "\\f7b6";
}

.fa-music:before {
  content: "\\f001";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-network-wired:before {
  content: "\\f6ff";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-newspaper:before {
  content: "\\f1ea";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-not-equal:before {
  content: "\\f53e";
}

.fa-notes-medical:before {
  content: "\\f481";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-oil-can:before {
  content: "\\f613";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-om:before {
  content: "\\f679";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-otter:before {
  content: "\\f700";
}

.fa-outdent:before {
  content: "\\f03b";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-pager:before {
  content: "\\f815";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-paint-roller:before {
  content: "\\f5aa";
}

.fa-palette:before {
  content: "\\f53f";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-pallet:before {
  content: "\\f482";
}

.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-parachute-box:before {
  content: "\\f4cd";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-parking:before {
  content: "\\f540";
}

.fa-passport:before {
  content: "\\f5ab";
}

.fa-pastafarianism:before {
  content: "\\f67b";
}

.fa-paste:before {
  content: "\\f0ea";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-peace:before {
  content: "\\f67c";
}

.fa-pen:before {
  content: "\\f304";
}

.fa-pen-alt:before {
  content: "\\f305";
}

.fa-pen-fancy:before {
  content: "\\f5ac";
}

.fa-pen-nib:before {
  content: "\\f5ad";
}

.fa-pen-square:before {
  content: "\\f14b";
}

.fa-pencil-alt:before {
  content: "\\f303";
}

.fa-pencil-ruler:before {
  content: "\\f5ae";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-people-carry:before {
  content: "\\f4ce";
}

.fa-pepper-hot:before {
  content: "\\f816";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-percentage:before {
  content: "\\f541";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-person-booth:before {
  content: "\\f756";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-phone-alt:before {
  content: "\\f879";
}

.fa-phone-slash:before {
  content: "\\f3dd";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-phone-square-alt:before {
  content: "\\f87b";
}

.fa-phone-volume:before {
  content: "\\f2a0";
}

.fa-photo-video:before {
  content: "\\f87c";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-piggy-bank:before {
  content: "\\f4d3";
}

.fa-pills:before {
  content: "\\f484";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-pizza-slice:before {
  content: "\\f818";
}

.fa-place-of-worship:before {
  content: "\\f67f";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-plane-arrival:before {
  content: "\\f5af";
}

.fa-plane-departure:before {
  content: "\\f5b0";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-poll:before {
  content: "\\f681";
}

.fa-poll-h:before {
  content: "\\f682";
}

.fa-poo:before {
  content: "\\f2fe";
}

.fa-poo-storm:before {
  content: "\\f75a";
}

.fa-poop:before {
  content: "\\f619";
}

.fa-portrait:before {
  content: "\\f3e0";
}

.fa-pound-sign:before {
  content: "\\f154";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-pray:before {
  content: "\\f683";
}

.fa-praying-hands:before {
  content: "\\f684";
}

.fa-prescription:before {
  content: "\\f5b1";
}

.fa-prescription-bottle:before {
  content: "\\f485";
}

.fa-prescription-bottle-alt:before {
  content: "\\f486";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-procedures:before {
  content: "\\f487";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-project-diagram:before {
  content: "\\f542";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-question:before {
  content: "\\f128";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-quidditch:before {
  content: "\\f458";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-quran:before {
  content: "\\f687";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-radiation:before {
  content: "\\f7b9";
}

.fa-radiation-alt:before {
  content: "\\f7ba";
}

.fa-rainbow:before {
  content: "\\f75b";
}

.fa-random:before {
  content: "\\f074";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-receipt:before {
  content: "\\f543";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-redo:before {
  content: "\\f01e";
}

.fa-redo-alt:before {
  content: "\\f2f9";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-remove-format:before {
  content: "\\f87d";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-reply:before {
  content: "\\f3e5";
}

.fa-reply-all:before {
  content: "\\f122";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-republican:before {
  content: "\\f75e";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-restroom:before {
  content: "\\f7bd";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-ribbon:before {
  content: "\\f4d6";
}

.fa-ring:before {
  content: "\\f70b";
}

.fa-road:before {
  content: "\\f018";
}

.fa-robot:before {
  content: "\\f544";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-route:before {
  content: "\\f4d7";
}

.fa-rss:before {
  content: "\\f09e";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-ruble-sign:before {
  content: "\\f158";
}

.fa-ruler:before {
  content: "\\f545";
}

.fa-ruler-combined:before {
  content: "\\f546";
}

.fa-ruler-horizontal:before {
  content: "\\f547";
}

.fa-ruler-vertical:before {
  content: "\\f548";
}

.fa-running:before {
  content: "\\f70c";
}

.fa-rupee-sign:before {
  content: "\\f156";
}

.fa-sad-cry:before {
  content: "\\f5b3";
}

.fa-sad-tear:before {
  content: "\\f5b4";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-satellite:before {
  content: "\\f7bf";
}

.fa-satellite-dish:before {
  content: "\\f7c0";
}

.fa-save:before {
  content: "\\f0c7";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-school:before {
  content: "\\f549";
}

.fa-screwdriver:before {
  content: "\\f54a";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-scroll:before {
  content: "\\f70e";
}

.fa-sd-card:before {
  content: "\\f7c2";
}

.fa-search:before {
  content: "\\f002";
}

.fa-search-dollar:before {
  content: "\\f688";
}

.fa-search-location:before {
  content: "\\f689";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-seedling:before {
  content: "\\f4d8";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-server:before {
  content: "\\f233";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shapes:before {
  content: "\\f61f";
}

.fa-share:before {
  content: "\\f064";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-shekel-sign:before {
  content: "\\f20b";
}

.fa-shield-alt:before {
  content: "\\f3ed";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-shipping-fast:before {
  content: "\\f48b";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shoe-prints:before {
  content: "\\f54b";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-shuttle-van:before {
  content: "\\f5b6";
}

.fa-sign:before {
  content: "\\f4d9";
}

.fa-sign-in-alt:before {
  content: "\\f2f6";
}

.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-sign-out-alt:before {
  content: "\\f2f5";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-signature:before {
  content: "\\f5b7";
}

.fa-sim-card:before {
  content: "\\f7c4";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-skating:before {
  content: "\\f7c5";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skiing:before {
  content: "\\f7c9";
}

.fa-skiing-nordic:before {
  content: "\\f7ca";
}

.fa-skull:before {
  content: "\\f54c";
}

.fa-skull-crossbones:before {
  content: "\\f714";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f3ef";
}

.fa-slash:before {
  content: "\\f715";
}

.fa-sleigh:before {
  content: "\\f7cc";
}

.fa-sliders-h:before {
  content: "\\f1de";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-smile:before {
  content: "\\f118";
}

.fa-smile-beam:before {
  content: "\\f5b8";
}

.fa-smile-wink:before {
  content: "\\f4da";
}

.fa-smog:before {
  content: "\\f75f";
}

.fa-smoking:before {
  content: "\\f48d";
}

.fa-smoking-ban:before {
  content: "\\f54d";
}

.fa-sms:before {
  content: "\\f7cd";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-snowboarding:before {
  content: "\\f7ce";
}

.fa-snowflake:before {
  content: "\\f2dc";
}

.fa-snowman:before {
  content: "\\f7d0";
}

.fa-snowplow:before {
  content: "\\f7d2";
}

.fa-socks:before {
  content: "\\f696";
}

.fa-solar-panel:before {
  content: "\\f5ba";
}

.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-alpha-down:before {
  content: "\\f15d";
}

.fa-sort-alpha-down-alt:before {
  content: "\\f881";
}

.fa-sort-alpha-up:before {
  content: "\\f15e";
}

.fa-sort-alpha-up-alt:before {
  content: "\\f882";
}

.fa-sort-amount-down:before {
  content: "\\f160";
}

.fa-sort-amount-down-alt:before {
  content: "\\f884";
}

.fa-sort-amount-up:before {
  content: "\\f161";
}

.fa-sort-amount-up-alt:before {
  content: "\\f885";
}

.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-numeric-down:before {
  content: "\\f162";
}

.fa-sort-numeric-down-alt:before {
  content: "\\f886";
}

.fa-sort-numeric-up:before {
  content: "\\f163";
}

.fa-sort-numeric-up-alt:before {
  content: "\\f887";
}

.fa-sort-up:before {
  content: "\\f0de";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-spa:before {
  content: "\\f5bb";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-spell-check:before {
  content: "\\f891";
}

.fa-spider:before {
  content: "\\f717";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-splotch:before {
  content: "\\f5bc";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-spray-can:before {
  content: "\\f5bd";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-square-full:before {
  content: "\\f45c";
}

.fa-square-root-alt:before {
  content: "\\f698";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-stamp:before {
  content: "\\f5bf";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-and-crescent:before {
  content: "\\f699";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-star-half-alt:before {
  content: "\\f5c0";
}

.fa-star-of-david:before {
  content: "\\f69a";
}

.fa-star-of-life:before {
  content: "\\f621";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stopwatch:before {
  content: "\\f2f2";
}

.fa-store:before {
  content: "\\f54e";
}

.fa-store-alt:before {
  content: "\\f54f";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stream:before {
  content: "\\f550";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-stroopwafel:before {
  content: "\\f551";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-suitcase-rolling:before {
  content: "\\f5c1";
}

.fa-sun:before {
  content: "\\f185";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-surprise:before {
  content: "\\f5c2";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swatchbook:before {
  content: "\\f5c3";
}

.fa-swimmer:before {
  content: "\\f5c4";
}

.fa-swimming-pool:before {
  content: "\\f5c5";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-synagogue:before {
  content: "\\f69b";
}

.fa-sync:before {
  content: "\\f021";
}

.fa-sync-alt:before {
  content: "\\f2f1";
}

.fa-syringe:before {
  content: "\\f48e";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-table-tennis:before {
  content: "\\f45d";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-tablet-alt:before {
  content: "\\f3fa";
}

.fa-tablets:before {
  content: "\\f490";
}

.fa-tachometer-alt:before {
  content: "\\f3fd";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-tape:before {
  content: "\\f4db";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-taxi:before {
  content: "\\f1ba";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-teeth:before {
  content: "\\f62e";
}

.fa-teeth-open:before {
  content: "\\f62f";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f3fe";
}

.fa-temperature-high:before {
  content: "\\f769";
}

.fa-temperature-low:before {
  content: "\\f76b";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-tenge:before {
  content: "\\f7d7";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-theater-masks:before {
  content: "\\f630";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-thermometer:before {
  content: "\\f491";
}

.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbtack:before {
  content: "\\f08d";
}

.fa-ticket-alt:before {
  content: "\\f3ff";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-tint-slash:before {
  content: "\\f5c7";
}

.fa-tired:before {
  content: "\\f5c8";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-toilet:before {
  content: "\\f7d8";
}

.fa-toilet-paper:before {
  content: "\\f71e";
}

.fa-toolbox:before {
  content: "\\f552";
}

.fa-tools:before {
  content: "\\f7d9";
}

.fa-tooth:before {
  content: "\\f5c9";
}

.fa-torah:before {
  content: "\\f6a0";
}

.fa-torii-gate:before {
  content: "\\f6a1";
}

.fa-tractor:before {
  content: "\\f722";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-traffic-light:before {
  content: "\\f637";
}

.fa-train:before {
  content: "\\f238";
}

.fa-tram:before {
  content: "\\f7da";
}

.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-trash-alt:before {
  content: "\\f2ed";
}

.fa-trash-restore:before {
  content: "\\f829";
}

.fa-trash-restore-alt:before {
  content: "\\f82a";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-truck-loading:before {
  content: "\\f4de";
}

.fa-truck-monster:before {
  content: "\\f63b";
}

.fa-truck-moving:before {
  content: "\\f4df";
}

.fa-truck-pickup:before {
  content: "\\f63c";
}

.fa-tshirt:before {
  content: "\\f553";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-tv:before {
  content: "\\f26c";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-umbrella-beach:before {
  content: "\\f5ca";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-undo:before {
  content: "\\f0e2";
}

.fa-undo-alt:before {
  content: "\\f2ea";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-university:before {
  content: "\\f19c";
}

.fa-unlink:before {
  content: "\\f127";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-user:before {
  content: "\\f007";
}

.fa-user-alt:before {
  content: "\\f406";
}

.fa-user-alt-slash:before {
  content: "\\f4fa";
}

.fa-user-astronaut:before {
  content: "\\f4fb";
}

.fa-user-check:before {
  content: "\\f4fc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-clock:before {
  content: "\\f4fd";
}

.fa-user-cog:before {
  content: "\\f4fe";
}

.fa-user-edit:before {
  content: "\\f4ff";
}

.fa-user-friends:before {
  content: "\\f500";
}

.fa-user-graduate:before {
  content: "\\f501";
}

.fa-user-injured:before {
  content: "\\f728";
}

.fa-user-lock:before {
  content: "\\f502";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-user-minus:before {
  content: "\\f503";
}

.fa-user-ninja:before {
  content: "\\f504";
}

.fa-user-nurse:before {
  content: "\\f82f";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-user-shield:before {
  content: "\\f505";
}

.fa-user-slash:before {
  content: "\\f506";
}

.fa-user-tag:before {
  content: "\\f507";
}

.fa-user-tie:before {
  content: "\\f508";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-users:before {
  content: "\\f0c0";
}

.fa-users-cog:before {
  content: "\\f509";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-utensil-spoon:before {
  content: "\\f2e5";
}

.fa-utensils:before {
  content: "\\f2e7";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-vector-square:before {
  content: "\\f5cb";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-vial:before {
  content: "\\f492";
}

.fa-vials:before {
  content: "\\f493";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-video:before {
  content: "\\f03d";
}

.fa-video-slash:before {
  content: "\\f4e2";
}

.fa-vihara:before {
  content: "\\f6a7";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-voicemail:before {
  content: "\\f897";
}

.fa-volleyball-ball:before {
  content: "\\f45f";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-mute:before {
  content: "\\f6a9";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-vote-yea:before {
  content: "\\f772";
}

.fa-vr-cardboard:before {
  content: "\\f729";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-walking:before {
  content: "\\f554";
}

.fa-wallet:before {
  content: "\\f555";
}

.fa-warehouse:before {
  content: "\\f494";
}

.fa-water:before {
  content: "\\f773";
}

.fa-wave-square:before {
  content: "\\f83e";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weight:before {
  content: "\\f496";
}

.fa-weight-hanging:before {
  content: "\\f5cd";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wind:before {
  content: "\\f72e";
}

.fa-window-close:before {
  content: "\\f410";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wine-bottle:before {
  content: "\\f72f";
}

.fa-wine-glass:before {
  content: "\\f4e3";
}

.fa-wine-glass-alt:before {
  content: "\\f5ce";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-won-sign:before {
  content: "\\f159";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-x-ray:before {
  content: "\\f497";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yen-sign:before {
  content: "\\f157";
}

.fa-yin-yang:before {
  content: "\\f6ad";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Font Awesome 5 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
}

.fab {
  font-family: "Font Awesome 5 Brands";
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
}

.far {
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg");
}

.fa,
.far,
.fas {
  font-family: "Font Awesome 5 Free";
}

.fa,
.fas {
  font-weight: 900;
}

/*! jQuery UI - v1.12.1 - 2016-09-14
* http://jqueryui.com
* Includes: core.css, accordion.css, autocomplete.css, menu.css, button.css, controlgroup.css, checkboxradio.css, datepicker.css, dialog.css, draggable.css, resizable.css, progressbar.css, selectable.css, selectmenu.css, slider.css, sortable.css, spinner.css, tabs.css, tooltip.css, theme.css
* To view and modify this theme, visit http://jqueryui.com/themeroller/?bgShadowXPos=&bgOverlayXPos=&bgErrorXPos=&bgHighlightXPos=&bgContentXPos=&bgHeaderXPos=&bgActiveXPos=&bgHoverXPos=&bgDefaultXPos=&bgShadowYPos=&bgOverlayYPos=&bgErrorYPos=&bgHighlightYPos=&bgContentYPos=&bgHeaderYPos=&bgActiveYPos=&bgHoverYPos=&bgDefaultYPos=&bgShadowRepeat=&bgOverlayRepeat=&bgErrorRepeat=&bgHighlightRepeat=&bgContentRepeat=&bgHeaderRepeat=&bgActiveRepeat=&bgHoverRepeat=&bgDefaultRepeat=&iconsHover=url(%22images%2Fui-icons_555555_256x240.png%22)&iconsHighlight=url(%22images%2Fui-icons_777620_256x240.png%22)&iconsHeader=url(%22images%2Fui-icons_444444_256x240.png%22)&iconsError=url(%22images%2Fui-icons_cc0000_256x240.png%22)&iconsDefault=url(%22images%2Fui-icons_777777_256x240.png%22)&iconsContent=url(%22images%2Fui-icons_444444_256x240.png%22)&iconsActive=url(%22images%2Fui-icons_ffffff_256x240.png%22)&bgImgUrlShadow=&bgImgUrlOverlay=&bgImgUrlHover=&bgImgUrlHighlight=&bgImgUrlHeader=&bgImgUrlError=&bgImgUrlDefault=&bgImgUrlContent=&bgImgUrlActive=&opacityFilterShadow=Alpha(Opacity%3D30)&opacityFilterOverlay=Alpha(Opacity%3D30)&opacityShadowPerc=30&opacityOverlayPerc=30&iconColorHover=%23555555&iconColorHighlight=%23777620&iconColorHeader=%23444444&iconColorError=%23cc0000&iconColorDefault=%23777777&iconColorContent=%23444444&iconColorActive=%23ffffff&bgImgOpacityShadow=0&bgImgOpacityOverlay=0&bgImgOpacityError=95&bgImgOpacityHighlight=55&bgImgOpacityContent=75&bgImgOpacityHeader=75&bgImgOpacityActive=65&bgImgOpacityHover=75&bgImgOpacityDefault=75&bgTextureShadow=flat&bgTextureOverlay=flat&bgTextureError=flat&bgTextureHighlight=flat&bgTextureContent=flat&bgTextureHeader=flat&bgTextureActive=flat&bgTextureHover=flat&bgTextureDefault=flat&cornerRadius=3px&fwDefault=normal&ffDefault=Arial%2CHelvetica%2Csans-serif&fsDefault=1em&cornerRadiusShadow=8px&thicknessShadow=5px&offsetLeftShadow=0px&offsetTopShadow=0px&opacityShadow=.3&bgColorShadow=%23666666&opacityOverlay=.3&bgColorOverlay=%23aaaaaa&fcError=%235f3f3f&borderColorError=%23f1a899&bgColorError=%23fddfdf&fcHighlight=%23777620&borderColorHighlight=%23dad55e&bgColorHighlight=%23fffa90&fcContent=%23333333&borderColorContent=%23dddddd&bgColorContent=%23ffffff&fcHeader=%23333333&borderColorHeader=%23dddddd&bgColorHeader=%23e9e9e9&fcActive=%23ffffff&borderColorActive=%23003eff&bgColorActive=%23007fff&fcHover=%232b2b2b&borderColorHover=%23cccccc&bgColorHover=%23ededed&fcDefault=%23454545&borderColorDefault=%23c5c5c5&bgColorDefault=%23f6f6f6
* Copyright jQuery Foundation and other contributors; Licensed MIT */

@-webkit-keyframes pace-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes pace-spinner {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes pace-spinner {
  0% {
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes pace-spinner {
  0% {
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes pace-spinner {
  0% {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.ui-helper-hidden {
  display: none;
}

.ui-helper-hidden-accessible {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.ui-helper-reset {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  line-height: 1.3;
  text-decoration: none;
  font-size: 100%;
  list-style: none;
}

.ui-helper-clearfix:after,
.ui-helper-clearfix:before {
  content: "";
  display: table;
  border-collapse: collapse;
}

.ui-helper-clearfix:after {
  clear: both;
}

.ui-helper-zfix {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  filter: Alpha(Opacity=0);
}

.ui-front {
  z-index: 100;
}

.ui-state-disabled {
  cursor: default !important;
  pointer-events: none;
}

.ui-icon {
  display: inline-block;
  vertical-align: middle;
  margin-top: -0.25em;
  position: relative;
  text-indent: -99999px;
  overflow: hidden;
  background-repeat: no-repeat;
}

.ui-widget-icon-block {
  left: 50%;
  margin-left: -8px;
  display: block;
}

.ui-widget-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ui-accordion .ui-accordion-header {
  display: block;
  cursor: pointer;
  position: relative;
  margin: 2px 0 0;
  padding: 0.5em 0.5em 0.5em 0.7em;
  font-size: 100%;
}

.ui-accordion .ui-accordion-content {
  padding: 1em 2.2em;
  border-top: 0;
  overflow: auto;
}

.ui-autocomplete {
  position: absolute;
  top: 0;
  left: 0;
  cursor: default;
}

.ui-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: block;
  outline: 0;
}

.ui-menu .ui-menu {
  position: absolute;
}

.ui-menu .ui-menu-item {
  margin: 0;
  cursor: pointer;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.ui-menu .ui-menu-item-wrapper {
  position: relative;
  padding: 3px 1em 3px 0.4em;
}

.ui-menu .ui-menu-divider {
  margin: 5px 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  border-width: 1px 0 0;
}

.ui-menu .ui-state-active,
.ui-menu .ui-state-focus {
  margin: -1px;
}

.ui-button,
.ui-menu-icons {
  position: relative;
}

.ui-menu-icons .ui-menu-item-wrapper {
  padding-left: 2em;
}

.ui-menu .ui-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0.2em;
  margin: auto 0;
}

.ui-menu .ui-menu-icon {
  left: auto;
  right: 0;
}

.ui-button {
  padding: 0.4em 1em;
  display: inline-block;
  line-height: normal;
  margin-right: 0.1em;
  cursor: pointer;
  vertical-align: middle;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: visible;
}

.ui-button:active,
.ui-button:hover,
.ui-button:link,
.ui-button:visited {
  text-decoration: none;
}

.ui-button-icon-only {
  width: 2em;
  box-sizing: border-box;
  text-indent: -9999px;
  white-space: nowrap;
}

input.ui-button.ui-button-icon-only {
  text-indent: 0;
}

.ui-button-icon-only .ui-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -8px;
  margin-left: -8px;
}

.ui-button.ui-icon-notext .ui-icon {
  padding: 0;
  width: 2.1em;
  height: 2.1em;
  text-indent: -9999px;
  white-space: nowrap;
}

input.ui-button.ui-icon-notext .ui-icon {
  width: auto;
  height: auto;
  text-indent: 0;
  white-space: normal;
  padding: 0.4em 1em;
}

button.ui-button::-moz-focus-inner,
input.ui-button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.ui-controlgroup {
  vertical-align: middle;
  display: inline-block;
}

.ui-controlgroup > .ui-controlgroup-item {
  float: left;
  margin-left: 0;
  margin-right: 0;
}

.ui-controlgroup > .ui-controlgroup-item.ui-visual-focus,
.ui-controlgroup > .ui-controlgroup-item:focus {
  z-index: 9999;
}

.ui-controlgroup-vertical > .ui-controlgroup-item {
  display: block;
  float: none;
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
  text-align: left;
}

.ui-controlgroup-vertical .ui-controlgroup-item {
  box-sizing: border-box;
}

.ui-controlgroup .ui-controlgroup-label {
  padding: 0.4em 1em;
}

.ui-controlgroup .ui-controlgroup-label span {
  font-size: 80%;
}

.ui-controlgroup-horizontal .ui-controlgroup-label + .ui-controlgroup-item {
  border-left: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label + .ui-controlgroup-item {
  border-top: none;
}

.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {
  border-right: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {
  border-bottom: none;
}

.ui-controlgroup-vertical .ui-spinner-input {
  width: 75%;
  width: calc(100% - 2.4em);
}

.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {
  border-top-style: solid;
}

.ui-checkboxradio-label .ui-icon-background {
  box-shadow: inset 1px 1px 1px #ccc;
  border-radius: 0.12em;
  border: 0;
}

.ui-checkboxradio-radio-label .ui-icon-background {
  width: 16px;
  height: 16px;
  border-radius: 1em;
  overflow: visible;
  border: 0;
}

.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,
.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {
  background-image: none;
  width: 8px;
  height: 8px;
  border-width: 4px;
  border-style: solid;
}

.ui-checkboxradio-disabled {
  pointer-events: none;
}

.ui-datepicker {
  width: 17em;
  padding: 0.2em 0.2em 0;
  display: none;
}

.ui-datepicker .ui-datepicker-header {
  position: relative;
  padding: 0.2em 0;
}

.ui-datepicker .ui-datepicker-next,
.ui-datepicker .ui-datepicker-prev {
  position: absolute;
  top: 2px;
  width: 1.8em;
  height: 1.8em;
}

.ui-datepicker .ui-datepicker-next-hover,
.ui-datepicker .ui-datepicker-prev-hover {
  top: 1px;
}

.ui-datepicker .ui-datepicker-prev {
  left: 2px;
}

.ui-datepicker .ui-datepicker-next {
  right: 2px;
}

.ui-datepicker .ui-datepicker-prev-hover {
  left: 1px;
}

.ui-datepicker .ui-datepicker-next-hover {
  right: 1px;
}

.ui-datepicker .ui-datepicker-next span,
.ui-datepicker .ui-datepicker-prev span {
  display: block;
  position: absolute;
  left: 50%;
  margin-left: -8px;
  top: 50%;
  margin-top: -8px;
}

.ui-datepicker .ui-datepicker-title {
  margin: 0 2.3em;
  line-height: 1.8em;
  text-align: center;
}

.ui-datepicker .ui-datepicker-title select {
  font-size: 1em;
  margin: 1px 0;
}

.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
  width: 45%;
}

.ui-datepicker table {
  width: 100%;
  font-size: 0.9em;
  border-collapse: collapse;
  margin: 0 0 0.4em;
}

.ui-datepicker th {
  padding: 0.7em 0.3em;
  text-align: center;
  font-weight: 700;
  border: 0;
}

.ui-datepicker td {
  border: 0;
  padding: 1px;
}

.ui-datepicker td a,
.ui-datepicker td span {
  display: block;
  padding: 0.2em;
  text-align: right;
  text-decoration: none;
}

.ui-datepicker .ui-datepicker-buttonpane {
  background-image: none;
  margin: 0.7em 0 0;
  padding: 0 0.2em;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

.ui-datepicker .ui-datepicker-buttonpane button {
  float: right;
  margin: 0.5em 0.2em 0.4em;
  cursor: pointer;
  padding: 0.2em 0.6em 0.3em;
  width: auto;
  overflow: visible;
}

.ui-datepicker.ui-datepicker-multi {
  width: auto;
}

.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-multi .ui-datepicker-group,
.ui-datepicker-rtl .ui-datepicker-buttonpane button {
  float: left;
}

.ui-datepicker-multi .ui-datepicker-group table {
  width: 95%;
  margin: 0 auto 0.4em;
}

.ui-datepicker-multi-2 .ui-datepicker-group {
  width: 50%;
}

.ui-datepicker-multi-3 .ui-datepicker-group {
  width: 33.3%;
}

.ui-datepicker-multi-4 .ui-datepicker-group {
  width: 25%;
}

.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
  border-left-width: 0;
}

.ui-datepicker-multi .ui-datepicker-buttonpane {
  clear: left;
}

.ui-datepicker-row-break {
  clear: both;
  width: 100%;
  font-size: 0;
}

.ui-datepicker-rtl {
  direction: rtl;
}

.ui-datepicker-rtl .ui-datepicker-prev {
  right: 2px;
  left: auto;
}

.ui-datepicker-rtl .ui-datepicker-next {
  left: 2px;
  right: auto;
}

.ui-datepicker-rtl .ui-datepicker-prev:hover {
  right: 1px;
  left: auto;
}

.ui-datepicker-rtl .ui-datepicker-next:hover {
  left: 1px;
  right: auto;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane {
  clear: right;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-rtl .ui-datepicker-group {
  float: right;
}

.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
  border-right-width: 0;
  border-left-width: 1px;
}

.ui-datepicker .ui-icon {
  display: block;
  text-indent: -99999px;
  overflow: hidden;
  background-repeat: no-repeat;
  left: 0.5em;
  top: 0.3em;
}

.ui-dialog {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.2em;
  outline: 0;
}

.ui-dialog .ui-dialog-titlebar {
  padding: 0.4em 1em;
  position: relative;
}

.ui-dialog .ui-dialog-title {
  float: left;
  margin: 0.1em 0;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ui-dialog .ui-dialog-titlebar-close {
  position: absolute;
  right: 0.3em;
  top: 50%;
  width: 20px;
  margin: -10px 0 0;
  padding: 1px;
  height: 20px;
}

.ui-dialog .ui-dialog-content {
  position: relative;
  border: 0;
  padding: 0.5em 1em;
  background: 0 0;
  overflow: auto;
}

.ui-dialog .ui-dialog-buttonpane {
  text-align: left;
  border-width: 1px 0 0;
  background-image: none;
  margin-top: 0.5em;
  padding: 0.3em 1em 0.5em 0.4em;
}

.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
  float: right;
}

.ui-dialog .ui-dialog-buttonpane button {
  margin: 0.5em 0.4em 0.5em 0;
  cursor: pointer;
}

.ui-dialog .ui-resizable-n {
  height: 2px;
  top: 0;
}

.ui-dialog .ui-resizable-e {
  width: 2px;
  right: 0;
}

.ui-dialog .ui-resizable-s {
  height: 2px;
  bottom: 0;
}

.ui-dialog .ui-resizable-w {
  width: 2px;
  left: 0;
}

.ui-dialog .ui-resizable-ne,
.ui-dialog .ui-resizable-nw,
.ui-dialog .ui-resizable-se,
.ui-dialog .ui-resizable-sw {
  width: 7px;
  height: 7px;
}

.ui-dialog .ui-resizable-se {
  right: 0;
  bottom: 0;
}

.ui-dialog .ui-resizable-sw {
  left: 0;
  bottom: 0;
}

.ui-dialog .ui-resizable-ne {
  right: 0;
  top: 0;
}

.ui-dialog .ui-resizable-nw {
  left: 0;
  top: 0;
}

.ui-draggable .ui-dialog-titlebar {
  cursor: move;
}

.ui-draggable-handle {
  -ms-touch-action: none;
  touch-action: none;
}

.ui-resizable {
  position: relative;
}

.ui-resizable-handle {
  position: absolute;
  font-size: 0.1px;
  display: block;
  -ms-touch-action: none;
  touch-action: none;
}

.ui-resizable-autohide .ui-resizable-handle,
.ui-resizable-disabled .ui-resizable-handle {
  display: none;
}

.ui-resizable-n {
  cursor: n-resize;
  height: 7px;
  width: 100%;
  top: -5px;
  left: 0;
}

.ui-resizable-s {
  cursor: s-resize;
  height: 7px;
  width: 100%;
  bottom: -5px;
  left: 0;
}

.ui-resizable-e {
  cursor: e-resize;
  width: 7px;
  right: -5px;
  top: 0;
  height: 100%;
}

.ui-resizable-w {
  cursor: w-resize;
  width: 7px;
  left: -5px;
  top: 0;
  height: 100%;
}

.ui-resizable-se {
  cursor: se-resize;
  width: 12px;
  height: 12px;
  right: 1px;
  bottom: 1px;
}

.ui-resizable-sw {
  cursor: sw-resize;
  width: 9px;
  height: 9px;
  left: -5px;
  bottom: -5px;
}

.ui-resizable-nw {
  cursor: nw-resize;
  width: 9px;
  height: 9px;
  left: -5px;
  top: -5px;
}

.ui-resizable-ne {
  cursor: ne-resize;
  width: 9px;
  height: 9px;
  right: -5px;
  top: -5px;
}

.ui-progressbar {
  height: 2em;
  text-align: left;
  overflow: hidden;
}

.ui-progressbar .ui-progressbar-value {
  margin: -1px;
  height: 100%;
}

.ui-progressbar .ui-progressbar-overlay {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  height: 100%;
  filter: alpha(opacity=25);
  opacity: 0.25;
}

.ui-progressbar-indeterminate .ui-progressbar-value {
  background-image: none;
}

.ui-selectable {
  -ms-touch-action: none;
  touch-action: none;
}

.ui-selectable-helper {
  position: absolute;
  z-index: 100;
  border: 1px dotted #000;
}

.ui-selectmenu-menu {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

.ui-selectmenu-menu .ui-menu {
  overflow: auto;
  overflow-x: hidden;
  padding-bottom: 1px;
}

.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {
  font-size: 1em;
  font-weight: 700;
  line-height: 1.5;
  padding: 2px 0.4em;
  margin: 0.5em 0 0;
  height: auto;
  border: 0;
}

.ui-selectmenu-open {
  display: block;
}

.ui-selectmenu-text {
  display: block;
  margin-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ui-selectmenu-button.ui-button {
  text-align: left;
  white-space: nowrap;
  width: 14em;
}

.ui-selectmenu-icon.ui-icon {
  float: right;
  margin-top: 0;
}

.ui-slider {
  position: relative;
  text-align: left;
}

.ui-slider .ui-slider-handle {
  position: absolute;
  z-index: 2;
  width: 1.2em;
  height: 1.2em;
  cursor: default;
  -ms-touch-action: none;
  touch-action: none;
}

.ui-slider .ui-slider-range {
  position: absolute;
  z-index: 1;
  font-size: 0.7em;
  display: block;
  border: 0;
  background-position: 0 0;
}

.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
  filter: inherit;
}

.ui-slider-horizontal {
  height: 0.8em;
}

.ui-slider-horizontal .ui-slider-handle {
  top: -0.3em;
  margin-left: -0.6em;
}

.ui-slider-horizontal .ui-slider-range {
  top: 0;
  height: 100%;
}

.ui-slider-horizontal .ui-slider-range-min {
  left: 0;
}

.ui-slider-horizontal .ui-slider-range-max {
  right: 0;
}

.ui-slider-vertical {
  width: 0.8em;
  height: 100px;
}

.ui-slider-vertical .ui-slider-handle {
  left: -0.3em;
  margin-left: 0;
  margin-bottom: -0.6em;
}

.ui-slider-vertical .ui-slider-range {
  left: 0;
  width: 100%;
}

.ui-slider-vertical .ui-slider-range-min {
  bottom: 0;
}

.ui-slider-vertical .ui-slider-range-max {
  top: 0;
}

.ui-sortable-handle {
  -ms-touch-action: none;
  touch-action: none;
}

.ui-spinner {
  position: relative;
  display: inline-block;
  overflow: hidden;
  padding: 0;
  vertical-align: middle;
}

.ui-spinner-input {
  border: 0;
  background: 0 0;
  color: inherit;
  padding: 0.222em 0;
  vertical-align: middle;
  margin: 0.2em 2em 0.2em 0.4em;
}

.ui-spinner-button {
  width: 1.6em;
  height: 50%;
  font-size: 0.5em;
  padding: 0;
  margin: 0;
  text-align: center;
  position: absolute;
  cursor: default;
  display: block;
  overflow: hidden;
  right: 0;
}

.ui-spinner a.ui-spinner-button {
  border-top-style: none;
  border-bottom-style: none;
  border-right-style: none;
}

.ui-spinner-up {
  top: 0;
}

.ui-spinner-down {
  bottom: 0;
}

.ui-tabs {
  position: relative;
  padding: 0.2em;
}

.ui-tabs .ui-tabs-nav {
  margin: 0;
  padding: 0.2em 0.2em 0;
}

.ui-tabs .ui-tabs-nav li {
  list-style: none;
  float: left;
  position: relative;
  top: 0;
  margin: 1px 0.2em 0 0;
  border-bottom-width: 0;
  padding: 0;
  white-space: nowrap;
}

.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
  float: left;
  padding: 0.5em 1em;
  text-decoration: none;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active {
  margin-bottom: -1px;
  padding-bottom: 1px;
}

.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {
  cursor: text;
}

.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {
  cursor: pointer;
}

.ui-tabs .ui-tabs-panel {
  display: block;
  border-width: 0;
  padding: 1em 1.4em;
  background: 0 0;
}

.ui-tooltip {
  padding: 8px;
  position: absolute;
  z-index: 9999;
  max-width: 300px;
}

body .ui-tooltip {
  border-width: 2px;
}

.ui-widget,
.ui-widget button,
.ui-widget input,
.ui-widget select,
.ui-widget textarea {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.ui-widget .ui-widget {
  font-size: 1em;
}

.ui-widget.ui-widget-content {
  border: 1px solid #c5c5c5;
}

.ui-widget-content {
  border: 1px solid #ddd;
  background: #fff;
  color: #333;
}

.ui-widget-content a,
.ui-widget-header a {
  color: #333;
}

.ui-widget-header {
  border: 1px solid #ddd;
  background: #e9e9e9;
  color: #333;
  font-weight: 700;
}

.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default {
  border: 1px solid #c5c5c5;
  background: #f6f6f6;
  font-weight: 400;
  color: #454545;
}

.ui-button {
  border: 1px solid #c5c5c5;
  background: #f6f6f6;
  font-weight: 400;
}

html .ui-button.ui-state-disabled:active,
html .ui-button.ui-state-disabled:hover {
  border: 1px solid #c5c5c5;
  background: #f6f6f6;
  font-weight: 400;
  color: #454545;
}

.ui-button,
.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited,
a.ui-button,
a:link.ui-button,
a:visited.ui-button {
  color: #454545;
  text-decoration: none;
}

.ui-button:focus,
.ui-button:hover,
.ui-state-focus,
.ui-state-hover,
.ui-widget-content .ui-state-focus,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-focus,
.ui-widget-header .ui-state-hover {
  border: 1px solid #ccc;
  background: #ededed;
  font-weight: 400;
  color: #2b2b2b;
}

.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited,
.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
a.ui-button:focus,
a.ui-button:hover {
  color: #2b2b2b;
  text-decoration: none;
}

.ui-visual-focus {
  box-shadow: 0 0 3px 1px #5e9ed6;
}

.ui-button.ui-state-active:hover,
.ui-button:active,
.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active {
  border: 1px solid #003eff;
  background: #007fff;
  font-weight: 400;
  color: #fff;
}

.ui-icon-background,
.ui-state-active .ui-icon-background {
  border: #003eff;
  background-color: #fff;
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
  color: #fff;
  text-decoration: none;
}

.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  border: 1px solid #dad55e;
  background: #fffa90;
  color: #777620;
}

.ui-state-checked {
  border: 1px solid #dad55e;
  background: #fffa90;
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
  color: #777620;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
  border: 1px solid #f1a899;
  background: #fddfdf;
  color: #5f3f3f;
}

.ui-state-error a,
.ui-state-error-text,
.ui-widget-content .ui-state-error a,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error a,
.ui-widget-header .ui-state-error-text {
  color: #5f3f3f;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
  font-weight: 700;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
  opacity: 0.7;
  filter: Alpha(Opacity=70);
  font-weight: 400;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: 0.35;
  filter: Alpha(Opacity=35);
  background-image: none;
}

.ui-state-disabled .ui-icon {
  filter: Alpha(Opacity=35);
}

.ui-icon {
  width: 16px;
  height: 16px;
}

.ui-icon,
.ui-widget-content .ui-icon,
.ui-widget-header .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.ui-button:focus .ui-icon,
.ui-button:hover .ui-icon,
.ui-state-focus .ui-icon,
.ui-state-hover .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.ui-button:active .ui-icon,
.ui-state-active .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.ui-button .ui-state-highlight.ui-icon,
.ui-state-highlight .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.ui-state-error .ui-icon,
.ui-state-error-text .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.ui-button .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.ui-icon-blank {
  background-position: 16px 16px;
}

.ui-icon-caret-1-n {
  background-position: 0 0;
}

.ui-icon-caret-1-ne {
  background-position: -16px 0;
}

.ui-icon-caret-1-e {
  background-position: -32px 0;
}

.ui-icon-caret-1-se {
  background-position: -48px 0;
}

.ui-icon-caret-1-s {
  background-position: -65px 0;
}

.ui-icon-caret-1-sw {
  background-position: -80px 0;
}

.ui-icon-caret-1-w {
  background-position: -96px 0;
}

.ui-icon-caret-1-nw {
  background-position: -112px 0;
}

.ui-icon-caret-2-n-s {
  background-position: -128px 0;
}

.ui-icon-caret-2-e-w {
  background-position: -144px 0;
}

.ui-icon-triangle-1-n {
  background-position: 0 -16px;
}

.ui-icon-triangle-1-ne {
  background-position: -16px -16px;
}

.ui-icon-triangle-1-e {
  background-position: -32px -16px;
}

.ui-icon-triangle-1-se {
  background-position: -48px -16px;
}

.ui-icon-triangle-1-s {
  background-position: -65px -16px;
}

.ui-icon-triangle-1-sw {
  background-position: -80px -16px;
}

.ui-icon-triangle-1-w {
  background-position: -96px -16px;
}

.ui-icon-triangle-1-nw {
  background-position: -112px -16px;
}

.ui-icon-triangle-2-n-s {
  background-position: -128px -16px;
}

.ui-icon-triangle-2-e-w {
  background-position: -144px -16px;
}

.ui-icon-arrow-1-n {
  background-position: 0 -32px;
}

.ui-icon-arrow-1-ne {
  background-position: -16px -32px;
}

.ui-icon-arrow-1-e {
  background-position: -32px -32px;
}

.ui-icon-arrow-1-se {
  background-position: -48px -32px;
}

.ui-icon-arrow-1-s {
  background-position: -65px -32px;
}

.ui-icon-arrow-1-sw {
  background-position: -80px -32px;
}

.ui-icon-arrow-1-w {
  background-position: -96px -32px;
}

.ui-icon-arrow-1-nw {
  background-position: -112px -32px;
}

.ui-icon-arrow-2-n-s {
  background-position: -128px -32px;
}

.ui-icon-arrow-2-ne-sw {
  background-position: -144px -32px;
}

.ui-icon-arrow-2-e-w {
  background-position: -160px -32px;
}

.ui-icon-arrow-2-se-nw {
  background-position: -176px -32px;
}

.ui-icon-arrowstop-1-n {
  background-position: -192px -32px;
}

.ui-icon-arrowstop-1-e {
  background-position: -208px -32px;
}

.ui-icon-arrowstop-1-s {
  background-position: -224px -32px;
}

.ui-icon-arrowstop-1-w {
  background-position: -240px -32px;
}

.ui-icon-arrowthick-1-n {
  background-position: 1px -48px;
}

.ui-icon-arrowthick-1-ne {
  background-position: -16px -48px;
}

.ui-icon-arrowthick-1-e {
  background-position: -32px -48px;
}

.ui-icon-arrowthick-1-se {
  background-position: -48px -48px;
}

.ui-icon-arrowthick-1-s {
  background-position: -64px -48px;
}

.ui-icon-arrowthick-1-sw {
  background-position: -80px -48px;
}

.ui-icon-arrowthick-1-w {
  background-position: -96px -48px;
}

.ui-icon-arrowthick-1-nw {
  background-position: -112px -48px;
}

.ui-icon-arrowthick-2-n-s {
  background-position: -128px -48px;
}

.ui-icon-arrowthick-2-ne-sw {
  background-position: -144px -48px;
}

.ui-icon-arrowthick-2-e-w {
  background-position: -160px -48px;
}

.ui-icon-arrowthick-2-se-nw {
  background-position: -176px -48px;
}

.ui-icon-arrowthickstop-1-n {
  background-position: -192px -48px;
}

.ui-icon-arrowthickstop-1-e {
  background-position: -208px -48px;
}

.ui-icon-arrowthickstop-1-s {
  background-position: -224px -48px;
}

.ui-icon-arrowthickstop-1-w {
  background-position: -240px -48px;
}

.ui-icon-arrowreturnthick-1-w {
  background-position: 0 -64px;
}

.ui-icon-arrowreturnthick-1-n {
  background-position: -16px -64px;
}

.ui-icon-arrowreturnthick-1-e {
  background-position: -32px -64px;
}

.ui-icon-arrowreturnthick-1-s {
  background-position: -48px -64px;
}

.ui-icon-arrowreturn-1-w {
  background-position: -64px -64px;
}

.ui-icon-arrowreturn-1-n {
  background-position: -80px -64px;
}

.ui-icon-arrowreturn-1-e {
  background-position: -96px -64px;
}

.ui-icon-arrowreturn-1-s {
  background-position: -112px -64px;
}

.ui-icon-arrowrefresh-1-w {
  background-position: -128px -64px;
}

.ui-icon-arrowrefresh-1-n {
  background-position: -144px -64px;
}

.ui-icon-arrowrefresh-1-e {
  background-position: -160px -64px;
}

.ui-icon-arrowrefresh-1-s {
  background-position: -176px -64px;
}

.ui-icon-arrow-4 {
  background-position: 0 -80px;
}

.ui-icon-arrow-4-diag {
  background-position: -16px -80px;
}

.ui-icon-extlink {
  background-position: -32px -80px;
}

.ui-icon-newwin {
  background-position: -48px -80px;
}

.ui-icon-refresh {
  background-position: -64px -80px;
}

.ui-icon-shuffle {
  background-position: -80px -80px;
}

.ui-icon-transfer-e-w {
  background-position: -96px -80px;
}

.ui-icon-transferthick-e-w {
  background-position: -112px -80px;
}

.ui-icon-folder-collapsed {
  background-position: 0 -96px;
}

.ui-icon-folder-open {
  background-position: -16px -96px;
}

.ui-icon-document {
  background-position: -32px -96px;
}

.ui-icon-document-b {
  background-position: -48px -96px;
}

.ui-icon-note {
  background-position: -64px -96px;
}

.ui-icon-mail-closed {
  background-position: -80px -96px;
}

.ui-icon-mail-open {
  background-position: -96px -96px;
}

.ui-icon-suitcase {
  background-position: -112px -96px;
}

.ui-icon-comment {
  background-position: -128px -96px;
}

.ui-icon-person {
  background-position: -144px -96px;
}

.ui-icon-print {
  background-position: -160px -96px;
}

.ui-icon-trash {
  background-position: -176px -96px;
}

.ui-icon-locked {
  background-position: -192px -96px;
}

.ui-icon-unlocked {
  background-position: -208px -96px;
}

.ui-icon-bookmark {
  background-position: -224px -96px;
}

.ui-icon-tag {
  background-position: -240px -96px;
}

.ui-icon-home {
  background-position: 0 -112px;
}

.ui-icon-flag {
  background-position: -16px -112px;
}

.ui-icon-calendar {
  background-position: -32px -112px;
}

.ui-icon-cart {
  background-position: -48px -112px;
}

.ui-icon-pencil {
  background-position: -64px -112px;
}

.ui-icon-clock {
  background-position: -80px -112px;
}

.ui-icon-disk {
  background-position: -96px -112px;
}

.ui-icon-calculator {
  background-position: -112px -112px;
}

.ui-icon-zoomin {
  background-position: -128px -112px;
}

.ui-icon-zoomout {
  background-position: -144px -112px;
}

.ui-icon-search {
  background-position: -160px -112px;
}

.ui-icon-wrench {
  background-position: -176px -112px;
}

.ui-icon-gear {
  background-position: -192px -112px;
}

.ui-icon-heart {
  background-position: -208px -112px;
}

.ui-icon-star {
  background-position: -224px -112px;
}

.ui-icon-link {
  background-position: -240px -112px;
}

.ui-icon-cancel {
  background-position: 0 -128px;
}

.ui-icon-plus {
  background-position: -16px -128px;
}

.ui-icon-plusthick {
  background-position: -32px -128px;
}

.ui-icon-minus {
  background-position: -48px -128px;
}

.ui-icon-minusthick {
  background-position: -64px -128px;
}

.ui-icon-close {
  background-position: -80px -128px;
}

.ui-icon-closethick {
  background-position: -96px -128px;
}

.ui-icon-key {
  background-position: -112px -128px;
}

.ui-icon-lightbulb {
  background-position: -128px -128px;
}

.ui-icon-scissors {
  background-position: -144px -128px;
}

.ui-icon-clipboard {
  background-position: -160px -128px;
}

.ui-icon-copy {
  background-position: -176px -128px;
}

.ui-icon-contact {
  background-position: -192px -128px;
}

.ui-icon-image {
  background-position: -208px -128px;
}

.ui-icon-video {
  background-position: -224px -128px;
}

.ui-icon-script {
  background-position: -240px -128px;
}

.ui-icon-alert {
  background-position: 0 -144px;
}

.ui-icon-info {
  background-position: -16px -144px;
}

.ui-icon-notice {
  background-position: -32px -144px;
}

.ui-icon-help {
  background-position: -48px -144px;
}

.ui-icon-check {
  background-position: -64px -144px;
}

.ui-icon-bullet {
  background-position: -80px -144px;
}

.ui-icon-radio-on {
  background-position: -96px -144px;
}

.ui-icon-radio-off {
  background-position: -112px -144px;
}

.ui-icon-pin-w {
  background-position: -128px -144px;
}

.ui-icon-pin-s {
  background-position: -144px -144px;
}

.ui-icon-play {
  background-position: 0 -160px;
}

.ui-icon-pause {
  background-position: -16px -160px;
}

.ui-icon-seek-next {
  background-position: -32px -160px;
}

.ui-icon-seek-prev {
  background-position: -48px -160px;
}

.ui-icon-seek-end {
  background-position: -64px -160px;
}

.ui-icon-seek-first,
.ui-icon-seek-start {
  background-position: -80px -160px;
}

.ui-icon-stop {
  background-position: -96px -160px;
}

.ui-icon-eject {
  background-position: -112px -160px;
}

.ui-icon-volume-off {
  background-position: -128px -160px;
}

.ui-icon-volume-on {
  background-position: -144px -160px;
}

.ui-icon-power {
  background-position: 0 -176px;
}

.ui-icon-signal-diag {
  background-position: -16px -176px;
}

.ui-icon-signal {
  background-position: -32px -176px;
}

.ui-icon-battery-0 {
  background-position: -48px -176px;
}

.ui-icon-battery-1 {
  background-position: -64px -176px;
}

.ui-icon-battery-2 {
  background-position: -80px -176px;
}

.ui-icon-battery-3 {
  background-position: -96px -176px;
}

.ui-icon-circle-plus {
  background-position: 0 -192px;
}

.ui-icon-circle-minus {
  background-position: -16px -192px;
}

.ui-icon-circle-close {
  background-position: -32px -192px;
}

.ui-icon-circle-triangle-e {
  background-position: -48px -192px;
}

.ui-icon-circle-triangle-s {
  background-position: -64px -192px;
}

.ui-icon-circle-triangle-w {
  background-position: -80px -192px;
}

.ui-icon-circle-triangle-n {
  background-position: -96px -192px;
}

.ui-icon-circle-arrow-e {
  background-position: -112px -192px;
}

.ui-icon-circle-arrow-s {
  background-position: -128px -192px;
}

.ui-icon-circle-arrow-w {
  background-position: -144px -192px;
}

.ui-icon-circle-arrow-n {
  background-position: -160px -192px;
}

.ui-icon-circle-zoomin {
  background-position: -176px -192px;
}

.ui-icon-circle-zoomout {
  background-position: -192px -192px;
}

.ui-icon-circle-check {
  background-position: -208px -192px;
}

.ui-icon-circlesmall-plus {
  background-position: 0 -208px;
}

.ui-icon-circlesmall-minus {
  background-position: -16px -208px;
}

.ui-icon-circlesmall-close {
  background-position: -32px -208px;
}

.ui-icon-squaresmall-plus {
  background-position: -48px -208px;
}

.ui-icon-squaresmall-minus {
  background-position: -64px -208px;
}

.ui-icon-squaresmall-close {
  background-position: -80px -208px;
}

.ui-icon-grip-dotted-vertical {
  background-position: 0 -224px;
}

.ui-icon-grip-dotted-horizontal {
  background-position: -16px -224px;
}

.ui-icon-grip-solid-vertical {
  background-position: -32px -224px;
}

.ui-icon-grip-solid-horizontal {
  background-position: -48px -224px;
}

.ui-icon-gripsmall-diagonal-se {
  background-position: -64px -224px;
}

.ui-icon-grip-diagonal-se {
  background-position: -80px -224px;
}

.ui-corner-all,
.ui-corner-left,
.ui-corner-tl,
.ui-corner-top {
  border-top-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-right,
.ui-corner-top,
.ui-corner-tr {
  border-top-right-radius: 3px;
}

.ui-corner-all,
.ui-corner-bl,
.ui-corner-bottom,
.ui-corner-left {
  border-bottom-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-br,
.ui-corner-right {
  border-bottom-right-radius: 3px;
}

.ui-widget-overlay {
  background: #aaa;
  opacity: 0.003;
  filter: Alpha(Opacity=0.3);
}

.ui-widget-shadow {
  -webkit-box-shadow: 0 0 5px #666;
  box-shadow: 0 0 5px #666;
}

.pace {
  -webkit-pointer-events: none;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.pace-inactive {
  display: none;
}

.pace .pace-progress {
  background: #000;
  position: fixed;
  z-index: 2000;
  top: 0;
  right: 100%;
  width: 100%;
  height: 2px;
}

.pace .pace-progress-inner {
  display: block;
  position: absolute;
  right: 0;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #000, 0 0 5px #000;
  opacity: 1;
  -webkit-transform: rotate(3deg) translate(0, -4px);
  -moz-transform: rotate(3deg) translate(0, -4px);
  -ms-transform: rotate(3deg) translate(0, -4px);
  -o-transform: rotate(3deg) translate(0, -4px);
  transform: rotate(3deg) translate(0, -4px);
}

.pace .pace-activity {
  display: block;
  position: fixed;
  z-index: 2000;
  top: 15px;
  right: 15px;
  width: 14px;
  height: 14px;
  border: solid 2px transparent;
  border-top-color: #000;
  border-left-color: #000;
  border-radius: 10px;
  -webkit-animation: pace-spinner 400ms linear infinite;
  -moz-animation: pace-spinner 400ms linear infinite;
  -ms-animation: pace-spinner 400ms linear infinite;
  -o-animation: pace-spinner 400ms linear infinite;
  animation: pace-spinner 400ms linear infinite;
}

/*!
 * Color Admin v4.4.0 (https://seantheme.com/color-admin/)
 * Copyright 2019 SeanTheme
 */
/*!
 * Bootstrap v4.3.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 The Bootstrap Authors
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
@keyframes progress-bar-stripes {
  0% {
    background-position: 1rem 0;
  }

  to {
    background-position: 0 0;
  }
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }
}

@-webkit-keyframes navbar-input-expand {
  0% {
    width: 220px;
  }

  to {
    width: 300px;
  }
}

@-moz-keyframes navbar-input-expand {
  0% {
    width: 220px;
  }

  to {
    width: 300px;
  }
}

@-o-keyframes navbar-input-expand {
  0% {
    width: 220px;
  }

  to {
    width: 300px;
  }
}

@keyframes navbar-input-expand {
  0% {
    width: 220px;
  }

  to {
    width: 300px;
  }
}

@-webkit-keyframes navbar-input-expand-xs {
  0% {
    width: 160px;
  }

  to {
    width: 200px;
  }
}

@-moz-keyframes navbar-input-expand-xs {
  0% {
    width: 160px;
  }

  to {
    width: 200px;
  }
}

@-o-keyframes navbar-input-expand-xs {
  0% {
    width: 160px;
  }

  to {
    width: 200px;
  }
}

@keyframes navbar-input-expand-xs {
  0% {
    width: 160px;
  }

  to {
    width: 200px;
  }
}

@-webkit-keyframes topMenuControlSlideInLeft {
  0% {
    left: -50px;
  }

  to {
    left: 0;
  }
}

@-moz-keyframes topMenuControlSlideInLeft {
  0% {
    left: -50px;
  }

  to {
    left: 0;
  }
}

@-o-keyframes topMenuControlSlideInLeft {
  0% {
    left: -50px;
  }

  to {
    left: 0;
  }
}

@keyframes topMenuControlSlideInLeft {
  0% {
    left: -50px;
  }

  to {
    left: 0;
  }
}

@-webkit-keyframes topMenuControlSlideInRight {
  0% {
    right: -50px;
  }

  to {
    right: 0;
  }
}

@-moz-keyframes topMenuControlSlideInRight {
  0% {
    right: -50px;
  }

  to {
    right: 0;
  }
}

@-o-keyframes topMenuControlSlideInRight {
  0% {
    right: -50px;
  }

  to {
    right: 0;
  }
}

@keyframes topMenuControlSlideInRight {
  0% {
    right: -50px;
  }

  to {
    right: 0;
  }
}

@-webkit-keyframes sidebarSlideInLeft {
  0% {
    left: -220px;
  }

  to {
    left: 0;
  }
}

@-moz-keyframes sidebarSlideInLeft {
  0% {
    left: -220px;
  }

  to {
    left: 0;
  }
}

@-o-keyframes sidebarSlideInLeft {
  0% {
    left: -220px;
  }

  to {
    left: 0;
  }
}

@keyframes sidebarSlideInLeft {
  0% {
    left: -220px;
  }

  to {
    left: 0;
  }
}

@-webkit-keyframes sidebarSlideInRight {
  0% {
    right: -220px;
  }

  to {
    right: 0;
  }
}

@-moz-keyframes sidebarSlideInRight {
  0% {
    right: -220px;
  }

  to {
    right: 0;
  }
}

@-o-keyframes sidebarSlideInRight {
  0% {
    right: -220px;
  }

  to {
    right: 0;
  }
}

@keyframes sidebarSlideInRight {
  0% {
    right: -220px;
  }

  to {
    right: 0;
  }
}

@-webkit-keyframes wideSidebarSlideInLeft {
  0% {
    left: -250px;
  }

  to {
    left: 0;
  }
}

@-moz-keyframes wideSidebarSlideInLeft {
  0% {
    left: -250px;
  }

  to {
    left: 0;
  }
}

@-o-keyframes wideSidebarSlideInLeft {
  0% {
    left: -250px;
  }

  to {
    left: 0;
  }
}

@keyframes wideSidebarSlideInLeft {
  0% {
    left: -250px;
  }

  to {
    left: 0;
  }
}

@-webkit-keyframes wideSidebarSlideInRight {
  0% {
    right: -250px;
  }

  to {
    right: 0;
  }
}

@-moz-keyframes wideSidebarSlideInRight {
  0% {
    right: -250px;
  }

  to {
    right: 0;
  }
}

@-o-keyframes wideSidebarSlideInRight {
  0% {
    right: -250px;
  }

  to {
    right: 0;
  }
}

@keyframes wideSidebarSlideInRight {
  0% {
    right: -250px;
  }

  to {
    right: 0;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    -moz-transform: rotate(359deg);
    -ms-transform: rotate(359deg);
    -o-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

@-moz-keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    -moz-transform: rotate(359deg);
    -ms-transform: rotate(359deg);
    -o-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

@-o-keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    -moz-transform: rotate(359deg);
    -ms-transform: rotate(359deg);
    -o-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    -moz-transform: rotate(359deg);
    -ms-transform: rotate(359deg);
    -o-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

@-webkit-keyframes pace-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes pace-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes pace-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes pace-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

:root {
  --blue: #348fe2;
  --indigo: #8753de;
  --purple: #727cb6;
  --pink: #fb5597;
  --red: #ff5b57;
  --orange: #f59c1a;
  --yellow: #ffd900;
  --green: #32a932;
  --teal: #00acac;
  --cyan: #49b6d6;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --dark-darker: #1a2229;
  --muted: #627884;
  --primary: #00acac;
  --secondary: #6c757d;
  --success: #00acac;
  --info: #49b6d6;
  --warning: #f59c1a;
  --danger: #ff5b57;
  --light: #f2f3f4;
  --dark: #2d353c;
  --inverse: #2d353c;
  --black: #000000;
  --white: #ffffff;
  --grey: #b6c2c9;
  --muted: #b6c2c9;
  --silver: #b6c2c9;
  --lime: #90ca4b;
  --aqua: #49b6d6;
  --breakpoint-xxs: 0px;
  --breakpoint-xs: 360px;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --breakpoint-xxl: 1660px;
  --breakpoint-xxxl: 1900px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}

*,
::after,
::before {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  height: 100%;
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
  text-align: left;
  background-color: #d9e0e7;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  overflow: visible;
  margin-top: 16px;
  margin-bottom: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border: 0;
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-top: 0;
}

p {
  margin-bottom: 15px;
}

abbr[data-original-title],
abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address,
dl,
ol,
ul {
  margin-bottom: 1rem;
}

address {
  font-style: normal;
  line-height: inherit;
}

dl,
ol,
ul {
  margin-top: 0;
}

ol ol,
ol ul,
ul ol,
ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote,
figure {
  margin: 0 0 1rem;
}

strong {
  font-weight: bolder;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #348fe2;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #1968b0;
  text-decoration: underline;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):focus,
a:not([href]):not([tabindex]):hover {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):focus {
  outline: 0;
}

code,
kbd,
pre,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;
}

samp {
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  display: block;
  font-size: 87.5%;
  color: #212529;
}

img,
svg {
  vertical-align: middle;
}

img {
  border-style: none;
}

svg {
  overflow: hidden;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 8px;
  padding-bottom: 8px;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

select {
  word-wrap: normal;
}

[type="button"],
[type="reset"],
[type="submit"],
button {
  -webkit-appearance: button;
}

[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled),
button:not(:disabled) {
  cursor: pointer;
}

[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="date"],
input[type="datetime-local"],
input[type="month"],
input[type="time"] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 8px;
  font-weight: 600;
  line-height: 1.2;
}

.h1,
h1 {
  font-size: 1.875rem;
}

.h2,
h2 {
  font-size: 1.5rem;
}

.h3,
h3 {
  font-size: 1.3125rem;
}

.h4,
h4 {
  font-size: 1.125rem;
}

.h5,
h5 {
  font-size: 0.9375rem;
}

.h6,
h6 {
  font-size: 0.75rem;
}

.lead {
  font-size: 0.9375rem;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2,
.display-3,
.display-4 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3,
.display-4 {
  font-size: 4.5rem;
}

.display-4 {
  font-size: 3.5rem;
}

.small,
small {
  font-size: 80%;
  font-weight: 400;
}

.mark,
mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-inline,
.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 16px;
  font-size: 0.9375rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "\\2014\\00A0";
}

.img-fluid,
.img-thumbnail {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #d9e0e7;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 8px;
  line-height: 1;
}

.figure-caption,
code {
  font-size: 90%;
  color: #6c757d;
}

code {
  word-break: break-word;
  padding: 2px 4px;
  color: #f90a69;
  background-color: #fff0f0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

a > code,
pre code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 3px;
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre code {
  font-size: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 750px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1170px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.card > hr,
.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col-auto {
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
}

.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto,
.col-xs,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-auto,
.col-xxl,
.col-xxl-1,
.col-xxl-10,
.col-xxl-11,
.col-xxl-12,
.col-xxl-2,
.col-xxl-3,
.col-xxl-4,
.col-xxl-5,
.col-xxl-6,
.col-xxl-7,
.col-xxl-8,
.col-xxl-9,
.col-xxl-auto,
.col-xxxl,
.col-xxxl-1,
.col-xxxl-10,
.col-xxxl-11,
.col-xxxl-12,
.col-xxxl-2,
.col-xxxl-3,
.col-xxxl-4,
.col-xxxl-5,
.col-xxxl-6,
.col-xxxl-7,
.col-xxxl-8,
.col-xxxl-9,
.col-xxxl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
}

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%;
}

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333%;
}

.offset-2 {
  margin-left: 16.66667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333%;
}

.offset-5 {
  margin-left: 41.66667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333%;
}

.offset-8 {
  margin-left: 66.66667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333%;
}

.offset-11 {
  margin-left: 91.66667%;
}

@media (min-width: 360px) {
  .col-xs {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-xs-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xs-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-xs-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xs-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xs-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-xs-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-xs-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xs-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-xs-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-xs-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xs-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-xs-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-xs-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xs-first {
    order: -1;
  }

  .order-xs-last {
    order: 13;
  }

  .order-xs-0 {
    order: 0;
  }

  .order-xs-1 {
    order: 1;
  }

  .order-xs-2 {
    order: 2;
  }

  .order-xs-3 {
    order: 3;
  }

  .order-xs-4 {
    order: 4;
  }

  .order-xs-5 {
    order: 5;
  }

  .order-xs-6 {
    order: 6;
  }

  .order-xs-7 {
    order: 7;
  }

  .order-xs-8 {
    order: 8;
  }

  .order-xs-9 {
    order: 9;
  }

  .order-xs-10 {
    order: 10;
  }

  .order-xs-11 {
    order: 11;
  }

  .order-xs-12 {
    order: 12;
  }

  .offset-xs-0 {
    margin-left: 0;
  }

  .offset-xs-1 {
    margin-left: 8.33333%;
  }

  .offset-xs-2 {
    margin-left: 16.66667%;
  }

  .offset-xs-3 {
    margin-left: 25%;
  }

  .offset-xs-4 {
    margin-left: 33.33333%;
  }

  .offset-xs-5 {
    margin-left: 41.66667%;
  }

  .offset-xs-6 {
    margin-left: 50%;
  }

  .offset-xs-7 {
    margin-left: 58.33333%;
  }

  .offset-xs-8 {
    margin-left: 66.66667%;
  }

  .offset-xs-9 {
    margin-left: 75%;
  }

  .offset-xs-10 {
    margin-left: 83.33333%;
  }

  .offset-xs-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-sm-first {
    order: -1;
  }

  .order-sm-last {
    order: 13;
  }

  .order-sm-0 {
    order: 0;
  }

  .order-sm-1 {
    order: 1;
  }

  .order-sm-2 {
    order: 2;
  }

  .order-sm-3 {
    order: 3;
  }

  .order-sm-4 {
    order: 4;
  }

  .order-sm-5 {
    order: 5;
  }

  .order-sm-6 {
    order: 6;
  }

  .order-sm-7 {
    order: 7;
  }

  .order-sm-8 {
    order: 8;
  }

  .order-sm-9 {
    order: 9;
  }

  .order-sm-10 {
    order: 10;
  }

  .order-sm-11 {
    order: 11;
  }

  .order-sm-12 {
    order: 12;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333%;
  }

  .offset-sm-2 {
    margin-left: 16.66667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333%;
  }

  .offset-sm-5 {
    margin-left: 41.66667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333%;
  }

  .offset-sm-8 {
    margin-left: 66.66667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333%;
  }

  .offset-sm-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-md-first {
    order: -1;
  }

  .order-md-last {
    order: 13;
  }

  .order-md-0 {
    order: 0;
  }

  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }

  .order-md-3 {
    order: 3;
  }

  .order-md-4 {
    order: 4;
  }

  .order-md-5 {
    order: 5;
  }

  .order-md-6 {
    order: 6;
  }

  .order-md-7 {
    order: 7;
  }

  .order-md-8 {
    order: 8;
  }

  .order-md-9 {
    order: 9;
  }

  .order-md-10 {
    order: 10;
  }

  .order-md-11 {
    order: 11;
  }

  .order-md-12 {
    order: 12;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333%;
  }

  .offset-md-2 {
    margin-left: 16.66667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333%;
  }

  .offset-md-5 {
    margin-left: 41.66667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333%;
  }

  .offset-md-8 {
    margin-left: 66.66667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333%;
  }

  .offset-md-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-lg-first {
    order: -1;
  }

  .order-lg-last {
    order: 13;
  }

  .order-lg-0 {
    order: 0;
  }

  .order-lg-1 {
    order: 1;
  }

  .order-lg-2 {
    order: 2;
  }

  .order-lg-3 {
    order: 3;
  }

  .order-lg-4 {
    order: 4;
  }

  .order-lg-5 {
    order: 5;
  }

  .order-lg-6 {
    order: 6;
  }

  .order-lg-7 {
    order: 7;
  }

  .order-lg-8 {
    order: 8;
  }

  .order-lg-9 {
    order: 9;
  }

  .order-lg-10 {
    order: 10;
  }

  .order-lg-11 {
    order: 11;
  }

  .order-lg-12 {
    order: 12;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333%;
  }

  .offset-lg-2 {
    margin-left: 16.66667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333%;
  }

  .offset-lg-5 {
    margin-left: 41.66667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333%;
  }

  .offset-lg-8 {
    margin-left: 66.66667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333%;
  }

  .offset-lg-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xl-first {
    order: -1;
  }

  .order-xl-last {
    order: 13;
  }

  .order-xl-0 {
    order: 0;
  }

  .order-xl-1 {
    order: 1;
  }

  .order-xl-2 {
    order: 2;
  }

  .order-xl-3 {
    order: 3;
  }

  .order-xl-4 {
    order: 4;
  }

  .order-xl-5 {
    order: 5;
  }

  .order-xl-6 {
    order: 6;
  }

  .order-xl-7 {
    order: 7;
  }

  .order-xl-8 {
    order: 8;
  }

  .order-xl-9 {
    order: 9;
  }

  .order-xl-10 {
    order: 10;
  }

  .order-xl-11 {
    order: 11;
  }

  .order-xl-12 {
    order: 12;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333%;
  }

  .offset-xl-2 {
    margin-left: 16.66667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333%;
  }

  .offset-xl-5 {
    margin-left: 41.66667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333%;
  }

  .offset-xl-8 {
    margin-left: 66.66667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333%;
  }

  .offset-xl-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1660px) {
  .col-xxl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xxl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-xxl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xxl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-xxl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-xxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-xxl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-xxl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-xxl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-xxl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xxl-first {
    order: -1;
  }

  .order-xxl-last {
    order: 13;
  }

  .order-xxl-0 {
    order: 0;
  }

  .order-xxl-1 {
    order: 1;
  }

  .order-xxl-2 {
    order: 2;
  }

  .order-xxl-3 {
    order: 3;
  }

  .order-xxl-4 {
    order: 4;
  }

  .order-xxl-5 {
    order: 5;
  }

  .order-xxl-6 {
    order: 6;
  }

  .order-xxl-7 {
    order: 7;
  }

  .order-xxl-8 {
    order: 8;
  }

  .order-xxl-9 {
    order: 9;
  }

  .order-xxl-10 {
    order: 10;
  }

  .order-xxl-11 {
    order: 11;
  }

  .order-xxl-12 {
    order: 12;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1900px) {
  .col-xxxl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-xxxl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xxxl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-xxxl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xxxl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xxxl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-xxxl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-xxxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xxxl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-xxxl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-xxxl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xxxl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-xxxl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-xxxl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xxxl-first {
    order: -1;
  }

  .order-xxxl-last {
    order: 13;
  }

  .order-xxxl-0 {
    order: 0;
  }

  .order-xxxl-1 {
    order: 1;
  }

  .order-xxxl-2 {
    order: 2;
  }

  .order-xxxl-3 {
    order: 3;
  }

  .order-xxxl-4 {
    order: 4;
  }

  .order-xxxl-5 {
    order: 5;
  }

  .order-xxxl-6 {
    order: 6;
  }

  .order-xxxl-7 {
    order: 7;
  }

  .order-xxxl-8 {
    order: 8;
  }

  .order-xxxl-9 {
    order: 9;
  }

  .order-xxxl-10 {
    order: 10;
  }

  .order-xxxl-11 {
    order: 11;
  }

  .order-xxxl-12 {
    order: 12;
  }

  .offset-xxxl-0 {
    margin-left: 0;
  }

  .offset-xxxl-1 {
    margin-left: 8.33333%;
  }

  .offset-xxxl-2 {
    margin-left: 16.66667%;
  }

  .offset-xxxl-3 {
    margin-left: 25%;
  }

  .offset-xxxl-4 {
    margin-left: 33.33333%;
  }

  .offset-xxxl-5 {
    margin-left: 41.66667%;
  }

  .offset-xxxl-6 {
    margin-left: 50%;
  }

  .offset-xxxl-7 {
    margin-left: 58.33333%;
  }

  .offset-xxxl-8 {
    margin-left: 66.66667%;
  }

  .offset-xxxl-9 {
    margin-left: 75%;
  }

  .offset-xxxl-10 {
    margin-left: 83.33333%;
  }

  .offset-xxxl-11 {
    margin-left: 91.66667%;
  }
}

.table {
  width: 100%;
  margin-bottom: 16px;
  color: #333;
}

.table td,
.table th {
  padding: 8px;
  vertical-align: top;
  border-top: 1px solid #e4e7ea;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e4e7ea;
}

.table tbody + tbody {
  border-top: 2px solid #e4e7ea;
}

.table-sm td,
.table-sm th {
  padding: 5px;
}

.table-bordered,
.table-bordered td,
.table-bordered th {
  border: 1px solid #e4e7ea;
}

.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px;
}

.table-borderless tbody + tbody,
.table-borderless td,
.table-borderless th,
.table-borderless thead th,
.table-dark.table-bordered {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f2f4f5;
}

.table-hover tbody tr:hover {
  color: #333;
  background-color: #f2f4f5;
}

.table-primary,
.table-primary > td,
.table-primary > th {
  background-color: #b8e8e8;
}

.table-primary tbody + tbody,
.table-primary td,
.table-primary th,
.table-primary thead th {
  border-color: #7ad4d4;
}

.table-hover .table-primary:hover,
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #a5e2e2;
}

.table-secondary,
.table-secondary > td,
.table-secondary > th {
  background-color: #d6d8db;
}

.table-secondary tbody + tbody,
.table-secondary td,
.table-secondary th,
.table-secondary thead th {
  border-color: #b3b7bb;
}

.table-hover .table-secondary:hover,
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success,
.table-success > td,
.table-success > th {
  background-color: #b8e8e8;
}

.table-success tbody + tbody,
.table-success td,
.table-success th,
.table-success thead th {
  border-color: #7ad4d4;
}

.table-hover .table-success:hover,
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #a5e2e2;
}

.table-info,
.table-info > td,
.table-info > th {
  background-color: #ccebf4;
}

.table-info tbody + tbody,
.table-info td,
.table-info th,
.table-info thead th {
  border-color: #a0d9ea;
}

.table-hover .table-info:hover,
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #b7e3ef;
}

.table-warning,
.table-warning > td,
.table-warning > th {
  background-color: #fce3bf;
}

.table-warning tbody + tbody,
.table-warning td,
.table-warning th,
.table-warning thead th {
  border-color: #facc88;
}

.table-hover .table-warning:hover,
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #fbd8a7;
}

.table-danger,
.table-danger > td,
.table-danger > th {
  background-color: #ffd1d0;
}

.table-danger tbody + tbody,
.table-danger td,
.table-danger th,
.table-danger thead th {
  border-color: #ffaaa8;
}

.table-hover .table-danger:hover,
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #ffb8b7;
}

.table-light,
.table-light > td,
.table-light > th {
  background-color: #fbfcfc;
}

.table-light tbody + tbody,
.table-light td,
.table-light th,
.table-light thead th {
  border-color: #f8f9f9;
}

.table-hover .table-light:hover,
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ecf1f1;
}

.table-hover .table-dark:hover,
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th,
.table-hover .table-inverse:hover,
.table-hover .table-inverse:hover > td,
.table-hover .table-inverse:hover > th {
  background-color: #b7b9bc;
}

.table-dark > td,
.table-dark > th,
.table-inverse,
.table-inverse > td,
.table-inverse > th {
  background-color: #c4c6c8;
}

.table-dark tbody + tbody,
.table-inverse tbody + tbody,
.table-inverse td,
.table-inverse th,
.table-inverse thead th {
  border-color: #92969a;
}

.table-black,
.table-black > td,
.table-black > th {
  background-color: #b8b8b8;
}

.table-black tbody + tbody,
.table-black td,
.table-black th,
.table-black thead th {
  border-color: #7a7a7a;
}

.table-hover .table-black:hover,
.table-hover .table-black:hover > td,
.table-hover .table-black:hover > th {
  background-color: #ababab;
}

.table-white,
.table-white > td,
.table-white > th {
  background-color: #fff;
}

.table-white tbody + tbody,
.table-white td,
.table-white th,
.table-white thead th {
  border-color: #fff;
}

.table-hover .table-white:hover,
.table-hover .table-white:hover > td,
.table-hover .table-white:hover > th {
  background-color: #f2f2f2;
}

.table-grey,
.table-grey > td,
.table-grey > th {
  background-color: #ebeef0;
}

.table-grey tbody + tbody,
.table-grey td,
.table-grey th,
.table-grey thead th {
  border-color: #d9dfe3;
}

.table-hover .table-grey:hover,
.table-hover .table-grey:hover > td,
.table-hover .table-grey:hover > th,
.table-hover .table-muted:hover,
.table-hover .table-muted:hover > td,
.table-hover .table-muted:hover > th,
.table-hover .table-silver:hover,
.table-hover .table-silver:hover > td,
.table-hover .table-silver:hover > th {
  background-color: #dce2e5;
}

.table-muted,
.table-muted > td,
.table-muted > th,
.table-silver {
  background-color: #ebeef0;
}

.table-muted tbody + tbody,
.table-muted td,
.table-muted th,
.table-muted thead th {
  border-color: #d9dfe3;
}

.table-silver > td,
.table-silver > th {
  background-color: #ebeef0;
}

.table-silver tbody + tbody,
.table-silver td,
.table-silver th,
.table-silver thead th {
  border-color: #d9dfe3;
}

.table-lime,
.table-lime > td,
.table-lime > th {
  background-color: #e0f0cd;
}

.table-lime tbody + tbody,
.table-lime td,
.table-lime th,
.table-lime thead th {
  border-color: #c5e3a1;
}

.table-hover .table-lime:hover,
.table-hover .table-lime:hover > td,
.table-hover .table-lime:hover > th {
  background-color: #d4eab9;
}

.table-aqua,
.table-aqua > td,
.table-aqua > th {
  background-color: #ccebf4;
}

.table-aqua tbody + tbody,
.table-aqua td,
.table-aqua th,
.table-aqua thead th {
  border-color: #a0d9ea;
}

.table-hover .table-aqua:hover,
.table-hover .table-aqua:hover > td,
.table-hover .table-aqua:hover > th {
  background-color: #b7e3ef;
}

.table-active,
.table-active > td,
.table-active > th {
  background-color: #f2f4f5;
}

.table-hover .table-active:hover,
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: #e4e7ea;
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #e4e7ea;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}

.table-dark td,
.table-dark th,
.table-dark thead th {
  border-color: #454d55;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 359.98px) {
  .table-responsive-xs {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xs > .table-bordered {
    border: 0;
  }
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-md > .table-bordered {
    border: 0;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}

@media (max-width: 1659.98px) {
  .table-responsive-xxl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xxl > .table-bordered {
    border: 0;
  }
}

@media (max-width: 1899.98px) {
  .table-responsive-xxxl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xxxl > .table-bordered {
    border: 0;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 14px + 2px);
  padding: 7px 0.75rem;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #2d353c;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d5dbe0;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:focus {
  color: #2d353c;
  background-color: #fff;
  border-color: #5db0ff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: #2d353c;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(7px + 1px);
  padding-bottom: calc(7px + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 0.875rem;
  line-height: 1.8;
}

.col-form-label-sm {
  padding-top: calc(0.3125rem + 1px);
  padding-bottom: calc(0.3125rem + 1px);
  font-size: 0.75rem;
  line-height: 1.4;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-bottom: 0;
  line-height: 1.5;
  color: #333;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-lg,
.form-control-plaintext.form-control-sm {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.4em + 0.625rem + 2px);
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}

.form-control-lg {
  height: calc(1.8em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  line-height: 1.8;
  border-radius: 6px;
}

select.form-control[multiple],
select.form-control[size],
textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}

.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.6875rem;
  color: #00acac;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.6875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(0, 172, 172, 0.9);
  border-radius: 4px;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #00acac;
  padding-right: calc(1.5em + 14px);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 3.5px);
  background-size: calc(0.75em + 7px) calc(0.75em + 7px);
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #00acac;
  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);
}

.form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip {
  display: block;
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 14px);
  background-position: top calc(0.375em + 3.5px) right calc(0.375em + 3.5px);
}

.custom-select.is-valid,
.was-validated .custom-select:valid {
  border-color: #00acac;
  padding-right: calc((1em + 14px) * 3 / 4 + 1.75rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___})
      no-repeat right 0.75rem center/8px 10px,
    url(${___CSS_LOADER_URL_REPLACEMENT_26___})
      #fff no-repeat center right 1.75rem / calc(0.75em + 7px)
      calc(0.75em + 7px);
}

.custom-select.is-valid:focus,
.was-validated .custom-select:valid:focus {
  border-color: #00acac;
  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);
}

.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip,
.form-control-file.is-valid ~ .valid-feedback,
.form-control-file.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.was-validated .form-control-file:valid ~ .valid-feedback,
.was-validated .form-control-file:valid ~ .valid-tooltip {
  display: block;
}

.form-check-input.is-valid ~ .form-check-label,
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #00acac;
}

.form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip,
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip {
  display: block;
}

.custom-control-input.is-valid ~ .custom-control-label,
.was-validated .custom-control-input:valid ~ .custom-control-label {
  color: #00acac;
}

.custom-control-input.is-valid ~ .custom-control-label::before,
.was-validated .custom-control-input:valid ~ .custom-control-label::before {
  border-color: #00acac;
}

.custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip,
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip {
  display: block;
}

.custom-control-input.is-valid:checked ~ .custom-control-label::before,
.was-validated
  .custom-control-input:valid:checked
  ~ .custom-control-label::before {
  border-color: #00dfdf;
  background-color: #00dfdf;
}

.custom-control-input.is-valid:focus ~ .custom-control-label::before,
.was-validated
  .custom-control-input:valid:focus
  ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);
}

.custom-control-input.is-valid:focus:not(:checked)
  ~ .custom-control-label::before,
.was-validated
  .custom-control-input:valid:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #00acac;
}

.custom-file-input.is-valid ~ .custom-file-label,
.was-validated .custom-file-input:valid ~ .custom-file-label {
  border-color: #00acac;
}

.custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip,
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip {
  display: block;
}

.custom-file-input.is-valid:focus ~ .custom-file-label,
.was-validated .custom-file-input:valid:focus ~ .custom-file-label {
  border-color: #00acac;
  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.6875rem;
  color: #ff5b57;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.6875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(255, 91, 87, 0.9);
  border-radius: 4px;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  border-color: #ff5b57;
  padding-right: calc(1.5em + 14px);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 3.5px);
  background-size: calc(0.75em + 7px) calc(0.75em + 7px);
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  border-color: #ff5b57;
  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);
}

.form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 14px);
  background-position: top calc(0.375em + 3.5px) right calc(0.375em + 3.5px);
}

.custom-select.is-invalid,
.was-validated .custom-select:invalid {
  border-color: #ff5b57;
  padding-right: calc((1em + 14px) * 3 / 4 + 1.75rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___})
      no-repeat right 0.75rem center/8px 10px,
    url(${___CSS_LOADER_URL_REPLACEMENT_28___})
      #fff no-repeat center right 1.75rem / calc(0.75em + 7px)
      calc(0.75em + 7px);
}

.custom-select.is-invalid:focus,
.was-validated .custom-select:invalid:focus {
  border-color: #ff5b57;
  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);
}

.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip,
.form-control-file.is-invalid ~ .invalid-feedback,
.form-control-file.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.was-validated .form-control-file:invalid ~ .invalid-feedback,
.was-validated .form-control-file:invalid ~ .invalid-tooltip {
  display: block;
}

.form-check-input.is-invalid ~ .form-check-label,
.was-validated .form-check-input:invalid ~ .form-check-label {
  color: #ff5b57;
}

.form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip,
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip {
  display: block;
}

.custom-control-input.is-invalid ~ .custom-control-label,
.was-validated .custom-control-input:invalid ~ .custom-control-label {
  color: #ff5b57;
}

.custom-control-input.is-invalid ~ .custom-control-label::before,
.was-validated .custom-control-input:invalid ~ .custom-control-label::before {
  border-color: #ff5b57;
}

.custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip,
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip {
  display: block;
}

.custom-control-input.is-invalid:checked ~ .custom-control-label::before,
.was-validated
  .custom-control-input:invalid:checked
  ~ .custom-control-label::before {
  border-color: #ff8d8a;
  background-color: #ff8d8a;
}

.custom-control-input.is-invalid:focus ~ .custom-control-label::before,
.was-validated
  .custom-control-input:invalid:focus
  ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);
}

.custom-control-input.is-invalid:focus:not(:checked)
  ~ .custom-control-label::before,
.was-validated
  .custom-control-input:invalid:focus:not(:checked)
  ~ .custom-control-label::before {
  border-color: #ff5b57;
}

.custom-file-input.is-invalid ~ .custom-file-label,
.was-validated .custom-file-input:invalid ~ .custom-file-label {
  border-color: #ff5b57;
}

.custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip,
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip {
  display: block;
}

.custom-file-input.is-invalid:focus ~ .custom-file-label,
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label {
  border-color: #ff5b57;
  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline .form-check,
input[type="button"].btn-block,
input[type="reset"].btn-block,
input[type="submit"].btn-block {
  width: 100%;
}

@media (min-width: 576px) {
  .form-inline .form-group,
  .form-inline label {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  .form-inline label {
    justify-content: center;
  }

  .form-inline .form-group {
    flex: 0 0 auto;
    flex-flow: row wrap;
  }

  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }

  .form-inline .form-control-plaintext {
    display: inline-block;
  }

  .form-inline .custom-select,
  .form-inline .input-group {
    width: auto;
  }

  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }

  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }

  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }

  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  color: #333;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 7px 0.75rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: #333;
  text-decoration: none;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.btn.disabled,
.btn:disabled {
  opacity: 0.65;
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-outline-primary {
  color: #00acac;
  border-color: #00acac;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
}

.btn-outline-primary.focus,
.btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #00acac;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
}

.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary.focus,
.btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #00acac;
  border-color: #00acac;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
}

.btn-outline-success.focus,
.btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #00acac;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled).active,
.btn-outline-success:not(:disabled):not(.disabled):active,
.show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
}

.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);
}

.btn-outline-info {
  color: #49b6d6;
  border-color: #49b6d6;
}

.btn-outline-info:hover {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-outline-info.focus,
.btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
  color: #49b6d6;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled).active,
.btn-outline-info:not(:disabled):not(.disabled):active,
.show > .btn-outline-info.dropdown-toggle {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);
}

.btn-outline-warning {
  color: #f59c1a;
  border-color: #f59c1a;
}

.btn-outline-warning:hover {
  color: #212529;
  background-color: #f59c1a;
  border-color: #f59c1a;
}

.btn-outline-warning.focus,
.btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(245, 156, 26, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  color: #f59c1a;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active,
.show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #f59c1a;
  border-color: #f59c1a;
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(245, 156, 26, 0.5);
}

.btn-outline-danger {
  color: #ff5b57;
  border-color: #ff5b57;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff5b57;
  border-color: #ff5b57;
}

.btn-outline-danger.focus,
.btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(255, 91, 87, 0.5);
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  color: #ff5b57;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled).active,
.btn-outline-danger:not(:disabled):not(.disabled):active,
.show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #ff5b57;
  border-color: #ff5b57;
}

.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 91, 87, 0.5);
}

.btn-outline-light {
  color: #f2f3f4;
  border-color: #f2f3f4;
}

.btn-outline-light:hover {
  color: #212529;
  background-color: #f2f3f4;
  border-color: #f2f3f4;
}

.btn-outline-light.focus,
.btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(242, 243, 244, 0.5);
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #f2f3f4;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled).active,
.btn-outline-light:not(:disabled):not(.disabled):active,
.show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f2f3f4;
  border-color: #f2f3f4;
}

.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(242, 243, 244, 0.5);
}

.btn-outline-dark,
.btn-outline-inverse {
  color: #2d353c;
  border-color: #2d353c;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
}

.btn-outline-dark.focus,
.btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
  color: #2d353c;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled).active,
.btn-outline-dark:not(:disabled):not(.disabled):active,
.show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
}

.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);
}

.btn-outline-inverse:hover {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
}

.btn-outline-inverse.focus,
.btn-outline-inverse:focus {
  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);
}

.btn-outline-inverse.disabled,
.btn-outline-inverse:disabled {
  color: #2d353c;
  background-color: transparent;
}

.btn-outline-inverse:not(:disabled):not(.disabled).active,
.btn-outline-inverse:not(:disabled):not(.disabled):active,
.show > .btn-outline-inverse.dropdown-toggle {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
}

.btn-outline-inverse:not(:disabled):not(.disabled).active:focus,
.btn-outline-inverse:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-inverse.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);
}

.btn-outline-black {
  color: #000;
  border-color: #000;
}

.btn-outline-black:hover {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.btn-outline-black.focus,
.btn-outline-black:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-black.disabled,
.btn-outline-black:disabled {
  color: #000;
  background-color: transparent;
}

.btn-outline-black:not(:disabled):not(.disabled).active,
.btn-outline-black:not(:disabled):not(.disabled):active,
.show > .btn-outline-black.dropdown-toggle {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.btn-outline-black:not(:disabled):not(.disabled).active:focus,
.btn-outline-black:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-black.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-white {
  color: #fff;
  border-color: #fff;
}

.btn-outline-white:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-outline-white.focus,
.btn-outline-white:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-white.disabled,
.btn-outline-white:disabled {
  color: #fff;
  background-color: transparent;
}

.btn-outline-white:not(:disabled):not(.disabled).active,
.btn-outline-white:not(:disabled):not(.disabled):active,
.show > .btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-outline-white:not(:disabled):not(.disabled).active:focus,
.btn-outline-white:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-grey,
.btn-outline-muted,
.btn-outline-silver {
  color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-grey:hover {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-grey.focus,
.btn-outline-grey:focus {
  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);
}

.btn-outline-grey.disabled,
.btn-outline-grey:disabled {
  color: #b6c2c9;
  background-color: transparent;
}

.btn-outline-grey:not(:disabled):not(.disabled).active,
.btn-outline-grey:not(:disabled):not(.disabled):active,
.show > .btn-outline-grey.dropdown-toggle {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-grey:not(:disabled):not(.disabled).active:focus,
.btn-outline-grey:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-grey.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);
}

.btn-outline-muted:hover {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-muted.focus,
.btn-outline-muted:focus {
  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);
}

.btn-outline-muted.disabled,
.btn-outline-muted:disabled {
  color: #b6c2c9;
  background-color: transparent;
}

.btn-outline-muted:not(:disabled):not(.disabled).active,
.btn-outline-muted:not(:disabled):not(.disabled):active,
.show > .btn-outline-muted.dropdown-toggle {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-muted:not(:disabled):not(.disabled).active:focus,
.btn-outline-muted:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-muted.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);
}

.btn-outline-silver:hover {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-silver.focus,
.btn-outline-silver:focus {
  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);
}

.btn-outline-silver.disabled,
.btn-outline-silver:disabled {
  color: #b6c2c9;
  background-color: transparent;
}

.btn-outline-silver:not(:disabled):not(.disabled).active,
.btn-outline-silver:not(:disabled):not(.disabled):active,
.show > .btn-outline-silver.dropdown-toggle {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-outline-silver:not(:disabled):not(.disabled).active:focus,
.btn-outline-silver:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-silver.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);
}

.btn-outline-lime {
  color: #90ca4b;
  border-color: #90ca4b;
}

.btn-outline-lime:hover {
  color: #212529;
  background-color: #90ca4b;
  border-color: #90ca4b;
}

.btn-outline-lime.focus,
.btn-outline-lime:focus {
  box-shadow: 0 0 0 0 rgba(144, 202, 75, 0.5);
}

.btn-outline-lime.disabled,
.btn-outline-lime:disabled {
  color: #90ca4b;
  background-color: transparent;
}

.btn-outline-lime:not(:disabled):not(.disabled).active,
.btn-outline-lime:not(:disabled):not(.disabled):active,
.show > .btn-outline-lime.dropdown-toggle {
  color: #212529;
  background-color: #90ca4b;
  border-color: #90ca4b;
}

.btn-outline-lime:not(:disabled):not(.disabled).active:focus,
.btn-outline-lime:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-lime.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(144, 202, 75, 0.5);
}

.btn-outline-aqua {
  color: #49b6d6;
  border-color: #49b6d6;
}

.btn-outline-aqua:hover {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-outline-aqua.focus,
.btn-outline-aqua:focus {
  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);
}

.btn-outline-aqua.disabled,
.btn-outline-aqua:disabled {
  color: #49b6d6;
  background-color: transparent;
}

.btn-outline-aqua:not(:disabled):not(.disabled).active,
.btn-outline-aqua:not(:disabled):not(.disabled):active,
.show > .btn-outline-aqua.dropdown-toggle {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-outline-aqua:not(:disabled):not(.disabled).active:focus,
.btn-outline-aqua:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-aqua.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #348fe2;
  text-decoration: none;
}

.btn-link:hover {
  color: #1968b0;
  text-decoration: underline;
}

.btn-link.focus,
.btn-link:focus {
  text-decoration: underline;
  box-shadow: none;
}

.btn-link.disabled,
.btn-link:disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-group-lg > .btn,
.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  line-height: 1.8;
  border-radius: 6px;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block + .btn-block {
  margin-top: 0.5rem;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropdown,
.dropleft,
.dropright,
.dropup {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.6875rem;
  color: #333;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 360px) {
  .dropdown-menu-xs-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xs-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1660px) {
  .dropdown-menu-xxl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1900px) {
  .dropdown-menu-xxxl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxxl-right {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropleft .dropdown-toggle::before,
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropdown-menu[x-placement^="bottom"],
.dropdown-menu[x-placement^="left"],
.dropdown-menu[x-placement^="right"],
.dropdown-menu[x-placement^="top"] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 8px 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:focus,
.dropdown-item:hover {
  text-decoration: none;
  background-color: #f8f9fa;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #348fe2;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.6875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group-vertical > .btn,
.btn-group > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group-vertical > .btn:hover,
.btn-group > .btn:hover {
  z-index: 1;
}

.btn-group-vertical > .btn.active,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn:focus,
.btn-group > .btn.active,
.btn-group > .btn:active,
.btn-group > .btn:focus {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:not(:first-child) > .btn,
.btn-group > .btn:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-group-sm > .btn + .dropdown-toggle-split,
.btn-sm + .dropdown-toggle-split {
  padding-right: 0.46875rem;
  padding-left: 0.46875rem;
}

.btn-group-lg > .btn + .dropdown-toggle-split,
.btn-lg + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn-group:not(:first-child),
.btn-group-vertical > .btn:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical > .btn-group:not(:last-child) > .btn,
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn-group:not(:first-child) > .btn,
.btn-group-vertical > .btn:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}

.btn-group-toggle > .btn input[type="checkbox"],
.btn-group-toggle > .btn input[type="radio"],
.btn-group-toggle > .btn-group > .btn input[type="checkbox"],
.btn-group-toggle > .btn-group > .btn input[type="radio"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .custom-file,
.input-group > .custom-select,
.input-group > .form-control,
.input-group > .form-control-plaintext {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .custom-file + .custom-file,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .form-control,
.input-group > .custom-select + .custom-file,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .form-control,
.input-group > .form-control + .custom-file,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .form-control,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .form-control {
  margin-left: -1px;
}

.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label,
.input-group > .custom-select:focus,
.input-group > .form-control:focus {
  z-index: 3;
}

.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}

.input-group > .custom-file:not(:last-child) .custom-file-label,
.input-group > .custom-file:not(:last-child) .custom-file-label::after,
.input-group > .custom-select:not(:last-child),
.input-group > .form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .custom-file:not(:first-child) .custom-file-label,
.input-group > .custom-select:not(:first-child),
.input-group > .form-control:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .custom-file {
  display: flex;
  align-items: center;
}

.input-group-append,
.input-group-prepend {
  display: flex;
}

.input-group-append .btn,
.input-group-prepend .btn {
  position: relative;
  z-index: 2;
}

.input-group-append .btn:focus,
.input-group-prepend .btn:focus {
  z-index: 3;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .btn,
.input-group-append .input-group-text + .input-group-text,
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-prepend .input-group-text + .input-group-text {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 7px 0.75rem;
  margin-bottom: 0;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #2d353c;
  text-align: center;
  white-space: nowrap;
  background-color: #d5dbe0;
  border: 1px solid #d5dbe0;
  border-radius: 4px;
}

.input-group-text input[type="checkbox"],
.input-group-text input[type="radio"] {
  margin-top: 0;
}

.input-group-lg > .custom-select,
.input-group-lg > .form-control:not(textarea) {
  height: calc(1.8em + 1rem + 2px);
}

.input-group-lg > .custom-select,
.input-group-lg > .form-control,
.input-group-lg > .input-group-append > .btn,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-prepend > .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  line-height: 1.8;
  border-radius: 6px;
}

.input-group-sm > .custom-select,
.input-group-sm > .form-control:not(textarea) {
  height: calc(1.4em + 0.625rem + 2px);
}

.input-group-sm > .custom-select,
.input-group-sm > .form-control,
.input-group-sm > .input-group-append > .btn,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-prepend > .input-group-text {
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group
  > .input-group-append:last-child
  > .btn:not(:last-child):not(.dropdown-toggle),
.input-group
  > .input-group-append:last-child
  > .input-group-text:not(:last-child),
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
  > .input-group-prepend:first-child
  > .input-group-text:not(:first-child),
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.125rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #348fe2;
  background-color: #348fe2;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #5db0ff;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #d0e5f8;
  border-color: #d0e5f8;
}

.custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}

.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::after,
.custom-control-label::before {
  position: absolute;
  top: 0.0625rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
}

.custom-control-label::before {
  pointer-events: none;
  background-color: #fff;
  border: #adb5bd solid 1px;
}

.custom-control-label::after {
  background: no-repeat 50%/50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 4px;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::before {
  border-color: #348fe2;
  background-color: #348fe2;
}

.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

.custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(52, 143, 226, 0.5);
}

.custom-checkbox
  .custom-control-input:disabled:indeterminate
  ~ .custom-control-label::before {
  background-color: rgba(52, 143, 226, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

.custom-radio
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before,
.custom-switch
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(52, 143, 226, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}

.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
  top: calc(0.0625rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 14px + 2px);
  padding: 7px 1.75rem 7px 0.75rem;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #2d353c;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___})
    no-repeat right 0.75rem center/8px 10px;
  background-color: #fff;
  border: 1px solid #d5dbe0;
  border-radius: 4px;
  appearance: none;
}

.custom-select:focus {
  border-color: #5db0ff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.custom-select:focus::-ms-value {
  color: #2d353c;
  background-color: #fff;
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}

.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}

.custom-select::-ms-expand {
  display: none;
}

.custom-select-sm {
  height: calc(1.4em + 0.625rem + 2px);
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  padding-left: 0.625rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.8em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.custom-file,
.custom-file-input {
  position: relative;
  width: 100%;
  height: calc(1.5em + 14px + 2px);
}

.custom-file {
  display: inline-block;
  margin-bottom: 0;
}

.custom-file-input {
  z-index: 2;
  margin: 0;
  opacity: 0;
}

.custom-file-input:focus ~ .custom-file-label {
  border-color: #5db0ff;
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label,
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px 0.75rem;
  line-height: 1.5;
  color: #2d353c;
}

.custom-file-label {
  left: 0;
  font-weight: 400;
  border: 1px solid #d5dbe0;
  z-index: 1;
  height: calc(1.5em + 14px + 2px);
  background-color: #fff;
  border-radius: 4px;
}

.custom-file-label::after {
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 14px);
  content: "Browse";
  background-color: #d5dbe0;
  border-left: inherit;
  border-radius: 0 4px 4px 0;
}

.custom-range {
  width: 100%;
  height: calc(1rem + 0.4rem);
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.custom-range:focus {
  outline: 0;
}

.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #d9e0e7, 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #d9e0e7, 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #d9e0e7, 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.custom-range::-moz-focus-outer {
  border: 0;
}

.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #348fe2;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    transition: none;
  }
}

.custom-range::-webkit-slider-thumb:active {
  background-color: #d0e5f8;
}

.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #348fe2;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    transition: none;
  }
}

.custom-range::-moz-range-thumb:active {
  background-color: #d0e5f8;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #348fe2;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    transition: none;
  }
}

.custom-range::-ms-thumb:active {
  background-color: #d0e5f8;
}

.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}

.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}

.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-moz-range-track {
  cursor: default;
}

.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.nav-link:focus,
.nav-link:hover {
  text-decoration: none;
}

.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 0 solid #dee2e6;
}

.nav-tabs .nav-item {
  margin-bottom: 0;
}

.nav-tabs .nav-link {
  border: 0 solid transparent;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .dropdown-menu {
  margin-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #348fe2;
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  padding: 8px 16px;
}

.navbar,
.navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.40625rem;
  padding-bottom: 0.40625rem;
  margin-right: 16px;
  font-size: 0.875rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand:focus,
.navbar-brand:hover {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
}

.navbar-toggler:focus,
.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 359.98px) {
  .navbar-expand-xs > .container,
  .navbar-expand-xs > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 360px) {
  .navbar-expand-xs {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xs .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xs .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xs .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xs > .container,
  .navbar-expand-xs > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-xs .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xs .navbar-toggler {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1659.98px) {
  .navbar-expand-xxl > .container,
  .navbar-expand-xxl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1660px) {
  .navbar-expand-xxl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xxl > .container,
  .navbar-expand-xxl > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1899.98px) {
  .navbar-expand-xxxl > .container,
  .navbar-expand-xxxl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1900px) {
  .navbar-expand-xxxl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xxxl > .container,
  .navbar-expand-xxxl > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-xxxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxxl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid {
  flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:focus,
.navbar-light .navbar-brand:hover,
.navbar-light .navbar-text a:focus,
.navbar-light .navbar-text a:hover {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:focus,
.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-text a:focus,
.navbar-dark .navbar-text a:hover {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:hover {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-text a {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(45, 53, 60, 0.15);
  border-radius: 4px;
}

.card > .list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.card > .list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.card-body {
  flex: 1 1 auto;
  padding: 15px;
}

.card-title {
  margin-bottom: 15px;
}

.card-subtitle {
  margin-top: -7.5px;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li.picker-switch
  table
  tbody
  tr
  td
  a,
body .datetimepicker.dropdown-menu > ul > li.picker-switch table tbody tr td a {
  text-decoration: none;
}

.card-link + .card-link {
  margin-left: 15px;
}

.card-header {
  padding: 15px;
  margin-bottom: 0;
  background-color: #f2f4f5;
  border-bottom: 1px solid rgba(45, 53, 60, 0.15);
}

.card-header:first-child {
  border-radius: calc(4px - 1px) calc(4px - 1px) 0 0;
}

.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 15px;
  background-color: #f2f4f5;
  border-top: 1px solid rgba(45, 53, 60, 0.15);
}

.card-footer:last-child {
  border-radius: 0 0 calc(4px - 1px) calc(4px - 1px);
}

.card-header-tabs {
  margin-bottom: -15px;
  border-bottom: 0;
}

.card-header-pills,
.card-header-tabs {
  margin-right: -7.5px;
  margin-left: -7.5px;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 15px;
}

.card-img {
  width: 100%;
  border-radius: calc(4px - 1px);
}

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(4px - 1px);
  border-top-right-radius: calc(4px - 1px);
}

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: calc(4px - 1px);
  border-bottom-left-radius: calc(4px - 1px);
}

.card-deck {
  display: flex;
  flex-direction: column;
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .card-deck .card {
    display: flex;
    flex: 1 0 0%;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: flex;
  flex-direction: column;
}

.card-group > .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    flex-flow: row wrap;
  }

  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }

  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group > .card:not(:last-child) .card-header,
  .card-group > .card:not(:last-child) .card-img-top {
    border-top-right-radius: 0;
  }

  .card-group > .card:not(:last-child) .card-footer,
  .card-group > .card:not(:last-child) .card-img-bottom {
    border-bottom-right-radius: 0;
  }

  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group > .card:not(:first-child) .card-header,
  .card-group > .card:not(:first-child) .card-img-top {
    border-top-left-radius: 0;
  }

  .card-group > .card:not(:first-child) .card-footer,
  .card-group > .card:not(:first-child) .card-img-bottom {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 15px;
    orphans: 1;
    widows: 1;
  }

  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion > .card {
  overflow: hidden;
}

.accordion > .card:not(:first-of-type) .card-header:first-child {
  border-radius: 0;
}

.accordion > .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 0;
  border-radius: 0;
}

.accordion > .card:first-of-type {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion > .card:last-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion > .card .card-header {
  margin-bottom: -1px;
}

.breadcrumb,
.pagination {
  display: flex;
  list-style: none;
  border-radius: 4px;
}

.breadcrumb {
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background-color: #e9ecef;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  padding-left: 0;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #6f8293;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  z-index: 2;
  color: #2d353c;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #d5dbe0;
}

.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: 0;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.page-item:last-child .page-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #348fe2;
  border-color: #348fe2;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  line-height: 1.8;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.6875rem;
  line-height: 1.4;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.badge {
  line-height: 1;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}

.panel .panel-heading .panel-title > a:focus,
.panel .panel-heading .panel-title > a:hover,
a.badge:focus,
a.badge:hover {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #00acac;
}

a.badge-primary:focus,
a.badge-primary:hover {
  color: #fff;
  background-color: #007979;
}

a.badge-primary.focus,
a.badge-primary:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}

a.badge-secondary:focus,
a.badge-secondary:hover {
  color: #fff;
  background-color: #545b62;
}

a.badge-secondary.focus,
a.badge-secondary:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #00acac;
}

a.badge-success:focus,
a.badge-success:hover {
  color: #fff;
  background-color: #007979;
}

a.badge-success.focus,
a.badge-success:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.5);
}

.badge-info {
  color: #212529;
  background-color: #49b6d6;
}

a.badge-info:focus,
a.badge-info:hover {
  color: #212529;
  background-color: #2b9fc1;
}

a.badge-info.focus,
a.badge-info:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(73, 182, 214, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #f59c1a;
}

a.badge-warning:focus,
a.badge-warning:hover {
  color: #212529;
  background-color: #d38109;
}

a.badge-warning.focus,
a.badge-warning:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(245, 156, 26, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #ff5b57;
}

a.badge-danger:focus,
a.badge-danger:hover {
  color: #fff;
  background-color: #ff2924;
}

a.badge-danger.focus,
a.badge-danger:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f2f3f4;
}

a.badge-light:focus,
a.badge-light:hover {
  color: #212529;
  background-color: #d6dadd;
}

a.badge-light.focus,
a.badge-light:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(242, 243, 244, 0.5);
}

.badge-dark,
.badge-inverse {
  color: #fff;
  background-color: #2d353c;
}

a.badge-dark:focus,
a.badge-dark:hover {
  color: #fff;
  background-color: #171b1f;
}

a.badge-dark.focus,
a.badge-dark:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(45, 53, 60, 0.5);
}

a.badge-inverse:focus,
a.badge-inverse:hover {
  color: #fff;
  background-color: #171b1f;
}

a.badge-inverse.focus,
a.badge-inverse:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(45, 53, 60, 0.5);
}

.badge-black {
  color: #fff;
  background-color: #000;
}

a.badge-black:focus,
a.badge-black:hover {
  color: #fff;
  background-color: #000;
}

a.badge-black.focus,
a.badge-black:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.5);
}

.badge-white {
  color: #212529;
  background-color: #fff;
}

a.badge-white:focus,
a.badge-white:hover {
  color: #212529;
  background-color: #e6e6e6;
}

a.badge-white.focus,
a.badge-white:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.badge-grey,
.badge-muted,
.badge-silver {
  color: #212529;
  background-color: #b6c2c9;
}

a.badge-grey:focus,
a.badge-grey:hover {
  color: #212529;
  background-color: #99aab3;
}

a.badge-grey.focus,
a.badge-grey:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(182, 194, 201, 0.5);
}

a.badge-muted:focus,
a.badge-muted:hover {
  color: #212529;
  background-color: #99aab3;
}

a.badge-muted.focus,
a.badge-muted:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(182, 194, 201, 0.5);
}

a.badge-silver:focus,
a.badge-silver:hover {
  color: #212529;
  background-color: #99aab3;
}

a.badge-silver.focus,
a.badge-silver:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(182, 194, 201, 0.5);
}

.badge-lime {
  color: #212529;
  background-color: #90ca4b;
}

a.badge-lime:focus,
a.badge-lime:hover {
  color: #212529;
  background-color: #76af33;
}

a.badge-lime.focus,
a.badge-lime:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(144, 202, 75, 0.5);
}

.badge-aqua {
  color: #212529;
  background-color: #49b6d6;
}

a.badge-aqua:focus,
a.badge-aqua:hover {
  color: #212529;
  background-color: #2b9fc1;
}

a.badge-aqua.focus,
a.badge-aqua:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(73, 182, 214, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 6px;
}

@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.9375rem;
  margin-bottom: 1.25rem;
  border: 0 solid transparent;
  border-radius: 4px;
}

.alert-heading {
  color: inherit;
}

.alert-link,
.header .navbar-brand b,
b {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.9375rem;
  color: inherit;
}

.alert-primary {
  color: #005959;
  background-color: #cee;
  border-color: #b8e8e8;
}

.alert-primary hr {
  border-top-color: #a5e2e2;
}

.alert-primary .alert-link {
  color: #002626;
}

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db;
}

.alert-secondary hr {
  border-top-color: #c8cbcf;
}

.alert-secondary .alert-link {
  color: #202326;
}

.alert-success {
  color: #005959;
  background-color: #cee;
  border-color: #b8e8e8;
}

.alert-success hr {
  border-top-color: #a5e2e2;
}

.alert-success .alert-link {
  color: #002626;
}

.alert-info {
  color: #265f6f;
  background-color: #dbf0f7;
  border-color: #ccebf4;
}

.alert-info hr {
  border-top-color: #b7e3ef;
}

.alert-info .alert-link {
  color: #193e49;
}

.alert-warning {
  color: #7f510e;
  background-color: #fdebd1;
  border-color: #fce3bf;
}

.alert-warning hr {
  border-top-color: #fbd8a7;
}

.alert-warning .alert-link {
  color: #513409;
}

.alert-danger {
  color: #852f2d;
  background-color: #ffdedd;
  border-color: #ffd1d0;
}

.alert-danger hr {
  border-top-color: #ffb8b7;
}

.alert-danger .alert-link {
  color: #5f2220;
}

.alert-light {
  color: #7e7e7f;
  background-color: #fcfdfd;
  border-color: #fbfcfc;
}

.alert-light hr {
  border-top-color: #ecf1f1;
}

.alert-light .alert-link {
  color: #656565;
}

.alert-dark,
.alert-inverse {
  color: #171c1f;
  background-color: #d5d7d8;
  border-color: #c4c6c8;
}

.alert-dark hr,
.alert-inverse hr {
  border-top-color: #b7b9bc;
}

.alert-dark .alert-link,
.alert-inverse .alert-link {
  color: #010202;
}

.alert-black {
  color: #000;
  background-color: #ccc;
  border-color: #b8b8b8;
}

.alert-black hr {
  border-top-color: #ababab;
}

.alert-black .alert-link {
  color: #000;
}

.alert-white {
  color: #858585;
  background-color: #fff;
  border-color: #fff;
}

.alert-white hr {
  border-top-color: #f2f2f2;
}

.alert-white .alert-link {
  color: #6c6c6c;
}

.alert-grey,
.alert-muted,
.alert-silver {
  color: #5f6569;
  background-color: #f0f3f4;
  border-color: #ebeef0;
}

.alert-grey hr,
.alert-muted hr,
.alert-silver hr {
  border-top-color: #dce2e5;
}

.alert-grey .alert-link,
.alert-muted .alert-link,
.alert-silver .alert-link {
  color: #474b4e;
}

.alert-lime {
  color: #4b6927;
  background-color: #e9f4db;
  border-color: #e0f0cd;
}

.alert-lime hr {
  border-top-color: #d4eab9;
}

.alert-lime .alert-link {
  color: #304419;
}

.alert-aqua {
  color: #265f6f;
  background-color: #dbf0f7;
  border-color: #ccebf4;
}

.alert-aqua hr {
  border-top-color: #b7e3ef;
}

.alert-aqua .alert-link {
  color: #193e49;
}

.progress-bar-left {
  border-radius: 2px 0 0 2px !important;
}

.progress-bar-right {
  border-radius: 0 2px 2px 0 !important;
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.5625rem;
  background-color: #e4e7ea;
  border-radius: 4px;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #348fe2;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}

.list-group-item-action:focus,
.list-group-item-action:hover {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.list-group-item-action:active {
  color: #333;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(45, 53, 60, 0.125);
}

.list-group-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #348fe2;
  border-color: #348fe2;
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal .list-group-item {
  margin-right: -1px;
  margin-bottom: 0;
}

.list-group-horizontal .list-group-item:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
}

.list-group-horizontal .list-group-item:last-child {
  margin-right: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
}

@media (min-width: 360px) {
  .list-group-horizontal-xs {
    flex-direction: row;
  }

  .list-group-horizontal-xs .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-xs .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xs .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-sm .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-sm .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-md .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-md .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-lg .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-lg .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-xl .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xl .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1660px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }

  .list-group-horizontal-xxl .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-xxl .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xxl .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1900px) {
  .list-group-horizontal-xxxl {
    flex-direction: row;
  }

  .list-group-horizontal-xxxl .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-xxxl .list-group-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xxxl .list-group-item:last-child {
    margin-right: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
}

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.list-group-flush .list-group-item:last-child {
  margin-bottom: -1px;
}

.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0;
}

.list-group-flush:last-child .list-group-item:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.list-group-item-primary {
  color: #005959;
  background-color: #b8e8e8;
}

.list-group-item-primary.list-group-item-action:focus,
.list-group-item-primary.list-group-item-action:hover {
  color: #005959;
  background-color: #a5e2e2;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #005959;
  border-color: #005959;
}

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}

.list-group-item-secondary.list-group-item-action:focus,
.list-group-item-secondary.list-group-item-action:hover {
  color: #383d41;
  background-color: #c8cbcf;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #383d41;
  border-color: #383d41;
}

.list-group-item-success {
  color: #005959;
  background-color: #b8e8e8;
}

.list-group-item-success.list-group-item-action:focus,
.list-group-item-success.list-group-item-action:hover {
  color: #005959;
  background-color: #a5e2e2;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #005959;
  border-color: #005959;
}

.list-group-item-info {
  color: #265f6f;
  background-color: #ccebf4;
}

.list-group-item-info.list-group-item-action:focus,
.list-group-item-info.list-group-item-action:hover {
  color: #265f6f;
  background-color: #b7e3ef;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #265f6f;
  border-color: #265f6f;
}

.list-group-item-warning {
  color: #7f510e;
  background-color: #fce3bf;
}

.list-group-item-warning.list-group-item-action:focus,
.list-group-item-warning.list-group-item-action:hover {
  color: #7f510e;
  background-color: #fbd8a7;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #7f510e;
  border-color: #7f510e;
}

.list-group-item-danger {
  color: #852f2d;
  background-color: #ffd1d0;
}

.list-group-item-danger.list-group-item-action:focus,
.list-group-item-danger.list-group-item-action:hover {
  color: #852f2d;
  background-color: #ffb8b7;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #852f2d;
  border-color: #852f2d;
}

.list-group-item-light {
  color: #7e7e7f;
  background-color: #fbfcfc;
}

.list-group-item-light.list-group-item-action:focus,
.list-group-item-light.list-group-item-action:hover {
  color: #7e7e7f;
  background-color: #ecf1f1;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #7e7e7f;
  border-color: #7e7e7f;
}

.list-group-item-dark,
.list-group-item-inverse {
  color: #171c1f;
  background-color: #c4c6c8;
}

.list-group-item-dark.list-group-item-action:focus,
.list-group-item-dark.list-group-item-action:hover {
  color: #171c1f;
  background-color: #b7b9bc;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #171c1f;
  border-color: #171c1f;
}

.list-group-item-inverse.list-group-item-action:focus,
.list-group-item-inverse.list-group-item-action:hover {
  color: #171c1f;
  background-color: #b7b9bc;
}

.list-group-item-inverse.list-group-item-action.active {
  color: #fff;
  background-color: #171c1f;
  border-color: #171c1f;
}

.list-group-item-black {
  color: #000;
  background-color: #b8b8b8;
}

.list-group-item-black.list-group-item-action:focus,
.list-group-item-black.list-group-item-action:hover {
  color: #000;
  background-color: #ababab;
}

.list-group-item-black.list-group-item-action.active {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.list-group-item-white {
  color: #858585;
  background-color: #fff;
}

.list-group-item-white.list-group-item-action:focus,
.list-group-item-white.list-group-item-action:hover {
  color: #858585;
  background-color: #f2f2f2;
}

.list-group-item-white.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-grey,
.list-group-item-muted,
.list-group-item-silver {
  color: #5f6569;
  background-color: #ebeef0;
}

.list-group-item-grey.list-group-item-action:focus,
.list-group-item-grey.list-group-item-action:hover {
  color: #5f6569;
  background-color: #dce2e5;
}

.list-group-item-grey.list-group-item-action.active {
  color: #fff;
  background-color: #5f6569;
  border-color: #5f6569;
}

.list-group-item-muted.list-group-item-action:focus,
.list-group-item-muted.list-group-item-action:hover {
  color: #5f6569;
  background-color: #dce2e5;
}

.list-group-item-muted.list-group-item-action.active {
  color: #fff;
  background-color: #5f6569;
  border-color: #5f6569;
}

.list-group-item-silver.list-group-item-action:focus,
.list-group-item-silver.list-group-item-action:hover {
  color: #5f6569;
  background-color: #dce2e5;
}

.list-group-item-silver.list-group-item-action.active {
  color: #fff;
  background-color: #5f6569;
  border-color: #5f6569;
}

.list-group-item-lime {
  color: #4b6927;
  background-color: #e0f0cd;
}

.list-group-item-lime.list-group-item-action:focus,
.list-group-item-lime.list-group-item-action:hover {
  color: #4b6927;
  background-color: #d4eab9;
}

.list-group-item-lime.list-group-item-action.active {
  color: #fff;
  background-color: #4b6927;
  border-color: #4b6927;
}

.list-group-item-aqua {
  color: #265f6f;
  background-color: #ccebf4;
}

.list-group-item-aqua.list-group-item-action:focus,
.list-group-item-aqua.list-group-item-action:hover {
  color: #265f6f;
  background-color: #b7e3ef;
}

.list-group-item-aqua.list-group-item-action.active {
  color: #fff;
  background-color: #265f6f;
  border-color: #265f6f;
}

.close {
  float: right;
  font-size: 1.125rem;
  font-weight: 700;
  color: #000;
  opacity: 0.5;
}

.close:hover {
  color: #000;
  text-decoration: none;
}

.close:not(:disabled):not(.disabled):focus,
.close:not(:disabled):not(.disabled):hover {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  appearance: none;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  max-width: 350px;
  overflow: hidden;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  opacity: 0;
  border-radius: 0.25rem;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast.showing {
  opacity: 1;
}

.toast.show {
  display: block;
  opacity: 1;
}

#page-loader.fade,
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.toast-body {
  padding: 0.75rem;
}

.modal,
.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  outline: 0;
}

.modal-dialog {
  align-items: center;
  justify-content: center;
  display: flex;
  height: calc(100vh - 60px) !important;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-footer,
.modal-dialog-scrollable .modal-header {
  flex-shrink: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
}

.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}

.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #d5dbe0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.modal-header .close {
  padding: 15px;
  margin: -15px -15px -15px auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #d5dbe0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.modal-footer > :not(:first-child) {
  margin-left: 0.25rem;
}

.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }

  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }

  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
  }

  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.tooltip,
.tooltip .arrow {
  position: absolute;
  display: block;
}

.tooltip {
  z-index: 1070;
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.6875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .arrow {
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-auto[x-placement^="top"],
.bs-tooltip-top {
  padding: 0.4rem 0;
}

.bs-tooltip-auto[x-placement^="top"] .arrow,
.bs-tooltip-top .arrow {
  bottom: 0;
}

.bs-tooltip-auto[x-placement^="top"] .arrow::before,
.bs-tooltip-top .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-auto[x-placement^="right"],
.bs-tooltip-right {
  padding: 0 0.4rem;
}

.bs-tooltip-auto[x-placement^="right"] .arrow,
.bs-tooltip-right .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-auto[x-placement^="right"] .arrow::before,
.bs-tooltip-right .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-auto[x-placement^="bottom"],
.bs-tooltip-bottom {
  padding: 0.4rem 0;
}

.bs-tooltip-auto[x-placement^="bottom"] .arrow,
.bs-tooltip-bottom .arrow {
  top: 0;
}

.bs-tooltip-auto[x-placement^="bottom"] .arrow::before,
.bs-tooltip-bottom .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-auto[x-placement^="left"],
.bs-tooltip-left {
  padding: 0 0.4rem;
}

.bs-tooltip-auto[x-placement^="left"] .arrow,
.bs-tooltip-left .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-auto[x-placement^="left"] .arrow::before,
.bs-tooltip-left .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
}

.popover,
.popover .arrow {
  position: absolute;
  display: block;
}

.popover {
  top: 0;
  left: 0;
  z-index: 1060;
  max-width: 276px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.6875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.popover .arrow {
  width: 1rem;
  height: 0.5rem;
  margin: 0 6px;
}

.popover .arrow::after,
.popover .arrow::before {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-auto[x-placement^="top"],
.bs-popover-top {
  margin-bottom: 0.5rem;
}

.bs-popover-auto[x-placement^="top"] > .arrow,
.bs-popover-top > .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}

.bs-popover-auto[x-placement^="top"] > .arrow::before,
.bs-popover-top > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^="top"] > .arrow::after,
.bs-popover-top > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-auto[x-placement^="right"],
.bs-popover-right {
  margin-left: 0.5rem;
}

.bs-popover-auto[x-placement^="right"] > .arrow,
.bs-popover-right > .arrow {
  left: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 6px 0;
}

.bs-popover-auto[x-placement^="right"] > .arrow::before,
.bs-popover-right > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^="right"] > .arrow::after,
.bs-popover-right > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-auto[x-placement^="bottom"],
.bs-popover-bottom {
  margin-top: 0.5rem;
}

.bs-popover-auto[x-placement^="bottom"] > .arrow,
.bs-popover-bottom > .arrow {
  top: calc((0.5rem + 1px) * -1);
}

.bs-popover-auto[x-placement^="bottom"] > .arrow::before,
.bs-popover-bottom > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^="bottom"] > .arrow::after,
.bs-popover-bottom > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-auto[x-placement^="bottom"] .popover-header::before,
.bs-popover-bottom .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-auto[x-placement^="left"],
.bs-popover-left {
  margin-right: 0.5rem;
}

.bs-popover-auto[x-placement^="left"] > .arrow,
.bs-popover-left > .arrow {
  right: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 6px 0;
}

.bs-popover-auto[x-placement^="left"] > .arrow::before,
.bs-popover-left > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^="left"] > .arrow::after,
.bs-popover-left > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.75rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(6px - 1px);
  border-top-right-radius: calc(6px - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #333;
}

.carousel,
.carousel-inner,
.header .navbar-nav > li,
.sidebar .nav > li,
.sidebar .sub-menu > li {
  /* position: relative */
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after,
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.active.carousel-item-right,
.carousel-item-next:not(.carousel-item-left) {
  transform: translateX(100%);
}

.active.carousel-item-left,
.carousel-item-prev:not(.carousel-item-right) {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right,
.carousel-fade .carousel-item.active {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: 0s 0.6s opacity;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-next,
.carousel-control-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-next,
  .carousel-control-prev {
    transition: none;
  }
}

.carousel-control-next:focus,
.carousel-control-next:hover,
.carousel-control-prev:focus,
.carousel-control-prev:hover {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50%/100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow 0.75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
  background-color: #007979 !important;
}

a.bg-secondary:focus,
a.bg-secondary:hover,
button.bg-secondary:focus,
button.bg-secondary:hover {
  background-color: #545b62 !important;
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
  background-color: #007979 !important;
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
  background-color: #2b9fc1 !important;
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
  background-color: #d38109 !important;
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
  background-color: #ff2924 !important;
}

a.bg-light:focus,
a.bg-light:hover,
button.bg-light:focus,
button.bg-light:hover {
  background-color: #d6dadd !important;
}

a.bg-dark:focus,
a.bg-dark:hover,
a.bg-inverse:focus,
a.bg-inverse:hover,
button.bg-dark:focus,
button.bg-dark:hover,
button.bg-inverse:focus,
button.bg-inverse:hover {
  background-color: #171b1f !important;
}

a.bg-black:focus,
a.bg-black:hover,
button.bg-black:focus,
button.bg-black:hover {
  background-color: #000 !important;
}

a.bg-white:focus,
a.bg-white:hover,
button.bg-white:focus,
button.bg-white:hover {
  background-color: #e6e6e6 !important;
}

a.bg-grey:focus,
a.bg-grey:hover,
a.bg-muted:focus,
a.bg-muted:hover,
a.bg-silver:focus,
a.bg-silver:hover,
button.bg-grey:focus,
button.bg-grey:hover,
button.bg-muted:focus,
button.bg-muted:hover,
button.bg-silver:focus,
button.bg-silver:hover {
  background-color: #99aab3 !important;
}

a.bg-lime:focus,
a.bg-lime:hover,
button.bg-lime:focus,
button.bg-lime:hover {
  background-color: #76af33 !important;
}

a.bg-aqua:focus,
a.bg-aqua:hover,
button.bg-aqua:focus,
button.bg-aqua:hover {
  background-color: #2b9fc1 !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #d5dbe0 !important;
}

.border-top {
  border-top: 1px solid #d5dbe0 !important;
}

.border-right {
  border-right: 1px solid #d5dbe0 !important;
}

.border-bottom {
  border-bottom: 1px solid #d5dbe0 !important;
}

.border-left {
  border-left: 1px solid #d5dbe0 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #00acac !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #00acac !important;
}

.border-info {
  border-color: #49b6d6 !important;
}

.border-warning {
  border-color: #f59c1a !important;
}

.border-danger {
  border-color: #ff5b57 !important;
}

.border-light {
  border-color: #f2f3f4 !important;
}

.border-dark,
.border-inverse {
  border-color: #2d353c !important;
}

.border-black {
  border-color: #000 !important;
}

.border-grey,
.border-muted,
.border-silver {
  border-color: #b6c2c9 !important;
}

.border-lime {
  border-color: #90ca4b !important;
}

.border-aqua {
  border-color: #49b6d6 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 3px !important;
}

.rounded {
  border-radius: 4px !important;
}

.rounded-right,
.rounded-top {
  border-top-right-radius: 4px !important;
}

.rounded-top {
  border-top-left-radius: 4px !important;
}

.rounded-right {
  border-bottom-right-radius: 4px !important;
}

.rounded-bottom,
.rounded-left {
  border-bottom-left-radius: 4px !important;
}

.rounded-bottom {
  border-bottom-right-radius: 4px !important;
}

.rounded-left {
  border-top-left-radius: 4px !important;
}

.rounded-lg {
  border-radius: 6px !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 360px) {
  .d-xs-none {
    display: none !important;
  }

  .d-xs-inline {
    display: inline !important;
  }

  .d-xs-inline-block {
    display: inline-block !important;
  }

  .d-xs-block {
    display: block !important;
  }

  .d-xs-table {
    display: table !important;
  }

  .d-xs-table-row {
    display: table-row !important;
  }

  .d-xs-table-cell {
    display: table-cell !important;
  }

  .d-xs-flex {
    display: flex !important;
  }

  .d-xs-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1660px) {
  .d-xxl-none {
    display: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1900px) {
  .d-xxxl-none {
    display: none !important;
  }

  .d-xxxl-inline {
    display: inline !important;
  }

  .d-xxxl-inline-block {
    display: inline-block !important;
  }

  .d-xxxl-block {
    display: block !important;
  }

  .d-xxxl-table {
    display: table !important;
  }

  .d-xxxl-table-row {
    display: table-row !important;
  }

  .d-xxxl-table-cell {
    display: table-cell !important;
  }

  .d-xxxl-flex {
    display: flex !important;
  }

  .d-xxxl-inline-flex {
    display: inline-flex !important;
  }
}

@media print {
  .d-print-none {
    display: none !important;
  }

  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }
}

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 360px) {
  .flex-xs-row {
    flex-direction: row !important;
  }

  .flex-xs-column {
    flex-direction: column !important;
  }

  .flex-xs-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xs-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xs-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xs-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xs-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xs-fill {
    flex: 1 1 auto !important;
  }

  .flex-xs-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xs-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xs-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xs-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xs-start {
    justify-content: flex-start !important;
  }

  .justify-content-xs-end {
    justify-content: flex-end !important;
  }

  .justify-content-xs-center {
    justify-content: center !important;
  }

  .justify-content-xs-between {
    justify-content: space-between !important;
  }

  .justify-content-xs-around {
    justify-content: space-around !important;
  }

  .align-items-xs-start {
    align-items: flex-start !important;
  }

  .align-items-xs-end {
    align-items: flex-end !important;
  }

  .align-items-xs-center {
    align-items: center !important;
  }

  .align-items-xs-baseline {
    align-items: baseline !important;
  }

  .align-items-xs-stretch {
    align-items: stretch !important;
  }

  .align-content-xs-start {
    align-content: flex-start !important;
  }

  .align-content-xs-end {
    align-content: flex-end !important;
  }

  .align-content-xs-center {
    align-content: center !important;
  }

  .align-content-xs-between {
    align-content: space-between !important;
  }

  .align-content-xs-around {
    align-content: space-around !important;
  }

  .align-content-xs-stretch {
    align-content: stretch !important;
  }

  .align-self-xs-auto {
    align-self: auto !important;
  }

  .align-self-xs-start {
    align-self: flex-start !important;
  }

  .align-self-xs-end {
    align-self: flex-end !important;
  }

  .align-self-xs-center {
    align-self: center !important;
  }

  .align-self-xs-baseline {
    align-self: baseline !important;
  }

  .align-self-xs-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1660px) {
  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1900px) {
  .flex-xxxl-row {
    flex-direction: row !important;
  }

  .flex-xxxl-column {
    flex-direction: column !important;
  }

  .flex-xxxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xxxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xxxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxxl-center {
    justify-content: center !important;
  }

  .justify-content-xxxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxxl-around {
    justify-content: space-around !important;
  }

  .align-items-xxxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxxl-center {
    align-items: center !important;
  }

  .align-items-xxxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxxl-center {
    align-content: center !important;
  }

  .align-content-xxxl-between {
    align-content: space-between !important;
  }

  .align-content-xxxl-around {
    align-content: space-around !important;
  }

  .align-content-xxxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxxl-auto {
    align-self: auto !important;
  }

  .align-self-xxxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxxl-center {
    align-self: center !important;
  }

  .align-self-xxxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxxl-stretch {
    align-self: stretch !important;
  }
}

.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 360px) {
  .float-xs-left {
    float: left !important;
  }

  .float-xs-right {
    float: right !important;
  }

  .float-xs-none {
    float: none !important;
  }
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }

  .float-sm-right {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }

  .float-md-right {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }

  .float-lg-right {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }

  .float-xl-right {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }
}

@media (min-width: 1660px) {
  .float-xxl-left {
    float: left !important;
  }

  .float-xxl-right {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }
}

@media (min-width: 1900px) {
  .float-xxxl-left {
    float: left !important;
  }

  .float-xxxl-right {
    float: right !important;
  }

  .float-xxxl-none {
    float: none !important;
  }
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-bottom,
.fixed-top {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-top {
  top: 0;
}

.fixed-bottom {
  bottom: 0;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: transparent;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.mt-1,
.my-1 {
  margin-top: 4px !important;
}

.mr-1,
.mx-1 {
  margin-right: 4px !important;
}

.mb-1,
.my-1 {
  margin-bottom: 4px !important;
}

.ml-1,
.mx-1 {
  margin-left: 4px !important;
}

.mt-2,
.my-2 {
  margin-top: 8px !important;
}

.mr-2,
.mx-2 {
  margin-right: 8px !important;
}

.mb-2,
.my-2 {
  margin-bottom: 8px !important;
}

.ml-2,
.mx-2 {
  margin-left: 8px !important;
}

.mt-3,
.my-3 {
  margin-top: 16px !important;
}

.mr-3,
.mx-3 {
  margin-right: 16px !important;
}

.mb-3,
.my-3 {
  margin-bottom: 16px !important;
}

.ml-3,
.mx-3 {
  margin-left: 16px !important;
}

.mt-4,
.my-4 {
  margin-top: 24px !important;
}

.mr-4,
.mx-4 {
  margin-right: 24px !important;
}

.mb-4,
.my-4 {
  margin-bottom: 24px !important;
}

.ml-4,
.mx-4 {
  margin-left: 24px !important;
}

.mt-5,
.my-5 {
  margin-top: 48px !important;
}

.mr-5,
.mx-5 {
  margin-right: 48px !important;
}

.mb-5,
.my-5 {
  margin-bottom: 48px !important;
}

.ml-5,
.mx-5 {
  margin-left: 48px !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.pt-1,
.py-1 {
  padding-top: 4px !important;
}

.pr-1,
.px-1 {
  padding-right: 4px !important;
}

.pb-1,
.py-1 {
  padding-bottom: 4px !important;
}

.pl-1,
.px-1 {
  padding-left: 4px !important;
}

.pt-2,
.py-2 {
  padding-top: 8px !important;
}

.pr-2,
.px-2 {
  padding-right: 8px !important;
}

.pb-2,
.py-2 {
  padding-bottom: 8px !important;
}

.pl-2,
.px-2 {
  padding-left: 8px !important;
}

.pt-3,
.py-3 {
  padding-top: 16px !important;
}

.pr-3,
.px-3 {
  padding-right: 16px !important;
}

.pb-3,
.py-3 {
  padding-bottom: 16px !important;
}

.pl-3,
.px-3 {
  padding-left: 16px !important;
}

.pt-4,
.py-4 {
  padding-top: 24px !important;
}

.pr-4,
.px-4 {
  padding-right: 24px !important;
}

.pb-4,
.py-4 {
  padding-bottom: 24px !important;
}

.pl-4,
.px-4 {
  padding-left: 24px !important;
}

.pt-5,
.py-5 {
  padding-top: 48px !important;
}

.pr-5,
.px-5 {
  padding-right: 48px !important;
}

.pb-5,
.py-5 {
  padding-bottom: 48px !important;
}

.pl-5,
.px-5 {
  padding-left: 48px !important;
}

.m-n1 {
  margin: -4px !important;
}

.mt-n1,
.my-n1 {
  margin-top: -4px !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -4px !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -4px !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -4px !important;
}

.m-n2 {
  margin: -8px !important;
}

.mt-n2,
.my-n2 {
  margin-top: -8px !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -8px !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -8px !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -8px !important;
}

.m-n3 {
  margin: -16px !important;
}

.mt-n3,
.my-n3 {
  margin-top: -16px !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -16px !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -16px !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -16px !important;
}

.m-n4 {
  margin: -24px !important;
}

.mt-n4,
.my-n4 {
  margin-top: -24px !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -24px !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -24px !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -24px !important;
}

.m-n5 {
  margin: -48px !important;
}

.mt-n5,
.my-n5 {
  margin-top: -48px !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -48px !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -48px !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -48px !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 360px) {
  .m-xs-0 {
    margin: 0 !important;
  }

  .mt-xs-0,
  .my-xs-0 {
    margin-top: 0 !important;
  }

  .mr-xs-0,
  .mx-xs-0 {
    margin-right: 0 !important;
  }

  .mb-xs-0,
  .my-xs-0 {
    margin-bottom: 0 !important;
  }

  .ml-xs-0,
  .mx-xs-0 {
    margin-left: 0 !important;
  }

  .m-xs-1 {
    margin: 4px !important;
  }

  .mt-xs-1,
  .my-xs-1 {
    margin-top: 4px !important;
  }

  .mr-xs-1,
  .mx-xs-1 {
    margin-right: 4px !important;
  }

  .mb-xs-1,
  .my-xs-1 {
    margin-bottom: 4px !important;
  }

  .ml-xs-1,
  .mx-xs-1 {
    margin-left: 4px !important;
  }

  .m-xs-2 {
    margin: 8px !important;
  }

  .mt-xs-2,
  .my-xs-2 {
    margin-top: 8px !important;
  }

  .mr-xs-2,
  .mx-xs-2 {
    margin-right: 8px !important;
  }

  .mb-xs-2,
  .my-xs-2 {
    margin-bottom: 8px !important;
  }

  .ml-xs-2,
  .mx-xs-2 {
    margin-left: 8px !important;
  }

  .m-xs-3 {
    margin: 16px !important;
  }

  .mt-xs-3,
  .my-xs-3 {
    margin-top: 16px !important;
  }

  .mr-xs-3,
  .mx-xs-3 {
    margin-right: 16px !important;
  }

  .mb-xs-3,
  .my-xs-3 {
    margin-bottom: 16px !important;
  }

  .ml-xs-3,
  .mx-xs-3 {
    margin-left: 16px !important;
  }

  .m-xs-4 {
    margin: 24px !important;
  }

  .mt-xs-4,
  .my-xs-4 {
    margin-top: 24px !important;
  }

  .mr-xs-4,
  .mx-xs-4 {
    margin-right: 24px !important;
  }

  .mb-xs-4,
  .my-xs-4 {
    margin-bottom: 24px !important;
  }

  .ml-xs-4,
  .mx-xs-4 {
    margin-left: 24px !important;
  }

  .m-xs-5 {
    margin: 48px !important;
  }

  .mt-xs-5,
  .my-xs-5 {
    margin-top: 48px !important;
  }

  .mr-xs-5,
  .mx-xs-5 {
    margin-right: 48px !important;
  }

  .mb-xs-5,
  .my-xs-5 {
    margin-bottom: 48px !important;
  }

  .ml-xs-5,
  .mx-xs-5 {
    margin-left: 48px !important;
  }

  .p-xs-0 {
    padding: 0 !important;
  }

  .pt-xs-0,
  .py-xs-0 {
    padding-top: 0 !important;
  }

  .pr-xs-0,
  .px-xs-0 {
    padding-right: 0 !important;
  }

  .pb-xs-0,
  .py-xs-0 {
    padding-bottom: 0 !important;
  }

  .pl-xs-0,
  .px-xs-0 {
    padding-left: 0 !important;
  }

  .p-xs-1 {
    padding: 4px !important;
  }

  .pt-xs-1,
  .py-xs-1 {
    padding-top: 4px !important;
  }

  .pr-xs-1,
  .px-xs-1 {
    padding-right: 4px !important;
  }

  .pb-xs-1,
  .py-xs-1 {
    padding-bottom: 4px !important;
  }

  .pl-xs-1,
  .px-xs-1 {
    padding-left: 4px !important;
  }

  .p-xs-2 {
    padding: 8px !important;
  }

  .pt-xs-2,
  .py-xs-2 {
    padding-top: 8px !important;
  }

  .pr-xs-2,
  .px-xs-2 {
    padding-right: 8px !important;
  }

  .pb-xs-2,
  .py-xs-2 {
    padding-bottom: 8px !important;
  }

  .pl-xs-2,
  .px-xs-2 {
    padding-left: 8px !important;
  }

  .p-xs-3 {
    padding: 16px !important;
  }

  .pt-xs-3,
  .py-xs-3 {
    padding-top: 16px !important;
  }

  .pr-xs-3,
  .px-xs-3 {
    padding-right: 16px !important;
  }

  .pb-xs-3,
  .py-xs-3 {
    padding-bottom: 16px !important;
  }

  .pl-xs-3,
  .px-xs-3 {
    padding-left: 16px !important;
  }

  .p-xs-4 {
    padding: 24px !important;
  }

  .pt-xs-4,
  .py-xs-4 {
    padding-top: 24px !important;
  }

  .pr-xs-4,
  .px-xs-4 {
    padding-right: 24px !important;
  }

  .pb-xs-4,
  .py-xs-4 {
    padding-bottom: 24px !important;
  }

  .pl-xs-4,
  .px-xs-4 {
    padding-left: 24px !important;
  }

  .p-xs-5 {
    padding: 48px !important;
  }

  .pt-xs-5,
  .py-xs-5 {
    padding-top: 48px !important;
  }

  .pr-xs-5,
  .px-xs-5 {
    padding-right: 48px !important;
  }

  .pb-xs-5,
  .py-xs-5 {
    padding-bottom: 48px !important;
  }

  .pl-xs-5,
  .px-xs-5 {
    padding-left: 48px !important;
  }

  .m-xs-n1 {
    margin: -4px !important;
  }

  .mt-xs-n1,
  .my-xs-n1 {
    margin-top: -4px !important;
  }

  .mr-xs-n1,
  .mx-xs-n1 {
    margin-right: -4px !important;
  }

  .mb-xs-n1,
  .my-xs-n1 {
    margin-bottom: -4px !important;
  }

  .ml-xs-n1,
  .mx-xs-n1 {
    margin-left: -4px !important;
  }

  .m-xs-n2 {
    margin: -8px !important;
  }

  .mt-xs-n2,
  .my-xs-n2 {
    margin-top: -8px !important;
  }

  .mr-xs-n2,
  .mx-xs-n2 {
    margin-right: -8px !important;
  }

  .mb-xs-n2,
  .my-xs-n2 {
    margin-bottom: -8px !important;
  }

  .ml-xs-n2,
  .mx-xs-n2 {
    margin-left: -8px !important;
  }

  .m-xs-n3 {
    margin: -16px !important;
  }

  .mt-xs-n3,
  .my-xs-n3 {
    margin-top: -16px !important;
  }

  .mr-xs-n3,
  .mx-xs-n3 {
    margin-right: -16px !important;
  }

  .mb-xs-n3,
  .my-xs-n3 {
    margin-bottom: -16px !important;
  }

  .ml-xs-n3,
  .mx-xs-n3 {
    margin-left: -16px !important;
  }

  .m-xs-n4 {
    margin: -24px !important;
  }

  .mt-xs-n4,
  .my-xs-n4 {
    margin-top: -24px !important;
  }

  .mr-xs-n4,
  .mx-xs-n4 {
    margin-right: -24px !important;
  }

  .mb-xs-n4,
  .my-xs-n4 {
    margin-bottom: -24px !important;
  }

  .ml-xs-n4,
  .mx-xs-n4 {
    margin-left: -24px !important;
  }

  .m-xs-n5 {
    margin: -48px !important;
  }

  .mt-xs-n5,
  .my-xs-n5 {
    margin-top: -48px !important;
  }

  .mr-xs-n5,
  .mx-xs-n5 {
    margin-right: -48px !important;
  }

  .mb-xs-n5,
  .my-xs-n5 {
    margin-bottom: -48px !important;
  }

  .ml-xs-n5,
  .mx-xs-n5 {
    margin-left: -48px !important;
  }

  .m-xs-auto {
    margin: auto !important;
  }

  .mt-xs-auto,
  .my-xs-auto {
    margin-top: auto !important;
  }

  .mr-xs-auto,
  .mx-xs-auto {
    margin-right: auto !important;
  }

  .mb-xs-auto,
  .my-xs-auto {
    margin-bottom: auto !important;
  }

  .ml-xs-auto,
  .mx-xs-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }

  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }

  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }

  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }

  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }

  .m-sm-1 {
    margin: 4px !important;
  }

  .mt-sm-1,
  .my-sm-1 {
    margin-top: 4px !important;
  }

  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 4px !important;
  }

  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 4px !important;
  }

  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 4px !important;
  }

  .m-sm-2 {
    margin: 8px !important;
  }

  .mt-sm-2,
  .my-sm-2 {
    margin-top: 8px !important;
  }

  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 8px !important;
  }

  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 8px !important;
  }

  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 8px !important;
  }

  .m-sm-3 {
    margin: 16px !important;
  }

  .mt-sm-3,
  .my-sm-3 {
    margin-top: 16px !important;
  }

  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 16px !important;
  }

  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 16px !important;
  }

  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 16px !important;
  }

  .m-sm-4 {
    margin: 24px !important;
  }

  .mt-sm-4,
  .my-sm-4 {
    margin-top: 24px !important;
  }

  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 24px !important;
  }

  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 24px !important;
  }

  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 24px !important;
  }

  .m-sm-5 {
    margin: 48px !important;
  }

  .mt-sm-5,
  .my-sm-5 {
    margin-top: 48px !important;
  }

  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 48px !important;
  }

  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 48px !important;
  }

  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 48px !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }

  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }

  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }

  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }

  .p-sm-1 {
    padding: 4px !important;
  }

  .pt-sm-1,
  .py-sm-1 {
    padding-top: 4px !important;
  }

  .pr-sm-1,
  .px-sm-1 {
    padding-right: 4px !important;
  }

  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 4px !important;
  }

  .pl-sm-1,
  .px-sm-1 {
    padding-left: 4px !important;
  }

  .p-sm-2 {
    padding: 8px !important;
  }

  .pt-sm-2,
  .py-sm-2 {
    padding-top: 8px !important;
  }

  .pr-sm-2,
  .px-sm-2 {
    padding-right: 8px !important;
  }

  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 8px !important;
  }

  .pl-sm-2,
  .px-sm-2 {
    padding-left: 8px !important;
  }

  .p-sm-3 {
    padding: 16px !important;
  }

  .pt-sm-3,
  .py-sm-3 {
    padding-top: 16px !important;
  }

  .pr-sm-3,
  .px-sm-3 {
    padding-right: 16px !important;
  }

  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 16px !important;
  }

  .pl-sm-3,
  .px-sm-3 {
    padding-left: 16px !important;
  }

  .p-sm-4 {
    padding: 24px !important;
  }

  .pt-sm-4,
  .py-sm-4 {
    padding-top: 24px !important;
  }

  .pr-sm-4,
  .px-sm-4 {
    padding-right: 24px !important;
  }

  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 24px !important;
  }

  .pl-sm-4,
  .px-sm-4 {
    padding-left: 24px !important;
  }

  .p-sm-5 {
    padding: 48px !important;
  }

  .pt-sm-5,
  .py-sm-5 {
    padding-top: 48px !important;
  }

  .pr-sm-5,
  .px-sm-5 {
    padding-right: 48px !important;
  }

  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 48px !important;
  }

  .pl-sm-5,
  .px-sm-5 {
    padding-left: 48px !important;
  }

  .m-sm-n1 {
    margin: -4px !important;
  }

  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -4px !important;
  }

  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -4px !important;
  }

  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -4px !important;
  }

  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -4px !important;
  }

  .m-sm-n2 {
    margin: -8px !important;
  }

  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -8px !important;
  }

  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -8px !important;
  }

  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -8px !important;
  }

  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -8px !important;
  }

  .m-sm-n3 {
    margin: -16px !important;
  }

  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -16px !important;
  }

  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -16px !important;
  }

  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -16px !important;
  }

  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -16px !important;
  }

  .m-sm-n4 {
    margin: -24px !important;
  }

  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -24px !important;
  }

  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -24px !important;
  }

  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -24px !important;
  }

  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -24px !important;
  }

  .m-sm-n5 {
    margin: -48px !important;
  }

  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -48px !important;
  }

  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -48px !important;
  }

  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -48px !important;
  }

  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -48px !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }

  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }

  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }

  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }

  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }

  .m-md-1 {
    margin: 4px !important;
  }

  .mt-md-1,
  .my-md-1 {
    margin-top: 4px !important;
  }

  .mr-md-1,
  .mx-md-1 {
    margin-right: 4px !important;
  }

  .mb-md-1,
  .my-md-1 {
    margin-bottom: 4px !important;
  }

  .ml-md-1,
  .mx-md-1 {
    margin-left: 4px !important;
  }

  .m-md-2 {
    margin: 8px !important;
  }

  .mt-md-2,
  .my-md-2 {
    margin-top: 8px !important;
  }

  .mr-md-2,
  .mx-md-2 {
    margin-right: 8px !important;
  }

  .mb-md-2,
  .my-md-2 {
    margin-bottom: 8px !important;
  }

  .ml-md-2,
  .mx-md-2 {
    margin-left: 8px !important;
  }

  .m-md-3 {
    margin: 16px !important;
  }

  .mt-md-3,
  .my-md-3 {
    margin-top: 16px !important;
  }

  .mr-md-3,
  .mx-md-3 {
    margin-right: 16px !important;
  }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 16px !important;
  }

  .ml-md-3,
  .mx-md-3 {
    margin-left: 16px !important;
  }

  .m-md-4 {
    margin: 24px !important;
  }

  .mt-md-4,
  .my-md-4 {
    margin-top: 24px !important;
  }

  .mr-md-4,
  .mx-md-4 {
    margin-right: 24px !important;
  }

  .mb-md-4,
  .my-md-4 {
    margin-bottom: 24px !important;
  }

  .ml-md-4,
  .mx-md-4 {
    margin-left: 24px !important;
  }

  .m-md-5 {
    margin: 48px !important;
  }

  .mt-md-5,
  .my-md-5 {
    margin-top: 48px !important;
  }

  .mr-md-5,
  .mx-md-5 {
    margin-right: 48px !important;
  }

  .mb-md-5,
  .my-md-5 {
    margin-bottom: 48px !important;
  }

  .ml-md-5,
  .mx-md-5 {
    margin-left: 48px !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }

  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }

  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }

  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }

  .p-md-1 {
    padding: 4px !important;
  }

  .pt-md-1,
  .py-md-1 {
    padding-top: 4px !important;
  }

  .pr-md-1,
  .px-md-1 {
    padding-right: 4px !important;
  }

  .pb-md-1,
  .py-md-1 {
    padding-bottom: 4px !important;
  }

  .pl-md-1,
  .px-md-1 {
    padding-left: 4px !important;
  }

  .p-md-2 {
    padding: 8px !important;
  }

  .pt-md-2,
  .py-md-2 {
    padding-top: 8px !important;
  }

  .pr-md-2,
  .px-md-2 {
    padding-right: 8px !important;
  }

  .pb-md-2,
  .py-md-2 {
    padding-bottom: 8px !important;
  }

  .pl-md-2,
  .px-md-2 {
    padding-left: 8px !important;
  }

  .p-md-3 {
    padding: 16px !important;
  }

  .pt-md-3,
  .py-md-3 {
    padding-top: 16px !important;
  }

  .pr-md-3,
  .px-md-3 {
    padding-right: 16px !important;
  }

  .pb-md-3,
  .py-md-3 {
    padding-bottom: 16px !important;
  }

  .pl-md-3,
  .px-md-3 {
    padding-left: 16px !important;
  }

  .p-md-4 {
    padding: 24px !important;
  }

  .pt-md-4,
  .py-md-4 {
    padding-top: 24px !important;
  }

  .pr-md-4,
  .px-md-4 {
    padding-right: 24px !important;
  }

  .pb-md-4,
  .py-md-4 {
    padding-bottom: 24px !important;
  }

  .pl-md-4,
  .px-md-4 {
    padding-left: 24px !important;
  }

  .p-md-5 {
    padding: 48px !important;
  }

  .pt-md-5,
  .py-md-5 {
    padding-top: 48px !important;
  }

  .pr-md-5,
  .px-md-5 {
    padding-right: 48px !important;
  }

  .pb-md-5,
  .py-md-5 {
    padding-bottom: 48px !important;
  }

  .pl-md-5,
  .px-md-5 {
    padding-left: 48px !important;
  }

  .m-md-n1 {
    margin: -4px !important;
  }

  .mt-md-n1,
  .my-md-n1 {
    margin-top: -4px !important;
  }

  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -4px !important;
  }

  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -4px !important;
  }

  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -4px !important;
  }

  .m-md-n2 {
    margin: -8px !important;
  }

  .mt-md-n2,
  .my-md-n2 {
    margin-top: -8px !important;
  }

  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -8px !important;
  }

  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -8px !important;
  }

  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -8px !important;
  }

  .m-md-n3 {
    margin: -16px !important;
  }

  .mt-md-n3,
  .my-md-n3 {
    margin-top: -16px !important;
  }

  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -16px !important;
  }

  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -16px !important;
  }

  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -16px !important;
  }

  .m-md-n4 {
    margin: -24px !important;
  }

  .mt-md-n4,
  .my-md-n4 {
    margin-top: -24px !important;
  }

  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -24px !important;
  }

  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -24px !important;
  }

  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -24px !important;
  }

  .m-md-n5 {
    margin: -48px !important;
  }

  .mt-md-n5,
  .my-md-n5 {
    margin-top: -48px !important;
  }

  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -48px !important;
  }

  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -48px !important;
  }

  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -48px !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }

  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }

  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }

  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }

  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }

  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }

  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }

  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }

  .m-lg-1 {
    margin: 4px !important;
  }

  .mt-lg-1,
  .my-lg-1 {
    margin-top: 4px !important;
  }

  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 4px !important;
  }

  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 4px !important;
  }

  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 4px !important;
  }

  .m-lg-2 {
    margin: 8px !important;
  }

  .mt-lg-2,
  .my-lg-2 {
    margin-top: 8px !important;
  }

  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 8px !important;
  }

  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 8px !important;
  }

  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 8px !important;
  }

  .m-lg-3 {
    margin: 16px !important;
  }

  .mt-lg-3,
  .my-lg-3 {
    margin-top: 16px !important;
  }

  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 16px !important;
  }

  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 16px !important;
  }

  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 16px !important;
  }

  .m-lg-4 {
    margin: 24px !important;
  }

  .mt-lg-4,
  .my-lg-4 {
    margin-top: 24px !important;
  }

  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 24px !important;
  }

  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 24px !important;
  }

  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 24px !important;
  }

  .m-lg-5 {
    margin: 48px !important;
  }

  .mt-lg-5,
  .my-lg-5 {
    margin-top: 48px !important;
  }

  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 48px !important;
  }

  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 48px !important;
  }

  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 48px !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }

  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }

  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }

  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }

  .p-lg-1 {
    padding: 4px !important;
  }

  .pt-lg-1,
  .py-lg-1 {
    padding-top: 4px !important;
  }

  .pr-lg-1,
  .px-lg-1 {
    padding-right: 4px !important;
  }

  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 4px !important;
  }

  .pl-lg-1,
  .px-lg-1 {
    padding-left: 4px !important;
  }

  .p-lg-2 {
    padding: 8px !important;
  }

  .pt-lg-2,
  .py-lg-2 {
    padding-top: 8px !important;
  }

  .pr-lg-2,
  .px-lg-2 {
    padding-right: 8px !important;
  }

  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 8px !important;
  }

  .pl-lg-2,
  .px-lg-2 {
    padding-left: 8px !important;
  }

  .p-lg-3 {
    padding: 16px !important;
  }

  .pt-lg-3,
  .py-lg-3 {
    padding-top: 16px !important;
  }

  .pr-lg-3,
  .px-lg-3 {
    padding-right: 16px !important;
  }

  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 16px !important;
  }

  .pl-lg-3,
  .px-lg-3 {
    padding-left: 16px !important;
  }

  .p-lg-4 {
    padding: 24px !important;
  }

  .pt-lg-4,
  .py-lg-4 {
    padding-top: 24px !important;
  }

  .pr-lg-4,
  .px-lg-4 {
    padding-right: 24px !important;
  }

  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 24px !important;
  }

  .pl-lg-4,
  .px-lg-4 {
    padding-left: 24px !important;
  }

  .p-lg-5 {
    padding: 48px !important;
  }

  .pt-lg-5,
  .py-lg-5 {
    padding-top: 48px !important;
  }

  .pr-lg-5,
  .px-lg-5 {
    padding-right: 48px !important;
  }

  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 48px !important;
  }

  .pl-lg-5,
  .px-lg-5 {
    padding-left: 48px !important;
  }

  .m-lg-n1 {
    margin: -4px !important;
  }

  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -4px !important;
  }

  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -4px !important;
  }

  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -4px !important;
  }

  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -4px !important;
  }

  .m-lg-n2 {
    margin: -8px !important;
  }

  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -8px !important;
  }

  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -8px !important;
  }

  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -8px !important;
  }

  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -8px !important;
  }

  .m-lg-n3 {
    margin: -16px !important;
  }

  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -16px !important;
  }

  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -16px !important;
  }

  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -16px !important;
  }

  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -16px !important;
  }

  .m-lg-n4 {
    margin: -24px !important;
  }

  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -24px !important;
  }

  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -24px !important;
  }

  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -24px !important;
  }

  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -24px !important;
  }

  .m-lg-n5 {
    margin: -48px !important;
  }

  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -48px !important;
  }

  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -48px !important;
  }

  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -48px !important;
  }

  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -48px !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }

  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }

  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }

  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }

  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }

  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }

  .m-xl-1 {
    margin: 4px !important;
  }

  .mt-xl-1,
  .my-xl-1 {
    margin-top: 4px !important;
  }

  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 4px !important;
  }

  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 4px !important;
  }

  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 4px !important;
  }

  .m-xl-2 {
    margin: 8px !important;
  }

  .mt-xl-2,
  .my-xl-2 {
    margin-top: 8px !important;
  }

  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 8px !important;
  }

  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 8px !important;
  }

  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 8px !important;
  }

  .m-xl-3 {
    margin: 16px !important;
  }

  .mt-xl-3,
  .my-xl-3 {
    margin-top: 16px !important;
  }

  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 16px !important;
  }

  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 16px !important;
  }

  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 16px !important;
  }

  .m-xl-4 {
    margin: 24px !important;
  }

  .mt-xl-4,
  .my-xl-4 {
    margin-top: 24px !important;
  }

  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 24px !important;
  }

  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 24px !important;
  }

  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 24px !important;
  }

  .m-xl-5 {
    margin: 48px !important;
  }

  .mt-xl-5,
  .my-xl-5 {
    margin-top: 48px !important;
  }

  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 48px !important;
  }

  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 48px !important;
  }

  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 48px !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }

  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }

  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }

  .p-xl-1 {
    padding: 4px !important;
  }

  .pt-xl-1,
  .py-xl-1 {
    padding-top: 4px !important;
  }

  .pr-xl-1,
  .px-xl-1 {
    padding-right: 4px !important;
  }

  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 4px !important;
  }

  .pl-xl-1,
  .px-xl-1 {
    padding-left: 4px !important;
  }

  .p-xl-2 {
    padding: 8px !important;
  }

  .pt-xl-2,
  .py-xl-2 {
    padding-top: 8px !important;
  }

  .pr-xl-2,
  .px-xl-2 {
    padding-right: 8px !important;
  }

  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 8px !important;
  }

  .pl-xl-2,
  .px-xl-2 {
    padding-left: 8px !important;
  }

  .p-xl-3 {
    padding: 16px !important;
  }

  .pt-xl-3,
  .py-xl-3 {
    padding-top: 16px !important;
  }

  .pr-xl-3,
  .px-xl-3 {
    padding-right: 16px !important;
  }

  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 16px !important;
  }

  .pl-xl-3,
  .px-xl-3 {
    padding-left: 16px !important;
  }

  .p-xl-4 {
    padding: 24px !important;
  }

  .pt-xl-4,
  .py-xl-4 {
    padding-top: 24px !important;
  }

  .pr-xl-4,
  .px-xl-4 {
    padding-right: 24px !important;
  }

  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 24px !important;
  }

  .pl-xl-4,
  .px-xl-4 {
    padding-left: 24px !important;
  }

  .p-xl-5 {
    padding: 48px !important;
  }

  .pt-xl-5,
  .py-xl-5 {
    padding-top: 48px !important;
  }

  .pr-xl-5,
  .px-xl-5 {
    padding-right: 48px !important;
  }

  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 48px !important;
  }

  .pl-xl-5,
  .px-xl-5 {
    padding-left: 48px !important;
  }

  .m-xl-n1 {
    margin: -4px !important;
  }

  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -4px !important;
  }

  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -4px !important;
  }

  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -4px !important;
  }

  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -4px !important;
  }

  .m-xl-n2 {
    margin: -8px !important;
  }

  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -8px !important;
  }

  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -8px !important;
  }

  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -8px !important;
  }

  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -8px !important;
  }

  .m-xl-n3 {
    margin: -16px !important;
  }

  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -16px !important;
  }

  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -16px !important;
  }

  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -16px !important;
  }

  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -16px !important;
  }

  .m-xl-n4 {
    margin: -24px !important;
  }

  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -24px !important;
  }

  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -24px !important;
  }

  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -24px !important;
  }

  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -24px !important;
  }

  .m-xl-n5 {
    margin: -48px !important;
  }

  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -48px !important;
  }

  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -48px !important;
  }

  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -48px !important;
  }

  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -48px !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }

  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }

  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1660px) {
  .m-xxl-0 {
    margin: 0 !important;
  }

  .mt-xxl-0,
  .my-xxl-0 {
    margin-top: 0 !important;
  }

  .mr-xxl-0,
  .mx-xxl-0 {
    margin-right: 0 !important;
  }

  .mb-xxl-0,
  .my-xxl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xxl-0,
  .mx-xxl-0 {
    margin-left: 0 !important;
  }

  .m-xxl-1 {
    margin: 4px !important;
  }

  .mt-xxl-1,
  .my-xxl-1 {
    margin-top: 4px !important;
  }

  .mr-xxl-1,
  .mx-xxl-1 {
    margin-right: 4px !important;
  }

  .mb-xxl-1,
  .my-xxl-1 {
    margin-bottom: 4px !important;
  }

  .ml-xxl-1,
  .mx-xxl-1 {
    margin-left: 4px !important;
  }

  .m-xxl-2 {
    margin: 8px !important;
  }

  .mt-xxl-2,
  .my-xxl-2 {
    margin-top: 8px !important;
  }

  .mr-xxl-2,
  .mx-xxl-2 {
    margin-right: 8px !important;
  }

  .mb-xxl-2,
  .my-xxl-2 {
    margin-bottom: 8px !important;
  }

  .ml-xxl-2,
  .mx-xxl-2 {
    margin-left: 8px !important;
  }

  .m-xxl-3 {
    margin: 16px !important;
  }

  .mt-xxl-3,
  .my-xxl-3 {
    margin-top: 16px !important;
  }

  .mr-xxl-3,
  .mx-xxl-3 {
    margin-right: 16px !important;
  }

  .mb-xxl-3,
  .my-xxl-3 {
    margin-bottom: 16px !important;
  }

  .ml-xxl-3,
  .mx-xxl-3 {
    margin-left: 16px !important;
  }

  .m-xxl-4 {
    margin: 24px !important;
  }

  .mt-xxl-4,
  .my-xxl-4 {
    margin-top: 24px !important;
  }

  .mr-xxl-4,
  .mx-xxl-4 {
    margin-right: 24px !important;
  }

  .mb-xxl-4,
  .my-xxl-4 {
    margin-bottom: 24px !important;
  }

  .ml-xxl-4,
  .mx-xxl-4 {
    margin-left: 24px !important;
  }

  .m-xxl-5 {
    margin: 48px !important;
  }

  .mt-xxl-5,
  .my-xxl-5 {
    margin-top: 48px !important;
  }

  .mr-xxl-5,
  .mx-xxl-5 {
    margin-right: 48px !important;
  }

  .mb-xxl-5,
  .my-xxl-5 {
    margin-bottom: 48px !important;
  }

  .ml-xxl-5,
  .mx-xxl-5 {
    margin-left: 48px !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .pt-xxl-0,
  .py-xxl-0 {
    padding-top: 0 !important;
  }

  .pr-xxl-0,
  .px-xxl-0 {
    padding-right: 0 !important;
  }

  .pb-xxl-0,
  .py-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xxl-0,
  .px-xxl-0 {
    padding-left: 0 !important;
  }

  .p-xxl-1 {
    padding: 4px !important;
  }

  .pt-xxl-1,
  .py-xxl-1 {
    padding-top: 4px !important;
  }

  .pr-xxl-1,
  .px-xxl-1 {
    padding-right: 4px !important;
  }

  .pb-xxl-1,
  .py-xxl-1 {
    padding-bottom: 4px !important;
  }

  .pl-xxl-1,
  .px-xxl-1 {
    padding-left: 4px !important;
  }

  .p-xxl-2 {
    padding: 8px !important;
  }

  .pt-xxl-2,
  .py-xxl-2 {
    padding-top: 8px !important;
  }

  .pr-xxl-2,
  .px-xxl-2 {
    padding-right: 8px !important;
  }

  .pb-xxl-2,
  .py-xxl-2 {
    padding-bottom: 8px !important;
  }

  .pl-xxl-2,
  .px-xxl-2 {
    padding-left: 8px !important;
  }

  .p-xxl-3 {
    padding: 16px !important;
  }

  .pt-xxl-3,
  .py-xxl-3 {
    padding-top: 16px !important;
  }

  .pr-xxl-3,
  .px-xxl-3 {
    padding-right: 16px !important;
  }

  .pb-xxl-3,
  .py-xxl-3 {
    padding-bottom: 16px !important;
  }

  .pl-xxl-3,
  .px-xxl-3 {
    padding-left: 16px !important;
  }

  .p-xxl-4 {
    padding: 24px !important;
  }

  .pt-xxl-4,
  .py-xxl-4 {
    padding-top: 24px !important;
  }

  .pr-xxl-4,
  .px-xxl-4 {
    padding-right: 24px !important;
  }

  .pb-xxl-4,
  .py-xxl-4 {
    padding-bottom: 24px !important;
  }

  .pl-xxl-4,
  .px-xxl-4 {
    padding-left: 24px !important;
  }

  .p-xxl-5 {
    padding: 48px !important;
  }

  .pt-xxl-5,
  .py-xxl-5 {
    padding-top: 48px !important;
  }

  .pr-xxl-5,
  .px-xxl-5 {
    padding-right: 48px !important;
  }

  .pb-xxl-5,
  .py-xxl-5 {
    padding-bottom: 48px !important;
  }

  .pl-xxl-5,
  .px-xxl-5 {
    padding-left: 48px !important;
  }

  .m-xxl-n1 {
    margin: -4px !important;
  }

  .mt-xxl-n1,
  .my-xxl-n1 {
    margin-top: -4px !important;
  }

  .mr-xxl-n1,
  .mx-xxl-n1 {
    margin-right: -4px !important;
  }

  .mb-xxl-n1,
  .my-xxl-n1 {
    margin-bottom: -4px !important;
  }

  .ml-xxl-n1,
  .mx-xxl-n1 {
    margin-left: -4px !important;
  }

  .m-xxl-n2 {
    margin: -8px !important;
  }

  .mt-xxl-n2,
  .my-xxl-n2 {
    margin-top: -8px !important;
  }

  .mr-xxl-n2,
  .mx-xxl-n2 {
    margin-right: -8px !important;
  }

  .mb-xxl-n2,
  .my-xxl-n2 {
    margin-bottom: -8px !important;
  }

  .ml-xxl-n2,
  .mx-xxl-n2 {
    margin-left: -8px !important;
  }

  .m-xxl-n3 {
    margin: -16px !important;
  }

  .mt-xxl-n3,
  .my-xxl-n3 {
    margin-top: -16px !important;
  }

  .mr-xxl-n3,
  .mx-xxl-n3 {
    margin-right: -16px !important;
  }

  .mb-xxl-n3,
  .my-xxl-n3 {
    margin-bottom: -16px !important;
  }

  .ml-xxl-n3,
  .mx-xxl-n3 {
    margin-left: -16px !important;
  }

  .m-xxl-n4 {
    margin: -24px !important;
  }

  .mt-xxl-n4,
  .my-xxl-n4 {
    margin-top: -24px !important;
  }

  .mr-xxl-n4,
  .mx-xxl-n4 {
    margin-right: -24px !important;
  }

  .mb-xxl-n4,
  .my-xxl-n4 {
    margin-bottom: -24px !important;
  }

  .ml-xxl-n4,
  .mx-xxl-n4 {
    margin-left: -24px !important;
  }

  .m-xxl-n5 {
    margin: -48px !important;
  }

  .mt-xxl-n5,
  .my-xxl-n5 {
    margin-top: -48px !important;
  }

  .mr-xxl-n5,
  .mx-xxl-n5 {
    margin-right: -48px !important;
  }

  .mb-xxl-n5,
  .my-xxl-n5 {
    margin-bottom: -48px !important;
  }

  .ml-xxl-n5,
  .mx-xxl-n5 {
    margin-left: -48px !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mt-xxl-auto,
  .my-xxl-auto {
    margin-top: auto !important;
  }

  .mr-xxl-auto,
  .mx-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-auto,
  .my-xxl-auto {
    margin-bottom: auto !important;
  }

  .ml-xxl-auto,
  .mx-xxl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1900px) {
  .m-xxxl-0 {
    margin: 0 !important;
  }

  .mt-xxxl-0,
  .my-xxxl-0 {
    margin-top: 0 !important;
  }

  .mr-xxxl-0,
  .mx-xxxl-0 {
    margin-right: 0 !important;
  }

  .mb-xxxl-0,
  .my-xxxl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xxxl-0,
  .mx-xxxl-0 {
    margin-left: 0 !important;
  }

  .m-xxxl-1 {
    margin: 4px !important;
  }

  .mt-xxxl-1,
  .my-xxxl-1 {
    margin-top: 4px !important;
  }

  .mr-xxxl-1,
  .mx-xxxl-1 {
    margin-right: 4px !important;
  }

  .mb-xxxl-1,
  .my-xxxl-1 {
    margin-bottom: 4px !important;
  }

  .ml-xxxl-1,
  .mx-xxxl-1 {
    margin-left: 4px !important;
  }

  .m-xxxl-2 {
    margin: 8px !important;
  }

  .mt-xxxl-2,
  .my-xxxl-2 {
    margin-top: 8px !important;
  }

  .mr-xxxl-2,
  .mx-xxxl-2 {
    margin-right: 8px !important;
  }

  .mb-xxxl-2,
  .my-xxxl-2 {
    margin-bottom: 8px !important;
  }

  .ml-xxxl-2,
  .mx-xxxl-2 {
    margin-left: 8px !important;
  }

  .m-xxxl-3 {
    margin: 16px !important;
  }

  .mt-xxxl-3,
  .my-xxxl-3 {
    margin-top: 16px !important;
  }

  .mr-xxxl-3,
  .mx-xxxl-3 {
    margin-right: 16px !important;
  }

  .mb-xxxl-3,
  .my-xxxl-3 {
    margin-bottom: 16px !important;
  }

  .ml-xxxl-3,
  .mx-xxxl-3 {
    margin-left: 16px !important;
  }

  .m-xxxl-4 {
    margin: 24px !important;
  }

  .mt-xxxl-4,
  .my-xxxl-4 {
    margin-top: 24px !important;
  }

  .mr-xxxl-4,
  .mx-xxxl-4 {
    margin-right: 24px !important;
  }

  .mb-xxxl-4,
  .my-xxxl-4 {
    margin-bottom: 24px !important;
  }

  .ml-xxxl-4,
  .mx-xxxl-4 {
    margin-left: 24px !important;
  }

  .m-xxxl-5 {
    margin: 48px !important;
  }

  .mt-xxxl-5,
  .my-xxxl-5 {
    margin-top: 48px !important;
  }

  .mr-xxxl-5,
  .mx-xxxl-5 {
    margin-right: 48px !important;
  }

  .mb-xxxl-5,
  .my-xxxl-5 {
    margin-bottom: 48px !important;
  }

  .ml-xxxl-5,
  .mx-xxxl-5 {
    margin-left: 48px !important;
  }

  .p-xxxl-0 {
    padding: 0 !important;
  }

  .pt-xxxl-0,
  .py-xxxl-0 {
    padding-top: 0 !important;
  }

  .pr-xxxl-0,
  .px-xxxl-0 {
    padding-right: 0 !important;
  }

  .pb-xxxl-0,
  .py-xxxl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xxxl-0,
  .px-xxxl-0 {
    padding-left: 0 !important;
  }

  .p-xxxl-1 {
    padding: 4px !important;
  }

  .pt-xxxl-1,
  .py-xxxl-1 {
    padding-top: 4px !important;
  }

  .pr-xxxl-1,
  .px-xxxl-1 {
    padding-right: 4px !important;
  }

  .pb-xxxl-1,
  .py-xxxl-1 {
    padding-bottom: 4px !important;
  }

  .pl-xxxl-1,
  .px-xxxl-1 {
    padding-left: 4px !important;
  }

  .p-xxxl-2 {
    padding: 8px !important;
  }

  .pt-xxxl-2,
  .py-xxxl-2 {
    padding-top: 8px !important;
  }

  .pr-xxxl-2,
  .px-xxxl-2 {
    padding-right: 8px !important;
  }

  .pb-xxxl-2,
  .py-xxxl-2 {
    padding-bottom: 8px !important;
  }

  .pl-xxxl-2,
  .px-xxxl-2 {
    padding-left: 8px !important;
  }

  .p-xxxl-3 {
    padding: 16px !important;
  }

  .pt-xxxl-3,
  .py-xxxl-3 {
    padding-top: 16px !important;
  }

  .pr-xxxl-3,
  .px-xxxl-3 {
    padding-right: 16px !important;
  }

  .pb-xxxl-3,
  .py-xxxl-3 {
    padding-bottom: 16px !important;
  }

  .pl-xxxl-3,
  .px-xxxl-3 {
    padding-left: 16px !important;
  }

  .p-xxxl-4 {
    padding: 24px !important;
  }

  .pt-xxxl-4,
  .py-xxxl-4 {
    padding-top: 24px !important;
  }

  .pr-xxxl-4,
  .px-xxxl-4 {
    padding-right: 24px !important;
  }

  .pb-xxxl-4,
  .py-xxxl-4 {
    padding-bottom: 24px !important;
  }

  .pl-xxxl-4,
  .px-xxxl-4 {
    padding-left: 24px !important;
  }

  .p-xxxl-5 {
    padding: 48px !important;
  }

  .pt-xxxl-5,
  .py-xxxl-5 {
    padding-top: 48px !important;
  }

  .pr-xxxl-5,
  .px-xxxl-5 {
    padding-right: 48px !important;
  }

  .pb-xxxl-5,
  .py-xxxl-5 {
    padding-bottom: 48px !important;
  }

  .pl-xxxl-5,
  .px-xxxl-5 {
    padding-left: 48px !important;
  }

  .m-xxxl-n1 {
    margin: -4px !important;
  }

  .mt-xxxl-n1,
  .my-xxxl-n1 {
    margin-top: -4px !important;
  }

  .mr-xxxl-n1,
  .mx-xxxl-n1 {
    margin-right: -4px !important;
  }

  .mb-xxxl-n1,
  .my-xxxl-n1 {
    margin-bottom: -4px !important;
  }

  .ml-xxxl-n1,
  .mx-xxxl-n1 {
    margin-left: -4px !important;
  }

  .m-xxxl-n2 {
    margin: -8px !important;
  }

  .mt-xxxl-n2,
  .my-xxxl-n2 {
    margin-top: -8px !important;
  }

  .mr-xxxl-n2,
  .mx-xxxl-n2 {
    margin-right: -8px !important;
  }

  .mb-xxxl-n2,
  .my-xxxl-n2 {
    margin-bottom: -8px !important;
  }

  .ml-xxxl-n2,
  .mx-xxxl-n2 {
    margin-left: -8px !important;
  }

  .m-xxxl-n3 {
    margin: -16px !important;
  }

  .mt-xxxl-n3,
  .my-xxxl-n3 {
    margin-top: -16px !important;
  }

  .mr-xxxl-n3,
  .mx-xxxl-n3 {
    margin-right: -16px !important;
  }

  .mb-xxxl-n3,
  .my-xxxl-n3 {
    margin-bottom: -16px !important;
  }

  .ml-xxxl-n3,
  .mx-xxxl-n3 {
    margin-left: -16px !important;
  }

  .m-xxxl-n4 {
    margin: -24px !important;
  }

  .mt-xxxl-n4,
  .my-xxxl-n4 {
    margin-top: -24px !important;
  }

  .mr-xxxl-n4,
  .mx-xxxl-n4 {
    margin-right: -24px !important;
  }

  .mb-xxxl-n4,
  .my-xxxl-n4 {
    margin-bottom: -24px !important;
  }

  .ml-xxxl-n4,
  .mx-xxxl-n4 {
    margin-left: -24px !important;
  }

  .m-xxxl-n5 {
    margin: -48px !important;
  }

  .mt-xxxl-n5,
  .my-xxxl-n5 {
    margin-top: -48px !important;
  }

  .mr-xxxl-n5,
  .mx-xxxl-n5 {
    margin-right: -48px !important;
  }

  .mb-xxxl-n5,
  .my-xxxl-n5 {
    margin-bottom: -48px !important;
  }

  .ml-xxxl-n5,
  .mx-xxxl-n5 {
    margin-left: -48px !important;
  }

  .m-xxxl-auto {
    margin: auto !important;
  }

  .mt-xxxl-auto,
  .my-xxxl-auto {
    margin-top: auto !important;
  }

  .mr-xxxl-auto,
  .mx-xxxl-auto {
    margin-right: auto !important;
  }

  .mb-xxxl-auto,
  .my-xxxl-auto {
    margin-bottom: auto !important;
  }

  .ml-xxxl-auto,
  .mx-xxxl-auto {
    margin-left: auto !important;
  }
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 360px) {
  .text-xs-left {
    text-align: left !important;
  }

  .text-xs-right {
    text-align: right !important;
  }

  .text-xs-center {
    text-align: center !important;
  }
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }

  .text-sm-right {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }

  .text-md-right {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }

  .text-lg-right {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }

  .text-xl-right {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1660px) {
  .text-xxl-left {
    text-align: left !important;
  }

  .text-xxl-right {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1900px) {
  .text-xxxl-left {
    text-align: left !important;
  }

  .text-xxxl-right {
    text-align: right !important;
  }

  .text-xxxl-center {
    text-align: center !important;
  }
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

a.text-primary:focus,
a.text-primary:hover {
  color: #006060 !important;
}

a.text-secondary:focus,
a.text-secondary:hover {
  color: #494f54 !important;
}

a.text-success:focus,
a.text-success:hover {
  color: #006060 !important;
}

a.text-info:focus,
a.text-info:hover {
  color: #278eac !important;
}

a.text-warning:focus,
a.text-warning:hover {
  color: #ba7208 !important;
}

a.text-danger:focus,
a.text-danger:hover {
  color: #ff100b !important;
}

a.text-light:focus,
a.text-light:hover {
  color: #c9cdd1 !important;
}

a.text-dark:focus,
a.text-dark:hover,
a.text-inverse:focus,
a.text-inverse:hover {
  color: #0c0e10 !important;
}

a.text-black:focus,
a.text-black:hover {
  color: #000 !important;
}

a.text-white:focus,
a.text-white:hover {
  color: #d9d9d9 !important;
}

a.text-grey:focus,
a.text-grey:hover,
a.text-muted:focus,
a.text-muted:hover,
a.text-silver:focus,
a.text-silver:hover {
  color: #8a9da8 !important;
}

a.text-lime:focus,
a.text-lime:hover {
  color: #699b2e !important;
}

a.text-aqua:focus,
a.text-aqua:hover {
  color: #278eac !important;
}

.text-body {
  color: #333 !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  ::after,
  ::before {
    text-shadow: none !important;
    box-shadow: none !important;
  }

  a:not(.btn) {
    text-decoration: underline;
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
  }

  pre {
    white-space: pre-wrap !important;
  }

  blockquote,
  pre {
    border: 1px solid #adb5bd;
  }

  thead {
    display: table-header-group;
  }

  blockquote,
  img,
  pre,
  tr {
    page-break-inside: avoid;
  }

  h2,
  h3,
  p {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }

  @page {
    size: a3;
  }

  .container,
  body {
    min-width: 992px !important;
  }

  .navbar {
    display: none;
  }

  .badge {
    border: 1px solid #000;
  }

  .table {
    border-collapse: collapse !important;
  }

  .table td,
  .table th {
    background-color: #fff !important;
  }

  .table-bordered td,
  .table-bordered th {
    border: 1px solid #dee2e6 !important;
  }

  .table-dark {
    color: inherit;
  }

  .table-dark tbody + tbody,
  .table-dark td,
  .table-dark th,
  .table-dark thead th {
    border-color: #e4e7ea;
  }

  .table .thead-dark th {
    color: inherit;
    border-color: #e4e7ea;
  }
}

body {
  height: 100%;
  letter-spacing: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1 small,
h2 small,
h3 small,
h4 small,
h5 small,
h6 small {
  font-size: 60%;
  font-weight: 400;
  color: #6f8293;
}

a:focus {
  outline: 0;
}

.footer {
  z-index: 1020;
  padding: 10px 0;
  margin: 0 30px 0 250px;
  border-top: 1px solid #c6ced5;
  line-height: 20px;
  font-weight: 600;
  color: #4e5c68;
}

@media (max-width: 767.98px) {
  .footer {
    margin-left: 20px;
  }
}

.header {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1020;
  margin-bottom: 0;
  padding: 0;
  -webkit-transition: box-shadow 0.2s linear;
  -moz-transition: box-shadow 0.2s linear;
  -ms-transition: box-shadow 0.2s linear;
  -o-transition: box-shadow 0.2s linear;
  transition: box-shadow 0.2s linear;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.chats > div + div:after,
.chats > div + div:before,
.chats > li + li:after,
.chats > li + li:before,
.sidebar .nav > li:after,
.sidebar .nav > li:before,
.sidebar .nav > li > a:after,
.sidebar .nav > li > a:before {
  content: "";
  display: table;
  clear: both;
}

@media (max-width: 767.98px) {
  .header {
    display: block;
  }
}

.header .navbar-toggle {
  position: relative;
  padding: 10px;
  margin-right: 10px;
  margin-left: auto;
  background-color: transparent;
  background-image: none;
  border: 0;
  outline: 0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

@media (min-width: 768px) {
  .header .navbar-toggle {
    display: none;
  }
}

.header .navbar-toggle .icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.header .navbar-toggle .icon-bar + .icon-bar {
  margin-top: 4px;
}

.header .navbar-toggle:hover {
  background: 0 0;
  opacity: 0.75;
}

.header .navbar-toggle.pull-left {
  margin-left: 10px;
  margin-right: 0;
}

.header .navbar-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (min-width: 768px) {
  .header .navbar-header {
    width: 220px;
  }
}

.header .navbar-brand,
.header .navbar-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.header .navbar-brand {
  height: 50px;
  font-weight: 100;
  font-size: 18px;
  line-height: 30px;
  text-decoration: none;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-align: center;
  align-items: center;
  padding: 10px 20px;
}

.header .navbar-brand img,
.sidebar .nav > li.nav-profile .image img,
.timeline .timeline-comment-box .user img,
.widget-list .widget-list-item .widget-list-media img {
  max-width: 100%;
  max-height: 100%;
}

.header .navbar-brand .navbar-logo {
  margin-right: 10px;
  background: #00acac;
  border: 10px solid transparent;
  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.header .navbar-nav {
  list-style-type: none;
  margin: 0;
  padding: 0;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

@media (max-width: 767.98px) {
  .header .navbar-nav {
    -webkit-box-pack: flex-end;
    -ms-flex-pack: flex-end;
    justify-content: flex-end;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-top: 1px solid #edf0f2;
    padding-left: 15px;
    padding-right: 15px;
  }
}

.header .navbar-nav > li > a {
  display: block;
  text-decoration: none;
  line-height: 20px;
  padding: 15px;
  border: 0;
}

.header .navbar-nav > li > a .label {
  position: absolute;
  top: 8px;
  right: 5px;
  display: block;
  background: #00acac;
  line-height: 12px;
  font-weight: 600;
  color: #fff;
  padding: 3px 6px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

.header .navbar-nav > li > a i {
  top: 1px;
  position: relative;
  font-size: 16px;
}

.header .navbar-nav > li > a:focus,
.header .navbar-nav > li > a:hover {
  opacity: 0.75;
}

.header .navbar-nav > li > a.icon i {
  font-size: 24px;
  height: 24px;
  margin: -2px 0;
  display: block;
}

.header .navbar-nav > li.active > a {
  background: #f2f3f4;
  opacity: 1;
}

.header .navbar-nav > li.dropdown .dropdown-menu {
  margin: 0;
}

.header .navbar-nav > li.dropdown.dropdown-lg {
  position: static;
}

.header .navbar-nav > li.dropdown.dropdown-lg .dropdown-menu {
  left: 20px !important;
  right: 20px !important;
  padding: 20px;
  -webkit-transform: none !important;
  -moz-transform: none !important;
  -ms-transform: none !important;
  -o-transform: none !important;
  transform: none !important;
}

@media (min-width: 768px) {
  .header .navbar-nav > li.dropdown.dropdown-lg .dropdown-menu {
    top: 100% !important;
  }
}

@media (max-width: 767.98px) {
  .header .navbar-nav > li.dropdown.dropdown-lg .dropdown-menu {
    overflow: scroll;
    top: 101px !important;
    max-height: calc(100vh - 101px);
  }
}

.header
  .navbar-nav
  > li.dropdown.dropdown-lg
  .dropdown-menu.dropdown-menu-lg
  .nav
  > li
  > a {
  padding: 0;
  background: 0 0;
  line-height: 24px;
}

.header .navbar-nav > li.show > a,
.header .navbar-nav > li.show > a:focus,
.header .navbar-nav > li.show > a:hover {
  background: 0 0;
  color: #2d353c;
  opacity: 1;
}

.header .navbar-nav > li.divider {
  height: 34px;
  margin-top: 10px;
  background: #f2f3f4;
  width: 1px;
}

.header .navbar-nav.navbar-right {
  margin-left: auto;
}

.header .navbar-form {
  padding: 0 15px;
  margin: 9px 0;
}

@media (max-width: 767.98px) {
  .header .navbar-form {
    padding-left: 5px;
    padding-right: 5px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
}

.header .navbar-form .form-group {
  margin: 0;
  position: relative;
}

.header .navbar-form .form-control {
  width: 220px;
  padding: 5px 15px;
  height: 32px;
  background: #f2f3f4;
  border-color: #f2f3f4;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

@media (max-width: 767.98px) {
  .header .navbar-form .form-control {
    width: 100%;
  }
}

.header .navbar-form .form-control:focus {
  width: 300px;
  border-color: #f2f3f4;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-animation: navbar-input-expand 0.2s;
  -moz-animation: navbar-input-expand 0.2s;
  -ms-animation: navbar-input-expand 0.2s;
  -o-animation: navbar-input-expand 0.2s;
  animation: navbar-input-expand 0.2s;
}

@media (max-width: 767.98px) {
  .header .navbar-form .form-control:focus {
    width: 100%;
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    -o-animation: none;
    animation: none;
  }
}

.header .navbar-form .btn-search {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border: 0;
  background: 0 0;
  -webkit-border-radius: 0 30px 30px 0;
  border-radius: 0 30px 30px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.header .navbar-form .btn-search > i[class*="ion-"] {
  font-size: 22px;
  display: block;
}

.header .navbar-user .image,
.header .navbar-user img {
  float: left;
  width: 30px;
  height: 30px;
  margin: -5px 0px -5px 0;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

.header .navbar-user .image {
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.header .navbar-user .image.image-icon {
  font-size: 22px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.header .navbar-user .image.image-icon i {
  float: none;
  display: block;
  font-size: 22px;
  text-align: center;
  width: auto;
  margin: 0 auto -8px;
}

.header .navbar-language .flag-icon {
  font-size: 15px;
  margin-right: 7px;
}

@media (min-width: 768px) {
  .header .navbar-collapse {
    display: block;
    -webkit-flex-basis: initial;
    flex-basis: initial;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .header .navbar-collapse {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .header .navbar-collapse .navbar-nav > li {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .header .navbar-collapse .navbar-nav > li > a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
}

.header.navbar-default {
  background: #fff;
}

.header.navbar-default .navbar-brand,
.header.navbar-default .navbar-nav > li > a {
  color: #2d353c;
}

.header.navbar-default .navbar-toggle .icon-bar {
  background: #2d353c;
}

.header.navbar-inverse {
  background: #1a2229;
}

.header.navbar-inverse .navbar-toggle .icon-bar,
body .introjs-bullets ul li a.active {
  background: #6f8293;
}

.header.navbar-inverse .navbar-brand {
  color: #fff;
}

@media (max-width: 767.98px) {
  .header.navbar-inverse .navbar-nav {
    border-color: #2d353c;
  }
}

.header.navbar-inverse .navbar-nav > li > a {
  color: rgba(255, 255, 255, 0.65);
}

.header.navbar-inverse .navbar-nav > li.active > a {
  background: #2d353c;
  opacity: 1;
}

.header.navbar-inverse .navbar-nav > li.divider {
  background: rgba(255, 255, 255, 0.2);
}

.header.navbar-inverse .navbar-form {
  margin: 10px 0;
}

.header.navbar-inverse .navbar-form .form-control {
  background: rgba(255, 255, 255, 0.25);
  border-color: transparent;
  height: 30px;
  color: #fff;
}

.header.navbar-inverse .navbar-form .form-control::-webkit-input-placeholder,
.login.login-v1
  .login-container
  .login-body
  .login-content
  .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.header.navbar-inverse .navbar-form .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.header.navbar-inverse .navbar-form .form-control:-ms-input-placeholder,
.login.login-v1
  .login-container
  .login-body
  .login-content
  .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.header.navbar-inverse .navbar-form .form-control:-moz-placeholder,
.login.login-v1
  .login-container
  .login-body
  .login-content
  .form-control:-moz-placeholder,
.login.login-v1
  .login-container
  .login-body
  .login-content
  .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.header.navbar-inverse .navbar-form .btn-search {
  color: rgba(255, 255, 255, 0.5);
}

.has-scroll .header {
  -webkit-box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
}

.sidebar {
  width: 220px;
  /* position: absolute; */
  left: 0;
  top: 0;
  bottom: 0;
  padding-top: 50px;
  background: #2d353c;
  z-index: 1010;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

@media (max-width: 767.98px) {
  .sidebar {
    padding-top: 0;
    left: -220px;
    z-index: 1021;
  }
}

#page-loader.fade.in,
#page-loader.fade.show,
.sidebar .nav,
.sidebar .nav .has-sub.active > .sub-menu,
.sidebar .nav.nav-profile.active {
  display: block;
}

.sidebar .nav > li > a {
  padding: 7px 20px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.6);
  display: block;
  text-decoration: none;
}

.sidebar .nav > li > a i {
  float: left;
  margin-right: 10px;
  width: 14px;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
}

.sidebar .nav > li > a i[class^="ion-"] {
  margin-right: 8px;
  width: 18px;
  font-size: 18px;
  margin-left: -2px;
}

.sidebar .nav > li > a .icon-img {
  float: left;
  margin-right: 10px;
  margin-top: 3px;
  width: 14px;
  height: 14px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.sidebar .nav > li > a .icon-img img,
.top-menu .nav > li > a .icon-img img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}

.sidebar .nav > li > a .badge {
  padding: 5px 8px;
  background: #1a2229;
  font-weight: 600;
  font-size: 10px;
}

.sidebar .nav > li > a .label {
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 8px;
}

.gradient-enabled .sidebar .nav > li.active > a,
.gradient-enabled .sidebar .nav > li > a .label.label-theme {
  background: -webkit-linear-gradient(to bottom, #00c6c6 0%, #009393 100%);
  background: -moz-linear-gradient(to bottom, #00c6c6 0%, #009393 100%);
  background: -o-linear-gradient(to bottom, #00c6c6 0%, #009393 100%);
  background: linear-gradient(to bottom, #00c6c6 0%, #009393 100%);
}

.sidebar .nav > li > a > span {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.sidebar .nav > li.nav-header a:focus,
.sidebar .nav > li.nav-header a:hover,
.sidebar .nav > li > a:focus,
.sidebar .nav > li > a:hover {
  background: 0 0;
  color: #fff;
}

.sidebar .nav > li.active > a {
  position: relative;
  z-index: 10;
  color: #fff;
  background: #242b30;
}

.sidebar .nav > li.active > a i {
  color: #00acac;
}

.gradient-enabled .sidebar .nav > li.active > a i {
  color: rgba(0, 0, 0, 0.65);
}

.gradient-enabled .sidebar .nav > li.active > a .caret {
  color: rgba(0, 0, 0, 0.5);
}

.sidebar .nav > li.active > a .badge,
.sidebar .nav > li.active > a .label {
  background: rgba(0, 0, 0, 0.65);
}

.sidebar .nav > li.nav-header {
  margin: 0;
  padding: 15px 20px 3px;
  line-height: 20px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 600;
}

.sidebar .nav > li.nav-header a {
  padding: 0;
  margin: 0;
  display: inline;
}

.sidebar .nav > li.nav-header a i {
  float: none;
  margin: 0;
}

.sidebar .nav > li.nav-profile {
  padding: 20px;
  color: #fff;
  background: #1a2229;
  overflow: hidden;
}

.sidebar .nav > li.nav-profile a {
  padding: 0;
}

.sidebar .nav > li.nav-profile > a {
  margin: -20px;
  padding: 20px;
  display: block;
  color: #fff;
  font-weight: 600;
}

.sidebar .nav > li.nav-profile > a:hover .cover.with-shadow:before {
  opacity: 0.75;
}

.sidebar .nav > li.nav-profile .image {
  width: 34px;
  height: 34px;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

.sidebar .nav > li.nav-profile .image.image-icon i {
  float: none;
  display: block;
  font-size: 24px;
  text-align: center;
  width: auto;
  margin: 0 auto -12px;
}

.sidebar .nav > li.nav-profile .info {
  font-size: 14px;
  position: relative;
}

.sidebar .nav > li.nav-profile .info .caret {
  margin-top: 2px;
}

.sidebar .nav > li.nav-profile .info small {
  display: block;
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  margin-bottom: -5px;
}

.sidebar .nav > li.nav-profile .cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-repeat: no-repeat;
  background-size: cover;
}

.sidebar .nav > li.nav-profile .cover.with-shadow:before,
.sidebar li > a .caret:before {
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.sidebar .nav > li.nav-profile .cover.with-shadow:before {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(26, 34, 41, 0.75);
  content: "";
}

.sidebar .nav > li.nav-widget {
  padding: 10px 20px;
}

.sidebar .nav > li.nav-widget i {
  margin-right: auto;
}

.sidebar .nav > li .text-theme {
  margin-left: 5px;
}

.sidebar .nav .sub-menu > li > a {
  color: rgba(255, 255, 255, 0.45);
}

.sidebar .nav .sub-menu > li > a .caret {
  margin-top: -1px;
  left: -5px;
  color: rgba(255, 255, 255, 0.25);
}

.sidebar .nav.nav-profile {
  padding: 5px 0;
  border-bottom: 1px solid #1a2229;
  display: none;
}

.sidebar li > a .caret {
  display: block;
  float: right;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 11px;
  border: 0;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.sidebar li > a .caret:before {
  content: "\\f054";
  display: block;
  text-align: center;
  opacity: 0.5;
}

.float-sub-menu-container .float-sub-menu li.active > a .caret:before,
.float-sub-menu-container .float-sub-menu li.expand > a .caret:before,
.float-sub-menu-container .float-sub-menu li.expanding > a .caret:before,
.sidebar li.active > a .caret:before,
.sidebar li.expand > a .caret:before,
.sidebar li.expanding > a .caret:before {
  opacity: 1;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.float-sub-menu-container .float-sub-menu li.closed > a .caret:before,
.float-sub-menu-container .float-sub-menu li.closing > a .caret:before,
.sidebar li.closed > a .caret:before,
.sidebar li.closing > a .caret:before {
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
}

.sidebar .sub-menu > li > a {
  padding: 3px 20px 3px 15px;
  display: block;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  position: relative;
}

.sidebar .sub-menu > li > a:focus,
.sidebar .sub-menu > li > a:hover {
  color: #fff;
}

.sidebar .sub-menu > li > a:after {
  content: "";
  position: absolute;
  left: -11px;
  top: 11px;
  width: 11px;
  height: 2px;
  background: #242b30;
}

.sidebar .sub-menu > li:before {
  content: "";
  position: absolute;
  left: -13px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #242b30;
}

.sidebar .sub-menu > li:after {
  content: "";
  position: absolute;
  left: 0;
  width: 6px;
  height: 6px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  top: 11px;
  margin-top: -2px;
  z-index: 10;
  background: #2d353c;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.sidebar .sub-menu > li:first-child:before {
  top: -14px;
}

.float-sub-menu-container .float-sub-menu li:first-child:last-child:before,
.sidebar .sub-menu > li:first-child:last-child:before {
  height: 27px;
}

.sidebar .sub-menu > li:last-child:before {
  bottom: auto;
  height: 13px;
}

.sidebar .sub-menu > li.has-sub > a:before {
  background: #242b30;
}

.content.content-inverse-mode h1,
.content.content-inverse-mode h2,
.content.content-inverse-mode h3,
.content.content-inverse-mode h4,
.content.content-inverse-mode h5,
.content.content-inverse-mode h6,
.sidebar .sub-menu > li.active > a {
  color: #fff;
}

.sidebar .sub-menu > li.active:after {
  border-color: #00acac;
}

.sidebar .sub-menu .sub-menu {
  padding: 0 0 0 15px;
  background: 0 0;
}

.sidebar .sidebar-minify-btn {
  margin: 10px 0;
  float: right;
  padding: 5px 20px 5px 10px !important;
  background: #242b30;
  color: #fff;
  -webkit-border-radius: 20px 0 0 20px;
  border-radius: 20px 0 0 20px;
}

.sidebar .sidebar-minify-btn i {
  margin: 0 !important;
  color: #fff;
}

.sidebar .sidebar-minify-btn:focus,
.sidebar .sidebar-minify-btn:hover {
  background: #1c2025 !important;
}

.content.content-inverse-mode .slimScrollDiv .slimScrollBar:before,
.sidebar .slimScrollDiv .slimScrollBar:before {
  background: rgba(255, 255, 255, 0.5) !important;
}

.sidebar.sidebar-grid .nav > li + li {
  margin-top: -1px;
}

.sidebar.sidebar-grid .nav > li > a {
  border-top: 1px solid #3d4852;
  border-bottom: 1px solid #3d4852;
}

.sidebar.sidebar-grid .nav > li.expand > a,
.sidebar.sidebar-grid .nav > li.expanding > a {
  border-bottom-color: transparent;
}

.sidebar.sidebar-grid .nav > li.active > a {
  border-color: #2d353c;
}

.sidebar.sidebar-transparent,
.sidebar.sidebar-transparent .nav > li.nav-profile .cover,
.sidebar.sidebar-transparent .nav > li.nav-profile .cover.with-shadow:before {
  background: 0 0;
}

.sidebar.sidebar-transparent + .sidebar-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  background-size: cover;
}

.sidebar.sidebar-transparent + .sidebar-bg:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(45, 53, 60, 0.75);
}

.sidebar.sidebar-transparent .nav > li.active > a {
  background: rgba(0, 0, 0, 0.3);
}

.sidebar.sidebar-transparent .nav > li.nav-profile,
.sidebar.sidebar-transparent .nav > li.nav-profile.active {
  background: rgba(0, 0, 0, 0.25);
}

.sidebar.sidebar-transparent .nav > li.nav-profile a:focus,
.sidebar.sidebar-transparent .nav > li.nav-profile a:hover {
  background: 0 0;
}

.sidebar.sidebar-transparent .sub-menu {
  background: 0 0;
}

.sidebar.sidebar-transparent .sub-menu > li.has-sub > a:after,
.sidebar.sidebar-transparent .sub-menu > li:before,
.sidebar.sidebar-transparent .sub-menu > li > a:after {
  background: rgba(0, 0, 0, 0.45);
}

.sidebar-bg {
  background: #2d353c;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 220px;
  z-index: 1000;
}

@media (max-width: 767.98px) {
  .sidebar-bg {
    padding-top: 0;
    left: -220px;
    z-index: 1020;
  }
}

.top-menu {
  background: #1a2229;
  left: 0;
  right: 0;
  z-index: 1015;
}

@media (min-width: 768px) {
  .top-menu {
    top: 50px;
    position: fixed;
    height: 40px;
  }
}

@media (max-width: 767.98px) {
  .top-menu {
    display: none;
  }
}

@media (min-width: 576px) {
  .top-menu .nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}

@media (max-width: 767.98px) {
  .top-menu .nav {
    display: block;
    margin: 0 !important;
  }
}

.top-menu .nav > li {
  position: relative;
  display: block;
}

.top-menu .nav > li > a {
  padding: 10px 20px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 20px;
  text-decoration: none;
  white-space: nowrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (min-width: 768px) {
  .top-menu .nav > li > a {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
}

.top-menu .nav > li > a i {
  font-size: 14px;
  margin-right: 10px;
  line-height: 20px;
  width: 14px;
  text-align: center;
}

.top-menu .nav > li > a .badge {
  margin-left: 5px;
  background: #2d353c;
}

.top-menu .nav > li > a .label {
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 5px;
}

.top-menu .nav > li > a .icon-img {
  float: left;
  margin-right: 7px;
  margin-left: -3px;
  width: 20px;
  height: 20px;
  overflow: hidden;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.top-menu .nav > li > a > span {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.top-menu .nav > li > a:focus,
.top-menu .nav > li > a:hover {
  background: 0 0;
  color: #fff;
}

.top-menu .nav > li.active > a {
  position: relative;
  z-index: 10;
  color: #fff;
}

.top-menu .nav > li.active > a i {
  color: #00acac;
}

.top-menu .nav > li.active > a.badge,
.top-menu .nav > li.active > a.label {
  background: rgba(0, 0, 0, 0.4);
}

.top-menu .nav > li.menu-control {
  position: absolute;
  top: 0;
  margin: 0;
  z-index: 10;
}

@media (max-width: 767.98px) {
  .top-menu .nav > li.menu-control {
    display: none !important;
  }
}

.top-menu .nav > li.menu-control > a {
  padding: 0;
  text-align: center;
  line-height: 40px;
  width: 40px;
  height: 40px;
  background: #2d353c;
}

.top-menu .nav > li.menu-control > a i {
  float: none;
  margin: 0;
  font-size: 18px;
  display: block;
  line-height: 40px;
  color: #fff;
  width: auto;
}

.top-menu .nav > li.menu-control > a:focus,
.top-menu .nav > li.menu-control > a:hover {
  background: #242b30;
}

.top-menu .nav > li.menu-control.menu-control-left {
  left: -50px;
}

.top-menu .nav > li.menu-control.menu-control-left > a {
  -webkit-box-shadow: 5px 0 8px -3px rgba(0, 0, 0, 0.5);
  box-shadow: 5px 0 8px -3px rgba(0, 0, 0, 0.5);
}

.top-menu .nav > li.menu-control.menu-control-left.show {
  left: 0;
  -webkit-animation: topMenuControlSlideInLeft 0.2s;
  -moz-animation: topMenuControlSlideInLeft 0.2s;
  -ms-animation: topMenuControlSlideInLeft 0.2s;
  -o-animation: topMenuControlSlideInLeft 0.2s;
  animation: topMenuControlSlideInLeft 0.2s;
}

.top-menu .nav > li.menu-control.menu-control-right {
  right: -50px;
}

.top-menu .nav > li.menu-control.menu-control-right > a {
  -webkit-box-shadow: -5px 0 8px -3px rgba(0, 0, 0, 0.5);
  box-shadow: -5px 0 8px -3px rgba(0, 0, 0, 0.5);
}

.top-menu .nav > li.menu-control.menu-control-right.show {
  right: 0;
  -webkit-animation: topMenuControlSlideInRight 0.2s;
  -moz-animation: topMenuControlSlideInRight 0.2s;
  -ms-animation: topMenuControlSlideInRight 0.2s;
  -o-animation: topMenuControlSlideInRight 0.2s;
  animation: topMenuControlSlideInRight 0.2s;
}

@media (min-width: 768px) {
  .top-menu .nav > li.has-sub:hover > .sub-menu {
    display: block;
  }
}

.top-menu .nav > li:focus > a,
.top-menu .nav > li:hover > a {
  background: 0 0;
  color: #fff;
}

.top-menu .nav .caret {
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 11px;
  border: 0;
  margin-left: 5px;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

@media (max-width: 767.98px) {
  .top-menu .nav .caret {
    margin-left: auto;
  }
}

.top-menu .nav .caret:before {
  content: "\\f054";
  display: block;
  text-align: center;
  opacity: 0.5;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.top-menu .nav .sub-menu {
  display: none;
  top: 40px;
  background: #2d353c;
  list-style-type: none;
  margin: 0;
  padding: 10px 0;
}

@media (min-width: 768px) {
  .top-menu .nav .sub-menu {
    width: 220px;
    position: absolute;
    left: 0;
    max-height: calc(100vh - 90px);
    overflow: scroll;
  }
}

.top-menu .nav .sub-menu > li > a {
  padding: 5px 20px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 767.98px) {
  .top-menu .nav .sub-menu > li > a {
    padding-left: 44px;
  }
}

.top-menu .nav .sub-menu > li > a .caret {
  margin-left: auto;
}

.float-sub-menu-container .float-sub-menu li > a:focus,
.float-sub-menu-container .float-sub-menu li > a:hover,
.top-menu .nav .sub-menu > li > a:focus,
.top-menu .nav .sub-menu > li > a:hover {
  color: #fff;
}

.top-menu .nav .sub-menu > li.active > a {
  background: #1a2229;
  color: #fff;
}

.top-menu .nav .sub-menu .sub-menu {
  background: rgba(0, 0, 0, 0.2);
  position: relative;
  left: 0;
  top: 0;
  max-height: auto;
  overflow: initial;
}

#page-loader {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #d9e0e7;
  z-index: 9999;
}

#page-loader.fade.d-none .spinner {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  -o-animation: none;
  animation: none;
}

.content {
  margin-left: 220px;
  padding: 20px 0px;
  height: calc(100vh - 80px);
  /* height: 100%; */
}

@media (max-width: 767.98px) {
  .content {
    margin-left: 0;
    padding: 20px;
  }
}

.content.content-full-width {
  padding: 0;
}

.content.content-full-width .page-header {
  margin: 20px 30px;
  position: relative;
  z-index: 10;
}

@media (max-width: 767.98px) {
  .content.content-full-width .page-header {
    margin: 20px;
  }

  .content.content-full-width .page-header + .page-header {
    margin-top: -20px;
  }
}

.content.content-full-width .breadcrumb {
  position: relative;
  z-index: 20;
  margin: 0 30px 0 0;
}

@media (max-width: 1199.98px) {
  .content.content-full-width .breadcrumb {
    margin: 20px 30px;
  }

  .content.content-full-width .breadcrumb + .page-header {
    margin-top: -20px;
  }
}

@media (max-width: 767.98px) {
  .content.content-full-width .breadcrumb {
    margin: 20px;
  }

  .content.content-full-width .breadcrumb + .page-header {
    margin-top: -20px;
  }
}

.content.content-inverse-mode .breadcrumb,
.content.content-inverse-mode .breadcrumb a,
.content.content-inverse-mode .page-header,
.float-sub-menu-container .float-sub-menu li.active > a,
.float-sub-menu-container .float-sub-menu li.expand > a,
.float-sub-menu-container .float-sub-menu li.expanding > a {
  color: #fff;
}

.content.content-inverse-mode .breadcrumb > li,
.content.content-inverse-mode .page-header small {
  color: rgba(255, 255, 255, 0.75);
}

.float-sub-menu-container {
  position: fixed;
  width: 220px;
  margin: 0;
  background: #242b30;
  z-index: 1020;
}

.float-sub-menu-container .float-sub-menu {
  margin: 0;
  list-style-type: none;
  padding: 9px 0 9px 39px;
}

.float-sub-menu-container .float-sub-menu li {
  position: relative;
}

.float-sub-menu-container .float-sub-menu li > a {
  line-height: 18px;
  display: block;
  text-decoration: none;
  position: relative;
  color: rgba(255, 255, 255, 0.6);
  padding: 3px 20px 3px 15px;
}

.float-sub-menu-container .float-sub-menu li > a .caret {
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 11px;
  margin-top: -1px;
  border: 0;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  float: right;
}

.float-sub-menu-container .float-sub-menu li > a .caret:before {
  display: block;
  text-align: center;
  opacity: 0.5;
  content: "\\f054";
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.float-sub-menu-container .float-sub-menu li > a:after {
  content: "";
  position: absolute;
  background: #2d353c;
  top: 11px;
  width: 11px;
  height: 2px;
  left: -11px;
}

.float-sub-menu-container .float-sub-menu li:before {
  content: "";
  background: #2d353c;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  left: -13px;
}

.float-sub-menu-container .float-sub-menu li:after {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  top: 11px;
  margin-top: -2px;
  z-index: 10;
  background: #242b30;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  left: 0;
}

.float-sub-menu-container .float-sub-menu li:first-child:before {
  top: -14px;
}

.float-sub-menu-container .float-sub-menu li:last-child:before {
  bottom: auto;
  height: 13px;
}

.float-sub-menu-container .float-sub-menu li.has-sub > a:before {
  background: #2d353c;
}

.float-sub-menu-container .float-sub-menu li.active:after {
  border-color: #00acac;
}

.float-sub-menu-container .float-sub-menu > li:first-child:before {
  top: 11px;
}

.float-sub-menu-container .float-sub-menu > li:first-child:last-child:before {
  height: 0 !important;
}

.float-sub-menu-container .float-sub-menu .active > .sub-menu,
.inbox .nav-inbox > li {
  display: block;
}

.float-sub-menu-container .float-sub-menu .sub-menu {
  display: none;
  list-style-type: none;
  background: 0 0;
  padding: 0 0 0 15px;
}

.float-sub-menu-container .float-sub-menu-arrow {
  position: absolute;
  top: 20px;
  width: 28px;
  height: 2px;
  background: #2d353c;
  left: 0;
}

.float-sub-menu-container .float-sub-menu-line {
  position: absolute;
  top: 20px;
  width: 2px;
  background: #2d353c;
  left: 26px;
}

.float-sub-menu-container .foat-sub-menu-arrow:after,
.float-sub-menu-container .foat-sub-menu-arrow:before,
.page-sidebar-minified .sidebar .nav > li > a span {
  display: none;
}

.boxed-layout {
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.boxed-layout .top-menu {
  max-width: 1280px;
  width: 100%;
  left: 50%;
  margin-left: -640px;
  position: absolute;
}

@media (max-width: 767.98px) {
  .boxed-layout .top-menu {
    position: relative;
    left: 0;
    margin: 0;
  }
}

.boxed-layout .pace {
  width: 1280px;
  left: 50%;
  margin-left: -640px;
  position: absolute;
}

.boxed-layout .page-container {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  min-height: 100%;
  background: #d9e0e7;
  position: relative;
  overflow: hidden;
  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
}

.boxed-layout .header {
  max-width: 1280px;
  width: 100%;
  right: auto;
  left: auto;
}

@media (min-width: 768px) {
  .boxed-layout .sidebar,
  .boxed-layout .sidebar-bg {
    left: auto;
    right: auto;
  }
}

@media (max-width: 1280px) {
  .boxed-layout .top-menu {
    left: 0;
    margin-left: 0;
  }
}

.page-content-full-height {
  height: 100%;
}

@media (min-width: 768px) {
  .page-content-full-height .content {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.page-header-fixed {
  padding-top: 50px;
}

@media (max-width: 767.98px) {
  .page-header-fixed {
    padding-top: 101px;
  }
}

/* .page-header-fixed .header,
.page-sidebar-fixed .sidebar {
    position: fixed
} */

@media (max-width: 767.98px) {
  .page-with-two-sidebar .sidebar-right.sidebar,
  .page-with-two-sidebar .sidebar-right.sidebar-bg {
    position: fixed;
    right: -220px;
    left: auto;
  }

  .page-with-two-sidebar .header .navbar-brand {
    margin: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .page-with-two-sidebar.page-right-sidebar-toggled .sidebar-right.sidebar,
  .page-with-two-sidebar.page-right-sidebar-toggled .sidebar-right.sidebar-bg,
  .page-with-two-sidebar.page-with-wide-sidebar.page-right-sidebar-toggled
    .sidebar-right.sidebar,
  .page-with-two-sidebar.page-with-wide-sidebar.page-right-sidebar-toggled
    .sidebar-right.sidebar-bg {
    right: 0;
    left: auto;
    -webkit-animation: sidebarSlideInRight 0.2s;
    -moz-animation: sidebarSlideInRight 0.2s;
    -ms-animation: sidebarSlideInRight 0.2s;
    -o-animation: sidebarSlideInRight 0.2s;
    animation: sidebarSlideInRight 0.2s;
  }

  .page-with-two-sidebar.page-with-wide-sidebar .sidebar-right.sidebar,
  .page-with-two-sidebar.page-with-wide-sidebar .sidebar-right.sidebar-bg {
    right: -250px;
    left: auto;
  }
}

.page-sidebar-minified .sidebar {
  width: 60px;
  position: absolute;
}

.page-sidebar-minified .sidebar .nav > li > a {
  padding: 10px 20px;
}

.media-messaging .media p,
.page-sidebar-minified .sidebar .nav > li > a i {
  margin: 0;
}

.page-sidebar-minified .sidebar .nav li.has-sub > .sub-menu,
.page-sidebar-minified .sidebar .nav-profile.expand,
.page-sidebar-minified .sidebar .slimScrollDiv .slimScrollBar,
.page-sidebar-minified .sidebar .slimScrollDiv .slimScrollRail {
  display: none !important;
}

.checkbox.checkbox-css input,
.page-sidebar-minified .sidebar .nav-header,
.page-sidebar-minified .sidebar .nav-profile,
.radio.radio-css input,
.switcher input {
  display: none;
}

.page-sidebar-minified .sidebar .caret {
  position: absolute;
  top: 10px;
  right: 5px;
}

.page-sidebar-minified .sidebar .caret:before {
  -webkit-transform: rotate(0deg) !important;
  -moz-transform: rotate(0deg) !important;
  -ms-transform: rotate(0deg) !important;
  -o-transform: rotate(0deg) !important;
  transform: rotate(0deg) !important;
}

.page-sidebar-minified .sidebar.sidebar-right .slimScrollDiv,
.page-sidebar-minified .sidebar.sidebar-right .slimScrollDiv > div {
  overflow: hidden !important;
}

.page-sidebar-minified .sidebar.sidebar-right .slimScrollBar {
  display: block !important;
}

.page-sidebar-minified .sidebar-bg {
  width: 60px;
}

.page-sidebar-minified .content {
  margin-left: 60px;
}

@media (max-width: 767.98px) {
  .page-sidebar-minified .content {
    margin-left: 0;
  }
}

.page-sidebar-minified .footer {
  margin-left: 90px;
}

@media (max-width: 767.98px) {
  .page-sidebar-minified .footer {
    margin-left: 20px;
  }
}

.page-sidebar-minified .sidebar-minify-btn i:before {
  content: "\\f101";
}

@media (min-width: 768px) {
  .page-sidebar-minified .map {
    left: 60px;
  }

  .page-sidebar-minified.page-with-right-sidebar {
    right: 60px;
    left: 0;
  }
}

.page-sidebar-minified.page-with-right-sidebar .content {
  margin-right: 60px;
  margin-left: 0;
}

@media (max-width: 767.98px) {
  .page-sidebar-minified.page-with-right-sidebar .content {
    margin-right: 0;
  }
}

.page-sidebar-minified.page-with-right-sidebar .footer {
  margin-right: 90px;
  margin-left: 30px;
}

@media (max-width: 767.98px) {
  .page-sidebar-minified.page-with-right-sidebar .footer {
    margin-right: 20px;
  }
}

.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > a .icon-img,
.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > a i {
  float: none;
  width: auto;
  margin: 0 0 0 5px;
}

.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > a .caret {
  position: absolute;
  right: auto;
  left: 3px;
}

.page-sidebar-minified.page-with-right-sidebar
  .sidebar
  .nav
  > li
  > a
  .caret:before,
.page-with-right-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li
  > a
  .caret:before {
  content: "\\f053";
}

.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > .sub-menu {
  padding: 10px 30px 10px 0;
}

.page-sidebar-minified.page-with-right-sidebar .sidebar-minify-btn i:before {
  content: "\\f100";
}

.page-sidebar-minified.page-sidebar-fixed .sidebar {
  position: fixed;
}

.page-sidebar-minified.page-sidebar-fixed .sidebar .slimScrollDiv,
.page-sidebar-minified.page-sidebar-fixed .sidebar .slimScrollDiv > div {
  overflow: hidden !important;
}

.page-sidebar-minified:not(.page-sidebar-fixed) .sidebar .slimScrollDiv,
.page-sidebar-minified:not(.page-sidebar-fixed) .sidebar .slimScrollDiv > div {
  overflow: visible !important;
  height: auto !important;
}

@media (max-width: 767.98px) {
  .page-sidebar-toggled .sidebar,
  .page-sidebar-toggled .sidebar-bg {
    left: 0;
    -webkit-animation: sidebarSlideInLeft 0.2s;
    -moz-animation: sidebarSlideInLeft 0.2s;
    -ms-animation: sidebarSlideInLeft 0.2s;
    -o-animation: sidebarSlideInLeft 0.2s;
    animation: sidebarSlideInLeft 0.2s;
  }

  .page-sidebar-toggled .sidebar-bg {
    position: fixed;
  }

  .page-sidebar-toggled.page-with-right-sidebar .sidebar,
  .page-sidebar-toggled.page-with-right-sidebar .sidebar-bg,
  .page-sidebar-toggled.page-with-right-sidebar.page-sidebar-minified .sidebar,
  .page-sidebar-toggled.page-with-right-sidebar.page-sidebar-minified
    .sidebar-bg {
    left: auto;
    right: 0;
    -webkit-animation: sidebarSlideInRight 0.2s;
    -moz-animation: sidebarSlideInRight 0.2s;
    -ms-animation: sidebarSlideInRight 0.2s;
    -o-animation: sidebarSlideInRight 0.2s;
    animation: sidebarSlideInRight 0.2s;
  }

  .page-sidebar-toggled.page-with-two-sidebar .sidebar-right.sidebar,
  .page-sidebar-toggled.page-with-two-sidebar .sidebar-right.sidebar-bg {
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    -o-animation: none;
    animation: none;
  }

  .page-sidebar-toggled.page-sidebar-minified.sidebar,
  .page-sidebar-toggled.page-sidebar-minified.sidebar-bg {
    position: fixed;
    left: 0;
    -webkit-animation: sidebarSlideInLeft 0.2s;
    -moz-animation: sidebarSlideInLeft 0.2s;
    -ms-animation: sidebarSlideInLeft 0.2s;
    -o-animation: sidebarSlideInLeft 0.2s;
    animation: sidebarSlideInLeft 0.2s;
  }
}

.page-with-light-sidebar .sidebar,
.page-with-light-sidebar .sidebar-bg {
  background: #fff;
}

.page-with-light-sidebar .sidebar .nav > li > a {
  color: #6f8293;
  font-weight: 600;
}

.page-with-light-sidebar .sidebar .nav > li > a:focus,
.page-with-light-sidebar .sidebar .nav > li > a:hover {
  color: #2d353c;
}

.page-with-light-sidebar .sidebar .nav > li.active > a {
  color: #2d353c;
  background: #f2f3f4;
}

.page-with-light-sidebar .sidebar .nav > li.active > a:focus,
.page-with-light-sidebar .sidebar .nav > li.active > a:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.today:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.next:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.next:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.prev:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.prev:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.switch:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.switch:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.today:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.today:hover {
  color: #2d353c;
  background: #f2f3f4;
}

.page-with-light-sidebar .sidebar .nav > li.nav-header,
.page-with-light-sidebar .sidebar .sub-menu > li > a .caret {
  color: #6f8293;
}

.page-with-light-sidebar .sidebar .nav > li.nav-profile.active > a,
.page-with-light-sidebar .sidebar .nav > li.nav-profile > a {
  color: #fff !important;
}

.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn {
  background: #f2f3f4;
  color: #2d353c;
}

.breadcrumb .breadcrumb-item + .breadcrumb-item:before,
.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn i {
  color: #9ba8b4;
}

.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:focus,
.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:hover {
  background: #f2f3f4 !important;
  color: #2d353c !important;
}

.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:focus i,
.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:hover i {
  color: #2d353c !important;
}

.page-with-light-sidebar .sidebar .nav.nav-profile {
  border-color: #f2f3f4;
}

.page-with-light-sidebar .sidebar .sub-menu > li > a {
  color: #6f8293;
  font-weight: 600 !important;
}

.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a:focus,
.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a:hover,
.page-with-light-sidebar .sidebar .sub-menu > li > a:focus,
.page-with-light-sidebar .sidebar .sub-menu > li > a:hover {
  color: #2d353c;
}

.page-with-light-sidebar .sidebar .sub-menu > li.has-sub > a:before,
.page-with-light-sidebar .sidebar .sub-menu > li:before,
.page-with-light-sidebar .sidebar .sub-menu > li > a:after {
  background: #dde0e2;
}

.page-with-light-sidebar .sidebar .sub-menu > li:after {
  border-width: 2px;
  border-color: #dde0e2;
  background: #fff;
}

.page-with-light-sidebar .sidebar .sub-menu > li.active:after {
  border-color: #00acac;
}

.page-with-light-sidebar .slimScrollDiv .slimScrollBar {
  background: #000 !important;
}

.page-with-light-sidebar .float-sub-menu-container,
.page-with-light-sidebar.page-sidebar-minified .sidebar .nav > li.active > a {
  background: #f2f3f4;
}

.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li:before,
.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a:after,
.page-with-light-sidebar .float-sub-menu-container .float-sub-menu-arrow,
.page-with-light-sidebar .float-sub-menu-container .float-sub-menu-line {
  background: #dde0e2;
}

.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a {
  color: #6f8293;
  font-weight: 600;
}

.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li:after {
  background: #f2f3f4;
  border-color: #dde0e2;
  border-width: 2px;
}

.breadcrumb .breadcrumb-item a,
.page-with-light-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li.active
  > a,
.page-with-light-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li.expand
  > a,
.page-with-light-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li.expanding
  > a {
  color: #2d353c;
}

.page-with-right-sidebar .float-sub-menu-container .float-sub-menu-line {
  left: auto;
  right: 26px;
}

.page-with-right-sidebar .float-sub-menu-container .float-sub-menu li:after,
.page-with-right-sidebar .float-sub-menu-container .float-sub-menu-arrow,
.page-with-right-sidebar .sidebar,
.page-with-right-sidebar .sidebar-bg {
  left: auto;
  right: 0;
}

.page-with-right-sidebar .float-sub-menu-container .float-sub-menu {
  padding-left: 0;
  padding-right: 39px;
  text-align: right;
}

.page-with-right-sidebar .float-sub-menu-container .float-sub-menu li > a {
  padding-left: 15px;
  padding-right: 20px;
}

.page-with-right-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li
  > a
  .caret {
  float: left;
}

.page-with-right-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li
  > a:after {
  right: -11px;
  left: auto;
}

.page-with-right-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li.active
  > a
  .caret:before,
.page-with-right-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li.expand
  > a
  .caret:before,
.page-with-right-sidebar
  .float-sub-menu-container
  .float-sub-menu
  li.expanding
  > a
  .caret:before {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.page-with-right-sidebar .float-sub-menu-container .float-sub-menu li:before {
  right: -13px;
  left: auto;
}

.page-with-right-sidebar .float-sub-menu-container .float-sub-menu .sub-menu {
  padding-left: 0;
  padding-right: 15px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar .sidebar,
  .page-with-right-sidebar .sidebar-bg {
    right: -220px;
  }
}

.page-with-right-sidebar .content {
  margin-left: 0;
  margin-right: 220px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar .content {
    margin-right: 0;
  }
}

.page-with-right-sidebar .footer {
  margin-left: 30px;
  margin-right: 250px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar .footer {
    margin-right: 30px;
  }
}

.page-with-right-sidebar .btn-scroll-to-top {
  left: 25px;
  right: auto;
}

@media (min-width: 768px) {
  .page-with-right-sidebar .map {
    right: 220px;
    left: 0;
  }
}

.page-with-right-sidebar.page-with-wide-sidebar .content {
  margin-right: 250px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar.page-with-wide-sidebar .content {
    margin-right: 0;
  }
}

.page-with-right-sidebar.page-with-wide-sidebar .footer {
  margin-right: 280px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar.page-with-wide-sidebar .footer {
    margin-right: 20px;
  }
}

.page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified .content {
  margin-right: 60px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified
    .content {
    margin-right: 0;
  }
}

.page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified .footer {
  margin-right: 90px;
}

@media (max-width: 767.98px) {
  .page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified
    .footer {
    margin-right: 20px;
  }
}

@media (min-width: 768px) {
  .page-with-top-menu,
  .page-with-top-menu .sidebar,
  .page-with-top-menu.page-header-fixed {
    padding-top: 90px;
  }

  .page-with-two-sidebar .sidebar-right.sidebar,
  .page-with-two-sidebar .sidebar-right.sidebar-bg {
    right: 0;
    left: auto;
  }

  .page-with-two-sidebar .content {
    margin-right: 220px;
  }

  .page-with-two-sidebar .footer {
    margin-right: 250px;
  }
}

.page-with-two-sidebar.page-sidebar-minified .sidebar-right.sidebar,
.page-with-two-sidebar.page-sidebar-minified .sidebar-right.sidebar-bg {
  width: 220px;
}

.page-with-two-sidebar.page-sidebar-minified.page-with-wide-sidebar
  .sidebar-right.sidebar,
.page-with-two-sidebar.page-sidebar-minified.page-with-wide-sidebar
  .sidebar-right.sidebar-bg,
.page-with-wide-sidebar .sidebar,
.page-with-wide-sidebar .sidebar-bg {
  width: 250px;
}

@media (min-width: 768px) {
  .page-with-two-sidebar.page-with-wide-sidebar .footer {
    margin-right: 280px;
  }
}

.page-with-two-sidebar.page-sidebar-fixed .sidebar.sidebar-right {
  position: fixed;
}

.page-with-two-sidebar.page-right-sidebar-collapsed .sidebar-right.sidebar,
.page-with-two-sidebar.page-right-sidebar-collapsed .sidebar-right.sidebar-bg {
  right: -220px;
}

.page-with-two-sidebar.page-right-sidebar-collapsed .content {
  margin-right: 0;
}

.page-with-two-sidebar.page-right-sidebar-collapsed.page-with-wide-sidebar
  .sidebar-right.sidebar,
.page-with-two-sidebar.page-right-sidebar-collapsed.page-with-wide-sidebar
  .sidebar-right.sidebar-bg {
  right: -250px;
}

@media (max-width: 767.98px) {
  .page-with-wide-sidebar .sidebar,
  .page-with-wide-sidebar .sidebar-bg {
    width: 250px;
    left: -250px;
  }
}

@media (min-width: 768px) {
  .page-with-wide-sidebar .content {
    margin-left: 250px;
  }

  .page-with-wide-sidebar .footer {
    margin-left: 280px;
  }

  .page-with-wide-sidebar .map {
    left: 250px;
  }

  .page-with-wide-sidebar.page-with-right-sidebar .content {
    margin-left: 0;
    margin-right: 250px;
  }

  .page-with-wide-sidebar.page-with-right-sidebar .footer {
    margin-left: 30px;
    margin-right: 280px;
  }

  .page-with-wide-sidebar.page-with-right-sidebar .map {
    right: 250px;
    left: 0;
  }

  .page-with-wide-sidebar.page-with-two-sidebar .content {
    margin-right: 250px;
    margin-left: 250px;
  }
}

@media (max-width: 767.98px) {
  .page-with-wide-sidebar.page-with-two-sidebar.page-right-sidebar-toggled
    .sidebar,
  .page-with-wide-sidebar.page-with-two-sidebar.page-right-sidebar-toggled
    .sidebar-bg {
    left: auto;
    right: 0;
    -webkit-animation: wideSidebarSlideInRight 0.2s;
    -moz-animation: wideSidebarSlideInRight 0.2s;
    -ms-animation: wideSidebarSlideInRight 0.2s;
    -o-animation: wideSidebarSlideInRight 0.2s;
    animation: wideSidebarSlideInRight 0.2s;
  }
}

.page-with-wide-sidebar.page-sidebar-minified .sidebar,
.page-with-wide-sidebar.page-sidebar-minified .sidebar + .sidebar-bg {
  width: 60px;
}

.page-with-wide-sidebar.page-sidebar-minified .sidebar-right.sidebar,
.page-with-wide-sidebar.page-sidebar-minified .sidebar-right.sidebar-bg {
  width: 250px;
}

@media (min-width: 768px) {
  .page-with-wide-sidebar.page-sidebar-minified:not(.page-with-right-sidebar)
    .content {
    margin-left: 60px;
  }

  .page-with-wide-sidebar.page-sidebar-minified:not(.page-with-right-sidebar)
    .footer {
    margin-left: 90px;
    margin-right: 280px;
  }
}

@media (max-width: 767.98px) {
  .page-with-wide-sidebar.page-sidebar-toggled .sidebar,
  .page-with-wide-sidebar.page-sidebar-toggled .sidebar-bg {
    left: 0;
    -webkit-animation: wideSidebarSlideInLeft 0.2s;
    -moz-animation: wideSidebarSlideInLeft 0.2s;
    -ms-animation: wideSidebarSlideInLeft 0.2s;
    -o-animation: wideSidebarSlideInLeft 0.2s;
    animation: wideSidebarSlideInLeft 0.2s;
  }

  .page-with-wide-sidebar.page-sidebar-toggled.page-with-right-sidebar .sidebar,
  .page-with-wide-sidebar.page-sidebar-toggled.page-with-right-sidebar
    .sidebar-bg {
    left: auto;
    right: 0;
    -webkit-animation: wideSidebarSlideInRight 0.2s;
    -moz-animation: wideSidebarSlideInRight 0.2s;
    -ms-animation: wideSidebarSlideInRight 0.2s;
    -o-animation: wideSidebarSlideInRight 0.2s;
    animation: wideSidebarSlideInRight 0.2s;
  }
}

.page-without-sidebar .content {
  margin-left: 0;
}

.page-without-sidebar .footer {
  margin-left: 30px;
}

@media (max-width: 767.98px) {
  .page-without-sidebar .header .navbar-brand {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
}

.alert.alert-primary {
  color: #10416d;
  background-color: #cce3f8;
  border-color: #348fe2;
}

.alert.alert-primary hr {
  border-top-color: #2083dd;
}

.alert.alert-primary .alert-link {
  color: #092641;
}

.alert.alert-secondary {
  color: #25282b;
  background-color: #dadddf;
  border-color: #6c757d;
}

.alert.alert-secondary hr {
  border-top-color: #60686f;
}

.alert.alert-secondary .alert-link {
  color: #0d0f10;
}

.alert.alert-success {
  color: #001313;
  background-color: #bfeaea;
  border-color: #00acac;
}

.alert.alert-success hr {
  border-top-color: #009393;
}

.alert.alert-success .alert-link {
  color: #000;
}

.alert.alert-info {
  color: #195a6d;
  background-color: #d2edf5;
  border-color: #49b6d6;
}

.alert.alert-info hr {
  border-top-color: #34aed1;
}

.alert.alert-info .alert-link {
  color: #0f3844;
}

.alert.alert-warning {
  color: #714505;
  background-color: #fde6c6;
  border-color: #f59c1a;
}

.alert.alert-warning hr {
  border-top-color: #eb900a;
}

.alert.alert-warning .alert-link {
  color: #402703;
}

.alert.alert-danger {
  color: #bd0500;
  background-color: #ffd6d5;
  border-color: #ff5b57;
}

.alert.alert-danger hr {
  border-top-color: #ff423e;
}

.alert.alert-danger .alert-link {
  color: #8a0300;
}

.alert.alert-inverse {
  color: #000;
  background-color: #cbcdce;
  border-color: #2d353c;
}

.alert.alert-inverse hr {
  border-top-color: #22282d;
}

.alert.alert-inverse .alert-link {
  color: #000;
}

.alert.alert-grey {
  color: #627884;
  background-color: #edf0f2;
  border-color: #b6c2c9;
}

.alert.alert-grey hr {
  border-top-color: #a7b6be;
}

.alert.alert-grey .alert-link {
  color: #4c5d67;
}

.alert.alert-blue {
  color: #10416d;
  background-color: #cce3f8;
  border-color: #348fe2;
}

.alert.alert-blue hr {
  border-top-color: #2083dd;
}

.alert.alert-blue .alert-link {
  color: #092641;
}

.alert.alert-indigo {
  color: #3f1880;
  background-color: #e1d4f7;
  border-color: #8753de;
}

.alert.alert-indigo hr {
  border-top-color: #783eda;
}

.alert.alert-indigo .alert-link {
  color: #2a1055;
}

.alert.alert-purple {
  color: #31375e;
  background-color: #dcdeed;
  border-color: #727cb6;
}

.alert.alert-purple hr {
  border-top-color: #616cad;
}

.alert.alert-purple .alert-link {
  color: #1f243d;
}

.alert.alert-pink {
  color: #b3044a;
  background-color: #fed5e5;
  border-color: #fb5597;
}

.alert.alert-pink hr {
  border-top-color: #fa3c88;
}

.alert.alert-pink .alert-link {
  color: #810335;
}

.alert.alert-red {
  color: #bd0500;
  background-color: #ffd6d5;
  border-color: #ff5b57;
}

.alert.alert-red hr {
  border-top-color: #ff423e;
}

.alert.alert-red .alert-link {
  color: #8a0300;
}

.alert.alert-orange {
  color: #714505;
  background-color: #fde6c6;
  border-color: #f59c1a;
}

.alert.alert-orange hr {
  border-top-color: #eb900a;
}

.alert.alert-orange .alert-link {
  color: #402703;
}

.alert.alert-yellow {
  color: #665700;
  background-color: #fff6bf;
  border-color: #ffd900;
}

.alert.alert-yellow hr {
  border-top-color: #e6c300;
}

.alert.alert-yellow .alert-link {
  color: #332b00;
}

.alert.alert-green {
  color: #0f330f;
  background-color: #cceacc;
  border-color: #32a932;
}

.alert.alert-green hr {
  border-top-color: #2c952c;
}

.alert.alert-green .alert-link {
  color: #030c03;
}

.alert.alert-teal {
  color: #001313;
  background-color: #bfeaea;
  border-color: #00acac;
}

.alert.alert-teal hr {
  border-top-color: #009393;
}

.alert.alert-teal .alert-link {
  color: #000;
}

.alert.alert-cyan {
  color: #195a6d;
  background-color: #d2edf5;
  border-color: #49b6d6;
}

.alert.alert-cyan hr {
  border-top-color: #34aed1;
}

.alert.alert-cyan .alert-link {
  color: #0f3844;
}

.alert.alert-white {
  color: #b3b3b3;
  background-color: #fff;
  border-color: #fff;
}

.alert.alert-white hr {
  border-top-color: #f2f2f2;
}

.alert.alert-white .alert-link {
  color: #999;
}

.alert.alert-gray {
  color: #25282b;
  background-color: #dadddf;
  border-color: #6c757d;
}

.alert.alert-gray hr {
  border-top-color: #60686f;
}

.alert.alert-gray .alert-link {
  color: #0d0f10;
}

.alert.alert-gray-dark {
  color: #000;
  background-color: #cccecf;
  border-color: #343a40;
}

.alert.alert-gray-dark hr {
  border-top-color: #292d32;
}

.alert.alert-black .alert-link,
.alert.alert-dark .alert-link,
.alert.alert-dark-darker .alert-link,
.alert.alert-gray-dark .alert-link {
  color: #000;
}

.alert.alert-black {
  color: #000;
  background-color: #bfbfbf;
  border-color: #000;
}

.alert.alert-black hr {
  border-top-color: #000;
}

.alert.alert-dark {
  color: #000;
  background-color: #cbcdce;
  border-color: #2d353c;
}

.alert.alert-dark hr {
  border-top-color: #22282d;
}

.alert.alert-dark-darker {
  color: #000;
  background-color: #c6c8ca;
  border-color: #1a2229;
}

.alert.alert-dark-darker hr {
  border-top-color: #101519;
}

.alert.alert-lime {
  color: #41601c;
  background-color: #e3f2d2;
  border-color: #90ca4b;
}

.alert.alert-lime hr {
  border-top-color: #84c239;
}

.alert.alert-lime .alert-link {
  color: #263811;
}

.alert.alert-light {
  color: #9fa7ae;
  background-color: #fcfcfc;
  border-color: #f2f3f4;
}

.alert.alert-light hr {
  border-top-color: #e4e6e8;
}

.alert.alert-light .alert-link {
  color: #848d97;
}

.alert.alert-silver {
  color: #627884;
  background-color: #edf0f2;
  border-color: #b6c2c9;
}

.alert.alert-silver hr {
  border-top-color: #a7b6be;
}

.alert.alert-silver .alert-link {
  color: #4c5d67;
}

.alert.alert-muted {
  color: #21282c;
  background-color: #d8dde0;
  border-color: #627884;
}

.alert.alert-muted hr {
  border-top-color: #576a76;
}

.alert.alert-muted .alert-link {
  color: #0b0e0f;
}

.alert.alert-aqua {
  color: #195a6d;
  background-color: #d2edf5;
  border-color: #49b6d6;
}

.alert.alert-aqua hr {
  border-top-color: #34aed1;
}

.alert.alert-aqua .alert-link {
  color: #0f3844;
}

.badge {
  font-size: 75%;
  font-weight: 600;
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #777;
  -webkit-border-radius: 12px;
  border-radius: 12px;
}

.badge.badge-primary {
  background: #348fe2;
}

.badge.badge-secondary {
  background: #6c757d;
}

.badge.badge-success {
  background: #00acac;
}

.badge.badge-info {
  background: #49b6d6;
}

.badge.badge-warning {
  background: #f59c1a;
}

.badge.badge-danger {
  background: #ff5b57;
}

.badge.badge-light {
  color: #2d353c;
}

.badge.badge-inverse {
  background: #2d353c;
}

.badge.badge-grey,
.badge.badge-muted {
  background: #b6c2c9;
}

.badge.badge-blue {
  background: #348fe2;
}

.badge.badge-indigo {
  background: #8753de;
}

.badge.badge-purple {
  background: #727cb6;
}

.badge.badge-pink {
  background: #fb5597;
}

.badge.badge-red {
  background: #ff5b57;
}

.badge.badge-orange {
  background: #f59c1a;
}

.badge.badge-yellow {
  background: #ffd900;
}

.badge.badge-green {
  background: #32a932;
}

.badge.badge-teal {
  background: #00acac;
}

.badge.badge-cyan {
  background: #49b6d6;
}

.badge.badge-white {
  background: #fff;
}

.badge.badge-gray {
  background: #6c757d;
}

.badge.badge-gray-dark {
  background: #343a40;
}

.badge.badge-black {
  background: #000;
}

.badge.badge-dark {
  background: #2d353c;
}

.badge.badge-dark-darker {
  background: #1a2229;
}

.badge.badge-lime {
  background: #90ca4b;
}

.badge.badge-light {
  background: #f2f3f4;
}

.badge.badge-silver {
  background: #b6c2c9;
}

.badge.badge-muted {
  background: #627884;
}

.badge.badge-aqua {
  background: #49b6d6;
}

.badge.badge-square {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.badge.badge-default,
.inbox .nav-inbox > li.active > a {
  background: #e4e7ea;
  color: #2d353c;
}

.breadcrumb {
  padding: 0;
  margin: 0;
  background: 0 0;
}

.breadcrumb .breadcrumb-item {
  line-height: 32px;
}

.btn-scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 25px;
  z-index: 1020;
}

.btn {
  font-weight: 600;
}

.btn.btn-circle,
.btn.btn-rounded {
  -webkit-border-radius: 200px;
  border-radius: 200px;
}

.btn.btn-icon {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  line-height: 28px;
  text-align: center;
  font-size: 14px;
}

.btn.btn-icon.btn-xs {
  width: 16px;
  height: 16px;
  font-size: 8px;
  line-height: 16px;
}

.btn-group-sm > .btn.btn-icon,
.btn.btn-icon.btn-sm {
  width: 22px;
  height: 22px;
  font-size: 11px;
  line-height: 22px;
}

.btn-group-lg > .btn.btn-icon,
.btn.btn-icon.btn-lg {
  width: 34px;
  height: 34px;
  font-size: 17px;
  line-height: 34px;
}

.btn.btn-theme {
  padding: 12px 30px;
  font-weight: 700;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.btn.btn-xs {
  font-size: 12px;
  line-height: 18px;
  padding: 1px 5px;
}

.btn.btn-white.btn-white-without-border {
  border-color: #fff;
}

.btn.btn-white.btn-white-without-border:not(.active):focus,
.btn.btn-white.btn-white-without-border:not(.active):hover {
  border-color: #f2f4f5 !important;
  background: #f2f4f5 !important;
}

.btn.btn-white.btn-white-without-border.active {
  border-color: #e4e7ea !important;
}

.btn-default {
  color: #212529;
  background-color: #f1f3f4;
  border-color: #f1f3f4;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-default:hover {
  color: #212529;
  background-color: #d3dadf;
  border-color: #d3dadf;
}

.btn-default.focus,
.btn-default:focus {
  box-shadow: 0 0 0 0 rgba(209, 212, 214, 0.5);
}

.btn-default.disabled,
.btn-default:disabled {
  color: #212529;
  background-color: #f1f3f4;
  border-color: #f1f3f4;
}

.btn-default:not(:disabled):not(.disabled).active,
.btn-default:not(:disabled):not(.disabled):active,
.show > .btn-default.dropdown-toggle {
  color: #212529;
  background-color: #d3dadf;
  border-color: #d3dadf;
}

.btn-default:not(:disabled):not(.disabled).active:focus,
.btn-default:not(:disabled):not(.disabled):active:focus,
.show > .btn-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(209, 212, 214, 0.5);
}

.btn-primary {
  color: #fff;
  background-color: #348fe2;
  border-color: #348fe2;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-primary:hover {
  color: #fff;
  background-color: #1c75c7;
  border-color: #1c75c7;
}

.btn-primary.focus,
.btn-primary:focus {
  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #348fe2;
  border-color: #348fe2;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #1c75c7;
  border-color: #1c75c7;
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #545b62;
  border-color: #545b62;
}

.btn-secondary.focus,
.btn-secondary:focus {
  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #545b62;
}

.btn-secondary:not(:disabled):not(.disabled).active:focus,
.btn-secondary:not(:disabled):not(.disabled):active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);
}

.btn-success {
  color: #000;
  background-color: #f5f9fd;
  border-color: #f5f9fd;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  font-size: 15px;
  padding-top: 10px;
}

.btn-success:hover {
  color: #000;
  background-color: #f5f9fd;
  border-color: #f5f9fd;
}

.btn-success.focus,
.btn-success:focus {
  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);
}

.btn-success.disabled,
.btn-success:disabled {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
}

.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show > .btn-success.dropdown-toggle {
  color: #000;
  background-color: #f5f9fd;
  border-color: #f5f9fd;
}

.btn-success:not(:disabled):not(.disabled).active:focus,
.btn-success:not(:disabled):not(.disabled):active:focus,
.show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);
}

.btn-info {
  background-color: #49b6d6;
  border-color: #49b6d6;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  color: #fff;
}

.btn-info:hover {
  color: #fff;
  background-color: #2b9fc1;
  border-color: #2b9fc1;
}

.btn-info.focus,
.btn-info:focus {
  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);
}

.btn-info.disabled,
.btn-info:disabled {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-info:not(:disabled):not(.disabled).active,
.btn-info:not(:disabled):not(.disabled):active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #2b9fc1;
  border-color: #2b9fc1;
}

.btn-info:not(:disabled):not(.disabled).active:focus,
.btn-info:not(:disabled):not(.disabled):active:focus,
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);
}

.btn-warning {
  background-color: #f59c1a;
  border-color: #f59c1a;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  color: #fff;
}

.btn-warning:hover {
  color: #fff;
  background-color: #d38109;
  border-color: #d38109;
}

.btn-warning.focus,
.btn-warning:focus {
  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: #212529;
  background-color: #f59c1a;
  border-color: #f59c1a;
}

.btn-warning:not(:disabled):not(.disabled).active,
.btn-warning:not(:disabled):not(.disabled):active,
.show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #d38109;
  border-color: #d38109;
}

.btn-warning:not(:disabled):not(.disabled).active:focus,
.btn-warning:not(:disabled):not(.disabled):active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #ff5b57;
  border-color: #ff5b57;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-danger:hover {
  color: #fff;
  background-color: #ff2924;
  border-color: #ff2924;
}

.btn-danger.focus,
.btn-danger:focus {
  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);
}

.btn-danger.disabled,
.btn-danger:disabled {
  color: #fff;
  background-color: #ff5b57;
  border-color: #ff5b57;
}

.btn-danger:not(:disabled):not(.disabled).active,
.btn-danger:not(:disabled):not(.disabled):active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #ff2924;
  border-color: #ff2924;
}

.btn-danger:not(:disabled):not(.disabled).active:focus,
.btn-danger:not(:disabled):not(.disabled):active:focus,
.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);
}

.btn-inverse {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-inverse:hover {
  color: #fff;
  background-color: #171b1f;
  border-color: #171b1f;
}

.btn-inverse.focus,
.btn-inverse:focus {
  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);
}

.btn-inverse.disabled,
.btn-inverse:disabled {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
}

.btn-inverse:not(:disabled):not(.disabled).active,
.btn-inverse:not(:disabled):not(.disabled):active,
.show > .btn-inverse.dropdown-toggle {
  color: #fff;
  background-color: #171b1f;
  border-color: #171b1f;
}

.btn-inverse:not(:disabled):not(.disabled).active:focus,
.btn-inverse:not(:disabled):not(.disabled):active:focus,
.show > .btn-inverse.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);
}

.btn-grey {
  background-color: #b6c2c9;
  border-color: #b6c2c9;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  color: #fff;
}

.btn-grey:hover {
  color: #212529;
  background-color: #99aab3;
  border-color: #99aab3;
}

.btn-grey.focus,
.btn-grey:focus {
  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);
}

.btn-grey.disabled,
.btn-grey:disabled {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-grey:not(:disabled):not(.disabled).active,
.btn-grey:not(:disabled):not(.disabled):active,
.show > .btn-grey.dropdown-toggle {
  color: #212529;
  background-color: #99aab3;
  border-color: #99aab3;
}

.btn-grey:not(:disabled):not(.disabled).active:focus,
.btn-grey:not(:disabled):not(.disabled):active:focus,
.show > .btn-grey.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);
}

.btn-grey:focus,
.btn-grey:hover {
  color: #fff;
}

.btn-blue {
  color: #fff;
  background-color: #348fe2;
  border-color: #348fe2;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-blue:hover {
  color: #fff;
  background-color: #1c75c7;
  border-color: #1c75c7;
}

.btn-blue.focus,
.btn-blue:focus {
  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);
}

.btn-blue.disabled,
.btn-blue:disabled {
  color: #fff;
  background-color: #348fe2;
  border-color: #348fe2;
}

.btn-blue:not(:disabled):not(.disabled).active,
.btn-blue:not(:disabled):not(.disabled):active,
.show > .btn-blue.dropdown-toggle {
  color: #fff;
  background-color: #1c75c7;
  border-color: #1c75c7;
}

.btn-blue:not(:disabled):not(.disabled).active:focus,
.btn-blue:not(:disabled):not(.disabled):active:focus,
.show > .btn-blue.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);
}

.btn-indigo {
  color: #fff;
  background-color: #8753de;
  border-color: #8753de;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-indigo:hover {
  color: #fff;
  background-color: #6929d5;
  border-color: #6929d5;
}

.btn-indigo.focus,
.btn-indigo:focus {
  box-shadow: 0 0 0 0 rgba(153, 109, 227, 0.5);
}

.btn-indigo.disabled,
.btn-indigo:disabled {
  color: #fff;
  background-color: #8753de;
  border-color: #8753de;
}

.btn-indigo:not(:disabled):not(.disabled).active,
.btn-indigo:not(:disabled):not(.disabled):active,
.show > .btn-indigo.dropdown-toggle {
  color: #fff;
  background-color: #6929d5;
  border-color: #6929d5;
}

.btn-indigo:not(:disabled):not(.disabled).active:focus,
.btn-indigo:not(:disabled):not(.disabled):active:focus,
.show > .btn-indigo.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(153, 109, 227, 0.5);
}

.btn-purple {
  color: #fff;
  background-color: #727cb6;
  border-color: #727cb6;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-purple:hover {
  color: #fff;
  background-color: #545fa1;
  border-color: #545fa1;
}

.btn-purple.focus,
.btn-purple:focus {
  box-shadow: 0 0 0 0 rgba(135, 144, 193, 0.5);
}

.btn-purple.disabled,
.btn-purple:disabled {
  color: #fff;
  background-color: #727cb6;
  border-color: #727cb6;
}

.btn-purple:not(:disabled):not(.disabled).active,
.btn-purple:not(:disabled):not(.disabled):active,
.show > .btn-purple.dropdown-toggle {
  color: #fff;
  background-color: #545fa1;
  border-color: #545fa1;
}

.btn-purple:not(:disabled):not(.disabled).active:focus,
.btn-purple:not(:disabled):not(.disabled):active:focus,
.show > .btn-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(135, 144, 193, 0.5);
}

.btn-pink {
  color: #fff;
  background-color: #fb5597;
  border-color: #fb5597;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-pink:hover {
  color: #fff;
  background-color: #fa2379;
  border-color: #fa2379;
}

.btn-pink.focus,
.btn-pink:focus {
  box-shadow: 0 0 0 0 rgba(252, 111, 167, 0.5);
}

.btn-pink.disabled,
.btn-pink:disabled {
  color: #fff;
  background-color: #fb5597;
  border-color: #fb5597;
}

.btn-pink:not(:disabled):not(.disabled).active,
.btn-pink:not(:disabled):not(.disabled):active,
.show > .btn-pink.dropdown-toggle {
  color: #fff;
  background-color: #fa2379;
  border-color: #fa2379;
}

.btn-pink:not(:disabled):not(.disabled).active:focus,
.btn-pink:not(:disabled):not(.disabled):active:focus,
.show > .btn-pink.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(252, 111, 167, 0.5);
}

.btn-red {
  color: #fff;
  background-color: #ff5b57;
  border-color: #ff5b57;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-red:hover {
  color: #fff;
  background-color: #ff2924;
  border-color: #ff2924;
}

.btn-red.focus,
.btn-red:focus {
  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);
}

.btn-red.disabled,
.btn-red:disabled {
  color: #fff;
  background-color: #ff5b57;
  border-color: #ff5b57;
}

.btn-red:not(:disabled):not(.disabled).active,
.btn-red:not(:disabled):not(.disabled):active,
.show > .btn-red.dropdown-toggle {
  color: #fff;
  background-color: #ff2924;
  border-color: #ff2924;
}

.btn-red:not(:disabled):not(.disabled).active:focus,
.btn-red:not(:disabled):not(.disabled):active:focus,
.show > .btn-red.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);
}

.btn-orange {
  background-color: #f59c1a;
  border-color: #f59c1a;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  color: #fff;
}

.btn-orange:hover {
  color: #fff;
  background-color: #d38109;
  border-color: #d38109;
}

.btn-orange.focus,
.btn-orange:focus {
  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);
}

.btn-orange.disabled,
.btn-orange:disabled {
  color: #212529;
  background-color: #f59c1a;
  border-color: #f59c1a;
}

.btn-orange:not(:disabled):not(.disabled).active,
.btn-orange:not(:disabled):not(.disabled):active,
.show > .btn-orange.dropdown-toggle {
  color: #fff;
  background-color: #d38109;
  border-color: #d38109;
}

.btn-orange:not(:disabled):not(.disabled).active:focus,
.btn-orange:not(:disabled):not(.disabled):active:focus,
.show > .btn-orange.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);
}

.btn-yellow {
  color: #212529;
  background-color: #ffd900;
  border-color: #ffd900;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-yellow:hover {
  color: #212529;
  background-color: #ccae00;
  border-color: #ccae00;
}

.btn-yellow.focus,
.btn-yellow:focus {
  box-shadow: 0 0 0 0 rgba(222, 190, 6, 0.5);
}

.btn-yellow.disabled,
.btn-yellow:disabled {
  color: #212529;
  background-color: #ffd900;
  border-color: #ffd900;
}

.btn-yellow:not(:disabled):not(.disabled).active,
.btn-yellow:not(:disabled):not(.disabled):active,
.show > .btn-yellow.dropdown-toggle {
  color: #212529;
  background-color: #ccae00;
  border-color: #ccae00;
}

.btn-yellow:not(:disabled):not(.disabled).active:focus,
.btn-yellow:not(:disabled):not(.disabled):active:focus,
.show > .btn-yellow.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222, 190, 6, 0.5);
}

.btn-green {
  color: #fff;
  background-color: #32a932;
  border-color: #32a932;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-green:hover {
  color: #fff;
  background-color: #268226;
  border-color: #268226;
}

.btn-green.focus,
.btn-green:focus {
  box-shadow: 0 0 0 0 rgba(81, 182, 81, 0.5);
}

.btn-green.disabled,
.btn-green:disabled {
  color: #fff;
  background-color: #32a932;
  border-color: #32a932;
}

.btn-green:not(:disabled):not(.disabled).active,
.btn-green:not(:disabled):not(.disabled):active,
.show > .btn-green.dropdown-toggle {
  color: #fff;
  background-color: #268226;
  border-color: #268226;
}

.btn-green:not(:disabled):not(.disabled).active:focus,
.btn-green:not(:disabled):not(.disabled):active:focus,
.show > .btn-green.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(81, 182, 81, 0.5);
}

.btn-teal {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-teal:hover {
  color: #fff;
  background-color: #007979;
  border-color: #007979;
}

.btn-teal.focus,
.btn-teal:focus {
  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);
}

.btn-teal.disabled,
.btn-teal:disabled {
  color: #fff;
  background-color: #00acac;
  border-color: #00acac;
}

.btn-teal:not(:disabled):not(.disabled).active,
.btn-teal:not(:disabled):not(.disabled):active,
.show > .btn-teal.dropdown-toggle {
  color: #fff;
  background-color: #007979;
  border-color: #007979;
}

.btn-teal:not(:disabled):not(.disabled).active:focus,
.btn-teal:not(:disabled):not(.disabled):active:focus,
.show > .btn-teal.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);
}

.btn-cyan {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-cyan:hover {
  color: #fff;
  background-color: #2b9fc1;
  border-color: #2b9fc1;
}

.btn-cyan.focus,
.btn-cyan:focus {
  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);
}

.btn-cyan.disabled,
.btn-cyan:disabled {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-cyan:not(:disabled):not(.disabled).active,
.btn-cyan:not(:disabled):not(.disabled):active,
.show > .btn-cyan.dropdown-toggle {
  color: #fff;
  background-color: #2b9fc1;
  border-color: #2b9fc1;
}

.btn-cyan:not(:disabled):not(.disabled).active:focus,
.btn-cyan:not(:disabled):not(.disabled):active:focus,
.show > .btn-cyan.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);
}

.btn-white,
.btn-white:hover {
  color: #212529;
  border-color: #d5dbe0;
}

.btn-white {
  -webkit-box-shadow: 0;
  box-shadow: 0;
  background-color: #fff;
}

.btn-white:hover {
  background-color: #f2f4f5;
}

.btn-white.focus,
.btn-white:focus {
  box-shadow: 0 0 0 0 rgba(186, 191, 196, 0.5);
}

.btn-white.disabled,
.btn-white:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #d5dbe0;
}

.btn-white:not(:disabled):not(.disabled).active,
.btn-white:not(:disabled):not(.disabled):active,
.show > .btn-white.dropdown-toggle {
  color: #212529;
  background-color: #e4e7ea;
  border-color: #d5dbe0;
}

.btn-white:not(:disabled):not(.disabled).active:focus,
.btn-white:not(:disabled):not(.disabled):active:focus,
.show > .btn-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(186, 191, 196, 0.5);
}

.btn-gray {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-gray:hover {
  color: #fff;
  background-color: #545b62;
  border-color: #545b62;
}

.btn-gray.focus,
.btn-gray:focus {
  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);
}

.btn-gray.disabled,
.btn-gray:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-gray:not(:disabled):not(.disabled).active,
.btn-gray:not(:disabled):not(.disabled):active,
.show > .btn-gray.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #545b62;
}

.btn-gray:not(:disabled):not(.disabled).active:focus,
.btn-gray:not(:disabled):not(.disabled):active:focus,
.show > .btn-gray.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);
}

.btn-gray-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-gray-dark:hover {
  color: #fff;
  background-color: #1d2124;
  border-color: #1d2124;
}

.btn-gray-dark.focus,
.btn-gray-dark:focus {
  box-shadow: 0 0 0 0 rgba(82, 88, 93, 0.5);
}

.btn-gray-dark.disabled,
.btn-gray-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-gray-dark:not(:disabled):not(.disabled).active,
.btn-gray-dark:not(:disabled):not(.disabled):active,
.show > .btn-gray-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #1d2124;
}

.btn-gray-dark:not(:disabled):not(.disabled).active:focus,
.btn-gray-dark:not(:disabled):not(.disabled):active:focus,
.show > .btn-gray-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82, 88, 93, 0.5);
}

.btn-black {
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-black,
.btn-black:hover {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.btn-black.focus,
.btn-black:focus {
  box-shadow: 0 0 0 0 rgba(38, 38, 38, 0.5);
}

.btn-black.disabled,
.btn-black:disabled {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.btn-black:not(:disabled):not(.disabled).active,
.btn-black:not(:disabled):not(.disabled):active,
.show > .btn-black.dropdown-toggle {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.btn-black:not(:disabled):not(.disabled).active:focus,
.btn-black:not(:disabled):not(.disabled):active:focus,
.show > .btn-black.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(38, 38, 38, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-dark:hover {
  color: #fff;
  background-color: #171b1f;
  border-color: #171b1f;
}

.btn-dark.focus,
.btn-dark:focus {
  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);
}

.btn-dark.disabled,
.btn-dark:disabled {
  color: #fff;
  background-color: #2d353c;
  border-color: #2d353c;
}

.btn-dark:not(:disabled):not(.disabled).active,
.btn-dark:not(:disabled):not(.disabled):active,
.show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #171b1f;
  border-color: #171b1f;
}

.btn-dark:not(:disabled):not(.disabled).active:focus,
.btn-dark:not(:disabled):not(.disabled):active:focus,
.show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);
}

.btn-dark-darker {
  color: #fff;
  background-color: #1a2229;
  border-color: #1a2229;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-dark-darker:hover {
  color: #fff;
  background-color: #06080a;
  border-color: #06080a;
}

.btn-dark-darker.focus,
.btn-dark-darker:focus {
  box-shadow: 0 0 0 0 rgba(60, 67, 73, 0.5);
}

.btn-dark-darker.disabled,
.btn-dark-darker:disabled {
  color: #fff;
  background-color: #1a2229;
  border-color: #1a2229;
}

.btn-dark-darker:not(:disabled):not(.disabled).active,
.btn-dark-darker:not(:disabled):not(.disabled):active,
.show > .btn-dark-darker.dropdown-toggle {
  color: #fff;
  background-color: #06080a;
  border-color: #06080a;
}

.btn-dark-darker:not(:disabled):not(.disabled).active:focus,
.btn-dark-darker:not(:disabled):not(.disabled):active:focus,
.show > .btn-dark-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(60, 67, 73, 0.5);
}

.btn-lime {
  background-color: #90ca4b;
  border-color: #90ca4b;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  color: #fff;
}

.btn-lime:hover {
  color: #fff;
  background-color: #76af33;
  border-color: #76af33;
}

.btn-lime.focus,
.btn-lime:focus {
  box-shadow: 0 0 0 0 rgba(127, 177, 70, 0.5);
}

.btn-lime.disabled,
.btn-lime:disabled {
  color: #212529;
  background-color: #90ca4b;
  border-color: #90ca4b;
}

.btn-lime:not(:disabled):not(.disabled).active,
.btn-lime:not(:disabled):not(.disabled):active,
.show > .btn-lime.dropdown-toggle {
  color: #fff;
  background-color: #76af33;
  border-color: #76af33;
}

.btn-lime:not(:disabled):not(.disabled).active:focus,
.btn-lime:not(:disabled):not(.disabled):active:focus,
.show > .btn-lime.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(127, 177, 70, 0.5);
}

.btn-lime:focus,
.btn-lime:hover {
  color: #fff;
}

.btn-light {
  color: #212529;
  background-color: #f2f3f4;
  border-color: #f2f3f4;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-light:hover {
  color: #212529;
  background-color: #d6dadd;
  border-color: #d6dadd;
}

.btn-light.focus,
.btn-light:focus {
  box-shadow: 0 0 0 0 rgba(211, 212, 214, 0.5);
}

.btn-light.disabled,
.btn-light:disabled {
  color: #212529;
  background-color: #f2f3f4;
  border-color: #f2f3f4;
}

.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):active,
.show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #d6dadd;
  border-color: #d6dadd;
}

.btn-light:not(:disabled):not(.disabled).active:focus,
.btn-light:not(:disabled):not(.disabled):active:focus,
.show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(211, 212, 214, 0.5);
}

.btn-silver {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-silver:hover {
  color: #212529;
  background-color: #99aab3;
  border-color: #99aab3;
}

.btn-silver.focus,
.btn-silver:focus {
  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);
}

.btn-silver.disabled,
.btn-silver:disabled {
  color: #212529;
  background-color: #b6c2c9;
  border-color: #b6c2c9;
}

.btn-silver:not(:disabled):not(.disabled).active,
.btn-silver:not(:disabled):not(.disabled):active,
.show > .btn-silver.dropdown-toggle {
  color: #212529;
  background-color: #99aab3;
  border-color: #99aab3;
}

.btn-silver:not(:disabled):not(.disabled).active:focus,
.btn-silver:not(:disabled):not(.disabled):active:focus,
.show > .btn-silver.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);
}

.btn-muted {
  color: #fff;
  background-color: #627884;
  border-color: #627884;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}

.btn-muted:hover {
  color: #fff;
  background-color: #4c5d67;
  border-color: #4c5d67;
}

.btn-muted.focus,
.btn-muted:focus {
  box-shadow: 0 0 0 0 rgba(121, 140, 151, 0.5);
}

.btn-muted.disabled,
.btn-muted:disabled {
  color: #fff;
  background-color: #627884;
  border-color: #627884;
}

.btn-muted:not(:disabled):not(.disabled).active,
.btn-muted:not(:disabled):not(.disabled):active,
.show > .btn-muted.dropdown-toggle {
  color: #fff;
  background-color: #4c5d67;
  border-color: #4c5d67;
}

.btn-muted:not(:disabled):not(.disabled).active:focus,
.btn-muted:not(:disabled):not(.disabled):active:focus,
.show > .btn-muted.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(121, 140, 151, 0.5);
}

.btn-aqua {
  background-color: #49b6d6;
  border-color: #49b6d6;
  -webkit-box-shadow: 0;
  box-shadow: 0;
  color: #fff;
}

.btn-aqua:hover {
  color: #fff;
  background-color: #2b9fc1;
  border-color: #2b9fc1;
}

.btn-aqua.focus,
.btn-aqua:focus {
  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);
}

.btn-aqua.disabled,
.btn-aqua:disabled {
  color: #212529;
  background-color: #49b6d6;
  border-color: #49b6d6;
}

.btn-aqua:not(:disabled):not(.disabled).active,
.btn-aqua:not(:disabled):not(.disabled):active,
.show > .btn-aqua.dropdown-toggle {
  color: #fff;
  background-color: #2b9fc1;
  border-color: #2b9fc1;
}

.btn-aqua:not(:disabled):not(.disabled).active:focus,
.btn-aqua:not(:disabled):not(.disabled):active:focus,
.show > .btn-aqua.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);
}

.btn-group .btn-default + .btn-default,
.input-group-append .btn-default + .btn-default,
.input-group-prepend .btn-default + .btn-default {
  border-left-color: #d3dadf;
}

.btn-group .btn-primary + .btn-primary,
.input-group-append .btn-primary + .btn-primary,
.input-group-prepend .btn-primary + .btn-primary {
  border-left-color: #1c75c7;
}

.btn-group .btn-secondary + .btn-secondary,
.input-group-append .btn-secondary + .btn-secondary,
.input-group-prepend .btn-secondary + .btn-secondary {
  border-left-color: #545b62;
}

.btn-group .btn-success + .btn-success,
.input-group-append .btn-success + .btn-success,
.input-group-prepend .btn-success + .btn-success {
  border-left-color: #007979;
}

.btn-group .btn-info + .btn-info,
.input-group-append .btn-info + .btn-info,
.input-group-prepend .btn-info + .btn-info {
  border-left-color: #2b9fc1;
}

.btn-group .btn-warning + .btn-warning,
.input-group-append .btn-warning + .btn-warning,
.input-group-prepend .btn-warning + .btn-warning {
  border-left-color: #d38109;
}

.btn-group .btn-danger + .btn-danger,
.input-group-append .btn-danger + .btn-danger,
.input-group-prepend .btn-danger + .btn-danger {
  border-left-color: #ff2924;
}

.btn-group .btn-inverse + .btn-inverse,
.input-group-append .btn-inverse + .btn-inverse,
.input-group-prepend .btn-inverse + .btn-inverse {
  border-left-color: #171b1f;
}

.btn-group .btn-grey + .btn-grey,
.input-group-append .btn-grey + .btn-grey,
.input-group-prepend .btn-grey + .btn-grey {
  border-left-color: #99aab3;
}

.btn-group .btn-blue + .btn-blue,
.input-group-append .btn-blue + .btn-blue,
.input-group-prepend .btn-blue + .btn-blue {
  border-left-color: #1c75c7;
}

.btn-group .btn-indigo + .btn-indigo,
.input-group-append .btn-indigo + .btn-indigo,
.input-group-prepend .btn-indigo + .btn-indigo {
  border-left-color: #6929d5;
}

.btn-group .btn-purple + .btn-purple,
.input-group-append .btn-purple + .btn-purple,
.input-group-prepend .btn-purple + .btn-purple {
  border-left-color: #545fa1;
}

.btn-group .btn-pink + .btn-pink,
.input-group-append .btn-pink + .btn-pink,
.input-group-prepend .btn-pink + .btn-pink {
  border-left-color: #fa2379;
}

.btn-group .btn-red + .btn-red,
.input-group-append .btn-red + .btn-red,
.input-group-prepend .btn-red + .btn-red {
  border-left-color: #ff2924;
}

.btn-group .btn-orange + .btn-orange,
.input-group-append .btn-orange + .btn-orange,
.input-group-prepend .btn-orange + .btn-orange {
  border-left-color: #d38109;
}

.btn-group .btn-yellow + .btn-yellow,
.input-group-append .btn-yellow + .btn-yellow,
.input-group-prepend .btn-yellow + .btn-yellow {
  border-left-color: #ccae00;
}

.btn-group .btn-green + .btn-green,
.input-group-append .btn-green + .btn-green,
.input-group-prepend .btn-green + .btn-green {
  border-left-color: #268226;
}

.btn-group .btn-teal + .btn-teal,
.input-group-append .btn-teal + .btn-teal,
.input-group-prepend .btn-teal + .btn-teal {
  border-left-color: #007979;
}

.btn-group .btn-cyan + .btn-cyan,
.input-group-append .btn-cyan + .btn-cyan,
.input-group-prepend .btn-cyan + .btn-cyan {
  border-left-color: #2b9fc1;
}

.btn-group .btn-white + .btn-white,
.input-group-append .btn-white + .btn-white,
.input-group-prepend .btn-white + .btn-white {
  border-left-color: #d5dbe0;
}

.btn-group .btn-gray + .btn-gray,
.input-group-append .btn-gray + .btn-gray,
.input-group-prepend .btn-gray + .btn-gray {
  border-left-color: #545b62;
}

.btn-group .btn-gray-dark + .btn-gray-dark,
.input-group-append .btn-gray-dark + .btn-gray-dark,
.input-group-prepend .btn-gray-dark + .btn-gray-dark {
  border-left-color: #1d2124;
}

.btn-group .btn-black + .btn-black,
.input-group-append .btn-black + .btn-black,
.input-group-prepend .btn-black + .btn-black {
  border-left-color: #000;
}

.btn-group .btn-dark + .btn-dark,
.input-group-append .btn-dark + .btn-dark,
.input-group-prepend .btn-dark + .btn-dark {
  border-left-color: #171b1f;
}

.btn-group .btn-dark-darker + .btn-dark-darker,
.input-group-append .btn-dark-darker + .btn-dark-darker,
.input-group-prepend .btn-dark-darker + .btn-dark-darker {
  border-left-color: #06080a;
}

.btn-group .btn-lime + .btn-lime,
.input-group-append .btn-lime + .btn-lime,
.input-group-prepend .btn-lime + .btn-lime {
  border-left-color: #76af33;
}

.btn-group .btn-light + .btn-light,
.input-group-append .btn-light + .btn-light,
.input-group-prepend .btn-light + .btn-light {
  border-left-color: #d6dadd;
}

.btn-group .btn-silver + .btn-silver,
.input-group-append .btn-silver + .btn-silver,
.input-group-prepend .btn-silver + .btn-silver {
  border-left-color: #99aab3;
}

.btn-group .btn-muted + .btn-muted,
.input-group-append .btn-muted + .btn-muted,
.input-group-prepend .btn-muted + .btn-muted {
  border-left-color: #4c5d67;
}

.btn-group .btn-aqua + .btn-aqua,
.input-group-append .btn-aqua + .btn-aqua,
.input-group-prepend .btn-aqua + .btn-aqua {
  border-left-color: #2b9fc1;
}

.btn-group > .btn-group:not(:first-child),
.btn-group > .btn:not(:first-child) {
  margin-left: 0;
  margin-right: -1px;
}

.card .card-header .card-header-tabs {
  margin-top: -5px;
}

.card .card-header .card-header-pills {
  margin-top: -8px;
  margin-bottom: -8px;
}

.card > .widget-list .widget-list-item {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.carousel .carousel-control .fa {
  position: absolute;
  top: 50%;
  display: block;
  width: 30px;
  height: 30px;
  margin-top: -15px;
  text-align: center;
  line-height: 30px;
  margin-left: -15px;
  z-index: 5;
}

.carousel .carousel-control.left .fa {
  margin-left: 15px;
}

.chats {
  list-style-type: none;
  margin: 0;
  padding: 12px 15px 15px;
}

.chats > div + div,
.chats > li + li {
  margin-top: 15px;
}

.chats .name {
  color: #2d353c;
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  text-decoration: none;
}

.chats .name .label {
  font-size: 8px;
  padding: 1px 4px 2px;
  margin-left: 3px;
  position: relative;
  top: -1px;
}

.chats .date-time {
  font-size: 10px;
  display: block;
  float: right;
  color: #6f8293;
  margin-top: 3px;
  font-weight: 600;
}

.chats .image {
  float: left;
  width: 60px;
  height: 60px;
  overflow: hidden;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.chats .image img,
.inbox .attached-document > li img {
  max-width: 100%;
}

.chats .image + .message {
  margin-left: 75px;
}

.chats .message {
  padding: 7px 12px;
  font-size: 12px;
  position: relative;
  background: #fff;
  -webkit-border-radius: 12px;
  border-radius: 12px;
}

.chats .message:before {
  content: "";
  position: absolute;
  left: -13px;
  top: 15px;
  border: 7px solid transparent;
  border-right-color: #fff;
}

.chats .right .name {
  text-align: right;
}

.chats .right .date-time {
  float: left;
}

.chats .right .image {
  float: right;
}

.chats .right .image + .message {
  margin-left: 0;
  margin-right: 75px;
}

.chats .right .message {
  text-align: right;
}

.chats .right .message:before {
  left: auto;
  right: -13px;
  border-right-color: transparent;
  border-left-color: #fff;
}

.panel-body .chats,
body .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td,
body .datetimepicker.dropdown-menu .datetimepicker-hours table tbody tr td,
body .datetimepicker.dropdown-menu .datetimepicker-minutes table tbody tr td,
body .datetimepicker.dropdown-menu .datetimepicker-months table tbody tr td,
body .datetimepicker.dropdown-menu .datetimepicker-years table tbody tr td {
  padding: 0;
}

.slimScrollDiv .chats {
  padding-right: 15px;
}

.has-success .checkbox.checkbox-css label,
.has-success.checkbox.checkbox-css label,
.is-valid .checkbox.checkbox-css label,
.is-valid.checkbox.checkbox-css label {
  color: #009393;
}

.has-success .checkbox.checkbox-css label:before,
.has-success.checkbox.checkbox-css label:before,
.is-valid .checkbox.checkbox-css label:before,
.is-valid.checkbox.checkbox-css label:before {
  background: rgba(0, 172, 172, 0.5);
}

.has-error .checkbox.checkbox-css label,
.has-error.checkbox.checkbox-css label,
.is-invalid .checkbox.checkbox-css label,
.is-invalid.checkbox.checkbox-css label {
  color: #ff423e;
}

.has-error .checkbox.checkbox-css label:before,
.has-error.checkbox.checkbox-css label:before,
.is-invalid .checkbox.checkbox-css label:before,
.is-invalid.checkbox.checkbox-css label:before {
  background: rgba(255, 91, 87, 0.5);
}

.checkbox.checkbox-css {
  line-height: 16px;
  padding-top: 7px;
}

.checkbox.checkbox-css label {
  padding-left: 24px;
  margin: 0;
  position: relative;
}

.checkbox.checkbox-css label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  background: #d5dbe0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.checkbox.checkbox-css input:checked + label:before {
  background: #348fe2;
  border-color: #348fe2;
}

.checkbox.checkbox-css input:checked + label:after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  height: 16px;
  width: 16px;
  text-align: center;
}

.checkbox.checkbox-css.checkbox-inline {
  padding-left: 0;
  display: inline-block;
}

.checkbox.checkbox-css.checkbox-inline + .checkbox-inline {
  margin-left: 15px;
}

.checkbox.checkbox-css.checkbox-success input:checked + label:before {
  background: #00acac;
  border-color: #00acac;
}

.checkbox.checkbox-css.checkbox-lime input:checked + label:before {
  background: #90ca4b;
  border-color: #90ca4b;
}

.checkbox.checkbox-css.checkbox-indigo input:checked + label:before {
  background: #8753de;
  border-color: #8753de;
}

.checkbox.checkbox-css.checkbox-purple input:checked + label:before {
  background: #727cb6;
  border-color: #727cb6;
}

.checkbox.checkbox-css.checkbox-inverse input:checked + label:before {
  background: #2d353c;
  border-color: #2d353c;
}

.checkbox.checkbox-css.checkbox-warning input:checked + label:before {
  background: #f59c1a;
  border-color: #f59c1a;
}

.checkbox.checkbox-css.checkbox-danger input:checked + label:before {
  background: #ff5b57;
  border-color: #ff5b57;
}

.checkbox.checkbox-css.checkbox-info input:checked + label:before {
  background: #49b6d6;
  border-color: #49b6d6;
}

.checkbox.checkbox-css.checkbox-pink input:checked + label:before {
  background: #fb5597;
  border-color: #fb5597;
}

.checkbox.checkbox-css.checkbox-yellow input:checked + label:before {
  background: #ffd900;
  border-color: #ffd900;
}

.close {
  margin-left: 15px;
  text-shadow: none;
  line-height: 14px;
}

.inverse-mode code,
code.inverse-mode {
  background: #2d353c;
  color: #fda0c5;
}

.coming-soon .brand {
  line-height: 40px;
  font-size: 28px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #fff;
  text-align: center;
}

.coming-soon .brand .logo {
  border: 25px solid transparent;
  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);
  background: #00acac;
  position: relative;
  width: 0;
  height: 0;
  display: block;
  margin: 0 auto 15px;
  vertical-align: middle;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

@media (max-width: 991.98px) {
  .coming-soon .brand .logo {
    border-width: 20px;
  }
}

.coming-soon .coming-soon-header {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 50px 50px;
  position: relative;
}

@media (max-width: 991.98px) {
  .coming-soon .coming-soon-header {
    padding: 50px 25px 25px;
  }
}

.coming-soon .coming-soon-header .desc {
  position: relative;
  z-index: 10;
  text-align: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.5px;
  margin-bottom: 50px;
}

@media (max-width: 991.98px) {
  .coming-soon .coming-soon-header .desc {
    font-size: 12px;
    letter-spacing: 0.25px;
    margin-bottom: 15px;
  }
}

.coming-soon .coming-soon-header .timer {
  position: relative;
  z-index: 10;
  margin-bottom: 0;
  padding: 10px 0;
}

.coming-soon .coming-soon-header .timer:after,
.coming-soon .coming-soon-header .timer:before,
.inbox .list-email > li.list-group-item:after,
.inbox .list-email > li.list-group-item:before,
.pager:after,
.pager:before,
.panel .panel-body:after,
.panel .panel-body:before,
.profile-content:after,
.profile-content:before,
.result-list:after,
.result-list:before {
  content: "";
  display: table;
  clear: both;
}

.coming-soon .coming-soon-header .timer .is-countdown {
  background: 0 0;
  border: 0;
  margin: 0 auto;
  width: 720px;
}

@media (max-width: 991.98px) {
  .coming-soon .coming-soon-header .timer .is-countdown {
    width: 520px;
  }
}

@media (max-width: 767.98px) {
  .coming-soon .coming-soon-header .timer .is-countdown {
    width: 480px;
  }
}

@media (max-width: 575.98px) {
  .coming-soon .coming-soon-header .timer .is-countdown {
    width: auto;
  }
}

.coming-soon .coming-soon-header .timer .is-countdown .countdown-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.coming-soon .coming-soon-header .timer .is-countdown .countdown-section {
  padding: 0 10px;
  float: none;
}

.coming-soon
  .coming-soon-header
  .timer
  .is-countdown
  .countdown-section
  + .countdown-section {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.coming-soon
  .coming-soon-header
  .timer
  .is-countdown
  .countdown-section
  .countdown-amount {
  font-size: 36px;
  color: #fff;
}

@media (max-width: 991.98px) {
  .coming-soon
    .coming-soon-header
    .timer
    .is-countdown
    .countdown-section
    .countdown-amount {
    font-size: 24px;
  }
}

.coming-soon
  .coming-soon-header
  .timer
  .is-countdown
  .countdown-section
  .countdown-period {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

@media (max-width: 991.98px) {
  .coming-soon
    .coming-soon-header
    .timer
    .is-countdown
    .countdown-section
    .countdown-period {
    font-size: 12px;
  }
}

.coming-soon .coming-soon-header .brand {
  position: relative;
  z-index: 10;
}

.coming-soon .coming-soon-header .bg-cover {
  background: -moz-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.75) 100%
  );
  background: -webkit-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.75) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.75) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#bf000000', GradientType=0);
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
}

.coming-soon .coming-soon-content {
  color: #2d353c;
  text-align: center;
  padding: 25px;
}

.coming-soon .coming-soon-content .desc {
  margin-bottom: 25px;
  font-size: 13px;
}

.coming-soon .coming-soon-content .input-group {
  width: 480px;
  margin: 0 auto 10px;
}

@media (max-width: 991.98px) {
  .coming-soon .coming-soon-content .input-group {
    width: 360px;
  }
}

@media (max-width: 767.98px) {
  .coming-soon .coming-soon-content .input-group {
    width: 300px;
  }
}

@media (max-width: 575.98px) {
  .coming-soon .coming-soon-content .input-group {
    width: auto;
  }
}

.dropdown-menu {
  font-size: 12px;
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}

.dropdown-item {
  padding: 5px 15px;
  font-weight: 600;
  color: #4e5c68;
  text-decoration: none;
}

.dropdown-item:focus,
.dropdown-item:hover {
  color: #2d353c;
  background: #f2f4f5;
}

.error,
.error .error-code {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.error {
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.error .error-code,
.error .error-content {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

.error .error-code {
  color: #2d353c;
  font-size: 200px;
  line-height: 1;
  text-shadow: 10px 10px 0 rgba(45, 53, 60, 0.2);
  padding: 30px;
  -ms-flex-align: flex-end;
  align-items: flex-end;
}

@media (max-width: 767.98px) {
  .error .error-code {
    font-size: 160px;
  }
}

@media (max-width: 575.98px) {
  .error .error-code {
    font-size: 120px;
  }
}

.error .error-content {
  top: 50%;
  bottom: 0;
  padding: 30px;
  background: #2d353c;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.error .error-message {
  color: #fff;
  font-size: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}

.error .error-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.5px;
}

.form-horizontal.form-bordered .form-group {
  border-bottom: 1px solid #e4e7ea;
  margin: 0;
}

.form-horizontal.form-bordered .form-group .col-form-label {
  padding: 15px;
  font-weight: 600;
  color: #4e5c68;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 991.98px) {
  .form-horizontal.form-bordered .form-group .col-form-label {
    padding-bottom: 8px;
  }
}

.form-horizontal.form-bordered .form-group .col-form-label + div {
  border-left: 1px solid #e4e7ea;
}

@media (max-width: 991.98px) {
  .form-horizontal.form-bordered .form-group .col-form-label + div {
    border-left: none;
    padding-top: 0;
  }
}

.form-horizontal.form-bordered .form-group > div {
  padding: 15px;
}

.form-horizontal.form-bordered .form-group:last-child {
  border-bottom: 0;
}

.gallery {
  margin: -5px;
}

.gallery .image {
  width: 25%;
  display: block;
  overflow: hidden;
  padding: 5px;
}

@media (max-width: 1199.98px) {
  .gallery .image {
    width: 33.33%;
  }
}

@media (max-width: 991.98px) {
  .gallery .image {
    width: 50%;
  }
}

@media (max-width: 575.98px) {
  .gallery .image {
    width: 100%;
  }
}

.gallery .image a {
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.gallery .image a:focus,
.gallery .image a:hover {
  opacity: 0.8;
}

.gallery .image .img,
.gallery .image img {
  width: 100%;
  height: 200px;
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.gallery .image .img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.gallery .image .image-inner {
  position: relative;
  background: #fff;
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.gallery .image .image-caption {
  position: absolute;
  top: 15px;
  left: 0;
  background: rgba(26, 34, 41, 0.75);
  color: #fff;
  font-weight: 600;
  padding: 5px 15px;
  margin: 0;
}

.gallery .image .image-info {
  background: #fff;
  padding: 15px;
  color: #4e5c68;
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.gallery .image .image-info .title {
  margin: 0 0 10px;
  line-height: 20px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #2d353c;
}

.gallery .image .image-info .rating {
  line-height: 20px;
  margin: 0 0 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.gallery .image .image-info .rating span.star {
  margin-right: 1px;
}

.gallery .image .image-info .rating span.star:before {
  content: "\\f005";
  color: #d5dbe0;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.gallery .image .image-info .rating span.star.active:before {
  color: #f59c1a;
}

.gallery .image .image-info .desc {
  line-height: 17px;
  font-size: 12px;
  height: 51px;
  overflow: hidden;
}

.gallery-option-set {
  display: block;
  margin-bottom: -5px;
}

.gallery-option-set .btn,
.inbox .email-content .wysihtml5-toolbar > li {
  margin: 0 5px 5px 0;
}

.inbox .nav-title {
  font-size: 11px;
  color: #9ba8b4;
  padding: 15px 15px 7px;
}

.inbox .nav-inbox {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: block;
}

.inbox .nav-inbox > li + li {
  margin-top: 0;
}

.inbox .nav-inbox > li > a {
  display: block;
  text-decoration: none;
  border-radius: 0;
  padding: 8px 20px;
  color: #2d353c;
  font-weight: 600;
}

.inbox .nav-inbox > li > a i {
  width: 20px;
}

.inbox .nav-inbox > li > a .badge {
  background: #6f8293;
  color: #fff;
  padding: 4px 8px;
  font-size: 10px;
  line-height: 11px;
}

.inbox .float-right-link {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.inbox .email-to {
  position: relative;
}

.inbox .email-to .form-control,
.inbox .email-to .tagit {
  border: 0 !important;
  border-bottom: 1px solid #d5dbe0 !important;
  padding: 10px 12px 10px 45px !important;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.inbox .email-to .tagit input {
  font-weight: 500;
}

.inbox .email-to .control-label {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  line-height: 16px;
  padding-left: 10px;
  width: 45px;
  margin-bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.inbox .email-subject .form-control {
  border: 0 !important;
  border-bottom: 1px solid #d5dbe0 !important;
  padding: 10px 12px !important;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.inbox .email-subject .form-control:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.inbox .email-content {
  padding: 0;
  margin: 0;
}

.inbox .email-content .wysihtml5-toolbar {
  padding: 10px 0 0;
}

.inbox .email-content .wysihtml5-toolbar .btn {
  font-size: 12px;
  margin-bottom: 5px;
}

.inbox .email-content .wysihtml5-toolbar .btn-group {
  margin-bottom: 5px;
}

.inbox .email-content .wysihtml5-toolbar .btn-group .btn {
  margin-bottom: 0;
}

.inbox .email-content .wysihtml5-sandbox {
  padding: 15px !important;
  border: 1px solid #d5dbe0 !important;
  -webkit-border-radius: 0 !important;
  border-radius: 0 !important;
}

.inbox .attached-document {
  list-style-type: none;
  margin: 15px 0 0;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.inbox .attached-document > li {
  width: 180px;
  background: #fff;
  color: #2d353c;
  font-weight: 600;
  position: relative;
  margin-right: 15px;
  margin-bottom: 15px;
  border: 1px solid #d5dbe0;
}

.inbox .attached-document > li:before {
  position: absolute;
  top: -1px;
  right: -1px;
  font-size: 12px;
  background: #d5dbe0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.inbox .attached-document > li .document-name {
  padding: 5px 10px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #f2f3f4;
  border-top: 1px solid #d5dbe0;
}

.inbox .attached-document > li .document-name a {
  color: #2d353c;
}

.inbox .attached-document > li .document-file {
  height: 70px;
  background: 0 0;
  overflow: hidden;
  text-align: center;
  line-height: 70px;
  font-size: 32px;
  margin: -1px;
}

.inbox .list-email {
  border-bottom: 1px solid #e4e7ea;
  margin: -1px 0;
}

.inbox .list-email > li.list-group-item {
  border: 0;
  margin-bottom: 0;
  padding: 15px;
  position: relative;
  width: 100%;
  overflow: hidden;
  -webkit-border-radius: 0;
  border-radius: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.inbox .list-email,
.inbox .list-email > li.list-group-item + li.list-group-item {
  border-top: 1px solid #e4e7ea;
}

.inbox .list-email > li.list-group-item a {
  color: #2d353c;
  text-decoration: none;
}

.inbox .list-email > li.list-group-item .email-info {
  max-width: calc(100% - 46px);
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.inbox .list-email > li.list-group-item .email-info > a {
  margin-top: -15px;
  margin-right: -15px;
  margin-bottom: -15px;
  padding: 15px;
  max-width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (max-width: 767.98px) {
  .inbox .list-email > li.list-group-item .email-info > a {
    display: block;
  }
}

.inbox .list-email > li.list-group-item .email-user {
  width: 30px;
  height: 30px;
  min-width: 30px;
  overflow: hidden;
  font-size: 18px;
  line-height: 30px;
  text-align: center;
  color: #6f8293;
  background: #c6ced5;
  margin: -5px 0;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

.inbox .list-email > li.list-group-item .email-user img,
.timeline img {
  max-width: 100%;
  display: block;
}

.inbox .list-email > li.list-group-item .email-sender {
  display: block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1199.98px) {
  .inbox .list-email > li.list-group-item .email-sender {
    width: 160px;
  }
}

@media (max-width: 991.98px) {
  .inbox .list-email > li.list-group-item .email-sender {
    width: 120px;
  }
}

@media (max-width: 767.98px) {
  .inbox .list-email > li.list-group-item .email-sender {
    width: auto;
    font-size: 14px;
    padding-right: 90px;
  }
}

.inbox .list-email > li.list-group-item .email-title {
  display: block;
  line-height: 20px;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 768px) {
  .inbox .list-email > li.list-group-item .email-title {
    padding-left: 15px;
  }
}

@media (max-width: 1199.98px) {
  .inbox .list-email > li.list-group-item .email-title {
    width: auto;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
}

@media (min-width: 768px) {
  .inbox .list-email > li.list-group-item .email-title + .email-desc {
    padding-left: 20px;
  }

  .inbox .list-email > li.list-group-item .email-title + .email-desc:before {
    content: "";
    position: absolute;
    left: 6px;
    top: 8px;
    width: 4px;
    height: 4px;
    background: #9ba8b4;
    -webkit-border-radius: 6px;
    border-radius: 6px;
  }
}

.inbox .list-email > li.list-group-item .email-desc {
  display: block;
  position: relative;
  color: #4e5c68;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

@media (max-width: 1199.98px) {
  .inbox .list-email > li.list-group-item .email-desc {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .inbox .list-email > li.list-group-item .email-desc {
    display: block;
    padding-right: 0;
  }
}

.inbox .list-email > li.list-group-item .email-time,
.input-group-addon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.inbox .list-email > li.list-group-item .email-time {
  display: block;
  width: 100px;
  position: absolute;
  right: 0;
  top: 15px;
  height: 20px;
  background: #fff;
  -webkit-box-pack: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  padding: 0 15px 0 0;
  font-size: 11px;
  font-weight: 500;
  color: #6f8293;
  text-align: right;
}

@media (max-width: 1199.98px) {
  .inbox .list-email > li.list-group-item .email-time {
    width: 90px;
  }
}

.inbox .list-email > li.list-group-item .email-checkbox .custom-checkbox {
  width: 16px;
  padding-left: 16px;
}

.inbox
  .list-email
  > li.list-group-item
  .email-checkbox
  .custom-checkbox
  .custom-control-label::after,
.inbox
  .list-email
  > li.list-group-item
  .email-checkbox
  .custom-checkbox
  .custom-control-label::before {
  left: -16px;
}

.inbox .list-email > li.list-group-item .email-checkbox + .email-user {
  margin-left: 15px;
}

.inbox .list-email > li.list-group-item.unread .email-title {
  font-weight: 600;
  color: #2d353c;
}

.inbox .list-email > li.list-group-item.unread .email-sender {
  font-weight: 600;
}

.inbox .list-email > li.list-group-item.selected,
.inbox .list-email > li.list-group-item.selected .email-time {
  background: #fffceb;
}

.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  color: #2d353c;
  text-align: center;
  background: #d5dbe0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.input-group-addon:focus,
body table.dataTable thead tr th:focus {
  outline: 0;
}

.form-control + .input-group-addon {
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-prepend .input-group-addon {
  -webkit-border-top-right-radius: 0;
  border-top-right-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  border-bottom-right-radius: 0;
}

.invoice {
  background: #fff;
  padding: 20px;
}

.invoice > div:not(.invoice-footer) {
  margin-bottom: 20px;
}

.invoice .invoice-company {
  font-size: 20px;
  font-weight: 600;
}

.invoice .invoice-header {
  margin: 0 -20px;
  background: #f2f3f4;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 991.98px) {
  .invoice .invoice-header {
    display: block;
  }

  .invoice .invoice-header > div + div {
    border-top: 1px solid #e6e7e8;
  }
}

.invoice .invoice-date,
.invoice .invoice-from,
.invoice .invoice-to {
  padding: 20px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.invoice .invoice-date .date,
.invoice .invoice-from strong,
.invoice .invoice-to strong,
.label {
  font-size: 16px;
  font-weight: 600;
}

.invoice .invoice-date {
  text-align: right;
}

@media (max-width: 991.98px) {
  .invoice .invoice-date {
    text-align: left;
  }
}

.invoice .invoice-price {
  background: #f2f3f4;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 575.98px) {
  .invoice .invoice-price {
    display: block;
  }
}

.invoice .invoice-price small {
  font-size: 12px;
  font-weight: 400;
  display: block;
}

.invoice .invoice-price .invoice-price-right {
  margin-left: auto;
  padding: 20px;
  font-size: 28px;
  font-weight: 300;
  position: relative;
  vertical-align: bottom;
  text-align: right;
  color: #fff;
  background: #2d353c;
  min-width: 25%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  -ms-flex-align: center;
  align-items: center;
}

.invoice .invoice-price .invoice-price-right small {
  display: block;
  opacity: 0.6;
  position: absolute;
  top: 15px;
  left: 20px;
  font-size: 12px;
}

.invoice .invoice-price .invoice-price-left {
  padding: 20px;
  font-size: 20px;
  font-weight: 600;
  position: relative;
  vertical-align: middle;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.invoice .invoice-price .invoice-price-left .invoice-price-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 575.98px) {
  .invoice .invoice-price .invoice-price-left .invoice-price-row {
    display: block;
    text-align: center;
  }
}

.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
  padding: 0 20px;
}

@media (max-width: 991.98px) {
  .invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
    padding: 0;
  }

  .invoice
    .invoice-price
    .invoice-price-left
    .invoice-price-row
    .sub-price
    + .sub-price {
    padding-left: 20px;
  }
}

@media (max-width: 575.98px) {
  .invoice
    .invoice-price
    .invoice-price-left
    .invoice-price-row
    .sub-price
    + .sub-price {
    padding-left: 0;
  }
}

.invoice .invoice-footer {
  border-top: 1px solid #d5dbe0;
  padding-top: 15px;
  font-size: 11px;
  color: #4e5c68;
}

.invoice .invoice-note {
  color: #4e5c68;
  margin-top: 80px;
  font-size: 11px;
  line-height: 1.75;
}

.invoice .table-invoice {
  font-size: 13px;
}

@media (max-width: 991.98px) {
  .invoice .table-invoice {
    white-space: nowrap;
  }
}

.label {
  display: inline;
  padding: 3px 6px 4px;
  font-size: 75%;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.label.label-primary {
  background: #348fe2;
}

.label.label-secondary {
  background: #6c757d;
}

.label.label-success {
  background: #00acac;
}

.label.label-info {
  background: #49b6d6;
}

.label.label-warning {
  background: #f59c1a;
}

.label.label-danger {
  background: #ff5b57;
}

.label.label-light {
  background: #fff;
  color: #2d353c;
}

.label.label-inverse {
  background: #2d353c;
}

.label.label-grey,
.label.label-muted {
  background: #b6c2c9;
}

.label.label-blue {
  background: #348fe2;
}

.label.label-indigo {
  background: #8753de;
}

.label.label-purple {
  background: #727cb6;
}

.label.label-pink {
  background: #fb5597;
}

.label.label-red {
  background: #ff5b57;
}

.label.label-orange {
  background: #f59c1a;
}

.label.label-yellow {
  color: #2d353c;
  background: #ffd900;
}

.label.label-green {
  background: #32a932;
}

.label.label-teal {
  background: #00acac;
}

.label.label-cyan {
  background: #49b6d6;
}

.label.label-white {
  background: #fff;
}

.label.label-gray {
  background: #6c757d;
}

.label.label-gray-dark {
  background: #343a40;
}

.label.label-black {
  background: #000;
}

.label.label-dark {
  background: #2d353c;
}

.label.label-dark-darker,
.tab-overflow .nav.nav-tabs.nav-tabs-inverse .next-button > a,
.tab-overflow .nav.nav-tabs.nav-tabs-inverse .prev-button > a {
  background: #1a2229;
}

.label.label-lime {
  background: #90ca4b;
}

.label.label-light {
  background: #f2f3f4;
}

.label.label-silver {
  background: #b6c2c9;
}

.label.label-muted {
  background: #627884;
}

.label.label-aqua {
  background: #49b6d6;
}

.label.label-square {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.label.label-default {
  background: #e4e7ea;
  color: #2d353c;
}

.lead {
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 300;
  line-height: 1.4;
}

.list-group-item.list-group-item-inverse {
  background: #1a2229;
  border-color: #2d353c;
  color: #fff;
}

.list-group-item.list-group-item-inverse .badge-inverse,
.list-group-item.list-group-item-inverse .label-inverse {
  background: rgba(0, 0, 0, 0.4);
}

.list-group-item.list-group-item-inverse:focus,
.list-group-item.list-group-item-inverse:hover {
  color: #fff;
  background: #202a32;
  text-decoration: none;
}

.login.login-v1,
.login.login-v1 .login-container .login-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.login.login-v1 {
  height: 100vh;
  width: 100%;
}

@media (max-width: 575.98px) {
  .login.login-v1 {
    background: #2d353c;
  }
}

.login.login-v1 .login-container {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.login.login-v1 .login-container .login-header {
  width: 400px;
  padding: 0;
  margin: 0 auto 15px;
  font-weight: 300;
  position: relative;
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-header {
    width: auto;
    left: 0;
    margin: 0;
    padding: 0 30px;
  }
}

.login.login-v1 .login-container .login-header .brand {
  padding: 0;
  font-size: 28px;
  color: #2d353c;
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-header .brand {
    color: #fff;
    font-size: 24px;
  }
}

.login.login-v1 .login-container .login-header .brand .logo {
  border: 14px solid transparent;
  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);
  background-color: #00acac;
  width: 28px;
  height: 28px;
  position: relative;
  font-size: 0;
  margin-right: 10px;
  top: -11px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-header .brand .logo {
    width: 24px;
    height: 24px;
    top: -9px;
  }
}

.login.login-v1 .login-container .login-header .brand small {
  font-size: 14px;
  display: block;
  color: #4e5c68;
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-header .brand small {
    font-size: 12px;
    color: #969a9e;
  }
}

.login.login-v1 .login-container .login-header .icon {
  margin-left: auto;
  color: rgba(45, 53, 60, 0.15);
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-header .icon {
    color: rgba(255, 255, 255, 0.15);
  }
}

.login.login-v1 .login-container .login-header .icon i {
  font-size: 64px;
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-header .icon i {
    font-size: 36px;
  }
}

.login.login-v1 .login-container .login-body {
  padding: 30px;
  background: #2d353c;
}

.login.login-v1 .login-container .login-body .login-content {
  padding: 0;
  color: #c6ced5;
  width: 400px;
  margin: 0 auto;
}

@media (max-width: 575.98px) {
  .login.login-v1 .login-container .login-body .login-content {
    width: auto;
  }
}

.login.login-v1 .login-container .login-body .login-content .form-control {
  border-color: transparent;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.login.login-v1
  .login-container
  .login-body
  .login-content
  .form-control:focus {
  -webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
}

.login.login-v2 {
  width: 400px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 0 0 -200px;
  left: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

@media (max-width: 575.98px) {
  .login.login-v2 {
    position: relative;
    margin: 0;
    left: 0;
    width: auto;
    padding: 30px 0;
    height: 100vh;
  }
}

.login.login-v2 a {
  color: #fff;
}

.login.login-v2 label {
  color: rgba(255, 255, 255, 0.6);
}

.login.login-v2 .login-header {
  padding: 0 20px;
  color: #fff;
  position: relative;
}

.login.login-v2 .login-header .brand {
  padding: 0;
  font-size: 28px;
  color: #fff;
}

@media (max-width: 575.98px) {
  .login.login-v2 .login-header .brand {
    font-size: 24px;
  }
}

.login.login-v2 .login-header .brand .logo,
.login.login-with-news-feed .right-content .login-header .brand .logo {
  border: 14px solid transparent;
  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);
  background-color: #00acac;
  width: 28px;
  height: 28px;
  position: relative;
  font-size: 0;
  margin-right: 10px;
  top: -11px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

@media (max-width: 575.98px) {
  .login.login-v2 .login-header .brand .logo {
    width: 24px;
    height: 24px;
    border-width: 12px;
    top: -9px;
  }
}

.login.login-v2 .login-header .brand small {
  font-size: 14px;
  display: block;
  color: rgba(255, 255, 255, 0.6);
}

@media (max-width: 575.98px) {
  .login.login-v2 .login-header .brand small {
    font-size: 12px;
  }
}

.login.login-v2 .login-header .icon {
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 0;
  color: rgba(255, 255, 255, 0.85);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.login.login-v2 .login-header .icon i,
.login.login-with-news-feed .right-content .login-header .icon i {
  font-size: 56px;
}

@media (max-width: 575.98px) {
  .login.login-v2 .login-header .icon i {
    font-size: 36px;
  }
}

.login.login-v2 .login-content {
  padding: 20px;
  color: #9ba8b4;
}

.login.login-v2 .login-content .form-control {
  border: 1px solid transparent;
}

.login.login-v2 .login-content .form-control:focus {
  border-color: transparent;
  -webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

.login.login-with-news-feed {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.login.login-with-news-feed .news-feed {
  position: fixed;
  left: 0;
  right: 500px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

@media (max-width: 1199.98px) {
  .login.login-with-news-feed .news-feed {
    right: 400px;
  }
}

@media (max-width: 767.98px) {
  .login.login-with-news-feed .news-feed {
    position: relative;
    right: 0;
    display: none;
  }
}

.login.login-with-news-feed .news-feed .news-image {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login.login-with-news-feed .news-feed .news-caption {
  color: rgba(255, 255, 255, 0.85);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 60px 60px 30px;
  font-size: 18px;
  letter-spacing: 0.25px;
  z-index: 20;
  font-weight: 300;
  background: -moz-linear-gradient(to bottom, transparent 0%, black 100%);
  background: -webkit-linear-gradient(to bottom, transparent 0%, black 100%);
  background: linear-gradient(to bottom, transparent 0%, #000 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);
}

@media (max-width: 1199.98px) {
  .login.login-with-news-feed .news-feed .news-caption {
    padding: 45px 45px 30px;
    font-size: 16px;
  }
}

.login.login-with-news-feed .news-feed .news-caption .caption-title {
  font-weight: 300;
  color: #fff;
  font-size: 36px;
}

@media (max-width: 1199.98px) {
  .login.login-with-news-feed .news-feed .news-caption .caption-title {
    font-size: 28px;
  }
}

.login.login-with-news-feed .right-content {
  min-height: 100%;
  background: #fff;
  width: 500px;
  margin-left: auto;
  padding: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

@media (max-width: 1199.98px) {
  .login.login-with-news-feed .right-content {
    width: 400px;
    padding: 45px;
  }
}

@media (max-width: 767.98px) {
  .login.login-with-news-feed .right-content {
    width: auto;
  }
}

@media (max-width: 575.98px) {
  .login.login-with-news-feed .right-content {
    padding: 30px;
  }
}

.login.login-with-news-feed .right-content .login-content {
  width: auto;
}

.login.login-with-news-feed .right-content .login-header {
  position: relative;
}

.login.login-with-news-feed .right-content .login-header + .login-content {
  padding-top: 30px;
}

.login.login-with-news-feed .right-content .login-header .brand {
  padding: 0;
  font-size: 28px;
  color: #1a2229;
}

@media (max-width: 767.98px) {
  .login.login-with-news-feed .right-content .login-header .brand {
    font-size: 20px;
  }
}

@media (max-width: 767.98px) {
  .login.login-with-news-feed .right-content .login-header .brand .logo {
    width: 20px;
    height: 20px;
    border-width: 10px;
    top: -7px;
  }
}

.login.login-with-news-feed .right-content .login-header .brand small {
  font-size: 14px;
  display: block;
  color: #557087;
}

@media (max-width: 1199.98px) {
  .login.login-with-news-feed .right-content .login-header .brand small {
    font-size: 12px;
    line-height: 18px;
  }
}

.login.login-with-news-feed .right-content .login-header .icon {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  color: #dae1e8;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 767.98px) {
  .login.login-with-news-feed .right-content .login-header .icon i {
    font-size: 36px;
  }
}

.login-cover,
.login-cover .login-cover-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.login-cover {
  -webkit-transition: background 0.2s linear;
  -moz-transition: background 0.2s linear;
  -ms-transition: background 0.2s linear;
  -o-transition: background 0.2s linear;
  transition: background 0.2s linear;
}

.login-cover .login-cover-bg {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0.9)
  );
}

.login-bg-list > li a,
.login-cover .login-cover-bg,
.login-cover .login-cover-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login-cover .login-cover-image {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.login-bg-list {
  list-style-type: none;
  position: absolute;
  right: 20px;
  bottom: 20px;
  margin: 0;
  padding: 0 0 0 20px;
  z-index: 1020;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.login-bg-list > li {
  width: 66px;
  height: 66px;
  overflow: hidden;
  border: 3px solid transparent;
  -webkit-border-radius: 66px;
  border-radius: 66px;
}

@media (max-width: 575.98px) {
  .login-bg-list > li {
    width: 46px;
    height: 46px;
  }
}

.login-bg-list > li a {
  display: block;
  height: 60px;
  overflow: hidden;
}

.login-bg-list > li img {
  max-height: 100%;
  max-width: 100%;
}

.login-bg-list > li:focus,
.login-bg-list > li:hover {
  border-color: rgba(255, 255, 255, 0.5);
}

.login-bg-list > li.active {
  border-color: #fff;
  z-index: 1020;
  position: relative;
}

.map {
  position: absolute;
  top: 50px;
  bottom: 0;
  left: 220px;
  right: 0;
  z-index: 0;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

@media (max-width: 767.98px) {
  .map {
    left: 0;
    top: 101px;
  }
}

.map .map-float-table {
  position: absolute;
  right: 25px;
  bottom: 25px;
  background: rgba(26, 34, 41, 0.8);
}

.map-content {
  padding: 0 30px;
  z-index: 10;
  position: relative;
}

.media-list {
  padding-left: 0;
  padding-right: 0;
  list-style: none;
}

.media-list.media-list-with-divider .media + .media {
  border-top: 1px solid #d5dbe0;
  padding-top: 15px;
}

.dropdown-menu.media-list {
  max-width: 360px;
  padding: 0;
}

.dropdown-menu.media-list .media {
  border-top: 1px solid #e4e7ea;
  border-bottom: 1px solid #e4e7ea;
  margin-top: 0;
  margin-bottom: -1px;
}

.dropdown-menu.media-list .media .media-object {
  height: 48px;
  width: 48px;
  line-height: 48px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.dropdown-menu.media-list .media .media-object-icon {
  position: absolute;
  margin-left: 30px;
  border: 2px solid #fff;
  background: #fff;
  margin-top: -11px;
  display: block;
  width: 22px;
  height: 22px;
  text-align: center;
  font-size: 18px;
  line-height: 18px;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.dropdown-menu.media-list .media .media-left {
  padding-right: 12px;
}

.dropdown-menu.media-list .media .media-right {
  padding-left: 12px;
}

.dropdown-menu.media-list .media .media-heading {
  color: #2d353c;
  margin-bottom: 0;
  font-size: 12.5px;
  line-height: 18px;
}

.dropdown-menu.media-list .media p {
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 14px;
  max-width: 270px;
  color: #4e5c68;
  font-size: 11px;
}

.dropdown-menu.media-list .dropdown-header {
  font-weight: 700;
  color: #2d353c;
  font-size: 10px;
  background: #f2f3f4;
  padding: 10px 15px;
}

.dropdown-menu.media-list .dropdown-footer,
.dropdown-menu.media-list .dropdown-item {
  padding: 10px 15px;
}

.media-messaging .media {
  padding: 15px;
}

.media-messaging .media + .media {
  margin-top: 0;
  padding-top: 15px;
}

.media-messaging .media:first-child {
  padding-top: 0;
}

.media-messaging .media:last-child {
  padding-bottom: 0;
}

.media,
body div.dt-autofill-list ul > li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.media + .media,
.timeline .timeline-body > div + div {
  margin-top: 15px;
}

.media .media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}

.media .media-object {
  width: 128px;
}

.media.media-lg .media-object {
  width: 256px;
}

.media.media-sm .media-object {
  width: 64px;
}

.media.media-xs .media-object {
  width: 32px;
}

.media > .media-left,
.media > .pull-left {
  padding-right: 15px;
}

.media > .media-right,
.media > .pull-right {
  padding-left: 15px;
}

.modal .modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-align: center;
  align-items: center;
}

.modal.modal-message .modal-dialog {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.modal.modal-message .modal-content {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.modal.modal-message .modal-body,
.modal.modal-message .modal-footer,
.modal.modal-message .modal-header {
  width: 60%;
  border: 0;
  margin: 0 auto;
}

@media (max-width: 767.98px) {
  .modal.modal-message .modal-body,
  .modal.modal-message .modal-footer,
  .modal.modal-message .modal-header {
    width: 90%;
  }
}

.nav.nav-pills .nav-item .nav-link,
.nav.nav-tabs .nav-item .nav-link {
  padding: 10px 15px;
  font-weight: 600;
  color: #6f8293;
}

.nav.nav-tabs .nav-item .nav-link.active,
.nav.nav-tabs .nav-item .nav-link:focus,
.nav.nav-tabs .nav-item .nav-link:hover {
  color: #2d353c;
}

.nav.nav-tabs.nav-tabs-inverse {
  background: #1a2229;
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.nav.nav-tabs.nav-tabs-inverse .nav-item .nav-link {
  color: #c6ced5;
}

.nav.nav-tabs.nav-tabs-inverse .nav-item .nav-link.active {
  color: #2d353c;
}

.nav.nav-tabs + .tab-content {
  padding: 15px;
  background: #fff;
  margin-bottom: 20px;
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.bootstrap-calendar .calendar .table.header td .icon-arrow-left:focus,
.bootstrap-calendar .calendar .table.header td .icon-arrow-left:hover,
.bootstrap-calendar .calendar .table.header td .icon-arrow-right:focus,
.bootstrap-calendar .calendar .table.header td .icon-arrow-right:hover,
.nav.nav-pills .nav-item .nav-link:focus,
.nav.nav-pills .nav-item .nav-link:hover,
body
  .datepicker
  .datepicker-centuries
  table
  thead
  tr
  th.datepicker-switch:focus:before,
body
  .datepicker
  .datepicker-centuries
  table
  thead
  tr
  th.datepicker-switch:hover:before,
body .datepicker .datepicker-centuries table thead tr th.next:focus:before,
body .datepicker .datepicker-centuries table thead tr th.next:hover:before,
body .datepicker .datepicker-centuries table thead tr th.prev:focus:before,
body .datepicker .datepicker-centuries table thead tr th.prev:hover:before,
body
  .datepicker
  .datepicker-days
  table
  thead
  tr
  th.datepicker-switch:focus:before,
body
  .datepicker
  .datepicker-days
  table
  thead
  tr
  th.datepicker-switch:hover:before,
body .datepicker .datepicker-days table thead tr th.next:focus:before,
body .datepicker .datepicker-days table thead tr th.next:hover:before,
body .datepicker .datepicker-days table thead tr th.prev:focus:before,
body .datepicker .datepicker-days table thead tr th.prev:hover:before,
body
  .datepicker
  .datepicker-decades
  table
  thead
  tr
  th.datepicker-switch:focus:before,
body
  .datepicker
  .datepicker-decades
  table
  thead
  tr
  th.datepicker-switch:hover:before,
body .datepicker .datepicker-decades table thead tr th.next:focus:before,
body .datepicker .datepicker-decades table thead tr th.next:hover:before,
body .datepicker .datepicker-decades table thead tr th.prev:focus:before,
body .datepicker .datepicker-decades table thead tr th.prev:hover:before,
body
  .datepicker
  .datepicker-months
  table
  thead
  tr
  th.datepicker-switch:focus:before,
body
  .datepicker
  .datepicker-months
  table
  thead
  tr
  th.datepicker-switch:hover:before,
body .datepicker .datepicker-months table thead tr th.next:focus:before,
body .datepicker .datepicker-months table thead tr th.next:hover:before,
body .datepicker .datepicker-months table thead tr th.prev:focus:before,
body .datepicker .datepicker-months table thead tr th.prev:hover:before,
body
  .datepicker
  .datepicker-years
  table
  thead
  tr
  th.datepicker-switch:focus:before,
body
  .datepicker
  .datepicker-years
  table
  thead
  tr
  th.datepicker-switch:hover:before,
body .datepicker .datepicker-years table thead tr th.next:focus:before,
body .datepicker .datepicker-years table thead tr th.next:hover:before,
body .datepicker .datepicker-years table thead tr th.prev:focus:before,
body .datepicker .datepicker-years table thead tr th.prev:hover:before {
  color: #2d353c;
}

.nav.nav-pills .nav-item .nav-link.active {
  color: #fff;
}

.note,
.note .note-content {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.note,
.note .note-icon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.note {
  margin-bottom: 20px;
  border-left: 3px solid;
  position: relative;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.note .note-icon {
  width: 80px;
  font-size: 56px;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.note .note-content {
  padding: 15px;
}

.note .note-content h1,
.note .note-content h2,
.note .note-content h3,
.note .note-content h4,
.note .note-content h5,
.note .note-content h6 {
  color: inherit;
}

.note.note-with-right-icon {
  border-left: none;
  border-right: 3px solid;
}

.note.note-primary {
  background: #61a8e8;
  color: #10416d;
}

.note.note-secondary {
  border-color: #6c757d;
  background: #868e96;
  color: #25282b;
}

.note.note-success {
  border-color: #00acac;
  background: #00dfdf;
  color: #001313;
}

.note.note-info {
  border-color: #49b6d6;
  background: #73c7df;
  color: #195a6d;
}

.note.note-warning {
  border-color: #f59c1a;
  background: #f7b14b;
  color: #714505;
}

.note.note-danger {
  border-color: #ff5b57;
  background: #ff8d8a;
  color: #bd0500;
}

.note.note-light {
  color: #2d353c;
}

.pager > li > a,
.pager > li > span,
.tab-overflow .nav.nav-tabs.nav-tabs-inverse > li > a.active {
  background: #fff;
  color: #2d353c;
}

.note.note-dark,
.note.note-inverse {
  background: #434f59;
  color: #000;
}

.note.note-inverse {
  border-color: #2d353c;
}

.note.note-black {
  background: #1a1a1a;
  color: #000;
}

.note.note-white {
  color: #b3b3b3;
}

.note.note-grey {
  border-color: #b6c2c9;
}

.note.note-grey,
.note.note-muted,
.note.note-silver {
  background: #d3dadf;
  color: #627884;
}

.note.note-lime {
  background: #a8d672;
  color: #41601c;
}

.note.note-aqua {
  background: #73c7df;
  color: #195a6d;
}

.note.note-blue {
  border-color: #348fe2;
  background: #77b4ec;
}

.note.note-indigo {
  border-color: #8753de;
  background: #b493ea;
}

.note.note-purple {
  border-color: #727cb6;
  background: #a4abd0;
}

.note.note-pink {
  border-color: #fb5597;
  background: #fda0c5;
}

.note.note-red {
  border-color: #ff5b57;
  background: #ffa6a4;
}

.note.note-orange {
  border-color: #f59c1a;
  background: #f8bc63;
}

.note.note-yellow {
  border-color: #ffd900;
  background: #ffe44d;
}

.note.note-green {
  border-color: #32a932;
  background: #59ce59;
}

.note.note-teal {
  border-color: #00acac;
  background: #00f9f9;
}

.note.note-cyan {
  border-color: #49b6d6;
  background: #87cfe4;
}

.note.note-white {
  border-color: #fff;
  background: #fff;
}

.note.note-gray {
  border-color: #6c757d;
  background: #939ba2;
}

.note.note-gray-dark {
  border-color: #343a40;
  background: #56606a;
}

.note.note-black {
  border-color: #000;
  background: #262626;
}

.note.note-dark {
  border-color: #2d353c;
  background: #4e5c68;
}

.note.note-dark-darker {
  border-color: #1a2229;
  background: #384958;
}

.note.note-lime {
  border-color: #90ca4b;
  background: #b4db86;
}

.note.note-light {
  border-color: #f2f3f4;
  background: #fff;
}

.note.note-silver {
  border-color: #b6c2c9;
  background: #e2e7ea;
}

.note.note-muted {
  border-color: #627884;
  background: #8a9da8;
}

.note.note-aqua {
  border-color: #49b6d6;
  background: #87cfe4;
}

.page-header {
  font-size: 24px;
  margin: 0 0 15px;
  padding: 0;
  border: 0;
  line-height: 32px;
  font-weight: 500;
}

.page-header small {
  line-height: 20px;
}

.pager {
  padding-left: 0;
  margin: 20px 0;
  text-align: center;
  list-style: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.pager > li + li,
.pagination .page-item + .page-item,
.panel .panel-heading .panel-heading-btn > a + a,
.result-list > li .result-info .btn-row a + a,
.theme-panel .theme-list > li + li {
  margin-left: 5px;
}

.pager > li > a,
.pager > li > span {
  display: block;
  padding: 5px 14px;
  border: 1px solid #d5dbe0;
  text-decoration: none;
  font-weight: 600;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.pager > li.previous {
  margin-right: auto;
}

.pager > li.next {
  margin-left: auto;
}

.pager > li.disabled > a,
.pager > li.disabled > span {
  opacity: 0.6;
  cursor: not-allowed;
}

.pager.pager-without-border > li > a,
.pager.pager-without-border > li > span {
  border: 0;
}

.pagination .page-item .page-link {
  font-weight: 600;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.pagination.pagination-lg .page-item .page-link {
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.pagination.pagination-sm .page-item .page-link,
.panel {
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.panel {
  margin-bottom: 20px;
  background: #fff;
  border: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.panel > .table-bordered,
.panel > .table-responsive > .table-bordered {
  border: 0;
  margin-bottom: 0;
}

.panel > .form-control + .panel-footer,
.panel > .table-bordered > thead > tr > th,
.panel > .table-responsive > .table-bordered > thead > tr > th {
  border-top: none;
}

.panel > .table-bordered > tbody > tr > td:first-child,
.panel > .table-bordered > thead > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:first-child {
  border-left: none;
}

.panel > .table-bordered > tbody > tr > td:last-child,
.panel > .table-bordered > thead > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:last-child {
  border-right: none;
}

.panel > .table-bordered > tbody > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td {
  border-bottom: none;
}

.panel > .form-control {
  border-right: 0;
  border-left: 0;
  padding: 15px;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.panel > .alert,
.panel > .note {
  margin: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.panel > .list-group,
.panel > .tab-content,
.panel > .table {
  margin-bottom: 0;
}

.panel > .tab-content {
  -webkit-border-radius: 0 0 3px 3px;
  border-radius: 0 0 3px 3px;
}

.panel > .list-group:last-child .list-group-item {
  border-width: 1px 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.panel > .list-group:last-child .list-group-item:last-child {
  border-bottom: 0;
  -webkit-border-bottom-right-radius: 3px;
  border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel > .widget-list .widget-list-item {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.panel > .table-responsive > .table > tbody > tr > td:first-child,
.panel > .table-responsive > .table > tbody > tr > th:first-child,
.panel > .table-responsive > .table > thead > tr > td:first-child,
.panel > .table-responsive > .table > thead > tr > th:first-child,
.panel > .table > tbody > tr > td:first-child,
.panel > .table > tbody > tr > th:first-child,
.panel > .table > thead > tr > td:first-child,
.panel > .table > thead > tr > th:first-child,
.widget-list .widget-list-item > div:first-child {
  padding-left: 15px;
}

.panel > .table-responsive > .table > tbody > tr > td:last-child,
.panel > .table-responsive > .table > tbody > tr > th:last-child,
.panel > .table-responsive > .table > thead > tr > td:last-child,
.panel > .table-responsive > .table > thead > tr > th:last-child,
.panel > .table > tbody > tr > td:last-child,
.panel > .table > tbody > tr > th:last-child,
.panel > .table > thead > tr > td:last-child,
.panel > .table > thead > tr > th:last-child,
.widget-list .widget-list-item > div:last-child {
  padding-right: 15px;
}

.panel .panel-heading {
  padding: 10px 15px;
  border: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-border-top-left-radius: 3px;
  border-top-left-radius: 3px;
  -webkit-border-top-right-radius: 3px;
  border-top-right-radius: 3px;
}

.panel .panel-heading .panel-title {
  line-height: 20px;
  font-size: 12px;
  margin-top: 0;
  margin-bottom: 0;
  color: inherit;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.panel .panel-heading .panel-title > a {
  color: inherit;
  display: block;
}

.panel .panel-heading .panel-title .pull-right {
  line-height: 20px;
}

.panel .panel-heading,
.panel .panel-heading .panel-heading-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.panel .panel-heading .panel-heading-btn .btn-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.panel .panel-heading .btn-group .btn {
  margin-top: -7px;
  margin-bottom: -7px;
}

.panel .panel-heading .btn-group .btn-group-sm > .btn,
.panel .panel-heading .btn-group .btn.btn-sm {
  margin-top: -5px;
  margin-bottom: -5px;
}

.panel .panel-heading .btn-group .btn.btn-xs {
  margin-top: -1px;
  margin-bottom: -1px;
}

.panel .panel-heading .progress {
  min-width: 120px;
}

.panel .panel-body {
  padding: 15px;
}

.panel .panel-body.no-padding,
.panel .panel-body.panel-form,
.panel .panel-body.panel-full-width,
.panel .panel-body.panel-table {
  padding: 0 !important;
}

.panel .panel-body.no-border {
  border: 0 !important;
}

.panel .panel-body[class^="bg-"] {
  -webkit-border-radius: 0 0 3px 3px;
  border-radius: 0 0 3px 3px;
}

.panel .panel-footer,
.panel .panel-toolbar {
  padding: 10px 15px;
  background: #fff;
}

.panel .panel-footer {
  border-top: 1px solid #d5dbe0;
  -webkit-border-bottom-right-radius: 3px;
  border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel [class^="col-"].ui-sortable {
  min-height: 0;
}

.panel.panel-default > .panel-heading {
  background: #f2f4f5;
  color: #4e5c68;
}

.panel.panel-inverse > .panel-heading {
  background: #1d2226;
  color: #fff;
}

.panel.panel-success > .panel-heading {
  background: #008686;
  color: #fff;
}

.panel.panel-warning > .panel-heading {
  background: #df880a;
  color: #fff;
}

.panel.panel-danger > .panel-heading {
  background: #ff3631;
  color: #fff;
}

.panel.panel-primary > .panel-heading {
  background: #1e7cd2;
  color: #fff;
}

.panel.panel-info > .panel-heading {
  background: #2ea7cb;
  color: #fff;
}

.panel.panel-loading .panel-body {
  position: relative;
  z-index: 0;
}

.panel.panel-loading .panel-body .panel-loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  opacity: 0.9;
  z-index: 10;
  -webkit-animation: fadeIn 0.2s;
  -moz-animation: fadeIn 0.2s;
  -ms-animation: fadeIn 0.2s;
  -o-animation: fadeIn 0.2s;
  animation: fadeIn 0.2s;
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.panel.panel-expand {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  overflow: hidden;
  z-index: 1080;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.panel.panel-expand,
.panel.panel-expand > .panel-body,
.panel.panel-expand > .panel-footer,
.panel.panel-expand > .panel-heading {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.panel.panel-expand > .panel-body {
  overflow-x: scroll;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.panel.panel-expand > .panel-body > .slimScrollDiv {
  height: 100% !important;
}

.panel.panel-expand
  > .panel-body
  > .slimScrollDiv
  > div:not(.slimScrollBar):not(.slimScrollRail) {
  height: 100% !important;
}

.panel.panel-expand > .panel-heading {
  -webkit-box-flex: 0;
  -ms-flex: 0;
  flex: 0;
}

.panel.panel-expand > .panel-heading .fa-expand:before {
  content: "\\f066";
}

.panel.panel-hover-icon .panel-heading .panel-heading-btn .btn i {
  visibility: hidden;
}

.panel.panel-hover-icon .panel-heading:focus .panel-heading-btn .btn i,
.panel.panel-hover-icon .panel-heading:hover .panel-heading-btn .btn i {
  visibility: visible;
}

.panel.panel-no-rounded-corner .panel-body,
.panel.panel-no-rounded-corner .panel-footer,
.panel.panel-no-rounded-corner .panel-header {
  -webkit-border-radius: 0 !important;
  border-radius: 0 !important;
}

.panel.panel-with-tabs .panel-heading {
  -ms-flex-align: center;
  align-items: center;
}

.panel.panel-with-tabs .panel-heading > .nav-tabs {
  margin-top: -5px;
  margin-bottom: -11px;
  border-bottom: none;
}

.panel.panel-with-tabs .panel-heading > .nav-tabs .nav-item .nav-link {
  border: 0;
  margin: 0;
}

.panel-group .panel {
  margin-bottom: 0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.panel-group .panel + .panel {
  margin-top: 5px;
}

.panel-expand .header,
.panel-expand .sidebar,
.panel-expand .sidebar-bg,
.panel-expand .top-menu {
  z-index: 0;
}

.panel-expand .content .row [class^="col-"] {
  position: inherit;
}

.panel-expand .content .panel-expand .row > [class^="col-"],
.profile-header {
  position: relative;
}

.panel-expand .vertical-box .vertical-box-column {
  display: table-cell;
}

.panel-expand .page-content-full-height .content {
  -webkit-transform: none;
  -moz-transform: none;
  -ms-transform: none;
  -o-transform: none;
  transform: none;
}

.mission-list {
  margin-bottom: 15px;
}

.profile-header {
  overflow: hidden;
}

.profile-header .profile-header-cover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.profile-header .profile-header-cover:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, transparent 0%, #000 100%);
}

.profile-header .profile-header-content {
  color: #fff;
  padding: 30px;
  position: relative;
}

@media (max-width: 991.98px) {
  .profile-header .profile-header-content {
    padding: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
}

.profile-header .profile-header-img {
  float: left;
  width: 120px;
  height: 120px;
  overflow: hidden;
  position: relative;
  z-index: 10;
  margin: -10px 0 -20px;
  padding: 3px;
  background: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

@media (max-width: 991.98px) {
  .profile-header .profile-header-img {
    margin: 0;
    width: 80px;
    height: 80px;
  }
}

.profile-header .profile-header-img + .profile-header-info {
  margin-left: 140px;
}

@media (max-width: 991.98px) {
  .profile-header .profile-header-img + .profile-header-info {
    margin-left: 20px;
  }
}

.profile-header .profile-header-img img {
  max-width: 100%;
}

.profile-header .profile-header-info h4 {
  font-weight: 600;
  color: #fff;
}

.profile-header .profile-header-tab {
  position: relative;
  background: #fff;
  list-style-type: none;
  margin: -10px 0 0;
  padding: 0 0 0 150px;
  -webkit-border-radius: 0;
  border-radius: 0;
}

@media (max-width: 991.98px) {
  .profile-header .profile-header-tab {
    padding: 0;
    margin: 0;
    overflow: scroll;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}

.profile-header .profile-header-tab .nav-item {
  display: inline-block;
  margin: 0;
}

.profile-header .profile-header-tab .nav-item .nav-link {
  display: block;
  color: #6f8293;
  line-height: 20px;
  padding: 10px 20px;
  text-decoration: none;
  font-weight: 700;
  font-size: 12px;
  border: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.profile-header .profile-header-tab .nav-item .nav-link:focus,
.profile-header .profile-header-tab .nav-item .nav-link:hover {
  background: 0 0;
  color: #4e5c68;
}

.profile-header .profile-header-tab .nav-item .nav-link.active {
  color: #2d353c;
  background: 0 0;
}

.profile-content {
  padding: 25px;
}

.profile-content .tab-content,
.profile-content .tab-pane {
  background: 0 0;
}

.profile-content .table.table-profile > thead > tr > th {
  border: 0;
  border-bottom: none !important;
  color: #2d353c;
  background: 0 0;
}

.profile-content .table.table-profile > thead > tr > th h4 {
  font-size: 20px;
  margin-top: 0;
}

.profile-content .table.table-profile > thead > tr > th h4 small {
  display: block;
  font-size: 12px;
  font-weight: 400;
  margin-top: 5px;
}

.profile-content .table.table-profile tbody > tr td {
  border: 0;
  color: #2d353c;
  background: 0 0;
}

.profile-content .table.table-profile tbody > tr td .form-control {
  border-color: #c8cfd6;
}

.profile-content .table.table-profile tbody > tr td .form-control:focus {
  border-color: #5db0ff;
}

.profile-content .table.table-profile tbody > tr td.field {
  width: 20%;
  text-align: right;
  font-weight: 600;
  color: #2d353c;
}

@media (max-width: 991.98px) {
  .profile-content .table.table-profile tbody > tr td.field {
    width: 35%;
  }
}

.profile-content .table.table-profile tbody > tr.highlight > td {
  border-top: 1px solid #c8cfd6;
  border-bottom: 1px solid #c8cfd6;
}

.profile-content .table.table-profile tbody > tr.divider > td {
  padding: 0 !important;
  height: 10px;
}

.progress .progress-bar {
  font-weight: 600;
}

.progress.progress-xs {
  height: 5px;
}

.progress.progress-xs .progress-bar {
  line-height: 5px;
}

.progress.progress-sm {
  height: 10px;
}

.progress.progress-sm .progress-bar {
  line-height: 10px;
}

.progress.progress-lg {
  height: 30px;
}

.progress.progress-lg .progress-bar {
  line-height: 30px;
}

.has-success .radio.radio-css label,
.has-success.radio.radio-css label,
.is-valid .radio.radio-css label,
.is-valid.radio.radio-css label {
  color: #009393;
}

.has-success .radio.radio-css label:before,
.has-success.radio.radio-css label:before,
.is-valid .radio.radio-css label:before,
.is-valid.radio.radio-css label:before {
  background: rgba(0, 172, 172, 0.5);
}

.has-error .radio.radio-css label,
.has-error.radio.radio-css label,
.is-invalid .radio.radio-css label,
.is-invalid.radio.radio-css label {
  color: #ff423e;
}

.has-error .radio.radio-css label:before,
.has-error.radio.radio-css label:before,
.is-invalid .radio.radio-css label:before,
.is-invalid.radio.radio-css label:before {
  background: rgba(255, 91, 87, 0.5);
}

.radio.radio-css {
  position: relative;
  line-height: 16px;
  padding-top: 7px;
}

.radio.radio-css label {
  padding-left: 24px;
  margin: 0;
  position: relative;
}

.radio.radio-css label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  background: #d5dbe0;
  -webkit-border-radius: 16px;
  border-radius: 16px;
}

.radio.radio-css input:checked + label:before {
  background: #348fe2;
  border-color: #348fe2;
}

.radio.radio-css input:checked + label:after {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  width: 6px;
  height: 6px;
  background: #fff;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.radio.radio-css.radio-inline {
  padding-left: 0;
  display: inline-block;
}

.radio.radio-css.radio-inline + .radio-inline {
  margin-left: 15px;
}

.radio.radio-css.radio-success input:checked + label:before,
.switcher.switcher-success input:checked + label:before {
  background: #00acac;
  border-color: #00acac;
}

.radio.radio-css.radio-lime input:checked + label:before,
.switcher.switcher-lime input:checked + label:before {
  background: #90ca4b;
  border-color: #90ca4b;
}

.radio.radio-css.radio-indigo input:checked + label:before,
.switcher.switcher-indigo input:checked + label:before {
  background: #8753de;
  border-color: #8753de;
}

.radio.radio-css.radio-purple input:checked + label:before,
.switcher.switcher-purple input:checked + label:before {
  background: #727cb6;
  border-color: #727cb6;
}

.radio.radio-css.radio-inverse input:checked + label:before,
.switcher.switcher-inverse input:checked + label:before {
  background: #2d353c;
  border-color: #2d353c;
}

.radio.radio-css.radio-warning input:checked + label:before,
.switcher.switcher-warning input:checked + label:before {
  background: #f59c1a;
  border-color: #f59c1a;
}

.radio.radio-css.radio-danger input:checked + label:before,
.switcher.switcher-danger input:checked + label:before {
  background: #ff5b57;
  border-color: #ff5b57;
}

.radio.radio-css.radio-info input:checked + label:before,
.switcher.switcher-info input:checked + label:before {
  background: #49b6d6;
  border-color: #49b6d6;
}

.radio.radio-css.radio-pink input:checked + label:before,
.switcher.switcher-pink input:checked + label:before {
  background: #fb5597;
  border-color: #fb5597;
}

.radio.radio-css.radio-yellow input:checked + label:before,
.switcher.switcher-yellow input:checked + label:before {
  background: #ffd900;
  border-color: #ffd900;
}

.register.register-with-news-feed {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.register.register-with-news-feed .news-feed {
  position: fixed;
  left: 0;
  right: 500px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

@media (max-width: 1199.98px) {
  .register.register-with-news-feed .news-feed {
    right: 400px;
  }
}

@media (max-width: 767.98px) {
  .register.register-with-news-feed .news-feed {
    position: relative;
    right: 0;
    display: none;
  }
}

.register.register-with-news-feed .news-feed .news-image {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.register.register-with-news-feed .news-feed .news-caption {
  color: rgba(255, 255, 255, 0.85);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 60px 60px 30px;
  font-size: 18px;
  letter-spacing: 0.25px;
  z-index: 20;
  font-weight: 300;
  background: -moz-linear-gradient(to bottom, transparent 0%, black 100%);
  background: -webkit-linear-gradient(to bottom, transparent 0%, black 100%);
  background: linear-gradient(to bottom, transparent 0%, #000 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);
}

@media (max-width: 1199.98px) {
  .register.register-with-news-feed .news-feed .news-caption {
    padding: 45px 45px 30px;
    font-size: 16px;
  }
}

.register.register-with-news-feed .news-feed .news-caption .caption-title {
  font-weight: 300;
  color: #fff;
  font-size: 36px;
}

@media (max-width: 1199.98px) {
  .register.register-with-news-feed .news-feed .news-caption .caption-title {
    font-size: 28px;
  }
}

.register.register-with-news-feed .right-content {
  min-height: 100%;
  background: #fff;
  width: 500px;
  margin-left: auto;
  padding: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

@media (max-width: 1199.98px) {
  .register.register-with-news-feed .right-content {
    width: 400px;
    padding: 45px;
  }
}

@media (max-width: 767.98px) {
  .register.register-with-news-feed .right-content {
    width: auto;
  }
}

@media (max-width: 575.98px) {
  .register.register-with-news-feed .right-content {
    padding: 30px;
  }
}

.register.register-with-news-feed .right-content .register-content {
  width: auto;
}

.register.register-with-news-feed .right-content .register-header {
  position: relative;
  font-size: 32px;
}

@media (max-width: 1199.98px) {
  .register.register-with-news-feed .right-content .register-header {
    font-size: 24px;
  }
}

.register.register-with-news-feed
  .right-content
  .register-header
  + .register-content {
  padding-top: 15px;
}

.register.register-with-news-feed .right-content .register-header small {
  color: #6f8293;
  display: block;
  font-size: 14px;
  margin-top: 10px;
  line-height: 20px;
}

@media (max-width: 1199.98px) {
  .register.register-with-news-feed .right-content .register-header small {
    font-size: 12px;
    line-height: 18px;
  }
}

.registered-users-list {
  list-style-type: none;
  margin: 7.5px;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.registered-users-list > li {
  width: 25%;
  font-size: 12px;
  padding: 7.5px;
  color: #2d353c;
}

.registered-users-list > li > a {
  display: block;
  margin-bottom: 10px;
}

.registered-users-list > li img {
  max-width: 100%;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.registered-users-list > li .username {
  font-size: 12px;
  color: #2d353c;
  margin-bottom: 0;
  font-weight: 600;
}

.registered-users-list > li .username small {
  display: block;
  font-size: 11px;
  color: #6f8293;
  line-height: 15px;
}

.result-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.result-list > li {
  background: #fff;
  overflow: hidden;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.result-list > li .result-info .btn-row:after,
.result-list > li .result-info .btn-row:before,
.result-list > li:after,
.result-list > li:before {
  content: "";
  display: table;
  clear: both;
}

@media (max-width: 991.98px) {
  .result-list > li {
    padding-top: 160px;
  }
}

@media (max-width: 575.98px) {
  .result-list > li {
    display: block;
  }
}

.result-list > li + li {
  margin-top: 10px;
}

.result-list > li .result-image {
  width: 240px;
  padding: 0;
  overflow: hidden;
  background: #2d353c;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

@media (max-width: 1199.98px) {
  .result-list > li .result-image {
    width: 180px;
  }
}

@media (max-width: 991.98px) {
  .result-list > li .result-image {
    width: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 160px;
  }
}

.result-list > li .result-image a,
body .datetimepicker.dropdown-menu > ul > li.collapse.in {
  display: block;
}

.result-list > li .result-image img,
body .datetimepicker.dropdown-menu > ul > li.picker-switch {
  width: 100%;
}

.result-list > li .result-image:focus,
.result-list > li .result-image:hover {
  opacity: 0.8;
}

.result-list > li .result-info {
  padding: 20px;
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

@media (max-width: 1199.98px) {
  .result-list > li .result-info {
    padding: 15px;
  }
}

.result-list > li .result-info .title {
  margin: 0 0 5px;
  font-size: 18px;
  line-height: 22px;
}

@media (max-width: 991.98px) {
  .result-list > li .result-info .title {
    font-size: 16px;
    line-height: 20px;
  }
}

.result-list > li .result-info .title a,
.theme-panel .theme-list > li.active > a.bg-white:before {
  color: #2d353c;
}

.result-list > li .result-info .location {
  color: #6f8293;
  margin-bottom: 15px;
}

.result-list > li .result-info .decs {
  margin-bottom: 20px;
  max-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 16px;
}

.result-list > li .result-info .btn-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.result-list > li .result-info .btn-row a {
  color: #2d353c;
  background: #f2f3f4;
  font-size: 14px;
  line-height: 18px;
  padding: 8px 10px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.result-list > li .result-info .btn-row a:focus,
.result-list > li .result-info .btn-row a:hover {
  background: #d5dbe0;
}

.result-list > li .result-price {
  width: 240px;
  font-size: 28px;
  text-align: center;
  background: #f2f3f4;
  color: #2d353c;
  padding: 20px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 1199.98px) {
  .result-list > li .result-price {
    width: 180px;
    padding: 15px;
  }
}

@media (max-width: 575.98px) {
  .result-list > li .result-price {
    width: auto;
  }
}

.result-list > li .result-price small {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #6f8293;
}

.result-list > li .result-price .btn {
  margin-top: 30px;
}

@media (max-width: 575.98px) {
  .result-list > li .result-price .btn {
    margin-top: 15px;
  }
}

.row > [class^="col-"].ui-sortable {
  min-height: 50px;
}

.spinner,
.spinner-small {
  height: 36px;
  width: 36px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -18px 0 0 -18px;
  border: 2px solid rgba(45, 53, 60, 0.85);
  border-top: 2px solid #fff;
  -webkit-border-radius: 36px;
  border-radius: 36px;
  -webkit-animation: rotation 0.6s infinite linear;
  -moz-animation: rotation 0.6s infinite linear;
  -ms-animation: rotation 0.6s infinite linear;
  -o-animation: rotation 0.6s infinite linear;
  animation: rotation 0.6s infinite linear;
}

.spinner-small {
  height: 28px;
  width: 28px;
  margin: -15px 0 0 -15px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

.switcher {
  display: inline-block;
}

.switcher label {
  display: block;
  margin: 0;
  width: 46px;
  height: 28px;
  position: relative;
}

.switcher label:after,
.switcher label:before {
  content: "";
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.switcher label:before {
  display: block;
  background: #d5dbe0;
  border: 1px solid #d5dbe0;
  width: 46px;
  height: 28px;
  -webkit-border-radius: 46px;
  border-radius: 46px;
}

.switcher label:after {
  height: 24px;
  width: 24px;
  position: absolute;
  left: 2px;
  top: 2px;
  background: #fff;
  -webkit-border-radius: 24px;
  border-radius: 24px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.switcher input:checked + label:before {
  background: #348fe2;
  border: 2px solid #348fe2;
}

.switcher input:checked + label:after {
  left: 20px;
}

.tab-overflow {
  position: relative;
  overflow: hidden;
  -webkit-border-radius: 3px 3px 0 0;
  border-radius: 3px 3px 0 0;
}

.tab-overflow .nav.nav-tabs {
  white-space: nowrap;
  display: table;
  margin: 0;
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.tab-overflow .nav.nav-tabs > li {
  display: table-cell;
  float: none;
}

.tab-overflow .nav.nav-tabs > li > a {
  margin-left: -1px;
}

.tab-overflow .nav.nav-tabs .next-button,
.tab-overflow .nav.nav-tabs .prev-button {
  position: absolute;
  top: 0;
  z-index: 10;
  display: none !important;
  opacity: 0;
  -webkit-box-shadow: 0 0 15px rgba(45, 53, 60, 0.25);
  box-shadow: 0 0 15px rgba(45, 53, 60, 0.25);
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.tab-overflow .nav.nav-tabs .prev-button {
  left: 0;
}

.tab-overflow .nav.nav-tabs .prev-button a {
  margin: 0;
  background: #f2f3f4;
  -webkit-border-radius: 4px 0 0;
  border-radius: 4px 0 0;
}

.tab-overflow .nav.nav-tabs .next-button {
  right: 0;
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
}

.tab-overflow .nav.nav-tabs .next-button a {
  margin: 0;
  background: #f2f3f4;
}

.tab-overflow .nav.nav-tabs.nav-tabs-inverse > li > a {
  background: 0 0;
}

.tab-overflow .nav.nav-tabs.nav-tabs-inverse .next-button,
.tab-overflow .nav.nav-tabs.nav-tabs-inverse .prev-button {
  -webkit-box-shadow: 0 0 15px #000;
  box-shadow: 0 0 15px #000;
}

.tab-overflow .nav.nav-tabs .next-button a,
.tab-overflow .nav.nav-tabs.nav-tabs-inverse .next-button + li > a.active,
.tab-overflow .nav.nav-tabs.nav-tabs-inverse .prev-button + li > a.active {
  -webkit-border-radius: 0 4px 0 0;
  border-radius: 0 4px 0 0;
}

.tab-overflow.overflow-left .nav.nav-tabs .prev-button,
.tab-overflow.overflow-right .nav.nav-tabs .next-button {
  display: block !important;
  opacity: 1;
  background: 0 0;
}

.flat-black .tab-overflow .next-button a,
.flat-black .tab-overflow .prev-button a {
  background: #d2d2d2;
}

.table thead tr th {
  font-weight: 600;
  border-bottom: 1px solid #b8c1ca;
}

.table tbody tr td.with-btn,
.table tbody tr td.with-btn-group,
.table tbody tr td.with-checkbox,
.table tbody tr td.with-form-control,
.table tbody tr td.with-img,
.table tbody tr td.with-input-group,
.table tbody tr td.with-radio,
.table tbody tr th.with-btn,
.table tbody tr th.with-btn-group,
.table tbody tr th.with-checkbox,
.table tbody tr th.with-form-control,
.table tbody tr th.with-img,
.table tbody tr th.with-input-group,
.table tbody tr th.with-radio,
.table tfoot tr td.with-btn,
.table tfoot tr td.with-btn-group,
.table tfoot tr td.with-checkbox,
.table tfoot tr td.with-form-control,
.table tfoot tr td.with-img,
.table tfoot tr td.with-input-group,
.table tfoot tr td.with-radio,
.table tfoot tr th.with-btn,
.table tfoot tr th.with-btn-group,
.table tfoot tr th.with-checkbox,
.table tfoot tr th.with-form-control,
.table tfoot tr th.with-img,
.table tfoot tr th.with-input-group,
.table tfoot tr th.with-radio,
.table thead tr td.with-btn,
.table thead tr td.with-btn-group,
.table thead tr td.with-checkbox,
.table thead tr td.with-form-control,
.table thead tr td.with-img,
.table thead tr td.with-input-group,
.table thead tr td.with-radio,
.table thead tr th.with-btn,
.table thead tr th.with-btn-group,
.table thead tr th.with-checkbox,
.table thead tr th.with-form-control,
.table thead tr th.with-img,
.table thead tr th.with-input-group,
.table thead tr th.with-radio {
  padding-top: 4px;
  padding-bottom: 4px;
}

.legend > table tbody tr + tr td,
.table tbody tr td.with-checkbox .checkbox,
.table tbody tr td.with-checkbox .radio,
.table tbody tr td.with-radio .checkbox,
.table tbody tr td.with-radio .radio,
.table tbody tr th.with-checkbox .checkbox,
.table tbody tr th.with-checkbox .radio,
.table tbody tr th.with-radio .checkbox,
.table tbody tr th.with-radio .radio,
.table tfoot tr td.with-checkbox .checkbox,
.table tfoot tr td.with-checkbox .radio,
.table tfoot tr td.with-radio .checkbox,
.table tfoot tr td.with-radio .radio,
.table tfoot tr th.with-checkbox .checkbox,
.table tfoot tr th.with-checkbox .radio,
.table tfoot tr th.with-radio .checkbox,
.table tfoot tr th.with-radio .radio,
.table thead tr td.with-checkbox .checkbox,
.table thead tr td.with-checkbox .radio,
.table thead tr td.with-radio .checkbox,
.table thead tr td.with-radio .radio,
.table thead tr th.with-checkbox .checkbox,
.table thead tr th.with-checkbox .radio,
.table thead tr th.with-radio .checkbox,
.table thead tr th.with-radio .radio {
  padding-top: 0;
}

.table.table-transparent {
  color: rgba(255, 255, 255, 0.75);
  background: 0 0;
}

.table.table-transparent tbody tr td,
.table.table-transparent tbody tr th,
.table.table-transparent tfoot tr td,
.table.table-transparent tfoot tr th,
.table.table-transparent thead tr td,
.table.table-transparent thead tr th {
  border-color: rgba(255, 255, 255, 0.15);
}

.table.table-transparent thead tr th {
  border-bottom-color: rgba(255, 255, 255, 0.5);
}

.table:not(.table-bordered) thead tr th {
  border-top: none;
}

.theme-panel {
  position: fixed;
  right: -175px;
  top: 150px;
  z-index: 1020;
  background: #fff;
  padding: 15px;
  width: 175px;
  -webkit-transition: right 0.2s linear;
  -moz-transition: right 0.2s linear;
  -ms-transition: right 0.2s linear;
  -o-transition: right 0.2s linear;
  transition: right 0.2s linear;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

.theme-panel .theme-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.theme-panel .theme-list + .theme-list {
  margin-top: 10px;
}

.theme-panel .theme-list > li > a {
  width: 20px;
  height: 20px;
  display: block;
  text-decoration: none;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.theme-panel .theme-list > li > a:focus,
.theme-panel .theme-list > li > a:hover {
  opacity: 0.6;
}

.theme-panel .theme-list > li.active > a,
.timeline,
.timeline > li {
  position: relative;
}

.theme-panel .theme-list > li.active > a:before,
.theme-panel .theme-version a span {
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.theme-panel .theme-list > li.active > a:before {
  content: "\\f00c";
  color: #fff;
  opacity: 0.4;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  font-weight: 900;
}

.theme-panel .theme-collapse-btn {
  position: absolute;
  left: -30px;
  top: 10%;
  margin-top: -15px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  color: #2d353c;
  background: #fff;
  text-align: center;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

@media (max-width: 767.98px) {
  .theme-panel .theme-collapse-btn {
    top: 35%;
  }
}

.theme-panel .theme-panel-content {
  margin: -15px;
  padding: 15px;
  background: #fff;
  position: relative;
  z-index: 10;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

.theme-panel .theme-version {
  margin: 0 0 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.theme-panel .theme-version a {
  width: calc(50% - 2.5px);
  padding-top: 35%;
  position: relative;
  text-decoration: none;
}

.theme-panel .theme-version a + a {
  margin-left: 5px;
}

.theme-panel .theme-version a span {
  font-weight: 700;
  margin: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top left;
}

.theme-panel .theme-version a.active:before,
.theme-panel .theme-version a:hover:before {
  content: "";
  position: absolute;
  border: 12px solid transparent;
  left: 0;
  top: 0;
  z-index: 10;
}

.theme-panel .theme-version a:hover:before {
  border-left-color: #9ba8b4;
  border-top-color: #9ba8b4;
}

.theme-panel .theme-version a.active:after,
.theme-panel .theme-version a:hover:after {
  content: "\\f00c";
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  z-index: 10;
  width: 16px;
  height: 16px;
  line-height: 16px;
  font-size: 10px;
  text-align: center;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.theme-panel .theme-version a.active:before {
  border-left-color: #007aff;
  border-top-color: #007aff;
}

.theme-panel .control-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.theme-panel .divider {
  height: 1px;
  margin: 15px 0;
  background: #d5dbe0;
}

.theme-panel.active {
  right: 0;
  -webkit-box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
}

.theme-panel.active .theme-collapse-btn .fa:before {
  content: "\\f00d";
}

.theme-panel.active a.bg-white {
  border: 1px solid #c6ced5;
}

.theme-panel.theme-panel-lg {
  top: 0;
  bottom: 0;
  width: 260px;
  right: -260px;
}

.theme-panel.theme-panel-lg .theme-list {
  margin-bottom: -3px;
}

.theme-panel.theme-panel-lg .theme-list > li {
  margin-right: 3px;
  margin-bottom: 3px;
}

.theme-panel.theme-panel-lg .theme-list > li + li {
  margin-left: 0;
}

.theme-panel.theme-panel-lg .theme-list > li > a {
  width: 28px;
  height: 28px;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.theme-panel.theme-panel-lg .theme-list > li > a:before {
  line-height: 28px;
}

.theme-panel.theme-panel-lg .theme-version {
  margin: 0 0 5px;
}

.theme-panel.theme-panel-lg .theme-panel-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  margin: 0;
  padding: 20px;
}

.theme-panel.theme-panel-lg .theme-collapse-btn {
  top: 30%;
}

@media (max-width: 767.98px) {
  .theme-panel.theme-panel-lg .theme-collapse-btn {
    top: 35%;
  }
}

.theme-panel.theme-panel-lg.active {
  right: 0;
}

.timeline {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.timeline:before {
  content: "";
  position: absolute;
  top: 5px;
  bottom: 5px;
  width: 5px;
  background: #2d353c;
  left: 20%;
  margin-left: -2.5px;
}

@media (max-width: 991.98px) {
  .timeline:before {
    left: 15%;
  }
}

@media (max-width: 575.98px) {
  .timeline:before {
    left: 50%;
  }
}

.timeline > li {
  min-height: 50px;
  padding: 20px 0;
}

.timeline .timeline-time {
  position: absolute;
  left: 0;
  width: 18%;
  text-align: right;
  top: 30px;
}

@media (max-width: 991.98px) {
  .timeline .timeline-time {
    width: 12%;
  }
}

@media (max-width: 575.98px) {
  .timeline .timeline-time {
    width: 50%;
    text-align: right;
    padding-right: 20px;
  }
}

.timeline .timeline-time .date {
  display: block;
  font-weight: 600;
  line-height: 16px;
  font-size: 12px;
}

.timeline .timeline-time .time {
  display: block;
  font-weight: 600;
  line-height: 24px;
  font-size: 20px;
  color: #2d353c;
}

.timeline .timeline-icon {
  left: 15%;
  position: absolute;
  width: 10%;
  text-align: center;
  top: 40px;
}

@media (max-width: 991.98px) {
  .timeline .timeline-icon {
    left: 10%;
  }
}

@media (max-width: 575.98px) {
  .timeline .timeline-icon {
    left: 45%;
  }
}

.timeline .timeline-icon a {
  text-decoration: none;
  width: 20px;
  height: 20px;
  display: inline-block;
  background: #d9e0e7;
  line-height: 10px;
  color: #fff;
  font-size: 14px;
  border: 5px solid #2d353c;
  -webkit-transition: border-color 0.2s linear;
  -moz-transition: border-color 0.2s linear;
  -ms-transition: border-color 0.2s linear;
  -o-transition: border-color 0.2s linear;
  transition: border-color 0.2s linear;
  -webkit-border-radius: 24px;
  border-radius: 24px;
}

.timeline .timeline-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #d5dbe0;
  line-height: 30px;
}

.timeline .timeline-header .userimage {
  float: left;
  width: 34px;
  height: 34px;
  overflow: hidden;
  margin: -2px 10px -2px 0;
  -webkit-border-radius: 36px;
  border-radius: 36px;
}

.timeline .timeline-header .username {
  font-size: 16px;
  font-weight: 600;
  color: #2d353c;
}

.timeline .timeline-header .username a {
  color: #2d353c;
}

.timeline .timeline-header .views {
  float: right;
  color: #6f8293;
  font-weight: 600;
}

.timeline .timeline-body {
  margin-left: 23%;
  margin-right: 17%;
  background: #fff;
  position: relative;
  padding: 20px 25px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

@media (max-width: 1199.98px) {
  .timeline .timeline-body {
    margin-left: 25%;
    margin-right: 10%;
  }
}

@media (max-width: 991.98px) {
  .timeline .timeline-body {
    margin-left: 20%;
    margin-right: 0;
  }
}

@media (max-width: 575.98px) {
  .timeline .timeline-body {
    margin-left: 0;
    margin-top: 60px;
    padding: 15px;
  }
}

.timeline .timeline-body:before {
  content: "";
  display: block;
  position: absolute;
  border: 10px solid transparent;
  border-right-color: #fff;
  left: -20px;
  top: 20px;
}

@media (max-width: 575.98px) {
  .timeline .timeline-body:before {
    border-right-color: transparent;
    border-bottom-color: #fff;
    left: 50%;
    margin-left: -10px;
    top: -20px;
  }
}

.timeline .timeline-body > div + div:last-child {
  margin-bottom: -20px;
  padding-bottom: 20px;
  -webkit-border-radius: 0 0 6px 6px;
  border-radius: 0 0 6px 6px;
}

@media (max-width: 575.98px) {
  .timeline .timeline-body > div + div:last-child {
    margin-bottom: -15px;
    padding-bottom: 15px;
  }
}

.timeline .timeline-content {
  letter-spacing: 0.25px;
  line-height: 18px;
  font-size: 13px;
}

.timeline .timeline-content:after,
.timeline .timeline-content:before {
  content: "";
  display: table;
  clear: both;
}

.timeline .timeline-title {
  margin-top: 0;
}

.timeline .timeline-footer {
  background: #fff;
  border-top: 1px solid #d5dbe0;
  padding-top: 15px;
  font-weight: 600;
}

.timeline .timeline-footer a:not(.btn) {
  color: #6f8293;
}

.timeline .timeline-footer a:not(.btn):focus,
.timeline .timeline-footer a:not(.btn):hover {
  color: #2d353c;
}

.timeline .timeline-likes {
  color: #6f8293;
  font-weight: 600;
  font-size: 12px;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.timeline .timeline-likes .stats-right {
  margin-left: auto;
}

.timeline .timeline-likes,
.timeline .timeline-likes .stats {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.timeline .timeline-likes .stats .stats-icon {
  font-size: 9px;
}

.timeline .timeline-likes .stats-total {
  margin-left: 3px;
  line-height: 20px;
}

.timeline .timeline-likes .stats-text {
  line-height: 20px;
}

.timeline .timeline-likes .stats-text + .stats-text {
  margin-left: 10px;
}

.timeline .timeline-comment-box {
  background: #f2f3f4;
  margin-left: -25px;
  margin-right: -25px;
  padding: 20px 25px;
}

@media (max-width: 575.98px) {
  .timeline .timeline-comment-box {
    margin-left: -15px;
    margin-right: -15px;
    padding: 15px;
  }
}

.timeline .timeline-comment-box .user {
  float: left;
  width: 34px;
  height: 34px;
  overflow: hidden;
  -webkit-border-radius: 36px;
  border-radius: 36px;
}

.timeline .timeline-comment-box .user + .input {
  margin-left: 44px;
}

.todolist {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.todolist > li {
  border-bottom: 1px solid #e4e7ea;
}

.todolist > li > a {
  display: block;
  color: #2d353c;
}

.todolist > li > a .todolist-input,
.todolist > li > a .todolist-title {
  display: table-cell;
  padding: 10px;
}

.todolist > li > a .todolist-input {
  text-align: center;
  font-size: 14px;
  border-right: 1px solid #e4e7ea;
  color: #e4e7ea;
}

.todolist > li > a .todolist-input i {
  display: block;
  width: 14px;
  text-align: center;
}

.todolist > li > a:focus,
.todolist > li > a:hover {
  background: #f2f3f4;
  text-decoration: none;
}

.todolist > li > a:focus .todolist-input i:before,
.todolist > li > a:hover .todolist-input i:before {
  content: "\\f14a";
  color: rgba(45, 53, 60, 0.4);
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.todolist > li.active > a .todolist-title {
  text-decoration: line-through;
}

.todolist > li.active > a i:before {
  content: "\\f14a";
  color: #00acac;
}

.todolist > li.active > a:focus i:before,
.todolist > li.active > a:hover i:before {
  color: #00acac;
}

@media (min-width: 992px) {
  .vertical-box {
    display: table;
    table-layout: fixed;
    border-spacing: 0;
    height: 100%;
    width: 100%;
  }
}

@media (max-width: 991.98px) {
  .vertical-box .vertical-box-column {
    width: 100% !important;
  }
}

@media (min-width: 992px) {
  .vertical-box-column {
    display: table-cell;
    vertical-align: top;
    height: 100%;
  }

  .vertical-box-row {
    display: table-row;
    height: 100%;
  }
}

.vertical-box-row > .vertical-box-cell {
  position: relative;
  height: 100%;
  width: 100%;
  float: none;
}

@media (min-width: 992px) {
  .vertical-box-row > .vertical-box-cell > .vertical-box-inner-cell {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }

  .vertical-box.with-grid > .vertical-box-column + .vertical-box-column {
    border-left: 1px solid #d5dbe0;
  }
}

@media (max-width: 991.98px) {
  .vertical-box.with-grid > .vertical-box-column + .vertical-box-column {
    border-top: 1px solid #d5dbe0;
  }
}

.vertical-box.with-border-top,
.vertical-box.with-grid,
.vertical-box.with-grid .vertical-box-row + .vertical-box-row > div,
.vertical-box.with-grid .vertical-box-row + .wrapper,
.vertical-box.with-grid .wrapper + .vertical-box-row > div,
.vertical-box.with-grid .wrapper + .wrapper,
div + .widget-input {
  border-top: 1px solid #d5dbe0;
}

.vertical-box.with-border-bottom,
body table.dataTable.collapsed tbody tr td .dtr-details > li {
  border-bottom: 1px solid #d5dbe0;
}

.widget-card {
  position: relative;
  margin-bottom: 15px;
  display: block;
  text-decoration: none !important;
}

.widget-card .widget-card-content {
  padding: 15px;
  position: relative;
}

.widget-card .widget-card-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
}

.widget-card .widget-card-cover .widget-card-cover-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40%;
  height: 40%;
  margin: -20% 0 0 -20%;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.widget-card .widget-card-cover .widget-card-cover-icon .fa {
  font-size: 1.5vw;
  line-height: 1.5vw;
}

.widget-card.widget-card-rounded .widget-card-content,
.widget-card.widget-card-rounded .widget-card-cover,
.widget-chart {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-card.square {
  padding-top: 100%;
  overflow: hidden;
}

.widget-card.square .widget-card-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.widget-card.square .widget-card-content.bottom {
  top: auto;
}

.inverse-mode .widget-card,
.inverse-mode.widget-card,
.widget-chart .widget-chart-sidebar .chart-legend > li {
  color: #fff;
}

.inverse-mode .widget-card .widget-card-cover,
.inverse-mode.widget-card .widget-card-cover {
  background-color: #2d353c;
}

.widget-chart {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
}

@media (min-width: 576px) {
  .widget-chart {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}

.widget-chart .chart-title {
  font-size: 16px !important;
  line-height: 20px;
  color: #fff;
  font-weight: 600 !important;
  margin: 2px 5px 5px;
}

.widget-chart .widget-chart-content {
  padding: 15px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

@media (min-width: 768px) {
  .widget-chart .widget-chart-content + .widget-chart-sidebar {
    -webkit-border-radius: 0 4px 4px 0;
    border-radius: 0 4px 4px 0;
  }
}

@media (max-width: 575.98px) {
  .widget-chart .widget-chart-content + .widget-chart-sidebar {
    -webkit-border-radius: 0 0 4px 4px;
    border-radius: 0 0 4px 4px;
  }
}

.widget-chart .widget-chart-full-width {
  margin: 0 -15px;
}

.widget-chart .widget-chart-sidebar {
  padding: 15px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

@media (min-width: 768px) {
  .widget-chart .widget-chart-sidebar {
    width: 230px;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .widget-chart .widget-chart-sidebar {
    width: 200px;
  }
}

.widget-chart .widget-chart-sidebar .chart-number {
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  color: #fff;
}

.widget-chart .chart-title small,
.widget-chart .widget-chart-sidebar .chart-number small {
  font-size: 12px;
  line-height: 16px;
  margin-top: 3px;
  color: #9ba8b4;
  display: block;
  font-weight: 400;
}

.widget-chart .widget-chart-sidebar .chart-legend {
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
}

.widget-chart .widget-chart-sidebar .chart-legend > li span {
  color: #9ba8b4;
  margin-left: 5px;
  font-weight: 400;
}

.widget-chart .widget-chart-sidebar .chart-legend > li + li {
  margin-top: 5px;
}

.widget-chart-info {
  color: #2d353c;
}

.widget-chart-info .widget-chart-info-title {
  margin: 0 0 5px;
  font-size: 14px;
}

.widget-chart-info .widget-chart-info-desc {
  font-size: 11px;
  color: #4e5c68;
  margin-bottom: 20px;
}

.widget-chart-info .widget-chart-info-progress {
  font-size: 11px;
  margin-bottom: 5px;
}

.widget-chart-info .widget-chart-info-progress .progress {
  margin-bottom: 0;
}

.widget-chart-content {
  padding: 10px;
  background: #f2f3f4;
}

.inverse-mode .widget-chart-content {
  background: #1d2226;
}

.inverse-mode .widget-chart-info {
  color: #c6ced5;
}

.inverse-mode .widget-chart-info .widget-chart-info-desc {
  color: #9ba8b4;
}

.inverse-mode .nvd3 text {
  fill: rgba(255, 255, 255, 0.75);
}

.inverse-mode .nvd3 .nv-axis line,
.inverse-mode .nvd3 .nv-axis path {
  stroke: rgba(255, 255, 255, 0.15);
}

.widget-chat {
  background: #fff;
}

.widget-chat .widget-chat-header {
  display: table;
  width: 100%;
  border-bottom: 1px solid #d5dbe0;
}

.widget-chat .widget-chat-header > div + div,
.widget-list .widget-list-item .widget-list-action + div,
.widget-list .widget-list-item .widget-list-content + div,
.widget-list .widget-list-item .widget-list-media + div,
.widget-todolist .widget-todolist-item .widget-todolist-input + div {
  padding-left: 0;
}

.widget-chat .widget-chat-header .widget-chat-header-icon {
  width: 1%;
}

.widget-chat .widget-chat-header .widget-chat-header-content,
.widget-chat .widget-chat-header .widget-chat-header-icon {
  padding: 12px 15px;
  display: table-cell;
  vertical-align: middle;
}

.widget-chat .widget-chat-header .widget-chat-header-title {
  font-size: 14px;
  margin: 0;
}

.widget-chat .widget-chat-header .widget-chat-header-desc {
  font-size: 12px;
  margin: 0;
}

.widget-chat .widget-chat-body {
  padding: 15px;
  background: #e4e7ea;
}

.widget-chat .widget-chat-item {
  color: #2d353c;
  position: relative;
  min-height: 38px;
  padding: 3px 0;
}

.widget-chat .widget-chat-media {
  width: 38px;
  height: 38px;
  position: absolute;
  bottom: 3px;
  left: 0;
  overflow: hidden;
  text-align: center;
  line-height: 38px;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.widget-chat .widget-chat-media img {
  max-width: 100%;
  max-height: 100%;
  display: block;
}

.widget-chat .widget-chat-info-container {
  background: #fff;
  display: inline-block;
  padding: 8px 12px;
  position: relative;
  color: #fff;
  -webkit-border-radius: 16px;
  border-radius: 16px;
}

.widget-chat .widget-chat-message {
  font-weight: 600;
  color: #2d353c;
}

.widget-chat .widget-chat-message:before {
  content: "";
  position: absolute;
  bottom: 0;
  left: -24px;
  border: 0 solid transparent;
  border-top-width: 15px;
  border-right-width: 10px;
  border-right-color: #fff;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  -webkit-transform: rotate(10deg);
  -moz-transform: rotate(10deg);
  -ms-transform: rotate(10deg);
  -o-transform: rotate(10deg);
  transform: rotate(10deg);
}

.widget-chat .widget-chat-message:after {
  content: "";
  display: inline-block;
  width: 60px;
  height: 12px;
}

.widget-chat .widget-chat-name {
  font-weight: 600;
}

.widget-chat .widget-chat-time {
  position: absolute;
  right: 12px;
  bottom: 8px;
  font-style: italic;
  color: #9ba8b4;
  font-weight: 600;
  font-size: 10px;
}

.widget-chat .with-media .widget-chat-info {
  margin-left: 53px;
  min-width: 60%;
}

.widget-chat .with-media .right .widget-chat-info {
  margin-right: 53px;
}

.widget-chat .right .widget-chat-media {
  left: auto;
  right: 0;
}

.widget-chat .right .widget-chat-info {
  margin-left: 0;
  text-align: right;
}

.widget-chat .right .widget-chat-time {
  right: auto;
  left: 12px;
}

.widget-chat .right .widget-chat-message:after {
  float: left;
}

.widget-chat .right .widget-chat-message:before {
  left: auto;
  right: -24px;
  bottom: -5px;
  border-right-width: 0;
  border-right-color: transparent;
  border-left-width: 10px;
  border-left-color: #fff;
}

.widget-chat.widget-chat-rounded {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-chat.widget-chat-rounded.widget-chat-input {
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.inverse-mode.widget-chat {
  background: #2d353c;
}

.inverse-mode.widget-chat .widget-chat-header {
  border-color: #2d353c;
}

.inverse-mode.widget-chat .widget-chat-header-title {
  color: #fff;
}

.inverse-mode.widget-chat .widget-chat-header-desc {
  color: #c6ced5;
}

.inverse-mode.widget-chat .widget-chat-body {
  background: #1a2229;
}

.widget-icon,
.widget-img {
  overflow: hidden;
  width: 40px;
  height: 40px;
}

.widget-icon {
  position: relative;
  font-size: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.widget-icon.user {
  font-size: 36px;
}

.widget-icon.user i {
  display: block;
  margin: 0 auto;
  padding-top: 38%;
}

.widget-icon.widget-icon-xs {
  width: 20px;
  height: 20px;
  font-size: 14px;
}

.widget-icon.widget-icon-xs.user {
  font-size: 18px;
}

.widget-icon.widget-icon-sm {
  width: 30px;
  height: 30px;
  font-size: 21px;
}

.widget-icon.widget-icon-sm.user {
  font-size: 27px;
}

.widget-icon.widget-icon-lg {
  width: 60px;
  height: 60px;
  font-size: 42px;
}

.widget-icon.widget-icon-lg.user {
  font-size: 54px;
}

.widget-icon.widget-icon-xl {
  width: 80px;
  height: 80px;
  font-size: 56px;
}

.widget-icon.widget-icon-xl.user {
  font-size: 72px;
}

.widget-img {
  line-height: 40px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.widget-img.widget-img-xl {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

.widget-img.widget-img-lg {
  width: 60px;
  height: 60px;
  line-height: 60px;
}

.widget-img.widget-img-sm {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.widget-img.widget-img-xs {
  width: 20px;
  height: 20px;
  line-height: 20px;
}

div + .widget-input.widget-input-rounded {
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.widget-input {
  position: relative;
  background: #fff;
}

.widget-input.widget-input-rounded {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-input-container {
  display: table;
  width: 100%;
}

.widget-input-container .widget-input-icon {
  display: table-cell;
  vertical-align: middle;
  width: 1%;
  padding: 0 5px;
}

.widget-input-container .widget-input-icon a {
  display: block;
  padding: 10px;
  font-size: 18px;
}

.widget-input-container .widget-input-box {
  display: table-cell;
  vertical-align: middle;
  padding: 5px 0;
}

.widget-input-container .widget-input-box .form-control {
  border-color: #f2f4f5;
  background: #f2f4f5;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.widget-input-container .widget-input-box .form-control:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.widget-input-container .widget-input-divider {
  display: table-cell;
  vertical-align: middle;
  width: 1px;
}

.widget-input-container .widget-input-divider:after {
  content: "";
  width: 1px;
  height: 26px;
  background: #d5dbe0;
  display: block;
}

.inverse-mode .widget-input,
.inverse-mode.widget-input {
  background: #2d353c;
}

.inverse-mode .widget-input-box .form-control {
  background: #3d4852;
  border-color: #3d4852;
  color: #fff;
}

.inverse-mode .widget-input-box .form-control::-webkit-input-placeholder,
.inverse-mode.widget-todolist
  .widget-todolist-item
  .widget-todolist-content
  .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.inverse-mode .widget-input-box .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.inverse-mode .widget-input-box .form-control:-ms-input-placeholder,
.inverse-mode.widget-todolist
  .widget-todolist-item
  .widget-todolist-content
  .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.inverse-mode .widget-input-box .form-control:-moz-placeholder,
.inverse-mode.widget-todolist
  .widget-todolist-item
  .widget-todolist-content
  .form-control:-moz-placeholder,
.inverse-mode.widget-todolist
  .widget-todolist-item
  .widget-todolist-content
  .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.inverse-mode .widget-input-divider:after,
.widget.inverse-mode hr {
  background: #4e5c68;
}

.inverse-mode div + .widget-input,
div + .widget-input.inverse-mode {
  border-color: #2d353c;
}

.widget-list .widget-list-item {
  display: table;
  width: 100%;
  background: #fff;
  text-decoration: none;
  color: #2d353c;
}

.widget-list .widget-list-item + .widget-list-item .widget-list-action,
.widget-list .widget-list-item + .widget-list-item .widget-list-content {
  border-top: 1px solid #e4e7ea;
}

.widget-list .widget-list-item .widget-list-media {
  width: 70px;
  height: 60px;
}

.widget-list .widget-list-item .widget-list-media.icon {
  width: 30px;
  height: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.widget-list .widget-list-item .widget-list-media.icon i {
  display: block;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.widget-list .widget-list-item .widget-list-content,
.widget-list .widget-list-item .widget-list-media {
  padding: 10px;
  display: table-cell;
  vertical-align: middle;
}

.widget-list .widget-list-item .widget-list-action {
  display: table-cell;
  vertical-align: middle;
  width: 10%;
  padding: 10px 10px 10px 15px;
  text-align: center;
}

.widget-list .widget-list-item .widget-list-title {
  font-size: 12px;
  line-height: 16px;
  margin: 0;
}

.widget-list .widget-list-item .widget-list-desc {
  font-size: 11px;
  margin: 0;
  color: #6f8293;
}

.widget-list.widget-list-rounded .widget-list-item:first-child,
.widget-list.widget-list-rounded.widget-list-item:first-child {
  -webkit-border-top-right-radius: 4px;
  border-top-right-radius: 4px;
  -webkit-border-top-left-radius: 4px;
  border-top-left-radius: 4px;
}

.widget-list.widget-list-rounded .widget-list-item:last-child,
.widget-list.widget-list-rounded.widget-list-item:last-child {
  -webkit-border-bottom-right-radius: 4px;
  border-bottom-right-radius: 4px;
  -webkit-border-bottom-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.inverse-mode .widget-list-item,
.inverse-mode.widget-list-item {
  background: #2d353c;
}

.inverse-mode .widget-list-item + .widget-list-item .widget-list-action,
.inverse-mode .widget-list-item + .widget-list-item .widget-list-content,
.inverse-mode.widget-list-item + .widget-list-item .widget-list-action,
.inverse-mode.widget-list-item + .widget-list-item .widget-list-content {
  border-color: #3d4852;
}

.inverse-mode .widget-list-item .widget-list-title,
.inverse-mode.widget-list-item .widget-list-title,
.widget-table.table.inverse-mode thead th {
  color: #fff;
}

.inverse-mode .widget-list-item .widget-list-desc,
.inverse-mode.widget-list-item .widget-list-desc {
  color: #c6ced5;
}

.widget-map {
  background: #fff;
}

.widget-map.widget-map-rounded {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-map.inverse-mode {
  background: #2d353c;
}

.widget-stats,
.widget.widget-stats {
  position: relative;
  color: #fff;
  padding: 15px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-stats .stats-info h4,
.widget.widget-stats .stats-info h4 {
  font-size: 12px;
  margin: 5px 0;
  color: rgba(255, 255, 255, 0.7);
}

.widget-stats .stats-info p,
.widget.widget-stats .stats-info p {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0;
}

.widget-stats .stats-link a,
.widget.widget-stats .stats-link a {
  display: block;
  margin: 15px -15px -15px;
  padding: 7px 15px;
  background: rgba(0, 0, 0, 0.4);
  text-align: right;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}

.widget-stats .stats-link a:focus,
.widget-stats .stats-link a:hover,
.widget.widget-stats .stats-link a:focus,
.widget.widget-stats .stats-link a:hover {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.widget-stats .stats-icon,
.widget.widget-stats .stats-icon {
  font-size: 42px;
  height: 56px;
  width: 56px;
  text-align: center;
  line-height: 56px;
  color: rgba(0, 0, 0, 0.15);
  position: absolute;
  right: 15px;
  top: 15px;
  margin-left: 15px;
}

.widget-stats .stats-icon.stats-icon-lg,
.widget.widget-stats .stats-icon.stats-icon-lg {
  font-size: 128px;
  top: 15px;
  right: 0;
  color: #fff;
  width: 128px;
  height: 50px;
  line-height: 50px;
  text-shadow: 3px 7px rgba(0, 0, 0, 0.25);
  opacity: 0.15;
}

.widget-stats .stats-icon.stats-icon-square,
.widget.widget-stats .stats-icon.stats-icon-square {
  opacity: 1;
  font-size: 42px;
  top: 15px;
  right: 15px;
  height: 56px;
  width: 56px;
  text-align: center;
  line-height: 56px;
  margin-left: 15px;
  -webkit-border-radius: 16px;
  border-radius: 16px;
}

.widget-stats .stats-content,
.widget-stats .stats-icon.stats-icon-lg i,
.widget.widget-stats .stats-content,
.widget.widget-stats .stats-icon.stats-icon-lg i {
  position: relative;
}

.widget-stats .stats-title,
.widget.widget-stats .stats-title {
  position: relative;
  margin: 0 0 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.widget-stats .stats-desc,
.widget.widget-stats .stats-desc {
  margin: -5px 0 -3px;
  color: rgba(255, 255, 255, 0.7);
}

.widget-stats .stats-number,
.widget.widget-stats .stats-number {
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: 600;
  letter-spacing: 1px;
}

.widget-stats .stats-progress,
.widget.widget-stats .stats-progress {
  background: rgba(0, 0, 0, 0.5);
  height: 2px;
  margin: 0 0 15px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-stats .stats-progress .progress-bar,
.widget.widget-stats .stats-progress .progress-bar {
  background: #fff;
  -webkit-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}

.widget-stats .stats-progress.stats-progress-light,
.widget.widget-stats .stats-progress.stats-progress-light {
  background: rgba(255, 255, 255, 0.3);
}

.widget-stats.text-inverse.stats-desc,
.widget.widget-stats.text-inverse.stats-desc {
  letter-spacing: 0;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}

.widget-stats.text-inverse.stats-title,
.widget.widget-stats.text-inverse.stats-title {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}

.widget-stats.text-inverse.stats-number,
.widget.widget-stats.text-inverse.stats-number {
  letter-spacing: 0;
  font-weight: 400;
}

.widget-stats.bg-white .stats-progress,
.widget.widget-stats.bg-white .stats-progress {
  background: rgba(0, 0, 0, 0.1);
}

.widget-stats.bg-white .stats-progress .progress-bar,
.widget.widget-stats.bg-white .stats-progress .progress-bar {
  background: #2d353c;
}

.widget-table.table {
  background: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-table.table .widget-table-img {
  width: 100px;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget-table.table .widget-table-title {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
}

.widget-table.table .widget-table-desc {
  margin: 0;
  font-size: 11px;
  line-height: 16px;
  color: #4e5c68;
}

.widget-table.table.table-bordered {
  border: 0;
}

.widget-table.table.table-bordered > tbody > tr td:first-child,
.widget-table.table.table-bordered > thead > tr th:first-child {
  border-left: none;
}

.widget-table.table.table-bordered > tbody > tr td:last-child,
.widget-table.table.table-bordered > thead > tr th:last-child {
  border-right: none;
}

.widget-table.table.table-bordered > tbody > tr:last-child > td {
  border-bottom: none;
}

.widget-table.table.table-bordered > thead:first-child > tr:first-child > td,
.widget-table.table.table-bordered > thead:first-child > tr:first-child > th {
  border-top: none;
}

.widget-table.table.inverse-mode {
  background: #2d353c;
  color: #c6ced5;
}

.widget-table.table.inverse-mode .widget-table-desc {
  color: #9ba8b4;
}

.widget-table.table.inverse-mode thead > tr > th {
  border-bottom-color: #4e5c68 !important;
}

.widget-table.table.inverse-mode tbody tr td,
.widget-table.table.inverse-mode tbody tr th,
.widget-table.table.inverse-mode tfoot tr td,
.widget-table.table.inverse-mode tfoot tr th,
.widget-table.table.inverse-mode thead tr td,
.widget-table.table.inverse-mode thead tr th {
  border-color: #3d4852;
}

.widget-todolist {
  background: #fff;
}

.widget-todolist:after,
.widget-todolist:before {
  content: "";
  display: table;
  clear: both;
}

.widget-todolist .widget-todolist-header {
  display: table;
  width: 100%;
}

.widget-todolist .widget-todolist-header .widget-todolist-header-left,
.widget-todolist .widget-todolist-header .widget-todolist-header-right {
  display: table-cell;
  vertical-align: middle;
  padding: 10px 15px;
}

.widget-todolist .widget-todolist-header .widget-todolist-header-right {
  width: 1%;
  text-align: center;
}

.widget-todolist .widget-todolist-header .widget-todolist-header-title {
  margin: 0;
  font-size: 18px;
  font-weight: 400;
}

.widget-todolist .widget-todolist-header .widget-todolist-header-total {
  font-size: 18px;
  font-weight: 600;
  color: #2d353c;
}

.widget-todolist .widget-todolist-header .widget-todolist-header-total small {
  display: block;
  font-size: 10px;
  line-height: 1;
}

.widget-todolist .widget-todolist-body {
  padding: 3px 0;
  border-top: 1px solid #e4e7ea;
  border-bottom: 1px solid #e4e7ea;
  margin-bottom: 20px;
}

.widget-todolist .widget-todolist-item {
  display: table;
  width: 100%;
}

.widget-todolist .widget-todolist-item .widget-todolist-icon {
  display: table-cell;
  padding: 10px 15px;
  vertical-align: middle;
  width: 1%;
  text-align: center;
  border-top: 1px solid #d5dbe0;
}

.widget-todolist .widget-todolist-item .widget-todolist-input {
  display: table-cell;
  padding: 10px 15px;
  vertical-align: middle;
  width: 45px;
  text-align: center;
}

.widget-todolist .widget-todolist-item .widget-todolist-content {
  display: table-cell;
  padding: 10px 15px;
  vertical-align: middle;
  border-top: 1px solid #e4e7ea;
}

.widget-todolist .widget-todolist-item .widget-todolist-content .form-control {
  margin: -5px 0;
  border: 0 !important;
  padding-left: 0;
  background: 0 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  -webkit-border-radius: 0 !important;
  border-radius: 0 !important;
}

.widget-todolist .widget-todolist-item .widget-todolist-desc,
.widget-todolist .widget-todolist-item .widget-todolist-title {
  font-size: 12px;
  margin: 0;
}

.widget-todolist .widget-todolist-item:first-child .widget-todolist-content,
.widget-todolist .widget-todolist-item:first-child .widget-todolist-icon {
  border-top: none;
}

.widget-todolist.widget-todolist-rounded {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.inverse-mode.widget-todolist {
  background: #2d353c;
}

.bootstrap-calendar .calendar .table.daysmonth tr td.event a,
.inverse-mode.widget-todolist
  .widget-todolist-header
  .widget-todolist-header-title,
.inverse-mode.widget-todolist
  .widget-todolist-header
  .widget-todolist-header-total,
.inverse-mode.widget-todolist
  .widget-todolist-item
  .widget-todolist-content
  .form-control,
.inverse-mode.widget-todolist .widget-todolist-item .widget-todolist-title {
  color: #fff;
}

.inverse-mode.widget-todolist .widget-todolist-body,
.inverse-mode.widget-todolist
  .widget-todolist-item
  + .widget-todolist-item
  .widget-todolist-content,
.inverse-mode.widget-todolist
  .widget-todolist-item
  + .widget-todolist-item
  .widget-todolist-icon {
  border-color: #3d4852;
}

.inverse-mode.widget-todolist .widget-todolist-item .widget-todolist-desc {
  color: #c6ced5;
}

.widget {
  overflow: hidden;
  margin-bottom: 20px;
  background: #fff;
  color: inherit;
  padding: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.widget .widget-header {
  display: table;
  width: 100%;
}

.widget .widget-header .widget-header-title {
  font-size: 12px;
  margin: 0;
  line-height: 20px;
  width: 100%;
  display: table-cell;
  padding: 10px 15px;
}

.widget .widget-header .widget-header-icon {
  width: 1%;
  display: table-cell;
  padding: 10px 15px;
}

.widget .widget-header .widget-header-icon + .widget-header-icon {
  padding-left: 0;
}

.widget .widget-body {
  padding: 15px;
}

.widget.widget-rounded {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.widget.inverse-mode {
  background: #2d353c;
}

.widget.inverse-mode .vertical-box.with-border-top,
.widget.inverse-mode
  .vertical-box.with-grid
  > .vertical-box-column
  + .vertical-box-column {
  border-color: #4e5c68;
}

.apexcharts-canvas .apexcharts-tooltip {
  border: 0 !important;
  font-size: inherit;
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}

.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-family: inherit !important;
  padding: 6px 12px;
  margin: 0;
  border: 0 !important;
  font-weight: 600;
}

.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  margin-right: 5px;
}

.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group {
  padding-left: 12px;
  padding-right: 12px;
}

.apexcharts-canvas
  .apexcharts-tooltip
  .apexcharts-tooltip-series-group
  .apexcharts-tooltip-y-group {
  padding: 6px 0;
}

.apexcharts-canvas
  .apexcharts-tooltip
  .apexcharts-tooltip-series-group
  + .apexcharts-tooltip-series-group {
  margin-top: -6px;
}

.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group.active,
.apexcharts-canvas
  .apexcharts-tooltip
  .apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0;
}

.apexcharts-canvas .apexcharts-tooltip.light .apexcharts-tooltip-title {
  background: #f2f3f4;
}

.apexcharts-canvas .apexcharts-tooltip.dark .apexcharts-tooltip-title {
  background: rgba(0, 0, 0, 0.5);
}

.apexcharts-canvas .apexcharts-xaxistooltip,
.apexcharts-canvas .apexcharts-yaxistooltip {
  border: 0 !important;
  font-size: inherit;
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.apexcharts-canvas .apexcharts-xaxistooltip:after,
.apexcharts-canvas .apexcharts-yaxistooltip:after,
body .datetimepicker .next:before,
body .datetimepicker .prev:before {
  display: none;
}

.apexcharts-canvas .apexcharts-xaxistooltip.light,
.apexcharts-canvas .apexcharts-yaxistooltip.light {
  background: #fff;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-top:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-top:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-top:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-top:before {
  border-top-color: #fff;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-bottom:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-bottom:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-bottom:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-bottom:before {
  border-bottom-color: #fff;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-left:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-left:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-left:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-left:before {
  border-left-color: #fff;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-right:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-right:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-right:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-right:before {
  border-right-color: #fff;
}

.apexcharts-canvas .apexcharts-xaxistooltip.dark,
.apexcharts-canvas .apexcharts-yaxistooltip.dark {
  background: #1a2229;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-top:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-top:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-top:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-top:before {
  border-top-color: #1a2229;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-bottom:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-bottom:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-bottom:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-bottom:before {
  border-bottom-color: #1a2229;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-left:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-left:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-left:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-left:before {
  border-left-color: #1a2229;
}

.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-right:before,
.apexcharts-canvas
  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-right:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-right:before,
.apexcharts-canvas
  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-right:before {
  border-right-color: #1a2229;
}

.apexcharts-canvas .apexcharts-legend.center .apexcharts-legend-series,
.apexcharts-canvas .apexcharts-legend.left .apexcharts-legend-series,
.apexcharts-canvas .apexcharts-legend.right .apexcharts-legend-series {
  padding: 5px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.apexcharts-canvas
  .apexcharts-legend.center
  .apexcharts-legend-series
  .apexcharts-legend-marker,
.apexcharts-canvas
  .apexcharts-legend.left
  .apexcharts-legend-series
  .apexcharts-legend-marker,
.apexcharts-canvas
  .apexcharts-legend.right
  .apexcharts-legend-series
  .apexcharts-legend-marker {
  margin-right: 5px;
  width: 8px !important;
  height: 8px !important;
}

.bootstrap-calendar .calendar {
  background: #fff;
  border: 0;
  padding: 7px 0 10px;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.bootstrap-calendar .calendar .table.header {
  padding: 0;
  margin: 0 0 2px;
  position: relative;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.bootstrap-calendar .calendar .table.header td {
  width: 45px;
  padding: 5px 15px;
  vertical-align: middle;
  border: 0;
}

.bootstrap-calendar .calendar .table.header td.year {
  width: calc(100% - 90px);
}

.bootstrap-calendar .calendar .table.header td .icon-arrow-left,
.bootstrap-calendar .calendar .table.header td .icon-arrow-right,
.bootstrap-calendar .calendar .table.header td .visualmonthyear {
  height: 100%;
  font-size: 16px;
  font-weight: 600;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.bootstrap-calendar .calendar .table.header td .icon-arrow-left,
.bootstrap-calendar .calendar .table.header td .icon-arrow-right {
  cursor: pointer;
  font-size: 14px;
  color: #c6ced5;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.bootstrap-calendar .calendar .table.header td .icon-arrow-left:before {
  content: "\\f060";
}

.bootstrap-calendar .calendar .table.header td .icon-arrow-right:before {
  content: "\\f061";
}

.bootstrap-calendar .calendar .table.daysmonth {
  margin: 0;
}

.bootstrap-calendar .calendar .table.daysmonth tr td {
  border: 0;
  padding: 7px 10px;
  font-weight: 600;
  color: #6f8293;
}

.bootstrap-calendar .calendar .table.daysmonth tr td a {
  display: block;
  text-shadow: none;
  width: 26px;
  height: 26px;
  line-height: 26px;
  margin: -4px auto;
  -webkit-border-radius: 20px;
  border-radius: 20px;
}

.bootstrap-calendar .calendar .table.daysmonth tr td.event {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.bootstrap-calendar .calendar .table.daysmonth tr.week_days td {
  background: 0 0;
  color: #4e5c68;
  font-weight: 700;
}

body .bootstrap-colorpalette .btn-color {
  width: 19px;
  height: 19px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body .bootstrap-colorpalette .btn-color:focus,
body .bootstrap-colorpalette .btn-color:hover {
  outline: 0;
  border: 1px solid rgba(0, 0, 0, 0.5) !important;
}

body .datetimepicker .datetimepicker-hours table,
body .datetimepicker .datetimepicker-minutes table {
  min-width: 220px;
}

body .datetimepicker .glyphicon {
  font-size: 14px;
  color: #2d353c;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body .datetimepicker .glyphicon.glyphicon-chevron-up:before {
  content: "\\f106";
}

body .datetimepicker .glyphicon.glyphicon-chevron-down:before {
  content: "\\f107";
}

body .datetimepicker .glyphicon.icon-arrow-left:before {
  content: "\\f104";
}

body .datetimepicker .glyphicon.icon-arrow-right:before {
  content: "\\f105";
}

body .datetimepicker .glyphicon.glyphicon-time:before {
  content: "\\f017";
}

body .datetimepicker .glyphicon.glyphicon-calendar:before {
  content: "\\f133";
}

body .datetimepicker.dropdown-menu {
  max-width: 320px;
  min-width: 200px;
  width: auto;
  padding: 5px;
  color: #2d353c;
  overflow: hidden;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

@media (max-width: 575.98px) {
  body .datetimepicker.dropdown-menu {
    max-width: 250px;
  }
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.next,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.picker-switch,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.prev,
body .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.next,
body .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tfoot
  tr
  th.switch,
body .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.today,
body .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.next,
body .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  thead
  tr
  th.switch,
body .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.today,
body .datetimepicker.dropdown-menu .datetimepicker-hours table tfoot tr th.next,
body .datetimepicker.dropdown-menu .datetimepicker-hours table tfoot tr th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tfoot
  tr
  th.today,
body .datetimepicker.dropdown-menu .datetimepicker-hours table thead tr th.next,
body .datetimepicker.dropdown-menu .datetimepicker-hours table thead tr th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  thead
  tr
  th.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.next,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.next,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.next,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tfoot
  tr
  th.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.next,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  thead
  tr
  th.today,
body .datetimepicker.dropdown-menu .datetimepicker-years table tfoot tr th.next,
body .datetimepicker.dropdown-menu .datetimepicker-years table tfoot tr th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tfoot
  tr
  th.today,
body .datetimepicker.dropdown-menu .datetimepicker-years table thead tr th.next,
body .datetimepicker.dropdown-menu .datetimepicker-years table thead tr th.prev,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.switch,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  thead
  tr
  th.today {
  padding: 5px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-hours table tfoot tr th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-hours table thead tr th.dow,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tfoot
  tr
  th.dow,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  thead
  tr
  th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-months table tfoot tr th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-months table thead tr th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-years table tfoot tr th.dow,
body .datetimepicker.dropdown-menu .datetimepicker-years table thead tr th.dow,
body .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-hours,
body .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-minutes,
body .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-picker {
  padding: 5px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade,
body .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td .hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month,
body .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td .year,
body .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td.day,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year,
body .datetimepicker.dropdown-menu .datetimepicker-hours table tbody tr td.day,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year,
body .datetimepicker.dropdown-menu .datetimepicker-months table tbody tr td.day,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year,
body .datetimepicker.dropdown-menu .datetimepicker-years table tbody tr td.day {
  padding: 7px 9px;
  height: auto;
  line-height: 16px !important;
  color: #6f8293;
  font-weight: 600;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.active {
  color: #fff;
  background: #348fe2 !important;
  text-shadow: none;
}

body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year.active:hover,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.active:focus,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.active:hover {
  text-shadow: none;
}

body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .decade.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .hour.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .minute.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .month.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td
  .year.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .decade.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .hour.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .minute.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .month.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td
  .year.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .decade.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .hour.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .minute.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .month.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td
  .year.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .decade.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .hour.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .minute.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .month.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td
  .year.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .decade.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .hour.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .minute.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .month.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td
  .year.timepicker-second,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.timepicker-second {
  border: 1px solid #d5dbe0;
  display: block;
  width: 80px;
  margin: 0 auto;
  line-height: 22px;
  height: auto;
  padding: 6px 15px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.today,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.today {
  background: #e4e7ea;
  color: #2d353c;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.today:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.today:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.today:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.today:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.today:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.today:before {
  border-bottom-color: #9ba8b4;
}

body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.today.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.today.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.today.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.today.active,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.today.active {
  color: #fff;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.today.active:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-days
  table
  tbody
  tr
  td.day.today.active:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.today.active:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-minutes
  table
  tbody
  tr
  td.day.today.active:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-months
  table
  tbody
  tr
  td.day.today.active:before,
body
  .datetimepicker.dropdown-menu
  .datetimepicker-years
  table
  tbody
  tr
  td.day.today.active:before {
  border-bottom-color: #bad9f5;
}

body .datetimepicker.dropdown-menu > ul > li .datepicker {
  padding: 5px;
  width: 320px;
}

@media (max-width: 575.98px) {
  body .datetimepicker.dropdown-menu > ul > li .datepicker {
    width: 250px;
  }
}

body .datetimepicker.dropdown-menu > ul > li .timepicker {
  width: auto;
}

body .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-picker {
  width: 200px;
  margin: 0 auto;
}

body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td {
  padding: 0;
  height: auto;
  line-height: inherit;
}

body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td .btn span,
body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.hour,
body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.minute {
  padding: 10px;
  height: auto;
  line-height: 16px !important;
  color: #6f8293;
  font-weight: 600;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.next:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.next:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.picker-switch:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.picker-switch:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.prev:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.prev:hover,
body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.hour:focus,
body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.hour:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute:hover {
  color: #2d353c;
  background: #f2f3f4;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.active,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.active {
  color: #fff;
  background: #2d353c !important;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.active:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.active:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.active:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.active:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.active:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.active:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.active:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.active:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.active:hover {
  text-shadow: none;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.timepicker-second,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.timepicker-second {
  border: 1px solid #d5dbe0;
  display: block;
  width: 80px;
  margin: 0 auto;
  line-height: 22px;
  height: auto;
  padding: 6px 15px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.separator {
  width: 1%;
}

body .datetimepicker.dropdown-menu > ul > li .timepicker table tr td .btn {
  padding: 0;
  border: 0;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.next:focus,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.next:hover,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.prev:focus,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.prev:hover,
body .daterangepicker.show-ranges .ranges ul li:focus,
body .daterangepicker.show-ranges .ranges ul li:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span:hover {
  background: #f2f3f4;
  color: #2d353c;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.active {
  color: #fff;
  background: #2d353c !important;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.timepicker-hour,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.timepicker-minute,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.timepicker-second {
  border: 1px solid #d5dbe0;
  display: block;
  width: 80px;
  margin: 0 auto;
  line-height: 22px;
  height: auto;
  padding: 6px 15px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn.btn-primary {
  padding: 5px 15px;
  background: #9ba8b4;
  margin-right: 5px;
  margin-left: 5px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn.btn-primary:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn.btn-primary:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn.btn-primary:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn.btn-primary:hover {
  background: #6f8293;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-hour,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-minute {
  height: auto;
  line-height: 30px;
  border: 1px solid #d5dbe0;
}

body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-hour:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-hour:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-minute:focus,
body
  .datetimepicker.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-minute:hover {
  background: 0 0;
  border-color: #9ba8b4;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li.picker-switch
  table
  tbody
  tr
  td
  span,
body
  .datetimepicker.dropdown-menu
  > ul
  > li.picker-switch
  table
  tbody
  tr
  td
  span {
  display: block;
  width: auto;
  margin: -1px 0 0;
  background: #f2f3f4;
  height: 36px;
  line-height: 36px;
  -webkit-border-radius: 0;
  border-radius: 0;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li.picker-switch
  table
  tbody
  tr
  td
  span:hover,
body
  .datetimepicker.dropdown-menu
  > ul
  > li.picker-switch
  table
  tbody
  tr
  td
  span:hover {
  background: #eceff1;
}

body .colorpicker:before,
body .datetimepicker.dropdown-menu.bottom:before {
  display: none;
}

body .datetimepicker.dropdown-menu.bottom:after {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  top: -7px;
  left: 15px;
}

body .datetimepicker.dropdown-menu.bottom.pull-right:after {
  left: auto;
  right: 15px;
}

body .datetimepicker + .input-group-addon {
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  border-bottom-left-radius: 0;
}

div .bootstrap-select .btn:active,
div .bootstrap-select .btn:focus {
  outline: 0 !important;
}

div .bootstrap-select .btn.dropdown-toggle:after {
  content: "";
  border: 5px solid transparent;
  border-top-color: rgba(255, 255, 255, 0.5);
  position: relative;
  top: 3px;
}

div .bootstrap-select .btn.btn-light,
div .bootstrap-select .btn.btn-white {
  color: #7e8f9e !important;
}

div .bootstrap-select .btn.btn-light.dropdown-toggle:after,
div .bootstrap-select .btn.btn-white.dropdown-toggle:after {
  border-top-color: rgba(45, 53, 60, 0.5);
}

div .bootstrap-select .btn.bs-placeholder {
  color: rgba(255, 255, 255, 0.75) !important;
}

div .bootstrap-select .btn.bs-placeholder:active,
div .bootstrap-select .btn.bs-placeholder:focus,
div .bootstrap-select .btn.bs-placeholder:hover {
  color: rgba(255, 255, 255, 0.75) !important;
}

div .bootstrap-select .dropdown-menu .bs-searchbox {
  padding: 0 8px 8px;
}

.icon-eye-close,
.icon-eye-open {
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.icon-eye-open:before {
  content: "\\f06e";
}

.icon-eye-close:before {
  content: "\\f070";
}

.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-hour,
.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-meridian,
.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-minute {
  width: 40px;
  height: 34px;
  border: 1px solid #d5dbe0;
  padding: 6px;
  background: #fff;
  color: #2d353c;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-hour:focus,
.bootstrap-timepicker-widget
  table
  tbody
  tr
  td
  .bootstrap-timepicker-meridian:focus,
.bootstrap-timepicker-widget
  table
  tbody
  tr
  td
  .bootstrap-timepicker-minute:focus {
  border-color: #5db0ff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
}

.bootstrap-timepicker-widget table tbody tr td .glyphicon {
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.bootstrap-timepicker-widget
  table
  tbody
  tr
  td
  .glyphicon.glyphicon-chevron-up:before {
  content: "\\f077";
}

.bootstrap-timepicker-widget
  table
  tbody
  tr
  td
  .glyphicon.glyphicon-chevron-down:before {
  content: "\\f078";
}

.bootstrap-timepicker-widget table tbody tr td a {
  border: 0;
  color: #6f8293;
  padding: 5px;
  -webkit-border-radius: 4px !important;
  border-radius: 4px !important;
}

.bootstrap-timepicker-widget table tbody tr td a:focus,
.bootstrap-timepicker-widget table tbody tr td a:hover {
  background: #e4e7ea;
  color: #2d353c;
}

.bootstrap-timepicker-widget table tbody tr td.separator {
  padding: 0 5px;
}

.bootstrap-timepicker-widget.dropdown-menu {
  padding: 5px !important;
  -webkit-border-radius: 6px !important;
  border-radius: 6px !important;
  -webkit-box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2) !important;
}

.bootstrap-timepicker-widget:before,
.dropzone .dz-preview .dz-error-mark svg,
.sw-main.sw-theme-default .step-anchor > li > a:after {
  display: none !important;
}

.bootstrap-timepicker-widget:after {
  left: 12px !important;
  top: -7px !important;
  border-width: 7px !important;
}

.bootstrap-timepicker-widget.timepicker-orient-bottom:after {
  top: auto !important;
  bottom: -7px;
}

.cke,
.dataTables_wrapper.dt-bootstrap
  .dataTables_scroll
  .dataTables_scrollBody
  .dataTable
  thead
  tr
  th,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_scroll
  .dataTables_scrollBody
  .dataTable
  thead
  tr
  th,
body .DTFC_ScrollWrapper .DTFC_LeftBodyWrapper .dataTable thead tr th,
body .DTFC_ScrollWrapper .DTFC_RightBodyWrapper .dataTable thead tr th,
body .DTFC_ScrollWrapper .dataTables_scrollBody .dataTable thead tr th {
  border: 0 !important;
}

.cke .cke_bottom,
.cke .cke_top {
  border-color: #d5dbe0;
  background: #f2f4f5;
}

.cke .cke_top .cke_button_off:focus,
.cke .cke_top .cke_button_off:hover,
.cke .cke_top .cke_combo_button:focus,
.cke .cke_top .cke_combo_button:hover {
  border-color: #d5dbe0;
  background: #d5dbe0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.cke .cke_top .cke_button_on,
.cke .cke_top .cke_combo_on {
  background: #fff;
  border-color: #d5dbe0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.cke .cke_bottom .cke_resizer {
  border-right-color: #9ba8b4;
}

body .colorpicker {
  border: 0;
  padding: 5px;
  z-index: 1010;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body .colorpicker .colorpicker-hue {
  margin-bottom: 5px;
  margin-left: 5px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body .colorpicker .colorpicker-alpha {
  margin-bottom: 5px;
  margin-left: 5px;
}

body .colorpicker .colorpicker-saturation {
  margin-bottom: 5px;
}

body .colorpicker .colorpicker-saturation i {
  border-color: rgba(0, 0, 0, 0.25);
}

body .colorpicker .colorpicker-alpha,
body .colorpicker .colorpicker-alpha div,
body .colorpicker .colorpicker-bar,
body .colorpicker .colorpicker-bar div,
body .colorpicker .colorpicker-color,
body .colorpicker .colorpicker-color div,
body .colorpicker .colorpicker-saturation {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body .colorpicker .colorpicker-bar {
  margin-top: 5px;
}

body .colorpicker:after {
  border-width: 7px;
  top: -7px;
}

body .colorpicker.colorpicker-left:after {
  left: 12px;
}

body .colorpicker.colorpicker-right:after {
  right: 12px;
}

body .colorpicker.colorpicker-with-alpha {
  width: 168px;
}

body .colorpicker-component .input-group-addon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

body .colorpicker-bs-popover .popover-body {
  padding: 5px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td,
body
  .colorpicker-bs-popover
  .popover-body
  .colorpicker-popup.colorpicker-bs-popover-content {
  padding: 0;
}

.combobox + .input-group-addon,
.combobox + .typeahead + .input-group-addon {
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  border-bottom-left-radius: 0;
}

.combobox-container {
  width: 100%;
}

.combobox-container .input-group .combobox {
  width: auto;
  border: 1px solid #d5dbe0;
  background: #fff;
  display: block;
  height: 34px;
  padding: 6px 12px;
  color: #2d353c;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.combobox-container .input-group .combobox:focus {
  outline: 0;
  border-color: #5db0ff !important;
  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
}

.combobox-container .input-group .input-group-addon {
  width: 35px;
}

.combobox-container .input-group .input-group-addon .caret {
  margin: 0;
}

.combobox-container .input-group .input-group-addon .glyphicon,
.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button
  .fc-icon
  .fc-icon-left-single-arrow,
.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button
  .fc-icon
  .fc-icon-right-single-arrow {
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.combobox-container
  .input-group
  .input-group-addon
  .glyphicon.glyphicon-remove:before {
  content: "\\f00d";
}

.combobox-container .input-group .input-group-addon.dropdown-toggle:before,
body .datepicker .datepicker-centuries table thead tr th.next i,
body .datepicker .datepicker-centuries table thead tr th.prev i,
body .datepicker .datepicker-days table thead tr th.next i,
body .datepicker .datepicker-days table thead tr th.prev i,
body .datepicker .datepicker-decades table thead tr th.next i,
body .datepicker .datepicker-decades table thead tr th.prev i,
body .datepicker .datepicker-months table thead tr th.next i,
body .datepicker .datepicker-months table thead tr th.prev i,
body .datepicker .datepicker-years table thead tr th.next i,
body .datepicker .datepicker-years table thead tr th.prev i,
body .datepicker.dropdown-menu:before,
body .daterangepicker:before,
body table.dataTable thead tr th.sorting:before,
body table.dataTable thead tr th.sorting_asc:before,
body table.dataTable thead tr th.sorting_desc:before {
  display: none;
}

.combobox-container .input-group .typeahead.dropdown-menu > li > a {
  padding: 5px 15px;
  font-weight: 600;
  color: #4e5c68;
  text-decoration: none;
  display: block;
}

.combobox-container .input-group .typeahead.dropdown-menu > li > a:focus,
.combobox-container .input-group .typeahead.dropdown-menu > li > a:hover,
.dataTables_wrapper.dt-bootstrap
  .dataTables_paginate
  .pagination
  .paginate_button
  a:focus,
.dataTables_wrapper.dt-bootstrap
  .dataTables_paginate
  .pagination
  .paginate_button
  a:hover,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_paginate
  .pagination
  .paginate_button
  a:focus,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_paginate
  .pagination
  .paginate_button
  a:hover {
  color: #2d353c;
  background: #f2f4f5;
}

body div.dt-autofill-background,
body table.dataTable.fixedHeader-floating {
  z-index: 1030;
}

body div.dt-autofill-list {
  z-index: 1040;
  border: 0;
  padding: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body div.dt-autofill-list ul > li .dt-autofill-question {
  padding: 15px;
  border-color: #d5dbe0;
  font-weight: 600;
  color: #4e5c68;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

body div.dt-autofill-list ul > li .dt-autofill-button {
  padding: 15px;
  width: 120px;
  border-color: #d5dbe0;
}

body div.dt-autofill-list ul > li .dt-autofill-button .btn {
  display: block;
  width: 100%;
  position: relative;
  color: transparent;
  background: #348fe2;
  border-color: #348fe2;
}

body div.dt-autofill-list ul > li .dt-autofill-button .btn:focus,
body div.dt-autofill-list ul > li .dt-autofill-button .btn:hover {
  background: #1968b0;
  border-color: #1968b0;
}

body div.dt-autofill-list ul > li .dt-autofill-button .btn:before {
  content: "Fill This";
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
}

body div.dt-autofill-list ul > li:first-child {
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

body div.dt-autofill-list ul > li:last-child {
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.century:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.century:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.decade:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.decade:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.hour:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.hour:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.month:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.month:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.year:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.year:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.switch:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.switch:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.century:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.century:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.decade:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.decade:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.hour:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.hour:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.month:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.month:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.year:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.year:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.switch:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.switch:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.century:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.century:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.decade:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.decade:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.hour:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.hour:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.month:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.month:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.year:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.year:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.switch:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.switch:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.century:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.century:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.decade:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.decade:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.hour:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.hour:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.month:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.month:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.year:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.year:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.switch:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.switch:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.century:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.century:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.decade:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.decade:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.hour:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.hour:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.month:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.month:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.year:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.year:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.switch:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.switch:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.century:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.century:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.decade:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.decade:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.hour:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.hour:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.month:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.month:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.year:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.year:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.switch:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.switch:hover,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  table
  tfoot
  .today:focus,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  table
  tfoot
  .today:hover,
body .datepicker .datepicker-centuries table tbody tr td span.century:focus,
body .datepicker .datepicker-centuries table tbody tr td span.century:hover,
body .datepicker .datepicker-centuries table tbody tr td span.decade:focus,
body .datepicker .datepicker-centuries table tbody tr td span.decade:hover,
body .datepicker .datepicker-centuries table tbody tr td span.month:focus,
body .datepicker .datepicker-centuries table tbody tr td span.month:hover,
body .datepicker .datepicker-centuries table tbody tr td span.year:focus,
body .datepicker .datepicker-centuries table tbody tr td span.year:hover,
body
  .datepicker
  .datepicker-centuries
  table
  thead
  tr
  th.datepicker-switch:focus,
body
  .datepicker
  .datepicker-centuries
  table
  thead
  tr
  th.datepicker-switch:hover,
body .datepicker .datepicker-centuries table thead tr th.next:focus,
body .datepicker .datepicker-centuries table thead tr th.next:hover,
body .datepicker .datepicker-centuries table thead tr th.prev:focus,
body .datepicker .datepicker-centuries table thead tr th.prev:hover,
body .datepicker .datepicker-days table tbody tr td span.century:focus,
body .datepicker .datepicker-days table tbody tr td span.century:hover,
body .datepicker .datepicker-days table tbody tr td span.decade:focus,
body .datepicker .datepicker-days table tbody tr td span.decade:hover,
body .datepicker .datepicker-days table tbody tr td span.month:focus,
body .datepicker .datepicker-days table tbody tr td span.month:hover,
body .datepicker .datepicker-days table tbody tr td span.year:focus,
body .datepicker .datepicker-days table tbody tr td span.year:hover,
body .datepicker .datepicker-days table thead tr th.datepicker-switch:focus,
body .datepicker .datepicker-days table thead tr th.datepicker-switch:hover,
body .datepicker .datepicker-days table thead tr th.next:focus,
body .datepicker .datepicker-days table thead tr th.next:hover,
body .datepicker .datepicker-days table thead tr th.prev:focus,
body .datepicker .datepicker-days table thead tr th.prev:hover,
body .datepicker .datepicker-decades table tbody tr td span.century:focus,
body .datepicker .datepicker-decades table tbody tr td span.century:hover,
body .datepicker .datepicker-decades table tbody tr td span.decade:focus,
body .datepicker .datepicker-decades table tbody tr td span.decade:hover,
body .datepicker .datepicker-decades table tbody tr td span.month:focus,
body .datepicker .datepicker-decades table tbody tr td span.month:hover,
body .datepicker .datepicker-decades table tbody tr td span.year:focus,
body .datepicker .datepicker-decades table tbody tr td span.year:hover,
body .datepicker .datepicker-decades table thead tr th.datepicker-switch:focus,
body .datepicker .datepicker-decades table thead tr th.datepicker-switch:hover,
body .datepicker .datepicker-decades table thead tr th.next:focus,
body .datepicker .datepicker-decades table thead tr th.next:hover,
body .datepicker .datepicker-decades table thead tr th.prev:focus,
body .datepicker .datepicker-decades table thead tr th.prev:hover,
body .datepicker .datepicker-months table tbody tr td span.century:focus,
body .datepicker .datepicker-months table tbody tr td span.century:hover,
body .datepicker .datepicker-months table tbody tr td span.decade:focus,
body .datepicker .datepicker-months table tbody tr td span.decade:hover,
body .datepicker .datepicker-months table tbody tr td span.month:focus,
body .datepicker .datepicker-months table tbody tr td span.month:hover,
body .datepicker .datepicker-months table tbody tr td span.year:focus,
body .datepicker .datepicker-months table tbody tr td span.year:hover,
body .datepicker .datepicker-months table thead tr th.datepicker-switch:focus,
body .datepicker .datepicker-months table thead tr th.datepicker-switch:hover,
body .datepicker .datepicker-months table thead tr th.next:focus,
body .datepicker .datepicker-months table thead tr th.next:hover,
body .datepicker .datepicker-months table thead tr th.prev:focus,
body .datepicker .datepicker-months table thead tr th.prev:hover,
body .datepicker .datepicker-years table tbody tr td span.century:focus,
body .datepicker .datepicker-years table tbody tr td span.century:hover,
body .datepicker .datepicker-years table tbody tr td span.decade:focus,
body .datepicker .datepicker-years table tbody tr td span.decade:hover,
body .datepicker .datepicker-years table tbody tr td span.month:focus,
body .datepicker .datepicker-years table tbody tr td span.month:hover,
body .datepicker .datepicker-years table tbody tr td span.year:focus,
body .datepicker .datepicker-years table tbody tr td span.year:hover,
body .datepicker .datepicker-years table thead tr th.datepicker-switch:focus,
body .datepicker .datepicker-years table thead tr th.datepicker-switch:hover,
body .datepicker .datepicker-years table thead tr th.next:focus,
body .datepicker .datepicker-years table thead tr th.next:hover,
body .datepicker .datepicker-years table thead tr th.prev:focus,
body .datepicker .datepicker-years table thead tr th.prev:hover,
body .datepicker table tfoot .today:focus,
body .datepicker table tfoot .today:hover,
body div.dt-autofill-list ul > li:focus,
body div.dt-autofill-list ul > li:hover {
  background: #f2f4f5;
}

body div.dt-button-info {
  border: 0;
  padding: 15px;
  background: rgba(45, 53, 60, 0.95);
  -webkit-border-radius: 8px;
  border-radius: 8px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body div.dt-button-info h2 {
  border: 0;
  background: 0 0;
  padding: 0;
  font-weight: 600;
  margin: 0;
  font-size: 24px;
  color: #e4e7ea;
}

body div.dt-button-info > div {
  padding: 0;
  margin-top: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #9ba8b4;
}

body div.DTCR_pointer {
  width: 2px;
  background: #348fe2;
  margin-left: -1px;
}

body table.dataTable {
  border-collapse: collapse !important;
}

body table.dataTable thead tr th.sorting:after {
  color: #c6ced5;
}

body table.dataTable thead tr th.sorting:after,
body table.dataTable thead tr th.sorting_asc:after,
body table.dataTable thead tr th.sorting_desc:after {
  opacity: 1;
  bottom: 8px;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body table.dataTable thead tr th.sorting:after {
  content: "\\f0dc";
}

body table.dataTable thead tr th.sorting_asc:after {
  content: "\\f0dd";
  color: #348fe2;
}

body table.dataTable thead tr th.sorting_desc:after {
  content: "\\f0de";
  color: #348fe2;
}

body table.dataTable tbody tr td.focus {
  outline: 0;
  z-index: 10;
  position: relative;
  -webkit-box-shadow: inset 0 0 0 2px #348fe2;
  box-shadow: inset 0 0 0 2px #348fe2;
}

body table.dataTable tbody tr td:focus {
  outline: 0;
}

body table.dataTable tbody tr.selected td {
  background: #fff7cc;
  color: #665700;
  font-weight: 600;
}

body table.dataTable tbody tr.dt-rowReorder-moving {
  outline: 2px solid #9ba8b4;
}

body table.dataTable.dt-rowReorder-float {
  outline: 2px solid #348fe2;
}

body table.dataTable.collapsed tbody tr td:first-child:before {
  background: #d5dbe0 !important;
  color: #4e5c68 !important;
  border: 0 !important;
  top: 10px !important;
  left: 8px !important;
  line-height: 16px !important;
  font-weight: 700 !important;
  height: 16px !important;
  width: 16px !important;
  text-align: center !important;
  text-indent: 0 !important;
  font-size: 14px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  -webkit-border-radius: 3px !important;
  border-radius: 3px !important;
}

body .DTFC_ScrollWrapper {
  margin: 0 0 15px;
}

body .DTFC_ScrollWrapper .DTFC_LeftWrapper .dataTable,
body .DTFC_ScrollWrapper .DTFC_RightWrapper .dataTable,
body .DTFC_ScrollWrapper .dataTables_scroll .dataTable {
  margin: 0 !important;
}

.dataTables_wrapper.dt-bootstrap
  .dataTables_scroll
  .dataTables_scrollBody
  .dataTable,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_scroll
  .dataTables_scrollBody
  .dataTable,
body .DTFC_ScrollWrapper .DTFC_LeftBodyWrapper .dataTable,
body .DTFC_ScrollWrapper .DTFC_RightBodyWrapper .dataTable,
body .DTFC_ScrollWrapper .dataTables_scrollBody .dataTable {
  border-bottom: none !important;
}

.dataTables_wrapper.dt-bootstrap.DTS .dataTables_scroll .dataTables_scrollBody,
.dataTables_wrapper.dt-bootstrap4.DTS .dataTables_scroll .dataTables_scrollBody,
body .DTFC_ScrollWrapper .dataTables_scroll {
  border-bottom: 1px solid #e4e7ea;
}

.dataTables_wrapper.dt-bootstrap,
.dataTables_wrapper.dt-bootstrap4 {
  display: block;
}

.dataTables_wrapper.dt-bootstrap .dataTables_length,
.dataTables_wrapper.dt-bootstrap4 .dataTables_length {
  margin-bottom: 15px;
}

.dataTables_wrapper.dt-bootstrap .dataTables_length .custom-select,
.dataTables_wrapper.dt-bootstrap4 .dataTables_length .custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

@media (min-width: 576px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_length,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_length {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}

@media (min-width: 768px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_length + .dt-buttons,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_length + .dt-buttons {
    margin-left: 10px;
  }
}

.dataTables_wrapper.dt-bootstrap .dataTables_length label .form-control,
.dataTables_wrapper.dt-bootstrap4 .dataTables_length label .form-control {
  display: block;
  margin: 0 8px;
  height: 34px;
}

.dataTables_wrapper.dt-bootstrap .dataTables_filter,
.dataTables_wrapper.dt-bootstrap4 .dataTables_filter {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_filter,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_filter {
    float: right;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}

.dataTables_wrapper.dt-bootstrap .dataTables_filter label,
.dataTables_wrapper.dt-bootstrap .dataTables_length label,
.dataTables_wrapper.dt-bootstrap4 .dataTables_filter label,
.dataTables_wrapper.dt-bootstrap4 .dataTables_length label {
  color: #4e5c68;
  font-weight: 600;
  margin: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.dataTables_wrapper.dt-bootstrap .dataTables_filter label .form-control,
.dataTables_wrapper.dt-bootstrap4 .dataTables_filter label .form-control {
  display: block;
  margin-left: 8px;
  width: 260px;
  height: 34px;
}

@media (max-width: 991.98px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_filter label .form-control,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_filter label .form-control {
    width: 100%;
  }
}

.dataTables_wrapper.dt-bootstrap .dataTable,
.dataTables_wrapper.dt-bootstrap4 .dataTable {
  margin: 0 0 15px !important;
}

.dataTables_wrapper.dt-bootstrap .dataTables_info,
.dataTables_wrapper.dt-bootstrap4 .dataTables_info {
  font-weight: 600;
  color: #6f8293;
}

@media (max-width: 575.98px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_info,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_info {
    padding-bottom: 8px;
  }
}

.dataTables_wrapper.dt-bootstrap .dataTables_paginate,
.dataTables_wrapper.dt-bootstrap4 .dataTables_paginate {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

@media (min-width: 576px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_paginate .pagination,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_paginate .pagination {
    margin-left: auto;
  }
}

@media (max-width: 575.98px) {
  .dataTables_wrapper.dt-bootstrap .dataTables_paginate .pagination,
  .dataTables_wrapper.dt-bootstrap4 .dataTables_paginate .pagination {
    margin-left: auto;
    margin-right: auto;
  }
}

.dataTables_wrapper.dt-bootstrap
  .dataTables_paginate
  .pagination
  .paginate_button
  a,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_paginate
  .pagination
  .paginate_button
  a {
  position: relative;
  display: block;
  padding: 8px 12px;
  margin-left: -1px;
  line-height: 1.25;
  color: #6f8293;
  background-color: #fff;
  border: 1px solid #d5dbe0;
  font-weight: 600;
  text-decoration: none;
  outline: 0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.dataTables_wrapper.dt-bootstrap
  .dataTables_paginate
  .pagination
  .paginate_button.active
  a,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_paginate
  .pagination
  .paginate_button.active
  a {
  border-color: #348fe2;
  background: #348fe2;
  color: #fff;
}

.dataTables_wrapper.dt-bootstrap
  .dataTables_paginate
  .pagination
  .paginate_button.disabled
  a,
.dataTables_wrapper.dt-bootstrap4
  .dataTables_paginate
  .pagination
  .paginate_button.disabled
  a {
  color: #9ba8b4 !important;
  pointer-events: none;
  cursor: auto;
  background-color: #fff !important;
  border-color: #d5dbe0 !important;
}

.dataTables_wrapper.dt-bootstrap .dt-autofill-handle,
.dataTables_wrapper.dt-bootstrap4 .dt-autofill-handle {
  background: #348fe2;
  border-color: #348fe2;
  margin-left: 1px;
}

.dataTables_wrapper.dt-bootstrap .dt-autofill-select,
.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select {
  background: #348fe2;
}

.dataTables_wrapper.dt-bootstrap .dt-autofill-select.left,
.dataTables_wrapper.dt-bootstrap .dt-autofill-select.top,
.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.left,
.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.top {
  margin-left: 1px;
  margin-top: 0;
}

.dataTables_wrapper.dt-bootstrap .dt-autofill-select.right,
.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.right {
  margin-left: -1px;
  margin-top: 0;
  margin-bottom: -1px;
}

.dataTables_wrapper.dt-bootstrap .dt-autofill-select.bottom,
.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.bottom {
  margin-left: 1px;
  margin-top: -2px;
}

.dataTables_wrapper.dt-bootstrap .dt-buttons,
.dataTables_wrapper.dt-bootstrap4 .dt-buttons {
  margin-bottom: 15px;
}

.dataTables_wrapper.dt-bootstrap .dt-buttons .btn,
.dataTables_wrapper.dt-bootstrap4 .dt-buttons .btn {
  padding: 6px 12px;
  line-height: 20px;
}

.dataTables_wrapper.dt-bootstrap .dataTables_scroll,
.dataTables_wrapper.dt-bootstrap4 .dataTables_scroll {
  margin: 0 0 15px !important;
}

.dataTables_wrapper.dt-bootstrap .dataTables_scroll .dataTable,
.dataTables_wrapper.dt-bootstrap4 .dataTables_scroll .dataTable {
  margin: 0 !important;
}

body .datepicker {
  color: #2d353c;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

body .datepicker table {
  width: 100%;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.switch,
body .datepicker .datepicker-centuries table thead tr th.datepicker-switch,
body .datepicker .datepicker-centuries table thead tr th.next,
body .datepicker .datepicker-centuries table thead tr th.prev,
body .datepicker .datepicker-days table thead tr th.datepicker-switch,
body .datepicker .datepicker-days table thead tr th.next,
body .datepicker .datepicker-days table thead tr th.prev,
body .datepicker .datepicker-decades table thead tr th.datepicker-switch,
body .datepicker .datepicker-decades table thead tr th.next,
body .datepicker .datepicker-decades table thead tr th.prev,
body .datepicker .datepicker-months table thead tr th.datepicker-switch,
body .datepicker .datepicker-months table thead tr th.next,
body .datepicker .datepicker-months table thead tr th.prev,
body .datepicker .datepicker-years table thead tr th.datepicker-switch,
body .datepicker .datepicker-years table thead tr th.next,
body .datepicker .datepicker-years table thead tr th.prev {
  line-height: 20px;
  padding: 5px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body .datepicker .datepicker-centuries table thead tr th.next,
body .datepicker .datepicker-centuries table thead tr th.prev,
body .datepicker .datepicker-days table thead tr th.next,
body .datepicker .datepicker-days table thead tr th.prev,
body .datepicker .datepicker-decades table thead tr th.next,
body .datepicker .datepicker-decades table thead tr th.prev,
body .datepicker .datepicker-months table thead tr th.next,
body .datepicker .datepicker-months table thead tr th.prev,
body .datepicker .datepicker-years table thead tr th.next,
body .datepicker .datepicker-years table thead tr th.prev {
  color: transparent;
  width: 14.28%;
  position: relative;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body .datepicker .datepicker-centuries table thead tr th.next:before,
body .datepicker .datepicker-centuries table thead tr th.prev:before,
body .datepicker .datepicker-days table thead tr th.next:before,
body .datepicker .datepicker-days table thead tr th.prev:before,
body .datepicker .datepicker-decades table thead tr th.next:before,
body .datepicker .datepicker-decades table thead tr th.prev:before,
body .datepicker .datepicker-months table thead tr th.next:before,
body .datepicker .datepicker-months table thead tr th.prev:before,
body .datepicker .datepicker-years table thead tr th.next:before,
body .datepicker .datepicker-years table thead tr th.prev:before {
  color: #6f8293;
  position: absolute;
  font-size: 14px;
  height: 14px;
  top: 50%;
  margin-top: -7px;
  line-height: 1;
}

body .datepicker .datepicker-centuries table thead tr th.prev:before,
body .datepicker .datepicker-days table thead tr th.prev:before,
body .datepicker .datepicker-decades table thead tr th.prev:before,
body .datepicker .datepicker-months table thead tr th.prev:before,
body .datepicker .datepicker-years table thead tr th.prev:before {
  content: "\\f104";
}

body .datepicker .datepicker-centuries table thead tr th.next:before,
body .datepicker .datepicker-days table thead tr th.next:before,
body .datepicker .datepicker-decades table thead tr th.next:before,
body .datepicker .datepicker-months table thead tr th.next:before,
body .datepicker .datepicker-years table thead tr th.next:before {
  content: "\\f105";
}

body .datepicker .datepicker-centuries table thead tr th.datepicker-switch,
body .datepicker .datepicker-days table thead tr th.datepicker-switch,
body .datepicker .datepicker-decades table thead tr th.datepicker-switch,
body .datepicker .datepicker-months table thead tr th.datepicker-switch,
body .datepicker .datepicker-years table thead tr th.datepicker-switch {
  width: auto;
}

body .datepicker .datepicker-centuries table thead tr th.dow,
body .datepicker .datepicker-days table thead tr th.dow,
body .datepicker .datepicker-decades table thead tr th.dow,
body .datepicker .datepicker-months table thead tr th.dow,
body .datepicker .datepicker-years table thead tr th.dow {
  padding: 5px 0;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  thead
  tr
  th.dow,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  .timepicker-hours,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  .timepicker-minutes,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  .timepicker-picker,
body .datepicker .datepicker-centuries table tbody tr td,
body .datepicker .datepicker-days table tbody tr td,
body .datepicker .datepicker-decades table tbody tr td,
body .datepicker .datepicker-months table tbody tr td,
body .datepicker .datepicker-years table tbody tr td {
  padding: 5px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.century,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.decade,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.hour,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.month,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.year,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.century,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.decade,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.hour,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.month,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.year,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.century,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.decade,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.hour,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.month,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.year,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.century,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.decade,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.hour,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.month,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.year,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.century,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.decade,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.hour,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.month,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.year,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.century,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.decade,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.hour,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.month,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.year,
body .datepicker .datepicker-centuries table tbody tr td span.century,
body .datepicker .datepicker-centuries table tbody tr td span.decade,
body .datepicker .datepicker-centuries table tbody tr td span.month,
body .datepicker .datepicker-centuries table tbody tr td span.year,
body .datepicker .datepicker-days table tbody tr td span.century,
body .datepicker .datepicker-days table tbody tr td span.decade,
body .datepicker .datepicker-days table tbody tr td span.month,
body .datepicker .datepicker-days table tbody tr td span.year,
body .datepicker .datepicker-decades table tbody tr td span.century,
body .datepicker .datepicker-decades table tbody tr td span.decade,
body .datepicker .datepicker-decades table tbody tr td span.month,
body .datepicker .datepicker-decades table tbody tr td span.year,
body .datepicker .datepicker-months table tbody tr td span.century,
body .datepicker .datepicker-months table tbody tr td span.decade,
body .datepicker .datepicker-months table tbody tr td span.month,
body .datepicker .datepicker-months table tbody tr td span.year,
body .datepicker .datepicker-years table tbody tr td span.century,
body .datepicker .datepicker-years table tbody tr td span.decade,
body .datepicker .datepicker-years table tbody tr td span.month,
body .datepicker .datepicker-years table tbody tr td span.year {
  font-weight: 600;
  color: #6f8293;
  text-shadow: none;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body .datepicker .datepicker-centuries table tbody tr td span.century.focused,
body .datepicker .datepicker-centuries table tbody tr td span.decade.focused,
body .datepicker .datepicker-centuries table tbody tr td span.month.focused,
body .datepicker .datepicker-centuries table tbody tr td span.year.focused,
body .datepicker .datepicker-days table tbody tr td span.century.focused,
body .datepicker .datepicker-days table tbody tr td span.decade.focused,
body .datepicker .datepicker-days table tbody tr td span.month.focused,
body .datepicker .datepicker-days table tbody tr td span.year.focused,
body .datepicker .datepicker-decades table tbody tr td span.century.focused,
body .datepicker .datepicker-decades table tbody tr td span.decade.focused,
body .datepicker .datepicker-decades table tbody tr td span.month.focused,
body .datepicker .datepicker-decades table tbody tr td span.year.focused,
body .datepicker .datepicker-months table tbody tr td span.century.focused,
body .datepicker .datepicker-months table tbody tr td span.decade.focused,
body .datepicker .datepicker-months table tbody tr td span.month.focused,
body .datepicker .datepicker-months table tbody tr td span.year.focused,
body .datepicker .datepicker-years table tbody tr td span.century.focused,
body .datepicker .datepicker-years table tbody tr td span.decade.focused,
body .datepicker .datepicker-years table tbody tr td span.month.focused,
body .datepicker .datepicker-years table tbody tr td span.year.focused {
  background: #e4e7ea;
  color: #2d353c;
}

body .datepicker .datepicker-centuries table tbody tr td span.century.active,
body .datepicker .datepicker-centuries table tbody tr td span.decade.active,
body .datepicker .datepicker-centuries table tbody tr td span.month.active,
body .datepicker .datepicker-centuries table tbody tr td span.year.active,
body .datepicker .datepicker-days table tbody tr td span.century.active,
body .datepicker .datepicker-days table tbody tr td span.decade.active,
body .datepicker .datepicker-days table tbody tr td span.month.active,
body .datepicker .datepicker-days table tbody tr td span.year.active,
body .datepicker .datepicker-decades table tbody tr td span.century.active,
body .datepicker .datepicker-decades table tbody tr td span.decade.active,
body .datepicker .datepicker-decades table tbody tr td span.month.active,
body .datepicker .datepicker-decades table tbody tr td span.year.active,
body .datepicker .datepicker-months table tbody tr td span.century.active,
body .datepicker .datepicker-months table tbody tr td span.decade.active,
body .datepicker .datepicker-months table tbody tr td span.month.active,
body .datepicker .datepicker-months table tbody tr td span.year.active,
body .datepicker .datepicker-years table tbody tr td span.century.active,
body .datepicker .datepicker-years table tbody tr td span.decade.active,
body .datepicker .datepicker-years table tbody tr td span.month.active,
body .datepicker .datepicker-years table tbody tr td span.year.active {
  background: #348fe2 !important;
  color: #fff;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day,
body .datepicker .datepicker-centuries table tbody tr td.day,
body .datepicker .datepicker-days table tbody tr td.day,
body .datepicker .datepicker-decades table tbody tr td.day,
body .datepicker .datepicker-months table tbody tr td.day,
body .datepicker .datepicker-years table tbody tr td.day {
  font-weight: 600;
  color: #4e5c68;
  padding: 5px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body .datepicker .datepicker-centuries table tbody tr td.day.highlighted,
body .datepicker .datepicker-centuries table tbody tr td.day.range,
body .datepicker .datepicker-centuries table tbody tr td.day.selected,
body .datepicker .datepicker-centuries table tbody tr td.day:focus,
body .datepicker .datepicker-centuries table tbody tr td.day:hover,
body .datepicker .datepicker-days table tbody tr td.day.highlighted,
body .datepicker .datepicker-days table tbody tr td.day.range,
body .datepicker .datepicker-days table tbody tr td.day.selected,
body .datepicker .datepicker-days table tbody tr td.day:focus,
body .datepicker .datepicker-days table tbody tr td.day:hover,
body .datepicker .datepicker-decades table tbody tr td.day.highlighted,
body .datepicker .datepicker-decades table tbody tr td.day.range,
body .datepicker .datepicker-decades table tbody tr td.day.selected,
body .datepicker .datepicker-decades table tbody tr td.day:focus,
body .datepicker .datepicker-decades table tbody tr td.day:hover,
body .datepicker .datepicker-months table tbody tr td.day.highlighted,
body .datepicker .datepicker-months table tbody tr td.day.range,
body .datepicker .datepicker-months table tbody tr td.day.selected,
body .datepicker .datepicker-months table tbody tr td.day:focus,
body .datepicker .datepicker-months table tbody tr td.day:hover,
body .datepicker .datepicker-years table tbody tr td.day.highlighted,
body .datepicker .datepicker-years table tbody tr td.day.range,
body .datepicker .datepicker-years table tbody tr td.day.selected,
body .datepicker .datepicker-years table tbody tr td.day:focus,
body .datepicker .datepicker-years table tbody tr td.day:hover {
  background: #f2f4f5;
  text-shadow: none;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day.today,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day.today,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day.today,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.today,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day.today,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day.today,
body .datepicker .datepicker-centuries table tbody tr td.day.today,
body .datepicker .datepicker-days table tbody tr td.day.today,
body .datepicker .datepicker-decades table tbody tr td.day.today,
body .datepicker .datepicker-months table tbody tr td.day.today,
body .datepicker .datepicker-years table tbody tr td.day.today {
  background: #e4e7ea !important;
  color: #2d353c;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day.active,
body .datepicker .datepicker-centuries table tbody tr td.day.active,
body .datepicker .datepicker-days table tbody tr td.day.active,
body .datepicker .datepicker-decades table tbody tr td.day.active,
body .datepicker .datepicker-months table tbody tr td.day.active,
body .datepicker .datepicker-years table tbody tr td.day.active {
  background: #348fe2 !important;
  color: #fff;
  text-shadow: none !important;
}

body .datepicker .datepicker-centuries table tbody tr td.day.range,
body .datepicker .datepicker-days table tbody tr td.day.range,
body .datepicker .datepicker-decades table tbody tr td.day.range,
body .datepicker .datepicker-months table tbody tr td.day.range,
body .datepicker .datepicker-years table tbody tr td.day.range {
  -webkit-border-radius: 0;
  border-radius: 0;
}

body .datepicker .datepicker-centuries table tbody tr td.day.range-start,
body .datepicker .datepicker-days table tbody tr td.day.range-start,
body .datepicker .datepicker-decades table tbody tr td.day.range-start,
body .datepicker .datepicker-months table tbody tr td.day.range-start,
body .datepicker .datepicker-years table tbody tr td.day.range-start {
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

.datepicker .input-daterange .input-group-addon + .form-control,
body .datepicker .datepicker-centuries table tbody tr td.day.range-end,
body .datepicker .datepicker-days table tbody tr td.day.range-end,
body .datepicker .datepicker-decades table tbody tr td.day.range-end,
body .datepicker .datepicker-months table tbody tr td.day.range-end,
body .datepicker .datepicker-years table tbody tr td.day.range-end {
  -webkit-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}

body .datepicker .datepicker-centuries table tbody tr td.day.old,
body .datepicker .datepicker-days table tbody tr td.day.old,
body .datepicker .datepicker-decades table tbody tr td.day.old,
body .datepicker .datepicker-months table tbody tr td.day.old,
body .datepicker .datepicker-years table tbody tr td.day.old {
  color: #c6ced5;
}

body .datepicker .datepicker-centuries table tbody tr td.day.new,
body .datepicker .datepicker-days table tbody tr td.day.new,
body .datepicker .datepicker-decades table tbody tr td.day.new,
body .datepicker .datepicker-months table tbody tr td.day.new,
body .datepicker .datepicker-years table tbody tr td.day.new {
  color: #9ba8b4;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day.old,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day.old,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day.old,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.old,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day.old,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day.old,
body .datepicker .datepicker-centuries table tbody tr td.day.disabled,
body .datepicker .datepicker-days table tbody tr td.day.disabled,
body .datepicker .datepicker-decades table tbody tr td.day.disabled,
body .datepicker .datepicker-months table tbody tr td.day.disabled,
body .datepicker .datepicker-years table tbody tr td.day.disabled {
  color: #c6ced5;
}

body .datepicker .datepicker-centuries table tbody tr td.day.disabled:focus,
body .datepicker .datepicker-centuries table tbody tr td.day.disabled:hover,
body .datepicker .datepicker-days table tbody tr td.day.disabled:focus,
body .datepicker .datepicker-days table tbody tr td.day.disabled:hover,
body .datepicker .datepicker-decades table tbody tr td.day.disabled:focus,
body .datepicker .datepicker-decades table tbody tr td.day.disabled:hover,
body .datepicker .datepicker-months table tbody tr td.day.disabled:focus,
body .datepicker .datepicker-months table tbody tr td.day.disabled:hover,
body .datepicker .datepicker-years table tbody tr td.day.disabled:focus,
body .datepicker .datepicker-years table tbody tr td.day.disabled:hover {
  background: 0 0;
}

body .datepicker.datepicker-inline {
  display: block;
  width: auto;
  padding: 0;
}

body .datepicker.dropdown-menu {
  min-width: 250px;
  width: 320px;
  border: 0;
  font-family: inherit;
  font-size: 12px;
  -webkit-box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
}

@media (max-width: 575.98px) {
  body .datepicker.dropdown-menu {
    width: 250px;
  }
}

body .datepicker.dropdown-menu.datepicker-orient-left:after {
  left: 15px;
}

body .datepicker.dropdown-menu.datepicker-orient-right:after {
  right: 15px;
}

body .datepicker.dropdown-menu.datepicker-orient-top {
  margin-bottom: 7px;
}

body .datepicker.dropdown-menu.datepicker-orient-bottom {
  margin-top: 7px;
}

.datepicker .input-daterange .input-group-addon,
body .input-daterange .input-group-addon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.datepicker .input-daterange .input-group-addon {
  margin: 0;
  font-weight: 600;
  background: #d5dbe0;
  color: #6f8293;
  -webkit-border-radius: 0;
  border-radius: 0;
}

body .input-daterange .input-group-addon {
  font-size: 12px;
  line-height: 1;
  min-width: 30px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

body .daterangepicker {
  z-index: 1020;
  border: 0;
  font-family: inherit;
  -webkit-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);
}

body .daterangepicker:after {
  border-width: 7px;
  top: -7px;
  left: 10px;
}

body .daterangepicker .drp-calendar {
  max-width: inherit;
  padding: 15px;
}

body .daterangepicker .drp-calendar .calendar-table table thead tr th {
  min-width: auto;
  width: auto;
  height: auto;
  line-height: 1;
  padding: 7px;
  color: #2d353c;
  font-weight: 700;
  border: 0;
}

body .daterangepicker .drp-calendar .calendar-table table thead tr th.next span,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.prev
  span {
  border-color: #2d353c;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.month
  .monthselect,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.month
  .yearselect {
  border-color: #d5dbe0;
  background: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.month
  .monthselect:focus,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr
  th.month
  .yearselect:focus {
  outline: 0;
  border-color: #5db0ff;
  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  thead
  tr:last-child
  th {
  padding-bottom: 14px;
}

body .daterangepicker .drp-calendar .calendar-table table tbody tr td {
  min-width: auto;
  width: auto;
  height: auto;
  line-height: 1;
  padding: 7px 9px;
  font-weight: 600;
  color: #2d353c;
  border: 0;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available:focus,
body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available:hover {
  background: #f2f3f4;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available.in-range {
  background: #e7f1fc;
  color: #10416d;
  -webkit-border-radius: 0;
  border-radius: 0;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available.active {
  background: #348fe2;
  color: #fff;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available.start-date {
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

body
  .daterangepicker
  .drp-calendar
  .calendar-table
  table
  tbody
  tr
  td.available.end-date {
  -webkit-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}

body .daterangepicker .drp-calendar .calendar-table table tbody tr td.off {
  background: 0 0;
  color: #c6ced5;
}

body .daterangepicker .drp-calendar.left {
  padding: 10px !important;
}

body .daterangepicker .drp-calendar.left .calendar-table {
  padding: 0 !important;
}

body .daterangepicker .drp-calendar.right {
  padding: 10px !important;
  border-left: 1px solid #d5dbe0;
}

@media (max-width: 575.98px) {
  body .daterangepicker .drp-calendar.right {
    border-left: none;
    border-top: 1px solid #d5dbe0;
  }
}

body .daterangepicker .drp-buttons {
  padding: 10px;
  border-color: #d5dbe0;
}

body .daterangepicker .drp-buttons .drp-selected,
body .daterangepicker.show-ranges .ranges ul li {
  font-weight: 600;
  color: #6f8293;
}

body .bootstrap-datetimepicker-widget .next:before,
body .bootstrap-datetimepicker-widget .prev:before,
body .daterangepicker .ranges {
  display: none;
}

body .daterangepicker.show-ranges .ranges {
  position: relative;
  display: block;
}

@media (max-width: 991.98px) {
  body .daterangepicker.show-ranges .ranges {
    float: none;
    margin: 0;
    padding: 10px;
    border-bottom: 1px solid #d5dbe0;
    overflow: scroll;
    max-width: 560px;
  }

  body .daterangepicker.show-ranges .ranges ul {
    width: auto;
    white-space: nowrap;
    padding-right: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}

@media (max-width: 991.98px) {
  body .daterangepicker.show-ranges .ranges ul li {
    margin-right: 10px !important;
    -webkit-border-radius: 4px;
    border-radius: 4px;
  }
}

body .daterangepicker.show-ranges .ranges ul li.active {
  background: #348fe2;
  color: #fff;
  margin-right: -1px;
}

body .daterangepicker.show-ranges .drp-calendar.left {
  border-left: 1px solid #d5dbe0;
}

@media (max-width: 991.98px) {
  body .daterangepicker.show-ranges .drp-calendar.left {
    border-left: none;
  }
}

.dropzone {
  border: 2px dashed #c6ced5 !important;
}

.dropzone .dz-message {
  font-weight: 300 !important;
  color: inherit !important;
  font-size: 28px !important;
  text-align: center !important;
  margin: 45px 0 !important;
}

.dropzone .dz-message .dz-note {
  font-size: 14px !important;
  font-weight: 400 !important;
  display: block !important;
  margin-top: 20px;
  color: #6f8293;
}

.dropzone .dz-preview .dz-image {
  -webkit-border-radius: 6px !important;
  border-radius: 6px !important;
}

.dropzone .dz-preview .dz-error-message {
  background: #ff5b57 !important;
}

.dropzone .dz-preview .dz-error-message:after {
  border-bottom-color: #ff5b57 !important;
}

.dropzone,
.dropzone .dz-preview .dz-details .dz-filename span,
.dropzone .dz-preview .dz-details .dz-size span {
  background: 0 0 !important;
}

.dropzone .dz-preview .dz-error-mark {
  z-index: 1020 !important;
}

.dropzone .dz-preview .dz-error-mark:before {
  content: "\\f00d";
  width: 54px;
  height: 54px;
  background: #c6ced5;
  font-size: 28px;
  color: #6f8293;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-border-radius: 40px;
  border-radius: 40px;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.dropzone .dz-preview .dz-error-mark:focus:before,
.dropzone .dz-preview .dz-error-mark:hover:before {
  background: #9ba8b4;
  color: #4e5c68;
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  background: #f2f3f4 !important;
  -webkit-border-radius: 4px !important;
  border-radius: 4px !important;
}

.dropzone .dz-preview.dz-image-preview {
  background: 0 0 !important;
}

.dropzone.dz-clickable:focus,
.dropzone.dz-clickable:hover {
  background: #f2f3f4 !important;
}

.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}

.dropzone.dz-clickable.dz-started:focus,
.dropzone.dz-clickable.dz-started:hover {
  background: 0 0 !important;
}

.inverse-mode .dropzone {
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.inverse-mode .dropzone .dz-clickable:focus,
.inverse-mode .dropzone .dz-clickable:hover {
  background: rgba(255, 255, 255, 0.15) !important;
}

.inverse-mode .dropzone .dz-message {
  color: inherit !important;
}

.inverse-mode .dropzone .dz-message .dz-note {
  color: rgba(255, 255, 255, 0.75) !important;
}

body .bootstrap-datetimepicker-widget .glyphicon {
  font-size: 14px;
  color: #2d353c;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body .bootstrap-datetimepicker-widget .glyphicon.glyphicon-chevron-up:before {
  content: "\\f106";
}

body .bootstrap-datetimepicker-widget .glyphicon.glyphicon-chevron-down:before {
  content: "\\f107";
}

body .bootstrap-datetimepicker-widget .glyphicon.glyphicon-chevron-left:before {
  content: "\\f104";
}

body
  .bootstrap-datetimepicker-widget
  .glyphicon.glyphicon-chevron-right:before {
  content: "\\f105";
}

body .bootstrap-datetimepicker-widget .glyphicon.glyphicon-time:before {
  content: "\\f017";
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .add-on
  i:before,
body .bootstrap-datetimepicker-widget .glyphicon.glyphicon-calendar:before {
  content: "\\f133";
}

body .bootstrap-datetimepicker-widget.dropdown-menu {
  max-width: 320px;
  min-width: 200px;
  width: auto;
  padding: 0;
  color: #2d353c;
  overflow: hidden;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

@media (max-width: 575.98px) {
  body .bootstrap-datetimepicker-widget.dropdown-menu {
    max-width: 250px;
  }
}

body .bootstrap-datetimepicker-widget.dropdown-menu > ul > li .datepicker {
  padding: 5px;
  width: 320px;
}

@media (max-width: 575.98px) {
  body .bootstrap-datetimepicker-widget.dropdown-menu > ul > li .datepicker {
    width: 250px;
  }
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade.active,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month.active,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year.active,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.active,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute.active {
  color: #fff;
  background: #348fe2 !important;
  text-shadow: none;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .decade.timepicker-second,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .month.timepicker-second,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td
  .year.timepicker-second,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.timepicker-second,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.minute.timepicker-second {
  border: 1px solid #d5dbe0;
  display: block;
  width: 80px;
  margin: 0 auto;
  line-height: 22px;
  height: auto;
  padding: 6px 15px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.century.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.decade.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.hour.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.month.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.year.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.century.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.decade.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.hour.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.month.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.year.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.century.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.decade.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.hour.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.month.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.year.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.century.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.decade.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.hour.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.month.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.year.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.century.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.decade.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.hour.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.month.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.year.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.century.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.decade.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.hour.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.month.focused,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.year.focused,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.today {
  background: #e4e7ea;
  color: #2d353c;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .datepicker
  table
  tbody
  tr
  td.day.today.active {
  color: #fff;
}

body .bootstrap-datetimepicker-widget.dropdown-menu > ul > li .timepicker {
  width: auto;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  .timepicker-picker {
  width: 200px;
  margin: 0 auto;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td {
  padding: 0;
  height: auto;
  line-height: inherit;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute {
  padding: 10px;
  height: auto;
  line-height: 16px !important;
  color: #6f8293;
  font-weight: 600;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute:hover {
  color: #2d353c;
  background: #f2f3f4;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.active,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.active {
  color: #fff;
  background: #2d353c !important;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.hour.timepicker-second,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.minute.timepicker-second {
  border: 1px solid #d5dbe0;
  display: block;
  width: 80px;
  margin: 0 auto;
  line-height: 22px;
  height: auto;
  padding: 6px 15px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td.separator {
  width: 1%;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn {
  padding: 0;
  border: 0;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span:hover {
  background: #f2f3f4;
  color: #2d353c;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.active {
  color: #fff;
  background: #2d353c !important;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.timepicker-minute,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn
  span.timepicker-second {
  border: 1px solid #d5dbe0;
  display: block;
  width: 80px;
  margin: 0 auto;
  line-height: 22px;
  height: auto;
  padding: 6px 15px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .btn.btn-primary {
  padding: 5px 15px;
  background: #9ba8b4;
  margin-right: 5px;
  margin-left: 5px;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-hour,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-minute {
  height: auto;
  line-height: 30px;
  border: 1px solid #d5dbe0;
}

body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-hour:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-hour:hover,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-minute:focus,
body
  .bootstrap-datetimepicker-widget.dropdown-menu
  > ul
  > li
  .timepicker
  table
  tr
  td
  .timepicker-minute:hover {
  background: 0 0;
  border-color: #9ba8b4;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  table,
body .bootstrap-datetimepicker-widget.dropdown-menu > ul > li.picker-switch {
  width: 100%;
}

body .bootstrap-datetimepicker-widget.dropdown-menu > ul > li.collapse.in {
  display: block;
}

body .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  display: none;
}

body .bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  top: -7px;
  left: 15px;
}

body .bootstrap-datetimepicker-widget.dropdown-menu.bottom.pull-right:after {
  left: auto;
  right: 15px;
}

body .bootstrap-datetimepicker-widget + .input-group-addon {
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  border-bottom-left-radius: 0;
}

.legend > table tbody tr td {
  padding: 4px 0 5px;
}

.legend > table tbody tr td.legendColorBox {
  padding-left: 5px !important;
}

.legend > table tbody tr td.legendColorBox > div {
  margin-right: 5px !important;
  border: 0 !important;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.legend > table tbody tr td.legendColorBox > div > div {
  border-width: 4px !important;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.legend > table tbody tr td.legendLabel {
  padding-right: 10px;
  color: #fff;
  font-size: 11px;
}

.flot-tooltip,
.legend > div {
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.legend > div {
  background: #1a2229 !important;
}

.flot-text .tickLabel {
  color: #2d353c;
  font-size: 12px;
  font-weight: 600;
}

.flot-tooltip {
  position: absolute;
  display: none;
  border: 0;
  padding: 6px 10px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  font-size: 11px;
  background: rgba(26, 34, 41, 0.85);
  z-index: 10000 !important;
}

.fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 0;
}

.fc .fc-toolbar.fc-header-toolbar:after,
.fc .fc-toolbar.fc-header-toolbar:before {
  content: "";
  display: table;
  clear: both;
}

.fc .fc-toolbar.fc-header-toolbar h2 {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 10px;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group {
  margin-bottom: 10px;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button {
  text-shadow: none;
  background: #fff;
  text-transform: capitalize;
  font-weight: 600;
  border: 0;
  padding: 6px 12px;
  height: auto;
  color: #9ba8b4;
  margin: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  -ms-transition: all 0.1s linear;
  -o-transition: all 0.1s linear;
  transition: all 0.1s linear;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button + .fc-button {
  margin-left: 1px;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button .fc-icon {
  margin: 0 -3px;
  top: 0;
}

.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button
  .fc-icon
  .fc-icon-left-single-arrow:after {
  content: "\\f0d9";
}

.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button
  .fc-icon
  .fc-icon-right-single-arrow:after {
  content: "\\f0da";
}

.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button.fc-state-disabled {
  opacity: 1;
  color: #9ba8b4;
  cursor: not-allowed;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-state-active {
  background: #f2f4f5;
  color: #2d353c;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button:focus,
.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button:hover {
  color: #2d353c;
  outline: 0;
}

.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-next-button,
.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-prev-button,
.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-today-button {
  color: #2d353c;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.switch:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.switch:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.switch:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.switch:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.switch:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.switch:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.switch:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.switch:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.switch:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.switch:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev:hover:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.switch:focus:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.switch:hover:before,
.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button.fc-next-button:focus,
.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button.fc-next-button:hover,
.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button.fc-prev-button:focus,
.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button.fc-prev-button:hover,
.sw-main.sw-theme-default .step-anchor > li > a:focus,
.sw-main.sw-theme-default .step-anchor > li > a:hover,
body
  #gritter-notice-wrapper
  .gritter-item-wrapper.gritter-light
  .gritter-close:focus:before,
body
  #gritter-notice-wrapper
  .gritter-item-wrapper.gritter-light
  .gritter-close:hover:before {
  color: #2d353c;
}

.fc
  .fc-toolbar.fc-header-toolbar
  .fc-button-group
  .fc-button.fc-today-button.fc-state-disabled {
  color: #9ba8b4;
  cursor: not-allowed;
}

.fc .fc-view-container {
  background: #fff;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th,
.fc .fc-view-container .fc-body > tr > td.fc-widget-content,
.fc .fc-view-container .fc-head .fc-head-container {
  border: 0;
}

.fc .fc-view-container .fc-head .fc-head-container .fc-widget-header {
  border-bottom: 1px solid #e4e7ea;
}

.fc .fc-view-container .fc-head .fc-head-container .fc-widget-header th {
  background: #f2f4f5;
  font-weight: 600;
  color: #2d353c;
  padding: 2px 15px;
  border-color: #e4e7ea;
}

.fc
  .fc-view-container
  .fc-head
  .fc-head-container
  .fc-widget-header
  th.fc-axis {
  padding-left: 4px;
  padding-right: 4px;
}

.fc .fc-view-container .fc-body > tr > td.fc-widget-content .fc-divider {
  background: #f2f4f5;
  border-color: #e4e7ea;
}

.fc .fc-view-container .fc-body .fc-bg td,
.fc .fc-view-container .fc-body > tr > td.fc-widget-content .fc-widget-content {
  border-color: #e4e7ea;
}

.fc .fc-view-container .fc-body .fc-bg td.fc-highlight {
  background: #d5dbe0;
}

.fc .fc-view-container .fc-body .fc-bg td.fc-today {
  background: #fffadb;
}

.fc .fc-view-container .fc-body .fc-bg td:first-child {
  border-left: none;
}

.fc .fc-view-container .fc-body .fc-content-skeleton .fc-day-number {
  font-weight: 600;
}

.fc
  .fc-view-container
  .fc-body
  .fc-content-skeleton
  .fc-event-container
  .fc-event {
  border: 0;
  background: #4e5c68;
  font-weight: 600;
  color: #fff;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.fc
  .fc-view-container
  .fc-body
  .fc-content-skeleton
  .fc-event-container
  .fc-event.fc-day-grid-event {
  padding: 1px 2px;
}

.fc .fc-view-container .fc-body .fc-highlight-skeleton .fc-highlight,
.jstree
  .jstree-container-ul
  .jstree-node
  .jstree-anchor
  .jstree-icon.jstree-checkbox.jstree-undetermined:after {
  background: #d5dbe0;
}

.fc .fc-scroller {
  overflow: initial;
  height: auto !important;
}

.fc .fc-axis,
.fc .fc-time {
  font-weight: 600;
}

.fc .fc-event,
.fc a.fc-event {
  border: 0;
  background: #4e5c68;
  font-weight: 600;
  color: #fff;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.fc .fc-event:focus,
.fc .fc-event:hover,
.fc a.fc-event:focus,
.fc a.fc-event:hover {
  color: #fff;
  opacity: 0.85;
}

.fc .fc-event.fc-day-grid-event,
.fc a.fc-event.fc-day-grid-event {
  padding: 1px 2px;
}

.fc-event-list .fc-event {
  background: 0 0;
  border: 0;
  color: #2d353c;
  padding: 7px 10px 7px 35px;
  font-size: 12px;
  line-height: 16px;
  position: relative;
  background: #fff;
  margin-bottom: 5px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.fc-event-list .fc-event + .fc-event {
  margin-top: 0;
}

.fc-event-list .fc-event .fc-event-icon {
  float: right;
  margin-left: 10px;
}

.fc-event-list .fc-event .fc-event-icon i {
  float: left;
  line-height: 18px;
}

.fc-event-list .fc-event.ui-draggable-dragging {
  border: 1px dashed #d5dbe0;
}

.fc-event-list .fc-event:before {
  content: "\\f0b2";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 25px;
  text-align: center;
  padding-top: 7px;
  padding-bottom: 7px;
  background: #f2f4f5;
  color: #c6ced5;
  font-size: 14px;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

.fc-event-list .fc-event:focus,
.fc-event-list .fc-event:hover {
  color: #2d353c;
  cursor: pointer;
  background: #fff;
}

.fc-event-list .fc-event:focus:before,
.fc-event-list .fc-event:hover:before {
  color: #6f8293;
}

body #gritter-notice-wrapper {
  width: 420px;
  z-index: 1030;
}

@media (max-width: 575.98px) {
  body #gritter-notice-wrapper {
    width: 320px;
  }
}

@media (max-width: 359.98px) {
  body #gritter-notice-wrapper {
    width: 280px;
  }
}

body #gritter-notice-wrapper .gritter-item-wrapper {
  background: 0 0;
  background: rgba(26, 34, 41, 0.9);
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

body #gritter-notice-wrapper .gritter-item-wrapper .gritter-bottom,
body #gritter-notice-wrapper .gritter-item-wrapper .gritter-top {
  background: 0 0;
  display: none;
}

body #gritter-notice-wrapper .gritter-item-wrapper .gritter-item {
  font-family: inherit;
  padding: 12px 95px 12px 15px;
  background: 0 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 575.98px) {
  body #gritter-notice-wrapper .gritter-item-wrapper .gritter-item {
    padding: 10px 70px 10px 10px;
  }
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-with-image,
body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-without-image {
  float: none;
  width: auto;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-image {
  margin: 0 15px 0 0;
  height: auto;
  -webkit-border-radius: 80px;
  border-radius: 80px;
}

@media (max-width: 575.98px) {
  body
    #gritter-notice-wrapper
    .gritter-item-wrapper
    .gritter-item
    .gritter-image {
    width: 36px;
    margin-right: 10px;
  }
}

@media (max-width: 359.98px) {
  body
    #gritter-notice-wrapper
    .gritter-item-wrapper
    .gritter-item
    .gritter-image {
    width: 24px;
  }
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-title {
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 0;
  font-weight: 600;
  color: #fff;
  text-shadow: none;
}

@media (max-width: 575.98px) {
  body
    #gritter-notice-wrapper
    .gritter-item-wrapper
    .gritter-item
    .gritter-title {
    font-size: 12px;
    line-height: 18px;
  }
}

body #gritter-notice-wrapper .gritter-item-wrapper .gritter-item p {
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.15px;
  color: #c6ced5;
}

@media (max-width: 575.98px) {
  body #gritter-notice-wrapper .gritter-item-wrapper .gritter-item p {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0;
  }
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-close {
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  background: 0 0;
  width: 80px;
  height: auto;
  display: block !important;
  font-family: inherit;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  color: #9ba8b4;
}

@media (max-width: 575.98px) {
  body
    #gritter-notice-wrapper
    .gritter-item-wrapper
    .gritter-item
    .gritter-close {
    width: 60px;
  }
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-close:before {
  content: "Close";
  position: absolute;
  text-align: center;
  top: 50%;
  right: 0;
  left: 0;
  color: inherit;
  z-index: 10;
  text-indent: 0;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 12px;
  margin-top: -6px;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-close:focus,
body
  #gritter-notice-wrapper
  .gritter-item-wrapper
  .gritter-item
  .gritter-close:hover {
  color: #fff;
  outline: 0;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper.gritter-light
  .gritter-bottom,
body #gritter-notice-wrapper .gritter-item-wrapper.gritter-light .gritter-item,
body #gritter-notice-wrapper .gritter-item-wrapper.gritter-light .gritter-top {
  background: rgba(255, 255, 255, 0.95);
  color: #6f8293;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper.gritter-light
  .gritter-item
  .gritter-title {
  color: #2d353c;
  font-weight: 600;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper.gritter-light
  .gritter-item
  p {
  color: #4e5c68;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper.gritter-light
  .gritter-close {
  border-color: #d5dbe0;
  color: #6f8293;
}

body
  #gritter-notice-wrapper
  .gritter-item-wrapper.without-rounded-img
  .gritter-item
  .gritter-image {
  -webkit-border-radius: 0;
  border-radius: 0;
}

.hljs-wrapper {
  background: #f2f3f4;
  position: relative;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.hljs-wrapper pre,
.hljs-wrapper pre .hljs,
.hljs-wrapper pre.hljs {
  border: 0;
  padding: 0;
  background: 0 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.hljs-wrapper pre .hljs,
.hljs-wrapper pre.hljs {
  padding: 15px;
  display: block;
  overflow-x: auto;
  font-size: 12px;
  color: #2d353c;
}

.hljs-wrapper pre .hljs .hljs-deletion,
.hljs-wrapper pre .hljs .hljs-name,
.hljs-wrapper pre .hljs .hljs-section,
.hljs-wrapper pre .hljs .hljs-selector-tag,
.hljs-wrapper pre .hljs .hljs-subst,
.hljs-wrapper pre .hljs .hljs-tag,
.hljs-wrapper pre.hljs .hljs-deletion,
.hljs-wrapper pre.hljs .hljs-name,
.hljs-wrapper pre.hljs .hljs-section,
.hljs-wrapper pre.hljs .hljs-selector-tag,
.hljs-wrapper pre.hljs .hljs-subst,
.hljs-wrapper pre.hljs .hljs-tag {
  color: #1968b0;
}

.hljs-wrapper pre .hljs .hljs-attr,
.hljs-wrapper pre .hljs .hljs-number,
.hljs-wrapper pre .hljs .hljs-selector-attr,
.hljs-wrapper pre .hljs .hljs-selector-class,
.hljs-wrapper pre .hljs .hljs-selector-pseudo,
.hljs-wrapper pre .hljs .hljs-template-variable,
.hljs-wrapper pre .hljs .hljs-type,
.hljs-wrapper pre .hljs .hljs-variable,
.hljs-wrapper pre.hljs .hljs-attr,
.hljs-wrapper pre.hljs .hljs-number,
.hljs-wrapper pre.hljs .hljs-selector-attr,
.hljs-wrapper pre.hljs .hljs-selector-class,
.hljs-wrapper pre.hljs .hljs-selector-pseudo,
.hljs-wrapper pre.hljs .hljs-template-variable,
.hljs-wrapper pre.hljs .hljs-type,
.hljs-wrapper pre.hljs .hljs-variable {
  color: #4a9be5;
}

.hljs-wrapper pre .hljs .hljs-addition,
.hljs-wrapper pre .hljs .hljs-attribute,
.hljs-wrapper pre .hljs .hljs-meta-string,
.hljs-wrapper pre .hljs .hljs-regexp,
.hljs-wrapper pre .hljs .hljs-string,
.hljs-wrapper pre.hljs .hljs-addition,
.hljs-wrapper pre.hljs .hljs-attribute,
.hljs-wrapper pre.hljs .hljs-meta-string,
.hljs-wrapper pre.hljs .hljs-regexp,
.hljs-wrapper pre.hljs .hljs-string {
  color: #ff3631;
}

.hljs-wrapper pre .hljs .hljs-comment,
.hljs-wrapper pre.hljs .hljs-comment {
  color: #8c9ba9;
}

.hljs-wrapper .btn-clipboard {
  position: absolute;
  right: 10px;
  top: 10px;
}

.panel-body + .hljs-wrapper {
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.modal .hljs-wrapper {
  margin-top: -1px;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.modal .hljs-wrapper + .modal-footer {
  border-top: none;
}

body .introjs-hint .introjs-hint-dot {
  border-color: rgba(45, 53, 60, 0.3);
}

body .introjs-hint .introjs-hint-pulse {
  background-color: rgba(45, 53, 60, 0.15);
  border-color: rgba(45, 53, 60, 0.15);
}

body .introjs-hint:hover .introjs-hint-pulse {
  border-color: rgba(45, 53, 60, 0.3);
  background-color: rgba(45, 53, 60, 0.3);
}

body .introjs-overlay {
  background: #2d353c;
}

body .introjs-bullets ul li a {
  background: #c6ced5;
}

body .introjs-helperNumberLayer {
  font-size: 36px;
  background: 0 0;
  color: #fff;
  font-family: inherit;
  border: 0;
  text-shadow: none;
  padding: 0;
  text-align: center;
  width: 36px;
  height: 36px;
  line-height: 36px;
  left: -46px;
  top: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body .introjs-helperLayer {
  border: 0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body .introjs-tooltip {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

body .introjs-button {
  background: #f2f3f4;
  border-color: #f2f3f4;
  text-shadow: none;
  color: #2d353c;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body .introjs-button:focus,
body .introjs-button:hover {
  background: #d5dbe0;
  border-color: #d5dbe0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body .introjs-button.introjs-nextbutton {
  border-left-color: #d5dbe0;
}

body .introjs-button.introjs-disabled,
body .introjs-button.introjs-disabled:focus,
body .introjs-button.introjs-disabled:hover {
  color: #9ba8b4;
  background: #f2f3f4;
  border-color: #f2f3f4;
}

body .introjs-tooltipbuttons,
body ul.wysihtml5-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.irs {
  font-family: inherit !important;
}

.irs .irs .irs-line {
  height: 4px;
  top: 27px;
}

.irs .irs .irs-line .irs-line-left,
.irs .irs .irs-line .irs-line-mid,
.irs .irs .irs-line .irs-line-right {
  background: #e4e7ea;
  height: 4px;
}

.irs .irs .irs-line .irs-line-left,
.irs .irs-bar-edge {
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

.irs .irs .irs-line .irs-line-right {
  -webkit-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}

.irs .irs .irs-from,
.irs .irs .irs-single,
.irs .irs .irs-to {
  background: #2d353c;
}

.irs .irs-bar-edge {
  background: #e4e7ea;
  border-right: 1px solid #fff;
  top: 27px;
  height: 4px;
}

.irs .irs-bar {
  background: #348fe2;
  height: 4px;
  top: 27px;
}

.irs .irs-max,
.irs .irs-min {
  font-size: 0.75rem;
  background: #f2f4f5;
  color: #4e5c68;
  font-weight: 600;
}

.irs .irs-slider {
  background: #fff;
  cursor: pointer;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.irs.irs--flat .irs-bar {
  height: 4px;
  top: 27px;
  background: #348fe2;
}

.irs.irs--flat .irs-handle {
  height: 14px;
}

.irs.irs--flat .irs-handle > i:first-child {
  background: #348fe2;
  width: 4px;
}

.irs.irs--flat .irs-handle.state_hover > i:first-child,
.irs.irs--flat .irs-handle:focus > i:first-child,
.irs.irs--flat .irs-handle:hover > i:first-child {
  background: #1a4871;
}

.irs.irs--big,
.irs.irs--modern,
.irs.irs--round,
.irs.irs--sharp,
.irs.irs--square {
  height: 40px;
}

.irs.irs--big .irs .irs-line {
  background: #e4e7ea;
  border: 0;
}

.irs.irs--big .irs-bar {
  height: 4px;
  top: 27px;
  background: #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--big .irs-handle {
  top: 20px;
  width: 20px;
  height: 20px;
  background: #fff;
  border: 0;
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.irs.irs--big .irs-handle.state_hover,
.irs.irs--big .irs-handle:focus,
.irs.irs--big .irs-handle:hover {
  background: #fff;
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}

.irs.irs--modern .irs .irs-line {
  background: #e4e7ea;
  border: 0;
}

.irs.irs--modern .irs-bar {
  height: 4px;
  top: 27px;
  background: #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--modern .irs-handle {
  width: 12px;
  border: 0;
  background: #b6c2c9;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.irs.irs--modern .irs-handle > i:nth-child(1) {
  background: 0 0;
  border: 6px solid transparent;
  border-bottom-color: #b6c2c9;
  top: -12px;
  left: 0;
  -webkit-transform: none;
  -moz-transform: none;
  -ms-transform: none;
  -o-transform: none;
  transform: none;
}

.irs.irs--modern .irs-handle > i:nth-child(2) {
  background: #b6c2c9;
  left: 1px;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.irs.irs--modern .irs-handle > i:nth-child(3) {
  top: 2px;
  left: 4px;
  width: 4px;
  height: 8px;
  border-color: #edf0f2;
}

.irs.irs--modern .irs-handle.state_hover,
.irs.irs--modern .irs-handle:focus,
.irs.irs--modern .irs-handle:hover {
  background: #b6c2c9;
}

.irs.irs--modern .irs-handle.state_hover > i:nth-child(1),
.irs.irs--modern .irs-handle:focus > i:nth-child(1),
.irs.irs--modern .irs-handle:hover > i:nth-child(1) {
  border: 6px solid transparent;
  border-bottom-color: #b6c2c9;
}

.irs.irs--modern .irs-handle.state_hover > i:nth-child(2),
.irs.irs--modern .irs-handle:focus > i:nth-child(2),
.irs.irs--modern .irs-handle:hover > i:nth-child(2) {
  background: #b6c2c9;
}

.irs.irs--modern .irs-handle.state_hover > i:nth-child(3),
.irs.irs--modern .irs-handle:focus > i:nth-child(3),
.irs.irs--modern .irs-handle:hover > i:nth-child(3) {
  border-color: #5b6165;
}

.irs.irs--sharp .irs .irs-line {
  background: #e4e7ea;
  border: 0;
}

.irs.irs--sharp .irs-bar {
  height: 4px;
  top: 27px;
  background: #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--sharp .irs-handle {
  top: 23px;
  background: #67abe9;
}

.irs.irs--sharp .irs-handle > i:first-child {
  border-top-color: #67abe9;
}

.irs.irs--sharp .irs-handle.state_hover,
.irs.irs--sharp .irs-handle:focus,
.irs.irs--sharp .irs-handle:hover {
  background: #2d353c;
}

.irs.irs--sharp .irs-handle.state_hover > i:first-child,
.irs.irs--sharp .irs-handle:focus > i:first-child,
.irs.irs--sharp .irs-handle:hover > i:first-child {
  border-top-color: #2d353c;
}

.irs.irs--round .irs-bar {
  height: 4px;
  top: 27px;
  background: #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--round .irs-handle {
  top: 20px;
  width: 20px;
  height: 20px;
  border: 3px solid #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--square .irs-bar {
  height: 4px;
  top: 27px;
  background: #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--square .irs-handle {
  top: 21px;
  width: 16px;
  height: 16px;
  border: 3px solid #348fe2;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.irs.irs--big .irs-from,
.irs.irs--big .irs-single,
.irs.irs--big .irs-to,
.irs.irs--flat .irs-from,
.irs.irs--flat .irs-single,
.irs.irs--flat .irs-to,
.irs.irs--modern .irs-from,
.irs.irs--modern .irs-single,
.irs.irs--modern .irs-to,
.irs.irs--round .irs-from,
.irs.irs--round .irs-single,
.irs.irs--round .irs-to,
.irs.irs--sharp .irs-from,
.irs.irs--sharp .irs-single,
.irs.irs--sharp .irs-to,
.irs.irs--square .irs-from,
.irs.irs--square .irs-single,
.irs.irs--square .irs-to {
  font-size: 11px;
  font-weight: 600;
}

.irs.irs--big .irs-from:before,
.irs.irs--big .irs-single:before,
.irs.irs--big .irs-to:before,
.irs.irs--flat .irs-from:before,
.irs.irs--flat .irs-single:before,
.irs.irs--flat .irs-to:before,
.irs.irs--modern .irs-from:before,
.irs.irs--modern .irs-single:before,
.irs.irs--modern .irs-to:before,
.irs.irs--round .irs-from:before,
.irs.irs--round .irs-single:before,
.irs.irs--round .irs-to:before,
.irs.irs--sharp .irs-from:before,
.irs.irs--sharp .irs-single:before,
.irs.irs--sharp .irs-to:before,
.irs.irs--square .irs-from:before,
.irs.irs--square .irs-single:before,
.irs.irs--square .irs-to:before {
  border-top-color: #2d353c;
}

.irs.irs--big .irs-max,
.irs.irs--big .irs-min,
.irs.irs--flat .irs-max,
.irs.irs--flat .irs-min,
.irs.irs--modern .irs-max,
.irs.irs--modern .irs-min,
.irs.irs--round .irs-max,
.irs.irs--round .irs-min,
.irs.irs--sharp .irs-max,
.irs.irs--sharp .irs-min,
.irs.irs--square .irs-max,
.irs.irs--square .irs-min {
  color: #2d353c;
  font-size: 11px;
  font-weight: 600;
  background: #dbe1e4;
}

.ui-widget {
  font-family: inherit;
}

.ui-widget.ui-autocomplete {
  padding: 5px 0;
  border: 0;
  font-size: 12px;
  -webkit-box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  -webkit-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
}

.ui-widget.ui-autocomplete .ui-menu-item-wrapper {
  padding: 5px 12px;
}

.ui-widget.ui-autocomplete .ui-menu-item-wrapper.ui-state-active {
  background: #348fe2;
  border: 0;
  color: #fff;
  margin: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.sw-main.sw-theme-default {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.sw-main.sw-theme-default .step-anchor {
  background: #f2f3f4;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

@media (max-width: 1199.98px) {
  .sw-main.sw-theme-default .step-anchor {
    overflow: scroll;
    white-space: nowrap;
  }
}

.sw-main.sw-theme-default .step-anchor > li {
  display: block;
  float: none;
  padding: 0;
  margin: 0;
}

@media (min-width: 992px) {
  .sw-main.sw-theme-default .step-anchor > li {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
}

.sw-main.sw-theme-default .step-anchor > li > a {
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 20px !important;
  margin: 0;
  color: #2d353c;
  -webkit-border-radius: 0;
  border-radius: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 1199.98px) {
  .sw-main.sw-theme-default .step-anchor > li > a {
    padding: 15px !important;
  }
}

.sw-main.sw-theme-default .step-anchor > li > a .number {
  padding: 0;
  height: 24px;
  width: 24px;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  margin-right: 10px;
  background: #d5dbe0;
  color: #2d353c;
  font-weight: 700;
  position: relative;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.sw-main.sw-theme-default .step-anchor > li > a small {
  display: block;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #6f8293;
}

.sw-main.sw-theme-default .step-anchor > li.active {
  background: #348fe2 !important;
}

.sw-main.sw-theme-default .step-anchor > li.active > a {
  color: #fff !important;
}

.sw-main.sw-theme-default .step-anchor > li.active > a .number {
  background: #276baa;
  color: #fff;
}

.sw-main.sw-theme-default .step-anchor > li.active > a small {
  color: #9ac7f1;
}

.sw-main.sw-theme-default .step-anchor > li.done > a .number {
  background: #2d353c !important;
}

.sw-main.sw-theme-default .step-anchor > li.done > a .number:before {
  content: "\\f00c";
  background: #2d353c !important;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

.sw-main.sw-theme-default .sw-container {
  margin: 0 !important;
  padding: 0;
  -webkit-border-radius: 0 !important;
  border-radius: 0 !important;
}

.sw-main.sw-theme-default .sw-container .step-content {
  background: #fff;
  padding: 20px 30px;
  border: 0 !important;
}

@media (max-width: 767.98px) {
  .sw-main.sw-theme-default .sw-container .step-content {
    padding: 20px;
  }
}

.sw-main.sw-theme-default .sw-toolbar {
  background: #f2f3f4;
  padding: 15px;
}

.sw-main.sw-theme-default .sw-toolbar:after,
.sw-main.sw-theme-default .sw-toolbar:before {
  content: "";
  display: table;
  clear: both;
}

.sw-main.sw-theme-default .sw-toolbar .sw-btn-group {
  margin: 0;
}

.sw-main.sw-theme-default .sw-toolbar .sw-btn-group .btn {
  min-width: 100px;
  -webkit-border-radius: 4px !important;
  border-radius: 4px !important;
}

.sw-main.sw-theme-default .sw-toolbar .sw-btn-group .btn + .btn {
  margin-left: 10px;
  border-left: none;
}

.ui-sortable .panel-heading {
  cursor: move;
}

.ui-sortable .ui-sortable-placeholder {
  border: 1px dashed #9ba8b4 !important;
  visibility: visible !important;
  background: 0 0 !important;
  margin: 0 !important;
}

.ui-sortable .ui-sortable-placeholder.panel {
  margin: -1px -1px 19px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.ui-sortable.ui-sortable-disabled .panel-heading {
  cursor: default;
}

.jstree .jstree-container-ul .jstree-node {
  position: relative;
  background: 0 0 !important;
}

.jstree .jstree-container-ul .jstree-node:before {
  content: "";
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 1px;
  border-left: 1px dotted #c6ced5;
}

.jstree .jstree-container-ul .jstree-node:last-child:before {
  bottom: 11px;
}

.jstree .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl {
  position: relative;
  background: 0 0;
}

.jstree .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl:before {
  content: "";
  position: absolute;
  left: 50%;
  right: 1px;
  top: 50%;
  border-top: 1px dotted #c6ced5;
}

.jstree .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -3px;
  margin-top: -3px;
  border: 5px solid transparent;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.jstree .jstree-container-ul .jstree-node .jstree-anchor {
  color: #6f8293;
  font-weight: 600;
}

.jstree
  .jstree-container-ul
  .jstree-node
  .jstree-anchor
  .jstree-icon.jstree-checkbox {
  background: 0 0;
}

.jstree
  .jstree-container-ul
  .jstree-node
  .jstree-anchor
  .jstree-icon.jstree-checkbox:before {
  content: "";
  position: absolute;
  left: 4px;
  top: 4px;
  right: 4px;
  bottom: 4px;
  border: 1px solid #d5dbe0;
  display: block;
  background: #fff;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.jstree
  .jstree-container-ul
  .jstree-node
  .jstree-anchor
  .jstree-icon.jstree-checkbox:after {
  content: "";
  position: absolute;
  left: 7px;
  top: 7px;
  right: 7px;
  bottom: 7px;
  display: block;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.jstree .jstree-container-ul .jstree-node .jstree-anchor.jstree-clicked {
  color: #2d353c;
}

.jstree
  .jstree-container-ul
  .jstree-node
  .jstree-anchor.jstree-clicked
  .jstree-icon.jstree-checkbox:after {
  content: "\\f00c";
  font-size: 10px;
  line-height: 15px;
  color: #2d353c;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td.day.new,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td.day.new,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td.day.new,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td.day.new,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td.day.new,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td.day.new,
.jstree .jstree-container-ul .jstree-node .jstree-anchor.jstree-disabled {
  color: #9ba8b4;
}

.jstree
  .jstree-container-ul
  .jstree-node
  .jstree-anchor.jstree-disabled
  > .jstree-icon {
  opacity: 0.4;
  -webkit-filter: none;
  filter: none;
}

.jstree .jstree-container-ul .jstree-node .jstree-hovered,
.jstree .jstree-container-ul .jstree-node .jstree-wholerow-hovered {
  background: 0 0;
  color: #2d353c;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.jstree .jstree-container-ul .jstree-node .jstree-clicked,
.jstree .jstree-container-ul .jstree-node .jstree-wholerow-clicked {
  background: #f2f3f4;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.jstree
  .jstree-container-ul
  .jstree-node.jstree-open
  .jstree-anchor
  > .fa-folder:before {
  content: "\\f07c";
  color: #9ba8b4;
}

.jstree
  .jstree-container-ul
  .jstree-node.jstree-open
  .jstree-anchor.jstree-clicked
  > .fa-folder:before {
  color: #2d353c;
}

.jstree .jstree-container-ul .jstree-node.jstree-open > .jstree-ocl:after {
  border-left-color: #9ba8b4;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.jstree .jstree-container-ul .jstree-node.jstree-closed > .jstree-ocl:after {
  border-left-color: #9ba8b4;
  margin-top: -5px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
}

.jvectormap-container .jvectormap-zoomin,
.jvectormap-container .jvectormap-zoomout {
  width: 16px;
  height: 16px;
  padding: 0;
  line-height: 16px;
  left: 15px;
  color: #2d353c;
  background: #fff;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.jvectormap-container .jvectormap-label {
  padding: 3px 6px;
  border: 0;
  background: rgba(0, 0, 0, 0.6);
}

.jvectormap-tip {
  padding: 3px 6px !important;
  border: 0 !important;
  background: rgba(0, 0, 0, 0.6) !important;
}

.map .jvectormap-zoomin,
.map .jvectormap-zoomout {
  width: 20px !important;
  height: 20px !important;
  font-size: 14px;
  line-height: 20px !important;
  left: 30px !important;
}

@media (max-width: 767.98px) {
  .map .jvectormap-zoomin,
  .map .jvectormap-zoomout {
    left: 20px !important;
  }
}

.map .jvectormap-zoomin {
  top: 70px;
}

@media (max-width: 1199.98px) {
  .map .jvectormap-zoomin {
    top: 100px;
  }
}

.map .jvectormap-zoomout {
  top: 95px;
}

@media (max-width: 1199.98px) {
  .map .jvectormap-zoomout {
    top: 125px;
  }
}

.material-icons {
  text-rendering: optimizeLegibility;
}

.morris-hover {
  z-index: 0 !important;
}

.morris-hover.morris-default-style {
  padding: 6px 10px;
  color: #2d353c;
  background: #f2f3f4;
  border: 0;
  font-family: inherit;
  font-size: 12px;
  text-align: center;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.morris-inverse .morris-hover {
  background: rgba(26, 34, 41, 0.85) !important;
  border: 0 !important;
  padding: 10px !important;
  color: #fff !important;
  -webkit-border-radius: 8px !important;
  border-radius: 8px !important;
}

html .nvd3-svg {
  direction: ltr;
}

html .nvtooltip {
  font-family: inherit;
  font-size: 12px;
  border: 0;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.95);
  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

html .nvtooltip table thead tr th strong {
  text-decoration: underline;
}

html .nvtooltip table tbody td.legend-color-guide div {
  border: 0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

html .nvd3-inverse-mode .nvd3 line.nv-guideline {
  stroke: rgba(255, 255, 255, 0.5);
}

html .nvd3-inverse-mode .nvd3 .nv-bars text {
  fill: #fff;
}

html .nvd3-inverse-mode .nvd3 .nv-axis line,
html .nvd3-inverse-mode .nvd3 .nv-axis path {
  fill: none;
  stroke: rgba(255, 255, 255, 0.15);
}

html .nvd3-inverse-mode .nvd3 .nv-legend-text,
html .nvd3-inverse-mode .nvd3 .nv-x text,
html .nvd3-inverse-mode .nvd3 .nv-y text {
  font-family: inherit;
  fill: rgba(255, 255, 255, 0.75);
  font-size: 11px;
  font-weight: 600;
}

html .nvd3-inverse-mode .nvd3 .nv-label text {
  fill: rgba(255, 255, 255, 0.75) !important;
}

html .nvd3-inverse-mode .nvd3 .nv-legend-symbol {
  r: 3;
}

html .nvd3-inverse-mode .nvd3.nv-pie .nv-pie-title {
  fill: rgba(255, 255, 255, 0.75);
}

html .nvd3-inverse-mode .nvd3.nv-pie path {
  stroke: rgba(0, 0, 0, 0.2);
}

.pace-top .pace .pace-progress {
  top: 0 !important;
}

.pace-top .pace .pace-activity {
  top: 15px !important;
}

.pace {
  background: 0 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  opacity: 1;
  -webkit-transition: opacity 1s;
  -moz-transition: opacity 1s;
  -ms-transition: opacity 1s;
  -o-transition: opacity 1s;
  transition: opacity 1s;
}

.pace .pace-progress {
  top: 50px;
  height: 3px;
  background: #00acac;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

@media (max-width: 767.98px) {
  .pace .pace-progress {
    top: 101px;
  }
}

.pace .pace-progress .pace-progress-inner {
  display: none;
}

.pace .pace-activity {
  display: block;
  position: fixed;
  z-index: 1030;
  top: 63px;
  right: 10px;
  width: 15px;
  height: 15px;
  border: 2px solid transparent;
  border-top-color: #00acac;
  border-left-color: #00acac;
  -webkit-animation: pace-spinner 400ms linear infinite;
  -moz-animation: pace-spinner 400ms linear infinite;
  -ms-animation: pace-spinner 400ms linear infinite;
  -o-animation: pace-spinner 400ms linear infinite;
  animation: pace-spinner 400ms linear infinite;
  -webkit-border-radius: 40px;
  border-radius: 40px;
}

@media (max-width: 767.98px) {
  .pace .pace-activity {
    top: 113px;
  }
}

.pace.pace-inactive {
  display: block;
  opacity: 0;
}

.pace-done .pace.pace-inactive {
  display: block;
}

.parsley-error {
  background: #fff !important;
  border-color: #ff5b57 !important;
  color: #2d353c !important;
}

.parsley-error:focus {
  border-color: #ff5b57 !important;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.125rem rgba(255, 91, 87, 0.3) !important;
  box-shadow: 0 0 0 0.125rem rgba(255, 91, 87, 0.3) !important;
}

.parsley-success {
  background: #fff !important;
  border-color: #00acac !important;
  color: #2d353c !important;
}

.parsley-success:focus {
  border-color: #00acac !important;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.125rem rgba(0, 172, 172, 0.3) !important;
  box-shadow: 0 0 0 0.125rem rgba(0, 172, 172, 0.3) !important;
}

.parsley-errors-list {
  padding: 0 !important;
  list-style-type: none !important;
  margin: 0 !important;
  color: #ff100b;
  font-size: 12px !important;
  line-height: inherit !important;
}

.parsley-errors-list.filled {
  margin-top: 5px !important;
}

.slider-wrapper {
  padding: 15px 30px;
}

.slider-wrapper .range-bar {
  background: #e4e7ea;
}

.slider-wrapper .range-bar .range-max,
.slider-wrapper .range-bar .range-min {
  color: #2d353c;
}

.slider-wrapper .range-bar .range-handle {
  cursor: pointer;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.slider-wrapper .range-bar .range-quantity {
  background: #348fe2;
}

.slider-wrapper.red .range-bar .range-quantity {
  background: #ff5b57;
}

.slider-wrapper.teal .range-bar .range-quantity {
  background: #00acac;
}

.slider-wrapper.purple .range-bar .range-quantity {
  background: #727cb6;
}

.slider-wrapper.orange .range-bar .range-quantity {
  background: #f59c1a;
}

.slider-wrapper.black .range-bar .range-quantity {
  background: #2d353c;
}

.slider-wrapper.slider-without-range {
  padding: 15px 0;
}

.slider-wrapper.slider-vertical {
  padding-left: 15px;
  padding-right: 15px;
}

.pwstrength-progress .progress {
  height: 12px;
  -webkit-border-radius: 60px;
  border-radius: 60px;
}

.pwstrength-progress .progress .progress-bar {
  min-width: 10% !important;
}

body .select2-container .select2-choice {
  height: auto !important;
  line-height: 18px !important;
  padding: 0 !important;
  border: 0 !important;
  background: 0 0 !important;
  margin-right: -5px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

body .select2-container .select2-choice .select2-chosen {
  font-weight: 600;
  color: #9ba8b4;
}

body .select2-container .select2-choice .select2-search-choice-close {
  background: #e4e7ea !important;
  font-size: 9px;
  text-align: center;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #9ba8b4;
  top: 1px;
  right: 20px;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-border-radius: 20px;
  border-radius: 20px;
}

body .select2-container .select2-choice .select2-search-choice-close:before {
  content: "\\f00d";
}

body .select2-container .select2-choice .select2-search-choice-close:focus,
body .select2-container .select2-choice .select2-search-choice-close:hover {
  background: #c6ced5 !important;
  color: #6f8293;
}

body .select2-container .select2-choice .select2-arrow {
  background: 0 0;
  border: 0;
  display: block;
  width: 14px;
  text-align: center;
  right: -1px;
  top: 1px;
}

body .select2-container .select2-choice .select2-arrow b,
body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close {
  background: 0 0 !important;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body .select2-container .select2-choice .select2-arrow b:before {
  content: "\\f078";
  color: #c6ced5;
}

body .select2-container.select2-container-multi .select2-choices {
  padding: 0;
  border: 0;
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-choice {
  margin: 0 5px 5px 0;
  background: #e4e7ea;
  color: #6f8293;
  font-weight: 600;
  border: 0;
  padding: 3px 3px 3px 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-shadow: none;
  box-shadow: none;
}

body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close {
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin-left: 5px;
  color: #c6ced5;
}

body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close:before {
  content: "\\f00d";
  font-size: 12px;
}

body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close:focus,
body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close:hover {
  color: #6f8293;
  text-decoration: none;
}

body
  .select2-container.select2-container-multi
  .select2-choices
  .select2-search-field
  input {
  padding: 0 !important;
  height: 19px !important;
}

body .select2-drop {
  margin-top: -3px;
}

body .select2-drop .select2-results {
  padding: 0;
  margin: 5px 0;
}

body .select2-drop .select2-results .select2-result {
  font-weight: 600;
  color: #2d353c;
}

body .select2-drop .select2-results .select2-result.select2-highlighted {
  background: #d5dbe0 !important;
  color: #2d353c;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date,
body .select2-drop .select2-search {
  position: relative;
}

body .select2-drop .select2-search input {
  border: 1px solid #d5dbe0;
  background: 0 0 !important;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

body .select2-drop .select2-search input:focus {
  border-color: #5db0ff;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

body .select2-drop .select2-search:before {
  content: "\\f002";
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -5px;
  font-size: 12px;
  line-height: 14px;
  color: #c6ced5;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body .select2-drop.select2-drop-active {
  border-color: #d5dbe0;
}

body .select2-drop.select2-drop-above {
  margin-top: 3px;
  border-top-color: #d5dbe0 !important;
}

.select2.select2-container {
  display: block;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple,
.select2.select2-container
  .selection
  .select2-selection.select2-selection--single {
  border-color: #d5dbe0;
  outline: 0;
  height: 34px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple {
  height: auto;
  min-height: 34px;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--single
  .select2-selection__rendered {
  padding: 6px 12px;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered,
.select2.select2-container
  .selection
  .select2-selection.select2-selection--single
  .select2-selection__rendered {
  line-height: 1;
  font-weight: 600;
  color: #2d353c;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__arrow,
.select2.select2-container
  .selection
  .select2-selection.select2-selection--single
  .select2-selection__arrow {
  height: auto;
  width: auto;
  position: relative;
  top: 0;
  right: 0;
  padding: 6px 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__arrow
  b,
.select2.select2-container
  .selection
  .select2-selection.select2-selection--single
  .select2-selection__arrow
  b {
  position: relative;
  top: 0;
  left: 0;
  margin: 0;
  border: 0;
  color: #2d353c;
  width: auto;
  height: auto;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__arrow
  b:before,
.select2.select2-container
  .selection
  .select2-selection.select2-selection--single
  .select2-selection__arrow
  b:before {
  content: "\\f0d7";
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered {
  padding: 6px 12px 1px;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered
  .select2-search--inline {
  float: none;
  min-width: 100px;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered
  .select2-search--inline
  .select2-search__field {
  margin-top: 0;
  margin-bottom: 5px;
  font-weight: 600;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered
  .select2-search--inline
  .select2-search__field::-webkit-input-placeholder {
  color: #6f8293;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered
  .select2-search--inline
  .select2-search__field::-moz-placeholder {
  color: #6f8293;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered
  .select2-search--inline
  .select2-search__field:-ms-input-placeholder {
  color: #6f8293;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__rendered
  .select2-search--inline
  .select2-search__field:-moz-placeholder {
  color: #6f8293;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__choice {
  border: 0;
  background: #e4e7ea;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-top: 0;
  padding: 4px 8px;
  color: #4e5c68;
  float: none;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.select2.select2-container
  .selection
  .select2-selection.select2-selection--multiple
  .select2-selection__choice
  .select2-selection__choice__remove {
  color: #9ba8b4;
  font-size: 13px;
  margin-right: 0;
  margin-left: 5px;
  margin-bottom: -1px;
  float: right;
}

.select2.select2-container.select2-container--above.select2-container--open
  .selection
  .select2-selection.select2-selection--single
  .select2-selection__arrow
  b:before {
  content: "\\f0d8";
}

.select2-container .select2-dropdown {
  border: 0;
  -webkit-box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.select2-container .select2-dropdown .select2-search--dropdown {
  padding: 6px;
}

.select2-container .select2-dropdown .select2-search--dropdown input {
  border-color: #d5dbe0;
  height: 34px;
  padding: 6px 12px;
  outline: 0;
  color: #2d353c;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.select2-container .select2-dropdown .select2-search--dropdown input:focus {
  border-color: #5db0ff;
  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);
}

.select2-container
  .select2-dropdown
  .select2-results
  .select2-results__options
  .select2-results__option {
  font-weight: 600;
  color: #4e5c68;
}

.select2-container
  .select2-dropdown
  .select2-results
  .select2-results__options
  .select2-results__option
  .select2-results__group {
  padding: 15px 6px 6px;
  color: #2d353c;
  font-size: 11px;
}

.select2-container
  .select2-dropdown
  .select2-results
  .select2-results__options
  .select2-results__option
  .select2-results__option {
  padding: 6px 15px;
}

.select2-container
  .select2-dropdown
  .select2-results
  .select2-results__options
  .select2-results__option.select2-results__option--highlighted {
  background: #f2f3f4;
  color: #2d353c;
}

.select2-container
  .select2-dropdown
  .select2-results
  .select2-results__options
  .select2-results__option.select2-results__message {
  font-weight: 600;
  font-size: 11px;
  color: #6f8293;
  padding: 6px;
}

.select2-container
  .select2-dropdown
  .select2-results
  .select2-results__options
  .select2-results__option[aria-selected="true"] {
  background: #348fe2;
  color: #fff;
}

.select2-container .select2-dropdown.select2-dropdown--above {
  -webkit-box-shadow: 0 -8px 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 -8px 16px rgba(0, 0, 0, 0.15);
}

.simplecolorpicker {
  z-index: 1010 !important;
}

.simplecolorpicker .color,
.simplecolorpicker .icon,
.simplecolorpicker.icon {
  width: 20px;
  height: 20px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.simplecolorpicker .color:focus,
.simplecolorpicker .icon:focus,
.simplecolorpicker.icon:focus {
  outline: 0 !important;
}

.simplecolorpicker.fontawesome .color[data-selected]:after,
.simplecolorpicker.glyphicons .color[data-selected]:after {
  display: block;
  text-align: center;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.simplecolorpicker.glyphicons .color[data-selected]:after {
  content: "\\f00c" !important;
  margin-left: 2px !important;
  top: 0 !important;
}

.simplecolorpicker.inline {
  padding: 5px 0 0 !important;
}

.simplecolorpicker.picker {
  border: 0 !important;
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175) !important;
}

.simplecolorpicker.picker .color {
  width: 20px;
  height: 20px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.slimScrollDiv .slimScrollBar,
.slimScrollDiv .slimScrollRail {
  width: 6px !important;
  right: 2px !important;
}

.slimScrollDiv .slimScrollBar {
  background: 0 0 !important;
}

.slimScrollDiv .slimScrollBar:before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  bottom: 2px;
  left: 0;
  background: #2d353c !important;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.inverse-mode .slimScrollDiv .slimScrollBar:before {
  background: rgba(255, 255, 255, 0.5) !important;
}

body .jqstooltip {
  border: 0;
  width: auto !important;
  height: auto !important;
  background: rgba(45, 53, 60, 0.9);
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.note-editor .note-toolbar {
  background: #2d353c;
  padding: 10px 15px !important;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.note-editor .note-toolbar.panel-heading .note-btn-group {
  margin-top: 0 !important;
}

.note-editor .note-toolbar.panel-heading .note-btn-group .btn {
  margin: 0 !important;
}

.note-editor .note-toolbar .dropdown-menu > li > a {
  display: block;
  padding: 5px 15px;
  color: #2d353c;
  text-decoration: none;
  white-space: nowrap;
}

.note-editor .note-editing-area .note-editable,
.note-editor .note-placeholder {
  padding: 15px !important;
}

.note-editor .modal .modal-header {
  display: block;
}

.note-editor .modal .modal-header .close {
  margin-top: -10px;
}

.note-editor.note-frame {
  border: 0 !important;
  margin: 0 !important;
  background: 0 0;
}

.note-editor.fullscreen .note-toolbar-wrapper,
.note-popover.popover,
.superbox.superbox-active .superbox-list .superbox-img img,
body ul.wysihtml5-toolbar .glyphicon.glyphicon-quote:before {
  display: none;
}

.note-popover.popover .note-toolbar,
.note-popover.popover .popover-content {
  padding: 10px 15px !important;
  background: #2d353c;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.note-toolbar .dropdown-toggle:after {
  display: none !important;
}

.superbox.superbox-active {
  font-size: 0;
  margin: -1px -1px 0 0;
}

.superbox.superbox-active .superbox-list {
  display: inline-block;
  position: relative;
  background: 0 0;
}

.superbox.superbox-active .superbox-list .superbox-img {
  width: 100%;
  cursor: pointer;
  display: block;
  padding-top: 75%;
  position: relative;
}

.superbox.superbox-active .superbox-list .superbox-img span {
  position: absolute;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  background-size: cover !important;
  background-position: center !important;
}

.superbox.superbox-active .superbox-list .superbox-img:hover {
  opacity: 0.8;
}

.superbox.superbox-active .superbox-list.superbox-O {
  z-index: 10;
}

.superbox.superbox-active .superbox-list.superbox-O:after,
.superbox.superbox-active .superbox-list.superbox-O:before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  border: 10px solid transparent;
  border-bottom-color: #d9e0e7;
  margin-left: -10px;
  z-index: 10;
}

.superbox.superbox-active .superbox-list.superbox-O:after {
  bottom: -3px;
  border-bottom-color: #2d353c;
  z-index: 20;
}

.superbox.superbox-active .superbox-show {
  background: #2d353c !important;
  margin: 1px 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.superbox.superbox-active .superbox-show .superbox-current-img {
  max-width: 100%;
  border: 0;
  -webkit-box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
}

.superbox.superbox-active .superbox-close {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 25px;
  width: 35px;
  height: 35px;
}

.swal-overlay .swal-modal .swal-icon--success,
.swal-overlay .swal-modal .swal-icon--success__ring {
  border-color: rgba(0, 172, 172, 0.2);
}

.swal-overlay .swal-modal .swal-icon--success__line--long,
.swal-overlay .swal-modal .swal-icon--success__line--tip {
  background-color: #00acac;
}

.swal-overlay .swal-modal .swal-icon--info {
  border-color: #49b6d6;
}

.swal-overlay .swal-modal .swal-icon--info:after,
.swal-overlay .swal-modal .swal-icon--info:before {
  background-color: #49b6d6;
}

.swal-overlay .swal-modal .swal-icon--warning {
  border-color: #f59c1a;
}

.swal-overlay .swal-modal .swal-icon--warning .swal-icon--warning__body,
.swal-overlay .swal-modal .swal-icon--warning .swal-icon--warning__dot {
  background-color: #f59c1a;
}

.swal-overlay .swal-modal .swal-icon--error {
  border-color: #ff5b57;
}

.swal-overlay .swal-modal .swal-icon--error .swal-icon--error__line {
  background-color: #ff5b57;
}

.tagit.ui-widget {
  border: 1px solid #d5dbe0;
  background: #fff;
  padding: 3px 6px;
  margin-bottom: 0;
  font-family: inherit;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.tagit.ui-widget li,
body ul.wysihtml5-toolbar > li {
  float: none;
}

.tagit.ui-widget li.tagit-choice {
  background: #d5dbe0;
  border: 0;
  color: #4e5c68;
  padding: 2px 24px 2px 6px;
  font-weight: 600;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.tagit.ui-widget li.tagit-choice .tagit-close {
  right: 2px;
  line-height: 24px;
  text-align: center;
  top: 0;
  margin: 0;
}

.tagit.ui-widget li.tagit-choice .tagit-close .ui-icon-close {
  background: 0 0;
  height: 24px;
  width: 16px;
  text-indent: 0;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.tagit.ui-widget li.tagit-choice .tagit-close .ui-icon-close:before {
  content: "\\f00d";
  font-size: 10px;
  color: inherit;
}

.tagit.ui-widget li.tagit-choice .tagit-close:focus .ui-icon-close:before,
.tagit.ui-widget li.tagit-choice .tagit-close:hover .ui-icon-close:before {
  color: rgba(0, 0, 0, 0.4);
}

.tagit.ui-widget li.tagit-new {
  padding: 2px 0;
}

.tagit.ui-widget.inverse li.tagit-choice {
  background: #2d353c;
  color: #fff;
}

.tagit.ui-widget.inverse
  li.tagit-choice
  .tagit-close:focus
  .ui-icon-close:before,
.tagit.ui-widget.inverse
  li.tagit-choice
  .tagit-close:hover
  .ui-icon-close:before {
  color: rgba(255, 255, 255, 0.4);
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .twitter-typeahead
  .tt-dropdown-menu
  .tt-suggestion.tt-is-under-cursor,
.tagit.ui-widget.primary li.tagit-choice {
  background: #348fe2;
  color: #fff;
}

.tagit.ui-widget.info li.tagit-choice {
  background: #49b6d6;
  color: #fff;
}

.tagit.ui-widget.success li.tagit-choice {
  background: #00acac;
  color: #fff;
}

.tagit.ui-widget.warning li.tagit-choice {
  background: #f59c1a;
  color: #fff;
}

.tagit.ui-widget.danger li.tagit-choice {
  background: #ff5b57;
  color: #fff;
}

.wysihtml5-sandbox {
  width: 100% !important;
  border-color: #d5dbe0 !important;
  padding: 15px !important;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .add-on
  i,
body ul.wysihtml5-toolbar .glyphicon {
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-quote:after {
  content: "\\f10d";
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-list:before {
  content: "\\f03a";
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-indent-right:before {
  content: "\\f038";
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-indent-left:before {
  content: "\\f036";
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-th-list:before {
  content: "\\f00b";
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-share:before {
  content: "\\f064";
}

body ul.wysihtml5-toolbar .glyphicon.glyphicon-picture:before {
  content: "\\f03e";
}

.panel-form .wysihtml5-toolbar {
  padding: 15px 15px 5px;
}

.panel-form .wysihtml5-sandbox {
  -webkit-border-radius: 0 0 4px 4px !important;
  border-radius: 0 0 4px 4px !important;
}

.editable-container,
.editable-container .editableform .form-group > div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.editable-container .editableform {
  display: block;
}

.editable-container .editableform .form-group > div {
  margin-bottom: -5px;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}

.editable-container .editableform .form-group > div .editable-input {
  margin-right: 5px;
  margin-bottom: 5px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .editable-clear-x {
  right: 12px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .editable-checklist
  > div
  > label {
  -webkit-box-pack: left;
  -ms-flex-pack: left;
  justify-content: left;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .editable-checklist
  > div
  > label
  input {
  margin-right: 5px;
  height: inherit;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .form-control {
  margin-top: -1px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .add-on {
  background: #d5dbe0;
  padding: 5px 10px;
  min-height: 34px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .add-on
  i {
  width: auto;
  height: auto;
  margin: 0;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker {
  width: 300px;
  color: #2d353c;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev {
  color: transparent;
  width: 14.28%;
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev:before {
  color: #6f8293;
  position: absolute;
  font-size: 14px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.prev:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.prev:before {
  content: "\\f104";
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.next:before,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.next:before {
  content: "\\f105";
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.switch,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.switch {
  width: auto;
  font-weight: 700;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  thead
  tr
  th.dow,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  thead
  tr
  th.dow,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  thead
  tr
  th.dow,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  thead
  tr
  th.dow,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  thead
  tr
  th.dow,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  thead
  tr
  th.dow {
  padding: 5px 0;
  border: 0;
  font-weight: 700;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.century.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.decade.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.hour.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.month.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-centuries
  table
  tbody
  tr
  td
  span.year.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.century.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.decade.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.hour.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.month.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-days
  table
  tbody
  tr
  td
  span.year.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.century.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.decade.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.hour.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.month.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-decades
  table
  tbody
  tr
  td
  span.year.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.century.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.decade.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.hour.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.month.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-hours
  table
  tbody
  tr
  td
  span.year.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.century.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.decade.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.hour.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.month.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-months
  table
  tbody
  tr
  td
  span.year.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.century.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.decade.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.hour.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.month.active,
.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .input-append.date
  .datetimepicker
  .datetimepicker-years
  table
  tbody
  tr
  td
  span.year.active {
  background: #348fe2 !important;
  color: #fff;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .editable-address
  input {
  border: 1px solid #d5dbe0;
  padding: 6px 10px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .editable-address
  input:focus {
  outline: 0;
  border-color: #5db0ff;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .twitter-typeahead
  .tt-hint {
  line-height: 22px;
  padding: 5px 11px;
  opacity: 0.6;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .twitter-typeahead
  .tt-dropdown-menu {
  border: 0;
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-input
  .twitter-typeahead
  .tt-dropdown-menu
  .tt-suggestion {
  padding: 5px 12px;
}

.editable-container .editableform .form-group > div .editable-buttons {
  margin-left: 0;
  margin-bottom: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.editable-container .editableform .form-group > div .editable-buttons .btn {
  width: 34px;
  height: 34px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons
  .btn
  + .btn {
  margin-left: 5px;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons
  .btn
  .glyphicon-ok,
.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons
  .btn
  .glyphicon-remove {
  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons
  .btn
  .glyphicon-ok:before {
  content: "\\f00c";
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons
  .btn
  .glyphicon-remove:before {
  content: "\\f00d";
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons.editable-buttons-bottom {
  display: block;
}

.editable-container
  .editableform
  .form-group
  > div
  .editable-buttons.editable-buttons-bottom
  .btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.editable-container .editableform .form-group.has-error .form-control {
  border-color: #ec5450;
  background: #ffefee;
}

.editable-container .editableform .form-group.has-error .editable-error-block {
  margin: 0 0 0 10px;
  white-space: nowrap;
  color: #d94d4a;
}

.row.row-space-0 > [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.row.row-space-2 > [class*="col-"] {
  padding-left: 1;
  padding-right: 1;
}

.row.row-space-4 > [class*="col-"] {
  padding-left: 2;
  padding-right: 2;
}

.row.row-space-6 > [class*="col-"] {
  padding-left: 3;
  padding-right: 3;
}

.row.row-space-8 > [class*="col-"] {
  padding-left: 4;
  padding-right: 4;
}

.row.row-space-10 > [class*="col-"] {
  padding-left: 5;
  padding-right: 5;
}

.row.row-space-12 > [class*="col-"] {
  padding-left: 6;
  padding-right: 6;
}

.row.row-space-14 > [class*="col-"] {
  padding-left: 7;
  padding-right: 7;
}

.row.row-space-16 > [class*="col-"] {
  padding-left: 8;
  padding-right: 8;
}

.row.row-space-18 > [class*="col-"] {
  padding-left: 9;
  padding-right: 9;
}

.row.row-space-20 > [class*="col-"] {
  padding-left: 10;
  padding-right: 10;
}

.row.row-space-22 > [class*="col-"] {
  padding-left: 11;
  padding-right: 11;
}

.row.row-space-24 > [class*="col-"] {
  padding-left: 12;
  padding-right: 12;
}

.row.row-space-26 > [class*="col-"] {
  padding-left: 13;
  padding-right: 13;
}

.row.row-space-28 > [class*="col-"] {
  padding-left: 14;
  padding-right: 14;
}

.row.row-space-30 > [class*="col-"] {
  padding-left: 15;
  padding-right: 15;
}

.m-auto {
  margin: auto !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 1px !important;
}

.m-2 {
  margin: 2px !important;
}

.m-3 {
  margin: 3px !important;
}

.m-4 {
  margin: 4px !important;
}

.m-5 {
  margin: 5px !important;
}

.m-10 {
  margin: 10px !important;
}

.m-15 {
  margin: 15px !important;
}

.m-20 {
  margin: 20px !important;
}

.m-25 {
  margin: 25px !important;
}

.m-30 {
  margin: 30px !important;
}

.m-35 {
  margin: 35px !important;
}

.m-40 {
  margin: 40px !important;
}

.m-t-auto {
  margin-top: auto !important;
}

.m-t-0 {
  margin-top: 0 !important;
}

.m-t-1 {
  margin-top: 1px !important;
}

.m-t-2 {
  margin-top: 2px !important;
}

.m-t-3 {
  margin-top: 3px !important;
}

.m-t-4 {
  margin-top: 4px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.m-r-auto {
  margin-right: auto !important;
}

.m-r-0 {
  margin-right: 0 !important;
}

.m-r-1 {
  margin-right: 1px !important;
}

.m-r-2 {
  margin-right: 2px !important;
}

.m-r-3 {
  margin-right: 3px !important;
}

.m-r-4 {
  margin-right: 4px !important;
}

.m-r-5 {
  margin-right: 5px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.m-r-15 {
  margin-right: 15px !important;
}

.m-r-20 {
  margin-right: 20px !important;
}

.m-r-25 {
  margin-right: 25px !important;
}

.m-r-30 {
  margin-right: 30px !important;
}

.m-r-35 {
  margin-right: 35px !important;
}

.m-r-40 {
  margin-right: 40px !important;
}

.m-b-auto {
  margin-bottom: auto !important;
}

.m-b-0 {
  margin-bottom: 0 !important;
}

.m-b-1 {
  margin-bottom: 1px !important;
}

.m-b-2 {
  margin-bottom: 2px !important;
}

.m-b-3 {
  margin-bottom: 3px !important;
}

.m-b-4 {
  margin-bottom: 4px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.m-l-auto {
  margin-left: auto !important;
}

.m-l-0 {
  margin-left: 0 !important;
}

.m-l-1 {
  margin-left: 1px !important;
}

.m-l-2 {
  margin-left: 2px !important;
}

.m-l-3 {
  margin-left: 3px !important;
}

.m-l-4 {
  margin-left: 4px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-10 {
  /* margin-left: 10px !important */
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.p-auto {
  padding: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 1px !important;
}

.p-2 {
  padding: 2px !important;
}

.p-3 {
  padding: 3px !important;
}

.p-4 {
  padding: 4px !important;
}

.p-5 {
  padding: 5px !important;
}

.p-10 {
  padding: 10px !important;
}

.p-15 {
  padding: 15px !important;
}

.p-20 {
  padding: 20px !important;
}

.p-25 {
  padding: 25px !important;
}

.p-30 {
  padding: 30px !important;
}

.p-35 {
  padding: 35px !important;
}

.p-40 {
  padding: 40px !important;
}

.p-t-auto {
  padding-top: auto !important;
}

.p-t-0 {
  padding-top: 0 !important;
}

.p-t-1 {
  padding-top: 1px !important;
}

.p-t-2 {
  padding-top: 2px !important;
}

.p-t-3 {
  padding-top: 3px !important;
}

.p-t-4 {
  padding-top: 4px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

/* .p-t-10 li:nth-child(5) {
    position: fixed;
    bottom: 100px;
    width: 100%;
} */

.navbar-cloud {
  position: fixed;
  bottom: 20px;
  width: 100%;
}

.p-t-15 {
  padding-top: 15px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.p-r-auto {
  padding-right: auto !important;
}

.p-r-0 {
  padding-right: 0 !important;
}

.p-r-1 {
  padding-right: 1px !important;
}

.p-r-2 {
  padding-right: 2px !important;
}

.p-r-3 {
  padding-right: 3px !important;
}

.p-r-4 {
  padding-right: 4px !important;
}

.p-r-5 {
  padding-right: 5px !important;
}

.p-r-10 {
  padding-right: 10px !important;
}

.p-r-15 {
  padding-right: 15px !important;
}

.p-r-20 {
  padding-right: 20px !important;
}

.p-r-25 {
  padding-right: 25px !important;
}

.p-r-30 {
  padding-right: 30px !important;
}

.p-r-35 {
  padding-right: 35px !important;
}

.p-r-40 {
  padding-right: 40px !important;
}

.p-b-auto {
  padding-bottom: auto !important;
}

.p-b-0 {
  padding-bottom: 0 !important;
}

.p-b-1 {
  padding-bottom: 1px !important;
}

.p-b-2 {
  padding-bottom: 2px !important;
}

.p-b-3 {
  padding-bottom: 3px !important;
}

.p-b-4 {
  padding-bottom: 4px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.p-l-auto {
  padding-left: auto !important;
}

.p-l-0 {
  padding-left: 0 !important;
}

.p-l-1 {
  padding-left: 1px !important;
}

.p-l-2 {
  padding-left: 2px !important;
}

.p-l-3 {
  padding-left: 3px !important;
}

.p-l-4 {
  padding-left: 4px !important;
}

.p-l-5 {
  padding-left: 5px !important;
}

.p-l-10 {
  padding-left: 10px !important;
}

.p-l-15 {
  padding-left: 15px !important;
}

.p-l-20 {
  padding-left: 20px !important;
}

.p-l-25 {
  padding-left: 25px !important;
}

.p-l-30 {
  padding-left: 30px !important;
}

.p-l-35 {
  padding-left: 35px !important;
}

.p-l-40 {
  padding-left: 40px !important;
}

.f-s-8 {
  font-size: 8px !important;
}

.f-s-9 {
  font-size: 9px !important;
}

.f-s-10 {
  font-size: 10px !important;
}

.f-s-11 {
  font-size: 11px !important;
}

.f-s-12 {
  font-size: 12px !important;
}

.f-s-13 {
  font-size: 13px !important;
}

.f-s-14 {
  font-size: 14px !important;
}

.f-s-15 {
  font-size: 15px !important;
}

.f-s-16 {
  font-size: 16px !important;
}

.f-s-17 {
  font-size: 17px !important;
}

.f-s-18 {
  font-size: 18px !important;
}

.f-s-19 {
  font-size: 19px !important;
}

.f-s-20 {
  font-size: 20px !important;
}

.f-s-21 {
  font-size: 21px !important;
}

.f-s-22 {
  font-size: 22px !important;
}

.f-s-23 {
  font-size: 23px !important;
}

.f-s-24 {
  font-size: 24px !important;
}

.f-s-25 {
  font-size: 25px !important;
}

.f-s-26 {
  font-size: 26px !important;
}

.f-s-27 {
  font-size: 27px !important;
}

.f-s-28 {
  font-size: 28px !important;
}

.f-s-29 {
  font-size: 29px !important;
}

.f-s-30 {
  font-size: 30px !important;
}

.f-s-31 {
  font-size: 31px !important;
}

.f-s-32 {
  font-size: 32px !important;
}

.f-s-33 {
  font-size: 33px !important;
}

.f-s-34 {
  font-size: 34px !important;
}

.f-s-35 {
  font-size: 35px !important;
}

.f-s-36 {
  font-size: 36px !important;
}

.f-s-37 {
  font-size: 37px !important;
}

.f-s-38 {
  font-size: 38px !important;
}

.f-s-39 {
  font-size: 39px !important;
}

.f-s-40 {
  font-size: 40px !important;
}

.f-s-41 {
  font-size: 41px !important;
}

.f-s-42 {
  font-size: 42px !important;
}

.f-s-43 {
  font-size: 43px !important;
}

.f-s-44 {
  font-size: 44px !important;
}

.f-s-45 {
  font-size: 45px !important;
}

.f-s-46 {
  font-size: 46px !important;
}

.f-s-47 {
  font-size: 47px !important;
}

.f-s-48 {
  font-size: 48px !important;
}

.f-s-49 {
  font-size: 49px !important;
}

.f-s-50 {
  font-size: 50px !important;
}

.f-s-51 {
  font-size: 51px !important;
}

.f-s-52 {
  font-size: 52px !important;
}

.f-s-53 {
  font-size: 53px !important;
}

.f-s-54 {
  font-size: 54px !important;
}

.f-s-55 {
  font-size: 55px !important;
}

.f-s-56 {
  font-size: 56px !important;
}

.f-s-57 {
  font-size: 57px !important;
}

.f-s-58 {
  font-size: 58px !important;
}

.f-s-59 {
  font-size: 59px !important;
}

.f-s-60 {
  font-size: 60px !important;
}

.f-s-61 {
  font-size: 61px !important;
}

.f-s-62 {
  font-size: 62px !important;
}

.f-s-63 {
  font-size: 63px !important;
}

.f-s-64 {
  font-size: 64px !important;
}

.f-s-65 {
  font-size: 65px !important;
}

.f-s-66 {
  font-size: 66px !important;
}

.f-s-67 {
  font-size: 67px !important;
}

.f-s-68 {
  font-size: 68px !important;
}

.f-s-69 {
  font-size: 69px !important;
}

.f-s-70 {
  font-size: 70px !important;
}

.f-s-71 {
  font-size: 71px !important;
}

.f-s-72 {
  font-size: 72px !important;
}

.f-s-73 {
  font-size: 73px !important;
}

.f-s-74 {
  font-size: 74px !important;
}

.f-s-75 {
  font-size: 75px !important;
}

.f-s-76 {
  font-size: 76px !important;
}

.f-s-77 {
  font-size: 77px !important;
}

.f-s-78 {
  font-size: 78px !important;
}

.f-s-79 {
  font-size: 79px !important;
}

.f-s-80 {
  font-size: 80px !important;
}

.f-w-100 {
  font-weight: 100 !important;
}

.f-w-200 {
  font-weight: 200 !important;
}

.f-w-300 {
  font-weight: 300 !important;
}

.f-w-400 {
  font-weight: 400 !important;
}

.f-w-500 {
  font-weight: 500 !important;
}

.f-w-600 {
  font-weight: 600 !important;
}

.f-w-700 {
  font-weight: 700 !important;
}

.f-w-800 {
  font-weight: 800 !important;
}

.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
  clear: both;
}

.text-center {
  text-align: center !important;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-ellipsis,
.text-nowrap {
  white-space: nowrap !important;
}

.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-underline {
  text-decoration: underline !important;
}

.line-height-1 {
  line-height: 1 !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.row.row-col-border > [class^="col-"] + [class^="col-"] {
  border-left: 1px solid #d5dbe0;
}

.pull-left {
  float: left !important;
}

.pull-right {
  float: right !important;
}

.pull-none {
  float: none !important;
}

.rounded-corner {
  border-radius: 100px !important;
}

.table-td-valign-middle td,
.table-th-valign-middle th,
.table-valign-middle td,
.table-valign-middle th {
  vertical-align: middle !important;
}

.table-td-valign-top td,
.table-th-valign-top th,
.table-valign-top td,
.table-valign-top th {
  vertical-align: top !important;
}

.table-td-valign-bottom td,
.table-th-valign-bottom th,
.table-valign-bottom td,
.table-valign-bottom th {
  vertical-align: bottom !important;
}

.table-th-without-border th {
  border-left: none !important;
  border-right: none !important;
}

.table-td-without-border td {
  border: 0 !important;
}

.table-td-bg-animate {
  -webkit-transition: background 0.3s linear;
  -moz-transition: background 0.3s linear;
  -ms-transition: background 0.3s linear;
  -o-transition: background 0.3s linear;
  transition: background 0.3s linear;
}

.valign-middle-container {
  display: table;
  height: 100%;
  width: 100%;
}

.valign-middle-inner-container {
  display: table-cell;
  vertical-align: middle;
}

.loading {
  cursor: progress;
}

.bg-theme {
  background-color: #00acac !important;
}

.label-theme {
  background-color: #00acac;
}

.text-theme {
  color: #00acac;
}

.text-primary {
  color: #00acac !important;
}

.text-primary-lighter {
  color: #40c1c1 !important;
}

.text-primary-darker {
  color: #008181 !important;
}

.app-theme-primary .app-sidebar .nav > li.active > a,
.bg-primary {
  background-color: #00acac !important;
}

.bg-primary-lighter {
  background-color: #40c1c1 !important;
}

.bg-primary-darker {
  background-color: #008181 !important;
}

.app-theme-gradient-primary .app-sidebar .nav > li.active > a,
.bg-gradient-primary {
  background: #00acac !important;
  background: -moz-linear-gradient(
    to bottom,
    #00dfdf 0%,
    #009393 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #00dfdf 0%,
    #009393 100%
  ) !important;
  background: linear-gradient(to bottom, #00dfdf 0%, #009393 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-primary-transparent-1 {
  background-color: rgba(0, 172, 172, 0.1) !important;
}

.text-primary-transparent-1 {
  color: rgba(0, 172, 172, 0.1) !important;
}

.bg-primary-transparent-2 {
  background-color: rgba(0, 172, 172, 0.2) !important;
}

.text-primary-transparent-2 {
  color: rgba(0, 172, 172, 0.2) !important;
}

.bg-primary-transparent-3 {
  background-color: rgba(0, 172, 172, 0.3) !important;
}

.text-primary-transparent-3 {
  color: rgba(0, 172, 172, 0.3) !important;
}

.bg-primary-transparent-4 {
  background-color: rgba(0, 172, 172, 0.4) !important;
}

.text-primary-transparent-4 {
  color: rgba(0, 172, 172, 0.4) !important;
}

.bg-primary-transparent-5 {
  background-color: rgba(0, 172, 172, 0.5) !important;
}

.text-primary-transparent-5 {
  color: rgba(0, 172, 172, 0.5) !important;
}

.bg-primary-transparent-6 {
  background-color: rgba(0, 172, 172, 0.6) !important;
}

.text-primary-transparent-6 {
  color: rgba(0, 172, 172, 0.6) !important;
}

.bg-primary-transparent-7 {
  background-color: rgba(0, 172, 172, 0.7) !important;
}

.text-primary-transparent-7 {
  color: rgba(0, 172, 172, 0.7) !important;
}

.bg-primary-transparent-8 {
  background-color: rgba(0, 172, 172, 0.8) !important;
}

.text-primary-transparent-8 {
  color: rgba(0, 172, 172, 0.8) !important;
}

.bg-primary-transparent-9 {
  background-color: rgba(0, 172, 172, 0.9) !important;
}

.text-primary-transparent-9 {
  color: rgba(0, 172, 172, 0.9) !important;
}

.text-secondary {
  color: #6c757d !important;
}

.text-secondary-lighter {
  color: #91989e !important;
}

.text-secondary-darker {
  color: #51585e !important;
}

.app-theme-secondary .app-sidebar .nav > li.active > a,
.bg-secondary {
  background-color: #6c757d !important;
}

.bg-secondary-lighter {
  background-color: #91989e !important;
}

.bg-secondary-darker {
  background-color: #51585e !important;
}

.app-theme-gradient-secondary .app-sidebar .nav > li.active > a,
.bg-gradient-secondary {
  background: #6c757d !important;
  background: -moz-linear-gradient(
    to bottom,
    #868e96 0%,
    #60686f 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #868e96 0%,
    #60686f 100%
  ) !important;
  background: linear-gradient(to bottom, #868e96 0%, #60686f 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-secondary-transparent-1 {
  background-color: rgba(108, 117, 125, 0.1) !important;
}

.text-secondary-transparent-1 {
  color: rgba(108, 117, 125, 0.1) !important;
}

.bg-secondary-transparent-2 {
  background-color: rgba(108, 117, 125, 0.2) !important;
}

.text-secondary-transparent-2 {
  color: rgba(108, 117, 125, 0.2) !important;
}

.bg-secondary-transparent-3 {
  background-color: rgba(108, 117, 125, 0.3) !important;
}

.text-secondary-transparent-3 {
  color: rgba(108, 117, 125, 0.3) !important;
}

.bg-secondary-transparent-4 {
  background-color: rgba(108, 117, 125, 0.4) !important;
}

.text-secondary-transparent-4 {
  color: rgba(108, 117, 125, 0.4) !important;
}

.bg-secondary-transparent-5 {
  background-color: rgba(108, 117, 125, 0.5) !important;
}

.text-secondary-transparent-5 {
  color: rgba(108, 117, 125, 0.5) !important;
}

.bg-secondary-transparent-6 {
  background-color: rgba(108, 117, 125, 0.6) !important;
}

.text-secondary-transparent-6 {
  color: rgba(108, 117, 125, 0.6) !important;
}

.bg-secondary-transparent-7 {
  background-color: rgba(108, 117, 125, 0.7) !important;
}

.text-secondary-transparent-7 {
  color: rgba(108, 117, 125, 0.7) !important;
}

.bg-secondary-transparent-8 {
  background-color: rgba(108, 117, 125, 0.8) !important;
}

.text-secondary-transparent-8 {
  color: rgba(108, 117, 125, 0.8) !important;
}

.bg-secondary-transparent-9 {
  background-color: rgba(108, 117, 125, 0.9) !important;
}

.text-secondary-transparent-9 {
  color: rgba(108, 117, 125, 0.9) !important;
}

.text-success {
  color: #00acac !important;
}

.text-success-lighter {
  color: #40c1c1 !important;
}

.text-success-darker {
  color: #008181 !important;
}

.app-theme-success .app-sidebar .nav > li.active > a,
.bg-success {
  background-color: #00acac !important;
}

.bg-success-lighter {
  background-color: #40c1c1 !important;
}

.bg-success-darker {
  background-color: #008181 !important;
}

.app-theme-gradient-success .app-sidebar .nav > li.active > a,
.bg-gradient-success {
  background: #00acac !important;
  background: -moz-linear-gradient(
    to bottom,
    #00dfdf 0%,
    #009393 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #00dfdf 0%,
    #009393 100%
  ) !important;
  background: linear-gradient(to bottom, #00dfdf 0%, #009393 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-success-transparent-1 {
  background-color: rgba(0, 172, 172, 0.1) !important;
}

.text-success-transparent-1 {
  color: rgba(0, 172, 172, 0.1) !important;
}

.bg-success-transparent-2 {
  background-color: rgba(0, 172, 172, 0.2) !important;
}

.text-success-transparent-2 {
  color: rgba(0, 172, 172, 0.2) !important;
}

.bg-success-transparent-3 {
  background-color: rgba(0, 172, 172, 0.3) !important;
}

.text-success-transparent-3 {
  color: rgba(0, 172, 172, 0.3) !important;
}

.bg-success-transparent-4 {
  background-color: rgba(0, 172, 172, 0.4) !important;
}

.text-success-transparent-4 {
  color: rgba(0, 172, 172, 0.4) !important;
}

.bg-success-transparent-5 {
  background-color: rgba(0, 172, 172, 0.5) !important;
}

.text-success-transparent-5 {
  color: rgba(0, 172, 172, 0.5) !important;
}

.bg-success-transparent-6 {
  background-color: rgba(0, 172, 172, 0.6) !important;
}

.text-success-transparent-6 {
  color: rgba(0, 172, 172, 0.6) !important;
}

.bg-success-transparent-7 {
  background-color: rgba(0, 172, 172, 0.7) !important;
}

.text-success-transparent-7 {
  color: rgba(0, 172, 172, 0.7) !important;
}

.bg-success-transparent-8 {
  background-color: rgba(0, 172, 172, 0.8) !important;
}

.text-success-transparent-8 {
  color: rgba(0, 172, 172, 0.8) !important;
}

.bg-success-transparent-9 {
  background-color: rgba(0, 172, 172, 0.9) !important;
}

.text-success-transparent-9 {
  color: rgba(0, 172, 172, 0.9) !important;
}

.text-info {
  color: #49b6d6 !important;
}

.text-info-lighter {
  color: #77c8e0 !important;
}

.text-info-darker {
  color: #3789a1 !important;
}

.app-theme-info .app-sidebar .nav > li.active > a,
.bg-info {
  background-color: #49b6d6 !important;
}

.bg-info-lighter {
  background-color: #77c8e0 !important;
}

.bg-info-darker {
  background-color: #3789a1 !important;
}

.app-theme-gradient-info .app-sidebar .nav > li.active > a,
.bg-gradient-info {
  background: #49b6d6 !important;
  background: -moz-linear-gradient(
    to bottom,
    #73c7df 0%,
    #34aed1 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #73c7df 0%,
    #34aed1 100%
  ) !important;
  background: linear-gradient(to bottom, #73c7df 0%, #34aed1 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-info-transparent-1 {
  background-color: rgba(73, 182, 214, 0.1) !important;
}

.text-info-transparent-1 {
  color: rgba(73, 182, 214, 0.1) !important;
}

.bg-info-transparent-2 {
  background-color: rgba(73, 182, 214, 0.2) !important;
}

.text-info-transparent-2 {
  color: rgba(73, 182, 214, 0.2) !important;
}

.bg-info-transparent-3 {
  background-color: rgba(73, 182, 214, 0.3) !important;
}

.text-info-transparent-3 {
  color: rgba(73, 182, 214, 0.3) !important;
}

.bg-info-transparent-4 {
  background-color: rgba(73, 182, 214, 0.4) !important;
}

.text-info-transparent-4 {
  color: rgba(73, 182, 214, 0.4) !important;
}

.bg-info-transparent-5 {
  background-color: rgba(73, 182, 214, 0.5) !important;
}

.text-info-transparent-5 {
  color: rgba(73, 182, 214, 0.5) !important;
}

.bg-info-transparent-6 {
  background-color: rgba(73, 182, 214, 0.6) !important;
}

.text-info-transparent-6 {
  color: rgba(73, 182, 214, 0.6) !important;
}

.bg-info-transparent-7 {
  background-color: rgba(73, 182, 214, 0.7) !important;
}

.text-info-transparent-7 {
  color: rgba(73, 182, 214, 0.7) !important;
}

.bg-info-transparent-8 {
  background-color: rgba(73, 182, 214, 0.8) !important;
}

.text-info-transparent-8 {
  color: rgba(73, 182, 214, 0.8) !important;
}

.bg-info-transparent-9 {
  background-color: rgba(73, 182, 214, 0.9) !important;
}

.text-info-transparent-9 {
  color: rgba(73, 182, 214, 0.9) !important;
}

.text-warning {
  color: #f59c1a !important;
}

.text-warning-lighter {
  color: #f8b553 !important;
}

.text-warning-darker {
  color: #b87514 !important;
}

.app-theme-warning .app-sidebar .nav > li.active > a,
.bg-warning {
  background-color: #f59c1a !important;
}

.bg-warning-lighter {
  background-color: #f8b553 !important;
}

.bg-warning-darker {
  background-color: #b87514 !important;
}

.app-theme-gradient-warning .app-sidebar .nav > li.active > a,
.bg-gradient-warning {
  background: #f59c1a !important;
  background: -moz-linear-gradient(
    to bottom,
    #f7b14b 0%,
    #eb900a 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #f7b14b 0%,
    #eb900a 100%
  ) !important;
  background: linear-gradient(to bottom, #f7b14b 0%, #eb900a 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-warning-transparent-1 {
  background-color: rgba(245, 156, 26, 0.1) !important;
}

.text-warning-transparent-1 {
  color: rgba(245, 156, 26, 0.1) !important;
}

.bg-warning-transparent-2 {
  background-color: rgba(245, 156, 26, 0.2) !important;
}

.text-warning-transparent-2 {
  color: rgba(245, 156, 26, 0.2) !important;
}

.bg-warning-transparent-3 {
  background-color: rgba(245, 156, 26, 0.3) !important;
}

.text-warning-transparent-3 {
  color: rgba(245, 156, 26, 0.3) !important;
}

.bg-warning-transparent-4 {
  background-color: rgba(245, 156, 26, 0.4) !important;
}

.text-warning-transparent-4 {
  color: rgba(245, 156, 26, 0.4) !important;
}

.bg-warning-transparent-5 {
  background-color: rgba(245, 156, 26, 0.5) !important;
}

.text-warning-transparent-5 {
  color: rgba(245, 156, 26, 0.5) !important;
}

.bg-warning-transparent-6 {
  background-color: rgba(245, 156, 26, 0.6) !important;
}

.text-warning-transparent-6 {
  color: rgba(245, 156, 26, 0.6) !important;
}

.bg-warning-transparent-7 {
  background-color: rgba(245, 156, 26, 0.7) !important;
}

.text-warning-transparent-7 {
  color: rgba(245, 156, 26, 0.7) !important;
}

.bg-warning-transparent-8 {
  background-color: rgba(245, 156, 26, 0.8) !important;
}

.text-warning-transparent-8 {
  color: rgba(245, 156, 26, 0.8) !important;
}

.bg-warning-transparent-9 {
  background-color: rgba(245, 156, 26, 0.9) !important;
}

.text-warning-transparent-9 {
  color: rgba(245, 156, 26, 0.9) !important;
}

.text-danger {
  color: #ff5b57 !important;
}

.text-danger-lighter {
  color: #ff8481 !important;
}

.text-danger-darker {
  color: #bf4441 !important;
}

.app-theme-danger .app-sidebar .nav > li.active > a,
.bg-danger {
  background-color: #ff5b57 !important;
}

.bg-danger-lighter {
  background-color: #ff8481 !important;
}

.bg-danger-darker {
  background-color: #bf4441 !important;
}

.app-theme-gradient-danger .app-sidebar .nav > li.active > a,
.bg-gradient-danger {
  background: #ff5b57 !important;
  background: -moz-linear-gradient(
    to bottom,
    #ff8d8a 0%,
    #ff423e 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #ff8d8a 0%,
    #ff423e 100%
  ) !important;
  background: linear-gradient(to bottom, #ff8d8a 0%, #ff423e 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-danger-transparent-1 {
  background-color: rgba(255, 91, 87, 0.1) !important;
}

.text-danger-transparent-1 {
  color: rgba(255, 91, 87, 0.1) !important;
}

.bg-danger-transparent-2 {
  background-color: rgba(255, 91, 87, 0.2) !important;
}

.text-danger-transparent-2 {
  color: rgba(255, 91, 87, 0.2) !important;
}

.bg-danger-transparent-3 {
  background-color: rgba(255, 91, 87, 0.3) !important;
}

.text-danger-transparent-3 {
  color: rgba(255, 91, 87, 0.3) !important;
}

.bg-danger-transparent-4 {
  background-color: rgba(255, 91, 87, 0.4) !important;
}

.text-danger-transparent-4 {
  color: rgba(255, 91, 87, 0.4) !important;
}

.bg-danger-transparent-5 {
  background-color: rgba(255, 91, 87, 0.5) !important;
}

.text-danger-transparent-5 {
  color: rgba(255, 91, 87, 0.5) !important;
}

.bg-danger-transparent-6 {
  background-color: rgba(255, 91, 87, 0.6) !important;
}

.text-danger-transparent-6 {
  color: rgba(255, 91, 87, 0.6) !important;
}

.bg-danger-transparent-7 {
  background-color: rgba(255, 91, 87, 0.7) !important;
}

.text-danger-transparent-7 {
  color: rgba(255, 91, 87, 0.7) !important;
}

.bg-danger-transparent-8 {
  background-color: rgba(255, 91, 87, 0.8) !important;
}

.text-danger-transparent-8 {
  color: rgba(255, 91, 87, 0.8) !important;
}

.bg-danger-transparent-9 {
  background-color: rgba(255, 91, 87, 0.9) !important;
}

.text-danger-transparent-9 {
  color: rgba(255, 91, 87, 0.9) !important;
}

.text-inverse {
  color: #2d353c !important;
}

.text-inverse-lighter {
  color: #62686d !important;
}

.text-inverse-darker {
  color: #22282d !important;
}

.app-theme-inverse .app-sidebar .nav > li.active > a,
.bg-inverse {
  background-color: #2d353c !important;
}

.bg-inverse-lighter {
  background-color: #62686d !important;
}

.bg-inverse-darker {
  background-color: #22282d !important;
}

.app-theme-gradient-inverse .app-sidebar .nav > li.active > a,
.bg-gradient-inverse {
  background: #2d353c !important;
  background: -moz-linear-gradient(
    to bottom,
    #434f59 0%,
    #22282d 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #434f59 0%,
    #22282d 100%
  ) !important;
  background: linear-gradient(to bottom, #434f59 0%, #22282d 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-inverse-transparent-1 {
  background-color: rgba(45, 53, 60, 0.1) !important;
}

.text-inverse-transparent-1 {
  color: rgba(45, 53, 60, 0.1) !important;
}

.bg-inverse-transparent-2 {
  background-color: rgba(45, 53, 60, 0.2) !important;
}

.text-inverse-transparent-2 {
  color: rgba(45, 53, 60, 0.2) !important;
}

.bg-inverse-transparent-3 {
  background-color: rgba(45, 53, 60, 0.3) !important;
}

.text-inverse-transparent-3 {
  color: rgba(45, 53, 60, 0.3) !important;
}

.bg-inverse-transparent-4 {
  background-color: rgba(45, 53, 60, 0.4) !important;
}

.text-inverse-transparent-4 {
  color: rgba(45, 53, 60, 0.4) !important;
}

.bg-inverse-transparent-5 {
  background-color: rgba(45, 53, 60, 0.5) !important;
}

.text-inverse-transparent-5 {
  color: rgba(45, 53, 60, 0.5) !important;
}

.bg-inverse-transparent-6 {
  background-color: rgba(45, 53, 60, 0.6) !important;
}

.text-inverse-transparent-6 {
  color: rgba(45, 53, 60, 0.6) !important;
}

.bg-inverse-transparent-7 {
  background-color: rgba(45, 53, 60, 0.7) !important;
}

.text-inverse-transparent-7 {
  color: rgba(45, 53, 60, 0.7) !important;
}

.bg-inverse-transparent-8 {
  background-color: rgba(45, 53, 60, 0.8) !important;
}

.text-inverse-transparent-8 {
  color: rgba(45, 53, 60, 0.8) !important;
}

.bg-inverse-transparent-9 {
  background-color: rgba(45, 53, 60, 0.9) !important;
}

.text-inverse-transparent-9 {
  color: rgba(45, 53, 60, 0.9) !important;
}

.text-grey {
  color: #b6c2c9 !important;
}

.text-grey-lighter {
  color: #c8d1d7 !important;
}

.text-grey-darker {
  color: #899297 !important;
}

.app-theme-grey .app-sidebar .nav > li.active > a,
.bg-grey {
  background-color: #b6c2c9 !important;
}

.bg-grey-lighter {
  background-color: #c8d1d7 !important;
}

.bg-grey-darker {
  background-color: #899297 !important;
}

.app-theme-gradient-grey .app-sidebar .nav > li.active > a,
.bg-gradient-grey {
  background: #b6c2c9 !important;
  background: -moz-linear-gradient(
    to bottom,
    #d3dadf 0%,
    #a7b6be 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #d3dadf 0%,
    #a7b6be 100%
  ) !important;
  background: linear-gradient(to bottom, #d3dadf 0%, #a7b6be 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-grey-transparent-1 {
  background-color: rgba(182, 194, 201, 0.1) !important;
}

.text-grey-transparent-1 {
  color: rgba(182, 194, 201, 0.1) !important;
}

.bg-grey-transparent-2 {
  background-color: rgba(182, 194, 201, 0.2) !important;
}

.text-grey-transparent-2 {
  color: rgba(182, 194, 201, 0.2) !important;
}

.bg-grey-transparent-3 {
  background-color: rgba(182, 194, 201, 0.3) !important;
}

.text-grey-transparent-3 {
  color: rgba(182, 194, 201, 0.3) !important;
}

.bg-grey-transparent-4 {
  background-color: rgba(182, 194, 201, 0.4) !important;
}

.text-grey-transparent-4 {
  color: rgba(182, 194, 201, 0.4) !important;
}

.bg-grey-transparent-5 {
  background-color: rgba(182, 194, 201, 0.5) !important;
}

.text-grey-transparent-5 {
  color: rgba(182, 194, 201, 0.5) !important;
}

.bg-grey-transparent-6 {
  background-color: rgba(182, 194, 201, 0.6) !important;
}

.text-grey-transparent-6 {
  color: rgba(182, 194, 201, 0.6) !important;
}

.bg-grey-transparent-7 {
  background-color: rgba(182, 194, 201, 0.7) !important;
}

.text-grey-transparent-7 {
  color: rgba(182, 194, 201, 0.7) !important;
}

.bg-grey-transparent-8 {
  background-color: rgba(182, 194, 201, 0.8) !important;
}

.text-grey-transparent-8 {
  color: rgba(182, 194, 201, 0.8) !important;
}

.bg-grey-transparent-9 {
  background-color: rgba(182, 194, 201, 0.9) !important;
}

.text-grey-transparent-9 {
  color: rgba(182, 194, 201, 0.9) !important;
}

.app-theme-gradient-muted .app-sidebar .nav > li.active > a,
.bg-gradient-muted {
  background: #b6c2c9 !important;
  background: -moz-linear-gradient(
    to bottom,
    #d3dadf 0%,
    #a7b6be 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #d3dadf 0%,
    #a7b6be 100%
  ) !important;
  background: linear-gradient(to bottom, #d3dadf 0%, #a7b6be 100%) !important;
}

.text-blue {
  color: #348fe2 !important;
}

.text-blue-lighter {
  color: #67abe9 !important;
}

.text-blue-darker {
  color: #276baa !important;
}

.app-theme-blue .app-sidebar .nav > li.active > a,
.bg-blue {
  background-color: #348fe2 !important;
}

.bg-blue-lighter {
  background-color: #67abe9 !important;
}

.bg-blue-darker {
  background-color: #276baa !important;
}

.app-theme-gradient-blue .app-sidebar .nav > li.active > a,
.bg-gradient-blue {
  background: #348fe2 !important;
  background: -moz-linear-gradient(
    to bottom,
    #61a8e8 0%,
    #2083dd 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #61a8e8 0%,
    #2083dd 100%
  ) !important;
  background: linear-gradient(to bottom, #61a8e8 0%, #2083dd 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-blue-transparent-1 {
  background-color: rgba(52, 143, 226, 0.1) !important;
}

.text-blue-transparent-1 {
  color: rgba(52, 143, 226, 0.1) !important;
}

.bg-blue-transparent-2 {
  background-color: rgba(52, 143, 226, 0.2) !important;
}

.text-blue-transparent-2 {
  color: rgba(52, 143, 226, 0.2) !important;
}

.bg-blue-transparent-3 {
  background-color: rgba(52, 143, 226, 0.3) !important;
}

.text-blue-transparent-3 {
  color: rgba(52, 143, 226, 0.3) !important;
}

.bg-blue-transparent-4 {
  background-color: rgba(52, 143, 226, 0.4) !important;
}

.text-blue-transparent-4 {
  color: rgba(52, 143, 226, 0.4) !important;
}

.bg-blue-transparent-5 {
  background-color: rgba(52, 143, 226, 0.5) !important;
}

.text-blue-transparent-5 {
  color: rgba(52, 143, 226, 0.5) !important;
}

.bg-blue-transparent-6 {
  background-color: rgba(52, 143, 226, 0.6) !important;
}

.text-blue-transparent-6 {
  color: rgba(52, 143, 226, 0.6) !important;
}

.bg-blue-transparent-7 {
  background-color: rgba(52, 143, 226, 0.7) !important;
}

.text-blue-transparent-7 {
  color: rgba(52, 143, 226, 0.7) !important;
}

.bg-blue-transparent-8 {
  background-color: rgba(52, 143, 226, 0.8) !important;
}

.text-blue-transparent-8 {
  color: rgba(52, 143, 226, 0.8) !important;
}

.bg-blue-transparent-9 {
  background-color: rgba(52, 143, 226, 0.9) !important;
}

.text-blue-transparent-9 {
  color: rgba(52, 143, 226, 0.9) !important;
}

.text-indigo {
  color: #8753de !important;
}

.text-indigo-lighter {
  color: #a57ee6 !important;
}

.text-indigo-darker {
  color: #653ea7 !important;
}

.app-theme-indigo .app-sidebar .nav > li.active > a,
.bg-indigo {
  background-color: #8753de !important;
}

.bg-indigo-lighter {
  background-color: #a57ee6 !important;
}

.bg-indigo-darker {
  background-color: #653ea7 !important;
}

.app-theme-gradient-indigo .app-sidebar .nav > li.active > a,
.bg-gradient-indigo {
  background: #8753de !important;
  background: -moz-linear-gradient(
    to bottom,
    #a57ee6 0%,
    #783eda 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #a57ee6 0%,
    #783eda 100%
  ) !important;
  background: linear-gradient(to bottom, #a57ee6 0%, #783eda 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-indigo-transparent-1 {
  background-color: rgba(135, 83, 222, 0.1) !important;
}

.text-indigo-transparent-1 {
  color: rgba(135, 83, 222, 0.1) !important;
}

.bg-indigo-transparent-2 {
  background-color: rgba(135, 83, 222, 0.2) !important;
}

.text-indigo-transparent-2 {
  color: rgba(135, 83, 222, 0.2) !important;
}

.bg-indigo-transparent-3 {
  background-color: rgba(135, 83, 222, 0.3) !important;
}

.text-indigo-transparent-3 {
  color: rgba(135, 83, 222, 0.3) !important;
}

.bg-indigo-transparent-4 {
  background-color: rgba(135, 83, 222, 0.4) !important;
}

.text-indigo-transparent-4 {
  color: rgba(135, 83, 222, 0.4) !important;
}

.bg-indigo-transparent-5 {
  background-color: rgba(135, 83, 222, 0.5) !important;
}

.text-indigo-transparent-5 {
  color: rgba(135, 83, 222, 0.5) !important;
}

.bg-indigo-transparent-6 {
  background-color: rgba(135, 83, 222, 0.6) !important;
}

.text-indigo-transparent-6 {
  color: rgba(135, 83, 222, 0.6) !important;
}

.bg-indigo-transparent-7 {
  background-color: rgba(135, 83, 222, 0.7) !important;
}

.text-indigo-transparent-7 {
  color: rgba(135, 83, 222, 0.7) !important;
}

.bg-indigo-transparent-8 {
  background-color: rgba(135, 83, 222, 0.8) !important;
}

.text-indigo-transparent-8 {
  color: rgba(135, 83, 222, 0.8) !important;
}

.bg-indigo-transparent-9 {
  background-color: rgba(135, 83, 222, 0.9) !important;
}

.text-indigo-transparent-9 {
  color: rgba(135, 83, 222, 0.9) !important;
}

.text-purple {
  color: #727cb6 !important;
}

.text-purple-lighter {
  color: #959dc8 !important;
}

.text-purple-darker {
  color: #565d89 !important;
}

.app-theme-purple .app-sidebar .nav > li.active > a,
.bg-purple {
  background-color: #727cb6 !important;
}

.bg-purple-lighter {
  background-color: #959dc8 !important;
}

.bg-purple-darker {
  background-color: #565d89 !important;
}

.app-theme-gradient-purple .app-sidebar .nav > li.active > a,
.bg-gradient-purple {
  background: #727cb6 !important;
  background: -moz-linear-gradient(
    to bottom,
    #949bc7 0%,
    #616cad 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #949bc7 0%,
    #616cad 100%
  ) !important;
  background: linear-gradient(to bottom, #949bc7 0%, #616cad 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-purple-transparent-1 {
  background-color: rgba(114, 124, 182, 0.1) !important;
}

.text-purple-transparent-1 {
  color: rgba(114, 124, 182, 0.1) !important;
}

.bg-purple-transparent-2 {
  background-color: rgba(114, 124, 182, 0.2) !important;
}

.text-purple-transparent-2 {
  color: rgba(114, 124, 182, 0.2) !important;
}

.bg-purple-transparent-3 {
  background-color: rgba(114, 124, 182, 0.3) !important;
}

.text-purple-transparent-3 {
  color: rgba(114, 124, 182, 0.3) !important;
}

.bg-purple-transparent-4 {
  background-color: rgba(114, 124, 182, 0.4) !important;
}

.text-purple-transparent-4 {
  color: rgba(114, 124, 182, 0.4) !important;
}

.bg-purple-transparent-5 {
  background-color: rgba(114, 124, 182, 0.5) !important;
}

.text-purple-transparent-5 {
  color: rgba(114, 124, 182, 0.5) !important;
}

.bg-purple-transparent-6 {
  background-color: rgba(114, 124, 182, 0.6) !important;
}

.text-purple-transparent-6 {
  color: rgba(114, 124, 182, 0.6) !important;
}

.bg-purple-transparent-7 {
  background-color: rgba(114, 124, 182, 0.7) !important;
}

.text-purple-transparent-7 {
  color: rgba(114, 124, 182, 0.7) !important;
}

.bg-purple-transparent-8 {
  background-color: rgba(114, 124, 182, 0.8) !important;
}

.text-purple-transparent-8 {
  color: rgba(114, 124, 182, 0.8) !important;
}

.bg-purple-transparent-9 {
  background-color: rgba(114, 124, 182, 0.9) !important;
}

.text-purple-transparent-9 {
  color: rgba(114, 124, 182, 0.9) !important;
}

.text-pink {
  color: #fb5597 !important;
}

.text-pink-lighter {
  color: #fc80b1 !important;
}

.text-pink-darker {
  color: #bc4071 !important;
}

.app-theme-pink .app-sidebar .nav > li.active > a,
.bg-pink {
  background-color: #fb5597 !important;
}

.bg-pink-lighter {
  background-color: #fc80b1 !important;
}

.bg-pink-darker {
  background-color: #bc4071 !important;
}

.app-theme-gradient-pink .app-sidebar .nav > li.active > a,
.bg-gradient-pink {
  background: #fb5597 !important;
  background: -moz-linear-gradient(
    to bottom,
    #fc87b5 0%,
    #fa3c88 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #fc87b5 0%,
    #fa3c88 100%
  ) !important;
  background: linear-gradient(to bottom, #fc87b5 0%, #fa3c88 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-pink-transparent-1 {
  background-color: rgba(251, 85, 151, 0.1) !important;
}

.text-pink-transparent-1 {
  color: rgba(251, 85, 151, 0.1) !important;
}

.bg-pink-transparent-2 {
  background-color: rgba(251, 85, 151, 0.2) !important;
}

.text-pink-transparent-2 {
  color: rgba(251, 85, 151, 0.2) !important;
}

.bg-pink-transparent-3 {
  background-color: rgba(251, 85, 151, 0.3) !important;
}

.text-pink-transparent-3 {
  color: rgba(251, 85, 151, 0.3) !important;
}

.bg-pink-transparent-4 {
  background-color: rgba(251, 85, 151, 0.4) !important;
}

.text-pink-transparent-4 {
  color: rgba(251, 85, 151, 0.4) !important;
}

.bg-pink-transparent-5 {
  background-color: rgba(251, 85, 151, 0.5) !important;
}

.text-pink-transparent-5 {
  color: rgba(251, 85, 151, 0.5) !important;
}

.bg-pink-transparent-6 {
  background-color: rgba(251, 85, 151, 0.6) !important;
}

.text-pink-transparent-6 {
  color: rgba(251, 85, 151, 0.6) !important;
}

.bg-pink-transparent-7 {
  background-color: rgba(251, 85, 151, 0.7) !important;
}

.text-pink-transparent-7 {
  color: rgba(251, 85, 151, 0.7) !important;
}

.bg-pink-transparent-8 {
  background-color: rgba(251, 85, 151, 0.8) !important;
}

.text-pink-transparent-8 {
  color: rgba(251, 85, 151, 0.8) !important;
}

.bg-pink-transparent-9 {
  background-color: rgba(251, 85, 151, 0.9) !important;
}

.text-pink-transparent-9 {
  color: rgba(251, 85, 151, 0.9) !important;
}

.text-red {
  color: #ff5b57 !important;
}

.text-red-lighter {
  color: #ff8481 !important;
}

.text-red-darker {
  color: #bf4441 !important;
}

.app-theme-red .app-sidebar .nav > li.active > a,
.bg-red {
  background-color: #ff5b57 !important;
}

.bg-red-lighter {
  background-color: #ff8481 !important;
}

.bg-red-darker {
  background-color: #bf4441 !important;
}

.app-theme-gradient-red .app-sidebar .nav > li.active > a,
.bg-gradient-red {
  background: #ff5b57 !important;
  background: -moz-linear-gradient(
    to bottom,
    #ff8d8a 0%,
    #ff423e 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #ff8d8a 0%,
    #ff423e 100%
  ) !important;
  background: linear-gradient(to bottom, #ff8d8a 0%, #ff423e 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-red-transparent-1 {
  background-color: rgba(255, 91, 87, 0.1) !important;
}

.text-red-transparent-1 {
  color: rgba(255, 91, 87, 0.1) !important;
}

.bg-red-transparent-2 {
  background-color: rgba(255, 91, 87, 0.2) !important;
}

.text-red-transparent-2 {
  color: rgba(255, 91, 87, 0.2) !important;
}

.bg-red-transparent-3 {
  background-color: rgba(255, 91, 87, 0.3) !important;
}

.text-red-transparent-3 {
  color: rgba(255, 91, 87, 0.3) !important;
}

.bg-red-transparent-4 {
  background-color: rgba(255, 91, 87, 0.4) !important;
}

.text-red-transparent-4 {
  color: rgba(255, 91, 87, 0.4) !important;
}

.bg-red-transparent-5 {
  background-color: rgba(255, 91, 87, 0.5) !important;
}

.text-red-transparent-5 {
  color: rgba(255, 91, 87, 0.5) !important;
}

.bg-red-transparent-6 {
  background-color: rgba(255, 91, 87, 0.6) !important;
}

.text-red-transparent-6 {
  color: rgba(255, 91, 87, 0.6) !important;
}

.bg-red-transparent-7 {
  background-color: rgba(255, 91, 87, 0.7) !important;
}

.text-red-transparent-7 {
  color: rgba(255, 91, 87, 0.7) !important;
}

.bg-red-transparent-8 {
  background-color: rgba(255, 91, 87, 0.8) !important;
}

.text-red-transparent-8 {
  color: rgba(255, 91, 87, 0.8) !important;
}

.bg-red-transparent-9 {
  background-color: rgba(255, 91, 87, 0.9) !important;
}

.text-red-transparent-9 {
  color: rgba(255, 91, 87, 0.9) !important;
}

.text-orange {
  color: #f59c1a !important;
}

.text-orange-lighter {
  color: #f8b553 !important;
}

.text-orange-darker {
  color: #b87514 !important;
}

.app-theme-orange .app-sidebar .nav > li.active > a,
.bg-orange {
  background-color: #f59c1a !important;
}

.bg-orange-lighter {
  background-color: #f8b553 !important;
}

.bg-orange-darker {
  background-color: #b87514 !important;
}

.app-theme-gradient-orange .app-sidebar .nav > li.active > a,
.bg-gradient-orange {
  background: #f59c1a !important;
  background: -moz-linear-gradient(
    to bottom,
    #f7b14b 0%,
    #eb900a 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #f7b14b 0%,
    #eb900a 100%
  ) !important;
  background: linear-gradient(to bottom, #f7b14b 0%, #eb900a 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-orange-transparent-1 {
  background-color: rgba(245, 156, 26, 0.1) !important;
}

.text-orange-transparent-1 {
  color: rgba(245, 156, 26, 0.1) !important;
}

.bg-orange-transparent-2 {
  background-color: rgba(245, 156, 26, 0.2) !important;
}

.text-orange-transparent-2 {
  color: rgba(245, 156, 26, 0.2) !important;
}

.bg-orange-transparent-3 {
  background-color: rgba(245, 156, 26, 0.3) !important;
}

.text-orange-transparent-3 {
  color: rgba(245, 156, 26, 0.3) !important;
}

.bg-orange-transparent-4 {
  background-color: rgba(245, 156, 26, 0.4) !important;
}

.text-orange-transparent-4 {
  color: rgba(245, 156, 26, 0.4) !important;
}

.bg-orange-transparent-5 {
  background-color: rgba(245, 156, 26, 0.5) !important;
}

.text-orange-transparent-5 {
  color: rgba(245, 156, 26, 0.5) !important;
}

.bg-orange-transparent-6 {
  background-color: rgba(245, 156, 26, 0.6) !important;
}

.text-orange-transparent-6 {
  color: rgba(245, 156, 26, 0.6) !important;
}

.bg-orange-transparent-7 {
  background-color: rgba(245, 156, 26, 0.7) !important;
}

.text-orange-transparent-7 {
  color: rgba(245, 156, 26, 0.7) !important;
}

.bg-orange-transparent-8 {
  background-color: rgba(245, 156, 26, 0.8) !important;
}

.text-orange-transparent-8 {
  color: rgba(245, 156, 26, 0.8) !important;
}

.bg-orange-transparent-9 {
  background-color: rgba(245, 156, 26, 0.9) !important;
}

.text-orange-transparent-9 {
  color: rgba(245, 156, 26, 0.9) !important;
}

.text-yellow {
  color: #ffd900 !important;
}

.text-yellow-lighter {
  color: #ffe340 !important;
}

.text-yellow-darker {
  color: #bfa300 !important;
}

.app-theme-yellow .app-sidebar .nav > li.active > a,
.bg-yellow {
  background-color: #ffd900 !important;
}

.bg-yellow-lighter {
  background-color: #ffe340 !important;
}

.bg-yellow-darker {
  background-color: #bfa300 !important;
}

.app-theme-gradient-yellow .app-sidebar .nav > li.active > a,
.bg-gradient-yellow {
  background: #ffd900 !important;
  background: -moz-linear-gradient(
    to bottom,
    #ffe133 0%,
    #e6c300 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #ffe133 0%,
    #e6c300 100%
  ) !important;
  background: linear-gradient(to bottom, #ffe133 0%, #e6c300 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-yellow-transparent-1 {
  background-color: rgba(255, 217, 0, 0.1) !important;
}

.text-yellow-transparent-1 {
  color: rgba(255, 217, 0, 0.1) !important;
}

.bg-yellow-transparent-2 {
  background-color: rgba(255, 217, 0, 0.2) !important;
}

.text-yellow-transparent-2 {
  color: rgba(255, 217, 0, 0.2) !important;
}

.bg-yellow-transparent-3 {
  background-color: rgba(255, 217, 0, 0.3) !important;
}

.text-yellow-transparent-3 {
  color: rgba(255, 217, 0, 0.3) !important;
}

.bg-yellow-transparent-4 {
  background-color: rgba(255, 217, 0, 0.4) !important;
}

.text-yellow-transparent-4 {
  color: rgba(255, 217, 0, 0.4) !important;
}

.bg-yellow-transparent-5 {
  background-color: rgba(255, 217, 0, 0.5) !important;
}

.text-yellow-transparent-5 {
  color: rgba(255, 217, 0, 0.5) !important;
}

.bg-yellow-transparent-6 {
  background-color: rgba(255, 217, 0, 0.6) !important;
}

.text-yellow-transparent-6 {
  color: rgba(255, 217, 0, 0.6) !important;
}

.bg-yellow-transparent-7 {
  background-color: rgba(255, 217, 0, 0.7) !important;
}

.text-yellow-transparent-7 {
  color: rgba(255, 217, 0, 0.7) !important;
}

.bg-yellow-transparent-8 {
  background-color: rgba(255, 217, 0, 0.8) !important;
}

.text-yellow-transparent-8 {
  color: rgba(255, 217, 0, 0.8) !important;
}

.bg-yellow-transparent-9 {
  background-color: rgba(255, 217, 0, 0.9) !important;
}

.text-yellow-transparent-9 {
  color: rgba(255, 217, 0, 0.9) !important;
}

.text-green {
  color: #32a932 !important;
}

.text-green-lighter {
  color: #65bf65 !important;
}

.text-green-darker {
  color: #267f26 !important;
}

.app-theme-green .app-sidebar .nav > li.active > a,
.bg-green {
  background-color: #32a932 !important;
}

.bg-green-lighter {
  background-color: #65bf65 !important;
}

.bg-green-darker {
  background-color: #267f26 !important;
}

.app-theme-gradient-green .app-sidebar .nav > li.active > a,
.bg-gradient-green {
  background: #32a932 !important;
  background: -moz-linear-gradient(
    to bottom,
    #46c846 0%,
    #2c952c 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #46c846 0%,
    #2c952c 100%
  ) !important;
  background: linear-gradient(to bottom, #46c846 0%, #2c952c 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-green-transparent-1 {
  background-color: rgba(50, 169, 50, 0.1) !important;
}

.text-green-transparent-1 {
  color: rgba(50, 169, 50, 0.1) !important;
}

.bg-green-transparent-2 {
  background-color: rgba(50, 169, 50, 0.2) !important;
}

.text-green-transparent-2 {
  color: rgba(50, 169, 50, 0.2) !important;
}

.bg-green-transparent-3 {
  background-color: rgba(50, 169, 50, 0.3) !important;
}

.text-green-transparent-3 {
  color: rgba(50, 169, 50, 0.3) !important;
}

.bg-green-transparent-4 {
  background-color: rgba(50, 169, 50, 0.4) !important;
}

.text-green-transparent-4 {
  color: rgba(50, 169, 50, 0.4) !important;
}

.bg-green-transparent-5 {
  background-color: rgba(50, 169, 50, 0.5) !important;
}

.text-green-transparent-5 {
  color: rgba(50, 169, 50, 0.5) !important;
}

.bg-green-transparent-6 {
  background-color: rgba(50, 169, 50, 0.6) !important;
}

.text-green-transparent-6 {
  color: rgba(50, 169, 50, 0.6) !important;
}

.bg-green-transparent-7 {
  background-color: rgba(50, 169, 50, 0.7) !important;
}

.text-green-transparent-7 {
  color: rgba(50, 169, 50, 0.7) !important;
}

.bg-green-transparent-8 {
  background-color: rgba(50, 169, 50, 0.8) !important;
}

.text-green-transparent-8 {
  color: rgba(50, 169, 50, 0.8) !important;
}

.bg-green-transparent-9 {
  background-color: rgba(50, 169, 50, 0.9) !important;
}

.text-green-transparent-9 {
  color: rgba(50, 169, 50, 0.9) !important;
}

.text-teal {
  color: #00acac !important;
}

.text-teal-lighter {
  color: #40c1c1 !important;
}

.text-teal-darker {
  color: #008181 !important;
}

.app-theme-teal .app-sidebar .nav > li.active > a,
.bg-teal {
  background-color: #00acac !important;
}

.bg-teal-lighter {
  background-color: #40c1c1 !important;
}

.bg-teal-darker {
  background-color: #008181 !important;
}

.app-theme-gradient-teal .app-sidebar .nav > li.active > a,
.bg-gradient-teal {
  background: #00acac !important;
  background: -moz-linear-gradient(
    to bottom,
    #00dfdf 0%,
    #009393 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #00dfdf 0%,
    #009393 100%
  ) !important;
  background: linear-gradient(to bottom, #00dfdf 0%, #009393 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-teal-transparent-1 {
  background-color: rgba(0, 172, 172, 0.1) !important;
}

.text-teal-transparent-1 {
  color: rgba(0, 172, 172, 0.1) !important;
}

.bg-teal-transparent-2 {
  background-color: rgba(0, 172, 172, 0.2) !important;
}

.text-teal-transparent-2 {
  color: rgba(0, 172, 172, 0.2) !important;
}

.bg-teal-transparent-3 {
  background-color: rgba(0, 172, 172, 0.3) !important;
}

.text-teal-transparent-3 {
  color: rgba(0, 172, 172, 0.3) !important;
}

.bg-teal-transparent-4 {
  background-color: rgba(0, 172, 172, 0.4) !important;
}

.text-teal-transparent-4 {
  color: rgba(0, 172, 172, 0.4) !important;
}

.bg-teal-transparent-5 {
  background-color: rgba(0, 172, 172, 0.5) !important;
}

.text-teal-transparent-5 {
  color: rgba(0, 172, 172, 0.5) !important;
}

.bg-teal-transparent-6 {
  background-color: rgba(0, 172, 172, 0.6) !important;
}

.text-teal-transparent-6 {
  color: rgba(0, 172, 172, 0.6) !important;
}

.bg-teal-transparent-7 {
  background-color: rgba(0, 172, 172, 0.7) !important;
}

.text-teal-transparent-7 {
  color: rgba(0, 172, 172, 0.7) !important;
}

.bg-teal-transparent-8 {
  background-color: rgba(0, 172, 172, 0.8) !important;
}

.text-teal-transparent-8 {
  color: rgba(0, 172, 172, 0.8) !important;
}

.bg-teal-transparent-9 {
  background-color: rgba(0, 172, 172, 0.9) !important;
}

.text-teal-transparent-9 {
  color: rgba(0, 172, 172, 0.9) !important;
}

.text-cyan {
  color: #49b6d6 !important;
}

.text-cyan-lighter {
  color: #77c8e0 !important;
}

.text-cyan-darker {
  color: #3789a1 !important;
}

.app-theme-cyan .app-sidebar .nav > li.active > a,
.bg-cyan {
  background-color: #49b6d6 !important;
}

.bg-cyan-lighter {
  background-color: #77c8e0 !important;
}

.bg-cyan-darker {
  background-color: #3789a1 !important;
}

.app-theme-gradient-cyan .app-sidebar .nav > li.active > a,
.bg-gradient-cyan {
  background: #49b6d6 !important;
  background: -moz-linear-gradient(
    to bottom,
    #73c7df 0%,
    #34aed1 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #73c7df 0%,
    #34aed1 100%
  ) !important;
  background: linear-gradient(to bottom, #73c7df 0%, #34aed1 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-cyan-transparent-1 {
  background-color: rgba(73, 182, 214, 0.1) !important;
}

.text-cyan-transparent-1 {
  color: rgba(73, 182, 214, 0.1) !important;
}

.bg-cyan-transparent-2 {
  background-color: rgba(73, 182, 214, 0.2) !important;
}

.text-cyan-transparent-2 {
  color: rgba(73, 182, 214, 0.2) !important;
}

.bg-cyan-transparent-3 {
  background-color: rgba(73, 182, 214, 0.3) !important;
}

.text-cyan-transparent-3 {
  color: rgba(73, 182, 214, 0.3) !important;
}

.bg-cyan-transparent-4 {
  background-color: rgba(73, 182, 214, 0.4) !important;
}

.text-cyan-transparent-4 {
  color: rgba(73, 182, 214, 0.4) !important;
}

.bg-cyan-transparent-5 {
  background-color: rgba(73, 182, 214, 0.5) !important;
}

.text-cyan-transparent-5 {
  color: rgba(73, 182, 214, 0.5) !important;
}

.bg-cyan-transparent-6 {
  background-color: rgba(73, 182, 214, 0.6) !important;
}

.text-cyan-transparent-6 {
  color: rgba(73, 182, 214, 0.6) !important;
}

.bg-cyan-transparent-7 {
  background-color: rgba(73, 182, 214, 0.7) !important;
}

.text-cyan-transparent-7 {
  color: rgba(73, 182, 214, 0.7) !important;
}

.bg-cyan-transparent-8 {
  background-color: rgba(73, 182, 214, 0.8) !important;
}

.text-cyan-transparent-8 {
  color: rgba(73, 182, 214, 0.8) !important;
}

.bg-cyan-transparent-9 {
  background-color: rgba(73, 182, 214, 0.9) !important;
}

.text-cyan-transparent-9 {
  color: rgba(73, 182, 214, 0.9) !important;
}

.text-white,
.text-white-lighter {
  color: #fff !important;
}

.text-white-darker {
  color: #bfbfbf !important;
}

.app-theme-white .app-sidebar .nav > li.active > a,
.bg-white,
.bg-white-lighter {
  background-color: #fff !important;
}

.bg-white-darker {
  background-color: #bfbfbf !important;
}

.app-theme-gradient-white .app-sidebar .nav > li.active > a,
.bg-gradient-white {
  background: #fff !important;
  background: -moz-linear-gradient(
    to bottom,
    white 0%,
    #f2f2f2 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    white 0%,
    #f2f2f2 100%
  ) !important;
  background: linear-gradient(to bottom, #fff 0%, #f2f2f2 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-white-transparent-1 {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.text-white-transparent-1 {
  color: rgba(255, 255, 255, 0.1) !important;
}

.bg-white-transparent-2 {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.text-white-transparent-2 {
  color: rgba(255, 255, 255, 0.2) !important;
}

.bg-white-transparent-3 {
  background-color: rgba(255, 255, 255, 0.3) !important;
}

.text-white-transparent-3 {
  color: rgba(255, 255, 255, 0.3) !important;
}

.bg-white-transparent-4 {
  background-color: rgba(255, 255, 255, 0.4) !important;
}

.text-white-transparent-4 {
  color: rgba(255, 255, 255, 0.4) !important;
}

.bg-white-transparent-5 {
  background-color: rgba(255, 255, 255, 0.5) !important;
}

.text-white-transparent-5 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.bg-white-transparent-6 {
  background-color: rgba(255, 255, 255, 0.6) !important;
}

.text-white-transparent-6 {
  color: rgba(255, 255, 255, 0.6) !important;
}

.bg-white-transparent-7 {
  background-color: rgba(255, 255, 255, 0.7) !important;
}

.text-white-transparent-7 {
  color: rgba(255, 255, 255, 0.7) !important;
}

.bg-white-transparent-8 {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

.text-white-transparent-8 {
  color: rgba(255, 255, 255, 0.8) !important;
}

.bg-white-transparent-9 {
  background-color: rgba(255, 255, 255, 0.9) !important;
}

.text-white-transparent-9 {
  color: rgba(255, 255, 255, 0.9) !important;
}

.text-gray {
  color: #6c757d !important;
}

.text-gray-lighter {
  color: #91989e !important;
}

.text-gray-darker {
  color: #51585e !important;
}

.app-theme-gray .app-sidebar .nav > li.active > a,
.bg-gray {
  background-color: #6c757d !important;
}

.bg-gray-lighter {
  background-color: #91989e !important;
}

.bg-gray-darker {
  background-color: #51585e !important;
}

.app-theme-gradient-gray .app-sidebar .nav > li.active > a,
.bg-gradient-gray {
  background: #6c757d !important;
  background: -moz-linear-gradient(
    to bottom,
    #868e96 0%,
    #60686f 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #868e96 0%,
    #60686f 100%
  ) !important;
  background: linear-gradient(to bottom, #868e96 0%, #60686f 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-gray-transparent-1 {
  background-color: rgba(108, 117, 125, 0.1) !important;
}

.text-gray-transparent-1 {
  color: rgba(108, 117, 125, 0.1) !important;
}

.bg-gray-transparent-2 {
  background-color: rgba(108, 117, 125, 0.2) !important;
}

.text-gray-transparent-2 {
  color: rgba(108, 117, 125, 0.2) !important;
}

.bg-gray-transparent-3 {
  background-color: rgba(108, 117, 125, 0.3) !important;
}

.text-gray-transparent-3 {
  color: rgba(108, 117, 125, 0.3) !important;
}

.bg-gray-transparent-4 {
  background-color: rgba(108, 117, 125, 0.4) !important;
}

.text-gray-transparent-4 {
  color: rgba(108, 117, 125, 0.4) !important;
}

.bg-gray-transparent-5 {
  background-color: rgba(108, 117, 125, 0.5) !important;
}

.text-gray-transparent-5 {
  color: rgba(108, 117, 125, 0.5) !important;
}

.bg-gray-transparent-6 {
  background-color: rgba(108, 117, 125, 0.6) !important;
}

.text-gray-transparent-6 {
  color: rgba(108, 117, 125, 0.6) !important;
}

.bg-gray-transparent-7 {
  background-color: rgba(108, 117, 125, 0.7) !important;
}

.text-gray-transparent-7 {
  color: rgba(108, 117, 125, 0.7) !important;
}

.bg-gray-transparent-8 {
  background-color: rgba(108, 117, 125, 0.8) !important;
}

.text-gray-transparent-8 {
  color: rgba(108, 117, 125, 0.8) !important;
}

.bg-gray-transparent-9 {
  background-color: rgba(108, 117, 125, 0.9) !important;
}

.text-gray-transparent-9 {
  color: rgba(108, 117, 125, 0.9) !important;
}

.text-gray-dark {
  color: #343a40 !important;
}

.text-gray-dark-lighter {
  color: #676b70 !important;
}

.text-gray-dark-darker {
  color: #272c30 !important;
}

.app-theme-gray-dark .app-sidebar .nav > li.active > a,
.bg-gray-dark {
  background-color: #343a40 !important;
}

.bg-gray-dark-lighter {
  background-color: #676b70 !important;
}

.bg-gray-dark-darker {
  background-color: #272c30 !important;
}

.app-theme-gradient-gray-dark .app-sidebar .nav > li.active > a,
.bg-gradient-gray-dark {
  background: #343a40 !important;
  background: -moz-linear-gradient(
    to bottom,
    #4b545c 0%,
    #292d32 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #4b545c 0%,
    #292d32 100%
  ) !important;
  background: linear-gradient(to bottom, #4b545c 0%, #292d32 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-gray-dark-transparent-1 {
  background-color: rgba(52, 58, 64, 0.1) !important;
}

.text-gray-dark-transparent-1 {
  color: rgba(52, 58, 64, 0.1) !important;
}

.bg-gray-dark-transparent-2 {
  background-color: rgba(52, 58, 64, 0.2) !important;
}

.text-gray-dark-transparent-2 {
  color: rgba(52, 58, 64, 0.2) !important;
}

.bg-gray-dark-transparent-3 {
  background-color: rgba(52, 58, 64, 0.3) !important;
}

.text-gray-dark-transparent-3 {
  color: rgba(52, 58, 64, 0.3) !important;
}

.bg-gray-dark-transparent-4 {
  background-color: rgba(52, 58, 64, 0.4) !important;
}

.text-gray-dark-transparent-4 {
  color: rgba(52, 58, 64, 0.4) !important;
}

.bg-gray-dark-transparent-5 {
  background-color: rgba(52, 58, 64, 0.5) !important;
}

.text-gray-dark-transparent-5 {
  color: rgba(52, 58, 64, 0.5) !important;
}

.bg-gray-dark-transparent-6 {
  background-color: rgba(52, 58, 64, 0.6) !important;
}

.text-gray-dark-transparent-6 {
  color: rgba(52, 58, 64, 0.6) !important;
}

.bg-gray-dark-transparent-7 {
  background-color: rgba(52, 58, 64, 0.7) !important;
}

.text-gray-dark-transparent-7 {
  color: rgba(52, 58, 64, 0.7) !important;
}

.bg-gray-dark-transparent-8 {
  background-color: rgba(52, 58, 64, 0.8) !important;
}

.text-gray-dark-transparent-8 {
  color: rgba(52, 58, 64, 0.8) !important;
}

.bg-gray-dark-transparent-9 {
  background-color: rgba(52, 58, 64, 0.9) !important;
}

.text-gray-dark-transparent-9 {
  color: rgba(52, 58, 64, 0.9) !important;
}

.text-black {
  color: #000 !important;
}

.text-black-lighter {
  color: #404040 !important;
}

.text-black-darker {
  color: #000 !important;
}

.bg-black {
  background-color: #000 !important;
}

.bg-black-lighter {
  background-color: #404040 !important;
}

.app-theme-black .app-sidebar .nav > li.active > a,
.bg-black-darker {
  background-color: #000 !important;
}

.app-theme-gradient-black .app-sidebar .nav > li.active > a,
.bg-gradient-black {
  background: #000 !important;
  background: -moz-linear-gradient(
    to bottom,
    #1a1a1a 0%,
    black 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #1a1a1a 0%,
    black 100%
  ) !important;
  background: linear-gradient(to bottom, #1a1a1a 0%, #000 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-black-transparent-1 {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.text-black-transparent-1 {
  color: rgba(0, 0, 0, 0.1) !important;
}

.bg-black-transparent-2 {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.text-black-transparent-2 {
  color: rgba(0, 0, 0, 0.2) !important;
}

.bg-black-transparent-3 {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

.text-black-transparent-3 {
  color: rgba(0, 0, 0, 0.3) !important;
}

.bg-black-transparent-4 {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

.text-black-transparent-4 {
  color: rgba(0, 0, 0, 0.4) !important;
}

.bg-black-transparent-5 {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.text-black-transparent-5 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.bg-black-transparent-6 {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.text-black-transparent-6 {
  color: rgba(0, 0, 0, 0.6) !important;
}

.bg-black-transparent-7 {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.text-black-transparent-7 {
  color: rgba(0, 0, 0, 0.7) !important;
}

.bg-black-transparent-8 {
  background-color: rgba(0, 0, 0, 0.8) !important;
}

.text-black-transparent-8 {
  color: rgba(0, 0, 0, 0.8) !important;
}

.bg-black-transparent-9 {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

.text-black-transparent-9 {
  color: rgba(0, 0, 0, 0.9) !important;
}

.text-dark {
  color: #2d353c !important;
}

.text-dark-lighter {
  color: #62686d !important;
}

.app-theme-dark .app-sidebar .nav > li.active > a,
.bg-dark {
  background-color: #2d353c !important;
}

.bg-dark-lighter {
  background-color: #62686d !important;
}

.app-theme-gradient-dark .app-sidebar .nav > li.active > a,
.bg-gradient-dark {
  background: #2d353c !important;
  background: -moz-linear-gradient(
    to bottom,
    #434f59 0%,
    #22282d 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #434f59 0%,
    #22282d 100%
  ) !important;
  background: linear-gradient(to bottom, #434f59 0%, #22282d 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-dark-transparent-1 {
  background-color: rgba(45, 53, 60, 0.1) !important;
}

.text-dark-transparent-1 {
  color: rgba(45, 53, 60, 0.1) !important;
}

.bg-dark-transparent-2 {
  background-color: rgba(45, 53, 60, 0.2) !important;
}

.text-dark-transparent-2 {
  color: rgba(45, 53, 60, 0.2) !important;
}

.bg-dark-transparent-3 {
  background-color: rgba(45, 53, 60, 0.3) !important;
}

.text-dark-transparent-3 {
  color: rgba(45, 53, 60, 0.3) !important;
}

.bg-dark-transparent-4 {
  background-color: rgba(45, 53, 60, 0.4) !important;
}

.text-dark-transparent-4 {
  color: rgba(45, 53, 60, 0.4) !important;
}

.bg-dark-transparent-5 {
  background-color: rgba(45, 53, 60, 0.5) !important;
}

.text-dark-transparent-5 {
  color: rgba(45, 53, 60, 0.5) !important;
}

.bg-dark-transparent-6 {
  background-color: rgba(45, 53, 60, 0.6) !important;
}

.text-dark-transparent-6 {
  color: rgba(45, 53, 60, 0.6) !important;
}

.bg-dark-transparent-7 {
  background-color: rgba(45, 53, 60, 0.7) !important;
}

.text-dark-transparent-7 {
  color: rgba(45, 53, 60, 0.7) !important;
}

.bg-dark-transparent-8 {
  background-color: rgba(45, 53, 60, 0.8) !important;
}

.text-dark-transparent-8 {
  color: rgba(45, 53, 60, 0.8) !important;
}

.bg-dark-transparent-9 {
  background-color: rgba(45, 53, 60, 0.9) !important;
}

.text-dark-transparent-9 {
  color: rgba(45, 53, 60, 0.9) !important;
}

.text-dark-darker {
  color: #1a2229 !important;
}

.text-dark-darker-lighter {
  color: #53595f !important;
}

.text-dark-darker-darker {
  color: #141a1f !important;
}

.app-theme-dark-darker .app-sidebar .nav > li.active > a,
.bg-dark-darker {
  background-color: #1a2229 !important;
}

.bg-dark-darker-lighter {
  background-color: #53595f !important;
}

.bg-dark-darker-darker {
  background-color: #141a1f !important;
}

.app-theme-gradient-dark-darker .app-sidebar .nav > li.active > a,
.bg-gradient-dark-darker {
  background: #1a2229 !important;
  background: -moz-linear-gradient(
    to bottom,
    #2e3c48 0%,
    #101519 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #2e3c48 0%,
    #101519 100%
  ) !important;
  background: linear-gradient(to bottom, #2e3c48 0%, #101519 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-dark-darker-transparent-1 {
  background-color: rgba(26, 34, 41, 0.1) !important;
}

.text-dark-darker-transparent-1 {
  color: rgba(26, 34, 41, 0.1) !important;
}

.bg-dark-darker-transparent-2 {
  background-color: rgba(26, 34, 41, 0.2) !important;
}

.text-dark-darker-transparent-2 {
  color: rgba(26, 34, 41, 0.2) !important;
}

.bg-dark-darker-transparent-3 {
  background-color: rgba(26, 34, 41, 0.3) !important;
}

.text-dark-darker-transparent-3 {
  color: rgba(26, 34, 41, 0.3) !important;
}

.bg-dark-darker-transparent-4 {
  background-color: rgba(26, 34, 41, 0.4) !important;
}

.text-dark-darker-transparent-4 {
  color: rgba(26, 34, 41, 0.4) !important;
}

.bg-dark-darker-transparent-5 {
  background-color: rgba(26, 34, 41, 0.5) !important;
}

.text-dark-darker-transparent-5 {
  color: rgba(26, 34, 41, 0.5) !important;
}

.bg-dark-darker-transparent-6 {
  background-color: rgba(26, 34, 41, 0.6) !important;
}

.text-dark-darker-transparent-6 {
  color: rgba(26, 34, 41, 0.6) !important;
}

.bg-dark-darker-transparent-7 {
  background-color: rgba(26, 34, 41, 0.7) !important;
}

.text-dark-darker-transparent-7 {
  color: rgba(26, 34, 41, 0.7) !important;
}

.bg-dark-darker-transparent-8 {
  background-color: rgba(26, 34, 41, 0.8) !important;
}

.text-dark-darker-transparent-8 {
  color: rgba(26, 34, 41, 0.8) !important;
}

.bg-dark-darker-transparent-9 {
  background-color: rgba(26, 34, 41, 0.9) !important;
}

.text-dark-darker-transparent-9 {
  color: rgba(26, 34, 41, 0.9) !important;
}

.text-lime {
  color: #90ca4b !important;
}

.text-lime-lighter {
  color: #acd778 !important;
}

.text-lime-darker {
  color: #6c9838 !important;
}

.app-theme-lime .app-sidebar .nav > li.active > a,
.bg-lime {
  background-color: #90ca4b !important;
}

.bg-lime-lighter {
  background-color: #acd778 !important;
}

.bg-lime-darker {
  background-color: #6c9838 !important;
}

.app-theme-gradient-lime .app-sidebar .nav > li.active > a,
.bg-gradient-lime {
  background: #90ca4b !important;
  background: -moz-linear-gradient(
    to bottom,
    #a8d672 0%,
    #84c239 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #a8d672 0%,
    #84c239 100%
  ) !important;
  background: linear-gradient(to bottom, #a8d672 0%, #84c239 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-lime-transparent-1 {
  background-color: rgba(144, 202, 75, 0.1) !important;
}

.text-lime-transparent-1 {
  color: rgba(144, 202, 75, 0.1) !important;
}

.bg-lime-transparent-2 {
  background-color: rgba(144, 202, 75, 0.2) !important;
}

.text-lime-transparent-2 {
  color: rgba(144, 202, 75, 0.2) !important;
}

.bg-lime-transparent-3 {
  background-color: rgba(144, 202, 75, 0.3) !important;
}

.text-lime-transparent-3 {
  color: rgba(144, 202, 75, 0.3) !important;
}

.bg-lime-transparent-4 {
  background-color: rgba(144, 202, 75, 0.4) !important;
}

.text-lime-transparent-4 {
  color: rgba(144, 202, 75, 0.4) !important;
}

.bg-lime-transparent-5 {
  background-color: rgba(144, 202, 75, 0.5) !important;
}

.text-lime-transparent-5 {
  color: rgba(144, 202, 75, 0.5) !important;
}

.bg-lime-transparent-6 {
  background-color: rgba(144, 202, 75, 0.6) !important;
}

.text-lime-transparent-6 {
  color: rgba(144, 202, 75, 0.6) !important;
}

.bg-lime-transparent-7 {
  background-color: rgba(144, 202, 75, 0.7) !important;
}

.text-lime-transparent-7 {
  color: rgba(144, 202, 75, 0.7) !important;
}

.bg-lime-transparent-8 {
  background-color: rgba(144, 202, 75, 0.8) !important;
}

.text-lime-transparent-8 {
  color: rgba(144, 202, 75, 0.8) !important;
}

.bg-lime-transparent-9 {
  background-color: rgba(144, 202, 75, 0.9) !important;
}

.text-lime-transparent-9 {
  color: rgba(144, 202, 75, 0.9) !important;
}

.text-light {
  color: #f2f3f4 !important;
}

.text-light-lighter {
  color: #f5f6f7 !important;
}

.text-light-darker {
  color: #b6b6b7 !important;
}

.app-theme-light .app-sidebar .nav > li.active > a,
.bg-light {
  background-color: #f2f3f4 !important;
}

.bg-light-lighter {
  background-color: #f5f6f7 !important;
}

.bg-light-darker {
  background-color: #b6b6b7 !important;
}

.app-theme-gradient-light .app-sidebar .nav > li.active > a,
.bg-gradient-light {
  background: #f2f3f4 !important;
  background: -moz-linear-gradient(
    to bottom,
    white 0%,
    #e4e6e8 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    white 0%,
    #e4e6e8 100%
  ) !important;
  background: linear-gradient(to bottom, #fff 0%, #e4e6e8 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-light-transparent-1 {
  background-color: rgba(242, 243, 244, 0.1) !important;
}

.text-light-transparent-1 {
  color: rgba(242, 243, 244, 0.1) !important;
}

.bg-light-transparent-2 {
  background-color: rgba(242, 243, 244, 0.2) !important;
}

.text-light-transparent-2 {
  color: rgba(242, 243, 244, 0.2) !important;
}

.bg-light-transparent-3 {
  background-color: rgba(242, 243, 244, 0.3) !important;
}

.text-light-transparent-3 {
  color: rgba(242, 243, 244, 0.3) !important;
}

.bg-light-transparent-4 {
  background-color: rgba(242, 243, 244, 0.4) !important;
}

.text-light-transparent-4 {
  color: rgba(242, 243, 244, 0.4) !important;
}

.bg-light-transparent-5 {
  background-color: rgba(242, 243, 244, 0.5) !important;
}

.text-light-transparent-5 {
  color: rgba(242, 243, 244, 0.5) !important;
}

.bg-light-transparent-6 {
  background-color: rgba(242, 243, 244, 0.6) !important;
}

.text-light-transparent-6 {
  color: rgba(242, 243, 244, 0.6) !important;
}

.bg-light-transparent-7 {
  background-color: rgba(242, 243, 244, 0.7) !important;
}

.text-light-transparent-7 {
  color: rgba(242, 243, 244, 0.7) !important;
}

.bg-light-transparent-8 {
  background-color: rgba(242, 243, 244, 0.8) !important;
}

.text-light-transparent-8 {
  color: rgba(242, 243, 244, 0.8) !important;
}

.bg-light-transparent-9 {
  background-color: rgba(242, 243, 244, 0.9) !important;
}

.text-light-transparent-9 {
  color: rgba(242, 243, 244, 0.9) !important;
}

.text-silver {
  color: #b6c2c9 !important;
}

.text-silver-lighter {
  color: #c8d1d7 !important;
}

.text-silver-darker {
  color: #899297 !important;
}

.app-theme-silver .app-sidebar .nav > li.active > a,
.bg-silver {
  background-color: #b6c2c9 !important;
}

.bg-silver-lighter {
  background-color: #c8d1d7 !important;
}

.bg-silver-darker {
  background-color: #899297 !important;
}

.app-theme-gradient-silver .app-sidebar .nav > li.active > a,
.bg-gradient-silver {
  background: #b6c2c9 !important;
  background: -moz-linear-gradient(
    to bottom,
    #d3dadf 0%,
    #a7b6be 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #d3dadf 0%,
    #a7b6be 100%
  ) !important;
  background: linear-gradient(to bottom, #d3dadf 0%, #a7b6be 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-silver-transparent-1 {
  background-color: rgba(182, 194, 201, 0.1) !important;
}

.text-silver-transparent-1 {
  color: rgba(182, 194, 201, 0.1) !important;
}

.bg-silver-transparent-2 {
  background-color: rgba(182, 194, 201, 0.2) !important;
}

.text-silver-transparent-2 {
  color: rgba(182, 194, 201, 0.2) !important;
}

.bg-silver-transparent-3 {
  background-color: rgba(182, 194, 201, 0.3) !important;
}

.text-silver-transparent-3 {
  color: rgba(182, 194, 201, 0.3) !important;
}

.bg-silver-transparent-4 {
  background-color: rgba(182, 194, 201, 0.4) !important;
}

.text-silver-transparent-4 {
  color: rgba(182, 194, 201, 0.4) !important;
}

.bg-silver-transparent-5 {
  background-color: rgba(182, 194, 201, 0.5) !important;
}

.text-silver-transparent-5 {
  color: rgba(182, 194, 201, 0.5) !important;
}

.bg-silver-transparent-6 {
  background-color: rgba(182, 194, 201, 0.6) !important;
}

.text-silver-transparent-6 {
  color: rgba(182, 194, 201, 0.6) !important;
}

.bg-silver-transparent-7 {
  background-color: rgba(182, 194, 201, 0.7) !important;
}

.text-silver-transparent-7 {
  color: rgba(182, 194, 201, 0.7) !important;
}

.bg-silver-transparent-8 {
  background-color: rgba(182, 194, 201, 0.8) !important;
}

.text-silver-transparent-8 {
  color: rgba(182, 194, 201, 0.8) !important;
}

.bg-silver-transparent-9 {
  background-color: rgba(182, 194, 201, 0.9) !important;
}

.text-silver-transparent-9 {
  color: rgba(182, 194, 201, 0.9) !important;
}

.text-muted {
  color: #627884 !important;
}

.text-muted-lighter {
  color: #8999a3 !important;
}

.text-muted-darker {
  color: #495a63 !important;
}

.app-theme-muted .app-sidebar .nav > li.active > a,
.bg-muted {
  background-color: #627884 !important;
}

.bg-muted-lighter {
  background-color: #8999a3 !important;
}

.bg-muted-darker {
  background-color: #495a63 !important;
}

.app-theme-gradient-muted .app-sidebar .nav > li.active > a,
.bg-gradient-muted {
  background: #627884 !important;
  background: -moz-linear-gradient(
    to bottom,
    #7b919e 0%,
    #576a76 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #7b919e 0%,
    #576a76 100%
  ) !important;
  background: linear-gradient(to bottom, #7b919e 0%, #576a76 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-muted-transparent-1 {
  background-color: rgba(98, 120, 132, 0.1) !important;
}

.text-muted-transparent-1 {
  color: rgba(98, 120, 132, 0.1) !important;
}

.bg-muted-transparent-2 {
  background-color: rgba(98, 120, 132, 0.2) !important;
}

.text-muted-transparent-2 {
  color: rgba(98, 120, 132, 0.2) !important;
}

.bg-muted-transparent-3 {
  background-color: rgba(98, 120, 132, 0.3) !important;
}

.text-muted-transparent-3 {
  color: rgba(98, 120, 132, 0.3) !important;
}

.bg-muted-transparent-4 {
  background-color: rgba(98, 120, 132, 0.4) !important;
}

.text-muted-transparent-4 {
  color: rgba(98, 120, 132, 0.4) !important;
}

.bg-muted-transparent-5 {
  background-color: rgba(98, 120, 132, 0.5) !important;
}

.text-muted-transparent-5 {
  color: rgba(98, 120, 132, 0.5) !important;
}

.bg-muted-transparent-6 {
  background-color: rgba(98, 120, 132, 0.6) !important;
}

.text-muted-transparent-6 {
  color: rgba(98, 120, 132, 0.6) !important;
}

.bg-muted-transparent-7 {
  background-color: rgba(98, 120, 132, 0.7) !important;
}

.text-muted-transparent-7 {
  color: rgba(98, 120, 132, 0.7) !important;
}

.bg-muted-transparent-8 {
  background-color: rgba(98, 120, 132, 0.8) !important;
}

.text-muted-transparent-8 {
  color: rgba(98, 120, 132, 0.8) !important;
}

.bg-muted-transparent-9 {
  background-color: rgba(98, 120, 132, 0.9) !important;
}

.text-muted-transparent-9 {
  color: rgba(98, 120, 132, 0.9) !important;
}

.text-aqua {
  color: #49b6d6 !important;
}

.text-aqua-lighter {
  color: #77c8e0 !important;
}

.text-aqua-darker {
  color: #3789a1 !important;
}

.app-theme-aqua .app-sidebar .nav > li.active > a,
.bg-aqua {
  background-color: #49b6d6 !important;
}

.bg-aqua-lighter {
  background-color: #77c8e0 !important;
}

.bg-aqua-darker {
  background-color: #3789a1 !important;
}

.app-theme-gradient-aqua .app-sidebar .nav > li.active > a,
.bg-gradient-aqua {
  background: #49b6d6 !important;
  background: -moz-linear-gradient(
    to bottom,
    #73c7df 0%,
    #34aed1 100%
  ) !important;
  background: -webkit-linear-gradient(
    to bottom,
    #73c7df 0%,
    #34aed1 100%
  ) !important;
  background: linear-gradient(to bottom, #73c7df 0%, #34aed1 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten(\$value, 10%)', endColorstr='darken(\$value, 5%)', GradientType=0) !important;
}

.bg-aqua-transparent-1 {
  background-color: rgba(73, 182, 214, 0.1) !important;
}

.text-aqua-transparent-1 {
  color: rgba(73, 182, 214, 0.1) !important;
}

.bg-aqua-transparent-2 {
  background-color: rgba(73, 182, 214, 0.2) !important;
}

.text-aqua-transparent-2 {
  color: rgba(73, 182, 214, 0.2) !important;
}

.bg-aqua-transparent-3 {
  background-color: rgba(73, 182, 214, 0.3) !important;
}

.text-aqua-transparent-3 {
  color: rgba(73, 182, 214, 0.3) !important;
}

.bg-aqua-transparent-4 {
  background-color: rgba(73, 182, 214, 0.4) !important;
}

.text-aqua-transparent-4 {
  color: rgba(73, 182, 214, 0.4) !important;
}

.bg-aqua-transparent-5 {
  background-color: rgba(73, 182, 214, 0.5) !important;
}

.text-aqua-transparent-5 {
  color: rgba(73, 182, 214, 0.5) !important;
}

.bg-aqua-transparent-6 {
  background-color: rgba(73, 182, 214, 0.6) !important;
}

.text-aqua-transparent-6 {
  color: rgba(73, 182, 214, 0.6) !important;
}

.bg-aqua-transparent-7 {
  background-color: rgba(73, 182, 214, 0.7) !important;
}

.text-aqua-transparent-7 {
  color: rgba(73, 182, 214, 0.7) !important;
}

.bg-aqua-transparent-8 {
  background-color: rgba(73, 182, 214, 0.8) !important;
}

.text-aqua-transparent-8 {
  color: rgba(73, 182, 214, 0.8) !important;
}

.bg-aqua-transparent-9 {
  background-color: rgba(73, 182, 214, 0.9) !important;
}

.text-aqua-transparent-9 {
  color: rgba(73, 182, 214, 0.9) !important;
}

.no-bg {
  background: 0 0 !important;
}

.bg-gradient-red-pink,
.bg-gradient-red-pink-diagonal-down,
.bg-gradient-red-pink-diagonal-up,
.bg-gradient-red-pink-to-right {
  background: #ff5b57;
}

.bg-gradient-red-pink {
  background: -moz-linear-gradient(to bottom, #ff5b57 0%, #fb5597 100%);
  background: -webkit-linear-gradient(to bottom, #ff5b57 0%, #fb5597 100%);
  background: linear-gradient(to bottom, #ff5b57 0%, #fb5597 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-red-pink-to-right,
.bg-gradient-red-pink-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-red-pink-to-right {
  background: -moz-linear-gradient(to right, #ff5b57 0%, #fb5597 100%);
  background: -webkit-linear-gradient(to right, #ff5b57 0%, #fb5597 100%);
  background: linear-gradient(to right, #ff5b57 0%, #fb5597 100%);
}

.bg-gradient-red-pink-to-top {
  background: -moz-linear-gradient(to top, #ff5b57 0%, #fb5597 100%);
  background: -webkit-linear-gradient(to top, #ff5b57 0%, #fb5597 100%);
  background: linear-gradient(to top, #ff5b57 0%, #fb5597 100%);
}

.bg-gradient-red-pink-to-left {
  background: -moz-linear-gradient(to left, #ff5b57 0%, #fb5597 100%);
  background: -webkit-linear-gradient(to left, #ff5b57 0%, #fb5597 100%);
  background: linear-gradient(to left, #ff5b57 0%, #fb5597 100%);
}

.bg-gradient-red-pink-diagonal-down,
.bg-gradient-red-pink-diagonal-up,
.bg-gradient-red-pink-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-red-pink-diagonal-down {
  background: -moz-linear-gradient(-45deg, #ff5b57 0%, #fb5597 100%);
  background: -webkit-linear-gradient(-45deg, #ff5b57 0%, #fb5597 100%);
  background: linear-gradient(-45deg, #ff5b57 0%, #fb5597 100%);
}

.bg-gradient-red-pink-diagonal-up {
  background: -moz-linear-gradient(45deg, #ff5b57 0%, #fb5597 100%);
  background: -webkit-linear-gradient(45deg, #ff5b57 0%, #fb5597 100%);
  background: linear-gradient(45deg, #ff5b57 0%, #fb5597 100%);
}

.bg-gradient-orange-red,
.bg-gradient-orange-red-diagonal-down,
.bg-gradient-orange-red-diagonal-up,
.bg-gradient-orange-red-to-right {
  background: #f59c1a;
}

.bg-gradient-orange-red {
  background: -moz-linear-gradient(to bottom, #f59c1a 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to bottom, #f59c1a 0%, #ff5b57 100%);
  background: linear-gradient(to bottom, #f59c1a 0%, #ff5b57 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-orange-red-to-right,
.bg-gradient-orange-red-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-orange-red-to-right {
  background: -moz-linear-gradient(to right, #f59c1a 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to right, #f59c1a 0%, #ff5b57 100%);
  background: linear-gradient(to right, #f59c1a 0%, #ff5b57 100%);
}

.bg-gradient-orange-red-to-top {
  background: -moz-linear-gradient(to top, #f59c1a 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to top, #f59c1a 0%, #ff5b57 100%);
  background: linear-gradient(to top, #f59c1a 0%, #ff5b57 100%);
}

.bg-gradient-orange-red-to-left {
  background: -moz-linear-gradient(to left, #f59c1a 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to left, #f59c1a 0%, #ff5b57 100%);
  background: linear-gradient(to left, #f59c1a 0%, #ff5b57 100%);
}

.bg-gradient-orange-red-diagonal-down,
.bg-gradient-orange-red-diagonal-up,
.bg-gradient-orange-red-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-orange-red-diagonal-down {
  background: -moz-linear-gradient(-45deg, #f59c1a 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(-45deg, #f59c1a 0%, #ff5b57 100%);
  background: linear-gradient(-45deg, #f59c1a 0%, #ff5b57 100%);
}

.bg-gradient-orange-red-diagonal-up {
  background: -moz-linear-gradient(45deg, #f59c1a 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(45deg, #f59c1a 0%, #ff5b57 100%);
  background: linear-gradient(45deg, #f59c1a 0%, #ff5b57 100%);
}

.bg-gradient-yellow-orange,
.bg-gradient-yellow-orange-diagonal-down,
.bg-gradient-yellow-orange-diagonal-up,
.bg-gradient-yellow-orange-to-right {
  background: #ffd900;
}

.bg-gradient-yellow-orange {
  background: -moz-linear-gradient(to bottom, #ffd900 0%, #f59c1a 100%);
  background: -webkit-linear-gradient(to bottom, #ffd900 0%, #f59c1a 100%);
  background: linear-gradient(to bottom, #ffd900 0%, #f59c1a 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-yellow-orange-to-right,
.bg-gradient-yellow-orange-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-yellow-orange-to-right {
  background: -moz-linear-gradient(to right, #ffd900 0%, #f59c1a 100%);
  background: -webkit-linear-gradient(to right, #ffd900 0%, #f59c1a 100%);
  background: linear-gradient(to right, #ffd900 0%, #f59c1a 100%);
}

.bg-gradient-yellow-orange-to-top {
  background: -moz-linear-gradient(to top, #ffd900 0%, #f59c1a 100%);
  background: -webkit-linear-gradient(to top, #ffd900 0%, #f59c1a 100%);
  background: linear-gradient(to top, #ffd900 0%, #f59c1a 100%);
}

.bg-gradient-yellow-orange-to-left {
  background: -moz-linear-gradient(to left, #ffd900 0%, #f59c1a 100%);
  background: -webkit-linear-gradient(to left, #ffd900 0%, #f59c1a 100%);
  background: linear-gradient(to left, #ffd900 0%, #f59c1a 100%);
}

.bg-gradient-yellow-orange-diagonal-down,
.bg-gradient-yellow-orange-diagonal-up,
.bg-gradient-yellow-orange-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-yellow-orange-diagonal-down {
  background: -moz-linear-gradient(-45deg, #ffd900 0%, #f59c1a 100%);
  background: -webkit-linear-gradient(-45deg, #ffd900 0%, #f59c1a 100%);
  background: linear-gradient(-45deg, #ffd900 0%, #f59c1a 100%);
}

.bg-gradient-yellow-orange-diagonal-up {
  background: -moz-linear-gradient(45deg, #ffd900 0%, #f59c1a 100%);
  background: -webkit-linear-gradient(45deg, #ffd900 0%, #f59c1a 100%);
  background: linear-gradient(45deg, #ffd900 0%, #f59c1a 100%);
}

.bg-gradient-yellow-red,
.bg-gradient-yellow-red-diagonal-down,
.bg-gradient-yellow-red-diagonal-up,
.bg-gradient-yellow-red-to-right {
  background: #ffd900;
}

.bg-gradient-yellow-red {
  background: -moz-linear-gradient(to bottom, #ffd900 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to bottom, #ffd900 0%, #ff5b57 100%);
  background: linear-gradient(to bottom, #ffd900 0%, #ff5b57 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-yellow-red-to-right,
.bg-gradient-yellow-red-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-yellow-red-to-right {
  background: -moz-linear-gradient(to right, #ffd900 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to right, #ffd900 0%, #ff5b57 100%);
  background: linear-gradient(to right, #ffd900 0%, #ff5b57 100%);
}

.bg-gradient-yellow-red-to-top {
  background: -moz-linear-gradient(to top, #ffd900 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to top, #ffd900 0%, #ff5b57 100%);
  background: linear-gradient(to top, #ffd900 0%, #ff5b57 100%);
}

.bg-gradient-yellow-red-to-left {
  background: -moz-linear-gradient(to left, #ffd900 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(to left, #ffd900 0%, #ff5b57 100%);
  background: linear-gradient(to left, #ffd900 0%, #ff5b57 100%);
}

.bg-gradient-yellow-red-diagonal-down,
.bg-gradient-yellow-red-diagonal-up,
.bg-gradient-yellow-red-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-yellow-red-diagonal-down {
  background: -moz-linear-gradient(-45deg, #ffd900 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(-45deg, #ffd900 0%, #ff5b57 100%);
  background: linear-gradient(-45deg, #ffd900 0%, #ff5b57 100%);
}

.bg-gradient-yellow-red-diagonal-up {
  background: -moz-linear-gradient(45deg, #ffd900 0%, #ff5b57 100%);
  background: -webkit-linear-gradient(45deg, #ffd900 0%, #ff5b57 100%);
  background: linear-gradient(45deg, #ffd900 0%, #ff5b57 100%);
}

.bg-gradient-teal-green,
.bg-gradient-teal-green-diagonal-down,
.bg-gradient-teal-green-diagonal-up,
.bg-gradient-teal-green-to-right {
  background: #00acac;
}

.bg-gradient-teal-green {
  background: -moz-linear-gradient(to bottom, #00acac 0%, #32a932 100%);
  background: -webkit-linear-gradient(to bottom, #00acac 0%, #32a932 100%);
  background: linear-gradient(to bottom, #00acac 0%, #32a932 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-teal-green-to-right,
.bg-gradient-teal-green-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-teal-green-to-right {
  background: -moz-linear-gradient(to right, #00acac 0%, #32a932 100%);
  background: -webkit-linear-gradient(to right, #00acac 0%, #32a932 100%);
  background: linear-gradient(to right, #00acac 0%, #32a932 100%);
}

.bg-gradient-teal-green-to-top {
  background: -moz-linear-gradient(to top, #00acac 0%, #32a932 100%);
  background: -webkit-linear-gradient(to top, #00acac 0%, #32a932 100%);
  background: linear-gradient(to top, #00acac 0%, #32a932 100%);
}

.bg-gradient-teal-green-to-left {
  background: -moz-linear-gradient(to left, #00acac 0%, #32a932 100%);
  background: -webkit-linear-gradient(to left, #00acac 0%, #32a932 100%);
  background: linear-gradient(to left, #00acac 0%, #32a932 100%);
}

.bg-gradient-teal-green-diagonal-down,
.bg-gradient-teal-green-diagonal-up,
.bg-gradient-teal-green-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-teal-green-diagonal-down {
  background: -moz-linear-gradient(-45deg, #00acac 0%, #32a932 100%);
  background: -webkit-linear-gradient(-45deg, #00acac 0%, #32a932 100%);
  background: linear-gradient(-45deg, #00acac 0%, #32a932 100%);
}

.bg-gradient-teal-green-diagonal-up {
  background: -moz-linear-gradient(45deg, #00acac 0%, #32a932 100%);
  background: -webkit-linear-gradient(45deg, #00acac 0%, #32a932 100%);
  background: linear-gradient(45deg, #00acac 0%, #32a932 100%);
}

.bg-gradient-yellow-green,
.bg-gradient-yellow-green-diagonal-down,
.bg-gradient-yellow-green-diagonal-up,
.bg-gradient-yellow-green-to-right {
  background: #ffd900;
}

.bg-gradient-yellow-green {
  background: -moz-linear-gradient(to bottom, #ffd900 0%, #32a932 100%);
  background: -webkit-linear-gradient(to bottom, #ffd900 0%, #32a932 100%);
  background: linear-gradient(to bottom, #ffd900 0%, #32a932 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-yellow-green-to-right,
.bg-gradient-yellow-green-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-yellow-green-to-right {
  background: -moz-linear-gradient(to right, #ffd900 0%, #32a932 100%);
  background: -webkit-linear-gradient(to right, #ffd900 0%, #32a932 100%);
  background: linear-gradient(to right, #ffd900 0%, #32a932 100%);
}

.bg-gradient-yellow-green-to-top {
  background: -moz-linear-gradient(to top, #ffd900 0%, #32a932 100%);
  background: -webkit-linear-gradient(to top, #ffd900 0%, #32a932 100%);
  background: linear-gradient(to top, #ffd900 0%, #32a932 100%);
}

.bg-gradient-yellow-green-to-left {
  background: -moz-linear-gradient(to left, #ffd900 0%, #32a932 100%);
  background: -webkit-linear-gradient(to left, #ffd900 0%, #32a932 100%);
  background: linear-gradient(to left, #ffd900 0%, #32a932 100%);
}

.bg-gradient-yellow-green-diagonal-down,
.bg-gradient-yellow-green-diagonal-up,
.bg-gradient-yellow-green-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-yellow-green-diagonal-down {
  background: -moz-linear-gradient(-45deg, #ffd900 0%, #32a932 100%);
  background: -webkit-linear-gradient(-45deg, #ffd900 0%, #32a932 100%);
  background: linear-gradient(-45deg, #ffd900 0%, #32a932 100%);
}

.bg-gradient-yellow-green-diagonal-up {
  background: -moz-linear-gradient(45deg, #ffd900 0%, #32a932 100%);
  background: -webkit-linear-gradient(45deg, #ffd900 0%, #32a932 100%);
  background: linear-gradient(45deg, #ffd900 0%, #32a932 100%);
}

.bg-gradient-blue-purple,
.bg-gradient-blue-purple-diagonal-down,
.bg-gradient-blue-purple-diagonal-up,
.bg-gradient-blue-purple-to-right {
  background: #348fe2;
}

.bg-gradient-blue-purple {
  background: -moz-linear-gradient(to bottom, #348fe2 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to bottom, #348fe2 0%, #727cb6 100%);
  background: linear-gradient(to bottom, #348fe2 0%, #727cb6 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-blue-purple-to-right,
.bg-gradient-blue-purple-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-blue-purple-to-right {
  background: -moz-linear-gradient(to right, #348fe2 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to right, #348fe2 0%, #727cb6 100%);
  background: linear-gradient(to right, #348fe2 0%, #727cb6 100%);
}

.bg-gradient-blue-purple-to-top {
  background: -moz-linear-gradient(to top, #348fe2 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to top, #348fe2 0%, #727cb6 100%);
  background: linear-gradient(to top, #348fe2 0%, #727cb6 100%);
}

.bg-gradient-blue-purple-to-left {
  background: -moz-linear-gradient(to left, #348fe2 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to left, #348fe2 0%, #727cb6 100%);
  background: linear-gradient(to left, #348fe2 0%, #727cb6 100%);
}

.bg-gradient-blue-purple-diagonal-down,
.bg-gradient-blue-purple-diagonal-up,
.bg-gradient-blue-purple-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-blue-purple-diagonal-down {
  background: -moz-linear-gradient(-45deg, #348fe2 0%, #727cb6 100%);
  background: -webkit-linear-gradient(-45deg, #348fe2 0%, #727cb6 100%);
  background: linear-gradient(-45deg, #348fe2 0%, #727cb6 100%);
}

.bg-gradient-blue-purple-diagonal-up {
  background: -moz-linear-gradient(45deg, #348fe2 0%, #727cb6 100%);
  background: -webkit-linear-gradient(45deg, #348fe2 0%, #727cb6 100%);
  background: linear-gradient(45deg, #348fe2 0%, #727cb6 100%);
}

.bg-gradient-cyan-blue,
.bg-gradient-cyan-blue-diagonal-down,
.bg-gradient-cyan-blue-diagonal-up,
.bg-gradient-cyan-blue-to-right {
  background: #49b6d6;
}

.bg-gradient-cyan-blue {
  background: -moz-linear-gradient(to bottom, #49b6d6 0%, #348fe2 100%);
  background: -webkit-linear-gradient(to bottom, #49b6d6 0%, #348fe2 100%);
  background: linear-gradient(to bottom, #49b6d6 0%, #348fe2 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-cyan-blue-to-right,
.bg-gradient-cyan-blue-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-cyan-blue-to-right {
  background: -moz-linear-gradient(to right, #49b6d6 0%, #348fe2 100%);
  background: -webkit-linear-gradient(to right, #49b6d6 0%, #348fe2 100%);
  background: linear-gradient(to right, #49b6d6 0%, #348fe2 100%);
}

.bg-gradient-cyan-blue-to-top {
  background: -moz-linear-gradient(to top, #49b6d6 0%, #348fe2 100%);
  background: -webkit-linear-gradient(to top, #49b6d6 0%, #348fe2 100%);
  background: linear-gradient(to top, #49b6d6 0%, #348fe2 100%);
}

.bg-gradient-cyan-blue-to-left {
  background: -moz-linear-gradient(to left, #49b6d6 0%, #348fe2 100%);
  background: -webkit-linear-gradient(to left, #49b6d6 0%, #348fe2 100%);
  background: linear-gradient(to left, #49b6d6 0%, #348fe2 100%);
}

.bg-gradient-cyan-blue-diagonal-down,
.bg-gradient-cyan-blue-diagonal-up,
.bg-gradient-cyan-blue-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-cyan-blue-diagonal-down {
  background: -moz-linear-gradient(-45deg, #49b6d6 0%, #348fe2 100%);
  background: -webkit-linear-gradient(-45deg, #49b6d6 0%, #348fe2 100%);
  background: linear-gradient(-45deg, #49b6d6 0%, #348fe2 100%);
}

.bg-gradient-cyan-blue-diagonal-up {
  background: -moz-linear-gradient(45deg, #49b6d6 0%, #348fe2 100%);
  background: -webkit-linear-gradient(45deg, #49b6d6 0%, #348fe2 100%);
  background: linear-gradient(45deg, #49b6d6 0%, #348fe2 100%);
}

.bg-gradient-cyan-purple,
.bg-gradient-cyan-purple-diagonal-down,
.bg-gradient-cyan-purple-diagonal-up,
.bg-gradient-cyan-purple-to-right {
  background: #49b6d6;
}

.bg-gradient-cyan-purple {
  background: -moz-linear-gradient(to bottom, #49b6d6 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to bottom, #49b6d6 0%, #727cb6 100%);
  background: linear-gradient(to bottom, #49b6d6 0%, #727cb6 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-cyan-purple-to-right,
.bg-gradient-cyan-purple-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-cyan-purple-to-right {
  background: -moz-linear-gradient(to right, #49b6d6 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to right, #49b6d6 0%, #727cb6 100%);
  background: linear-gradient(to right, #49b6d6 0%, #727cb6 100%);
}

.bg-gradient-cyan-purple-to-top {
  background: -moz-linear-gradient(to top, #49b6d6 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to top, #49b6d6 0%, #727cb6 100%);
  background: linear-gradient(to top, #49b6d6 0%, #727cb6 100%);
}

.bg-gradient-cyan-purple-to-left {
  background: -moz-linear-gradient(to left, #49b6d6 0%, #727cb6 100%);
  background: -webkit-linear-gradient(to left, #49b6d6 0%, #727cb6 100%);
  background: linear-gradient(to left, #49b6d6 0%, #727cb6 100%);
}

.bg-gradient-cyan-purple-diagonal-down,
.bg-gradient-cyan-purple-diagonal-up,
.bg-gradient-cyan-purple-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-cyan-purple-diagonal-down {
  background: -moz-linear-gradient(-45deg, #49b6d6 0%, #727cb6 100%);
  background: -webkit-linear-gradient(-45deg, #49b6d6 0%, #727cb6 100%);
  background: linear-gradient(-45deg, #49b6d6 0%, #727cb6 100%);
}

.bg-gradient-cyan-purple-diagonal-up {
  background: -moz-linear-gradient(45deg, #49b6d6 0%, #727cb6 100%);
  background: -webkit-linear-gradient(45deg, #49b6d6 0%, #727cb6 100%);
  background: linear-gradient(45deg, #49b6d6 0%, #727cb6 100%);
}

.bg-gradient-cyan-indigo,
.bg-gradient-cyan-indigo-diagonal-down,
.bg-gradient-cyan-indigo-diagonal-up,
.bg-gradient-cyan-indigo-to-right {
  background: #49b6d6;
}

.bg-gradient-cyan-indigo {
  background: -moz-linear-gradient(to bottom, #49b6d6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to bottom, #49b6d6 0%, #8753de 100%);
  background: linear-gradient(to bottom, #49b6d6 0%, #8753de 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-cyan-indigo-to-right,
.bg-gradient-cyan-indigo-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-cyan-indigo-to-right {
  background: -moz-linear-gradient(to right, #49b6d6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to right, #49b6d6 0%, #8753de 100%);
  background: linear-gradient(to right, #49b6d6 0%, #8753de 100%);
}

.bg-gradient-cyan-indigo-to-top {
  background: -moz-linear-gradient(to top, #49b6d6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to top, #49b6d6 0%, #8753de 100%);
  background: linear-gradient(to top, #49b6d6 0%, #8753de 100%);
}

.bg-gradient-cyan-indigo-to-left {
  background: -moz-linear-gradient(to left, #49b6d6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to left, #49b6d6 0%, #8753de 100%);
  background: linear-gradient(to left, #49b6d6 0%, #8753de 100%);
}

.bg-gradient-cyan-indigo-diagonal-down,
.bg-gradient-cyan-indigo-diagonal-up,
.bg-gradient-cyan-indigo-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-cyan-indigo-diagonal-down {
  background: -moz-linear-gradient(-45deg, #49b6d6 0%, #8753de 100%);
  background: -webkit-linear-gradient(-45deg, #49b6d6 0%, #8753de 100%);
  background: linear-gradient(-45deg, #49b6d6 0%, #8753de 100%);
}

.bg-gradient-cyan-indigo-diagonal-up {
  background: -moz-linear-gradient(45deg, #49b6d6 0%, #8753de 100%);
  background: -webkit-linear-gradient(45deg, #49b6d6 0%, #8753de 100%);
  background: linear-gradient(45deg, #49b6d6 0%, #8753de 100%);
}

.bg-gradient-blue-indigo,
.bg-gradient-blue-indigo-diagonal-down,
.bg-gradient-blue-indigo-diagonal-up,
.bg-gradient-blue-indigo-to-right {
  background: #348fe2;
}

.bg-gradient-blue-indigo {
  background: -moz-linear-gradient(to bottom, #348fe2 0%, #8753de 100%);
  background: -webkit-linear-gradient(to bottom, #348fe2 0%, #8753de 100%);
  background: linear-gradient(to bottom, #348fe2 0%, #8753de 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-blue-indigo-to-right,
.bg-gradient-blue-indigo-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-blue-indigo-to-right {
  background: -moz-linear-gradient(to right, #348fe2 0%, #8753de 100%);
  background: -webkit-linear-gradient(to right, #348fe2 0%, #8753de 100%);
  background: linear-gradient(to right, #348fe2 0%, #8753de 100%);
}

.bg-gradient-blue-indigo-to-top {
  background: -moz-linear-gradient(to top, #348fe2 0%, #8753de 100%);
  background: -webkit-linear-gradient(to top, #348fe2 0%, #8753de 100%);
  background: linear-gradient(to top, #348fe2 0%, #8753de 100%);
}

.bg-gradient-blue-indigo-to-left {
  background: -moz-linear-gradient(to left, #348fe2 0%, #8753de 100%);
  background: -webkit-linear-gradient(to left, #348fe2 0%, #8753de 100%);
  background: linear-gradient(to left, #348fe2 0%, #8753de 100%);
}

.bg-gradient-blue-indigo-diagonal-down,
.bg-gradient-blue-indigo-diagonal-up,
.bg-gradient-blue-indigo-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-blue-indigo-diagonal-down {
  background: -moz-linear-gradient(-45deg, #348fe2 0%, #8753de 100%);
  background: -webkit-linear-gradient(-45deg, #348fe2 0%, #8753de 100%);
  background: linear-gradient(-45deg, #348fe2 0%, #8753de 100%);
}

.bg-gradient-blue-indigo-diagonal-up {
  background: -moz-linear-gradient(45deg, #348fe2 0%, #8753de 100%);
  background: -webkit-linear-gradient(45deg, #348fe2 0%, #8753de 100%);
  background: linear-gradient(45deg, #348fe2 0%, #8753de 100%);
}

.bg-gradient-purple-indigo,
.bg-gradient-purple-indigo-diagonal-down,
.bg-gradient-purple-indigo-diagonal-up,
.bg-gradient-purple-indigo-to-right {
  background: #727cb6;
}

.bg-gradient-purple-indigo {
  background: -moz-linear-gradient(to bottom, #727cb6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to bottom, #727cb6 0%, #8753de 100%);
  background: linear-gradient(to bottom, #727cb6 0%, #8753de 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-purple-indigo-to-right,
.bg-gradient-purple-indigo-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-purple-indigo-to-right {
  background: -moz-linear-gradient(to right, #727cb6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to right, #727cb6 0%, #8753de 100%);
  background: linear-gradient(to right, #727cb6 0%, #8753de 100%);
}

.bg-gradient-purple-indigo-to-top {
  background: -moz-linear-gradient(to top, #727cb6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to top, #727cb6 0%, #8753de 100%);
  background: linear-gradient(to top, #727cb6 0%, #8753de 100%);
}

.bg-gradient-purple-indigo-to-left {
  background: -moz-linear-gradient(to left, #727cb6 0%, #8753de 100%);
  background: -webkit-linear-gradient(to left, #727cb6 0%, #8753de 100%);
  background: linear-gradient(to left, #727cb6 0%, #8753de 100%);
}

.bg-gradient-purple-indigo-diagonal-down,
.bg-gradient-purple-indigo-diagonal-up,
.bg-gradient-purple-indigo-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-purple-indigo-diagonal-down {
  background: -moz-linear-gradient(-45deg, #727cb6 0%, #8753de 100%);
  background: -webkit-linear-gradient(-45deg, #727cb6 0%, #8753de 100%);
  background: linear-gradient(-45deg, #727cb6 0%, #8753de 100%);
}

.bg-gradient-purple-indigo-diagonal-up {
  background: -moz-linear-gradient(45deg, #727cb6 0%, #8753de 100%);
  background: -webkit-linear-gradient(45deg, #727cb6 0%, #8753de 100%);
  background: linear-gradient(45deg, #727cb6 0%, #8753de 100%);
}

.bg-gradient-silver-black,
.bg-gradient-silver-black-diagonal-down,
.bg-gradient-silver-black-diagonal-up,
.bg-gradient-silver-black-to-right {
  background: #b6c2c9;
}

.bg-gradient-silver-black {
  background: -moz-linear-gradient(to bottom, #b6c2c9 0%, #000 100%);
  background: -webkit-linear-gradient(to bottom, #b6c2c9 0%, #000 100%);
  background: linear-gradient(to bottom, #b6c2c9 0%, #000 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=0);
}

.bg-gradient-silver-black-to-right,
.bg-gradient-silver-black-to-top {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-silver-black-to-right {
  background: -moz-linear-gradient(to right, #b6c2c9 0%, #000 100%);
  background: -webkit-linear-gradient(to right, #b6c2c9 0%, #000 100%);
  background: linear-gradient(to right, #b6c2c9 0%, #000 100%);
}

.bg-gradient-silver-black-to-top {
  background: -moz-linear-gradient(to top, #b6c2c9 0%, #000 100%);
  background: -webkit-linear-gradient(to top, #b6c2c9 0%, #000 100%);
  background: linear-gradient(to top, #b6c2c9 0%, #000 100%);
}

.bg-gradient-silver-black-to-left {
  background: -moz-linear-gradient(to left, #b6c2c9 0%, #000 100%);
  background: -webkit-linear-gradient(to left, #b6c2c9 0%, #000 100%);
  background: linear-gradient(to left, #b6c2c9 0%, #000 100%);
}

.bg-gradient-silver-black-diagonal-down,
.bg-gradient-silver-black-diagonal-up,
.bg-gradient-silver-black-to-left {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='\$from', endColorstr='\$to', GradientType=1);
}

.bg-gradient-silver-black-diagonal-down {
  background: -moz-linear-gradient(-45deg, #b6c2c9 0%, #000 100%);
  background: -webkit-linear-gradient(-45deg, #b6c2c9 0%, #000 100%);
  background: linear-gradient(-45deg, #b6c2c9 0%, #000 100%);
}

.bg-gradient-silver-black-diagonal-up {
  background: -moz-linear-gradient(45deg, #b6c2c9 0%, #000 100%);
  background: -webkit-linear-gradient(45deg, #b6c2c9 0%, #000 100%);
  background: linear-gradient(45deg, #b6c2c9 0%, #000 100%);
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.with-shadow {
  box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.1) !important;
}

.hide {
  display: none !important;
}

.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}

.img-rounded {
  border-radius: 0.375rem;
}

.img-circle {
  border-radius: 50%;
}

.valign-top {
  vertical-align: top !important;
}

.valign-bottom {
  vertical-align: bottom !important;
}

.valign-middle {
  vertical-align: middle !important;
}

.table-no-border-left tbody tr td,
.table-no-border-left tbody tr th,
.table-no-border-left thead tr td,
.table-no-border-left thead tr th {
  border-left: none;
}

.table-no-border-right tbody tr td,
.table-no-border-right tbody tr th,
.table-no-border-right thead tr td,
.table-no-border-right thead tr th {
  border-right: none;
}

.text-gradient {
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.row {
  margin-left: -10px;
  margin-right: -10px;
}

.row > [class^="col-"] {
  padding-left: 10px;
  padding-right: 10px;
}

.row.row-space-0 {
  margin-left: 0;
  margin-right: 0;
}

.row.row-space-2 {
  margin-left: -1px;
  margin-right: -1px;
}

.row.row-space-4 {
  margin-left: -2px;
  margin-right: -2px;
}

.row.row-space-6 {
  margin-left: -3px;
  margin-right: -3px;
}

.row.row-space-8 {
  margin-left: -4px;
  margin-right: -4px;
}

.row.row-space-10 {
  margin-left: -5px;
  margin-right: -5px;
}

.row.row-space-12 {
  margin-left: -6px;
  margin-right: -6px;
}

.row.row-space-14 {
  margin-left: -7px;
  margin-right: -7px;
}

.row.row-space-16 {
  margin-left: -8px;
  margin-right: -8px;
}

.row.row-space-18 {
  margin-left: -9px;
  margin-right: -9px;
}

.row.row-space-20 {
  margin-left: -10px;
  margin-right: -10px;
}

.row.row-space-22 {
  margin-left: -11px;
  margin-right: -11px;
}

.row.row-space-24 {
  margin-left: -12px;
  margin-right: -12px;
}

.row.row-space-26 {
  margin-left: -13px;
  margin-right: -13px;
}

.row.row-space-28 {
  margin-left: -14px;
  margin-right: -14px;
}

.row.row-space-30 {
  margin-left: -15px;
  margin-right: -15px;
}

.row.row-space-0 > [class^="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.row.row-space-2 > [class^="col-"] {
  padding-left: 1px;
  padding-right: 1px;
}

.row.row-space-4 > [class^="col-"] {
  padding-left: 2px;
  padding-right: 2px;
}

.row.row-space-6 > [class^="col-"] {
  padding-left: 3px;
  padding-right: 3px;
}

.row.row-space-8 > [class^="col-"] {
  padding-left: 4px;
  padding-right: 4px;
}

.row.row-space-10 > [class^="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}

.row.row-space-12 > [class^="col-"] {
  padding-left: 6px;
  padding-right: 6px;
}

.row.row-space-14 > [class^="col-"] {
  padding-left: 7px;
  padding-right: 7px;
}

.row.row-space-16 > [class^="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

.row.row-space-18 > [class^="col-"] {
  padding-left: 9px;
  padding-right: 9px;
}

.row.row-space-20 > [class^="col-"] {
  padding-left: 10px;
  padding-right: 10px;
}

.row.row-space-22 > [class^="col-"] {
  padding-left: 11px;
  padding-right: 11px;
}

.row.row-space-24 > [class^="col-"] {
  padding-left: 12px;
  padding-right: 12px;
}

.row.row-space-26 > [class^="col-"] {
  padding-left: 13px;
  padding-right: 13px;
}

.row.row-space-28 > [class^="col-"] {
  padding-left: 14px;
  padding-right: 14px;
}

.row.row-space-30 > [class^="col-"] {
  padding-left: 15px;
  padding-right: 15px;
}

.height-xs {
  height: 150px !important;
}

.height-sm {
  height: 300px !important;
}

.height-md {
  height: 450px !important;
}

.height-lg {
  height: 600px !important;
}

.height-full {
  height: 100% !important;
}

.height-0 {
  height: 0 !important;
}

.height-10 {
  height: 10px !important;
}

.height-20 {
  height: 20px !important;
}

.height-30 {
  height: 30px !important;
}

.height-40 {
  height: 40px !important;
}

.height-50 {
  height: 50px !important;
}

.height-60 {
  height: 60px !important;
}

.height-70 {
  height: 70px !important;
}

.height-80 {
  height: 80px !important;
}

.height-90 {
  height: 90px !important;
}

.height-100 {
  height: 100px !important;
}

.height-150 {
  height: 150px !important;
}

.height-200 {
  height: 200px !important;
}

.height-250 {
  height: 250px !important;
}

.height-300 {
  height: 300px !important;
}

.height-350 {
  height: 350px !important;
}

.height-400 {
  height: 400px !important;
}

.height-450 {
  height: 450px !important;
}

.height-500 {
  height: 500px !important;
}

.height-550 {
  height: 550px !important;
}

.height-600 {
  height: 600px !important;
}

.wrapper {
  padding: 15px;
}

.width-xs {
  width: 150px !important;
}

.width-sm {
  width: 300px !important;
}

.width-md {
  width: 450px !important;
}

.width-lg {
  width: 600px !important;
}

.width-full {
  width: 100% !important;
}

.width-0 {
  width: 0 !important;
}

.width-10 {
  width: 10px !important;
}

.width-20 {
  width: 20px !important;
}

.width-30 {
  width: 30px !important;
}

.width-40 {
  width: 40px !important;
}

.width-50 {
  width: 50px !important;
}

.width-60 {
  width: 60px !important;
}

.width-70 {
  width: 70px !important;
}

.width-80 {
  width: 80px !important;
}

.width-90 {
  width: 90px !important;
}

.width-100 {
  width: 100px !important;
}

.width-150 {
  width: 150px !important;
}

.width-200 {
  width: 200px !important;
}

.width-250 {
  width: 250px !important;
}

.width-300 {
  width: 300px !important;
}

.width-350 {
  width: 350px !important;
}

.width-400 {
  width: 400px !important;
}

.width-450 {
  width: 450px !important;
}

.width-500 {
  width: 500px !important;
}

.width-550 {
  width: 550px !important;
}

.width-600 {
  width: 600px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/default/app.min.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;IAC9D,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;;IAEE,yEAAyE;IACzE,iEAAiE;IACjE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,yEAAyE;IACzE,iEAAiE;IACjE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;IAC9D,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;;IAEE,yEAAyE;IACzE,iEAAiE;IACjE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,yEAAyE;IACzE,iEAAiE;IACjE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;;;IAGE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;;IAGE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;;;;;IAKE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;;;;IAIE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;;;;;IAKE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;;;;IAIE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kDAAkD;IAClD,0CAA0C;EAC5C;;EAEA;IACE,gDAAgD;IAChD,wCAAwC;EAC1C;;EAEA;IACE,kDAAkD;IAClD,0CAA0C;EAC5C;;EAEA;IACE,gDAAgD;IAChD,wCAAwC;EAC1C;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kDAAkD;IAClD,0CAA0C;EAC5C;;EAEA;IACE,gDAAgD;IAChD,wCAAwC;EAC1C;;EAEA;IACE,kDAAkD;IAClD,0CAA0C;EAC5C;;EAEA;IACE,gDAAgD;IAChD,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;;IAEE,uDAAuD;IACvD,+CAA+C;EACjD;;EAEA;;;;IAIE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;;;IAGE,uDAAuD;IACvD,+CAA+C;EACjD;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;;IAEE,uDAAuD;IACvD,+CAA+C;EACjD;;EAEA;;;;IAIE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;;;IAGE,uDAAuD;IACvD,+CAA+C;EACjD;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,uDAAuD;IACvD,+CAA+C;EACjD;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,uDAAuD;IACvD,+CAA+C;EACjD;AACF;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kDAAkD;IAClD,0CAA0C;EAC5C;;EAEA;IACE,gDAAgD;IAChD,wCAAwC;EAC1C;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;AACF;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kDAAkD;IAClD,0CAA0C;EAC5C;;EAEA;IACE,gDAAgD;IAChD,wCAAwC;EAC1C;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;;EAEA;IACE,sDAAsD;IACtD,8CAA8C;EAChD;;EAEA;IACE,wDAAwD;IACxD,gDAAgD;EAClD;AACF;;AAEA;EACE;;;IAGE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE;;;IAGE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE;;;;;;IAME,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;EACtB;AACF;;AAEA;EACE;;;;;;IAME,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;EACtB;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,sEAAsE;IACtE,8DAA8D;EAChE;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;;IAEE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;;IAEE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;;IAEE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;;IAEE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;;IAEE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;;IAEE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,4CAA4C;IAC5C,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6CAA6C;IAC7C,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE;qBACiB;IACjB,qEAAqE;IACrE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE;sBACkB;IAClB,0EAA0E;IAC1E,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE;sBACkB;IAClB,0EAA0E;IAC1E,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE;iCAC6B;IAC7B;mBACe;IACf,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,2EAA2E;IAC3E,mEAAmE;IACnE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE;qBACiB;IACjB,qEAAqE;IACrE,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE;sBACkB;IAClB,0EAA0E;IAC1E,2CAA2C;IAC3C,mCAAmC;EACrC;;EAEA;IACE;sBACkB;IAClB,0EAA0E;IAC1E,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE;iCAC6B;IAC7B;mBACe;IACf,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,2EAA2E;IAC3E,mEAAmE;IACnE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,0CAA0C;IAC1C,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,0CAA0C;IAC1C,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,0CAA0C;IAC1C,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,0CAA0C;IAC1C,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,0CAA0C;IAC1C,kCAAkC;EACpC;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;EAC9C;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,qDAAqD;IACrD,6CAA6C;IAC7C,UAAU;EACZ;;EAEA;IACE,oDAAoD;IACpD,4CAA4C;IAC5C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wDAAwD;IACxD,gDAAgD;IAChD,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wDAAwD;IACxD,gDAAgD;IAChD,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,uDAAuD;IACvD,+CAA+C;IAC/C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,uDAAuD;IACvD,+CAA+C;IAC/C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;IACxB,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;IACxB,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;EACxC;;EAEA;;IAEE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;EACxC;;EAEA;;IAEE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;EACxC;;EAEA;;IAEE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;EACxC;;EAEA;;IAEE,gCAAgC;IAChC,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,8CAA8C;IAC9C,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;IACnC,uCAAuC;IACvC,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;IACnC,uCAAuC;IACvC,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2DAA2D;IAC3D,mDAAmD;EACrD;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2DAA2D;IAC3D,mDAAmD;EACrD;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yDAAyD;IACzD,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yDAAyD;IACzD,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;IAChE,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,mEAAmE;IACnE,2DAA2D;IAC3D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;EACjE;;EAEA;IACE,UAAU;IACV,wDAAwD;IACxD,gDAAgD;IAChD,qCAAqC;IACrC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;EACjE;;EAEA;IACE,UAAU;IACV,wDAAwD;IACxD,gDAAgD;IAChD,qCAAqC;IACrC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;EAClE;;EAEA;IACE,UAAU;IACV,uDAAuD;IACvD,+CAA+C;IAC/C,sCAAsC;IACtC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;IACV,wEAAwE;IACxE,gEAAgE;EAClE;;EAEA;IACE,UAAU;IACV,uDAAuD;IACvD,+CAA+C;IAC/C,sCAAsC;IACtC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,uEAAuE;IACvE,+DAA+D;IAC/D,yEAAyE;IACzE,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,oEAAoE;IACpE,4DAA4D;IAC5D,uCAAuC;IACvC,+BAA+B;IAC/B,sEAAsE;IACtE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,mCAAmC;EACrC;AACF;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;EACxB,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;EAIE,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;EAGE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;IACE,0CAA0C;IAC1C,kCAAkC;IAClC,2CAA2C;IAC3C,mCAAmC;IACnC,+CAA+C;IAC/C,uCAAuC;EACzC;AACF;;AAEA;;;EAGE;AACF;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;AACF;;AAEA;;;;;;EAME,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,sEAAsE;EACtE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,sEAAsE;EACtE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,sEAAsE;EACtE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,gFAAgF;EAChF,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;;EAGE,gFAAgF;AAClF;;AAEA;;EAEE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;;;EAME,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4CAAuC;EACvC;;;;yDAI8D;AAChE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4CAAwC;EACxC;;;;0DAI+D;AACjE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAsC;EACtC;;;;0DAI6D;AAC/D;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;oEAIoE;;AAEpE;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0DAAqG;AACvG;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,MAAM;EACN,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oDAAuzE;EACvzE,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;;;EAME,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,0DAAyD;AAC3D;;AAEA;;;;EAIE,0DAAyD;AAC3D;;AAEA;;EAEE,0DAAyD;AAC3D;;AAEA;;EAEE,0DAAyD;AAC3D;;AAEA;;EAEE,0DAAyD;AAC3D;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,UAAU;EACV,kDAAkD;EAClD,+CAA+C;EAC/C,8CAA8C;EAC9C,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,kDAAkD;EAClD,iDAAiD;EACjD,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;;;EAGE;AACF;;;;;EAKE;AACF;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB;;gFAE8E;EAC9E;+CAC6C;AAC/C;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,wCAAwC;EACxC,YAAY;AACd;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,SAAS;EACT,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE;4BAC0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;EAYE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;EAaE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkGE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,iCAAiC;EACjC,0DAA4P;EAC5P,4BAA4B;EAC5B,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,0EAA0E;AAC5E;;AAEA;;EAEE,qBAAqB;EACrB,mDAAmD;EACnD;;;;wBAIsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,iCAAiC;EACjC,0DAAsS;EACtS,4BAA4B;EAC5B,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,0EAA0E;AAC5E;;AAEA;;EAEE,qBAAqB;EACrB,mDAAmD;EACnD;;;;wBAIsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE;;IAEE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;gEAC8D;AAChE;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;;;EAME,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;;;EAME,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;;;;;;;EAUE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAAgN;AAClN;;AAEA;;;EAGE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,0DAA6J;AAC/J;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAA0J;AAC5J;;AAEA;;;;;;EAME,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB;gEAC8D;AAChE;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB;2CACyC;EACzC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB;gCAC8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB;gCAC8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB;gCAC8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE;gCAC8B;AAChC;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,0DAAsP;AACxP;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,0DAA4P;AAC9P;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;EAWE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,aAAa;AACf;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd;gEAC8D;AAChE;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;;;;GASC;EACD,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,4BAA4B;EAC5B,oCAAoC;EACpC,gDAAgD;EAChD,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,2CAA2C;EAC3C,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,MAAM;EACN,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,MAAM;AACR;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,SAAS;EACT,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,MAAM;EACN,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;;EAEE,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,UAAU;EACV,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,0DAAsM;AACxM;;AAEA;EACE,0DAAsM;AACxM;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,qCAAqC;EACrC,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE,oCAAoC;AACtC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;EAYE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,aAAa;AACf;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;uCACqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;;;IAGE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;;;IAGE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;;;;IAIE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;EAClC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;;;;;;;;EAQE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,qBAAqB;IACrB,+BAA+B;EACjC;AACF;;AAEA;;;;;;;EAOE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,2CAA2C;EAC3C,wCAAwC;EACxC,uCAAuC;EACvC,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,OAAO;EACT;;EAEA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;;;;;;;;;;EAWE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,wEAAwE;EACxE,qEAAqE;EACrE,mEAAmE;EACnE,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oDAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;EAME,UAAU;EACV,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;EAIE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,oDAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE;IACE,SAAS;IACT,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,iDAAiD;EACjD,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;EACE,QAAQ;EACR,kDAAkD;EAClD,+CAA+C;EAC/C,8CAA8C;EAC9C,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,0DAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,OAAO;IACP,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;;GAGG;;AAEH;EACE;;IAEE,eAAe;IACf,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;;;;;;IAME,QAAQ;IACR,UAAU;IACV,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,mCAAmC;EACrC;;EAEA;;IAEE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;;;;;;;;;;;EAYE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE;;IAEE,OAAO;IACP,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,UAAU;IACV,QAAQ;IACR,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,mCAAmC;EACrC;;EAEA;;IAEE,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,OAAO;IACP,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,kCAAkC;EACpC;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwgCE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;;EAIE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;EAKE,YAAY;EACZ,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,OAAO;EACT;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE;;IAEE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;IAIE,UAAU;IACV,QAAQ;IACR,+CAA+C;IAC/C,4CAA4C;IAC5C,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC;EACzC;AACF;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,OAAO;IACP,8CAA8C;IAC9C,2CAA2C;IAC3C,0CAA0C;IAC1C,yCAAyC;IACzC,sCAAsC;EACxC;;EAEA;;;IAGE,UAAU;IACV,QAAQ;IACR,+CAA+C;IAC/C,4CAA4C;IAC5C,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC;EACzC;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0DAA0N;EAC1N,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gEAAgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,oDAAuC;EACvC,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;;;;;EAME,+CAA+C;AACjD;;AAEA;;;;;;EAME,eAAe;EACf,WAAW;AACb;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;;;;;;EAME,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD,sHAAsH;EACtH,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,8CAA8C;EAC9C,aAAa;EACb,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0DAAoD;AACtD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,2CAA2C;EAC3C,uCAAuC;EACvC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;;;;;IAME,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,OAAO;IACP,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,gEAAgE;EAChE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;;;;EAKE,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,8BAA8B;EAC9B,gEAAgE;EAChE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,uDAAuD;EACvD,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,OAAO;EACP,YAAY;EACZ,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;EACN,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,uEAAuE;EACvE,0EAA0E;EAC1E,iEAAiE;EACjE,oHAAoH;AACtH;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE;;;;GAIC;AACH;;AAEA;;;EAGE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,OAAO;IACP,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;;;IAGE,UAAU;EACZ;AACF;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgGE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,2BAA2B;EAC3B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;;;EAIE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,OAAO;EACP,YAAY;EACZ,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;EACN,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,uEAAuE;EACvE,0EAA0E;EAC1E,iEAAiE;EACjE,oHAAoH;AACtH;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;EACf;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,gDAAgD;EAChD,6CAA6C;EAC7C,4CAA4C;EAC5C,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,wBAAwB;EACxB,UAAU;EACV,mDAAmD;EACnD,2CAA2C;EAC3C,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;;EAGE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0CE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;;;EAME,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,yCAAyC;EACzC,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,4BAA4B;EAC5B,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;;;;;;;EAOE,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;AAClC;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;;;;;;;;EASE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;EAEE,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;EAIE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;;;;;;;;;EASE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,sDAAsD;EACtD,8CAA8C;EAC9C,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;;;;;;EAQE,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+NE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqPE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2OE,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsdE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAisBE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4CE,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4CE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwKE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;EAgBE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwME,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsDE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,qBAAqB;EACrB,UAAU;EACV,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;EACE,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,6BAA6B;EAC7B,4DAA4D;EAC5D,oDAAoD;AACtD;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;;;;EAOE,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;;;;;;EAaE,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,kCAAkC;EAClC,0BAA0B;EAC1B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;;;;;;;EAaE,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;EAgBE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAs7CE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,UAAU;EACV,WAAW;EACX,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,mCAAmC;EACnC,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;EAWE,8BAA8B;AAChC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;;;;;;;;;EAUE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;;;;EAUE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuOE,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwGE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0ZE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6EE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6EE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6EE,8BAA8B;EAC9B,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;;;;EAKE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;EAKE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;EAME,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6EE,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,UAAU;EACV,qBAAqB;EACrB,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;;;;;;;;EAQE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;;;;;;;EAQE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;EAgBE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;;EAQE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgJE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+YE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;EASE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;;;EAQE,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;EAgBE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,SAAS;AACX;;AAEA;;;;;;;;;EASE,UAAU;EACV,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,MAAM;AACR;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;EAIE,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0cE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0EE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;;;EAME,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;;;;;EAKE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;;;;;IAKE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;IAKE,WAAW;EACb;AACF;;AAEA;;;;;EAKE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;;;;;IAKE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;;;;;EAKE,UAAU;EACV,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE;;;;;IAKE,WAAW;EACb;AACF;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,cAAc;EACd,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;EAME,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;EAKE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,MAAM;EACN,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;EACzC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;;;EAGE,gBAAgB;EAChB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;EACV,OAAO;EACP,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,kDAAkD;EAClD,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;EACT,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAyEE,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,kDAAkD;EAClD,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;;EAGE,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,IAAI;AACN;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,qDAAqD;EACrD,kDAAkD;EAClD,iDAAiD;EACjD,gDAAgD;EAChD,6CAA6C;EAC7C,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,QAAQ;EACR,WAAW;EACX,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;;;;;;EAME,0BAA0B;EAC1B,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,MAAM;EACN,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,yDAAyD;EACzD,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;;;;;;;;EAQE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;;;;;;EAUE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;;;;;;;EAUE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;EAIE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;;;;;EAKE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;;;;EAKE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,iEAAiE;EACjE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,OAAO;EACP,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;;EAQE,+BAA+B;AACjC;;AAEA;;;;;;;;;EASE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;;;;;;;;EASE,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;;;EAQE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;;;;;;EAOE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgJE,kBAAkB;EAClB,aAAa;EACb,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgJE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsYE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,UAAU;EACV,qBAAqB;EACrB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,yDAAyD;EACzD,iDAAiD;AACnD;;AAEA;;;;;;;EAOE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;;;;EAOE,SAAS;EACT,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;;;;;;;;EAQE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;EAcE,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;EAME,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;GAIG;;AAEH;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;AAC7E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,2BAA2B;EAC3B;;;;cAIY;EACZ;;;;cAIY;EACZ,wEAAwE;EACxE,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;EAC3B;;;;cAIY;EACZ;;;;cAIY;EACZ,wEAAwE;EACxE,qJAAqJ;AACvJ;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,wEAAwE;EACxE,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B;;;;cAIY;EACZ;;;;cAIY;EACZ,2EAA2E;EAC3E,qJAAqJ;AACvJ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,wEAAwE;EACxE,gEAAgE;EAChE,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;EACtE,8DAA8D;AAChE;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;AAC/D;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,qEAAqE;EACrE,6DAA6D;EAC7D,4GAA4G;AAC9G;;AAEA;;EAEE,4GAA4G;AAC9G;;AAEA;EACE,iEAAiE;EACjE,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA;EACE,+DAA+D;EAC/D,kEAAkE;EAClE,0DAA0D;AAC5D;;AAEA;EACE,gEAAgE;EAChE,mEAAmE;EACnE,2DAA2D;AAC7D;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE,+DAA+D;EAC/D,kEAAkE;EAClE,0DAA0D;AAC5D;;AAEA;EACE,8DAA8D;EAC9D,iEAAiE;EACjE,yDAAyD;AAC3D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/*!\n * animate.css -https://daneden.github.io/animate.css/\n * Version - 3.7.2\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2019 Daniel Eden\n */\n@-webkit-keyframes bounce {\n  0%,\n  20%,\n  53%,\n  80%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  40%,\n  43% {\n    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -30px, 0);\n    transform: translate3d(0, -30px, 0);\n  }\n\n  70% {\n    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -15px, 0);\n    transform: translate3d(0, -15px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -4px, 0);\n    transform: translate3d(0, -4px, 0);\n  }\n}\n\n@keyframes bounce {\n  0%,\n  20%,\n  53%,\n  80%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  40%,\n  43% {\n    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -30px, 0);\n    transform: translate3d(0, -30px, 0);\n  }\n\n  70% {\n    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    -webkit-transform: translate3d(0, -15px, 0);\n    transform: translate3d(0, -15px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -4px, 0);\n    transform: translate3d(0, -4px, 0);\n  }\n}\n\n@-webkit-keyframes flash {\n  0%,\n  50%,\n  to {\n    opacity: 1;\n  }\n\n  25%,\n  75% {\n    opacity: 0;\n  }\n}\n\n@keyframes flash {\n  0%,\n  50%,\n  to {\n    opacity: 1;\n  }\n\n  25%,\n  75% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes pulse {\n  0%,\n  to {\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  50% {\n    -webkit-transform: scale3d(1.05, 1.05, 1.05);\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  to {\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  50% {\n    -webkit-transform: scale3d(1.05, 1.05, 1.05);\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n}\n\n@-webkit-keyframes rubberBand {\n  0%,\n  to {\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  30% {\n    -webkit-transform: scale3d(1.25, 0.75, 1);\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.75, 1.25, 1);\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    -webkit-transform: scale3d(1.15, 0.85, 1);\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    -webkit-transform: scale3d(0.95, 1.05, 1);\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    -webkit-transform: scale3d(1.05, 0.95, 1);\n    transform: scale3d(1.05, 0.95, 1);\n  }\n}\n\n@keyframes rubberBand {\n  0%,\n  to {\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  30% {\n    -webkit-transform: scale3d(1.25, 0.75, 1);\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.75, 1.25, 1);\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    -webkit-transform: scale3d(1.15, 0.85, 1);\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    -webkit-transform: scale3d(0.95, 1.05, 1);\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    -webkit-transform: scale3d(1.05, 0.95, 1);\n    transform: scale3d(1.05, 0.95, 1);\n  }\n}\n\n@-webkit-keyframes shake {\n  0%,\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  0%,\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@-webkit-keyframes headShake {\n  0%,\n  50% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  6.5% {\n    -webkit-transform: translateX(-6px) rotateY(-9deg);\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n\n  18.5% {\n    -webkit-transform: translateX(5px) rotateY(7deg);\n    transform: translateX(5px) rotateY(7deg);\n  }\n\n  31.5% {\n    -webkit-transform: translateX(-3px) rotateY(-5deg);\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n\n  43.5% {\n    -webkit-transform: translateX(2px) rotateY(3deg);\n    transform: translateX(2px) rotateY(3deg);\n  }\n}\n\n@keyframes headShake {\n  0%,\n  50% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  6.5% {\n    -webkit-transform: translateX(-6px) rotateY(-9deg);\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n\n  18.5% {\n    -webkit-transform: translateX(5px) rotateY(7deg);\n    transform: translateX(5px) rotateY(7deg);\n  }\n\n  31.5% {\n    -webkit-transform: translateX(-3px) rotateY(-5deg);\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n\n  43.5% {\n    -webkit-transform: translateX(2px) rotateY(3deg);\n    transform: translateX(2px) rotateY(3deg);\n  }\n}\n\n@-webkit-keyframes swing {\n  20% {\n    -webkit-transform: rotate(15deg);\n    transform: rotate(15deg);\n  }\n\n  40% {\n    -webkit-transform: rotate(-10deg);\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    -webkit-transform: rotate(5deg);\n    transform: rotate(5deg);\n  }\n\n  80% {\n    -webkit-transform: rotate(-5deg);\n    transform: rotate(-5deg);\n  }\n\n  to {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n}\n\n@keyframes swing {\n  20% {\n    -webkit-transform: rotate(15deg);\n    transform: rotate(15deg);\n  }\n\n  40% {\n    -webkit-transform: rotate(-10deg);\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    -webkit-transform: rotate(5deg);\n    transform: rotate(5deg);\n  }\n\n  80% {\n    -webkit-transform: rotate(-5deg);\n    transform: rotate(-5deg);\n  }\n\n  to {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n}\n\n@-webkit-keyframes tada {\n  0%,\n  to {\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  10%,\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);\n    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);\n  }\n\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n\n  40%,\n  60%,\n  80% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n}\n\n@keyframes tada {\n  0%,\n  to {\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  10%,\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);\n    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);\n  }\n\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n\n  40%,\n  60%,\n  80% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n}\n\n@-webkit-keyframes wobble {\n  0%,\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);\n    transform: translate3d(-25%, 0, 0) rotate(-5deg);\n  }\n\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);\n    transform: translate3d(20%, 0, 0) rotate(3deg);\n  }\n\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);\n    transform: translate3d(-15%, 0, 0) rotate(-3deg);\n  }\n\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);\n    transform: translate3d(10%, 0, 0) rotate(2deg);\n  }\n\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);\n    transform: translate3d(-5%, 0, 0) rotate(-1deg);\n  }\n}\n\n@keyframes wobble {\n  0%,\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);\n    transform: translate3d(-25%, 0, 0) rotate(-5deg);\n  }\n\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);\n    transform: translate3d(20%, 0, 0) rotate(3deg);\n  }\n\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);\n    transform: translate3d(-15%, 0, 0) rotate(-3deg);\n  }\n\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);\n    transform: translate3d(10%, 0, 0) rotate(2deg);\n  }\n\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);\n    transform: translate3d(-5%, 0, 0) rotate(-1deg);\n  }\n}\n\n@-webkit-keyframes jello {\n  0%,\n  11.1%,\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  22.2% {\n    -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n\n  33.3% {\n    -webkit-transform: skewX(6.25deg) skewY(6.25deg);\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n\n  44.4% {\n    -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n\n  55.5% {\n    -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n\n  66.6% {\n    -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n\n  77.7% {\n    -webkit-transform: skewX(0.39062deg) skewY(0.39062deg);\n    transform: skewX(0.39062deg) skewY(0.39062deg);\n  }\n\n  88.8% {\n    -webkit-transform: skewX(-0.19531deg) skewY(-0.19531deg);\n    transform: skewX(-0.19531deg) skewY(-0.19531deg);\n  }\n}\n\n@keyframes jello {\n  0%,\n  11.1%,\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  22.2% {\n    -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n\n  33.3% {\n    -webkit-transform: skewX(6.25deg) skewY(6.25deg);\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n\n  44.4% {\n    -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n\n  55.5% {\n    -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n\n  66.6% {\n    -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n\n  77.7% {\n    -webkit-transform: skewX(0.39062deg) skewY(0.39062deg);\n    transform: skewX(0.39062deg) skewY(0.39062deg);\n  }\n\n  88.8% {\n    -webkit-transform: skewX(-0.19531deg) skewY(-0.19531deg);\n    transform: skewX(-0.19531deg) skewY(-0.19531deg);\n  }\n}\n\n@-webkit-keyframes heartBeat {\n  0%,\n  28%,\n  70% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  14%,\n  42% {\n    -webkit-transform: scale(1.3);\n    transform: scale(1.3);\n  }\n}\n\n@keyframes heartBeat {\n  0%,\n  28%,\n  70% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  14%,\n  42% {\n    -webkit-transform: scale(1.3);\n    transform: scale(1.3);\n  }\n}\n\n@-webkit-keyframes bounceIn {\n  0%,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.03, 1.03, 1.03);\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    -webkit-transform: scale3d(0.97, 0.97, 0.97);\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n}\n\n@keyframes bounceIn {\n  0%,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.03, 1.03, 1.03);\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    -webkit-transform: scale3d(0.97, 0.97, 0.97);\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n}\n\n@-webkit-keyframes bounceInDown {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -3000px, 0);\n    transform: translate3d(0, -3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 25px, 0);\n    transform: translate3d(0, 25px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, 5px, 0);\n    transform: translate3d(0, 5px, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes bounceInDown {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -3000px, 0);\n    transform: translate3d(0, -3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 25px, 0);\n    transform: translate3d(0, 25px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, 5px, 0);\n    transform: translate3d(0, 5px, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes bounceInLeft {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-3000px, 0, 0);\n    transform: translate3d(-3000px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(25px, 0, 0);\n    transform: translate3d(25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n    transform: translate3d(5px, 0, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes bounceInLeft {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-3000px, 0, 0);\n    transform: translate3d(-3000px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(25px, 0, 0);\n    transform: translate3d(25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n    transform: translate3d(5px, 0, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes bounceInRight {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(3000px, 0, 0);\n    transform: translate3d(3000px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n    transform: translate3d(-5px, 0, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes bounceInRight {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(3000px, 0, 0);\n    transform: translate3d(3000px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n    transform: translate3d(-5px, 0, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes bounceInUp {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes bounceInUp {\n  0%,\n  60%,\n  75%,\n  90%,\n  to {\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes bounceOut {\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%,\n  55% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n\n@keyframes bounceOut {\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%,\n  55% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n\n@-webkit-keyframes bounceOutDown {\n  20% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n@keyframes bounceOutDown {\n  20% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n@-webkit-keyframes bounceOutLeft {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(20px, 0, 0);\n    transform: translate3d(20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n\n@keyframes bounceOutLeft {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(20px, 0, 0);\n    transform: translate3d(20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n\n@-webkit-keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(-20px, 0, 0);\n    transform: translate3d(-20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n@keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(-20px, 0, 0);\n    transform: translate3d(-20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n@-webkit-keyframes bounceOutUp {\n  20% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 20px, 0);\n    transform: translate3d(0, 20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@keyframes bounceOutUp {\n  20% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 20px, 0);\n    transform: translate3d(0, 20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutDownBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n@keyframes fadeOutDownBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n\n@keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutRightBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n@keyframes fadeOutRightBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@-webkit-keyframes fadeOutUpBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@keyframes fadeOutUpBig {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@-webkit-keyframes flip {\n  0% {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(0)\n      rotateY(-1turn);\n    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)\n      rotateY(-190deg);\n    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)\n      rotateY(-170deg);\n    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95)\n      translateZ(0) rotateY(0deg);\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translateZ(0)\n      rotateY(0deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);\n    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n}\n\n@keyframes flip {\n  0% {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(0)\n      rotateY(-1turn);\n    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)\n      rotateY(-190deg);\n    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(150px)\n      rotateY(-170deg);\n    transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95)\n      translateZ(0) rotateY(0deg);\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translateZ(0)\n      rotateY(0deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    -webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);\n    transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n}\n\n@-webkit-keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) rotateX(-5deg);\n    transform: perspective(400px) rotateX(-5deg);\n  }\n\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n\n@keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) rotateX(-5deg);\n    transform: perspective(400px) rotateX(-5deg);\n  }\n\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n\n@-webkit-keyframes flipInY {\n  0% {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) rotateY(-20deg);\n    transform: perspective(400px) rotateY(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    -webkit-transform: perspective(400px) rotateY(10deg);\n    transform: perspective(400px) rotateY(10deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) rotateY(-5deg);\n    transform: perspective(400px) rotateY(-5deg);\n  }\n\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n\n@keyframes flipInY {\n  0% {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) rotateY(-20deg);\n    transform: perspective(400px) rotateY(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    -webkit-transform: perspective(400px) rotateY(10deg);\n    transform: perspective(400px) rotateY(10deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) rotateY(-5deg);\n    transform: perspective(400px) rotateY(-5deg);\n  }\n\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n\n@-webkit-keyframes flipOutX {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n\n  30% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes flipOutX {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n\n  30% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes flipOutY {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n\n  30% {\n    -webkit-transform: perspective(400px) rotateY(-15deg);\n    transform: perspective(400px) rotateY(-15deg);\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes flipOutY {\n  0% {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n\n  30% {\n    -webkit-transform: perspective(400px) rotateY(-15deg);\n    transform: perspective(400px) rotateY(-15deg);\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n\n  60% {\n    -webkit-transform: skewX(20deg);\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: skewX(-5deg);\n    transform: skewX(-5deg);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n\n  60% {\n    -webkit-transform: skewX(20deg);\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: skewX(-5deg);\n    transform: skewX(-5deg);\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes lightSpeedOut {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n    transform: translate3d(100%, 0, 0) skewX(30deg);\n    opacity: 0;\n  }\n}\n\n@keyframes lightSpeedOut {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\n    transform: translate3d(100%, 0, 0) skewX(30deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate(-200deg);\n    transform: rotate(-200deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate(-200deg);\n    transform: rotate(-200deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes rotateInDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@keyframes rotateInDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes rotateInDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@keyframes rotateInDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes rotateInUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@keyframes rotateInUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes rotateInUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@keyframes rotateInUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes rotateOut {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate(200deg);\n    transform: rotate(200deg);\n    opacity: 0;\n  }\n}\n\n@keyframes rotateOut {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate(200deg);\n    transform: rotate(200deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes rotateOutDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n}\n\n@keyframes rotateOutDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes rotateOutDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n\n@keyframes rotateOutDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes rotateOutUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n\n@keyframes rotateOutUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes rotateOutUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes rotateOutUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes hinge {\n  0% {\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n  }\n\n  20%,\n  60% {\n    -webkit-transform: rotate(80deg);\n    transform: rotate(80deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n  }\n\n  40%,\n  80% {\n    -webkit-transform: rotate(60deg);\n    transform: rotate(60deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: translate3d(0, 700px, 0);\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n}\n\n@keyframes hinge {\n  0% {\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n  }\n\n  20%,\n  60% {\n    -webkit-transform: rotate(80deg);\n    transform: rotate(80deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n  }\n\n  40%,\n  80% {\n    -webkit-transform: rotate(60deg);\n    transform: rotate(60deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    -webkit-transform: translate3d(0, 700px, 0);\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes jackInTheBox {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.1) rotate(30deg);\n    transform: scale(0.1) rotate(30deg);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n  }\n\n  50% {\n    -webkit-transform: rotate(-10deg);\n    transform: rotate(-10deg);\n  }\n\n  70% {\n    -webkit-transform: rotate(3deg);\n    transform: rotate(3deg);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes jackInTheBox {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.1) rotate(30deg);\n    transform: scale(0.1) rotate(30deg);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n  }\n\n  50% {\n    -webkit-transform: rotate(-10deg);\n    transform: rotate(-10deg);\n  }\n\n  70% {\n    -webkit-transform: rotate(3deg);\n    transform: rotate(3deg);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@-webkit-keyframes rollIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);\n    transform: translate3d(-100%, 0, 0) rotate(-120deg);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes rollIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);\n    transform: translate3d(-100%, 0, 0) rotate(-120deg);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes rollOut {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0) rotate(120deg);\n    transform: translate3d(100%, 0, 0) rotate(120deg);\n  }\n}\n\n@keyframes rollOut {\n  0% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0) rotate(120deg);\n    transform: translate3d(100%, 0, 0) rotate(120deg);\n  }\n}\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes zoomInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@keyframes zoomInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@-webkit-keyframes zoomInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@keyframes zoomInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@-webkit-keyframes zoomInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@keyframes zoomInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@-webkit-keyframes zoomInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@keyframes zoomInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@-webkit-keyframes zoomOut {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes zoomOut {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes zoomOutDown {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@keyframes zoomOutDown {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@-webkit-keyframes zoomOutLeft {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n    -webkit-transform-origin: left center;\n    transform-origin: left center;\n  }\n}\n\n@keyframes zoomOutLeft {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n    -webkit-transform-origin: left center;\n    transform-origin: left center;\n  }\n}\n\n@-webkit-keyframes zoomOutRight {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n    -webkit-transform-origin: right center;\n    transform-origin: right center;\n  }\n}\n\n@keyframes zoomOutRight {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n    -webkit-transform-origin: right center;\n    transform-origin: right center;\n  }\n}\n\n@-webkit-keyframes zoomOutUp {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@keyframes zoomOutUp {\n  40% {\n    opacity: 1;\n    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    -webkit-transform-origin: center bottom;\n    transform-origin: center bottom;\n    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n\n@-webkit-keyframes slideInDown {\n  0% {\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes slideInDown {\n  0% {\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes slideInLeft {\n  0% {\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes slideInLeft {\n  0% {\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes slideInRight {\n  0% {\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes slideInRight {\n  0% {\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes slideInUp {\n  0% {\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes slideInUp {\n  0% {\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes slideOutDown {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes slideOutDown {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@-webkit-keyframes slideOutLeft {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes slideOutLeft {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@-webkit-keyframes slideOutRight {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes slideOutRight {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@-webkit-keyframes slideOutUp {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes slideOutUp {\n  0% {\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n\n  to {\n    visibility: hidden;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.bounce {\n  -webkit-animation-name: bounce;\n  animation-name: bounce;\n  -webkit-transform-origin: center bottom;\n  transform-origin: center bottom;\n}\n\n.flash {\n  -webkit-animation-name: flash;\n  animation-name: flash;\n}\n\n.pulse {\n  -webkit-animation-name: pulse;\n  animation-name: pulse;\n}\n\n.rubberBand {\n  -webkit-animation-name: rubberBand;\n  animation-name: rubberBand;\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n.headShake {\n  -webkit-animation-timing-function: ease-in-out;\n  animation-timing-function: ease-in-out;\n  -webkit-animation-name: headShake;\n  animation-name: headShake;\n}\n\n.swing {\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n  -webkit-animation-name: swing;\n  animation-name: swing;\n}\n\n.tada {\n  -webkit-animation-name: tada;\n  animation-name: tada;\n}\n\n.wobble {\n  -webkit-animation-name: wobble;\n  animation-name: wobble;\n}\n\n.jello {\n  -webkit-animation-name: jello;\n  animation-name: jello;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\n\n.heartBeat {\n  -webkit-animation-name: heartBeat;\n  animation-name: heartBeat;\n  -webkit-animation-duration: 1.3s;\n  animation-duration: 1.3s;\n  -webkit-animation-timing-function: ease-in-out;\n  animation-timing-function: ease-in-out;\n}\n\n.bounceIn {\n  -webkit-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-name: bounceIn;\n  animation-name: bounceIn;\n}\n\n.bounceInDown {\n  -webkit-animation-name: bounceInDown;\n  animation-name: bounceInDown;\n}\n\n.bounceInLeft {\n  -webkit-animation-name: bounceInLeft;\n  animation-name: bounceInLeft;\n}\n\n.bounceInRight {\n  -webkit-animation-name: bounceInRight;\n  animation-name: bounceInRight;\n}\n\n.bounceInUp {\n  -webkit-animation-name: bounceInUp;\n  animation-name: bounceInUp;\n}\n\n.bounceOut {\n  -webkit-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-name: bounceOut;\n  animation-name: bounceOut;\n}\n\n.bounceOutDown {\n  -webkit-animation-name: bounceOutDown;\n  animation-name: bounceOutDown;\n}\n\n.bounceOutLeft {\n  -webkit-animation-name: bounceOutLeft;\n  animation-name: bounceOutLeft;\n}\n\n.bounceOutRight {\n  -webkit-animation-name: bounceOutRight;\n  animation-name: bounceOutRight;\n}\n\n.bounceOutUp {\n  -webkit-animation-name: bounceOutUp;\n  animation-name: bounceOutUp;\n}\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n.fadeInDownBig {\n  -webkit-animation-name: fadeInDownBig;\n  animation-name: fadeInDownBig;\n}\n\n.fadeInLeft {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft;\n}\n\n.fadeInLeftBig {\n  -webkit-animation-name: fadeInLeftBig;\n  animation-name: fadeInLeftBig;\n}\n\n.fadeInRight {\n  -webkit-animation-name: fadeInRight;\n  animation-name: fadeInRight;\n}\n\n.fadeInRightBig {\n  -webkit-animation-name: fadeInRightBig;\n  animation-name: fadeInRightBig;\n}\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n}\n\n.fadeInUpBig {\n  -webkit-animation-name: fadeInUpBig;\n  animation-name: fadeInUpBig;\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n.fadeOutDownBig {\n  -webkit-animation-name: fadeOutDownBig;\n  animation-name: fadeOutDownBig;\n}\n\n.fadeOutLeft {\n  -webkit-animation-name: fadeOutLeft;\n  animation-name: fadeOutLeft;\n}\n\n.fadeOutLeftBig {\n  -webkit-animation-name: fadeOutLeftBig;\n  animation-name: fadeOutLeftBig;\n}\n\n.fadeOutRight {\n  -webkit-animation-name: fadeOutRight;\n  animation-name: fadeOutRight;\n}\n\n.fadeOutRightBig {\n  -webkit-animation-name: fadeOutRightBig;\n  animation-name: fadeOutRightBig;\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n\n.fadeOutUpBig {\n  -webkit-animation-name: fadeOutUpBig;\n  animation-name: fadeOutUpBig;\n}\n\n.animated.flip {\n  -webkit-backface-visibility: visible;\n  backface-visibility: visible;\n  -webkit-animation-name: flip;\n  animation-name: flip;\n}\n\n.flipInX,\n.flipInY,\n.flipOutX,\n.flipOutY {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInX;\n  animation-name: flipInX;\n}\n\n.flipInY,\n.flipOutX,\n.flipOutY {\n  -webkit-animation-name: flipInY;\n  animation-name: flipInY;\n}\n\n.flipOutX,\n.flipOutY {\n  -webkit-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-name: flipOutX;\n  animation-name: flipOutX;\n}\n\n.flipOutY {\n  -webkit-animation-name: flipOutY;\n  animation-name: flipOutY;\n}\n\n.lightSpeedIn {\n  -webkit-animation-name: lightSpeedIn;\n  animation-name: lightSpeedIn;\n  -webkit-animation-timing-function: ease-out;\n  animation-timing-function: ease-out;\n}\n\n.lightSpeedOut {\n  -webkit-animation-name: lightSpeedOut;\n  animation-name: lightSpeedOut;\n  -webkit-animation-timing-function: ease-in;\n  animation-timing-function: ease-in;\n}\n\n.rotateIn {\n  -webkit-animation-name: rotateIn;\n  animation-name: rotateIn;\n}\n\n.rotateInDownLeft {\n  -webkit-animation-name: rotateInDownLeft;\n  animation-name: rotateInDownLeft;\n}\n\n.rotateInDownRight {\n  -webkit-animation-name: rotateInDownRight;\n  animation-name: rotateInDownRight;\n}\n\n.rotateInUpLeft {\n  -webkit-animation-name: rotateInUpLeft;\n  animation-name: rotateInUpLeft;\n}\n\n.rotateInUpRight {\n  -webkit-animation-name: rotateInUpRight;\n  animation-name: rotateInUpRight;\n}\n\n.rotateOut {\n  -webkit-animation-name: rotateOut;\n  animation-name: rotateOut;\n}\n\n.rotateOutDownLeft {\n  -webkit-animation-name: rotateOutDownLeft;\n  animation-name: rotateOutDownLeft;\n}\n\n.rotateOutDownRight {\n  -webkit-animation-name: rotateOutDownRight;\n  animation-name: rotateOutDownRight;\n}\n\n.rotateOutUpLeft {\n  -webkit-animation-name: rotateOutUpLeft;\n  animation-name: rotateOutUpLeft;\n}\n\n.rotateOutUpRight {\n  -webkit-animation-name: rotateOutUpRight;\n  animation-name: rotateOutUpRight;\n}\n\n.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n  -webkit-animation-name: hinge;\n  animation-name: hinge;\n}\n\n.jackInTheBox {\n  -webkit-animation-name: jackInTheBox;\n  animation-name: jackInTheBox;\n}\n\n.rollIn {\n  -webkit-animation-name: rollIn;\n  animation-name: rollIn;\n}\n\n.rollOut {\n  -webkit-animation-name: rollOut;\n  animation-name: rollOut;\n}\n\n.zoomIn {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn;\n}\n\n.zoomInDown {\n  -webkit-animation-name: zoomInDown;\n  animation-name: zoomInDown;\n}\n\n.zoomInLeft {\n  -webkit-animation-name: zoomInLeft;\n  animation-name: zoomInLeft;\n}\n\n.zoomInRight {\n  -webkit-animation-name: zoomInRight;\n  animation-name: zoomInRight;\n}\n\n.zoomInUp {\n  -webkit-animation-name: zoomInUp;\n  animation-name: zoomInUp;\n}\n\n.zoomOut {\n  -webkit-animation-name: zoomOut;\n  animation-name: zoomOut;\n}\n\n.zoomOutDown {\n  -webkit-animation-name: zoomOutDown;\n  animation-name: zoomOutDown;\n}\n\n.zoomOutLeft {\n  -webkit-animation-name: zoomOutLeft;\n  animation-name: zoomOutLeft;\n}\n\n.zoomOutRight {\n  -webkit-animation-name: zoomOutRight;\n  animation-name: zoomOutRight;\n}\n\n.zoomOutUp {\n  -webkit-animation-name: zoomOutUp;\n  animation-name: zoomOutUp;\n}\n\n.slideInDown {\n  -webkit-animation-name: slideInDown;\n  animation-name: slideInDown;\n}\n\n.slideInLeft {\n  -webkit-animation-name: slideInLeft;\n  animation-name: slideInLeft;\n}\n\n.slideInRight {\n  -webkit-animation-name: slideInRight;\n  animation-name: slideInRight;\n}\n\n.slideInUp {\n  -webkit-animation-name: slideInUp;\n  animation-name: slideInUp;\n}\n\n.slideOutDown {\n  -webkit-animation-name: slideOutDown;\n  animation-name: slideOutDown;\n}\n\n.slideOutLeft {\n  -webkit-animation-name: slideOutLeft;\n  animation-name: slideOutLeft;\n}\n\n.slideOutRight {\n  -webkit-animation-name: slideOutRight;\n  animation-name: slideOutRight;\n}\n\n.slideOutUp {\n  -webkit-animation-name: slideOutUp;\n  animation-name: slideOutUp;\n}\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.delay-1s {\n  -webkit-animation-delay: 1s;\n  animation-delay: 1s;\n}\n\n.animated.delay-2s {\n  -webkit-animation-delay: 2s;\n  animation-delay: 2s;\n}\n\n.animated.delay-3s {\n  -webkit-animation-delay: 3s;\n  animation-delay: 3s;\n}\n\n.animated.delay-4s {\n  -webkit-animation-delay: 4s;\n  animation-delay: 4s;\n}\n\n.animated.delay-5s {\n  -webkit-animation-delay: 5s;\n  animation-delay: 5s;\n}\n\n.animated.fast {\n  -webkit-animation-duration: 0.8s;\n  animation-duration: 0.8s;\n}\n\n.animated.faster {\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n}\n\n.animated.slow {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.slower {\n  -webkit-animation-duration: 3s;\n  animation-duration: 3s;\n}\n\n@media (prefers-reduced-motion: reduce), (print) {\n  .animated {\n    -webkit-animation-duration: 1ms !important;\n    animation-duration: 1ms !important;\n    -webkit-transition-duration: 1ms !important;\n    transition-duration: 1ms !important;\n    -webkit-animation-iteration-count: 1 !important;\n    animation-iteration-count: 1 !important;\n  }\n}\n\n/*!\n * Font Awesome Free 5.10.1 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n\n.fa,\n.fab,\n.fad,\n.fal,\n.far,\n.fas {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1;\n}\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: 0.08em solid #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fab.fa-pull-left,\n.fal.fa-pull-left,\n.far.fa-pull-left,\n.fas.fa-pull-left {\n  margin-right: 0.3em;\n}\n\n.fa.fa-pull-right,\n.fab.fa-pull-right,\n.fal.fa-pull-right,\n.far.fa-pull-right,\n.fas.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s linear infinite;\n  animation: fa-spin 2s linear infinite;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s steps(8) infinite;\n  animation: fa-spin 1s steps(8) infinite;\n}\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical,\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1);\n  transform: scale(-1);\n}\n\n:root .fa-flip-both,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-rotate-90 {\n  -webkit-filter: none;\n  filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n\n.fa-accessible-icon:before {\n  content: \"\\f368\";\n}\n\n.fa-accusoft:before {\n  content: \"\\f369\";\n}\n\n.fa-acquisitions-incorporated:before {\n  content: \"\\f6af\";\n}\n\n.fa-ad:before {\n  content: \"\\f641\";\n}\n\n.fa-address-book:before {\n  content: \"\\f2b9\";\n}\n\n.fa-address-card:before {\n  content: \"\\f2bb\";\n}\n\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n\n.fa-adn:before {\n  content: \"\\f170\";\n}\n\n.fa-adobe:before {\n  content: \"\\f778\";\n}\n\n.fa-adversal:before {\n  content: \"\\f36a\";\n}\n\n.fa-affiliatetheme:before {\n  content: \"\\f36b\";\n}\n\n.fa-air-freshener:before {\n  content: \"\\f5d0\";\n}\n\n.fa-airbnb:before {\n  content: \"\\f834\";\n}\n\n.fa-algolia:before {\n  content: \"\\f36c\";\n}\n\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n\n.fa-alipay:before {\n  content: \"\\f642\";\n}\n\n.fa-allergies:before {\n  content: \"\\f461\";\n}\n\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n\n.fa-amazon-pay:before {\n  content: \"\\f42c\";\n}\n\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\";\n}\n\n.fa-amilia:before {\n  content: \"\\f36d\";\n}\n\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n\n.fa-android:before {\n  content: \"\\f17b\";\n}\n\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n\n.fa-angry:before {\n  content: \"\\f556\";\n}\n\n.fa-angrycreative:before {\n  content: \"\\f36e\";\n}\n\n.fa-angular:before {\n  content: \"\\f420\";\n}\n\n.fa-ankh:before {\n  content: \"\\f644\";\n}\n\n.fa-app-store:before {\n  content: \"\\f36f\";\n}\n\n.fa-app-store-ios:before {\n  content: \"\\f370\";\n}\n\n.fa-apper:before {\n  content: \"\\f371\";\n}\n\n.fa-apple:before {\n  content: \"\\f179\";\n}\n\n.fa-apple-alt:before {\n  content: \"\\f5d1\";\n}\n\n.fa-apple-pay:before {\n  content: \"\\f415\";\n}\n\n.fa-archive:before {\n  content: \"\\f187\";\n}\n\n.fa-archway:before {\n  content: \"\\f557\";\n}\n\n.fa-arrow-alt-circle-down:before {\n  content: \"\\f358\";\n}\n\n.fa-arrow-alt-circle-left:before {\n  content: \"\\f359\";\n}\n\n.fa-arrow-alt-circle-right:before {\n  content: \"\\f35a\";\n}\n\n.fa-arrow-alt-circle-up:before {\n  content: \"\\f35b\";\n}\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n\n.fa-arrows-alt-h:before {\n  content: \"\\f337\";\n}\n\n.fa-arrows-alt-v:before {\n  content: \"\\f338\";\n}\n\n.fa-artstation:before {\n  content: \"\\f77a\";\n}\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\";\n}\n\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n\n.fa-asymmetrik:before {\n  content: \"\\f372\";\n}\n\n.fa-at:before {\n  content: \"\\f1fa\";\n}\n\n.fa-atlas:before {\n  content: \"\\f558\";\n}\n\n.fa-atlassian:before {\n  content: \"\\f77b\";\n}\n\n.fa-atom:before {\n  content: \"\\f5d2\";\n}\n\n.fa-audible:before {\n  content: \"\\f373\";\n}\n\n.fa-audio-description:before {\n  content: \"\\f29e\";\n}\n\n.fa-autoprefixer:before {\n  content: \"\\f41c\";\n}\n\n.fa-avianex:before {\n  content: \"\\f374\";\n}\n\n.fa-aviato:before {\n  content: \"\\f421\";\n}\n\n.fa-award:before {\n  content: \"\\f559\";\n}\n\n.fa-aws:before {\n  content: \"\\f375\";\n}\n\n.fa-baby:before {\n  content: \"\\f77c\";\n}\n\n.fa-baby-carriage:before {\n  content: \"\\f77d\";\n}\n\n.fa-backspace:before {\n  content: \"\\f55a\";\n}\n\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n\n.fa-bacon:before {\n  content: \"\\f7e5\";\n}\n\n.fa-balance-scale:before {\n  content: \"\\f24e\";\n}\n\n.fa-balance-scale-left:before {\n  content: \"\\f515\";\n}\n\n.fa-balance-scale-right:before {\n  content: \"\\f516\";\n}\n\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n\n.fa-band-aid:before {\n  content: \"\\f462\";\n}\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n\n.fa-bars:before {\n  content: \"\\f0c9\";\n}\n\n.fa-baseball-ball:before {\n  content: \"\\f433\";\n}\n\n.fa-basketball-ball:before {\n  content: \"\\f434\";\n}\n\n.fa-bath:before {\n  content: \"\\f2cd\";\n}\n\n.fa-battery-empty:before {\n  content: \"\\f244\";\n}\n\n.fa-battery-full:before {\n  content: \"\\f240\";\n}\n\n.fa-battery-half:before {\n  content: \"\\f242\";\n}\n\n.fa-battery-quarter:before {\n  content: \"\\f243\";\n}\n\n.fa-battery-three-quarters:before {\n  content: \"\\f241\";\n}\n\n.fa-battle-net:before {\n  content: \"\\f835\";\n}\n\n.fa-bed:before {\n  content: \"\\f236\";\n}\n\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\";\n}\n\n.fa-bezier-curve:before {\n  content: \"\\f55b\";\n}\n\n.fa-bible:before {\n  content: \"\\f647\";\n}\n\n.fa-bicycle:before {\n  content: \"\\f206\";\n}\n\n.fa-biking:before {\n  content: \"\\f84a\";\n}\n\n.fa-bimobject:before {\n  content: \"\\f378\";\n}\n\n.fa-binoculars:before {\n  content: \"\\f1e5\";\n}\n\n.fa-biohazard:before {\n  content: \"\\f780\";\n}\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\";\n}\n\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n\n.fa-bitcoin:before {\n  content: \"\\f379\";\n}\n\n.fa-bity:before {\n  content: \"\\f37a\";\n}\n\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n\n.fa-blackberry:before {\n  content: \"\\f37b\";\n}\n\n.fa-blender:before {\n  content: \"\\f517\";\n}\n\n.fa-blender-phone:before {\n  content: \"\\f6b6\";\n}\n\n.fa-blind:before {\n  content: \"\\f29d\";\n}\n\n.fa-blog:before {\n  content: \"\\f781\";\n}\n\n.fa-blogger:before {\n  content: \"\\f37c\";\n}\n\n.fa-blogger-b:before {\n  content: \"\\f37d\";\n}\n\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n\n.fa-bold:before {\n  content: \"\\f032\";\n}\n\n.fa-bolt:before {\n  content: \"\\f0e7\";\n}\n\n.fa-bomb:before {\n  content: \"\\f1e2\";\n}\n\n.fa-bone:before {\n  content: \"\\f5d7\";\n}\n\n.fa-bong:before {\n  content: \"\\f55c\";\n}\n\n.fa-book:before {\n  content: \"\\f02d\";\n}\n\n.fa-book-dead:before {\n  content: \"\\f6b7\";\n}\n\n.fa-book-medical:before {\n  content: \"\\f7e6\";\n}\n\n.fa-book-open:before {\n  content: \"\\f518\";\n}\n\n.fa-book-reader:before {\n  content: \"\\f5da\";\n}\n\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n\n.fa-bootstrap:before {\n  content: \"\\f836\";\n}\n\n.fa-border-all:before {\n  content: \"\\f84c\";\n}\n\n.fa-border-none:before {\n  content: \"\\f850\";\n}\n\n.fa-border-style:before {\n  content: \"\\f853\";\n}\n\n.fa-bowling-ball:before {\n  content: \"\\f436\";\n}\n\n.fa-box:before {\n  content: \"\\f466\";\n}\n\n.fa-box-open:before {\n  content: \"\\f49e\";\n}\n\n.fa-boxes:before {\n  content: \"\\f468\";\n}\n\n.fa-braille:before {\n  content: \"\\f2a1\";\n}\n\n.fa-brain:before {\n  content: \"\\f5dc\";\n}\n\n.fa-bread-slice:before {\n  content: \"\\f7ec\";\n}\n\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n\n.fa-briefcase-medical:before {\n  content: \"\\f469\";\n}\n\n.fa-broadcast-tower:before {\n  content: \"\\f519\";\n}\n\n.fa-broom:before {\n  content: \"\\f51a\";\n}\n\n.fa-brush:before {\n  content: \"\\f55d\";\n}\n\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n\n.fa-buffer:before {\n  content: \"\\f837\";\n}\n\n.fa-bug:before {\n  content: \"\\f188\";\n}\n\n.fa-building:before {\n  content: \"\\f1ad\";\n}\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n\n.fa-burn:before {\n  content: \"\\f46a\";\n}\n\n.fa-buromobelexperte:before {\n  content: \"\\f37f\";\n}\n\n.fa-bus:before {\n  content: \"\\f207\";\n}\n\n.fa-bus-alt:before {\n  content: \"\\f55e\";\n}\n\n.fa-business-time:before {\n  content: \"\\f64a\";\n}\n\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n\n.fa-calculator:before {\n  content: \"\\f1ec\";\n}\n\n.fa-calendar:before {\n  content: \"\\f133\";\n}\n\n.fa-calendar-alt:before {\n  content: \"\\f073\";\n}\n\n.fa-calendar-check:before {\n  content: \"\\f274\";\n}\n\n.fa-calendar-day:before {\n  content: \"\\f783\";\n}\n\n.fa-calendar-minus:before {\n  content: \"\\f272\";\n}\n\n.fa-calendar-plus:before {\n  content: \"\\f271\";\n}\n\n.fa-calendar-times:before {\n  content: \"\\f273\";\n}\n\n.fa-calendar-week:before {\n  content: \"\\f784\";\n}\n\n.fa-camera:before {\n  content: \"\\f030\";\n}\n\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n\n.fa-campground:before {\n  content: \"\\f6bb\";\n}\n\n.fa-canadian-maple-leaf:before {\n  content: \"\\f785\";\n}\n\n.fa-candy-cane:before {\n  content: \"\\f786\";\n}\n\n.fa-cannabis:before {\n  content: \"\\f55f\";\n}\n\n.fa-capsules:before {\n  content: \"\\f46b\";\n}\n\n.fa-car:before {\n  content: \"\\f1b9\";\n}\n\n.fa-car-alt:before {\n  content: \"\\f5de\";\n}\n\n.fa-car-battery:before {\n  content: \"\\f5df\";\n}\n\n.fa-car-crash:before {\n  content: \"\\f5e1\";\n}\n\n.fa-car-side:before {\n  content: \"\\f5e4\";\n}\n\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n\n.fa-caret-square-down:before {\n  content: \"\\f150\";\n}\n\n.fa-caret-square-left:before {\n  content: \"\\f191\";\n}\n\n.fa-caret-square-right:before {\n  content: \"\\f152\";\n}\n\n.fa-caret-square-up:before {\n  content: \"\\f151\";\n}\n\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n\n.fa-carrot:before {\n  content: \"\\f787\";\n}\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\";\n}\n\n.fa-cart-plus:before {\n  content: \"\\f217\";\n}\n\n.fa-cash-register:before {\n  content: \"\\f788\";\n}\n\n.fa-cat:before {\n  content: \"\\f6be\";\n}\n\n.fa-cc-amazon-pay:before {\n  content: \"\\f42d\";\n}\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n\n.fa-cc-apple-pay:before {\n  content: \"\\f416\";\n}\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n\n.fa-centercode:before {\n  content: \"\\f380\";\n}\n\n.fa-centos:before {\n  content: \"\\f789\";\n}\n\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n\n.fa-chair:before {\n  content: \"\\f6c0\";\n}\n\n.fa-chalkboard:before {\n  content: \"\\f51b\";\n}\n\n.fa-chalkboard-teacher:before {\n  content: \"\\f51c\";\n}\n\n.fa-charging-station:before {\n  content: \"\\f5e7\";\n}\n\n.fa-chart-area:before {\n  content: \"\\f1fe\";\n}\n\n.fa-chart-bar:before {\n  content: \"\\f080\";\n}\n\n.fa-chart-line:before {\n  content: \"\\f201\";\n}\n\n.fa-chart-pie:before {\n  content: \"\\f200\";\n}\n\n.fa-check:before {\n  content: \"\\f00c\";\n}\n\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n\n.fa-check-double:before {\n  content: \"\\f560\";\n}\n\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n\n.fa-cheese:before {\n  content: \"\\f7ef\";\n}\n\n.fa-chess:before {\n  content: \"\\f439\";\n}\n\n.fa-chess-bishop:before {\n  content: \"\\f43a\";\n}\n\n.fa-chess-board:before {\n  content: \"\\f43c\";\n}\n\n.fa-chess-king:before {\n  content: \"\\f43f\";\n}\n\n.fa-chess-knight:before {\n  content: \"\\f441\";\n}\n\n.fa-chess-pawn:before {\n  content: \"\\f443\";\n}\n\n.fa-chess-queen:before {\n  content: \"\\f445\";\n}\n\n.fa-chess-rook:before {\n  content: \"\\f447\";\n}\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n\n.fa-child:before {\n  content: \"\\f1ae\";\n}\n\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n\n.fa-chromecast:before {\n  content: \"\\f838\";\n}\n\n.fa-church:before {\n  content: \"\\f51d\";\n}\n\n.fa-circle:before {\n  content: \"\\f111\";\n}\n\n.fa-circle-notch:before {\n  content: \"\\f1ce\";\n}\n\n.fa-city:before {\n  content: \"\\f64f\";\n}\n\n.fa-clinic-medical:before {\n  content: \"\\f7f2\";\n}\n\n.fa-clipboard:before {\n  content: \"\\f328\";\n}\n\n.fa-clipboard-check:before {\n  content: \"\\f46c\";\n}\n\n.fa-clipboard-list:before {\n  content: \"\\f46d\";\n}\n\n.fa-clock:before {\n  content: \"\\f017\";\n}\n\n.fa-clone:before {\n  content: \"\\f24d\";\n}\n\n.fa-closed-captioning:before {\n  content: \"\\f20a\";\n}\n\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n\n.fa-cloud-download-alt:before {\n  content: \"\\f381\";\n}\n\n.fa-cloud-meatball:before {\n  content: \"\\f73b\";\n}\n\n.fa-cloud-moon:before {\n  content: \"\\f6c3\";\n}\n\n.fa-cloud-moon-rain:before {\n  content: \"\\f73c\";\n}\n\n.fa-cloud-rain:before {\n  content: \"\\f73d\";\n}\n\n.fa-cloud-showers-heavy:before {\n  content: \"\\f740\";\n}\n\n.fa-cloud-sun:before {\n  content: \"\\f6c4\";\n}\n\n.fa-cloud-sun-rain:before {\n  content: \"\\f743\";\n}\n\n.fa-cloud-upload-alt:before {\n  content: \"\\f382\";\n}\n\n.fa-cloudscale:before {\n  content: \"\\f383\";\n}\n\n.fa-cloudsmith:before {\n  content: \"\\f384\";\n}\n\n.fa-cloudversify:before {\n  content: \"\\f385\";\n}\n\n.fa-cocktail:before {\n  content: \"\\f561\";\n}\n\n.fa-code:before {\n  content: \"\\f121\";\n}\n\n.fa-code-branch:before {\n  content: \"\\f126\";\n}\n\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n\n.fa-cog:before {\n  content: \"\\f013\";\n}\n\n.fa-cogs:before {\n  content: \"\\f085\";\n}\n\n.fa-coins:before {\n  content: \"\\f51e\";\n}\n\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n\n.fa-comment:before {\n  content: \"\\f075\";\n}\n\n.fa-comment-alt:before {\n  content: \"\\f27a\";\n}\n\n.fa-comment-dollar:before {\n  content: \"\\f651\";\n}\n\n.fa-comment-dots:before {\n  content: \"\\f4ad\";\n}\n\n.fa-comment-medical:before {\n  content: \"\\f7f5\";\n}\n\n.fa-comment-slash:before {\n  content: \"\\f4b3\";\n}\n\n.fa-comments:before {\n  content: \"\\f086\";\n}\n\n.fa-comments-dollar:before {\n  content: \"\\f653\";\n}\n\n.fa-compact-disc:before {\n  content: \"\\f51f\";\n}\n\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n\n.fa-compress:before {\n  content: \"\\f066\";\n}\n\n.fa-compress-arrows-alt:before {\n  content: \"\\f78c\";\n}\n\n.fa-concierge-bell:before {\n  content: \"\\f562\";\n}\n\n.fa-confluence:before {\n  content: \"\\f78d\";\n}\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n\n.fa-cookie:before {\n  content: \"\\f563\";\n}\n\n.fa-cookie-bite:before {\n  content: \"\\f564\";\n}\n\n.fa-copy:before {\n  content: \"\\f0c5\";\n}\n\n.fa-copyright:before {\n  content: \"\\f1f9\";\n}\n\n.fa-cotton-bureau:before {\n  content: \"\\f89e\";\n}\n\n.fa-couch:before {\n  content: \"\\f4b8\";\n}\n\n.fa-cpanel:before {\n  content: \"\\f388\";\n}\n\n.fa-creative-commons:before {\n  content: \"\\f25e\";\n}\n\n.fa-creative-commons-by:before {\n  content: \"\\f4e7\";\n}\n\n.fa-creative-commons-nc:before {\n  content: \"\\f4e8\";\n}\n\n.fa-creative-commons-nc-eu:before {\n  content: \"\\f4e9\";\n}\n\n.fa-creative-commons-nc-jp:before {\n  content: \"\\f4ea\";\n}\n\n.fa-creative-commons-nd:before {\n  content: \"\\f4eb\";\n}\n\n.fa-creative-commons-pd:before {\n  content: \"\\f4ec\";\n}\n\n.fa-creative-commons-pd-alt:before {\n  content: \"\\f4ed\";\n}\n\n.fa-creative-commons-remix:before {\n  content: \"\\f4ee\";\n}\n\n.fa-creative-commons-sa:before {\n  content: \"\\f4ef\";\n}\n\n.fa-creative-commons-sampling:before {\n  content: \"\\f4f0\";\n}\n\n.fa-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\";\n}\n\n.fa-creative-commons-share:before {\n  content: \"\\f4f2\";\n}\n\n.fa-creative-commons-zero:before {\n  content: \"\\f4f3\";\n}\n\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n\n.fa-critical-role:before {\n  content: \"\\f6c9\";\n}\n\n.fa-crop:before {\n  content: \"\\f125\";\n}\n\n.fa-crop-alt:before {\n  content: \"\\f565\";\n}\n\n.fa-cross:before {\n  content: \"\\f654\";\n}\n\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n\n.fa-crow:before {\n  content: \"\\f520\";\n}\n\n.fa-crown:before {\n  content: \"\\f521\";\n}\n\n.fa-crutch:before {\n  content: \"\\f7f7\";\n}\n\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n\n.fa-css3-alt:before {\n  content: \"\\f38b\";\n}\n\n.fa-cube:before {\n  content: \"\\f1b2\";\n}\n\n.fa-cubes:before {\n  content: \"\\f1b3\";\n}\n\n.fa-cut:before {\n  content: \"\\f0c4\";\n}\n\n.fa-cuttlefish:before {\n  content: \"\\f38c\";\n}\n\n.fa-d-and-d:before {\n  content: \"\\f38d\";\n}\n\n.fa-d-and-d-beyond:before {\n  content: \"\\f6ca\";\n}\n\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n\n.fa-database:before {\n  content: \"\\f1c0\";\n}\n\n.fa-deaf:before {\n  content: \"\\f2a4\";\n}\n\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n\n.fa-democrat:before {\n  content: \"\\f747\";\n}\n\n.fa-deploydog:before {\n  content: \"\\f38e\";\n}\n\n.fa-deskpro:before {\n  content: \"\\f38f\";\n}\n\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n\n.fa-dev:before {\n  content: \"\\f6cc\";\n}\n\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n\n.fa-dharmachakra:before {\n  content: \"\\f655\";\n}\n\n.fa-dhl:before {\n  content: \"\\f790\";\n}\n\n.fa-diagnoses:before {\n  content: \"\\f470\";\n}\n\n.fa-diaspora:before {\n  content: \"\\f791\";\n}\n\n.fa-dice:before {\n  content: \"\\f522\";\n}\n\n.fa-dice-d20:before {\n  content: \"\\f6cf\";\n}\n\n.fa-dice-d6:before {\n  content: \"\\f6d1\";\n}\n\n.fa-dice-five:before {\n  content: \"\\f523\";\n}\n\n.fa-dice-four:before {\n  content: \"\\f524\";\n}\n\n.fa-dice-one:before {\n  content: \"\\f525\";\n}\n\n.fa-dice-six:before {\n  content: \"\\f526\";\n}\n\n.fa-dice-three:before {\n  content: \"\\f527\";\n}\n\n.fa-dice-two:before {\n  content: \"\\f528\";\n}\n\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n\n.fa-digital-ocean:before {\n  content: \"\\f391\";\n}\n\n.fa-digital-tachograph:before {\n  content: \"\\f566\";\n}\n\n.fa-directions:before {\n  content: \"\\f5eb\";\n}\n\n.fa-discord:before {\n  content: \"\\f392\";\n}\n\n.fa-discourse:before {\n  content: \"\\f393\";\n}\n\n.fa-divide:before {\n  content: \"\\f529\";\n}\n\n.fa-dizzy:before {\n  content: \"\\f567\";\n}\n\n.fa-dna:before {\n  content: \"\\f471\";\n}\n\n.fa-dochub:before {\n  content: \"\\f394\";\n}\n\n.fa-docker:before {\n  content: \"\\f395\";\n}\n\n.fa-dog:before {\n  content: \"\\f6d3\";\n}\n\n.fa-dollar-sign:before {\n  content: \"\\f155\";\n}\n\n.fa-dolly:before {\n  content: \"\\f472\";\n}\n\n.fa-dolly-flatbed:before {\n  content: \"\\f474\";\n}\n\n.fa-donate:before {\n  content: \"\\f4b9\";\n}\n\n.fa-door-closed:before {\n  content: \"\\f52a\";\n}\n\n.fa-door-open:before {\n  content: \"\\f52b\";\n}\n\n.fa-dot-circle:before {\n  content: \"\\f192\";\n}\n\n.fa-dove:before {\n  content: \"\\f4ba\";\n}\n\n.fa-download:before {\n  content: \"\\f019\";\n}\n\n.fa-draft2digital:before {\n  content: \"\\f396\";\n}\n\n.fa-drafting-compass:before {\n  content: \"\\f568\";\n}\n\n.fa-dragon:before {\n  content: \"\\f6d5\";\n}\n\n.fa-draw-polygon:before {\n  content: \"\\f5ee\";\n}\n\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n\n.fa-dribbble-square:before {\n  content: \"\\f397\";\n}\n\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n\n.fa-drum:before {\n  content: \"\\f569\";\n}\n\n.fa-drum-steelpan:before {\n  content: \"\\f56a\";\n}\n\n.fa-drumstick-bite:before {\n  content: \"\\f6d7\";\n}\n\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n\n.fa-dumbbell:before {\n  content: \"\\f44b\";\n}\n\n.fa-dumpster:before {\n  content: \"\\f793\";\n}\n\n.fa-dumpster-fire:before {\n  content: \"\\f794\";\n}\n\n.fa-dungeon:before {\n  content: \"\\f6d9\";\n}\n\n.fa-dyalog:before {\n  content: \"\\f399\";\n}\n\n.fa-earlybirds:before {\n  content: \"\\f39a\";\n}\n\n.fa-ebay:before {\n  content: \"\\f4f4\";\n}\n\n.fa-edge:before {\n  content: \"\\f282\";\n}\n\n.fa-edit:before {\n  content: \"\\f044\";\n}\n\n.fa-egg:before {\n  content: \"\\f7fb\";\n}\n\n.fa-eject:before {\n  content: \"\\f052\";\n}\n\n.fa-elementor:before {\n  content: \"\\f430\";\n}\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n\n.fa-ello:before {\n  content: \"\\f5f1\";\n}\n\n.fa-ember:before {\n  content: \"\\f423\";\n}\n\n.fa-empire:before {\n  content: \"\\f1d1\";\n}\n\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\";\n}\n\n.fa-envelope-open-text:before {\n  content: \"\\f658\";\n}\n\n.fa-envelope-square:before {\n  content: \"\\f199\";\n}\n\n.fa-envira:before {\n  content: \"\\f299\";\n}\n\n.fa-equals:before {\n  content: \"\\f52c\";\n}\n\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n\n.fa-erlang:before {\n  content: \"\\f39d\";\n}\n\n.fa-ethereum:before {\n  content: \"\\f42e\";\n}\n\n.fa-ethernet:before {\n  content: \"\\f796\";\n}\n\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n\n.fa-euro-sign:before {\n  content: \"\\f153\";\n}\n\n.fa-evernote:before {\n  content: \"\\f839\";\n}\n\n.fa-exchange-alt:before {\n  content: \"\\f362\";\n}\n\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n\n.fa-exclamation-triangle:before {\n  content: \"\\f071\";\n}\n\n.fa-expand:before {\n  content: \"\\f065\";\n}\n\n.fa-expand-arrows-alt:before {\n  content: \"\\f31e\";\n}\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n\n.fa-external-link-alt:before {\n  content: \"\\f35d\";\n}\n\n.fa-external-link-square-alt:before {\n  content: \"\\f360\";\n}\n\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n\n.fa-eye-dropper:before {\n  content: \"\\f1fb\";\n}\n\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n\n.fa-facebook-f:before {\n  content: \"\\f39e\";\n}\n\n.fa-facebook-messenger:before {\n  content: \"\\f39f\";\n}\n\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n\n.fa-fan:before {\n  content: \"\\f863\";\n}\n\n.fa-fantasy-flight-games:before {\n  content: \"\\f6dc\";\n}\n\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n\n.fa-fax:before {\n  content: \"\\f1ac\";\n}\n\n.fa-feather:before {\n  content: \"\\f52d\";\n}\n\n.fa-feather-alt:before {\n  content: \"\\f56b\";\n}\n\n.fa-fedex:before {\n  content: \"\\f797\";\n}\n\n.fa-fedora:before {\n  content: \"\\f798\";\n}\n\n.fa-female:before {\n  content: \"\\f182\";\n}\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n\n.fa-figma:before {\n  content: \"\\f799\";\n}\n\n.fa-file:before {\n  content: \"\\f15b\";\n}\n\n.fa-file-alt:before {\n  content: \"\\f15c\";\n}\n\n.fa-file-archive:before {\n  content: \"\\f1c6\";\n}\n\n.fa-file-audio:before {\n  content: \"\\f1c7\";\n}\n\n.fa-file-code:before {\n  content: \"\\f1c9\";\n}\n\n.fa-file-contract:before {\n  content: \"\\f56c\";\n}\n\n.fa-file-csv:before {\n  content: \"\\f6dd\";\n}\n\n.fa-file-download:before {\n  content: \"\\f56d\";\n}\n\n.fa-file-excel:before {\n  content: \"\\f1c3\";\n}\n\n.fa-file-export:before {\n  content: \"\\f56e\";\n}\n\n.fa-file-image:before {\n  content: \"\\f1c5\";\n}\n\n.fa-file-import:before {\n  content: \"\\f56f\";\n}\n\n.fa-file-invoice:before {\n  content: \"\\f570\";\n}\n\n.fa-file-invoice-dollar:before {\n  content: \"\\f571\";\n}\n\n.fa-file-medical:before {\n  content: \"\\f477\";\n}\n\n.fa-file-medical-alt:before {\n  content: \"\\f478\";\n}\n\n.fa-file-pdf:before {\n  content: \"\\f1c1\";\n}\n\n.fa-file-powerpoint:before {\n  content: \"\\f1c4\";\n}\n\n.fa-file-prescription:before {\n  content: \"\\f572\";\n}\n\n.fa-file-signature:before {\n  content: \"\\f573\";\n}\n\n.fa-file-upload:before {\n  content: \"\\f574\";\n}\n\n.fa-file-video:before {\n  content: \"\\f1c8\";\n}\n\n.fa-file-word:before {\n  content: \"\\f1c2\";\n}\n\n.fa-fill:before {\n  content: \"\\f575\";\n}\n\n.fa-fill-drip:before {\n  content: \"\\f576\";\n}\n\n.fa-film:before {\n  content: \"\\f008\";\n}\n\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n\n.fa-fingerprint:before {\n  content: \"\\f577\";\n}\n\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n\n.fa-fire-alt:before {\n  content: \"\\f7e4\";\n}\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n\n.fa-first-aid:before {\n  content: \"\\f479\";\n}\n\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n\n.fa-first-order-alt:before {\n  content: \"\\f50a\";\n}\n\n.fa-firstdraft:before {\n  content: \"\\f3a1\";\n}\n\n.fa-fish:before {\n  content: \"\\f578\";\n}\n\n.fa-fist-raised:before {\n  content: \"\\f6de\";\n}\n\n.fa-flag:before {\n  content: \"\\f024\";\n}\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n\n.fa-flag-usa:before {\n  content: \"\\f74d\";\n}\n\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n\n.fa-flipboard:before {\n  content: \"\\f44d\";\n}\n\n.fa-flushed:before {\n  content: \"\\f579\";\n}\n\n.fa-fly:before {\n  content: \"\\f417\";\n}\n\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n\n.fa-folder-minus:before {\n  content: \"\\f65d\";\n}\n\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n\n.fa-folder-plus:before {\n  content: \"\\f65e\";\n}\n\n.fa-font:before {\n  content: \"\\f031\";\n}\n\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n\n.fa-font-awesome-alt:before {\n  content: \"\\f35c\";\n}\n\n.fa-font-awesome-flag:before {\n  content: \"\\f425\";\n}\n\n.fa-font-awesome-logo-full:before {\n  content: \"\\f4e6\";\n}\n\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n\n.fa-fonticons-fi:before {\n  content: \"\\f3a2\";\n}\n\n.fa-football-ball:before {\n  content: \"\\f44e\";\n}\n\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n\n.fa-fort-awesome-alt:before {\n  content: \"\\f3a3\";\n}\n\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n\n.fa-freebsd:before {\n  content: \"\\f3a4\";\n}\n\n.fa-frog:before {\n  content: \"\\f52e\";\n}\n\n.fa-frown:before {\n  content: \"\\f119\";\n}\n\n.fa-frown-open:before {\n  content: \"\\f57a\";\n}\n\n.fa-fulcrum:before {\n  content: \"\\f50b\";\n}\n\n.fa-funnel-dollar:before {\n  content: \"\\f662\";\n}\n\n.fa-futbol:before {\n  content: \"\\f1e3\";\n}\n\n.fa-galactic-republic:before {\n  content: \"\\f50c\";\n}\n\n.fa-galactic-senate:before {\n  content: \"\\f50d\";\n}\n\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n\n.fa-gas-pump:before {\n  content: \"\\f52f\";\n}\n\n.fa-gavel:before {\n  content: \"\\f0e3\";\n}\n\n.fa-gem:before {\n  content: \"\\f3a5\";\n}\n\n.fa-genderless:before {\n  content: \"\\f22d\";\n}\n\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n\n.fa-gg:before {\n  content: \"\\f260\";\n}\n\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n\n.fa-ghost:before {\n  content: \"\\f6e2\";\n}\n\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n\n.fa-gifts:before {\n  content: \"\\f79c\";\n}\n\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n\n.fa-git-alt:before {\n  content: \"\\f841\";\n}\n\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n\n.fa-github:before {\n  content: \"\\f09b\";\n}\n\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n\n.fa-gitkraken:before {\n  content: \"\\f3a6\";\n}\n\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n\n.fa-gitter:before {\n  content: \"\\f426\";\n}\n\n.fa-glass-cheers:before {\n  content: \"\\f79f\";\n}\n\n.fa-glass-martini:before {\n  content: \"\\f000\";\n}\n\n.fa-glass-martini-alt:before {\n  content: \"\\f57b\";\n}\n\n.fa-glass-whiskey:before {\n  content: \"\\f7a0\";\n}\n\n.fa-glasses:before {\n  content: \"\\f530\";\n}\n\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n\n.fa-globe-africa:before {\n  content: \"\\f57c\";\n}\n\n.fa-globe-americas:before {\n  content: \"\\f57d\";\n}\n\n.fa-globe-asia:before {\n  content: \"\\f57e\";\n}\n\n.fa-globe-europe:before {\n  content: \"\\f7a2\";\n}\n\n.fa-gofore:before {\n  content: \"\\f3a7\";\n}\n\n.fa-golf-ball:before {\n  content: \"\\f450\";\n}\n\n.fa-goodreads:before {\n  content: \"\\f3a8\";\n}\n\n.fa-goodreads-g:before {\n  content: \"\\f3a9\";\n}\n\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n\n.fa-google-drive:before {\n  content: \"\\f3aa\";\n}\n\n.fa-google-play:before {\n  content: \"\\f3ab\";\n}\n\n.fa-google-plus:before {\n  content: \"\\f2b3\";\n}\n\n.fa-google-plus-g:before {\n  content: \"\\f0d5\";\n}\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n\n.fa-gopuram:before {\n  content: \"\\f664\";\n}\n\n.fa-graduation-cap:before {\n  content: \"\\f19d\";\n}\n\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n\n.fa-greater-than:before {\n  content: \"\\f531\";\n}\n\n.fa-greater-than-equal:before {\n  content: \"\\f532\";\n}\n\n.fa-grimace:before {\n  content: \"\\f57f\";\n}\n\n.fa-grin:before {\n  content: \"\\f580\";\n}\n\n.fa-grin-alt:before {\n  content: \"\\f581\";\n}\n\n.fa-grin-beam:before {\n  content: \"\\f582\";\n}\n\n.fa-grin-beam-sweat:before {\n  content: \"\\f583\";\n}\n\n.fa-grin-hearts:before {\n  content: \"\\f584\";\n}\n\n.fa-grin-squint:before {\n  content: \"\\f585\";\n}\n\n.fa-grin-squint-tears:before {\n  content: \"\\f586\";\n}\n\n.fa-grin-stars:before {\n  content: \"\\f587\";\n}\n\n.fa-grin-tears:before {\n  content: \"\\f588\";\n}\n\n.fa-grin-tongue:before {\n  content: \"\\f589\";\n}\n\n.fa-grin-tongue-squint:before {\n  content: \"\\f58a\";\n}\n\n.fa-grin-tongue-wink:before {\n  content: \"\\f58b\";\n}\n\n.fa-grin-wink:before {\n  content: \"\\f58c\";\n}\n\n.fa-grip-horizontal:before {\n  content: \"\\f58d\";\n}\n\n.fa-grip-lines:before {\n  content: \"\\f7a4\";\n}\n\n.fa-grip-lines-vertical:before {\n  content: \"\\f7a5\";\n}\n\n.fa-grip-vertical:before {\n  content: \"\\f58e\";\n}\n\n.fa-gripfire:before {\n  content: \"\\f3ac\";\n}\n\n.fa-grunt:before {\n  content: \"\\f3ad\";\n}\n\n.fa-guitar:before {\n  content: \"\\f7a6\";\n}\n\n.fa-gulp:before {\n  content: \"\\f3ae\";\n}\n\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n\n.fa-hacker-news:before {\n  content: \"\\f1d4\";\n}\n\n.fa-hacker-news-square:before {\n  content: \"\\f3af\";\n}\n\n.fa-hackerrank:before {\n  content: \"\\f5f7\";\n}\n\n.fa-hamburger:before {\n  content: \"\\f805\";\n}\n\n.fa-hammer:before {\n  content: \"\\f6e3\";\n}\n\n.fa-hamsa:before {\n  content: \"\\f665\";\n}\n\n.fa-hand-holding:before {\n  content: \"\\f4bd\";\n}\n\n.fa-hand-holding-heart:before {\n  content: \"\\f4be\";\n}\n\n.fa-hand-holding-usd:before {\n  content: \"\\f4c0\";\n}\n\n.fa-hand-lizard:before {\n  content: \"\\f258\";\n}\n\n.fa-hand-middle-finger:before {\n  content: \"\\f806\";\n}\n\n.fa-hand-paper:before {\n  content: \"\\f256\";\n}\n\n.fa-hand-peace:before {\n  content: \"\\f25b\";\n}\n\n.fa-hand-point-down:before {\n  content: \"\\f0a7\";\n}\n\n.fa-hand-point-left:before {\n  content: \"\\f0a5\";\n}\n\n.fa-hand-point-right:before {\n  content: \"\\f0a4\";\n}\n\n.fa-hand-point-up:before {\n  content: \"\\f0a6\";\n}\n\n.fa-hand-pointer:before {\n  content: \"\\f25a\";\n}\n\n.fa-hand-rock:before {\n  content: \"\\f255\";\n}\n\n.fa-hand-scissors:before {\n  content: \"\\f257\";\n}\n\n.fa-hand-spock:before {\n  content: \"\\f259\";\n}\n\n.fa-hands:before {\n  content: \"\\f4c2\";\n}\n\n.fa-hands-helping:before {\n  content: \"\\f4c4\";\n}\n\n.fa-handshake:before {\n  content: \"\\f2b5\";\n}\n\n.fa-hanukiah:before {\n  content: \"\\f6e6\";\n}\n\n.fa-hard-hat:before {\n  content: \"\\f807\";\n}\n\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n\n.fa-hat-wizard:before {\n  content: \"\\f6e8\";\n}\n\n.fa-haykal:before {\n  content: \"\\f666\";\n}\n\n.fa-hdd:before {\n  content: \"\\f0a0\";\n}\n\n.fa-heading:before {\n  content: \"\\f1dc\";\n}\n\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n\n.fa-headphones-alt:before {\n  content: \"\\f58f\";\n}\n\n.fa-headset:before {\n  content: \"\\f590\";\n}\n\n.fa-heart:before {\n  content: \"\\f004\";\n}\n\n.fa-heart-broken:before {\n  content: \"\\f7a9\";\n}\n\n.fa-heartbeat:before {\n  content: \"\\f21e\";\n}\n\n.fa-helicopter:before {\n  content: \"\\f533\";\n}\n\n.fa-highlighter:before {\n  content: \"\\f591\";\n}\n\n.fa-hiking:before {\n  content: \"\\f6ec\";\n}\n\n.fa-hippo:before {\n  content: \"\\f6ed\";\n}\n\n.fa-hips:before {\n  content: \"\\f452\";\n}\n\n.fa-hire-a-helper:before {\n  content: \"\\f3b0\";\n}\n\n.fa-history:before {\n  content: \"\\f1da\";\n}\n\n.fa-hockey-puck:before {\n  content: \"\\f453\";\n}\n\n.fa-holly-berry:before {\n  content: \"\\f7aa\";\n}\n\n.fa-home:before {\n  content: \"\\f015\";\n}\n\n.fa-hooli:before {\n  content: \"\\f427\";\n}\n\n.fa-hornbill:before {\n  content: \"\\f592\";\n}\n\n.fa-horse:before {\n  content: \"\\f6f0\";\n}\n\n.fa-horse-head:before {\n  content: \"\\f7ab\";\n}\n\n.fa-hospital:before {\n  content: \"\\f0f8\";\n}\n\n.fa-hospital-alt:before {\n  content: \"\\f47d\";\n}\n\n.fa-hospital-symbol:before {\n  content: \"\\f47e\";\n}\n\n.fa-hot-tub:before {\n  content: \"\\f593\";\n}\n\n.fa-hotdog:before {\n  content: \"\\f80f\";\n}\n\n.fa-hotel:before {\n  content: \"\\f594\";\n}\n\n.fa-hotjar:before {\n  content: \"\\f3b1\";\n}\n\n.fa-hourglass:before {\n  content: \"\\f254\";\n}\n\n.fa-hourglass-end:before {\n  content: \"\\f253\";\n}\n\n.fa-hourglass-half:before {\n  content: \"\\f252\";\n}\n\n.fa-hourglass-start:before {\n  content: \"\\f251\";\n}\n\n.fa-house-damage:before {\n  content: \"\\f6f1\";\n}\n\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n\n.fa-hryvnia:before {\n  content: \"\\f6f2\";\n}\n\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n\n.fa-hubspot:before {\n  content: \"\\f3b2\";\n}\n\n.fa-i-cursor:before {\n  content: \"\\f246\";\n}\n\n.fa-ice-cream:before {\n  content: \"\\f810\";\n}\n\n.fa-icicles:before {\n  content: \"\\f7ad\";\n}\n\n.fa-icons:before {\n  content: \"\\f86d\";\n}\n\n.fa-id-badge:before {\n  content: \"\\f2c1\";\n}\n\n.fa-id-card:before {\n  content: \"\\f2c2\";\n}\n\n.fa-id-card-alt:before {\n  content: \"\\f47f\";\n}\n\n.fa-igloo:before {\n  content: \"\\f7ae\";\n}\n\n.fa-image:before {\n  content: \"\\f03e\";\n}\n\n.fa-images:before {\n  content: \"\\f302\";\n}\n\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n\n.fa-industry:before {\n  content: \"\\f275\";\n}\n\n.fa-infinity:before {\n  content: \"\\f534\";\n}\n\n.fa-info:before {\n  content: \"\\f129\";\n}\n\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n\n.fa-intercom:before {\n  content: \"\\f7af\";\n}\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n\n.fa-invision:before {\n  content: \"\\f7b0\";\n}\n\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n\n.fa-italic:before {\n  content: \"\\f033\";\n}\n\n.fa-itch-io:before {\n  content: \"\\f83a\";\n}\n\n.fa-itunes:before {\n  content: \"\\f3b4\";\n}\n\n.fa-itunes-note:before {\n  content: \"\\f3b5\";\n}\n\n.fa-java:before {\n  content: \"\\f4e4\";\n}\n\n.fa-jedi:before {\n  content: \"\\f669\";\n}\n\n.fa-jedi-order:before {\n  content: \"\\f50e\";\n}\n\n.fa-jenkins:before {\n  content: \"\\f3b6\";\n}\n\n.fa-jira:before {\n  content: \"\\f7b1\";\n}\n\n.fa-joget:before {\n  content: \"\\f3b7\";\n}\n\n.fa-joint:before {\n  content: \"\\f595\";\n}\n\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n\n.fa-journal-whills:before {\n  content: \"\\f66a\";\n}\n\n.fa-js:before {\n  content: \"\\f3b8\";\n}\n\n.fa-js-square:before {\n  content: \"\\f3b9\";\n}\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n\n.fa-kaaba:before {\n  content: \"\\f66b\";\n}\n\n.fa-kaggle:before {\n  content: \"\\f5fa\";\n}\n\n.fa-key:before {\n  content: \"\\f084\";\n}\n\n.fa-keybase:before {\n  content: \"\\f4f5\";\n}\n\n.fa-keyboard:before {\n  content: \"\\f11c\";\n}\n\n.fa-keycdn:before {\n  content: \"\\f3ba\";\n}\n\n.fa-khanda:before {\n  content: \"\\f66d\";\n}\n\n.fa-kickstarter:before {\n  content: \"\\f3bb\";\n}\n\n.fa-kickstarter-k:before {\n  content: \"\\f3bc\";\n}\n\n.fa-kiss:before {\n  content: \"\\f596\";\n}\n\n.fa-kiss-beam:before {\n  content: \"\\f597\";\n}\n\n.fa-kiss-wink-heart:before {\n  content: \"\\f598\";\n}\n\n.fa-kiwi-bird:before {\n  content: \"\\f535\";\n}\n\n.fa-korvue:before {\n  content: \"\\f42f\";\n}\n\n.fa-landmark:before {\n  content: \"\\f66f\";\n}\n\n.fa-language:before {\n  content: \"\\f1ab\";\n}\n\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n\n.fa-laptop-code:before {\n  content: \"\\f5fc\";\n}\n\n.fa-laptop-medical:before {\n  content: \"\\f812\";\n}\n\n.fa-laravel:before {\n  content: \"\\f3bd\";\n}\n\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n\n.fa-laugh:before {\n  content: \"\\f599\";\n}\n\n.fa-laugh-beam:before {\n  content: \"\\f59a\";\n}\n\n.fa-laugh-squint:before {\n  content: \"\\f59b\";\n}\n\n.fa-laugh-wink:before {\n  content: \"\\f59c\";\n}\n\n.fa-layer-group:before {\n  content: \"\\f5fd\";\n}\n\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n\n.fa-lemon:before {\n  content: \"\\f094\";\n}\n\n.fa-less:before {\n  content: \"\\f41d\";\n}\n\n.fa-less-than:before {\n  content: \"\\f536\";\n}\n\n.fa-less-than-equal:before {\n  content: \"\\f537\";\n}\n\n.fa-level-down-alt:before {\n  content: \"\\f3be\";\n}\n\n.fa-level-up-alt:before {\n  content: \"\\f3bf\";\n}\n\n.fa-life-ring:before {\n  content: \"\\f1cd\";\n}\n\n.fa-lightbulb:before {\n  content: \"\\f0eb\";\n}\n\n.fa-line:before {\n  content: \"\\f3c0\";\n}\n\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n\n.fa-linkedin:before {\n  content: \"\\f08c\";\n}\n\n.fa-linkedin-in:before {\n  content: \"\\f0e1\";\n}\n\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n\n.fa-lira-sign:before {\n  content: \"\\f195\";\n}\n\n.fa-list:before {\n  content: \"\\f03a\";\n}\n\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n\n.fa-lock:before {\n  content: \"\\f023\";\n}\n\n.fa-lock-open:before {\n  content: \"\\f3c1\";\n}\n\n.fa-long-arrow-alt-down:before {\n  content: \"\\f309\";\n}\n\n.fa-long-arrow-alt-left:before {\n  content: \"\\f30a\";\n}\n\n.fa-long-arrow-alt-right:before {\n  content: \"\\f30b\";\n}\n\n.fa-long-arrow-alt-up:before {\n  content: \"\\f30c\";\n}\n\n.fa-low-vision:before {\n  content: \"\\f2a8\";\n}\n\n.fa-luggage-cart:before {\n  content: \"\\f59d\";\n}\n\n.fa-lyft:before {\n  content: \"\\f3c3\";\n}\n\n.fa-magento:before {\n  content: \"\\f3c4\";\n}\n\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n\n.fa-mail-bulk:before {\n  content: \"\\f674\";\n}\n\n.fa-mailchimp:before {\n  content: \"\\f59e\";\n}\n\n.fa-male:before {\n  content: \"\\f183\";\n}\n\n.fa-mandalorian:before {\n  content: \"\\f50f\";\n}\n\n.fa-map:before {\n  content: \"\\f279\";\n}\n\n.fa-map-marked:before {\n  content: \"\\f59f\";\n}\n\n.fa-map-marked-alt:before {\n  content: \"\\f5a0\";\n}\n\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n\n.fa-map-marker-alt:before {\n  content: \"\\f3c5\";\n}\n\n.fa-map-pin:before {\n  content: \"\\f276\";\n}\n\n.fa-map-signs:before {\n  content: \"\\f277\";\n}\n\n.fa-markdown:before {\n  content: \"\\f60f\";\n}\n\n.fa-marker:before {\n  content: \"\\f5a1\";\n}\n\n.fa-mars:before {\n  content: \"\\f222\";\n}\n\n.fa-mars-double:before {\n  content: \"\\f227\";\n}\n\n.fa-mars-stroke:before {\n  content: \"\\f229\";\n}\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\";\n}\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\";\n}\n\n.fa-mask:before {\n  content: \"\\f6fa\";\n}\n\n.fa-mastodon:before {\n  content: \"\\f4f6\";\n}\n\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n\n.fa-medal:before {\n  content: \"\\f5a2\";\n}\n\n.fa-medapps:before {\n  content: \"\\f3c6\";\n}\n\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n\n.fa-medium-m:before {\n  content: \"\\f3c7\";\n}\n\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n\n.fa-medrt:before {\n  content: \"\\f3c8\";\n}\n\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n\n.fa-megaport:before {\n  content: \"\\f5a3\";\n}\n\n.fa-meh:before {\n  content: \"\\f11a\";\n}\n\n.fa-meh-blank:before {\n  content: \"\\f5a4\";\n}\n\n.fa-meh-rolling-eyes:before {\n  content: \"\\f5a5\";\n}\n\n.fa-memory:before {\n  content: \"\\f538\";\n}\n\n.fa-mendeley:before {\n  content: \"\\f7b3\";\n}\n\n.fa-menorah:before {\n  content: \"\\f676\";\n}\n\n.fa-mercury:before {\n  content: \"\\f223\";\n}\n\n.fa-meteor:before {\n  content: \"\\f753\";\n}\n\n.fa-microchip:before {\n  content: \"\\f2db\";\n}\n\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n\n.fa-microphone-alt:before {\n  content: \"\\f3c9\";\n}\n\n.fa-microphone-alt-slash:before {\n  content: \"\\f539\";\n}\n\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n\n.fa-microscope:before {\n  content: \"\\f610\";\n}\n\n.fa-microsoft:before {\n  content: \"\\f3ca\";\n}\n\n.fa-minus:before {\n  content: \"\\f068\";\n}\n\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n\n.fa-mitten:before {\n  content: \"\\f7b5\";\n}\n\n.fa-mix:before {\n  content: \"\\f3cb\";\n}\n\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n\n.fa-mizuni:before {\n  content: \"\\f3cc\";\n}\n\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n\n.fa-mobile-alt:before {\n  content: \"\\f3cd\";\n}\n\n.fa-modx:before {\n  content: \"\\f285\";\n}\n\n.fa-monero:before {\n  content: \"\\f3d0\";\n}\n\n.fa-money-bill:before {\n  content: \"\\f0d6\";\n}\n\n.fa-money-bill-alt:before {\n  content: \"\\f3d1\";\n}\n\n.fa-money-bill-wave:before {\n  content: \"\\f53a\";\n}\n\n.fa-money-bill-wave-alt:before {\n  content: \"\\f53b\";\n}\n\n.fa-money-check:before {\n  content: \"\\f53c\";\n}\n\n.fa-money-check-alt:before {\n  content: \"\\f53d\";\n}\n\n.fa-monument:before {\n  content: \"\\f5a6\";\n}\n\n.fa-moon:before {\n  content: \"\\f186\";\n}\n\n.fa-mortar-pestle:before {\n  content: \"\\f5a7\";\n}\n\n.fa-mosque:before {\n  content: \"\\f678\";\n}\n\n.fa-motorcycle:before {\n  content: \"\\f21c\";\n}\n\n.fa-mountain:before {\n  content: \"\\f6fc\";\n}\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\";\n}\n\n.fa-mug-hot:before {\n  content: \"\\f7b6\";\n}\n\n.fa-music:before {\n  content: \"\\f001\";\n}\n\n.fa-napster:before {\n  content: \"\\f3d2\";\n}\n\n.fa-neos:before {\n  content: \"\\f612\";\n}\n\n.fa-network-wired:before {\n  content: \"\\f6ff\";\n}\n\n.fa-neuter:before {\n  content: \"\\f22c\";\n}\n\n.fa-newspaper:before {\n  content: \"\\f1ea\";\n}\n\n.fa-nimblr:before {\n  content: \"\\f5a8\";\n}\n\n.fa-node:before {\n  content: \"\\f419\";\n}\n\n.fa-node-js:before {\n  content: \"\\f3d3\";\n}\n\n.fa-not-equal:before {\n  content: \"\\f53e\";\n}\n\n.fa-notes-medical:before {\n  content: \"\\f481\";\n}\n\n.fa-npm:before {\n  content: \"\\f3d4\";\n}\n\n.fa-ns8:before {\n  content: \"\\f3d5\";\n}\n\n.fa-nutritionix:before {\n  content: \"\\f3d6\";\n}\n\n.fa-object-group:before {\n  content: \"\\f247\";\n}\n\n.fa-object-ungroup:before {\n  content: \"\\f248\";\n}\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n\n.fa-oil-can:before {\n  content: \"\\f613\";\n}\n\n.fa-old-republic:before {\n  content: \"\\f510\";\n}\n\n.fa-om:before {\n  content: \"\\f679\";\n}\n\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n\n.fa-osi:before {\n  content: \"\\f41a\";\n}\n\n.fa-otter:before {\n  content: \"\\f700\";\n}\n\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n\n.fa-page4:before {\n  content: \"\\f3d7\";\n}\n\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n\n.fa-pager:before {\n  content: \"\\f815\";\n}\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\";\n}\n\n.fa-paint-roller:before {\n  content: \"\\f5aa\";\n}\n\n.fa-palette:before {\n  content: \"\\f53f\";\n}\n\n.fa-palfed:before {\n  content: \"\\f3d8\";\n}\n\n.fa-pallet:before {\n  content: \"\\f482\";\n}\n\n.fa-paper-plane:before {\n  content: \"\\f1d8\";\n}\n\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n\n.fa-parachute-box:before {\n  content: \"\\f4cd\";\n}\n\n.fa-paragraph:before {\n  content: \"\\f1dd\";\n}\n\n.fa-parking:before {\n  content: \"\\f540\";\n}\n\n.fa-passport:before {\n  content: \"\\f5ab\";\n}\n\n.fa-pastafarianism:before {\n  content: \"\\f67b\";\n}\n\n.fa-paste:before {\n  content: \"\\f0ea\";\n}\n\n.fa-patreon:before {\n  content: \"\\f3d9\";\n}\n\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n\n.fa-pause-circle:before {\n  content: \"\\f28b\";\n}\n\n.fa-paw:before {\n  content: \"\\f1b0\";\n}\n\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n\n.fa-peace:before {\n  content: \"\\f67c\";\n}\n\n.fa-pen:before {\n  content: \"\\f304\";\n}\n\n.fa-pen-alt:before {\n  content: \"\\f305\";\n}\n\n.fa-pen-fancy:before {\n  content: \"\\f5ac\";\n}\n\n.fa-pen-nib:before {\n  content: \"\\f5ad\";\n}\n\n.fa-pen-square:before {\n  content: \"\\f14b\";\n}\n\n.fa-pencil-alt:before {\n  content: \"\\f303\";\n}\n\n.fa-pencil-ruler:before {\n  content: \"\\f5ae\";\n}\n\n.fa-penny-arcade:before {\n  content: \"\\f704\";\n}\n\n.fa-people-carry:before {\n  content: \"\\f4ce\";\n}\n\n.fa-pepper-hot:before {\n  content: \"\\f816\";\n}\n\n.fa-percent:before {\n  content: \"\\f295\";\n}\n\n.fa-percentage:before {\n  content: \"\\f541\";\n}\n\n.fa-periscope:before {\n  content: \"\\f3da\";\n}\n\n.fa-person-booth:before {\n  content: \"\\f756\";\n}\n\n.fa-phabricator:before {\n  content: \"\\f3db\";\n}\n\n.fa-phoenix-framework:before {\n  content: \"\\f3dc\";\n}\n\n.fa-phoenix-squadron:before {\n  content: \"\\f511\";\n}\n\n.fa-phone:before {\n  content: \"\\f095\";\n}\n\n.fa-phone-alt:before {\n  content: \"\\f879\";\n}\n\n.fa-phone-slash:before {\n  content: \"\\f3dd\";\n}\n\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n\n.fa-phone-square-alt:before {\n  content: \"\\f87b\";\n}\n\n.fa-phone-volume:before {\n  content: \"\\f2a0\";\n}\n\n.fa-photo-video:before {\n  content: \"\\f87c\";\n}\n\n.fa-php:before {\n  content: \"\\f457\";\n}\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n\n.fa-pied-piper-hat:before {\n  content: \"\\f4e5\";\n}\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n\n.fa-piggy-bank:before {\n  content: \"\\f4d3\";\n}\n\n.fa-pills:before {\n  content: \"\\f484\";\n}\n\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n\n.fa-pizza-slice:before {\n  content: \"\\f818\";\n}\n\n.fa-place-of-worship:before {\n  content: \"\\f67f\";\n}\n\n.fa-plane:before {\n  content: \"\\f072\";\n}\n\n.fa-plane-arrival:before {\n  content: \"\\f5af\";\n}\n\n.fa-plane-departure:before {\n  content: \"\\f5b0\";\n}\n\n.fa-play:before {\n  content: \"\\f04b\";\n}\n\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n\n.fa-playstation:before {\n  content: \"\\f3df\";\n}\n\n.fa-plug:before {\n  content: \"\\f1e6\";\n}\n\n.fa-plus:before {\n  content: \"\\f067\";\n}\n\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n\n.fa-podcast:before {\n  content: \"\\f2ce\";\n}\n\n.fa-poll:before {\n  content: \"\\f681\";\n}\n\n.fa-poll-h:before {\n  content: \"\\f682\";\n}\n\n.fa-poo:before {\n  content: \"\\f2fe\";\n}\n\n.fa-poo-storm:before {\n  content: \"\\f75a\";\n}\n\n.fa-poop:before {\n  content: \"\\f619\";\n}\n\n.fa-portrait:before {\n  content: \"\\f3e0\";\n}\n\n.fa-pound-sign:before {\n  content: \"\\f154\";\n}\n\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n\n.fa-pray:before {\n  content: \"\\f683\";\n}\n\n.fa-praying-hands:before {\n  content: \"\\f684\";\n}\n\n.fa-prescription:before {\n  content: \"\\f5b1\";\n}\n\n.fa-prescription-bottle:before {\n  content: \"\\f485\";\n}\n\n.fa-prescription-bottle-alt:before {\n  content: \"\\f486\";\n}\n\n.fa-print:before {\n  content: \"\\f02f\";\n}\n\n.fa-procedures:before {\n  content: \"\\f487\";\n}\n\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n\n.fa-project-diagram:before {\n  content: \"\\f542\";\n}\n\n.fa-pushed:before {\n  content: \"\\f3e1\";\n}\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n\n.fa-python:before {\n  content: \"\\f3e2\";\n}\n\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n\n.fa-question:before {\n  content: \"\\f128\";\n}\n\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n\n.fa-quidditch:before {\n  content: \"\\f458\";\n}\n\n.fa-quinscape:before {\n  content: \"\\f459\";\n}\n\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n\n.fa-quran:before {\n  content: \"\\f687\";\n}\n\n.fa-r-project:before {\n  content: \"\\f4f7\";\n}\n\n.fa-radiation:before {\n  content: \"\\f7b9\";\n}\n\n.fa-radiation-alt:before {\n  content: \"\\f7ba\";\n}\n\n.fa-rainbow:before {\n  content: \"\\f75b\";\n}\n\n.fa-random:before {\n  content: \"\\f074\";\n}\n\n.fa-raspberry-pi:before {\n  content: \"\\f7bb\";\n}\n\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n\n.fa-react:before {\n  content: \"\\f41b\";\n}\n\n.fa-reacteurope:before {\n  content: \"\\f75d\";\n}\n\n.fa-readme:before {\n  content: \"\\f4d5\";\n}\n\n.fa-rebel:before {\n  content: \"\\f1d0\";\n}\n\n.fa-receipt:before {\n  content: \"\\f543\";\n}\n\n.fa-recycle:before {\n  content: \"\\f1b8\";\n}\n\n.fa-red-river:before {\n  content: \"\\f3e3\";\n}\n\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n\n.fa-redhat:before {\n  content: \"\\f7bc\";\n}\n\n.fa-redo:before {\n  content: \"\\f01e\";\n}\n\n.fa-redo-alt:before {\n  content: \"\\f2f9\";\n}\n\n.fa-registered:before {\n  content: \"\\f25d\";\n}\n\n.fa-remove-format:before {\n  content: \"\\f87d\";\n}\n\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n\n.fa-reply:before {\n  content: \"\\f3e5\";\n}\n\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n\n.fa-replyd:before {\n  content: \"\\f3e6\";\n}\n\n.fa-republican:before {\n  content: \"\\f75e\";\n}\n\n.fa-researchgate:before {\n  content: \"\\f4f8\";\n}\n\n.fa-resolving:before {\n  content: \"\\f3e7\";\n}\n\n.fa-restroom:before {\n  content: \"\\f7bd\";\n}\n\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n\n.fa-rev:before {\n  content: \"\\f5b2\";\n}\n\n.fa-ribbon:before {\n  content: \"\\f4d6\";\n}\n\n.fa-ring:before {\n  content: \"\\f70b\";\n}\n\n.fa-road:before {\n  content: \"\\f018\";\n}\n\n.fa-robot:before {\n  content: \"\\f544\";\n}\n\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n\n.fa-rocketchat:before {\n  content: \"\\f3e8\";\n}\n\n.fa-rockrms:before {\n  content: \"\\f3e9\";\n}\n\n.fa-route:before {\n  content: \"\\f4d7\";\n}\n\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n\n.fa-ruble-sign:before {\n  content: \"\\f158\";\n}\n\n.fa-ruler:before {\n  content: \"\\f545\";\n}\n\n.fa-ruler-combined:before {\n  content: \"\\f546\";\n}\n\n.fa-ruler-horizontal:before {\n  content: \"\\f547\";\n}\n\n.fa-ruler-vertical:before {\n  content: \"\\f548\";\n}\n\n.fa-running:before {\n  content: \"\\f70c\";\n}\n\n.fa-rupee-sign:before {\n  content: \"\\f156\";\n}\n\n.fa-sad-cry:before {\n  content: \"\\f5b3\";\n}\n\n.fa-sad-tear:before {\n  content: \"\\f5b4\";\n}\n\n.fa-safari:before {\n  content: \"\\f267\";\n}\n\n.fa-salesforce:before {\n  content: \"\\f83b\";\n}\n\n.fa-sass:before {\n  content: \"\\f41e\";\n}\n\n.fa-satellite:before {\n  content: \"\\f7bf\";\n}\n\n.fa-satellite-dish:before {\n  content: \"\\f7c0\";\n}\n\n.fa-save:before {\n  content: \"\\f0c7\";\n}\n\n.fa-schlix:before {\n  content: \"\\f3ea\";\n}\n\n.fa-school:before {\n  content: \"\\f549\";\n}\n\n.fa-screwdriver:before {\n  content: \"\\f54a\";\n}\n\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n\n.fa-scroll:before {\n  content: \"\\f70e\";\n}\n\n.fa-sd-card:before {\n  content: \"\\f7c2\";\n}\n\n.fa-search:before {\n  content: \"\\f002\";\n}\n\n.fa-search-dollar:before {\n  content: \"\\f688\";\n}\n\n.fa-search-location:before {\n  content: \"\\f689\";\n}\n\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n\n.fa-searchengin:before {\n  content: \"\\f3eb\";\n}\n\n.fa-seedling:before {\n  content: \"\\f4d8\";\n}\n\n.fa-sellcast:before {\n  content: \"\\f2da\";\n}\n\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n\n.fa-server:before {\n  content: \"\\f233\";\n}\n\n.fa-servicestack:before {\n  content: \"\\f3ec\";\n}\n\n.fa-shapes:before {\n  content: \"\\f61f\";\n}\n\n.fa-share:before {\n  content: \"\\f064\";\n}\n\n.fa-share-alt:before {\n  content: \"\\f1e0\";\n}\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\";\n}\n\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n\n.fa-shekel-sign:before {\n  content: \"\\f20b\";\n}\n\n.fa-shield-alt:before {\n  content: \"\\f3ed\";\n}\n\n.fa-ship:before {\n  content: \"\\f21a\";\n}\n\n.fa-shipping-fast:before {\n  content: \"\\f48b\";\n}\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n\n.fa-shoe-prints:before {\n  content: \"\\f54b\";\n}\n\n.fa-shopping-bag:before {\n  content: \"\\f290\";\n}\n\n.fa-shopping-basket:before {\n  content: \"\\f291\";\n}\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n\n.fa-shopware:before {\n  content: \"\\f5b5\";\n}\n\n.fa-shower:before {\n  content: \"\\f2cc\";\n}\n\n.fa-shuttle-van:before {\n  content: \"\\f5b6\";\n}\n\n.fa-sign:before {\n  content: \"\\f4d9\";\n}\n\n.fa-sign-in-alt:before {\n  content: \"\\f2f6\";\n}\n\n.fa-sign-language:before {\n  content: \"\\f2a7\";\n}\n\n.fa-sign-out-alt:before {\n  content: \"\\f2f5\";\n}\n\n.fa-signal:before {\n  content: \"\\f012\";\n}\n\n.fa-signature:before {\n  content: \"\\f5b7\";\n}\n\n.fa-sim-card:before {\n  content: \"\\f7c4\";\n}\n\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n\n.fa-sistrix:before {\n  content: \"\\f3ee\";\n}\n\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n\n.fa-sith:before {\n  content: \"\\f512\";\n}\n\n.fa-skating:before {\n  content: \"\\f7c5\";\n}\n\n.fa-sketch:before {\n  content: \"\\f7c6\";\n}\n\n.fa-skiing:before {\n  content: \"\\f7c9\";\n}\n\n.fa-skiing-nordic:before {\n  content: \"\\f7ca\";\n}\n\n.fa-skull:before {\n  content: \"\\f54c\";\n}\n\n.fa-skull-crossbones:before {\n  content: \"\\f714\";\n}\n\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n\n.fa-slack:before {\n  content: \"\\f198\";\n}\n\n.fa-slack-hash:before {\n  content: \"\\f3ef\";\n}\n\n.fa-slash:before {\n  content: \"\\f715\";\n}\n\n.fa-sleigh:before {\n  content: \"\\f7cc\";\n}\n\n.fa-sliders-h:before {\n  content: \"\\f1de\";\n}\n\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n\n.fa-smile:before {\n  content: \"\\f118\";\n}\n\n.fa-smile-beam:before {\n  content: \"\\f5b8\";\n}\n\n.fa-smile-wink:before {\n  content: \"\\f4da\";\n}\n\n.fa-smog:before {\n  content: \"\\f75f\";\n}\n\n.fa-smoking:before {\n  content: \"\\f48d\";\n}\n\n.fa-smoking-ban:before {\n  content: \"\\f54d\";\n}\n\n.fa-sms:before {\n  content: \"\\f7cd\";\n}\n\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\";\n}\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n\n.fa-snowboarding:before {\n  content: \"\\f7ce\";\n}\n\n.fa-snowflake:before {\n  content: \"\\f2dc\";\n}\n\n.fa-snowman:before {\n  content: \"\\f7d0\";\n}\n\n.fa-snowplow:before {\n  content: \"\\f7d2\";\n}\n\n.fa-socks:before {\n  content: \"\\f696\";\n}\n\n.fa-solar-panel:before {\n  content: \"\\f5ba\";\n}\n\n.fa-sort:before {\n  content: \"\\f0dc\";\n}\n\n.fa-sort-alpha-down:before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-down-alt:before {\n  content: \"\\f881\";\n}\n\n.fa-sort-alpha-up:before {\n  content: \"\\f15e\";\n}\n\n.fa-sort-alpha-up-alt:before {\n  content: \"\\f882\";\n}\n\n.fa-sort-amount-down:before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-down-alt:before {\n  content: \"\\f884\";\n}\n\n.fa-sort-amount-up:before {\n  content: \"\\f161\";\n}\n\n.fa-sort-amount-up-alt:before {\n  content: \"\\f885\";\n}\n\n.fa-sort-down:before {\n  content: \"\\f0dd\";\n}\n\n.fa-sort-numeric-down:before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-down-alt:before {\n  content: \"\\f886\";\n}\n\n.fa-sort-numeric-up:before {\n  content: \"\\f163\";\n}\n\n.fa-sort-numeric-up-alt:before {\n  content: \"\\f887\";\n}\n\n.fa-sort-up:before {\n  content: \"\\f0de\";\n}\n\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n\n.fa-sourcetree:before {\n  content: \"\\f7d3\";\n}\n\n.fa-spa:before {\n  content: \"\\f5bb\";\n}\n\n.fa-space-shuttle:before {\n  content: \"\\f197\";\n}\n\n.fa-speakap:before {\n  content: \"\\f3f3\";\n}\n\n.fa-speaker-deck:before {\n  content: \"\\f83c\";\n}\n\n.fa-spell-check:before {\n  content: \"\\f891\";\n}\n\n.fa-spider:before {\n  content: \"\\f717\";\n}\n\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n\n.fa-splotch:before {\n  content: \"\\f5bc\";\n}\n\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n\n.fa-spray-can:before {\n  content: \"\\f5bd\";\n}\n\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n\n.fa-square-full:before {\n  content: \"\\f45c\";\n}\n\n.fa-square-root-alt:before {\n  content: \"\\f698\";\n}\n\n.fa-squarespace:before {\n  content: \"\\f5be\";\n}\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n\n.fa-stackpath:before {\n  content: \"\\f842\";\n}\n\n.fa-stamp:before {\n  content: \"\\f5bf\";\n}\n\n.fa-star:before {\n  content: \"\\f005\";\n}\n\n.fa-star-and-crescent:before {\n  content: \"\\f699\";\n}\n\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n\n.fa-star-half-alt:before {\n  content: \"\\f5c0\";\n}\n\n.fa-star-of-david:before {\n  content: \"\\f69a\";\n}\n\n.fa-star-of-life:before {\n  content: \"\\f621\";\n}\n\n.fa-staylinked:before {\n  content: \"\\f3f5\";\n}\n\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n\n.fa-steam-symbol:before {\n  content: \"\\f3f6\";\n}\n\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n\n.fa-sticker-mule:before {\n  content: \"\\f3f7\";\n}\n\n.fa-sticky-note:before {\n  content: \"\\f249\";\n}\n\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n\n.fa-stop-circle:before {\n  content: \"\\f28d\";\n}\n\n.fa-stopwatch:before {\n  content: \"\\f2f2\";\n}\n\n.fa-store:before {\n  content: \"\\f54e\";\n}\n\n.fa-store-alt:before {\n  content: \"\\f54f\";\n}\n\n.fa-strava:before {\n  content: \"\\f428\";\n}\n\n.fa-stream:before {\n  content: \"\\f550\";\n}\n\n.fa-street-view:before {\n  content: \"\\f21d\";\n}\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n\n.fa-stripe:before {\n  content: \"\\f429\";\n}\n\n.fa-stripe-s:before {\n  content: \"\\f42a\";\n}\n\n.fa-stroopwafel:before {\n  content: \"\\f551\";\n}\n\n.fa-studiovinari:before {\n  content: \"\\f3f8\";\n}\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n\n.fa-subway:before {\n  content: \"\\f239\";\n}\n\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n\n.fa-suitcase-rolling:before {\n  content: \"\\f5c1\";\n}\n\n.fa-sun:before {\n  content: \"\\f185\";\n}\n\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n\n.fa-supple:before {\n  content: \"\\f3f9\";\n}\n\n.fa-surprise:before {\n  content: \"\\f5c2\";\n}\n\n.fa-suse:before {\n  content: \"\\f7d6\";\n}\n\n.fa-swatchbook:before {\n  content: \"\\f5c3\";\n}\n\n.fa-swimmer:before {\n  content: \"\\f5c4\";\n}\n\n.fa-swimming-pool:before {\n  content: \"\\f5c5\";\n}\n\n.fa-symfony:before {\n  content: \"\\f83d\";\n}\n\n.fa-synagogue:before {\n  content: \"\\f69b\";\n}\n\n.fa-sync:before {\n  content: \"\\f021\";\n}\n\n.fa-sync-alt:before {\n  content: \"\\f2f1\";\n}\n\n.fa-syringe:before {\n  content: \"\\f48e\";\n}\n\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n\n.fa-table-tennis:before {\n  content: \"\\f45d\";\n}\n\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n\n.fa-tablet-alt:before {\n  content: \"\\f3fa\";\n}\n\n.fa-tablets:before {\n  content: \"\\f490\";\n}\n\n.fa-tachometer-alt:before {\n  content: \"\\f3fd\";\n}\n\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n\n.fa-tape:before {\n  content: \"\\f4db\";\n}\n\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n\n.fa-taxi:before {\n  content: \"\\f1ba\";\n}\n\n.fa-teamspeak:before {\n  content: \"\\f4f9\";\n}\n\n.fa-teeth:before {\n  content: \"\\f62e\";\n}\n\n.fa-teeth-open:before {\n  content: \"\\f62f\";\n}\n\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n\n.fa-telegram-plane:before {\n  content: \"\\f3fe\";\n}\n\n.fa-temperature-high:before {\n  content: \"\\f769\";\n}\n\n.fa-temperature-low:before {\n  content: \"\\f76b\";\n}\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n\n.fa-tenge:before {\n  content: \"\\f7d7\";\n}\n\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n\n.fa-th:before {\n  content: \"\\f00a\";\n}\n\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n\n.fa-the-red-yeti:before {\n  content: \"\\f69d\";\n}\n\n.fa-theater-masks:before {\n  content: \"\\f630\";\n}\n\n.fa-themeco:before {\n  content: \"\\f5c6\";\n}\n\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n\n.fa-thermometer:before {\n  content: \"\\f491\";\n}\n\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\";\n}\n\n.fa-thermometer-full:before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-half:before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\";\n}\n\n.fa-think-peaks:before {\n  content: \"\\f731\";\n}\n\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n\n.fa-thumbtack:before {\n  content: \"\\f08d\";\n}\n\n.fa-ticket-alt:before {\n  content: \"\\f3ff\";\n}\n\n.fa-times:before {\n  content: \"\\f00d\";\n}\n\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n\n.fa-tint:before {\n  content: \"\\f043\";\n}\n\n.fa-tint-slash:before {\n  content: \"\\f5c7\";\n}\n\n.fa-tired:before {\n  content: \"\\f5c8\";\n}\n\n.fa-toggle-off:before {\n  content: \"\\f204\";\n}\n\n.fa-toggle-on:before {\n  content: \"\\f205\";\n}\n\n.fa-toilet:before {\n  content: \"\\f7d8\";\n}\n\n.fa-toilet-paper:before {\n  content: \"\\f71e\";\n}\n\n.fa-toolbox:before {\n  content: \"\\f552\";\n}\n\n.fa-tools:before {\n  content: \"\\f7d9\";\n}\n\n.fa-tooth:before {\n  content: \"\\f5c9\";\n}\n\n.fa-torah:before {\n  content: \"\\f6a0\";\n}\n\n.fa-torii-gate:before {\n  content: \"\\f6a1\";\n}\n\n.fa-tractor:before {\n  content: \"\\f722\";\n}\n\n.fa-trade-federation:before {\n  content: \"\\f513\";\n}\n\n.fa-trademark:before {\n  content: \"\\f25c\";\n}\n\n.fa-traffic-light:before {\n  content: \"\\f637\";\n}\n\n.fa-train:before {\n  content: \"\\f238\";\n}\n\n.fa-tram:before {\n  content: \"\\f7da\";\n}\n\n.fa-transgender:before {\n  content: \"\\f224\";\n}\n\n.fa-transgender-alt:before {\n  content: \"\\f225\";\n}\n\n.fa-trash:before {\n  content: \"\\f1f8\";\n}\n\n.fa-trash-alt:before {\n  content: \"\\f2ed\";\n}\n\n.fa-trash-restore:before {\n  content: \"\\f829\";\n}\n\n.fa-trash-restore-alt:before {\n  content: \"\\f82a\";\n}\n\n.fa-tree:before {\n  content: \"\\f1bb\";\n}\n\n.fa-trello:before {\n  content: \"\\f181\";\n}\n\n.fa-tripadvisor:before {\n  content: \"\\f262\";\n}\n\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n\n.fa-truck-loading:before {\n  content: \"\\f4de\";\n}\n\n.fa-truck-monster:before {\n  content: \"\\f63b\";\n}\n\n.fa-truck-moving:before {\n  content: \"\\f4df\";\n}\n\n.fa-truck-pickup:before {\n  content: \"\\f63c\";\n}\n\n.fa-tshirt:before {\n  content: \"\\f553\";\n}\n\n.fa-tty:before {\n  content: \"\\f1e4\";\n}\n\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n\n.fa-tv:before {\n  content: \"\\f26c\";\n}\n\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n\n.fa-typo3:before {\n  content: \"\\f42b\";\n}\n\n.fa-uber:before {\n  content: \"\\f402\";\n}\n\n.fa-ubuntu:before {\n  content: \"\\f7df\";\n}\n\n.fa-uikit:before {\n  content: \"\\f403\";\n}\n\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n\n.fa-umbrella-beach:before {\n  content: \"\\f5ca\";\n}\n\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n\n.fa-undo-alt:before {\n  content: \"\\f2ea\";\n}\n\n.fa-uniregistry:before {\n  content: \"\\f404\";\n}\n\n.fa-universal-access:before {\n  content: \"\\f29a\";\n}\n\n.fa-university:before {\n  content: \"\\f19c\";\n}\n\n.fa-unlink:before {\n  content: \"\\f127\";\n}\n\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n\n.fa-untappd:before {\n  content: \"\\f405\";\n}\n\n.fa-upload:before {\n  content: \"\\f093\";\n}\n\n.fa-ups:before {\n  content: \"\\f7e0\";\n}\n\n.fa-usb:before {\n  content: \"\\f287\";\n}\n\n.fa-user:before {\n  content: \"\\f007\";\n}\n\n.fa-user-alt:before {\n  content: \"\\f406\";\n}\n\n.fa-user-alt-slash:before {\n  content: \"\\f4fa\";\n}\n\n.fa-user-astronaut:before {\n  content: \"\\f4fb\";\n}\n\n.fa-user-check:before {\n  content: \"\\f4fc\";\n}\n\n.fa-user-circle:before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-clock:before {\n  content: \"\\f4fd\";\n}\n\n.fa-user-cog:before {\n  content: \"\\f4fe\";\n}\n\n.fa-user-edit:before {\n  content: \"\\f4ff\";\n}\n\n.fa-user-friends:before {\n  content: \"\\f500\";\n}\n\n.fa-user-graduate:before {\n  content: \"\\f501\";\n}\n\n.fa-user-injured:before {\n  content: \"\\f728\";\n}\n\n.fa-user-lock:before {\n  content: \"\\f502\";\n}\n\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n\n.fa-user-minus:before {\n  content: \"\\f503\";\n}\n\n.fa-user-ninja:before {\n  content: \"\\f504\";\n}\n\n.fa-user-nurse:before {\n  content: \"\\f82f\";\n}\n\n.fa-user-plus:before {\n  content: \"\\f234\";\n}\n\n.fa-user-secret:before {\n  content: \"\\f21b\";\n}\n\n.fa-user-shield:before {\n  content: \"\\f505\";\n}\n\n.fa-user-slash:before {\n  content: \"\\f506\";\n}\n\n.fa-user-tag:before {\n  content: \"\\f507\";\n}\n\n.fa-user-tie:before {\n  content: \"\\f508\";\n}\n\n.fa-user-times:before {\n  content: \"\\f235\";\n}\n\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n\n.fa-users-cog:before {\n  content: \"\\f509\";\n}\n\n.fa-usps:before {\n  content: \"\\f7e1\";\n}\n\n.fa-ussunnah:before {\n  content: \"\\f407\";\n}\n\n.fa-utensil-spoon:before {\n  content: \"\\f2e5\";\n}\n\n.fa-utensils:before {\n  content: \"\\f2e7\";\n}\n\n.fa-vaadin:before {\n  content: \"\\f408\";\n}\n\n.fa-vector-square:before {\n  content: \"\\f5cb\";\n}\n\n.fa-venus:before {\n  content: \"\\f221\";\n}\n\n.fa-venus-double:before {\n  content: \"\\f226\";\n}\n\n.fa-venus-mars:before {\n  content: \"\\f228\";\n}\n\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n\n.fa-vial:before {\n  content: \"\\f492\";\n}\n\n.fa-vials:before {\n  content: \"\\f493\";\n}\n\n.fa-viber:before {\n  content: \"\\f409\";\n}\n\n.fa-video:before {\n  content: \"\\f03d\";\n}\n\n.fa-video-slash:before {\n  content: \"\\f4e2\";\n}\n\n.fa-vihara:before {\n  content: \"\\f6a7\";\n}\n\n.fa-vimeo:before {\n  content: \"\\f40a\";\n}\n\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n\n.fa-vimeo-v:before {\n  content: \"\\f27d\";\n}\n\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n\n.fa-vk:before {\n  content: \"\\f189\";\n}\n\n.fa-vnv:before {\n  content: \"\\f40b\";\n}\n\n.fa-voicemail:before {\n  content: \"\\f897\";\n}\n\n.fa-volleyball-ball:before {\n  content: \"\\f45f\";\n}\n\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n\n.fa-volume-mute:before {\n  content: \"\\f6a9\";\n}\n\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n\n.fa-vote-yea:before {\n  content: \"\\f772\";\n}\n\n.fa-vr-cardboard:before {\n  content: \"\\f729\";\n}\n\n.fa-vuejs:before {\n  content: \"\\f41f\";\n}\n\n.fa-walking:before {\n  content: \"\\f554\";\n}\n\n.fa-wallet:before {\n  content: \"\\f555\";\n}\n\n.fa-warehouse:before {\n  content: \"\\f494\";\n}\n\n.fa-water:before {\n  content: \"\\f773\";\n}\n\n.fa-wave-square:before {\n  content: \"\\f83e\";\n}\n\n.fa-waze:before {\n  content: \"\\f83f\";\n}\n\n.fa-weebly:before {\n  content: \"\\f5cc\";\n}\n\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n\n.fa-weight:before {\n  content: \"\\f496\";\n}\n\n.fa-weight-hanging:before {\n  content: \"\\f5cd\";\n}\n\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n\n.fa-whatsapp-square:before {\n  content: \"\\f40c\";\n}\n\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n\n.fa-whmcs:before {\n  content: \"\\f40d\";\n}\n\n.fa-wifi:before {\n  content: \"\\f1eb\";\n}\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n\n.fa-wind:before {\n  content: \"\\f72e\";\n}\n\n.fa-window-close:before {\n  content: \"\\f410\";\n}\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\";\n}\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n\n.fa-window-restore:before {\n  content: \"\\f2d2\";\n}\n\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n\n.fa-wine-bottle:before {\n  content: \"\\f72f\";\n}\n\n.fa-wine-glass:before {\n  content: \"\\f4e3\";\n}\n\n.fa-wine-glass-alt:before {\n  content: \"\\f5ce\";\n}\n\n.fa-wix:before {\n  content: \"\\f5cf\";\n}\n\n.fa-wizards-of-the-coast:before {\n  content: \"\\f730\";\n}\n\n.fa-wolf-pack-battalion:before {\n  content: \"\\f514\";\n}\n\n.fa-won-sign:before {\n  content: \"\\f159\";\n}\n\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n\n.fa-wordpress-simple:before {\n  content: \"\\f411\";\n}\n\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n\n.fa-wpressr:before {\n  content: \"\\f3e4\";\n}\n\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n\n.fa-x-ray:before {\n  content: \"\\f497\";\n}\n\n.fa-xbox:before {\n  content: \"\\f412\";\n}\n\n.fa-xing:before {\n  content: \"\\f168\";\n}\n\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n\n.fa-y-combinator:before {\n  content: \"\\f23b\";\n}\n\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n\n.fa-yammer:before {\n  content: \"\\f840\";\n}\n\n.fa-yandex:before {\n  content: \"\\f413\";\n}\n\n.fa-yandex-international:before {\n  content: \"\\f414\";\n}\n\n.fa-yarn:before {\n  content: \"\\f7e3\";\n}\n\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n\n.fa-yen-sign:before {\n  content: \"\\f157\";\n}\n\n.fa-yin-yang:before {\n  content: \"\\f6ad\";\n}\n\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n\n.fa-youtube-square:before {\n  content: \"\\f431\";\n}\n\n.fa-zhihu:before {\n  content: \"\\f63f\";\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n@font-face {\n  font-family: \"Font Awesome 5 Brands\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(../webfonts/fa-brands-400.eot);\n  src: url(../webfonts/fa-brands-400.eot?#iefix) format(\"embedded-opentype\"),\n    url(../webfonts/fa-brands-400.woff2) format(\"woff2\"),\n    url(../webfonts/fa-brands-400.woff) format(\"woff\"),\n    url(../webfonts/fa-brands-400.ttf) format(\"truetype\"),\n    url(../webfonts/fa-brands-400.svg#fontawesome) format(\"svg\");\n}\n\n.fab {\n  font-family: \"Font Awesome 5 Brands\";\n}\n\n@font-face {\n  font-family: \"Font Awesome 5 Free\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(../webfonts/fa-regular-400.eot);\n  src: url(../webfonts/fa-regular-400.eot?#iefix) format(\"embedded-opentype\"),\n    url(../webfonts/fa-regular-400.woff2) format(\"woff2\"),\n    url(../webfonts/fa-regular-400.woff) format(\"woff\"),\n    url(../webfonts/fa-regular-400.ttf) format(\"truetype\"),\n    url(../webfonts/fa-regular-400.svg#fontawesome) format(\"svg\");\n}\n\n.far {\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Font Awesome 5 Free\";\n  font-style: normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(../webfonts/fa-solid-900.eot);\n  src: url(../webfonts/fa-solid-900.eot?#iefix) format(\"embedded-opentype\"),\n    url(../webfonts/fa-solid-900.woff2) format(\"woff2\"),\n    url(../webfonts/fa-solid-900.woff) format(\"woff\"),\n    url(../webfonts/fa-solid-900.ttf) format(\"truetype\"),\n    url(../webfonts/fa-solid-900.svg#fontawesome) format(\"svg\");\n}\n\n.fa,\n.far,\n.fas {\n  font-family: \"Font Awesome 5 Free\";\n}\n\n.fa,\n.fas {\n  font-weight: 900;\n}\n\n/*! jQuery UI - v1.12.1 - 2016-09-14\n* http://jqueryui.com\n* Includes: core.css, accordion.css, autocomplete.css, menu.css, button.css, controlgroup.css, checkboxradio.css, datepicker.css, dialog.css, draggable.css, resizable.css, progressbar.css, selectable.css, selectmenu.css, slider.css, sortable.css, spinner.css, tabs.css, tooltip.css, theme.css\n* To view and modify this theme, visit http://jqueryui.com/themeroller/?bgShadowXPos=&bgOverlayXPos=&bgErrorXPos=&bgHighlightXPos=&bgContentXPos=&bgHeaderXPos=&bgActiveXPos=&bgHoverXPos=&bgDefaultXPos=&bgShadowYPos=&bgOverlayYPos=&bgErrorYPos=&bgHighlightYPos=&bgContentYPos=&bgHeaderYPos=&bgActiveYPos=&bgHoverYPos=&bgDefaultYPos=&bgShadowRepeat=&bgOverlayRepeat=&bgErrorRepeat=&bgHighlightRepeat=&bgContentRepeat=&bgHeaderRepeat=&bgActiveRepeat=&bgHoverRepeat=&bgDefaultRepeat=&iconsHover=url(%22images%2Fui-icons_555555_256x240.png%22)&iconsHighlight=url(%22images%2Fui-icons_777620_256x240.png%22)&iconsHeader=url(%22images%2Fui-icons_444444_256x240.png%22)&iconsError=url(%22images%2Fui-icons_cc0000_256x240.png%22)&iconsDefault=url(%22images%2Fui-icons_777777_256x240.png%22)&iconsContent=url(%22images%2Fui-icons_444444_256x240.png%22)&iconsActive=url(%22images%2Fui-icons_ffffff_256x240.png%22)&bgImgUrlShadow=&bgImgUrlOverlay=&bgImgUrlHover=&bgImgUrlHighlight=&bgImgUrlHeader=&bgImgUrlError=&bgImgUrlDefault=&bgImgUrlContent=&bgImgUrlActive=&opacityFilterShadow=Alpha(Opacity%3D30)&opacityFilterOverlay=Alpha(Opacity%3D30)&opacityShadowPerc=30&opacityOverlayPerc=30&iconColorHover=%23555555&iconColorHighlight=%23777620&iconColorHeader=%23444444&iconColorError=%23cc0000&iconColorDefault=%23777777&iconColorContent=%23444444&iconColorActive=%23ffffff&bgImgOpacityShadow=0&bgImgOpacityOverlay=0&bgImgOpacityError=95&bgImgOpacityHighlight=55&bgImgOpacityContent=75&bgImgOpacityHeader=75&bgImgOpacityActive=65&bgImgOpacityHover=75&bgImgOpacityDefault=75&bgTextureShadow=flat&bgTextureOverlay=flat&bgTextureError=flat&bgTextureHighlight=flat&bgTextureContent=flat&bgTextureHeader=flat&bgTextureActive=flat&bgTextureHover=flat&bgTextureDefault=flat&cornerRadius=3px&fwDefault=normal&ffDefault=Arial%2CHelvetica%2Csans-serif&fsDefault=1em&cornerRadiusShadow=8px&thicknessShadow=5px&offsetLeftShadow=0px&offsetTopShadow=0px&opacityShadow=.3&bgColorShadow=%23666666&opacityOverlay=.3&bgColorOverlay=%23aaaaaa&fcError=%235f3f3f&borderColorError=%23f1a899&bgColorError=%23fddfdf&fcHighlight=%23777620&borderColorHighlight=%23dad55e&bgColorHighlight=%23fffa90&fcContent=%23333333&borderColorContent=%23dddddd&bgColorContent=%23ffffff&fcHeader=%23333333&borderColorHeader=%23dddddd&bgColorHeader=%23e9e9e9&fcActive=%23ffffff&borderColorActive=%23003eff&bgColorActive=%23007fff&fcHover=%232b2b2b&borderColorHover=%23cccccc&bgColorHover=%23ededed&fcDefault=%23454545&borderColorDefault=%23c5c5c5&bgColorDefault=%23f6f6f6\n* Copyright jQuery Foundation and other contributors; Licensed MIT */\n\n@-webkit-keyframes pace-spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes pace-spinner {\n  0% {\n    -moz-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -moz-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-o-keyframes pace-spinner {\n  0% {\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-ms-keyframes pace-spinner {\n  0% {\n    -ms-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pace-spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ui-helper-hidden {\n  display: none;\n}\n\n.ui-helper-hidden-accessible {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.ui-helper-reset {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  line-height: 1.3;\n  text-decoration: none;\n  font-size: 100%;\n  list-style: none;\n}\n\n.ui-helper-clearfix:after,\n.ui-helper-clearfix:before {\n  content: \"\";\n  display: table;\n  border-collapse: collapse;\n}\n\n.ui-helper-clearfix:after {\n  clear: both;\n}\n\n.ui-helper-zfix {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  filter: Alpha(Opacity=0);\n}\n\n.ui-front {\n  z-index: 100;\n}\n\n.ui-state-disabled {\n  cursor: default !important;\n  pointer-events: none;\n}\n\n.ui-icon {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: -0.25em;\n  position: relative;\n  text-indent: -99999px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n}\n\n.ui-widget-icon-block {\n  left: 50%;\n  margin-left: -8px;\n  display: block;\n}\n\n.ui-widget-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ui-accordion .ui-accordion-header {\n  display: block;\n  cursor: pointer;\n  position: relative;\n  margin: 2px 0 0;\n  padding: 0.5em 0.5em 0.5em 0.7em;\n  font-size: 100%;\n}\n\n.ui-accordion .ui-accordion-content {\n  padding: 1em 2.2em;\n  border-top: 0;\n  overflow: auto;\n}\n\n.ui-autocomplete {\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: default;\n}\n\n.ui-menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: block;\n  outline: 0;\n}\n\n.ui-menu .ui-menu {\n  position: absolute;\n}\n\n.ui-menu .ui-menu-item {\n  margin: 0;\n  cursor: pointer;\n  list-style-image: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);\n}\n\n.ui-menu .ui-menu-item-wrapper {\n  position: relative;\n  padding: 3px 1em 3px 0.4em;\n}\n\n.ui-menu .ui-menu-divider {\n  margin: 5px 0;\n  height: 0;\n  font-size: 0;\n  line-height: 0;\n  border-width: 1px 0 0;\n}\n\n.ui-menu .ui-state-active,\n.ui-menu .ui-state-focus {\n  margin: -1px;\n}\n\n.ui-button,\n.ui-menu-icons {\n  position: relative;\n}\n\n.ui-menu-icons .ui-menu-item-wrapper {\n  padding-left: 2em;\n}\n\n.ui-menu .ui-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0.2em;\n  margin: auto 0;\n}\n\n.ui-menu .ui-menu-icon {\n  left: auto;\n  right: 0;\n}\n\n.ui-button {\n  padding: 0.4em 1em;\n  display: inline-block;\n  line-height: normal;\n  margin-right: 0.1em;\n  cursor: pointer;\n  vertical-align: middle;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow: visible;\n}\n\n.ui-button:active,\n.ui-button:hover,\n.ui-button:link,\n.ui-button:visited {\n  text-decoration: none;\n}\n\n.ui-button-icon-only {\n  width: 2em;\n  box-sizing: border-box;\n  text-indent: -9999px;\n  white-space: nowrap;\n}\n\ninput.ui-button.ui-button-icon-only {\n  text-indent: 0;\n}\n\n.ui-button-icon-only .ui-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -8px;\n  margin-left: -8px;\n}\n\n.ui-button.ui-icon-notext .ui-icon {\n  padding: 0;\n  width: 2.1em;\n  height: 2.1em;\n  text-indent: -9999px;\n  white-space: nowrap;\n}\n\ninput.ui-button.ui-icon-notext .ui-icon {\n  width: auto;\n  height: auto;\n  text-indent: 0;\n  white-space: normal;\n  padding: 0.4em 1em;\n}\n\nbutton.ui-button::-moz-focus-inner,\ninput.ui-button::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.ui-controlgroup {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.ui-controlgroup > .ui-controlgroup-item {\n  float: left;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.ui-controlgroup > .ui-controlgroup-item.ui-visual-focus,\n.ui-controlgroup > .ui-controlgroup-item:focus {\n  z-index: 9999;\n}\n\n.ui-controlgroup-vertical > .ui-controlgroup-item {\n  display: block;\n  float: none;\n  width: 100%;\n  margin-top: 0;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-item {\n  box-sizing: border-box;\n}\n\n.ui-controlgroup .ui-controlgroup-label {\n  padding: 0.4em 1em;\n}\n\n.ui-controlgroup .ui-controlgroup-label span {\n  font-size: 80%;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label + .ui-controlgroup-item {\n  border-left: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label + .ui-controlgroup-item {\n  border-top: none;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {\n  border-right: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {\n  border-bottom: none;\n}\n\n.ui-controlgroup-vertical .ui-spinner-input {\n  width: 75%;\n  width: calc(100% - 2.4em);\n}\n\n.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {\n  border-top-style: solid;\n}\n\n.ui-checkboxradio-label .ui-icon-background {\n  box-shadow: inset 1px 1px 1px #ccc;\n  border-radius: 0.12em;\n  border: 0;\n}\n\n.ui-checkboxradio-radio-label .ui-icon-background {\n  width: 16px;\n  height: 16px;\n  border-radius: 1em;\n  overflow: visible;\n  border: 0;\n}\n\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {\n  background-image: none;\n  width: 8px;\n  height: 8px;\n  border-width: 4px;\n  border-style: solid;\n}\n\n.ui-checkboxradio-disabled {\n  pointer-events: none;\n}\n\n.ui-datepicker {\n  width: 17em;\n  padding: 0.2em 0.2em 0;\n  display: none;\n}\n\n.ui-datepicker .ui-datepicker-header {\n  position: relative;\n  padding: 0.2em 0;\n}\n\n.ui-datepicker .ui-datepicker-next,\n.ui-datepicker .ui-datepicker-prev {\n  position: absolute;\n  top: 2px;\n  width: 1.8em;\n  height: 1.8em;\n}\n\n.ui-datepicker .ui-datepicker-next-hover,\n.ui-datepicker .ui-datepicker-prev-hover {\n  top: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev {\n  left: 2px;\n}\n\n.ui-datepicker .ui-datepicker-next {\n  right: 2px;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover {\n  left: 1px;\n}\n\n.ui-datepicker .ui-datepicker-next-hover {\n  right: 1px;\n}\n\n.ui-datepicker .ui-datepicker-next span,\n.ui-datepicker .ui-datepicker-prev span {\n  display: block;\n  position: absolute;\n  left: 50%;\n  margin-left: -8px;\n  top: 50%;\n  margin-top: -8px;\n}\n\n.ui-datepicker .ui-datepicker-title {\n  margin: 0 2.3em;\n  line-height: 1.8em;\n  text-align: center;\n}\n\n.ui-datepicker .ui-datepicker-title select {\n  font-size: 1em;\n  margin: 1px 0;\n}\n\n.ui-datepicker select.ui-datepicker-month,\n.ui-datepicker select.ui-datepicker-year {\n  width: 45%;\n}\n\n.ui-datepicker table {\n  width: 100%;\n  font-size: 0.9em;\n  border-collapse: collapse;\n  margin: 0 0 0.4em;\n}\n\n.ui-datepicker th {\n  padding: 0.7em 0.3em;\n  text-align: center;\n  font-weight: 700;\n  border: 0;\n}\n\n.ui-datepicker td {\n  border: 0;\n  padding: 1px;\n}\n\n.ui-datepicker td a,\n.ui-datepicker td span {\n  display: block;\n  padding: 0.2em;\n  text-align: right;\n  text-decoration: none;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane {\n  background-image: none;\n  margin: 0.7em 0 0;\n  padding: 0 0.2em;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button {\n  float: right;\n  margin: 0.5em 0.2em 0.4em;\n  cursor: pointer;\n  padding: 0.2em 0.6em 0.3em;\n  width: auto;\n  overflow: visible;\n}\n\n.ui-datepicker.ui-datepicker-multi {\n  width: auto;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-multi .ui-datepicker-group,\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\n  float: left;\n}\n\n.ui-datepicker-multi .ui-datepicker-group table {\n  width: 95%;\n  margin: 0 auto 0.4em;\n}\n\n.ui-datepicker-multi-2 .ui-datepicker-group {\n  width: 50%;\n}\n\n.ui-datepicker-multi-3 .ui-datepicker-group {\n  width: 33.3%;\n}\n\n.ui-datepicker-multi-4 .ui-datepicker-group {\n  width: 25%;\n}\n\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\n  border-left-width: 0;\n}\n\n.ui-datepicker-multi .ui-datepicker-buttonpane {\n  clear: left;\n}\n\n.ui-datepicker-row-break {\n  clear: both;\n  width: 100%;\n  font-size: 0;\n}\n\n.ui-datepicker-rtl {\n  direction: rtl;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev {\n  right: 2px;\n  left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next {\n  left: 2px;\n  right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\n  right: 1px;\n  left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next:hover {\n  left: 1px;\n  right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\n  clear: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-rtl .ui-datepicker-group {\n  float: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\n  border-right-width: 0;\n  border-left-width: 1px;\n}\n\n.ui-datepicker .ui-icon {\n  display: block;\n  text-indent: -99999px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n  left: 0.5em;\n  top: 0.3em;\n}\n\n.ui-dialog {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 0.2em;\n  outline: 0;\n}\n\n.ui-dialog .ui-dialog-titlebar {\n  padding: 0.4em 1em;\n  position: relative;\n}\n\n.ui-dialog .ui-dialog-title {\n  float: left;\n  margin: 0.1em 0;\n  white-space: nowrap;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ui-dialog .ui-dialog-titlebar-close {\n  position: absolute;\n  right: 0.3em;\n  top: 50%;\n  width: 20px;\n  margin: -10px 0 0;\n  padding: 1px;\n  height: 20px;\n}\n\n.ui-dialog .ui-dialog-content {\n  position: relative;\n  border: 0;\n  padding: 0.5em 1em;\n  background: 0 0;\n  overflow: auto;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n  text-align: left;\n  border-width: 1px 0 0;\n  background-image: none;\n  margin-top: 0.5em;\n  padding: 0.3em 1em 0.5em 0.4em;\n}\n\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n  float: right;\n}\n\n.ui-dialog .ui-dialog-buttonpane button {\n  margin: 0.5em 0.4em 0.5em 0;\n  cursor: pointer;\n}\n\n.ui-dialog .ui-resizable-n {\n  height: 2px;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-e {\n  width: 2px;\n  right: 0;\n}\n\n.ui-dialog .ui-resizable-s {\n  height: 2px;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-w {\n  width: 2px;\n  left: 0;\n}\n\n.ui-dialog .ui-resizable-ne,\n.ui-dialog .ui-resizable-nw,\n.ui-dialog .ui-resizable-se,\n.ui-dialog .ui-resizable-sw {\n  width: 7px;\n  height: 7px;\n}\n\n.ui-dialog .ui-resizable-se {\n  right: 0;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-sw {\n  left: 0;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-ne {\n  right: 0;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-nw {\n  left: 0;\n  top: 0;\n}\n\n.ui-draggable .ui-dialog-titlebar {\n  cursor: move;\n}\n\n.ui-draggable-handle {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-resizable {\n  position: relative;\n}\n\n.ui-resizable-handle {\n  position: absolute;\n  font-size: 0.1px;\n  display: block;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-resizable-autohide .ui-resizable-handle,\n.ui-resizable-disabled .ui-resizable-handle {\n  display: none;\n}\n\n.ui-resizable-n {\n  cursor: n-resize;\n  height: 7px;\n  width: 100%;\n  top: -5px;\n  left: 0;\n}\n\n.ui-resizable-s {\n  cursor: s-resize;\n  height: 7px;\n  width: 100%;\n  bottom: -5px;\n  left: 0;\n}\n\n.ui-resizable-e {\n  cursor: e-resize;\n  width: 7px;\n  right: -5px;\n  top: 0;\n  height: 100%;\n}\n\n.ui-resizable-w {\n  cursor: w-resize;\n  width: 7px;\n  left: -5px;\n  top: 0;\n  height: 100%;\n}\n\n.ui-resizable-se {\n  cursor: se-resize;\n  width: 12px;\n  height: 12px;\n  right: 1px;\n  bottom: 1px;\n}\n\n.ui-resizable-sw {\n  cursor: sw-resize;\n  width: 9px;\n  height: 9px;\n  left: -5px;\n  bottom: -5px;\n}\n\n.ui-resizable-nw {\n  cursor: nw-resize;\n  width: 9px;\n  height: 9px;\n  left: -5px;\n  top: -5px;\n}\n\n.ui-resizable-ne {\n  cursor: ne-resize;\n  width: 9px;\n  height: 9px;\n  right: -5px;\n  top: -5px;\n}\n\n.ui-progressbar {\n  height: 2em;\n  text-align: left;\n  overflow: hidden;\n}\n\n.ui-progressbar .ui-progressbar-value {\n  margin: -1px;\n  height: 100%;\n}\n\n.ui-progressbar .ui-progressbar-overlay {\n  background: url(data:image/gif;base64,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);\n  height: 100%;\n  filter: alpha(opacity=25);\n  opacity: 0.25;\n}\n\n.ui-progressbar-indeterminate .ui-progressbar-value {\n  background-image: none;\n}\n\n.ui-selectable {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-selectable-helper {\n  position: absolute;\n  z-index: 100;\n  border: 1px dotted #000;\n}\n\n.ui-selectmenu-menu {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: none;\n}\n\n.ui-selectmenu-menu .ui-menu {\n  overflow: auto;\n  overflow-x: hidden;\n  padding-bottom: 1px;\n}\n\n.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {\n  font-size: 1em;\n  font-weight: 700;\n  line-height: 1.5;\n  padding: 2px 0.4em;\n  margin: 0.5em 0 0;\n  height: auto;\n  border: 0;\n}\n\n.ui-selectmenu-open {\n  display: block;\n}\n\n.ui-selectmenu-text {\n  display: block;\n  margin-right: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ui-selectmenu-button.ui-button {\n  text-align: left;\n  white-space: nowrap;\n  width: 14em;\n}\n\n.ui-selectmenu-icon.ui-icon {\n  float: right;\n  margin-top: 0;\n}\n\n.ui-slider {\n  position: relative;\n  text-align: left;\n}\n\n.ui-slider .ui-slider-handle {\n  position: absolute;\n  z-index: 2;\n  width: 1.2em;\n  height: 1.2em;\n  cursor: default;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-slider .ui-slider-range {\n  position: absolute;\n  z-index: 1;\n  font-size: 0.7em;\n  display: block;\n  border: 0;\n  background-position: 0 0;\n}\n\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n  filter: inherit;\n}\n\n.ui-slider-horizontal {\n  height: 0.8em;\n}\n\n.ui-slider-horizontal .ui-slider-handle {\n  top: -0.3em;\n  margin-left: -0.6em;\n}\n\n.ui-slider-horizontal .ui-slider-range {\n  top: 0;\n  height: 100%;\n}\n\n.ui-slider-horizontal .ui-slider-range-min {\n  left: 0;\n}\n\n.ui-slider-horizontal .ui-slider-range-max {\n  right: 0;\n}\n\n.ui-slider-vertical {\n  width: 0.8em;\n  height: 100px;\n}\n\n.ui-slider-vertical .ui-slider-handle {\n  left: -0.3em;\n  margin-left: 0;\n  margin-bottom: -0.6em;\n}\n\n.ui-slider-vertical .ui-slider-range {\n  left: 0;\n  width: 100%;\n}\n\n.ui-slider-vertical .ui-slider-range-min {\n  bottom: 0;\n}\n\n.ui-slider-vertical .ui-slider-range-max {\n  top: 0;\n}\n\n.ui-sortable-handle {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-spinner {\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  padding: 0;\n  vertical-align: middle;\n}\n\n.ui-spinner-input {\n  border: 0;\n  background: 0 0;\n  color: inherit;\n  padding: 0.222em 0;\n  vertical-align: middle;\n  margin: 0.2em 2em 0.2em 0.4em;\n}\n\n.ui-spinner-button {\n  width: 1.6em;\n  height: 50%;\n  font-size: 0.5em;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n  position: absolute;\n  cursor: default;\n  display: block;\n  overflow: hidden;\n  right: 0;\n}\n\n.ui-spinner a.ui-spinner-button {\n  border-top-style: none;\n  border-bottom-style: none;\n  border-right-style: none;\n}\n\n.ui-spinner-up {\n  top: 0;\n}\n\n.ui-spinner-down {\n  bottom: 0;\n}\n\n.ui-tabs {\n  position: relative;\n  padding: 0.2em;\n}\n\n.ui-tabs .ui-tabs-nav {\n  margin: 0;\n  padding: 0.2em 0.2em 0;\n}\n\n.ui-tabs .ui-tabs-nav li {\n  list-style: none;\n  float: left;\n  position: relative;\n  top: 0;\n  margin: 1px 0.2em 0 0;\n  border-bottom-width: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\n  float: left;\n  padding: 0.5em 1em;\n  text-decoration: none;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\n  margin-bottom: -1px;\n  padding-bottom: 1px;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {\n  cursor: text;\n}\n\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {\n  cursor: pointer;\n}\n\n.ui-tabs .ui-tabs-panel {\n  display: block;\n  border-width: 0;\n  padding: 1em 1.4em;\n  background: 0 0;\n}\n\n.ui-tooltip {\n  padding: 8px;\n  position: absolute;\n  z-index: 9999;\n  max-width: 300px;\n}\n\nbody .ui-tooltip {\n  border-width: 2px;\n}\n\n.ui-widget,\n.ui-widget button,\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n}\n\n.ui-widget .ui-widget {\n  font-size: 1em;\n}\n\n.ui-widget.ui-widget-content {\n  border: 1px solid #c5c5c5;\n}\n\n.ui-widget-content {\n  border: 1px solid #ddd;\n  background: #fff;\n  color: #333;\n}\n\n.ui-widget-content a,\n.ui-widget-header a {\n  color: #333;\n}\n\n.ui-widget-header {\n  border: 1px solid #ddd;\n  background: #e9e9e9;\n  color: #333;\n  font-weight: 700;\n}\n\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default {\n  border: 1px solid #c5c5c5;\n  background: #f6f6f6;\n  font-weight: 400;\n  color: #454545;\n}\n\n.ui-button {\n  border: 1px solid #c5c5c5;\n  background: #f6f6f6;\n  font-weight: 400;\n}\n\nhtml .ui-button.ui-state-disabled:active,\nhtml .ui-button.ui-state-disabled:hover {\n  border: 1px solid #c5c5c5;\n  background: #f6f6f6;\n  font-weight: 400;\n  color: #454545;\n}\n\n.ui-button,\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited,\na.ui-button,\na:link.ui-button,\na:visited.ui-button {\n  color: #454545;\n  text-decoration: none;\n}\n\n.ui-button:focus,\n.ui-button:hover,\n.ui-state-focus,\n.ui-state-hover,\n.ui-widget-content .ui-state-focus,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-focus,\n.ui-widget-header .ui-state-hover {\n  border: 1px solid #ccc;\n  background: #ededed;\n  font-weight: 400;\n  color: #2b2b2b;\n}\n\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited,\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\na.ui-button:focus,\na.ui-button:hover {\n  color: #2b2b2b;\n  text-decoration: none;\n}\n\n.ui-visual-focus {\n  box-shadow: 0 0 3px 1px #5e9ed6;\n}\n\n.ui-button.ui-state-active:hover,\n.ui-button:active,\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active {\n  border: 1px solid #003eff;\n  background: #007fff;\n  font-weight: 400;\n  color: #fff;\n}\n\n.ui-icon-background,\n.ui-state-active .ui-icon-background {\n  border: #003eff;\n  background-color: #fff;\n}\n\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n  color: #fff;\n  text-decoration: none;\n}\n\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n  border: 1px solid #dad55e;\n  background: #fffa90;\n  color: #777620;\n}\n\n.ui-state-checked {\n  border: 1px solid #dad55e;\n  background: #fffa90;\n}\n\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n  color: #777620;\n}\n\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n  border: 1px solid #f1a899;\n  background: #fddfdf;\n  color: #5f3f3f;\n}\n\n.ui-state-error a,\n.ui-state-error-text,\n.ui-widget-content .ui-state-error a,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error a,\n.ui-widget-header .ui-state-error-text {\n  color: #5f3f3f;\n}\n\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n  font-weight: 700;\n}\n\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n  opacity: 0.7;\n  filter: Alpha(Opacity=70);\n  font-weight: 400;\n}\n\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n  opacity: 0.35;\n  filter: Alpha(Opacity=35);\n  background-image: none;\n}\n\n.ui-state-disabled .ui-icon {\n  filter: Alpha(Opacity=35);\n}\n\n.ui-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.ui-icon,\n.ui-widget-content .ui-icon,\n.ui-widget-header .ui-icon {\n  background-image: url(images/ui-icons_444444_256x240.png);\n}\n\n.ui-button:focus .ui-icon,\n.ui-button:hover .ui-icon,\n.ui-state-focus .ui-icon,\n.ui-state-hover .ui-icon {\n  background-image: url(images/ui-icons_555555_256x240.png);\n}\n\n.ui-button:active .ui-icon,\n.ui-state-active .ui-icon {\n  background-image: url(images/ui-icons_ffffff_256x240.png);\n}\n\n.ui-button .ui-state-highlight.ui-icon,\n.ui-state-highlight .ui-icon {\n  background-image: url(images/ui-icons_777620_256x240.png);\n}\n\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n  background-image: url(images/ui-icons_cc0000_256x240.png);\n}\n\n.ui-button .ui-icon {\n  background-image: url(images/ui-icons_777777_256x240.png);\n}\n\n.ui-icon-blank {\n  background-position: 16px 16px;\n}\n\n.ui-icon-caret-1-n {\n  background-position: 0 0;\n}\n\n.ui-icon-caret-1-ne {\n  background-position: -16px 0;\n}\n\n.ui-icon-caret-1-e {\n  background-position: -32px 0;\n}\n\n.ui-icon-caret-1-se {\n  background-position: -48px 0;\n}\n\n.ui-icon-caret-1-s {\n  background-position: -65px 0;\n}\n\n.ui-icon-caret-1-sw {\n  background-position: -80px 0;\n}\n\n.ui-icon-caret-1-w {\n  background-position: -96px 0;\n}\n\n.ui-icon-caret-1-nw {\n  background-position: -112px 0;\n}\n\n.ui-icon-caret-2-n-s {\n  background-position: -128px 0;\n}\n\n.ui-icon-caret-2-e-w {\n  background-position: -144px 0;\n}\n\n.ui-icon-triangle-1-n {\n  background-position: 0 -16px;\n}\n\n.ui-icon-triangle-1-ne {\n  background-position: -16px -16px;\n}\n\n.ui-icon-triangle-1-e {\n  background-position: -32px -16px;\n}\n\n.ui-icon-triangle-1-se {\n  background-position: -48px -16px;\n}\n\n.ui-icon-triangle-1-s {\n  background-position: -65px -16px;\n}\n\n.ui-icon-triangle-1-sw {\n  background-position: -80px -16px;\n}\n\n.ui-icon-triangle-1-w {\n  background-position: -96px -16px;\n}\n\n.ui-icon-triangle-1-nw {\n  background-position: -112px -16px;\n}\n\n.ui-icon-triangle-2-n-s {\n  background-position: -128px -16px;\n}\n\n.ui-icon-triangle-2-e-w {\n  background-position: -144px -16px;\n}\n\n.ui-icon-arrow-1-n {\n  background-position: 0 -32px;\n}\n\n.ui-icon-arrow-1-ne {\n  background-position: -16px -32px;\n}\n\n.ui-icon-arrow-1-e {\n  background-position: -32px -32px;\n}\n\n.ui-icon-arrow-1-se {\n  background-position: -48px -32px;\n}\n\n.ui-icon-arrow-1-s {\n  background-position: -65px -32px;\n}\n\n.ui-icon-arrow-1-sw {\n  background-position: -80px -32px;\n}\n\n.ui-icon-arrow-1-w {\n  background-position: -96px -32px;\n}\n\n.ui-icon-arrow-1-nw {\n  background-position: -112px -32px;\n}\n\n.ui-icon-arrow-2-n-s {\n  background-position: -128px -32px;\n}\n\n.ui-icon-arrow-2-ne-sw {\n  background-position: -144px -32px;\n}\n\n.ui-icon-arrow-2-e-w {\n  background-position: -160px -32px;\n}\n\n.ui-icon-arrow-2-se-nw {\n  background-position: -176px -32px;\n}\n\n.ui-icon-arrowstop-1-n {\n  background-position: -192px -32px;\n}\n\n.ui-icon-arrowstop-1-e {\n  background-position: -208px -32px;\n}\n\n.ui-icon-arrowstop-1-s {\n  background-position: -224px -32px;\n}\n\n.ui-icon-arrowstop-1-w {\n  background-position: -240px -32px;\n}\n\n.ui-icon-arrowthick-1-n {\n  background-position: 1px -48px;\n}\n\n.ui-icon-arrowthick-1-ne {\n  background-position: -16px -48px;\n}\n\n.ui-icon-arrowthick-1-e {\n  background-position: -32px -48px;\n}\n\n.ui-icon-arrowthick-1-se {\n  background-position: -48px -48px;\n}\n\n.ui-icon-arrowthick-1-s {\n  background-position: -64px -48px;\n}\n\n.ui-icon-arrowthick-1-sw {\n  background-position: -80px -48px;\n}\n\n.ui-icon-arrowthick-1-w {\n  background-position: -96px -48px;\n}\n\n.ui-icon-arrowthick-1-nw {\n  background-position: -112px -48px;\n}\n\n.ui-icon-arrowthick-2-n-s {\n  background-position: -128px -48px;\n}\n\n.ui-icon-arrowthick-2-ne-sw {\n  background-position: -144px -48px;\n}\n\n.ui-icon-arrowthick-2-e-w {\n  background-position: -160px -48px;\n}\n\n.ui-icon-arrowthick-2-se-nw {\n  background-position: -176px -48px;\n}\n\n.ui-icon-arrowthickstop-1-n {\n  background-position: -192px -48px;\n}\n\n.ui-icon-arrowthickstop-1-e {\n  background-position: -208px -48px;\n}\n\n.ui-icon-arrowthickstop-1-s {\n  background-position: -224px -48px;\n}\n\n.ui-icon-arrowthickstop-1-w {\n  background-position: -240px -48px;\n}\n\n.ui-icon-arrowreturnthick-1-w {\n  background-position: 0 -64px;\n}\n\n.ui-icon-arrowreturnthick-1-n {\n  background-position: -16px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-e {\n  background-position: -32px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-s {\n  background-position: -48px -64px;\n}\n\n.ui-icon-arrowreturn-1-w {\n  background-position: -64px -64px;\n}\n\n.ui-icon-arrowreturn-1-n {\n  background-position: -80px -64px;\n}\n\n.ui-icon-arrowreturn-1-e {\n  background-position: -96px -64px;\n}\n\n.ui-icon-arrowreturn-1-s {\n  background-position: -112px -64px;\n}\n\n.ui-icon-arrowrefresh-1-w {\n  background-position: -128px -64px;\n}\n\n.ui-icon-arrowrefresh-1-n {\n  background-position: -144px -64px;\n}\n\n.ui-icon-arrowrefresh-1-e {\n  background-position: -160px -64px;\n}\n\n.ui-icon-arrowrefresh-1-s {\n  background-position: -176px -64px;\n}\n\n.ui-icon-arrow-4 {\n  background-position: 0 -80px;\n}\n\n.ui-icon-arrow-4-diag {\n  background-position: -16px -80px;\n}\n\n.ui-icon-extlink {\n  background-position: -32px -80px;\n}\n\n.ui-icon-newwin {\n  background-position: -48px -80px;\n}\n\n.ui-icon-refresh {\n  background-position: -64px -80px;\n}\n\n.ui-icon-shuffle {\n  background-position: -80px -80px;\n}\n\n.ui-icon-transfer-e-w {\n  background-position: -96px -80px;\n}\n\n.ui-icon-transferthick-e-w {\n  background-position: -112px -80px;\n}\n\n.ui-icon-folder-collapsed {\n  background-position: 0 -96px;\n}\n\n.ui-icon-folder-open {\n  background-position: -16px -96px;\n}\n\n.ui-icon-document {\n  background-position: -32px -96px;\n}\n\n.ui-icon-document-b {\n  background-position: -48px -96px;\n}\n\n.ui-icon-note {\n  background-position: -64px -96px;\n}\n\n.ui-icon-mail-closed {\n  background-position: -80px -96px;\n}\n\n.ui-icon-mail-open {\n  background-position: -96px -96px;\n}\n\n.ui-icon-suitcase {\n  background-position: -112px -96px;\n}\n\n.ui-icon-comment {\n  background-position: -128px -96px;\n}\n\n.ui-icon-person {\n  background-position: -144px -96px;\n}\n\n.ui-icon-print {\n  background-position: -160px -96px;\n}\n\n.ui-icon-trash {\n  background-position: -176px -96px;\n}\n\n.ui-icon-locked {\n  background-position: -192px -96px;\n}\n\n.ui-icon-unlocked {\n  background-position: -208px -96px;\n}\n\n.ui-icon-bookmark {\n  background-position: -224px -96px;\n}\n\n.ui-icon-tag {\n  background-position: -240px -96px;\n}\n\n.ui-icon-home {\n  background-position: 0 -112px;\n}\n\n.ui-icon-flag {\n  background-position: -16px -112px;\n}\n\n.ui-icon-calendar {\n  background-position: -32px -112px;\n}\n\n.ui-icon-cart {\n  background-position: -48px -112px;\n}\n\n.ui-icon-pencil {\n  background-position: -64px -112px;\n}\n\n.ui-icon-clock {\n  background-position: -80px -112px;\n}\n\n.ui-icon-disk {\n  background-position: -96px -112px;\n}\n\n.ui-icon-calculator {\n  background-position: -112px -112px;\n}\n\n.ui-icon-zoomin {\n  background-position: -128px -112px;\n}\n\n.ui-icon-zoomout {\n  background-position: -144px -112px;\n}\n\n.ui-icon-search {\n  background-position: -160px -112px;\n}\n\n.ui-icon-wrench {\n  background-position: -176px -112px;\n}\n\n.ui-icon-gear {\n  background-position: -192px -112px;\n}\n\n.ui-icon-heart {\n  background-position: -208px -112px;\n}\n\n.ui-icon-star {\n  background-position: -224px -112px;\n}\n\n.ui-icon-link {\n  background-position: -240px -112px;\n}\n\n.ui-icon-cancel {\n  background-position: 0 -128px;\n}\n\n.ui-icon-plus {\n  background-position: -16px -128px;\n}\n\n.ui-icon-plusthick {\n  background-position: -32px -128px;\n}\n\n.ui-icon-minus {\n  background-position: -48px -128px;\n}\n\n.ui-icon-minusthick {\n  background-position: -64px -128px;\n}\n\n.ui-icon-close {\n  background-position: -80px -128px;\n}\n\n.ui-icon-closethick {\n  background-position: -96px -128px;\n}\n\n.ui-icon-key {\n  background-position: -112px -128px;\n}\n\n.ui-icon-lightbulb {\n  background-position: -128px -128px;\n}\n\n.ui-icon-scissors {\n  background-position: -144px -128px;\n}\n\n.ui-icon-clipboard {\n  background-position: -160px -128px;\n}\n\n.ui-icon-copy {\n  background-position: -176px -128px;\n}\n\n.ui-icon-contact {\n  background-position: -192px -128px;\n}\n\n.ui-icon-image {\n  background-position: -208px -128px;\n}\n\n.ui-icon-video {\n  background-position: -224px -128px;\n}\n\n.ui-icon-script {\n  background-position: -240px -128px;\n}\n\n.ui-icon-alert {\n  background-position: 0 -144px;\n}\n\n.ui-icon-info {\n  background-position: -16px -144px;\n}\n\n.ui-icon-notice {\n  background-position: -32px -144px;\n}\n\n.ui-icon-help {\n  background-position: -48px -144px;\n}\n\n.ui-icon-check {\n  background-position: -64px -144px;\n}\n\n.ui-icon-bullet {\n  background-position: -80px -144px;\n}\n\n.ui-icon-radio-on {\n  background-position: -96px -144px;\n}\n\n.ui-icon-radio-off {\n  background-position: -112px -144px;\n}\n\n.ui-icon-pin-w {\n  background-position: -128px -144px;\n}\n\n.ui-icon-pin-s {\n  background-position: -144px -144px;\n}\n\n.ui-icon-play {\n  background-position: 0 -160px;\n}\n\n.ui-icon-pause {\n  background-position: -16px -160px;\n}\n\n.ui-icon-seek-next {\n  background-position: -32px -160px;\n}\n\n.ui-icon-seek-prev {\n  background-position: -48px -160px;\n}\n\n.ui-icon-seek-end {\n  background-position: -64px -160px;\n}\n\n.ui-icon-seek-first,\n.ui-icon-seek-start {\n  background-position: -80px -160px;\n}\n\n.ui-icon-stop {\n  background-position: -96px -160px;\n}\n\n.ui-icon-eject {\n  background-position: -112px -160px;\n}\n\n.ui-icon-volume-off {\n  background-position: -128px -160px;\n}\n\n.ui-icon-volume-on {\n  background-position: -144px -160px;\n}\n\n.ui-icon-power {\n  background-position: 0 -176px;\n}\n\n.ui-icon-signal-diag {\n  background-position: -16px -176px;\n}\n\n.ui-icon-signal {\n  background-position: -32px -176px;\n}\n\n.ui-icon-battery-0 {\n  background-position: -48px -176px;\n}\n\n.ui-icon-battery-1 {\n  background-position: -64px -176px;\n}\n\n.ui-icon-battery-2 {\n  background-position: -80px -176px;\n}\n\n.ui-icon-battery-3 {\n  background-position: -96px -176px;\n}\n\n.ui-icon-circle-plus {\n  background-position: 0 -192px;\n}\n\n.ui-icon-circle-minus {\n  background-position: -16px -192px;\n}\n\n.ui-icon-circle-close {\n  background-position: -32px -192px;\n}\n\n.ui-icon-circle-triangle-e {\n  background-position: -48px -192px;\n}\n\n.ui-icon-circle-triangle-s {\n  background-position: -64px -192px;\n}\n\n.ui-icon-circle-triangle-w {\n  background-position: -80px -192px;\n}\n\n.ui-icon-circle-triangle-n {\n  background-position: -96px -192px;\n}\n\n.ui-icon-circle-arrow-e {\n  background-position: -112px -192px;\n}\n\n.ui-icon-circle-arrow-s {\n  background-position: -128px -192px;\n}\n\n.ui-icon-circle-arrow-w {\n  background-position: -144px -192px;\n}\n\n.ui-icon-circle-arrow-n {\n  background-position: -160px -192px;\n}\n\n.ui-icon-circle-zoomin {\n  background-position: -176px -192px;\n}\n\n.ui-icon-circle-zoomout {\n  background-position: -192px -192px;\n}\n\n.ui-icon-circle-check {\n  background-position: -208px -192px;\n}\n\n.ui-icon-circlesmall-plus {\n  background-position: 0 -208px;\n}\n\n.ui-icon-circlesmall-minus {\n  background-position: -16px -208px;\n}\n\n.ui-icon-circlesmall-close {\n  background-position: -32px -208px;\n}\n\n.ui-icon-squaresmall-plus {\n  background-position: -48px -208px;\n}\n\n.ui-icon-squaresmall-minus {\n  background-position: -64px -208px;\n}\n\n.ui-icon-squaresmall-close {\n  background-position: -80px -208px;\n}\n\n.ui-icon-grip-dotted-vertical {\n  background-position: 0 -224px;\n}\n\n.ui-icon-grip-dotted-horizontal {\n  background-position: -16px -224px;\n}\n\n.ui-icon-grip-solid-vertical {\n  background-position: -32px -224px;\n}\n\n.ui-icon-grip-solid-horizontal {\n  background-position: -48px -224px;\n}\n\n.ui-icon-gripsmall-diagonal-se {\n  background-position: -64px -224px;\n}\n\n.ui-icon-grip-diagonal-se {\n  background-position: -80px -224px;\n}\n\n.ui-corner-all,\n.ui-corner-left,\n.ui-corner-tl,\n.ui-corner-top {\n  border-top-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-right,\n.ui-corner-top,\n.ui-corner-tr {\n  border-top-right-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bl,\n.ui-corner-bottom,\n.ui-corner-left {\n  border-bottom-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-br,\n.ui-corner-right {\n  border-bottom-right-radius: 3px;\n}\n\n.ui-widget-overlay {\n  background: #aaa;\n  opacity: 0.003;\n  filter: Alpha(Opacity=0.3);\n}\n\n.ui-widget-shadow {\n  -webkit-box-shadow: 0 0 5px #666;\n  box-shadow: 0 0 5px #666;\n}\n\n.pace {\n  -webkit-pointer-events: none;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.pace-inactive {\n  display: none;\n}\n\n.pace .pace-progress {\n  background: #000;\n  position: fixed;\n  z-index: 2000;\n  top: 0;\n  right: 100%;\n  width: 100%;\n  height: 2px;\n}\n\n.pace .pace-progress-inner {\n  display: block;\n  position: absolute;\n  right: 0;\n  width: 100px;\n  height: 100%;\n  box-shadow: 0 0 10px #000, 0 0 5px #000;\n  opacity: 1;\n  -webkit-transform: rotate(3deg) translate(0, -4px);\n  -moz-transform: rotate(3deg) translate(0, -4px);\n  -ms-transform: rotate(3deg) translate(0, -4px);\n  -o-transform: rotate(3deg) translate(0, -4px);\n  transform: rotate(3deg) translate(0, -4px);\n}\n\n.pace .pace-activity {\n  display: block;\n  position: fixed;\n  z-index: 2000;\n  top: 15px;\n  right: 15px;\n  width: 14px;\n  height: 14px;\n  border: solid 2px transparent;\n  border-top-color: #000;\n  border-left-color: #000;\n  border-radius: 10px;\n  -webkit-animation: pace-spinner 400ms linear infinite;\n  -moz-animation: pace-spinner 400ms linear infinite;\n  -ms-animation: pace-spinner 400ms linear infinite;\n  -o-animation: pace-spinner 400ms linear infinite;\n  animation: pace-spinner 400ms linear infinite;\n}\n\n/*!\n * Color Admin v4.4.0 (https://seantheme.com/color-admin/)\n * Copyright 2019 SeanTheme\n */\n/*!\n * Bootstrap v4.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 The Bootstrap Authors\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n@keyframes progress-bar-stripes {\n  0% {\n    background-position: 1rem 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes navbar-input-expand {\n  0% {\n    width: 220px;\n  }\n\n  to {\n    width: 300px;\n  }\n}\n\n@-moz-keyframes navbar-input-expand {\n  0% {\n    width: 220px;\n  }\n\n  to {\n    width: 300px;\n  }\n}\n\n@-o-keyframes navbar-input-expand {\n  0% {\n    width: 220px;\n  }\n\n  to {\n    width: 300px;\n  }\n}\n\n@keyframes navbar-input-expand {\n  0% {\n    width: 220px;\n  }\n\n  to {\n    width: 300px;\n  }\n}\n\n@-webkit-keyframes navbar-input-expand-xs {\n  0% {\n    width: 160px;\n  }\n\n  to {\n    width: 200px;\n  }\n}\n\n@-moz-keyframes navbar-input-expand-xs {\n  0% {\n    width: 160px;\n  }\n\n  to {\n    width: 200px;\n  }\n}\n\n@-o-keyframes navbar-input-expand-xs {\n  0% {\n    width: 160px;\n  }\n\n  to {\n    width: 200px;\n  }\n}\n\n@keyframes navbar-input-expand-xs {\n  0% {\n    width: 160px;\n  }\n\n  to {\n    width: 200px;\n  }\n}\n\n@-webkit-keyframes topMenuControlSlideInLeft {\n  0% {\n    left: -50px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-moz-keyframes topMenuControlSlideInLeft {\n  0% {\n    left: -50px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-o-keyframes topMenuControlSlideInLeft {\n  0% {\n    left: -50px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@keyframes topMenuControlSlideInLeft {\n  0% {\n    left: -50px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-webkit-keyframes topMenuControlSlideInRight {\n  0% {\n    right: -50px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-moz-keyframes topMenuControlSlideInRight {\n  0% {\n    right: -50px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-o-keyframes topMenuControlSlideInRight {\n  0% {\n    right: -50px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@keyframes topMenuControlSlideInRight {\n  0% {\n    right: -50px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-webkit-keyframes sidebarSlideInLeft {\n  0% {\n    left: -220px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-moz-keyframes sidebarSlideInLeft {\n  0% {\n    left: -220px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-o-keyframes sidebarSlideInLeft {\n  0% {\n    left: -220px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@keyframes sidebarSlideInLeft {\n  0% {\n    left: -220px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-webkit-keyframes sidebarSlideInRight {\n  0% {\n    right: -220px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-moz-keyframes sidebarSlideInRight {\n  0% {\n    right: -220px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-o-keyframes sidebarSlideInRight {\n  0% {\n    right: -220px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@keyframes sidebarSlideInRight {\n  0% {\n    right: -220px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-webkit-keyframes wideSidebarSlideInLeft {\n  0% {\n    left: -250px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-moz-keyframes wideSidebarSlideInLeft {\n  0% {\n    left: -250px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-o-keyframes wideSidebarSlideInLeft {\n  0% {\n    left: -250px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@keyframes wideSidebarSlideInLeft {\n  0% {\n    left: -250px;\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@-webkit-keyframes wideSidebarSlideInRight {\n  0% {\n    right: -250px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-moz-keyframes wideSidebarSlideInRight {\n  0% {\n    right: -250px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-o-keyframes wideSidebarSlideInRight {\n  0% {\n    right: -250px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@keyframes wideSidebarSlideInRight {\n  0% {\n    right: -250px;\n  }\n\n  to {\n    right: 0;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes rotation {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(359deg);\n    -moz-transform: rotate(359deg);\n    -ms-transform: rotate(359deg);\n    -o-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@-moz-keyframes rotation {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(359deg);\n    -moz-transform: rotate(359deg);\n    -ms-transform: rotate(359deg);\n    -o-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@-o-keyframes rotation {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(359deg);\n    -moz-transform: rotate(359deg);\n    -ms-transform: rotate(359deg);\n    -o-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes rotation {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(359deg);\n    -moz-transform: rotate(359deg);\n    -ms-transform: rotate(359deg);\n    -o-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@-webkit-keyframes pace-spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes pace-spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-o-keyframes pace-spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pace-spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n:root {\n  --blue: #348fe2;\n  --indigo: #8753de;\n  --purple: #727cb6;\n  --pink: #fb5597;\n  --red: #ff5b57;\n  --orange: #f59c1a;\n  --yellow: #ffd900;\n  --green: #32a932;\n  --teal: #00acac;\n  --cyan: #49b6d6;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --dark-darker: #1a2229;\n  --muted: #627884;\n  --primary: #00acac;\n  --secondary: #6c757d;\n  --success: #00acac;\n  --info: #49b6d6;\n  --warning: #f59c1a;\n  --danger: #ff5b57;\n  --light: #f2f3f4;\n  --dark: #2d353c;\n  --inverse: #2d353c;\n  --black: #000000;\n  --white: #ffffff;\n  --grey: #b6c2c9;\n  --muted: #b6c2c9;\n  --silver: #b6c2c9;\n  --lime: #90ca4b;\n  --aqua: #49b6d6;\n  --breakpoint-xxs: 0px;\n  --breakpoint-xs: 360px;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --breakpoint-xxl: 1660px;\n  --breakpoint-xxxl: 1900px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,\n    \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n::after,\n::before {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n  height: 100%;\n}\n\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #333;\n  text-align: left;\n  background-color: #d9e0e7;\n}\n\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  overflow: visible;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  border: 0;\n  height: 1px;\n  background: rgba(0, 0, 0, 0.1);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin-top: 0;\n}\n\np {\n  margin-bottom: 15px;\n}\n\nabbr[data-original-title],\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none;\n}\n\naddress,\ndl,\nol,\nul {\n  margin-bottom: 1rem;\n}\n\naddress {\n  font-style: normal;\n  line-height: inherit;\n}\n\ndl,\nol,\nul {\n  margin-top: 0;\n}\n\nol ol,\nol ul,\nul ol,\nul ul {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote,\nfigure {\n  margin: 0 0 1rem;\n}\n\nstrong {\n  font-weight: bolder;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #348fe2;\n  text-decoration: none;\n  background-color: transparent;\n}\n\na:hover {\n  color: #1968b0;\n  text-decoration: underline;\n}\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]):focus,\na:not([href]):not([tabindex]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n    \"Courier New\", monospace;\n}\n\nsamp {\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\nimg {\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nselect {\n  word-wrap: normal;\n}\n\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"],\nbutton {\n  -webkit-appearance: button;\n}\n\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled),\nbutton:not(:disabled) {\n  cursor: pointer;\n}\n\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner,\nbutton::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=\"date\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"],\ninput[type=\"time\"] {\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 8px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.h1,\nh1 {\n  font-size: 1.875rem;\n}\n\n.h2,\nh2 {\n  font-size: 1.5rem;\n}\n\n.h3,\nh3 {\n  font-size: 1.3125rem;\n}\n\n.h4,\nh4 {\n  font-size: 1.125rem;\n}\n\n.h5,\nh5 {\n  font-size: 0.9375rem;\n}\n\n.h6,\nh6 {\n  font-size: 0.75rem;\n}\n\n.lead {\n  font-size: 0.9375rem;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-2,\n.display-3,\n.display-4 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-3,\n.display-4 {\n  font-size: 4.5rem;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n}\n\n.small,\nsmall {\n  font-size: 80%;\n  font-weight: 400;\n}\n\n.mark,\nmark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-inline,\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 16px;\n  font-size: 0.9375rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d;\n}\n\n.blockquote-footer::before {\n  content: \"\\2014\\00A0\";\n}\n\n.img-fluid,\n.img-thumbnail {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #d9e0e7;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 8px;\n  line-height: 1;\n}\n\n.figure-caption,\ncode {\n  font-size: 90%;\n  color: #6c757d;\n}\n\ncode {\n  word-break: break-word;\n  padding: 2px 4px;\n  color: #f90a69;\n  background-color: #fff0f0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\na > code,\npre code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 3px;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 700;\n}\n\npre code {\n  font-size: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 750px;\n  }\n}\n\n@media (min-width: 992px) {\n  .container {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1170px;\n  }\n}\n\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.card > hr,\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.no-gutters > .col,\n.no-gutters > [class*=\"col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col,\n.col-1,\n.col-10,\n.col-11,\n.col-12,\n.col-2,\n.col-3,\n.col-4,\n.col-5,\n.col-6,\n.col-7,\n.col-8,\n.col-9 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col-auto {\n  position: relative;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col-lg,\n.col-lg-1,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-lg-auto,\n.col-md,\n.col-md-1,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-md-auto,\n.col-sm,\n.col-sm-1,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-sm-auto,\n.col-xl,\n.col-xl-1,\n.col-xl-10,\n.col-xl-11,\n.col-xl-12,\n.col-xl-2,\n.col-xl-3,\n.col-xl-4,\n.col-xl-5,\n.col-xl-6,\n.col-xl-7,\n.col-xl-8,\n.col-xl-9,\n.col-xl-auto,\n.col-xs,\n.col-xs-1,\n.col-xs-10,\n.col-xs-11,\n.col-xs-12,\n.col-xs-2,\n.col-xs-3,\n.col-xs-4,\n.col-xs-5,\n.col-xs-6,\n.col-xs-7,\n.col-xs-8,\n.col-xs-9,\n.col-xs-auto,\n.col-xxl,\n.col-xxl-1,\n.col-xxl-10,\n.col-xxl-11,\n.col-xxl-12,\n.col-xxl-2,\n.col-xxl-3,\n.col-xxl-4,\n.col-xxl-5,\n.col-xxl-6,\n.col-xxl-7,\n.col-xxl-8,\n.col-xxl-9,\n.col-xxl-auto,\n.col-xxxl,\n.col-xxxl-1,\n.col-xxxl-10,\n.col-xxxl-11,\n.col-xxxl-12,\n.col-xxxl-2,\n.col-xxxl-3,\n.col-xxxl-4,\n.col-xxxl-5,\n.col-xxxl-6,\n.col-xxxl-7,\n.col-xxxl-8,\n.col-xxxl-9,\n.col-xxxl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%;\n}\n\n.col-2 {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%;\n}\n\n.col-5 {\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%;\n}\n\n.col-8 {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%;\n}\n\n.col-11 {\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.33333%;\n}\n\n.offset-2 {\n  margin-left: 16.66667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333%;\n}\n\n.offset-5 {\n  margin-left: 41.66667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333%;\n}\n\n.offset-8 {\n  margin-left: 66.66667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333%;\n}\n\n.offset-11 {\n  margin-left: 91.66667%;\n}\n\n@media (min-width: 360px) {\n  .col-xs {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-xs-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xs-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-xs-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-xs-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xs-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-xs-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-xs-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xs-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-xs-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-xs-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xs-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-xs-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-xs-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xs-first {\n    order: -1;\n  }\n\n  .order-xs-last {\n    order: 13;\n  }\n\n  .order-xs-0 {\n    order: 0;\n  }\n\n  .order-xs-1 {\n    order: 1;\n  }\n\n  .order-xs-2 {\n    order: 2;\n  }\n\n  .order-xs-3 {\n    order: 3;\n  }\n\n  .order-xs-4 {\n    order: 4;\n  }\n\n  .order-xs-5 {\n    order: 5;\n  }\n\n  .order-xs-6 {\n    order: 6;\n  }\n\n  .order-xs-7 {\n    order: 7;\n  }\n\n  .order-xs-8 {\n    order: 8;\n  }\n\n  .order-xs-9 {\n    order: 9;\n  }\n\n  .order-xs-10 {\n    order: 10;\n  }\n\n  .order-xs-11 {\n    order: 11;\n  }\n\n  .order-xs-12 {\n    order: 12;\n  }\n\n  .offset-xs-0 {\n    margin-left: 0;\n  }\n\n  .offset-xs-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-xs-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-xs-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xs-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-xs-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-xs-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xs-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-xs-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-xs-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xs-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-xs-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-sm-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-sm-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-sm-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-sm-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-sm-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-sm-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-sm-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-sm-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-sm-first {\n    order: -1;\n  }\n\n  .order-sm-last {\n    order: 13;\n  }\n\n  .order-sm-0 {\n    order: 0;\n  }\n\n  .order-sm-1 {\n    order: 1;\n  }\n\n  .order-sm-2 {\n    order: 2;\n  }\n\n  .order-sm-3 {\n    order: 3;\n  }\n\n  .order-sm-4 {\n    order: 4;\n  }\n\n  .order-sm-5 {\n    order: 5;\n  }\n\n  .order-sm-6 {\n    order: 6;\n  }\n\n  .order-sm-7 {\n    order: 7;\n  }\n\n  .order-sm-8 {\n    order: 8;\n  }\n\n  .order-sm-9 {\n    order: 9;\n  }\n\n  .order-sm-10 {\n    order: 10;\n  }\n\n  .order-sm-11 {\n    order: 11;\n  }\n\n  .order-sm-12 {\n    order: 12;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-md-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-md-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-md-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-md-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-md-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-md-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-md-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-md-first {\n    order: -1;\n  }\n\n  .order-md-last {\n    order: 13;\n  }\n\n  .order-md-0 {\n    order: 0;\n  }\n\n  .order-md-1 {\n    order: 1;\n  }\n\n  .order-md-2 {\n    order: 2;\n  }\n\n  .order-md-3 {\n    order: 3;\n  }\n\n  .order-md-4 {\n    order: 4;\n  }\n\n  .order-md-5 {\n    order: 5;\n  }\n\n  .order-md-6 {\n    order: 6;\n  }\n\n  .order-md-7 {\n    order: 7;\n  }\n\n  .order-md-8 {\n    order: 8;\n  }\n\n  .order-md-9 {\n    order: 9;\n  }\n\n  .order-md-10 {\n    order: 10;\n  }\n\n  .order-md-11 {\n    order: 11;\n  }\n\n  .order-md-12 {\n    order: 12;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-lg-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-lg-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-lg-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-lg-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-lg-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-lg-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-lg-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-lg-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-lg-first {\n    order: -1;\n  }\n\n  .order-lg-last {\n    order: 13;\n  }\n\n  .order-lg-0 {\n    order: 0;\n  }\n\n  .order-lg-1 {\n    order: 1;\n  }\n\n  .order-lg-2 {\n    order: 2;\n  }\n\n  .order-lg-3 {\n    order: 3;\n  }\n\n  .order-lg-4 {\n    order: 4;\n  }\n\n  .order-lg-5 {\n    order: 5;\n  }\n\n  .order-lg-6 {\n    order: 6;\n  }\n\n  .order-lg-7 {\n    order: 7;\n  }\n\n  .order-lg-8 {\n    order: 8;\n  }\n\n  .order-lg-9 {\n    order: 9;\n  }\n\n  .order-lg-10 {\n    order: 10;\n  }\n\n  .order-lg-11 {\n    order: 11;\n  }\n\n  .order-lg-12 {\n    order: 12;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-xl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-xl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-xl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-xl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xl-first {\n    order: -1;\n  }\n\n  .order-xl-last {\n    order: 13;\n  }\n\n  .order-xl-0 {\n    order: 0;\n  }\n\n  .order-xl-1 {\n    order: 1;\n  }\n\n  .order-xl-2 {\n    order: 2;\n  }\n\n  .order-xl-3 {\n    order: 3;\n  }\n\n  .order-xl-4 {\n    order: 4;\n  }\n\n  .order-xl-5 {\n    order: 5;\n  }\n\n  .order-xl-6 {\n    order: 6;\n  }\n\n  .order-xl-7 {\n    order: 7;\n  }\n\n  .order-xl-8 {\n    order: 8;\n  }\n\n  .order-xl-9 {\n    order: 9;\n  }\n\n  .order-xl-10 {\n    order: 10;\n  }\n\n  .order-xl-11 {\n    order: 11;\n  }\n\n  .order-xl-12 {\n    order: 12;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 1660px) {\n  .col-xxl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xxl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-xxl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-xxl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xxl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-xxl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-xxl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xxl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-xxl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-xxl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xxl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-xxl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-xxl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xxl-first {\n    order: -1;\n  }\n\n  .order-xxl-last {\n    order: 13;\n  }\n\n  .order-xxl-0 {\n    order: 0;\n  }\n\n  .order-xxl-1 {\n    order: 1;\n  }\n\n  .order-xxl-2 {\n    order: 2;\n  }\n\n  .order-xxl-3 {\n    order: 3;\n  }\n\n  .order-xxl-4 {\n    order: 4;\n  }\n\n  .order-xxl-5 {\n    order: 5;\n  }\n\n  .order-xxl-6 {\n    order: 6;\n  }\n\n  .order-xxl-7 {\n    order: 7;\n  }\n\n  .order-xxl-8 {\n    order: 8;\n  }\n\n  .order-xxl-9 {\n    order: 9;\n  }\n\n  .order-xxl-10 {\n    order: 10;\n  }\n\n  .order-xxl-11 {\n    order: 11;\n  }\n\n  .order-xxl-12 {\n    order: 12;\n  }\n\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxl-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-xxl-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxl-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-xxl-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxl-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-xxl-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxl-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-xxl-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 1900px) {\n  .col-xxxl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .col-xxxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xxxl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .col-xxxl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .col-xxxl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xxxl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .col-xxxl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .col-xxxl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xxxl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .col-xxxl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .col-xxxl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xxxl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .col-xxxl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .col-xxxl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xxxl-first {\n    order: -1;\n  }\n\n  .order-xxxl-last {\n    order: 13;\n  }\n\n  .order-xxxl-0 {\n    order: 0;\n  }\n\n  .order-xxxl-1 {\n    order: 1;\n  }\n\n  .order-xxxl-2 {\n    order: 2;\n  }\n\n  .order-xxxl-3 {\n    order: 3;\n  }\n\n  .order-xxxl-4 {\n    order: 4;\n  }\n\n  .order-xxxl-5 {\n    order: 5;\n  }\n\n  .order-xxxl-6 {\n    order: 6;\n  }\n\n  .order-xxxl-7 {\n    order: 7;\n  }\n\n  .order-xxxl-8 {\n    order: 8;\n  }\n\n  .order-xxxl-9 {\n    order: 9;\n  }\n\n  .order-xxxl-10 {\n    order: 10;\n  }\n\n  .order-xxxl-11 {\n    order: 11;\n  }\n\n  .order-xxxl-12 {\n    order: 12;\n  }\n\n  .offset-xxxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxxl-1 {\n    margin-left: 8.33333%;\n  }\n\n  .offset-xxxl-2 {\n    margin-left: 16.66667%;\n  }\n\n  .offset-xxxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxxl-4 {\n    margin-left: 33.33333%;\n  }\n\n  .offset-xxxl-5 {\n    margin-left: 41.66667%;\n  }\n\n  .offset-xxxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxxl-7 {\n    margin-left: 58.33333%;\n  }\n\n  .offset-xxxl-8 {\n    margin-left: 66.66667%;\n  }\n\n  .offset-xxxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxxl-10 {\n    margin-left: 83.33333%;\n  }\n\n  .offset-xxxl-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 16px;\n  color: #333;\n}\n\n.table td,\n.table th {\n  padding: 8px;\n  vertical-align: top;\n  border-top: 1px solid #e4e7ea;\n}\n\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #e4e7ea;\n}\n\n.table tbody + tbody {\n  border-top: 2px solid #e4e7ea;\n}\n\n.table-sm td,\n.table-sm th {\n  padding: 5px;\n}\n\n.table-bordered,\n.table-bordered td,\n.table-bordered th {\n  border: 1px solid #e4e7ea;\n}\n\n.table-bordered thead td,\n.table-bordered thead th {\n  border-bottom-width: 2px;\n}\n\n.table-borderless tbody + tbody,\n.table-borderless td,\n.table-borderless th,\n.table-borderless thead th,\n.table-dark.table-bordered {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #f2f4f5;\n}\n\n.table-hover tbody tr:hover {\n  color: #333;\n  background-color: #f2f4f5;\n}\n\n.table-primary,\n.table-primary > td,\n.table-primary > th {\n  background-color: #b8e8e8;\n}\n\n.table-primary tbody + tbody,\n.table-primary td,\n.table-primary th,\n.table-primary thead th {\n  border-color: #7ad4d4;\n}\n\n.table-hover .table-primary:hover,\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: #a5e2e2;\n}\n\n.table-secondary,\n.table-secondary > td,\n.table-secondary > th {\n  background-color: #d6d8db;\n}\n\n.table-secondary tbody + tbody,\n.table-secondary td,\n.table-secondary th,\n.table-secondary thead th {\n  border-color: #b3b7bb;\n}\n\n.table-hover .table-secondary:hover,\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: #c8cbcf;\n}\n\n.table-success,\n.table-success > td,\n.table-success > th {\n  background-color: #b8e8e8;\n}\n\n.table-success tbody + tbody,\n.table-success td,\n.table-success th,\n.table-success thead th {\n  border-color: #7ad4d4;\n}\n\n.table-hover .table-success:hover,\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: #a5e2e2;\n}\n\n.table-info,\n.table-info > td,\n.table-info > th {\n  background-color: #ccebf4;\n}\n\n.table-info tbody + tbody,\n.table-info td,\n.table-info th,\n.table-info thead th {\n  border-color: #a0d9ea;\n}\n\n.table-hover .table-info:hover,\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: #b7e3ef;\n}\n\n.table-warning,\n.table-warning > td,\n.table-warning > th {\n  background-color: #fce3bf;\n}\n\n.table-warning tbody + tbody,\n.table-warning td,\n.table-warning th,\n.table-warning thead th {\n  border-color: #facc88;\n}\n\n.table-hover .table-warning:hover,\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: #fbd8a7;\n}\n\n.table-danger,\n.table-danger > td,\n.table-danger > th {\n  background-color: #ffd1d0;\n}\n\n.table-danger tbody + tbody,\n.table-danger td,\n.table-danger th,\n.table-danger thead th {\n  border-color: #ffaaa8;\n}\n\n.table-hover .table-danger:hover,\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: #ffb8b7;\n}\n\n.table-light,\n.table-light > td,\n.table-light > th {\n  background-color: #fbfcfc;\n}\n\n.table-light tbody + tbody,\n.table-light td,\n.table-light th,\n.table-light thead th {\n  border-color: #f8f9f9;\n}\n\n.table-hover .table-light:hover,\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: #ecf1f1;\n}\n\n.table-hover .table-dark:hover,\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th,\n.table-hover .table-inverse:hover,\n.table-hover .table-inverse:hover > td,\n.table-hover .table-inverse:hover > th {\n  background-color: #b7b9bc;\n}\n\n.table-dark > td,\n.table-dark > th,\n.table-inverse,\n.table-inverse > td,\n.table-inverse > th {\n  background-color: #c4c6c8;\n}\n\n.table-dark tbody + tbody,\n.table-inverse tbody + tbody,\n.table-inverse td,\n.table-inverse th,\n.table-inverse thead th {\n  border-color: #92969a;\n}\n\n.table-black,\n.table-black > td,\n.table-black > th {\n  background-color: #b8b8b8;\n}\n\n.table-black tbody + tbody,\n.table-black td,\n.table-black th,\n.table-black thead th {\n  border-color: #7a7a7a;\n}\n\n.table-hover .table-black:hover,\n.table-hover .table-black:hover > td,\n.table-hover .table-black:hover > th {\n  background-color: #ababab;\n}\n\n.table-white,\n.table-white > td,\n.table-white > th {\n  background-color: #fff;\n}\n\n.table-white tbody + tbody,\n.table-white td,\n.table-white th,\n.table-white thead th {\n  border-color: #fff;\n}\n\n.table-hover .table-white:hover,\n.table-hover .table-white:hover > td,\n.table-hover .table-white:hover > th {\n  background-color: #f2f2f2;\n}\n\n.table-grey,\n.table-grey > td,\n.table-grey > th {\n  background-color: #ebeef0;\n}\n\n.table-grey tbody + tbody,\n.table-grey td,\n.table-grey th,\n.table-grey thead th {\n  border-color: #d9dfe3;\n}\n\n.table-hover .table-grey:hover,\n.table-hover .table-grey:hover > td,\n.table-hover .table-grey:hover > th,\n.table-hover .table-muted:hover,\n.table-hover .table-muted:hover > td,\n.table-hover .table-muted:hover > th,\n.table-hover .table-silver:hover,\n.table-hover .table-silver:hover > td,\n.table-hover .table-silver:hover > th {\n  background-color: #dce2e5;\n}\n\n.table-muted,\n.table-muted > td,\n.table-muted > th,\n.table-silver {\n  background-color: #ebeef0;\n}\n\n.table-muted tbody + tbody,\n.table-muted td,\n.table-muted th,\n.table-muted thead th {\n  border-color: #d9dfe3;\n}\n\n.table-silver > td,\n.table-silver > th {\n  background-color: #ebeef0;\n}\n\n.table-silver tbody + tbody,\n.table-silver td,\n.table-silver th,\n.table-silver thead th {\n  border-color: #d9dfe3;\n}\n\n.table-lime,\n.table-lime > td,\n.table-lime > th {\n  background-color: #e0f0cd;\n}\n\n.table-lime tbody + tbody,\n.table-lime td,\n.table-lime th,\n.table-lime thead th {\n  border-color: #c5e3a1;\n}\n\n.table-hover .table-lime:hover,\n.table-hover .table-lime:hover > td,\n.table-hover .table-lime:hover > th {\n  background-color: #d4eab9;\n}\n\n.table-aqua,\n.table-aqua > td,\n.table-aqua > th {\n  background-color: #ccebf4;\n}\n\n.table-aqua tbody + tbody,\n.table-aqua td,\n.table-aqua th,\n.table-aqua thead th {\n  border-color: #a0d9ea;\n}\n\n.table-hover .table-aqua:hover,\n.table-hover .table-aqua:hover > td,\n.table-hover .table-aqua:hover > th {\n  background-color: #b7e3ef;\n}\n\n.table-active,\n.table-active > td,\n.table-active > th {\n  background-color: #f2f4f5;\n}\n\n.table-hover .table-active:hover,\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: #e4e7ea;\n}\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #454d55;\n}\n\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #e4e7ea;\n}\n\n.table-dark {\n  color: #fff;\n  background-color: #343a40;\n}\n\n.table-dark td,\n.table-dark th,\n.table-dark thead th {\n  border-color: #454d55;\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.table-dark.table-hover tbody tr:hover {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 359.98px) {\n  .table-responsive-xs {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-xs > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1659.98px) {\n  .table-responsive-xxl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-xxl > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1899.98px) {\n  .table-responsive-xxxl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-xxxl > .table-bordered {\n    border: 0;\n  }\n}\n\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 14px + 2px);\n  padding: 7px 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #2d353c;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #d5dbe0;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n\n.form-control:focus {\n  color: #2d353c;\n  background-color: #fff;\n  border-color: #5db0ff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #2d353c;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(7px + 1px);\n  padding-bottom: calc(7px + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.8;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.3125rem + 1px);\n  padding-bottom: calc(0.3125rem + 1px);\n  font-size: 0.75rem;\n  line-height: 1.4;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #333;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n\n.form-control-plaintext.form-control-lg,\n.form-control-plaintext.form-control-sm {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.4em + 0.625rem + 2px);\n  padding: 0.3125rem 0.625rem;\n  font-size: 0.75rem;\n  line-height: 1.4;\n  border-radius: 3px;\n}\n\n.form-control-lg {\n  height: calc(1.8em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.8;\n  border-radius: 6px;\n}\n\nselect.form-control[multiple],\nselect.form-control[size],\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.form-row > .col,\n.form-row > [class*=\"col-\"] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n\n.form-check-input:disabled ~ .form-check-label {\n  color: #6c757d;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.6875rem;\n  color: #00acac;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.6875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(0, 172, 172, 0.9);\n  border-radius: 4px;\n}\n\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  border-color: #00acac;\n  padding-right: calc(1.5em + 14px);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300acac' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center right calc(0.375em + 3.5px);\n  background-size: calc(0.75em + 7px) calc(0.75em + 7px);\n}\n\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n  border-color: #00acac;\n  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);\n}\n\n.form-control.is-valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-tooltip,\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n  padding-right: calc(1.5em + 14px);\n  background-position: top calc(0.375em + 3.5px) right calc(0.375em + 3.5px);\n}\n\n.custom-select.is-valid,\n.was-validated .custom-select:valid {\n  border-color: #00acac;\n  padding-right: calc((1em + 14px) * 3 / 4 + 1.75rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\")\n      no-repeat right 0.75rem center/8px 10px,\n    url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300acac' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")\n      #fff no-repeat center right 1.75rem / calc(0.75em + 7px)\n      calc(0.75em + 7px);\n}\n\n.custom-select.is-valid:focus,\n.was-validated .custom-select:valid:focus {\n  border-color: #00acac;\n  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);\n}\n\n.custom-select.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-tooltip,\n.form-control-file.is-valid ~ .valid-feedback,\n.form-control-file.is-valid ~ .valid-tooltip,\n.was-validated .custom-select:valid ~ .valid-feedback,\n.was-validated .custom-select:valid ~ .valid-tooltip,\n.was-validated .form-control-file:valid ~ .valid-feedback,\n.was-validated .form-control-file:valid ~ .valid-tooltip {\n  display: block;\n}\n\n.form-check-input.is-valid ~ .form-check-label,\n.was-validated .form-check-input:valid ~ .form-check-label {\n  color: #00acac;\n}\n\n.form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip,\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip {\n  display: block;\n}\n\n.custom-control-input.is-valid ~ .custom-control-label,\n.was-validated .custom-control-input:valid ~ .custom-control-label {\n  color: #00acac;\n}\n\n.custom-control-input.is-valid ~ .custom-control-label::before,\n.was-validated .custom-control-input:valid ~ .custom-control-label::before {\n  border-color: #00acac;\n}\n\n.custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip,\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip {\n  display: block;\n}\n\n.custom-control-input.is-valid:checked ~ .custom-control-label::before,\n.was-validated\n  .custom-control-input:valid:checked\n  ~ .custom-control-label::before {\n  border-color: #00dfdf;\n  background-color: #00dfdf;\n}\n\n.custom-control-input.is-valid:focus ~ .custom-control-label::before,\n.was-validated\n  .custom-control-input:valid:focus\n  ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);\n}\n\n.custom-control-input.is-valid:focus:not(:checked)\n  ~ .custom-control-label::before,\n.was-validated\n  .custom-control-input:valid:focus:not(:checked)\n  ~ .custom-control-label::before {\n  border-color: #00acac;\n}\n\n.custom-file-input.is-valid ~ .custom-file-label,\n.was-validated .custom-file-input:valid ~ .custom-file-label {\n  border-color: #00acac;\n}\n\n.custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip,\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip {\n  display: block;\n}\n\n.custom-file-input.is-valid:focus ~ .custom-file-label,\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label {\n  border-color: #00acac;\n  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.6875rem;\n  color: #ff5b57;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.6875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(255, 91, 87, 0.9);\n  border-radius: 4px;\n}\n\n.form-control.is-invalid,\n.was-validated .form-control:invalid {\n  border-color: #ff5b57;\n  padding-right: calc(1.5em + 14px);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23ff5b57' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23ff5b57' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center right calc(0.375em + 3.5px);\n  background-size: calc(0.75em + 7px) calc(0.75em + 7px);\n}\n\n.form-control.is-invalid:focus,\n.was-validated .form-control:invalid:focus {\n  border-color: #ff5b57;\n  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);\n}\n\n.form-control.is-invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-tooltip,\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 14px);\n  background-position: top calc(0.375em + 3.5px) right calc(0.375em + 3.5px);\n}\n\n.custom-select.is-invalid,\n.was-validated .custom-select:invalid {\n  border-color: #ff5b57;\n  padding-right: calc((1em + 14px) * 3 / 4 + 1.75rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\")\n      no-repeat right 0.75rem center/8px 10px,\n    url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23ff5b57' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23ff5b57' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\")\n      #fff no-repeat center right 1.75rem / calc(0.75em + 7px)\n      calc(0.75em + 7px);\n}\n\n.custom-select.is-invalid:focus,\n.was-validated .custom-select:invalid:focus {\n  border-color: #ff5b57;\n  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);\n}\n\n.custom-select.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-tooltip,\n.form-control-file.is-invalid ~ .invalid-feedback,\n.form-control-file.is-invalid ~ .invalid-tooltip,\n.was-validated .custom-select:invalid ~ .invalid-feedback,\n.was-validated .custom-select:invalid ~ .invalid-tooltip,\n.was-validated .form-control-file:invalid ~ .invalid-feedback,\n.was-validated .form-control-file:invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.form-check-input.is-invalid ~ .form-check-label,\n.was-validated .form-check-input:invalid ~ .form-check-label {\n  color: #ff5b57;\n}\n\n.form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip,\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.custom-control-input.is-invalid ~ .custom-control-label,\n.was-validated .custom-control-input:invalid ~ .custom-control-label {\n  color: #ff5b57;\n}\n\n.custom-control-input.is-invalid ~ .custom-control-label::before,\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before {\n  border-color: #ff5b57;\n}\n\n.custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip,\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.custom-control-input.is-invalid:checked ~ .custom-control-label::before,\n.was-validated\n  .custom-control-input:invalid:checked\n  ~ .custom-control-label::before {\n  border-color: #ff8d8a;\n  background-color: #ff8d8a;\n}\n\n.custom-control-input.is-invalid:focus ~ .custom-control-label::before,\n.was-validated\n  .custom-control-input:invalid:focus\n  ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);\n}\n\n.custom-control-input.is-invalid:focus:not(:checked)\n  ~ .custom-control-label::before,\n.was-validated\n  .custom-control-input:invalid:focus:not(:checked)\n  ~ .custom-control-label::before {\n  border-color: #ff5b57;\n}\n\n.custom-file-input.is-invalid ~ .custom-file-label,\n.was-validated .custom-file-input:invalid ~ .custom-file-label {\n  border-color: #ff5b57;\n}\n\n.custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip,\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.custom-file-input.is-invalid:focus ~ .custom-file-label,\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label {\n  border-color: #ff5b57;\n  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n\n.form-inline .form-check,\ninput[type=\"button\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"submit\"].btn-block {\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .form-inline .form-group,\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n  }\n\n  .form-inline label {\n    justify-content: center;\n  }\n\n  .form-inline .form-group {\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n  }\n\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n\n  .form-inline .custom-select,\n  .form-inline .input-group {\n    width: auto;\n  }\n\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n\n  .form-inline .form-check-input {\n    position: relative;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  color: #333;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 7px 0.75rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 4px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn:hover {\n  color: #333;\n  text-decoration: none;\n}\n\n.btn.focus,\n.btn:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.btn.disabled,\n.btn:disabled {\n  opacity: 0.65;\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-outline-primary {\n  color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-outline-primary.focus,\n.btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);\n}\n\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n  color: #00acac;\n  background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.btn-outline-primary:not(:disabled):not(.disabled):active,\n.show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary.focus,\n.btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-secondary.disabled,\n.btn-outline-secondary:disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\n.show > .btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-success {\n  color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-outline-success.focus,\n.btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);\n}\n\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n  color: #00acac;\n  background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.btn-outline-success:not(:disabled):not(.disabled):active,\n.show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(0, 172, 172, 0.5);\n}\n\n.btn-outline-info {\n  color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-outline-info:hover {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-outline-info.focus,\n.btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);\n}\n\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n  color: #49b6d6;\n  background-color: transparent;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.btn-outline-info:not(:disabled):not(.disabled):active,\n.show > .btn-outline-info.dropdown-toggle {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);\n}\n\n.btn-outline-warning {\n  color: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.btn-outline-warning.focus,\n.btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(245, 156, 26, 0.5);\n}\n\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n  color: #f59c1a;\n  background-color: transparent;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.btn-outline-warning:not(:disabled):not(.disabled):active,\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(245, 156, 26, 0.5);\n}\n\n.btn-outline-danger {\n  color: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.btn-outline-danger.focus,\n.btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(255, 91, 87, 0.5);\n}\n\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n  color: #ff5b57;\n  background-color: transparent;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.btn-outline-danger:not(:disabled):not(.disabled):active,\n.show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 91, 87, 0.5);\n}\n\n.btn-outline-light {\n  color: #f2f3f4;\n  border-color: #f2f3f4;\n}\n\n.btn-outline-light:hover {\n  color: #212529;\n  background-color: #f2f3f4;\n  border-color: #f2f3f4;\n}\n\n.btn-outline-light.focus,\n.btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(242, 243, 244, 0.5);\n}\n\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n  color: #f2f3f4;\n  background-color: transparent;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled).active,\n.btn-outline-light:not(:disabled):not(.disabled):active,\n.show > .btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #f2f3f4;\n  border-color: #f2f3f4;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(242, 243, 244, 0.5);\n}\n\n.btn-outline-dark,\n.btn-outline-inverse {\n  color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-outline-dark.focus,\n.btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);\n}\n\n.btn-outline-dark.disabled,\n.btn-outline-dark:disabled {\n  color: #2d353c;\n  background-color: transparent;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled).active,\n.btn-outline-dark:not(:disabled):not(.disabled):active,\n.show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);\n}\n\n.btn-outline-inverse:hover {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-outline-inverse.focus,\n.btn-outline-inverse:focus {\n  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);\n}\n\n.btn-outline-inverse.disabled,\n.btn-outline-inverse:disabled {\n  color: #2d353c;\n  background-color: transparent;\n}\n\n.btn-outline-inverse:not(:disabled):not(.disabled).active,\n.btn-outline-inverse:not(:disabled):not(.disabled):active,\n.show > .btn-outline-inverse.dropdown-toggle {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-outline-inverse:not(:disabled):not(.disabled).active:focus,\n.btn-outline-inverse:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-inverse.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(45, 53, 60, 0.5);\n}\n\n.btn-outline-black {\n  color: #000;\n  border-color: #000;\n}\n\n.btn-outline-black:hover {\n  color: #fff;\n  background-color: #000;\n  border-color: #000;\n}\n\n.btn-outline-black.focus,\n.btn-outline-black:focus {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n\n.btn-outline-black.disabled,\n.btn-outline-black:disabled {\n  color: #000;\n  background-color: transparent;\n}\n\n.btn-outline-black:not(:disabled):not(.disabled).active,\n.btn-outline-black:not(:disabled):not(.disabled):active,\n.show > .btn-outline-black.dropdown-toggle {\n  color: #fff;\n  background-color: #000;\n  border-color: #000;\n}\n\n.btn-outline-black:not(:disabled):not(.disabled).active:focus,\n.btn-outline-black:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-black.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n\n.btn-outline-white {\n  color: #fff;\n  border-color: #fff;\n}\n\n.btn-outline-white:hover {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n\n.btn-outline-white.focus,\n.btn-outline-white:focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-white.disabled,\n.btn-outline-white:disabled {\n  color: #fff;\n  background-color: transparent;\n}\n\n.btn-outline-white:not(:disabled):not(.disabled).active,\n.btn-outline-white:not(:disabled):not(.disabled):active,\n.show > .btn-outline-white.dropdown-toggle {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n\n.btn-outline-white:not(:disabled):not(.disabled).active:focus,\n.btn-outline-white:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-white.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-grey,\n.btn-outline-muted,\n.btn-outline-silver {\n  color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-grey:hover {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-grey.focus,\n.btn-outline-grey:focus {\n  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);\n}\n\n.btn-outline-grey.disabled,\n.btn-outline-grey:disabled {\n  color: #b6c2c9;\n  background-color: transparent;\n}\n\n.btn-outline-grey:not(:disabled):not(.disabled).active,\n.btn-outline-grey:not(:disabled):not(.disabled):active,\n.show > .btn-outline-grey.dropdown-toggle {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-grey:not(:disabled):not(.disabled).active:focus,\n.btn-outline-grey:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-grey.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);\n}\n\n.btn-outline-muted:hover {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-muted.focus,\n.btn-outline-muted:focus {\n  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);\n}\n\n.btn-outline-muted.disabled,\n.btn-outline-muted:disabled {\n  color: #b6c2c9;\n  background-color: transparent;\n}\n\n.btn-outline-muted:not(:disabled):not(.disabled).active,\n.btn-outline-muted:not(:disabled):not(.disabled):active,\n.show > .btn-outline-muted.dropdown-toggle {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-muted:not(:disabled):not(.disabled).active:focus,\n.btn-outline-muted:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-muted.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);\n}\n\n.btn-outline-silver:hover {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-silver.focus,\n.btn-outline-silver:focus {\n  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);\n}\n\n.btn-outline-silver.disabled,\n.btn-outline-silver:disabled {\n  color: #b6c2c9;\n  background-color: transparent;\n}\n\n.btn-outline-silver:not(:disabled):not(.disabled).active,\n.btn-outline-silver:not(:disabled):not(.disabled):active,\n.show > .btn-outline-silver.dropdown-toggle {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-outline-silver:not(:disabled):not(.disabled).active:focus,\n.btn-outline-silver:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-silver.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(182, 194, 201, 0.5);\n}\n\n.btn-outline-lime {\n  color: #90ca4b;\n  border-color: #90ca4b;\n}\n\n.btn-outline-lime:hover {\n  color: #212529;\n  background-color: #90ca4b;\n  border-color: #90ca4b;\n}\n\n.btn-outline-lime.focus,\n.btn-outline-lime:focus {\n  box-shadow: 0 0 0 0 rgba(144, 202, 75, 0.5);\n}\n\n.btn-outline-lime.disabled,\n.btn-outline-lime:disabled {\n  color: #90ca4b;\n  background-color: transparent;\n}\n\n.btn-outline-lime:not(:disabled):not(.disabled).active,\n.btn-outline-lime:not(:disabled):not(.disabled):active,\n.show > .btn-outline-lime.dropdown-toggle {\n  color: #212529;\n  background-color: #90ca4b;\n  border-color: #90ca4b;\n}\n\n.btn-outline-lime:not(:disabled):not(.disabled).active:focus,\n.btn-outline-lime:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-lime.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(144, 202, 75, 0.5);\n}\n\n.btn-outline-aqua {\n  color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-outline-aqua:hover {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-outline-aqua.focus,\n.btn-outline-aqua:focus {\n  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);\n}\n\n.btn-outline-aqua.disabled,\n.btn-outline-aqua:disabled {\n  color: #49b6d6;\n  background-color: transparent;\n}\n\n.btn-outline-aqua:not(:disabled):not(.disabled).active,\n.btn-outline-aqua:not(:disabled):not(.disabled):active,\n.show > .btn-outline-aqua.dropdown-toggle {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-outline-aqua:not(:disabled):not(.disabled).active:focus,\n.btn-outline-aqua:not(:disabled):not(.disabled):active:focus,\n.show > .btn-outline-aqua.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(73, 182, 214, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #348fe2;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: #1968b0;\n  text-decoration: underline;\n}\n\n.btn-link.focus,\n.btn-link:focus {\n  text-decoration: underline;\n  box-shadow: none;\n}\n\n.btn-link.disabled,\n.btn-link:disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.btn-group-lg > .btn,\n.btn-lg {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.8;\n  border-radius: 6px;\n}\n\n.btn-group-sm > .btn,\n.btn-sm {\n  padding: 0.3125rem 0.625rem;\n  font-size: 0.75rem;\n  line-height: 1.4;\n  border-radius: 3px;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropdown,\n.dropleft,\n.dropright,\n.dropup {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.6875rem;\n  color: #333;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 360px) {\n  .dropdown-menu-xs-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xs-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1660px) {\n  .dropdown-menu-xxl-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1900px) {\n  .dropdown-menu-xxxl-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxxl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n\n.dropleft .dropdown-toggle::before,\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n\n.dropdown-menu[x-placement^=\"bottom\"],\n.dropdown-menu[x-placement^=\"left\"],\n.dropdown-menu[x-placement^=\"right\"],\n.dropdown-menu[x-placement^=\"top\"] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 8px 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #348fe2;\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.6875rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.btn-group-vertical > .btn,\n.btn-group > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn:hover {\n  z-index: 1;\n}\n\n.btn-group-vertical > .btn.active,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn:focus,\n.btn-group > .btn.active,\n.btn-group > .btn:active,\n.btn-group > .btn:focus {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn-group:not(:last-child) > .btn,\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group > .btn-group:not(:first-child) > .btn,\n.btn-group > .btn:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n\n.dropdown-toggle-split::after,\n.dropright .dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-group-sm > .btn + .dropdown-toggle-split,\n.btn-sm + .dropdown-toggle-split {\n  padding-right: 0.46875rem;\n  padding-left: 0.46875rem;\n}\n\n.btn-group-lg > .btn + .dropdown-toggle-split,\n.btn-lg + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n\n.btn-group-vertical > .btn-group:not(:first-child),\n.btn-group-vertical > .btn:not(:first-child) {\n  margin-top: -1px;\n}\n\n.btn-group-vertical > .btn-group:not(:last-child) > .btn,\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical > .btn-group:not(:first-child) > .btn,\n.btn-group-vertical > .btn:not(:first-child) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n\n.btn-group-toggle > .btn input[type=\"checkbox\"],\n.btn-group-toggle > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"radio\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n\n.input-group > .custom-file,\n.input-group > .custom-select,\n.input-group > .form-control,\n.input-group > .form-control-plaintext {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  margin-bottom: 0;\n}\n\n.input-group > .custom-file + .custom-file,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .form-control,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .form-control,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .form-control {\n  margin-left: -1px;\n}\n\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label,\n.input-group > .custom-select:focus,\n.input-group > .form-control:focus {\n  z-index: 3;\n}\n\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n\n.input-group > .custom-file:not(:last-child) .custom-file-label,\n.input-group > .custom-file:not(:last-child) .custom-file-label::after,\n.input-group > .custom-select:not(:last-child),\n.input-group > .form-control:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .custom-file:not(:first-child) .custom-file-label,\n.input-group > .custom-select:not(:first-child),\n.input-group > .form-control:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group > .custom-file {\n  display: flex;\n  align-items: center;\n}\n\n.input-group-append,\n.input-group-prepend {\n  display: flex;\n}\n\n.input-group-append .btn,\n.input-group-prepend .btn {\n  position: relative;\n  z-index: 2;\n}\n\n.input-group-append .btn:focus,\n.input-group-prepend .btn:focus {\n  z-index: 3;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .btn,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-prepend .input-group-text + .input-group-text {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 7px 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #2d353c;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #d5dbe0;\n  border: 1px solid #d5dbe0;\n  border-radius: 4px;\n}\n\n.input-group-text input[type=\"checkbox\"],\n.input-group-text input[type=\"radio\"] {\n  margin-top: 0;\n}\n\n.input-group-lg > .custom-select,\n.input-group-lg > .form-control:not(textarea) {\n  height: calc(1.8em + 1rem + 2px);\n}\n\n.input-group-lg > .custom-select,\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-append > .btn,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-prepend > .input-group-text {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.8;\n  border-radius: 6px;\n}\n\n.input-group-sm > .custom-select,\n.input-group-sm > .form-control:not(textarea) {\n  height: calc(1.4em + 0.625rem + 2px);\n}\n\n.input-group-sm > .custom-select,\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-append > .btn,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-prepend > .input-group-text {\n  padding: 0.3125rem 0.625rem;\n  font-size: 0.75rem;\n  line-height: 1.4;\n  border-radius: 3px;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem;\n}\n\n.input-group\n  > .input-group-append:last-child\n  > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group\n  > .input-group-append:last-child\n  > .input-group-text:not(:last-child),\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group\n  > .input-group-prepend:first-child\n  > .input-group-text:not(:first-child),\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.125rem;\n  padding-left: 1.5rem;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #348fe2;\n  background-color: #348fe2;\n}\n\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #5db0ff;\n}\n\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: #d0e5f8;\n  border-color: #d0e5f8;\n}\n\n.custom-control-input:disabled ~ .custom-control-label {\n  color: #6c757d;\n}\n\n.custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n\n.custom-control-label::after,\n.custom-control-label::before {\n  position: absolute;\n  top: 0.0625rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n}\n\n.custom-control-label::before {\n  pointer-events: none;\n  background-color: #fff;\n  border: #adb5bd solid 1px;\n}\n\n.custom-control-label::after {\n  background: no-repeat 50%/50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 4px;\n}\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23FFFFFF' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox\n  .custom-control-input:indeterminate\n  ~ .custom-control-label::before {\n  border-color: #348fe2;\n  background-color: #348fe2;\n}\n\n.custom-checkbox\n  .custom-control-input:indeterminate\n  ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23FFFFFF' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox\n  .custom-control-input:disabled:checked\n  ~ .custom-control-label::before {\n  background-color: rgba(52, 143, 226, 0.5);\n}\n\n.custom-checkbox\n  .custom-control-input:disabled:indeterminate\n  ~ .custom-control-label::before {\n  background-color: rgba(52, 143, 226, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23FFFFFF'/%3e%3c/svg%3e\");\n}\n\n.custom-radio\n  .custom-control-input:disabled:checked\n  ~ .custom-control-label::before,\n.custom-switch\n  .custom-control-input:disabled:checked\n  ~ .custom-control-label::before {\n  background-color: rgba(52, 143, 226, 0.5);\n}\n\n.custom-switch {\n  padding-left: 2.25rem;\n}\n\n.custom-switch .custom-control-label::before {\n  left: -2.25rem;\n  width: 1.75rem;\n  pointer-events: all;\n  border-radius: 0.5rem;\n}\n\n.custom-switch .custom-control-label::after {\n  top: calc(0.0625rem + 2px);\n  left: calc(-2.25rem + 2px);\n  width: calc(1rem - 4px);\n  height: calc(1rem - 4px);\n  background-color: #adb5bd;\n  border-radius: 0.5rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fff;\n  transform: translateX(0.75rem);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 14px + 2px);\n  padding: 7px 1.75rem 7px 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #2d353c;\n  vertical-align: middle;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\")\n    no-repeat right 0.75rem center/8px 10px;\n  background-color: #fff;\n  border: 1px solid #d5dbe0;\n  border-radius: 4px;\n  appearance: none;\n}\n\n.custom-select:focus {\n  border-color: #5db0ff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.custom-select:focus::-ms-value {\n  color: #2d353c;\n  background-color: #fff;\n}\n\n.custom-select[multiple],\n.custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n\n.custom-select:disabled {\n  color: #6c757d;\n  background-color: #e9ecef;\n}\n\n.custom-select::-ms-expand {\n  display: none;\n}\n\n.custom-select-sm {\n  height: calc(1.4em + 0.625rem + 2px);\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  padding-left: 0.625rem;\n  font-size: 0.75rem;\n}\n\n.custom-select-lg {\n  height: calc(1.8em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 0.875rem;\n}\n\n.custom-file,\n.custom-file-input {\n  position: relative;\n  width: 100%;\n  height: calc(1.5em + 14px + 2px);\n}\n\n.custom-file {\n  display: inline-block;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  z-index: 2;\n  margin: 0;\n  opacity: 0;\n}\n\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: #5db0ff;\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.custom-file-input:disabled ~ .custom-file-label {\n  background-color: #e9ecef;\n}\n\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label,\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 7px 0.75rem;\n  line-height: 1.5;\n  color: #2d353c;\n}\n\n.custom-file-label {\n  left: 0;\n  font-weight: 400;\n  border: 1px solid #d5dbe0;\n  z-index: 1;\n  height: calc(1.5em + 14px + 2px);\n  background-color: #fff;\n  border-radius: 4px;\n}\n\n.custom-file-label::after {\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 14px);\n  content: \"Browse\";\n  background-color: #d5dbe0;\n  border-left: inherit;\n  border-radius: 0 4px 4px 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: calc(1rem + 0.4rem);\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n\n.custom-range:focus {\n  outline: 0;\n}\n\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #d9e0e7, 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #d9e0e7, 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #d9e0e7, 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #348fe2;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n\n.custom-range::-webkit-slider-thumb:active {\n  background-color: #d0e5f8;\n}\n\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #348fe2;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n\n.custom-range::-moz-range-thumb:active {\n  background-color: #d0e5f8;\n}\n\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0.2rem;\n  margin-left: 0.2rem;\n  background-color: #348fe2;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    transition: none;\n  }\n}\n\n.custom-range::-ms-thumb:active {\n  background-color: #d0e5f8;\n}\n\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n}\n\n.custom-range::-ms-fill-lower {\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n\n.nav-link:focus,\n.nav-link:hover {\n  text-decoration: none;\n}\n\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 0 solid #dee2e6;\n}\n\n.nav-tabs .nav-item {\n  margin-bottom: 0;\n}\n\n.nav-tabs .nav-link {\n  border: 0 solid transparent;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 4px;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #348fe2;\n}\n\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  padding: 8px 16px;\n}\n\n.navbar,\n.navbar > .container,\n.navbar > .container-fluid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.40625rem;\n  padding-bottom: 0.40625rem;\n  margin-right: 16px;\n  font-size: 0.875rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n\n.navbar-brand:focus,\n.navbar-brand:hover {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.navbar-toggler:focus,\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n@media (max-width: 359.98px) {\n  .navbar-expand-xs > .container,\n  .navbar-expand-xs > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 360px) {\n  .navbar-expand-xs {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xs .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xs .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xs .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xs > .container,\n  .navbar-expand-xs > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-xs .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xs .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1659.98px) {\n  .navbar-expand-xxl > .container,\n  .navbar-expand-xxl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1660px) {\n  .navbar-expand-xxl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xxl > .container,\n  .navbar-expand-xxl > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1899.98px) {\n  .navbar-expand-xxxl > .container,\n  .navbar-expand-xxxl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1900px) {\n  .navbar-expand-xxxl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xxxl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xxxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xxxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xxxl > .container,\n  .navbar-expand-xxxl > .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-xxxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xxxl .navbar-toggler {\n    display: none;\n  }\n}\n\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid {\n  flex-wrap: nowrap;\n}\n\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:focus,\n.navbar-light .navbar-brand:hover,\n.navbar-light .navbar-text a:focus,\n.navbar-light .navbar-text a:hover {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-nav .nav-link:focus,\n.navbar-light .navbar-nav .nav-link:hover {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.active,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' strokeWidth='2' strokeLinecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n\n.navbar-dark .navbar-brand:focus,\n.navbar-dark .navbar-brand:hover,\n.navbar-dark .navbar-text a:focus,\n.navbar-dark .navbar-text a:hover {\n  color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-nav .nav-link:focus,\n.navbar-dark .navbar-nav .nav-link:hover {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.active,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-text a {\n  color: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' strokeWidth='2' strokeLinecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(45, 53, 60, 0.15);\n  border-radius: 4px;\n}\n\n.card > .list-group:first-child .list-group-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.card > .list-group:last-child .list-group-item:last-child {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 15px;\n}\n\n.card-title {\n  margin-bottom: 15px;\n}\n\n.card-subtitle {\n  margin-top: -7.5px;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li.picker-switch\n  table\n  tbody\n  tr\n  td\n  a,\nbody .datetimepicker.dropdown-menu > ul > li.picker-switch table tbody tr td a {\n  text-decoration: none;\n}\n\n.card-link + .card-link {\n  margin-left: 15px;\n}\n\n.card-header {\n  padding: 15px;\n  margin-bottom: 0;\n  background-color: #f2f4f5;\n  border-bottom: 1px solid rgba(45, 53, 60, 0.15);\n}\n\n.card-header:first-child {\n  border-radius: calc(4px - 1px) calc(4px - 1px) 0 0;\n}\n\n.card-header + .list-group .list-group-item:first-child {\n  border-top: 0;\n}\n\n.card-footer {\n  padding: 15px;\n  background-color: #f2f4f5;\n  border-top: 1px solid rgba(45, 53, 60, 0.15);\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 calc(4px - 1px) calc(4px - 1px);\n}\n\n.card-header-tabs {\n  margin-bottom: -15px;\n  border-bottom: 0;\n}\n\n.card-header-pills,\n.card-header-tabs {\n  margin-right: -7.5px;\n  margin-left: -7.5px;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 15px;\n}\n\n.card-img {\n  width: 100%;\n  border-radius: calc(4px - 1px);\n}\n\n.card-img-top {\n  width: 100%;\n  border-top-left-radius: calc(4px - 1px);\n  border-top-right-radius: calc(4px - 1px);\n}\n\n.card-img-bottom {\n  width: 100%;\n  border-bottom-right-radius: calc(4px - 1px);\n  border-bottom-left-radius: calc(4px - 1px);\n}\n\n.card-deck {\n  display: flex;\n  flex-direction: column;\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-deck {\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n\n  .card-deck .card {\n    display: flex;\n    flex: 1 0 0%;\n    flex-direction: column;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.card-group > .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-group {\n    flex-flow: row wrap;\n  }\n\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group > .card:not(:last-child) .card-header,\n  .card-group > .card:not(:last-child) .card-img-top {\n    border-top-right-radius: 0;\n  }\n\n  .card-group > .card:not(:last-child) .card-footer,\n  .card-group > .card:not(:last-child) .card-img-bottom {\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .card-group > .card:not(:first-child) .card-header,\n  .card-group > .card:not(:first-child) .card-img-top {\n    border-top-left-radius: 0;\n  }\n\n  .card-group > .card:not(:first-child) .card-footer,\n  .card-group > .card:not(:first-child) .card-img-bottom {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 15px;\n    orphans: 1;\n    widows: 1;\n  }\n\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion > .card {\n  overflow: hidden;\n}\n\n.accordion > .card:not(:first-of-type) .card-header:first-child {\n  border-radius: 0;\n}\n\n.accordion > .card:not(:first-of-type):not(:last-of-type) {\n  border-bottom: 0;\n  border-radius: 0;\n}\n\n.accordion > .card:first-of-type {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.accordion > .card:last-of-type {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.accordion > .card .card-header {\n  margin-bottom: -1px;\n}\n\n.breadcrumb,\n.pagination {\n  display: flex;\n  list-style: none;\n  border-radius: 4px;\n}\n\n.breadcrumb {\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  background-color: #e9ecef;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: \"/\";\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  padding-left: 0;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #6f8293;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: #2d353c;\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #d5dbe0;\n}\n\n.page-link:focus {\n  z-index: 2;\n  outline: 0;\n  box-shadow: 0;\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.page-item.active .page-link {\n  z-index: 1;\n  color: #fff;\n  background-color: #348fe2;\n  border-color: #348fe2;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 0.875rem;\n  line-height: 1.8;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.6875rem;\n  line-height: 1.4;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n\n.badge {\n  line-height: 1;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\n\n.panel .panel-heading .panel-title > a:focus,\n.panel .panel-heading .panel-title > a:hover,\na.badge:focus,\na.badge:hover {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #00acac;\n}\n\na.badge-primary:focus,\na.badge-primary:hover {\n  color: #fff;\n  background-color: #007979;\n}\n\na.badge-primary.focus,\na.badge-primary:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.5);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d;\n}\n\na.badge-secondary:focus,\na.badge-secondary:hover {\n  color: #fff;\n  background-color: #545b62;\n}\n\na.badge-secondary.focus,\na.badge-secondary:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #00acac;\n}\n\na.badge-success:focus,\na.badge-success:hover {\n  color: #fff;\n  background-color: #007979;\n}\n\na.badge-success.focus,\na.badge-success:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 172, 172, 0.5);\n}\n\n.badge-info {\n  color: #212529;\n  background-color: #49b6d6;\n}\n\na.badge-info:focus,\na.badge-info:hover {\n  color: #212529;\n  background-color: #2b9fc1;\n}\n\na.badge-info.focus,\na.badge-info:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(73, 182, 214, 0.5);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #f59c1a;\n}\n\na.badge-warning:focus,\na.badge-warning:hover {\n  color: #212529;\n  background-color: #d38109;\n}\n\na.badge-warning.focus,\na.badge-warning:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(245, 156, 26, 0.5);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #ff5b57;\n}\n\na.badge-danger:focus,\na.badge-danger:hover {\n  color: #fff;\n  background-color: #ff2924;\n}\n\na.badge-danger.focus,\na.badge-danger:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(255, 91, 87, 0.5);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #f2f3f4;\n}\n\na.badge-light:focus,\na.badge-light:hover {\n  color: #212529;\n  background-color: #d6dadd;\n}\n\na.badge-light.focus,\na.badge-light:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(242, 243, 244, 0.5);\n}\n\n.badge-dark,\n.badge-inverse {\n  color: #fff;\n  background-color: #2d353c;\n}\n\na.badge-dark:focus,\na.badge-dark:hover {\n  color: #fff;\n  background-color: #171b1f;\n}\n\na.badge-dark.focus,\na.badge-dark:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(45, 53, 60, 0.5);\n}\n\na.badge-inverse:focus,\na.badge-inverse:hover {\n  color: #fff;\n  background-color: #171b1f;\n}\n\na.badge-inverse.focus,\na.badge-inverse:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(45, 53, 60, 0.5);\n}\n\n.badge-black {\n  color: #fff;\n  background-color: #000;\n}\n\na.badge-black:focus,\na.badge-black:hover {\n  color: #fff;\n  background-color: #000;\n}\n\na.badge-black.focus,\na.badge-black:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.5);\n}\n\n.badge-white {\n  color: #212529;\n  background-color: #fff;\n}\n\na.badge-white:focus,\na.badge-white:hover {\n  color: #212529;\n  background-color: #e6e6e6;\n}\n\na.badge-white.focus,\na.badge-white:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.badge-grey,\n.badge-muted,\n.badge-silver {\n  color: #212529;\n  background-color: #b6c2c9;\n}\n\na.badge-grey:focus,\na.badge-grey:hover {\n  color: #212529;\n  background-color: #99aab3;\n}\n\na.badge-grey.focus,\na.badge-grey:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(182, 194, 201, 0.5);\n}\n\na.badge-muted:focus,\na.badge-muted:hover {\n  color: #212529;\n  background-color: #99aab3;\n}\n\na.badge-muted.focus,\na.badge-muted:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(182, 194, 201, 0.5);\n}\n\na.badge-silver:focus,\na.badge-silver:hover {\n  color: #212529;\n  background-color: #99aab3;\n}\n\na.badge-silver.focus,\na.badge-silver:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(182, 194, 201, 0.5);\n}\n\n.badge-lime {\n  color: #212529;\n  background-color: #90ca4b;\n}\n\na.badge-lime:focus,\na.badge-lime:hover {\n  color: #212529;\n  background-color: #76af33;\n}\n\na.badge-lime.focus,\na.badge-lime:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(144, 202, 75, 0.5);\n}\n\n.badge-aqua {\n  color: #212529;\n  background-color: #49b6d6;\n}\n\na.badge-aqua:focus,\na.badge-aqua:hover {\n  color: #212529;\n  background-color: #2b9fc1;\n}\n\na.badge-aqua.focus,\na.badge-aqua:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(73, 182, 214, 0.5);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 6px;\n}\n\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.9375rem;\n  margin-bottom: 1.25rem;\n  border: 0 solid transparent;\n  border-radius: 4px;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link,\n.header .navbar-brand b,\nb {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.9375rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #005959;\n  background-color: #cee;\n  border-color: #b8e8e8;\n}\n\n.alert-primary hr {\n  border-top-color: #a5e2e2;\n}\n\n.alert-primary .alert-link {\n  color: #002626;\n}\n\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db;\n}\n\n.alert-secondary hr {\n  border-top-color: #c8cbcf;\n}\n\n.alert-secondary .alert-link {\n  color: #202326;\n}\n\n.alert-success {\n  color: #005959;\n  background-color: #cee;\n  border-color: #b8e8e8;\n}\n\n.alert-success hr {\n  border-top-color: #a5e2e2;\n}\n\n.alert-success .alert-link {\n  color: #002626;\n}\n\n.alert-info {\n  color: #265f6f;\n  background-color: #dbf0f7;\n  border-color: #ccebf4;\n}\n\n.alert-info hr {\n  border-top-color: #b7e3ef;\n}\n\n.alert-info .alert-link {\n  color: #193e49;\n}\n\n.alert-warning {\n  color: #7f510e;\n  background-color: #fdebd1;\n  border-color: #fce3bf;\n}\n\n.alert-warning hr {\n  border-top-color: #fbd8a7;\n}\n\n.alert-warning .alert-link {\n  color: #513409;\n}\n\n.alert-danger {\n  color: #852f2d;\n  background-color: #ffdedd;\n  border-color: #ffd1d0;\n}\n\n.alert-danger hr {\n  border-top-color: #ffb8b7;\n}\n\n.alert-danger .alert-link {\n  color: #5f2220;\n}\n\n.alert-light {\n  color: #7e7e7f;\n  background-color: #fcfdfd;\n  border-color: #fbfcfc;\n}\n\n.alert-light hr {\n  border-top-color: #ecf1f1;\n}\n\n.alert-light .alert-link {\n  color: #656565;\n}\n\n.alert-dark,\n.alert-inverse {\n  color: #171c1f;\n  background-color: #d5d7d8;\n  border-color: #c4c6c8;\n}\n\n.alert-dark hr,\n.alert-inverse hr {\n  border-top-color: #b7b9bc;\n}\n\n.alert-dark .alert-link,\n.alert-inverse .alert-link {\n  color: #010202;\n}\n\n.alert-black {\n  color: #000;\n  background-color: #ccc;\n  border-color: #b8b8b8;\n}\n\n.alert-black hr {\n  border-top-color: #ababab;\n}\n\n.alert-black .alert-link {\n  color: #000;\n}\n\n.alert-white {\n  color: #858585;\n  background-color: #fff;\n  border-color: #fff;\n}\n\n.alert-white hr {\n  border-top-color: #f2f2f2;\n}\n\n.alert-white .alert-link {\n  color: #6c6c6c;\n}\n\n.alert-grey,\n.alert-muted,\n.alert-silver {\n  color: #5f6569;\n  background-color: #f0f3f4;\n  border-color: #ebeef0;\n}\n\n.alert-grey hr,\n.alert-muted hr,\n.alert-silver hr {\n  border-top-color: #dce2e5;\n}\n\n.alert-grey .alert-link,\n.alert-muted .alert-link,\n.alert-silver .alert-link {\n  color: #474b4e;\n}\n\n.alert-lime {\n  color: #4b6927;\n  background-color: #e9f4db;\n  border-color: #e0f0cd;\n}\n\n.alert-lime hr {\n  border-top-color: #d4eab9;\n}\n\n.alert-lime .alert-link {\n  color: #304419;\n}\n\n.alert-aqua {\n  color: #265f6f;\n  background-color: #dbf0f7;\n  border-color: #ccebf4;\n}\n\n.alert-aqua hr {\n  border-top-color: #b7e3ef;\n}\n\n.alert-aqua .alert-link {\n  color: #193e49;\n}\n\n.progress-bar-left {\n  border-radius: 2px 0 0 2px !important;\n}\n\n.progress-bar-right {\n  border-radius: 0 2px 2px 0 !important;\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.5625rem;\n  background-color: #e4e7ea;\n  border-radius: 4px;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #348fe2;\n  transition: width 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.15) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.15) 75%,\n    transparent 75%,\n    transparent\n  );\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.media {\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n\n.list-group-item-action:focus,\n.list-group-item-action:hover {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n\n.list-group-item-action:active {\n  color: #333;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(45, 53, 60, 0.125);\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #348fe2;\n  border-color: #348fe2;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n\n.list-group-horizontal .list-group-item {\n  margin-right: -1px;\n  margin-bottom: 0;\n}\n\n.list-group-horizontal .list-group-item:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-top-right-radius: 0;\n}\n\n.list-group-horizontal .list-group-item:last-child {\n  margin-right: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 0;\n}\n\n@media (min-width: 360px) {\n  .list-group-horizontal-xs {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xs .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-xs .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xs .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-sm .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-sm .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-sm .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-md .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-md .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-md .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-lg .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-lg .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-lg .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xl .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-xl .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xl .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n@media (min-width: 1660px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xxl .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-xxl .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xxl .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n@media (min-width: 1900px) {\n  .list-group-horizontal-xxxl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xxxl .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0;\n  }\n\n  .list-group-horizontal-xxxl .list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xxxl .list-group-item:last-child {\n    margin-right: 0;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n  }\n}\n\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n\n.list-group-flush .list-group-item:last-child {\n  margin-bottom: -1px;\n}\n\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0;\n}\n\n.list-group-flush:last-child .list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom: 0;\n}\n\n.list-group-item-primary {\n  color: #005959;\n  background-color: #b8e8e8;\n}\n\n.list-group-item-primary.list-group-item-action:focus,\n.list-group-item-primary.list-group-item-action:hover {\n  color: #005959;\n  background-color: #a5e2e2;\n}\n\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: #005959;\n  border-color: #005959;\n}\n\n.list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db;\n}\n\n.list-group-item-secondary.list-group-item-action:focus,\n.list-group-item-secondary.list-group-item-action:hover {\n  color: #383d41;\n  background-color: #c8cbcf;\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: #383d41;\n  border-color: #383d41;\n}\n\n.list-group-item-success {\n  color: #005959;\n  background-color: #b8e8e8;\n}\n\n.list-group-item-success.list-group-item-action:focus,\n.list-group-item-success.list-group-item-action:hover {\n  color: #005959;\n  background-color: #a5e2e2;\n}\n\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: #005959;\n  border-color: #005959;\n}\n\n.list-group-item-info {\n  color: #265f6f;\n  background-color: #ccebf4;\n}\n\n.list-group-item-info.list-group-item-action:focus,\n.list-group-item-info.list-group-item-action:hover {\n  color: #265f6f;\n  background-color: #b7e3ef;\n}\n\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: #265f6f;\n  border-color: #265f6f;\n}\n\n.list-group-item-warning {\n  color: #7f510e;\n  background-color: #fce3bf;\n}\n\n.list-group-item-warning.list-group-item-action:focus,\n.list-group-item-warning.list-group-item-action:hover {\n  color: #7f510e;\n  background-color: #fbd8a7;\n}\n\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: #7f510e;\n  border-color: #7f510e;\n}\n\n.list-group-item-danger {\n  color: #852f2d;\n  background-color: #ffd1d0;\n}\n\n.list-group-item-danger.list-group-item-action:focus,\n.list-group-item-danger.list-group-item-action:hover {\n  color: #852f2d;\n  background-color: #ffb8b7;\n}\n\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: #852f2d;\n  border-color: #852f2d;\n}\n\n.list-group-item-light {\n  color: #7e7e7f;\n  background-color: #fbfcfc;\n}\n\n.list-group-item-light.list-group-item-action:focus,\n.list-group-item-light.list-group-item-action:hover {\n  color: #7e7e7f;\n  background-color: #ecf1f1;\n}\n\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: #7e7e7f;\n  border-color: #7e7e7f;\n}\n\n.list-group-item-dark,\n.list-group-item-inverse {\n  color: #171c1f;\n  background-color: #c4c6c8;\n}\n\n.list-group-item-dark.list-group-item-action:focus,\n.list-group-item-dark.list-group-item-action:hover {\n  color: #171c1f;\n  background-color: #b7b9bc;\n}\n\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: #171c1f;\n  border-color: #171c1f;\n}\n\n.list-group-item-inverse.list-group-item-action:focus,\n.list-group-item-inverse.list-group-item-action:hover {\n  color: #171c1f;\n  background-color: #b7b9bc;\n}\n\n.list-group-item-inverse.list-group-item-action.active {\n  color: #fff;\n  background-color: #171c1f;\n  border-color: #171c1f;\n}\n\n.list-group-item-black {\n  color: #000;\n  background-color: #b8b8b8;\n}\n\n.list-group-item-black.list-group-item-action:focus,\n.list-group-item-black.list-group-item-action:hover {\n  color: #000;\n  background-color: #ababab;\n}\n\n.list-group-item-black.list-group-item-action.active {\n  color: #fff;\n  background-color: #000;\n  border-color: #000;\n}\n\n.list-group-item-white {\n  color: #858585;\n  background-color: #fff;\n}\n\n.list-group-item-white.list-group-item-action:focus,\n.list-group-item-white.list-group-item-action:hover {\n  color: #858585;\n  background-color: #f2f2f2;\n}\n\n.list-group-item-white.list-group-item-action.active {\n  color: #fff;\n  background-color: #858585;\n  border-color: #858585;\n}\n\n.list-group-item-grey,\n.list-group-item-muted,\n.list-group-item-silver {\n  color: #5f6569;\n  background-color: #ebeef0;\n}\n\n.list-group-item-grey.list-group-item-action:focus,\n.list-group-item-grey.list-group-item-action:hover {\n  color: #5f6569;\n  background-color: #dce2e5;\n}\n\n.list-group-item-grey.list-group-item-action.active {\n  color: #fff;\n  background-color: #5f6569;\n  border-color: #5f6569;\n}\n\n.list-group-item-muted.list-group-item-action:focus,\n.list-group-item-muted.list-group-item-action:hover {\n  color: #5f6569;\n  background-color: #dce2e5;\n}\n\n.list-group-item-muted.list-group-item-action.active {\n  color: #fff;\n  background-color: #5f6569;\n  border-color: #5f6569;\n}\n\n.list-group-item-silver.list-group-item-action:focus,\n.list-group-item-silver.list-group-item-action:hover {\n  color: #5f6569;\n  background-color: #dce2e5;\n}\n\n.list-group-item-silver.list-group-item-action.active {\n  color: #fff;\n  background-color: #5f6569;\n  border-color: #5f6569;\n}\n\n.list-group-item-lime {\n  color: #4b6927;\n  background-color: #e0f0cd;\n}\n\n.list-group-item-lime.list-group-item-action:focus,\n.list-group-item-lime.list-group-item-action:hover {\n  color: #4b6927;\n  background-color: #d4eab9;\n}\n\n.list-group-item-lime.list-group-item-action.active {\n  color: #fff;\n  background-color: #4b6927;\n  border-color: #4b6927;\n}\n\n.list-group-item-aqua {\n  color: #265f6f;\n  background-color: #ccebf4;\n}\n\n.list-group-item-aqua.list-group-item-action:focus,\n.list-group-item-aqua.list-group-item-action:hover {\n  color: #265f6f;\n  background-color: #b7e3ef;\n}\n\n.list-group-item-aqua.list-group-item-action.active {\n  color: #fff;\n  background-color: #265f6f;\n  border-color: #265f6f;\n}\n\n.close {\n  float: right;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #000;\n  opacity: 0.5;\n}\n\n.close:hover {\n  color: #000;\n  text-decoration: none;\n}\n\n.close:not(:disabled):not(.disabled):focus,\n.close:not(:disabled):not(.disabled):hover {\n  opacity: 0.75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.toast {\n  max-width: 350px;\n  overflow: hidden;\n  font-size: 0.875rem;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  opacity: 0;\n  border-radius: 0.25rem;\n}\n\n.toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast.showing {\n  opacity: 1;\n}\n\n.toast.show {\n  display: block;\n  opacity: 1;\n}\n\n#page-loader.fade,\n.toast.hide {\n  display: none;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.toast-body {\n  padding: 0.75rem;\n}\n\n.modal,\n.modal-open {\n  overflow: hidden;\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  outline: 0;\n}\n\n.modal-dialog {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  height: calc(100vh - 60px) !important;\n}\n\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n\n.modal.show .modal-dialog {\n  transform: none;\n}\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-footer,\n.modal-dialog-scrollable .modal-header {\n  flex-shrink: 0;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n}\n\n.modal-dialog-centered.modal-dialog-scrollable {\n  flex-direction: column;\n  justify-content: center;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 15px;\n  border-bottom: 1px solid #d5dbe0;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.modal-header .close {\n  padding: 15px;\n  margin: -15px -15px -15px auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #d5dbe0;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.modal-footer > :not(:first-child) {\n  margin-left: 0.25rem;\n}\n\n.modal-footer > :not(:last-child) {\n  margin-right: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n  }\n\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n\n.tooltip,\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n}\n\n.tooltip {\n  z-index: 1070;\n  margin: 0;\n  font-family: \"Open Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.6875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n\n.tooltip.show {\n  opacity: 0.9;\n}\n\n.tooltip .arrow {\n  width: 0.8rem;\n  height: 0.4rem;\n}\n\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-auto[x-placement^=\"top\"],\n.bs-tooltip-top {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow,\n.bs-tooltip-top .arrow {\n  bottom: 0;\n}\n\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before,\n.bs-tooltip-top .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-auto[x-placement^=\"right\"],\n.bs-tooltip-right {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow,\n.bs-tooltip-right .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before,\n.bs-tooltip-right .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-auto[x-placement^=\"bottom\"],\n.bs-tooltip-bottom {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow,\n.bs-tooltip-bottom .arrow {\n  top: 0;\n}\n\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before,\n.bs-tooltip-bottom .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-auto[x-placement^=\"left\"],\n.bs-tooltip-left {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow,\n.bs-tooltip-left .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before,\n.bs-tooltip-left .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n\n.popover,\n.popover .arrow {\n  position: absolute;\n  display: block;\n}\n\n.popover {\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  max-width: 276px;\n  font-family: \"Open Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.6875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n}\n\n.popover .arrow {\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 6px;\n}\n\n.popover .arrow::after,\n.popover .arrow::before {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-auto[x-placement^=\"top\"],\n.bs-popover-top {\n  margin-bottom: 0.5rem;\n}\n\n.bs-popover-auto[x-placement^=\"top\"] > .arrow,\n.bs-popover-top > .arrow {\n  bottom: calc((0.5rem + 1px) * -1);\n}\n\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::before,\n.bs-popover-top > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::after,\n.bs-popover-top > .arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-auto[x-placement^=\"right\"],\n.bs-popover-right {\n  margin-left: 0.5rem;\n}\n\n.bs-popover-auto[x-placement^=\"right\"] > .arrow,\n.bs-popover-right > .arrow {\n  left: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 6px 0;\n}\n\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::before,\n.bs-popover-right > .arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::after,\n.bs-popover-right > .arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-auto[x-placement^=\"bottom\"],\n.bs-popover-bottom {\n  margin-top: 0.5rem;\n}\n\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow,\n.bs-popover-bottom > .arrow {\n  top: calc((0.5rem + 1px) * -1);\n}\n\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before,\n.bs-popover-bottom > .arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after,\n.bs-popover-bottom > .arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n\n.bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before,\n.bs-popover-bottom .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #f7f7f7;\n}\n\n.bs-popover-auto[x-placement^=\"left\"],\n.bs-popover-left {\n  margin-right: 0.5rem;\n}\n\n.bs-popover-auto[x-placement^=\"left\"] > .arrow,\n.bs-popover-left > .arrow {\n  right: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 6px 0;\n}\n\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::before,\n.bs-popover-left > .arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::after,\n.bs-popover-left > .arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.75rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(6px - 1px);\n  border-top-right-radius: calc(6px - 1px);\n}\n\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #333;\n}\n\n.carousel,\n.carousel-inner,\n.header .navbar-nav > li,\n.sidebar .nav > li,\n.sidebar .sub-menu > li {\n  /* position: relative */\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-inner::after,\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active {\n  display: block;\n}\n\n.active.carousel-item-right,\n.carousel-item-next:not(.carousel-item-left) {\n  transform: translateX(100%);\n}\n\n.active.carousel-item-left,\n.carousel-item-prev:not(.carousel-item-right) {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right,\n.carousel-fade .carousel-item.active {\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: 0s 0.6s opacity;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-next,\n.carousel-control-prev {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-next,\n  .carousel-control-prev {\n    transition: none;\n  }\n}\n\n.carousel-control-next:focus,\n.carousel-control-next:hover,\n.carousel-control-prev:focus,\n.carousel-control-prev:hover {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50%/100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23FFFFFF' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23FFFFFF' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n\n.carousel-indicators li {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow 0.75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\na.bg-primary:focus,\na.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n  background-color: #007979 !important;\n}\n\na.bg-secondary:focus,\na.bg-secondary:hover,\nbutton.bg-secondary:focus,\nbutton.bg-secondary:hover {\n  background-color: #545b62 !important;\n}\n\na.bg-success:focus,\na.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n  background-color: #007979 !important;\n}\n\na.bg-info:focus,\na.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n  background-color: #2b9fc1 !important;\n}\n\na.bg-warning:focus,\na.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n  background-color: #d38109 !important;\n}\n\na.bg-danger:focus,\na.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n  background-color: #ff2924 !important;\n}\n\na.bg-light:focus,\na.bg-light:hover,\nbutton.bg-light:focus,\nbutton.bg-light:hover {\n  background-color: #d6dadd !important;\n}\n\na.bg-dark:focus,\na.bg-dark:hover,\na.bg-inverse:focus,\na.bg-inverse:hover,\nbutton.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-inverse:focus,\nbutton.bg-inverse:hover {\n  background-color: #171b1f !important;\n}\n\na.bg-black:focus,\na.bg-black:hover,\nbutton.bg-black:focus,\nbutton.bg-black:hover {\n  background-color: #000 !important;\n}\n\na.bg-white:focus,\na.bg-white:hover,\nbutton.bg-white:focus,\nbutton.bg-white:hover {\n  background-color: #e6e6e6 !important;\n}\n\na.bg-grey:focus,\na.bg-grey:hover,\na.bg-muted:focus,\na.bg-muted:hover,\na.bg-silver:focus,\na.bg-silver:hover,\nbutton.bg-grey:focus,\nbutton.bg-grey:hover,\nbutton.bg-muted:focus,\nbutton.bg-muted:hover,\nbutton.bg-silver:focus,\nbutton.bg-silver:hover {\n  background-color: #99aab3 !important;\n}\n\na.bg-lime:focus,\na.bg-lime:hover,\nbutton.bg-lime:focus,\nbutton.bg-lime:hover {\n  background-color: #76af33 !important;\n}\n\na.bg-aqua:focus,\na.bg-aqua:hover,\nbutton.bg-aqua:focus,\nbutton.bg-aqua:hover {\n  background-color: #2b9fc1 !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #d5dbe0 !important;\n}\n\n.border-top {\n  border-top: 1px solid #d5dbe0 !important;\n}\n\n.border-right {\n  border-right: 1px solid #d5dbe0 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #d5dbe0 !important;\n}\n\n.border-left {\n  border-left: 1px solid #d5dbe0 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #00acac !important;\n}\n\n.border-secondary {\n  border-color: #6c757d !important;\n}\n\n.border-success {\n  border-color: #00acac !important;\n}\n\n.border-info {\n  border-color: #49b6d6 !important;\n}\n\n.border-warning {\n  border-color: #f59c1a !important;\n}\n\n.border-danger {\n  border-color: #ff5b57 !important;\n}\n\n.border-light {\n  border-color: #f2f3f4 !important;\n}\n\n.border-dark,\n.border-inverse {\n  border-color: #2d353c !important;\n}\n\n.border-black {\n  border-color: #000 !important;\n}\n\n.border-grey,\n.border-muted,\n.border-silver {\n  border-color: #b6c2c9 !important;\n}\n\n.border-lime {\n  border-color: #90ca4b !important;\n}\n\n.border-aqua {\n  border-color: #49b6d6 !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 3px !important;\n}\n\n.rounded {\n  border-radius: 4px !important;\n}\n\n.rounded-right,\n.rounded-top {\n  border-top-right-radius: 4px !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 4px !important;\n}\n\n.rounded-right {\n  border-bottom-right-radius: 4px !important;\n}\n\n.rounded-bottom,\n.rounded-left {\n  border-bottom-left-radius: 4px !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 4px !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 4px !important;\n}\n\n.rounded-lg {\n  border-radius: 6px !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 360px) {\n  .d-xs-none {\n    display: none !important;\n  }\n\n  .d-xs-inline {\n    display: inline !important;\n  }\n\n  .d-xs-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xs-block {\n    display: block !important;\n  }\n\n  .d-xs-table {\n    display: table !important;\n  }\n\n  .d-xs-table-row {\n    display: table-row !important;\n  }\n\n  .d-xs-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xs-flex {\n    display: flex !important;\n  }\n\n  .d-xs-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1660px) {\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .d-xxxl-none {\n    display: none !important;\n  }\n\n  .d-xxxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxxl-block {\n    display: block !important;\n  }\n\n  .d-xxxl-table {\n    display: table !important;\n  }\n\n  .d-xxxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxxl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive embed,\n.embed-responsive iframe,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 360px) {\n  .flex-xs-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xs-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xs-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xs-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xs-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xs-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xs-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xs-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xs-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xs-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xs-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xs-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xs-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xs-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xs-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xs-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xs-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xs-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xs-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xs-center {\n    align-items: center !important;\n  }\n\n  .align-items-xs-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xs-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xs-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xs-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xs-center {\n    align-content: center !important;\n  }\n\n  .align-content-xs-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xs-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xs-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xs-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xs-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xs-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xs-center {\n    align-self: center !important;\n  }\n\n  .align-self-xs-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xs-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1660px) {\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .flex-xxxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xxxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xxxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxxl-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xxxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxxl-stretch {\n    align-self: stretch !important;\n  }\n}\n\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 360px) {\n  .float-xs-left {\n    float: left !important;\n  }\n\n  .float-xs-right {\n    float: right !important;\n  }\n\n  .float-xs-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n\n  .float-sm-right {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n\n  .float-md-right {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n\n  .float-lg-right {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n\n  .float-xl-right {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1660px) {\n  .float-xxl-left {\n    float: left !important;\n  }\n\n  .float-xxl-right {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .float-xxxl-left {\n    float: left !important;\n  }\n\n  .float-xxxl-right {\n    float: right !important;\n  }\n\n  .float-xxxl-none {\n    float: none !important;\n  }\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-bottom,\n.fixed-top {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-top {\n  top: 0;\n}\n\n.fixed-bottom {\n  bottom: 0;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: transparent;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 4px !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 4px !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 4px !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 4px !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 8px !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 8px !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 8px !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 8px !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 16px !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 16px !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 16px !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 16px !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 24px !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 24px !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 24px !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 24px !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 48px !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 48px !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 48px !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 48px !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 4px !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 4px !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 4px !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 4px !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 8px !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 8px !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 8px !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 8px !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 16px !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 16px !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 16px !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 16px !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 24px !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 24px !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 24px !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 24px !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 48px !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 48px !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 48px !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 48px !important;\n}\n\n.m-n1 {\n  margin: -4px !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -4px !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -4px !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -4px !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -4px !important;\n}\n\n.m-n2 {\n  margin: -8px !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -8px !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -8px !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -8px !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -8px !important;\n}\n\n.m-n3 {\n  margin: -16px !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -16px !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -16px !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -16px !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -16px !important;\n}\n\n.m-n4 {\n  margin: -24px !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -24px !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -24px !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -24px !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -24px !important;\n}\n\n.m-n5 {\n  margin: -48px !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -48px !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -48px !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -48px !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -48px !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 360px) {\n  .m-xs-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xs-0,\n  .my-xs-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xs-0,\n  .mx-xs-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xs-0,\n  .my-xs-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xs-0,\n  .mx-xs-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xs-1 {\n    margin: 4px !important;\n  }\n\n  .mt-xs-1,\n  .my-xs-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-xs-1,\n  .mx-xs-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-xs-1,\n  .my-xs-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-xs-1,\n  .mx-xs-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-xs-2 {\n    margin: 8px !important;\n  }\n\n  .mt-xs-2,\n  .my-xs-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-xs-2,\n  .mx-xs-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-xs-2,\n  .my-xs-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-xs-2,\n  .mx-xs-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-xs-3 {\n    margin: 16px !important;\n  }\n\n  .mt-xs-3,\n  .my-xs-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-xs-3,\n  .mx-xs-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-xs-3,\n  .my-xs-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-xs-3,\n  .mx-xs-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-xs-4 {\n    margin: 24px !important;\n  }\n\n  .mt-xs-4,\n  .my-xs-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-xs-4,\n  .mx-xs-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-xs-4,\n  .my-xs-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-xs-4,\n  .mx-xs-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-xs-5 {\n    margin: 48px !important;\n  }\n\n  .mt-xs-5,\n  .my-xs-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-xs-5,\n  .mx-xs-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-xs-5,\n  .my-xs-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-xs-5,\n  .mx-xs-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-xs-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xs-0,\n  .py-xs-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xs-0,\n  .px-xs-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xs-0,\n  .py-xs-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xs-0,\n  .px-xs-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xs-1 {\n    padding: 4px !important;\n  }\n\n  .pt-xs-1,\n  .py-xs-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-xs-1,\n  .px-xs-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-xs-1,\n  .py-xs-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-xs-1,\n  .px-xs-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-xs-2 {\n    padding: 8px !important;\n  }\n\n  .pt-xs-2,\n  .py-xs-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-xs-2,\n  .px-xs-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-xs-2,\n  .py-xs-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-xs-2,\n  .px-xs-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-xs-3 {\n    padding: 16px !important;\n  }\n\n  .pt-xs-3,\n  .py-xs-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-xs-3,\n  .px-xs-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-xs-3,\n  .py-xs-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-xs-3,\n  .px-xs-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-xs-4 {\n    padding: 24px !important;\n  }\n\n  .pt-xs-4,\n  .py-xs-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-xs-4,\n  .px-xs-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-xs-4,\n  .py-xs-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-xs-4,\n  .px-xs-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-xs-5 {\n    padding: 48px !important;\n  }\n\n  .pt-xs-5,\n  .py-xs-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-xs-5,\n  .px-xs-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-xs-5,\n  .py-xs-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-xs-5,\n  .px-xs-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-xs-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-xs-n1,\n  .my-xs-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-xs-n1,\n  .mx-xs-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-xs-n1,\n  .my-xs-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-xs-n1,\n  .mx-xs-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-xs-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-xs-n2,\n  .my-xs-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-xs-n2,\n  .mx-xs-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-xs-n2,\n  .my-xs-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-xs-n2,\n  .mx-xs-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-xs-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-xs-n3,\n  .my-xs-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-xs-n3,\n  .mx-xs-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-xs-n3,\n  .my-xs-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-xs-n3,\n  .mx-xs-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-xs-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-xs-n4,\n  .my-xs-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-xs-n4,\n  .mx-xs-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-xs-n4,\n  .my-xs-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-xs-n4,\n  .mx-xs-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-xs-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-xs-n5,\n  .my-xs-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-xs-n5,\n  .mx-xs-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-xs-n5,\n  .my-xs-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-xs-n5,\n  .mx-xs-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-xs-auto {\n    margin: auto !important;\n  }\n\n  .mt-xs-auto,\n  .my-xs-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xs-auto,\n  .mx-xs-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xs-auto,\n  .my-xs-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xs-auto,\n  .mx-xs-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 4px !important;\n  }\n\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-sm-2 {\n    margin: 8px !important;\n  }\n\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-sm-3 {\n    margin: 16px !important;\n  }\n\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-sm-4 {\n    margin: 24px !important;\n  }\n\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-sm-5 {\n    margin: 48px !important;\n  }\n\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 4px !important;\n  }\n\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-sm-2 {\n    padding: 8px !important;\n  }\n\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-sm-3 {\n    padding: 16px !important;\n  }\n\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-sm-4 {\n    padding: 24px !important;\n  }\n\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-sm-5 {\n    padding: 48px !important;\n  }\n\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-sm-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-sm-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-sm-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-sm-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-sm-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 4px !important;\n  }\n\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-md-2 {\n    margin: 8px !important;\n  }\n\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-md-3 {\n    margin: 16px !important;\n  }\n\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-md-4 {\n    margin: 24px !important;\n  }\n\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-md-5 {\n    margin: 48px !important;\n  }\n\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 4px !important;\n  }\n\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-md-2 {\n    padding: 8px !important;\n  }\n\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-md-3 {\n    padding: 16px !important;\n  }\n\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-md-4 {\n    padding: 24px !important;\n  }\n\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-md-5 {\n    padding: 48px !important;\n  }\n\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-md-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-md-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-md-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-md-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-md-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 4px !important;\n  }\n\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-lg-2 {\n    margin: 8px !important;\n  }\n\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-lg-3 {\n    margin: 16px !important;\n  }\n\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-lg-4 {\n    margin: 24px !important;\n  }\n\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-lg-5 {\n    margin: 48px !important;\n  }\n\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 4px !important;\n  }\n\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-lg-2 {\n    padding: 8px !important;\n  }\n\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-lg-3 {\n    padding: 16px !important;\n  }\n\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-lg-4 {\n    padding: 24px !important;\n  }\n\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-lg-5 {\n    padding: 48px !important;\n  }\n\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-lg-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-lg-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-lg-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-lg-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-lg-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 4px !important;\n  }\n\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-xl-2 {\n    margin: 8px !important;\n  }\n\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-xl-3 {\n    margin: 16px !important;\n  }\n\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-xl-4 {\n    margin: 24px !important;\n  }\n\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-xl-5 {\n    margin: 48px !important;\n  }\n\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 4px !important;\n  }\n\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-xl-2 {\n    padding: 8px !important;\n  }\n\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-xl-3 {\n    padding: 16px !important;\n  }\n\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-xl-4 {\n    padding: 24px !important;\n  }\n\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-xl-5 {\n    padding: 48px !important;\n  }\n\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-xl-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-xl-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-xl-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-xl-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-xl-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1660px) {\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xxl-0,\n  .my-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xxl-0,\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xxl-0,\n  .my-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xxl-0,\n  .mx-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 4px !important;\n  }\n\n  .mt-xxl-1,\n  .my-xxl-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-xxl-1,\n  .mx-xxl-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-xxl-1,\n  .my-xxl-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-xxl-1,\n  .mx-xxl-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-xxl-2 {\n    margin: 8px !important;\n  }\n\n  .mt-xxl-2,\n  .my-xxl-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-xxl-2,\n  .mx-xxl-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-xxl-2,\n  .my-xxl-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-xxl-2,\n  .mx-xxl-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-xxl-3 {\n    margin: 16px !important;\n  }\n\n  .mt-xxl-3,\n  .my-xxl-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-xxl-3,\n  .mx-xxl-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-xxl-3,\n  .my-xxl-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-xxl-3,\n  .mx-xxl-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-xxl-4 {\n    margin: 24px !important;\n  }\n\n  .mt-xxl-4,\n  .my-xxl-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-xxl-4,\n  .mx-xxl-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-xxl-4,\n  .my-xxl-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-xxl-4,\n  .mx-xxl-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-xxl-5 {\n    margin: 48px !important;\n  }\n\n  .mt-xxl-5,\n  .my-xxl-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-xxl-5,\n  .mx-xxl-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-xxl-5,\n  .my-xxl-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-xxl-5,\n  .mx-xxl-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xxl-0,\n  .py-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xxl-0,\n  .px-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xxl-0,\n  .py-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xxl-0,\n  .px-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 4px !important;\n  }\n\n  .pt-xxl-1,\n  .py-xxl-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-xxl-1,\n  .px-xxl-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-xxl-1,\n  .py-xxl-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-xxl-1,\n  .px-xxl-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-xxl-2 {\n    padding: 8px !important;\n  }\n\n  .pt-xxl-2,\n  .py-xxl-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-xxl-2,\n  .px-xxl-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-xxl-2,\n  .py-xxl-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-xxl-2,\n  .px-xxl-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-xxl-3 {\n    padding: 16px !important;\n  }\n\n  .pt-xxl-3,\n  .py-xxl-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-xxl-3,\n  .px-xxl-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-xxl-3,\n  .py-xxl-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-xxl-3,\n  .px-xxl-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-xxl-4 {\n    padding: 24px !important;\n  }\n\n  .pt-xxl-4,\n  .py-xxl-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-xxl-4,\n  .px-xxl-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-xxl-4,\n  .py-xxl-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-xxl-4,\n  .px-xxl-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-xxl-5 {\n    padding: 48px !important;\n  }\n\n  .pt-xxl-5,\n  .py-xxl-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-xxl-5,\n  .px-xxl-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-xxl-5,\n  .py-xxl-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-xxl-5,\n  .px-xxl-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-xxl-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-xxl-n1,\n  .my-xxl-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-xxl-n1,\n  .mx-xxl-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-xxl-n1,\n  .my-xxl-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-xxl-n1,\n  .mx-xxl-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-xxl-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-xxl-n2,\n  .my-xxl-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-xxl-n2,\n  .mx-xxl-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-xxl-n2,\n  .my-xxl-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-xxl-n2,\n  .mx-xxl-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-xxl-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-xxl-n3,\n  .my-xxl-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-xxl-n3,\n  .mx-xxl-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-xxl-n3,\n  .my-xxl-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-xxl-n3,\n  .mx-xxl-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-xxl-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-xxl-n4,\n  .my-xxl-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-xxl-n4,\n  .mx-xxl-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-xxl-n4,\n  .my-xxl-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-xxl-n4,\n  .mx-xxl-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-xxl-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-xxl-n5,\n  .my-xxl-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-xxl-n5,\n  .mx-xxl-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-xxl-n5,\n  .my-xxl-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-xxl-n5,\n  .mx-xxl-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xxl-auto,\n  .my-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xxl-auto,\n  .mx-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-auto,\n  .my-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xxl-auto,\n  .mx-xxl-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .m-xxxl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xxxl-0,\n  .my-xxxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xxxl-0,\n  .mx-xxxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xxxl-0,\n  .my-xxxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xxxl-0,\n  .mx-xxxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xxxl-1 {\n    margin: 4px !important;\n  }\n\n  .mt-xxxl-1,\n  .my-xxxl-1 {\n    margin-top: 4px !important;\n  }\n\n  .mr-xxxl-1,\n  .mx-xxxl-1 {\n    margin-right: 4px !important;\n  }\n\n  .mb-xxxl-1,\n  .my-xxxl-1 {\n    margin-bottom: 4px !important;\n  }\n\n  .ml-xxxl-1,\n  .mx-xxxl-1 {\n    margin-left: 4px !important;\n  }\n\n  .m-xxxl-2 {\n    margin: 8px !important;\n  }\n\n  .mt-xxxl-2,\n  .my-xxxl-2 {\n    margin-top: 8px !important;\n  }\n\n  .mr-xxxl-2,\n  .mx-xxxl-2 {\n    margin-right: 8px !important;\n  }\n\n  .mb-xxxl-2,\n  .my-xxxl-2 {\n    margin-bottom: 8px !important;\n  }\n\n  .ml-xxxl-2,\n  .mx-xxxl-2 {\n    margin-left: 8px !important;\n  }\n\n  .m-xxxl-3 {\n    margin: 16px !important;\n  }\n\n  .mt-xxxl-3,\n  .my-xxxl-3 {\n    margin-top: 16px !important;\n  }\n\n  .mr-xxxl-3,\n  .mx-xxxl-3 {\n    margin-right: 16px !important;\n  }\n\n  .mb-xxxl-3,\n  .my-xxxl-3 {\n    margin-bottom: 16px !important;\n  }\n\n  .ml-xxxl-3,\n  .mx-xxxl-3 {\n    margin-left: 16px !important;\n  }\n\n  .m-xxxl-4 {\n    margin: 24px !important;\n  }\n\n  .mt-xxxl-4,\n  .my-xxxl-4 {\n    margin-top: 24px !important;\n  }\n\n  .mr-xxxl-4,\n  .mx-xxxl-4 {\n    margin-right: 24px !important;\n  }\n\n  .mb-xxxl-4,\n  .my-xxxl-4 {\n    margin-bottom: 24px !important;\n  }\n\n  .ml-xxxl-4,\n  .mx-xxxl-4 {\n    margin-left: 24px !important;\n  }\n\n  .m-xxxl-5 {\n    margin: 48px !important;\n  }\n\n  .mt-xxxl-5,\n  .my-xxxl-5 {\n    margin-top: 48px !important;\n  }\n\n  .mr-xxxl-5,\n  .mx-xxxl-5 {\n    margin-right: 48px !important;\n  }\n\n  .mb-xxxl-5,\n  .my-xxxl-5 {\n    margin-bottom: 48px !important;\n  }\n\n  .ml-xxxl-5,\n  .mx-xxxl-5 {\n    margin-left: 48px !important;\n  }\n\n  .p-xxxl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xxxl-0,\n  .py-xxxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xxxl-0,\n  .px-xxxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xxxl-0,\n  .py-xxxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xxxl-0,\n  .px-xxxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xxxl-1 {\n    padding: 4px !important;\n  }\n\n  .pt-xxxl-1,\n  .py-xxxl-1 {\n    padding-top: 4px !important;\n  }\n\n  .pr-xxxl-1,\n  .px-xxxl-1 {\n    padding-right: 4px !important;\n  }\n\n  .pb-xxxl-1,\n  .py-xxxl-1 {\n    padding-bottom: 4px !important;\n  }\n\n  .pl-xxxl-1,\n  .px-xxxl-1 {\n    padding-left: 4px !important;\n  }\n\n  .p-xxxl-2 {\n    padding: 8px !important;\n  }\n\n  .pt-xxxl-2,\n  .py-xxxl-2 {\n    padding-top: 8px !important;\n  }\n\n  .pr-xxxl-2,\n  .px-xxxl-2 {\n    padding-right: 8px !important;\n  }\n\n  .pb-xxxl-2,\n  .py-xxxl-2 {\n    padding-bottom: 8px !important;\n  }\n\n  .pl-xxxl-2,\n  .px-xxxl-2 {\n    padding-left: 8px !important;\n  }\n\n  .p-xxxl-3 {\n    padding: 16px !important;\n  }\n\n  .pt-xxxl-3,\n  .py-xxxl-3 {\n    padding-top: 16px !important;\n  }\n\n  .pr-xxxl-3,\n  .px-xxxl-3 {\n    padding-right: 16px !important;\n  }\n\n  .pb-xxxl-3,\n  .py-xxxl-3 {\n    padding-bottom: 16px !important;\n  }\n\n  .pl-xxxl-3,\n  .px-xxxl-3 {\n    padding-left: 16px !important;\n  }\n\n  .p-xxxl-4 {\n    padding: 24px !important;\n  }\n\n  .pt-xxxl-4,\n  .py-xxxl-4 {\n    padding-top: 24px !important;\n  }\n\n  .pr-xxxl-4,\n  .px-xxxl-4 {\n    padding-right: 24px !important;\n  }\n\n  .pb-xxxl-4,\n  .py-xxxl-4 {\n    padding-bottom: 24px !important;\n  }\n\n  .pl-xxxl-4,\n  .px-xxxl-4 {\n    padding-left: 24px !important;\n  }\n\n  .p-xxxl-5 {\n    padding: 48px !important;\n  }\n\n  .pt-xxxl-5,\n  .py-xxxl-5 {\n    padding-top: 48px !important;\n  }\n\n  .pr-xxxl-5,\n  .px-xxxl-5 {\n    padding-right: 48px !important;\n  }\n\n  .pb-xxxl-5,\n  .py-xxxl-5 {\n    padding-bottom: 48px !important;\n  }\n\n  .pl-xxxl-5,\n  .px-xxxl-5 {\n    padding-left: 48px !important;\n  }\n\n  .m-xxxl-n1 {\n    margin: -4px !important;\n  }\n\n  .mt-xxxl-n1,\n  .my-xxxl-n1 {\n    margin-top: -4px !important;\n  }\n\n  .mr-xxxl-n1,\n  .mx-xxxl-n1 {\n    margin-right: -4px !important;\n  }\n\n  .mb-xxxl-n1,\n  .my-xxxl-n1 {\n    margin-bottom: -4px !important;\n  }\n\n  .ml-xxxl-n1,\n  .mx-xxxl-n1 {\n    margin-left: -4px !important;\n  }\n\n  .m-xxxl-n2 {\n    margin: -8px !important;\n  }\n\n  .mt-xxxl-n2,\n  .my-xxxl-n2 {\n    margin-top: -8px !important;\n  }\n\n  .mr-xxxl-n2,\n  .mx-xxxl-n2 {\n    margin-right: -8px !important;\n  }\n\n  .mb-xxxl-n2,\n  .my-xxxl-n2 {\n    margin-bottom: -8px !important;\n  }\n\n  .ml-xxxl-n2,\n  .mx-xxxl-n2 {\n    margin-left: -8px !important;\n  }\n\n  .m-xxxl-n3 {\n    margin: -16px !important;\n  }\n\n  .mt-xxxl-n3,\n  .my-xxxl-n3 {\n    margin-top: -16px !important;\n  }\n\n  .mr-xxxl-n3,\n  .mx-xxxl-n3 {\n    margin-right: -16px !important;\n  }\n\n  .mb-xxxl-n3,\n  .my-xxxl-n3 {\n    margin-bottom: -16px !important;\n  }\n\n  .ml-xxxl-n3,\n  .mx-xxxl-n3 {\n    margin-left: -16px !important;\n  }\n\n  .m-xxxl-n4 {\n    margin: -24px !important;\n  }\n\n  .mt-xxxl-n4,\n  .my-xxxl-n4 {\n    margin-top: -24px !important;\n  }\n\n  .mr-xxxl-n4,\n  .mx-xxxl-n4 {\n    margin-right: -24px !important;\n  }\n\n  .mb-xxxl-n4,\n  .my-xxxl-n4 {\n    margin-bottom: -24px !important;\n  }\n\n  .ml-xxxl-n4,\n  .mx-xxxl-n4 {\n    margin-left: -24px !important;\n  }\n\n  .m-xxxl-n5 {\n    margin: -48px !important;\n  }\n\n  .mt-xxxl-n5,\n  .my-xxxl-n5 {\n    margin-top: -48px !important;\n  }\n\n  .mr-xxxl-n5,\n  .mx-xxxl-n5 {\n    margin-right: -48px !important;\n  }\n\n  .mb-xxxl-n5,\n  .my-xxxl-n5 {\n    margin-bottom: -48px !important;\n  }\n\n  .ml-xxxl-n5,\n  .mx-xxxl-n5 {\n    margin-left: -48px !important;\n  }\n\n  .m-xxxl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xxxl-auto,\n  .my-xxxl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xxxl-auto,\n  .mx-xxxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxxl-auto,\n  .my-xxxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xxxl-auto,\n  .mx-xxxl-auto {\n    margin-left: auto !important;\n  }\n}\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n    \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (min-width: 360px) {\n  .text-xs-left {\n    text-align: left !important;\n  }\n\n  .text-xs-right {\n    text-align: right !important;\n  }\n\n  .text-xs-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n\n  .text-sm-right {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n\n  .text-md-right {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n\n  .text-lg-right {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n\n  .text-xl-right {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1660px) {\n  .text-xxl-left {\n    text-align: left !important;\n  }\n\n  .text-xxl-right {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .text-xxxl-left {\n    text-align: left !important;\n  }\n\n  .text-xxxl-right {\n    text-align: right !important;\n  }\n\n  .text-xxxl-center {\n    text-align: center !important;\n  }\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\na.text-primary:focus,\na.text-primary:hover {\n  color: #006060 !important;\n}\n\na.text-secondary:focus,\na.text-secondary:hover {\n  color: #494f54 !important;\n}\n\na.text-success:focus,\na.text-success:hover {\n  color: #006060 !important;\n}\n\na.text-info:focus,\na.text-info:hover {\n  color: #278eac !important;\n}\n\na.text-warning:focus,\na.text-warning:hover {\n  color: #ba7208 !important;\n}\n\na.text-danger:focus,\na.text-danger:hover {\n  color: #ff100b !important;\n}\n\na.text-light:focus,\na.text-light:hover {\n  color: #c9cdd1 !important;\n}\n\na.text-dark:focus,\na.text-dark:hover,\na.text-inverse:focus,\na.text-inverse:hover {\n  color: #0c0e10 !important;\n}\n\na.text-black:focus,\na.text-black:hover {\n  color: #000 !important;\n}\n\na.text-white:focus,\na.text-white:hover {\n  color: #d9d9d9 !important;\n}\n\na.text-grey:focus,\na.text-grey:hover,\na.text-muted:focus,\na.text-muted:hover,\na.text-silver:focus,\na.text-silver:hover {\n  color: #8a9da8 !important;\n}\n\na.text-lime:focus,\na.text-lime:hover {\n  color: #699b2e !important;\n}\n\na.text-aqua:focus,\na.text-aqua:hover {\n  color: #278eac !important;\n}\n\n.text-body {\n  color: #333 !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n  ::after,\n  ::before {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  pre {\n    white-space: pre-wrap !important;\n  }\n\n  blockquote,\n  pre {\n    border: 1px solid #adb5bd;\n  }\n\n  thead {\n    display: table-header-group;\n  }\n\n  blockquote,\n  img,\n  pre,\n  tr {\n    page-break-inside: avoid;\n  }\n\n  h2,\n  h3,\n  p {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n\n  @page {\n    size: a3;\n  }\n\n  .container,\n  body {\n    min-width: 992px !important;\n  }\n\n  .navbar {\n    display: none;\n  }\n\n  .badge {\n    border: 1px solid #000;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n  }\n\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n\n  .table-bordered td,\n  .table-bordered th {\n    border: 1px solid #dee2e6 !important;\n  }\n\n  .table-dark {\n    color: inherit;\n  }\n\n  .table-dark tbody + tbody,\n  .table-dark td,\n  .table-dark th,\n  .table-dark thead th {\n    border-color: #e4e7ea;\n  }\n\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #e4e7ea;\n  }\n}\n\nbody {\n  height: 100%;\n  letter-spacing: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1 small,\nh2 small,\nh3 small,\nh4 small,\nh5 small,\nh6 small {\n  font-size: 60%;\n  font-weight: 400;\n  color: #6f8293;\n}\n\na:focus {\n  outline: 0;\n}\n\n.footer {\n  z-index: 1020;\n  padding: 10px 0;\n  margin: 0 30px 0 250px;\n  border-top: 1px solid #c6ced5;\n  line-height: 20px;\n  font-weight: 600;\n  color: #4e5c68;\n}\n\n@media (max-width: 767.98px) {\n  .footer {\n    margin-left: 20px;\n  }\n}\n\n.header {\n  position: relative;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1020;\n  margin-bottom: 0;\n  padding: 0;\n  -webkit-transition: box-shadow 0.2s linear;\n  -moz-transition: box-shadow 0.2s linear;\n  -ms-transition: box-shadow 0.2s linear;\n  -o-transition: box-shadow 0.2s linear;\n  transition: box-shadow 0.2s linear;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.chats > div + div:after,\n.chats > div + div:before,\n.chats > li + li:after,\n.chats > li + li:before,\n.sidebar .nav > li:after,\n.sidebar .nav > li:before,\n.sidebar .nav > li > a:after,\n.sidebar .nav > li > a:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n@media (max-width: 767.98px) {\n  .header {\n    display: block;\n  }\n}\n\n.header .navbar-toggle {\n  position: relative;\n  padding: 10px;\n  margin-right: 10px;\n  margin-left: auto;\n  background-color: transparent;\n  background-image: none;\n  border: 0;\n  outline: 0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n@media (min-width: 768px) {\n  .header .navbar-toggle {\n    display: none;\n  }\n}\n\n.header .navbar-toggle .icon-bar {\n  display: block;\n  width: 22px;\n  height: 2px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.header .navbar-toggle .icon-bar + .icon-bar {\n  margin-top: 4px;\n}\n\n.header .navbar-toggle:hover {\n  background: 0 0;\n  opacity: 0.75;\n}\n\n.header .navbar-toggle.pull-left {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n.header .navbar-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .header .navbar-header {\n    width: 220px;\n  }\n}\n\n.header .navbar-brand,\n.header .navbar-nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.header .navbar-brand {\n  height: 50px;\n  font-weight: 100;\n  font-size: 18px;\n  line-height: 30px;\n  text-decoration: none;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 10px 20px;\n}\n\n.header .navbar-brand img,\n.sidebar .nav > li.nav-profile .image img,\n.timeline .timeline-comment-box .user img,\n.widget-list .widget-list-item .widget-list-media img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.header .navbar-brand .navbar-logo {\n  margin-right: 10px;\n  background: #00acac;\n  border: 10px solid transparent;\n  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);\n  position: relative;\n  overflow: hidden;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.header .navbar-nav {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n@media (max-width: 767.98px) {\n  .header .navbar-nav {\n    -webkit-box-pack: flex-end;\n    -ms-flex-pack: flex-end;\n    justify-content: flex-end;\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    border-top: 1px solid #edf0f2;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n\n.header .navbar-nav > li > a {\n  display: block;\n  text-decoration: none;\n  line-height: 20px;\n  padding: 15px;\n  border: 0;\n}\n\n.header .navbar-nav > li > a .label {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  display: block;\n  background: #00acac;\n  line-height: 12px;\n  font-weight: 600;\n  color: #fff;\n  padding: 3px 6px;\n  -webkit-border-radius: 30px;\n  border-radius: 30px;\n}\n\n.header .navbar-nav > li > a i {\n  top: 1px;\n  position: relative;\n  font-size: 16px;\n}\n\n.header .navbar-nav > li > a:focus,\n.header .navbar-nav > li > a:hover {\n  opacity: 0.75;\n}\n\n.header .navbar-nav > li > a.icon i {\n  font-size: 24px;\n  height: 24px;\n  margin: -2px 0;\n  display: block;\n}\n\n.header .navbar-nav > li.active > a {\n  background: #f2f3f4;\n  opacity: 1;\n}\n\n.header .navbar-nav > li.dropdown .dropdown-menu {\n  margin: 0;\n}\n\n.header .navbar-nav > li.dropdown.dropdown-lg {\n  position: static;\n}\n\n.header .navbar-nav > li.dropdown.dropdown-lg .dropdown-menu {\n  left: 20px !important;\n  right: 20px !important;\n  padding: 20px;\n  -webkit-transform: none !important;\n  -moz-transform: none !important;\n  -ms-transform: none !important;\n  -o-transform: none !important;\n  transform: none !important;\n}\n\n@media (min-width: 768px) {\n  .header .navbar-nav > li.dropdown.dropdown-lg .dropdown-menu {\n    top: 100% !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header .navbar-nav > li.dropdown.dropdown-lg .dropdown-menu {\n    overflow: scroll;\n    top: 101px !important;\n    max-height: calc(100vh - 101px);\n  }\n}\n\n.header\n  .navbar-nav\n  > li.dropdown.dropdown-lg\n  .dropdown-menu.dropdown-menu-lg\n  .nav\n  > li\n  > a {\n  padding: 0;\n  background: 0 0;\n  line-height: 24px;\n}\n\n.header .navbar-nav > li.show > a,\n.header .navbar-nav > li.show > a:focus,\n.header .navbar-nav > li.show > a:hover {\n  background: 0 0;\n  color: #2d353c;\n  opacity: 1;\n}\n\n.header .navbar-nav > li.divider {\n  height: 34px;\n  margin-top: 10px;\n  background: #f2f3f4;\n  width: 1px;\n}\n\n.header .navbar-nav.navbar-right {\n  margin-left: auto;\n}\n\n.header .navbar-form {\n  padding: 0 15px;\n  margin: 9px 0;\n}\n\n@media (max-width: 767.98px) {\n  .header .navbar-form {\n    padding-left: 5px;\n    padding-right: 5px;\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n  }\n}\n\n.header .navbar-form .form-group {\n  margin: 0;\n  position: relative;\n}\n\n.header .navbar-form .form-control {\n  width: 220px;\n  padding: 5px 15px;\n  height: 32px;\n  background: #f2f3f4;\n  border-color: #f2f3f4;\n  -webkit-border-radius: 30px;\n  border-radius: 30px;\n}\n\n@media (max-width: 767.98px) {\n  .header .navbar-form .form-control {\n    width: 100%;\n  }\n}\n\n.header .navbar-form .form-control:focus {\n  width: 300px;\n  border-color: #f2f3f4;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-animation: navbar-input-expand 0.2s;\n  -moz-animation: navbar-input-expand 0.2s;\n  -ms-animation: navbar-input-expand 0.2s;\n  -o-animation: navbar-input-expand 0.2s;\n  animation: navbar-input-expand 0.2s;\n}\n\n@media (max-width: 767.98px) {\n  .header .navbar-form .form-control:focus {\n    width: 100%;\n    -webkit-animation: none;\n    -moz-animation: none;\n    -ms-animation: none;\n    -o-animation: none;\n    animation: none;\n  }\n}\n\n.header .navbar-form .btn-search {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border: 0;\n  background: 0 0;\n  -webkit-border-radius: 0 30px 30px 0;\n  border-radius: 0 30px 30px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.header .navbar-form .btn-search > i[class*=\"ion-\"] {\n  font-size: 22px;\n  display: block;\n}\n\n.header .navbar-user .image,\n.header .navbar-user img {\n  float: left;\n  width: 30px;\n  height: 30px;\n  margin: -5px 0px -5px 0;\n  -webkit-border-radius: 30px;\n  border-radius: 30px;\n}\n\n.header .navbar-user .image {\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.header .navbar-user .image.image-icon {\n  font-size: 22px;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.header .navbar-user .image.image-icon i {\n  float: none;\n  display: block;\n  font-size: 22px;\n  text-align: center;\n  width: auto;\n  margin: 0 auto -8px;\n}\n\n.header .navbar-language .flag-icon {\n  font-size: 15px;\n  margin-right: 7px;\n}\n\n@media (min-width: 768px) {\n  .header .navbar-collapse {\n    display: block;\n    -webkit-flex-basis: initial;\n    flex-basis: initial;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .header .navbar-collapse {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .header .navbar-collapse .navbar-nav > li {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n  }\n\n  .header .navbar-collapse .navbar-nav > li > a {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n}\n\n.header.navbar-default {\n  background: #fff;\n}\n\n.header.navbar-default .navbar-brand,\n.header.navbar-default .navbar-nav > li > a {\n  color: #2d353c;\n}\n\n.header.navbar-default .navbar-toggle .icon-bar {\n  background: #2d353c;\n}\n\n.header.navbar-inverse {\n  background: #1a2229;\n}\n\n.header.navbar-inverse .navbar-toggle .icon-bar,\nbody .introjs-bullets ul li a.active {\n  background: #6f8293;\n}\n\n.header.navbar-inverse .navbar-brand {\n  color: #fff;\n}\n\n@media (max-width: 767.98px) {\n  .header.navbar-inverse .navbar-nav {\n    border-color: #2d353c;\n  }\n}\n\n.header.navbar-inverse .navbar-nav > li > a {\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.header.navbar-inverse .navbar-nav > li.active > a {\n  background: #2d353c;\n  opacity: 1;\n}\n\n.header.navbar-inverse .navbar-nav > li.divider {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.header.navbar-inverse .navbar-form {\n  margin: 10px 0;\n}\n\n.header.navbar-inverse .navbar-form .form-control {\n  background: rgba(255, 255, 255, 0.25);\n  border-color: transparent;\n  height: 30px;\n  color: #fff;\n}\n\n.header.navbar-inverse .navbar-form .form-control::-webkit-input-placeholder,\n.login.login-v1\n  .login-container\n  .login-body\n  .login-content\n  .form-control::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.header.navbar-inverse .navbar-form .form-control::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.header.navbar-inverse .navbar-form .form-control:-ms-input-placeholder,\n.login.login-v1\n  .login-container\n  .login-body\n  .login-content\n  .form-control:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.header.navbar-inverse .navbar-form .form-control:-moz-placeholder,\n.login.login-v1\n  .login-container\n  .login-body\n  .login-content\n  .form-control:-moz-placeholder,\n.login.login-v1\n  .login-container\n  .login-body\n  .login-content\n  .form-control::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.header.navbar-inverse .navbar-form .btn-search {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.has-scroll .header {\n  -webkit-box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);\n}\n\n.sidebar {\n  width: 220px;\n  /* position: absolute; */\n  left: 0;\n  top: 0;\n  bottom: 0;\n  padding-top: 50px;\n  background: #2d353c;\n  z-index: 1010;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -o-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n@media (max-width: 767.98px) {\n  .sidebar {\n    padding-top: 0;\n    left: -220px;\n    z-index: 1021;\n  }\n}\n\n#page-loader.fade.in,\n#page-loader.fade.show,\n.sidebar .nav,\n.sidebar .nav .has-sub.active > .sub-menu,\n.sidebar .nav.nav-profile.active {\n  display: block;\n}\n\n.sidebar .nav > li > a {\n  padding: 7px 20px;\n  line-height: 20px;\n  color: rgba(255, 255, 255, 0.6);\n  display: block;\n  text-decoration: none;\n}\n\n.sidebar .nav > li > a i {\n  float: left;\n  margin-right: 10px;\n  width: 14px;\n  text-align: center;\n  line-height: 20px;\n  font-size: 14px;\n}\n\n.sidebar .nav > li > a i[class^=\"ion-\"] {\n  margin-right: 8px;\n  width: 18px;\n  font-size: 18px;\n  margin-left: -2px;\n}\n\n.sidebar .nav > li > a .icon-img {\n  float: left;\n  margin-right: 10px;\n  margin-top: 3px;\n  width: 14px;\n  height: 14px;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.sidebar .nav > li > a .icon-img img,\n.top-menu .nav > li > a .icon-img img {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n}\n\n.sidebar .nav > li > a .badge {\n  padding: 5px 8px;\n  background: #1a2229;\n  font-weight: 600;\n  font-size: 10px;\n}\n\n.sidebar .nav > li > a .label {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-left: 8px;\n}\n\n.gradient-enabled .sidebar .nav > li.active > a,\n.gradient-enabled .sidebar .nav > li > a .label.label-theme {\n  background: -webkit-linear-gradient(to bottom, #00c6c6 0%, #009393 100%);\n  background: -moz-linear-gradient(to bottom, #00c6c6 0%, #009393 100%);\n  background: -o-linear-gradient(to bottom, #00c6c6 0%, #009393 100%);\n  background: linear-gradient(to bottom, #00c6c6 0%, #009393 100%);\n}\n\n.sidebar .nav > li > a > span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.sidebar .nav > li.nav-header a:focus,\n.sidebar .nav > li.nav-header a:hover,\n.sidebar .nav > li > a:focus,\n.sidebar .nav > li > a:hover {\n  background: 0 0;\n  color: #fff;\n}\n\n.sidebar .nav > li.active > a {\n  position: relative;\n  z-index: 10;\n  color: #fff;\n  background: #242b30;\n}\n\n.sidebar .nav > li.active > a i {\n  color: #00acac;\n}\n\n.gradient-enabled .sidebar .nav > li.active > a i {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.gradient-enabled .sidebar .nav > li.active > a .caret {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.sidebar .nav > li.active > a .badge,\n.sidebar .nav > li.active > a .label {\n  background: rgba(0, 0, 0, 0.65);\n}\n\n.sidebar .nav > li.nav-header {\n  margin: 0;\n  padding: 15px 20px 3px;\n  line-height: 20px;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.45);\n  font-weight: 600;\n}\n\n.sidebar .nav > li.nav-header a {\n  padding: 0;\n  margin: 0;\n  display: inline;\n}\n\n.sidebar .nav > li.nav-header a i {\n  float: none;\n  margin: 0;\n}\n\n.sidebar .nav > li.nav-profile {\n  padding: 20px;\n  color: #fff;\n  background: #1a2229;\n  overflow: hidden;\n}\n\n.sidebar .nav > li.nav-profile a {\n  padding: 0;\n}\n\n.sidebar .nav > li.nav-profile > a {\n  margin: -20px;\n  padding: 20px;\n  display: block;\n  color: #fff;\n  font-weight: 600;\n}\n\n.sidebar .nav > li.nav-profile > a:hover .cover.with-shadow:before {\n  opacity: 0.75;\n}\n\n.sidebar .nav > li.nav-profile .image {\n  width: 34px;\n  height: 34px;\n  margin-bottom: 10px;\n  overflow: hidden;\n  position: relative;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-border-radius: 30px;\n  border-radius: 30px;\n}\n\n.sidebar .nav > li.nav-profile .image.image-icon i {\n  float: none;\n  display: block;\n  font-size: 24px;\n  text-align: center;\n  width: auto;\n  margin: 0 auto -12px;\n}\n\n.sidebar .nav > li.nav-profile .info {\n  font-size: 14px;\n  position: relative;\n}\n\n.sidebar .nav > li.nav-profile .info .caret {\n  margin-top: 2px;\n}\n\n.sidebar .nav > li.nav-profile .info small {\n  display: block;\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 12px;\n  margin-bottom: -5px;\n}\n\n.sidebar .nav > li.nav-profile .cover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(images/cover-sidebar-user.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.sidebar .nav > li.nav-profile .cover.with-shadow:before,\n.sidebar li > a .caret:before {\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.sidebar .nav > li.nav-profile .cover.with-shadow:before {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(26, 34, 41, 0.75);\n  content: \"\";\n}\n\n.sidebar .nav > li.nav-widget {\n  padding: 10px 20px;\n}\n\n.sidebar .nav > li.nav-widget i {\n  margin-right: auto;\n}\n\n.sidebar .nav > li .text-theme {\n  margin-left: 5px;\n}\n\n.sidebar .nav .sub-menu > li > a {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.sidebar .nav .sub-menu > li > a .caret {\n  margin-top: -1px;\n  left: -5px;\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.sidebar .nav.nav-profile {\n  padding: 5px 0;\n  border-bottom: 1px solid #1a2229;\n  display: none;\n}\n\n.sidebar li > a .caret {\n  display: block;\n  float: right;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-size: 11px;\n  border: 0;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.sidebar li > a .caret:before {\n  content: \"\\f054\";\n  display: block;\n  text-align: center;\n  opacity: 0.5;\n}\n\n.float-sub-menu-container .float-sub-menu li.active > a .caret:before,\n.float-sub-menu-container .float-sub-menu li.expand > a .caret:before,\n.float-sub-menu-container .float-sub-menu li.expanding > a .caret:before,\n.sidebar li.active > a .caret:before,\n.sidebar li.expand > a .caret:before,\n.sidebar li.expanding > a .caret:before {\n  opacity: 1;\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.float-sub-menu-container .float-sub-menu li.closed > a .caret:before,\n.float-sub-menu-container .float-sub-menu li.closing > a .caret:before,\n.sidebar li.closed > a .caret:before,\n.sidebar li.closing > a .caret:before {\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n\n.sidebar .sub-menu > li > a {\n  padding: 3px 20px 3px 15px;\n  display: block;\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  position: relative;\n}\n\n.sidebar .sub-menu > li > a:focus,\n.sidebar .sub-menu > li > a:hover {\n  color: #fff;\n}\n\n.sidebar .sub-menu > li > a:after {\n  content: \"\";\n  position: absolute;\n  left: -11px;\n  top: 11px;\n  width: 11px;\n  height: 2px;\n  background: #242b30;\n}\n\n.sidebar .sub-menu > li:before {\n  content: \"\";\n  position: absolute;\n  left: -13px;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: #242b30;\n}\n\n.sidebar .sub-menu > li:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 6px;\n  height: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  top: 11px;\n  margin-top: -2px;\n  z-index: 10;\n  background: #2d353c;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.sidebar .sub-menu > li:first-child:before {\n  top: -14px;\n}\n\n.float-sub-menu-container .float-sub-menu li:first-child:last-child:before,\n.sidebar .sub-menu > li:first-child:last-child:before {\n  height: 27px;\n}\n\n.sidebar .sub-menu > li:last-child:before {\n  bottom: auto;\n  height: 13px;\n}\n\n.sidebar .sub-menu > li.has-sub > a:before {\n  background: #242b30;\n}\n\n.content.content-inverse-mode h1,\n.content.content-inverse-mode h2,\n.content.content-inverse-mode h3,\n.content.content-inverse-mode h4,\n.content.content-inverse-mode h5,\n.content.content-inverse-mode h6,\n.sidebar .sub-menu > li.active > a {\n  color: #fff;\n}\n\n.sidebar .sub-menu > li.active:after {\n  border-color: #00acac;\n}\n\n.sidebar .sub-menu .sub-menu {\n  padding: 0 0 0 15px;\n  background: 0 0;\n}\n\n.sidebar .sidebar-minify-btn {\n  margin: 10px 0;\n  float: right;\n  padding: 5px 20px 5px 10px !important;\n  background: #242b30;\n  color: #fff;\n  -webkit-border-radius: 20px 0 0 20px;\n  border-radius: 20px 0 0 20px;\n}\n\n.sidebar .sidebar-minify-btn i {\n  margin: 0 !important;\n  color: #fff;\n}\n\n.sidebar .sidebar-minify-btn:focus,\n.sidebar .sidebar-minify-btn:hover {\n  background: #1c2025 !important;\n}\n\n.content.content-inverse-mode .slimScrollDiv .slimScrollBar:before,\n.sidebar .slimScrollDiv .slimScrollBar:before {\n  background: rgba(255, 255, 255, 0.5) !important;\n}\n\n.sidebar.sidebar-grid .nav > li + li {\n  margin-top: -1px;\n}\n\n.sidebar.sidebar-grid .nav > li > a {\n  border-top: 1px solid #3d4852;\n  border-bottom: 1px solid #3d4852;\n}\n\n.sidebar.sidebar-grid .nav > li.expand > a,\n.sidebar.sidebar-grid .nav > li.expanding > a {\n  border-bottom-color: transparent;\n}\n\n.sidebar.sidebar-grid .nav > li.active > a {\n  border-color: #2d353c;\n}\n\n.sidebar.sidebar-transparent,\n.sidebar.sidebar-transparent .nav > li.nav-profile .cover,\n.sidebar.sidebar-transparent .nav > li.nav-profile .cover.with-shadow:before {\n  background: 0 0;\n}\n\n.sidebar.sidebar-transparent + .sidebar-bg {\n  background: url(images/cover-sidebar.jpg);\n  background-size: cover;\n}\n\n.sidebar.sidebar-transparent + .sidebar-bg:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(45, 53, 60, 0.75);\n}\n\n.sidebar.sidebar-transparent .nav > li.active > a {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.sidebar.sidebar-transparent .nav > li.nav-profile,\n.sidebar.sidebar-transparent .nav > li.nav-profile.active {\n  background: rgba(0, 0, 0, 0.25);\n}\n\n.sidebar.sidebar-transparent .nav > li.nav-profile a:focus,\n.sidebar.sidebar-transparent .nav > li.nav-profile a:hover {\n  background: 0 0;\n}\n\n.sidebar.sidebar-transparent .sub-menu {\n  background: 0 0;\n}\n\n.sidebar.sidebar-transparent .sub-menu > li.has-sub > a:after,\n.sidebar.sidebar-transparent .sub-menu > li:before,\n.sidebar.sidebar-transparent .sub-menu > li > a:after {\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.sidebar-bg {\n  background: #2d353c;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 220px;\n  z-index: 1000;\n}\n\n@media (max-width: 767.98px) {\n  .sidebar-bg {\n    padding-top: 0;\n    left: -220px;\n    z-index: 1020;\n  }\n}\n\n.top-menu {\n  background: #1a2229;\n  left: 0;\n  right: 0;\n  z-index: 1015;\n}\n\n@media (min-width: 768px) {\n  .top-menu {\n    top: 50px;\n    position: fixed;\n    height: 40px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .top-menu {\n    display: none;\n  }\n}\n\n@media (min-width: 576px) {\n  .top-menu .nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .top-menu .nav {\n    display: block;\n    margin: 0 !important;\n  }\n}\n\n.top-menu .nav > li {\n  position: relative;\n  display: block;\n}\n\n.top-menu .nav > li > a {\n  padding: 10px 20px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 20px;\n  text-decoration: none;\n  white-space: nowrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .top-menu .nav > li > a {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n}\n\n.top-menu .nav > li > a i {\n  font-size: 14px;\n  margin-right: 10px;\n  line-height: 20px;\n  width: 14px;\n  text-align: center;\n}\n\n.top-menu .nav > li > a .badge {\n  margin-left: 5px;\n  background: #2d353c;\n}\n\n.top-menu .nav > li > a .label {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-left: 5px;\n}\n\n.top-menu .nav > li > a .icon-img {\n  float: left;\n  margin-right: 7px;\n  margin-left: -3px;\n  width: 20px;\n  height: 20px;\n  overflow: hidden;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.top-menu .nav > li > a > span {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.top-menu .nav > li > a:focus,\n.top-menu .nav > li > a:hover {\n  background: 0 0;\n  color: #fff;\n}\n\n.top-menu .nav > li.active > a {\n  position: relative;\n  z-index: 10;\n  color: #fff;\n}\n\n.top-menu .nav > li.active > a i {\n  color: #00acac;\n}\n\n.top-menu .nav > li.active > a.badge,\n.top-menu .nav > li.active > a.label {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.top-menu .nav > li.menu-control {\n  position: absolute;\n  top: 0;\n  margin: 0;\n  z-index: 10;\n}\n\n@media (max-width: 767.98px) {\n  .top-menu .nav > li.menu-control {\n    display: none !important;\n  }\n}\n\n.top-menu .nav > li.menu-control > a {\n  padding: 0;\n  text-align: center;\n  line-height: 40px;\n  width: 40px;\n  height: 40px;\n  background: #2d353c;\n}\n\n.top-menu .nav > li.menu-control > a i {\n  float: none;\n  margin: 0;\n  font-size: 18px;\n  display: block;\n  line-height: 40px;\n  color: #fff;\n  width: auto;\n}\n\n.top-menu .nav > li.menu-control > a:focus,\n.top-menu .nav > li.menu-control > a:hover {\n  background: #242b30;\n}\n\n.top-menu .nav > li.menu-control.menu-control-left {\n  left: -50px;\n}\n\n.top-menu .nav > li.menu-control.menu-control-left > a {\n  -webkit-box-shadow: 5px 0 8px -3px rgba(0, 0, 0, 0.5);\n  box-shadow: 5px 0 8px -3px rgba(0, 0, 0, 0.5);\n}\n\n.top-menu .nav > li.menu-control.menu-control-left.show {\n  left: 0;\n  -webkit-animation: topMenuControlSlideInLeft 0.2s;\n  -moz-animation: topMenuControlSlideInLeft 0.2s;\n  -ms-animation: topMenuControlSlideInLeft 0.2s;\n  -o-animation: topMenuControlSlideInLeft 0.2s;\n  animation: topMenuControlSlideInLeft 0.2s;\n}\n\n.top-menu .nav > li.menu-control.menu-control-right {\n  right: -50px;\n}\n\n.top-menu .nav > li.menu-control.menu-control-right > a {\n  -webkit-box-shadow: -5px 0 8px -3px rgba(0, 0, 0, 0.5);\n  box-shadow: -5px 0 8px -3px rgba(0, 0, 0, 0.5);\n}\n\n.top-menu .nav > li.menu-control.menu-control-right.show {\n  right: 0;\n  -webkit-animation: topMenuControlSlideInRight 0.2s;\n  -moz-animation: topMenuControlSlideInRight 0.2s;\n  -ms-animation: topMenuControlSlideInRight 0.2s;\n  -o-animation: topMenuControlSlideInRight 0.2s;\n  animation: topMenuControlSlideInRight 0.2s;\n}\n\n@media (min-width: 768px) {\n  .top-menu .nav > li.has-sub:hover > .sub-menu {\n    display: block;\n  }\n}\n\n.top-menu .nav > li:focus > a,\n.top-menu .nav > li:hover > a {\n  background: 0 0;\n  color: #fff;\n}\n\n.top-menu .nav .caret {\n  display: block;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-size: 11px;\n  border: 0;\n  margin-left: 5px;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n@media (max-width: 767.98px) {\n  .top-menu .nav .caret {\n    margin-left: auto;\n  }\n}\n\n.top-menu .nav .caret:before {\n  content: \"\\f054\";\n  display: block;\n  text-align: center;\n  opacity: 0.5;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.top-menu .nav .sub-menu {\n  display: none;\n  top: 40px;\n  background: #2d353c;\n  list-style-type: none;\n  margin: 0;\n  padding: 10px 0;\n}\n\n@media (min-width: 768px) {\n  .top-menu .nav .sub-menu {\n    width: 220px;\n    position: absolute;\n    left: 0;\n    max-height: calc(100vh - 90px);\n    overflow: scroll;\n  }\n}\n\n.top-menu .nav .sub-menu > li > a {\n  padding: 5px 20px;\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 767.98px) {\n  .top-menu .nav .sub-menu > li > a {\n    padding-left: 44px;\n  }\n}\n\n.top-menu .nav .sub-menu > li > a .caret {\n  margin-left: auto;\n}\n\n.float-sub-menu-container .float-sub-menu li > a:focus,\n.float-sub-menu-container .float-sub-menu li > a:hover,\n.top-menu .nav .sub-menu > li > a:focus,\n.top-menu .nav .sub-menu > li > a:hover {\n  color: #fff;\n}\n\n.top-menu .nav .sub-menu > li.active > a {\n  background: #1a2229;\n  color: #fff;\n}\n\n.top-menu .nav .sub-menu .sub-menu {\n  background: rgba(0, 0, 0, 0.2);\n  position: relative;\n  left: 0;\n  top: 0;\n  max-height: auto;\n  overflow: initial;\n}\n\n#page-loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: #d9e0e7;\n  z-index: 9999;\n}\n\n#page-loader.fade.d-none .spinner {\n  -webkit-animation: none;\n  -moz-animation: none;\n  -ms-animation: none;\n  -o-animation: none;\n  animation: none;\n}\n\n.content {\n  margin-left: 220px;\n  padding: 20px 0px;\n  height: calc(100vh - 80px);\n  /* height: 100%; */\n}\n\n@media (max-width: 767.98px) {\n  .content {\n    margin-left: 0;\n    padding: 20px;\n  }\n}\n\n.content.content-full-width {\n  padding: 0;\n}\n\n.content.content-full-width .page-header {\n  margin: 20px 30px;\n  position: relative;\n  z-index: 10;\n}\n\n@media (max-width: 767.98px) {\n  .content.content-full-width .page-header {\n    margin: 20px;\n  }\n\n  .content.content-full-width .page-header + .page-header {\n    margin-top: -20px;\n  }\n}\n\n.content.content-full-width .breadcrumb {\n  position: relative;\n  z-index: 20;\n  margin: 0 30px 0 0;\n}\n\n@media (max-width: 1199.98px) {\n  .content.content-full-width .breadcrumb {\n    margin: 20px 30px;\n  }\n\n  .content.content-full-width .breadcrumb + .page-header {\n    margin-top: -20px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .content.content-full-width .breadcrumb {\n    margin: 20px;\n  }\n\n  .content.content-full-width .breadcrumb + .page-header {\n    margin-top: -20px;\n  }\n}\n\n.content.content-inverse-mode .breadcrumb,\n.content.content-inverse-mode .breadcrumb a,\n.content.content-inverse-mode .page-header,\n.float-sub-menu-container .float-sub-menu li.active > a,\n.float-sub-menu-container .float-sub-menu li.expand > a,\n.float-sub-menu-container .float-sub-menu li.expanding > a {\n  color: #fff;\n}\n\n.content.content-inverse-mode .breadcrumb > li,\n.content.content-inverse-mode .page-header small {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.float-sub-menu-container {\n  position: fixed;\n  width: 220px;\n  margin: 0;\n  background: #242b30;\n  z-index: 1020;\n}\n\n.float-sub-menu-container .float-sub-menu {\n  margin: 0;\n  list-style-type: none;\n  padding: 9px 0 9px 39px;\n}\n\n.float-sub-menu-container .float-sub-menu li {\n  position: relative;\n}\n\n.float-sub-menu-container .float-sub-menu li > a {\n  line-height: 18px;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  color: rgba(255, 255, 255, 0.6);\n  padding: 3px 20px 3px 15px;\n}\n\n.float-sub-menu-container .float-sub-menu li > a .caret {\n  display: block;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-size: 11px;\n  margin-top: -1px;\n  border: 0;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  float: right;\n}\n\n.float-sub-menu-container .float-sub-menu li > a .caret:before {\n  display: block;\n  text-align: center;\n  opacity: 0.5;\n  content: \"\\f054\";\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.float-sub-menu-container .float-sub-menu li > a:after {\n  content: \"\";\n  position: absolute;\n  background: #2d353c;\n  top: 11px;\n  width: 11px;\n  height: 2px;\n  left: -11px;\n}\n\n.float-sub-menu-container .float-sub-menu li:before {\n  content: \"\";\n  background: #2d353c;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  left: -13px;\n}\n\n.float-sub-menu-container .float-sub-menu li:after {\n  content: \"\";\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  top: 11px;\n  margin-top: -2px;\n  z-index: 10;\n  background: #242b30;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  left: 0;\n}\n\n.float-sub-menu-container .float-sub-menu li:first-child:before {\n  top: -14px;\n}\n\n.float-sub-menu-container .float-sub-menu li:last-child:before {\n  bottom: auto;\n  height: 13px;\n}\n\n.float-sub-menu-container .float-sub-menu li.has-sub > a:before {\n  background: #2d353c;\n}\n\n.float-sub-menu-container .float-sub-menu li.active:after {\n  border-color: #00acac;\n}\n\n.float-sub-menu-container .float-sub-menu > li:first-child:before {\n  top: 11px;\n}\n\n.float-sub-menu-container .float-sub-menu > li:first-child:last-child:before {\n  height: 0 !important;\n}\n\n.float-sub-menu-container .float-sub-menu .active > .sub-menu,\n.inbox .nav-inbox > li {\n  display: block;\n}\n\n.float-sub-menu-container .float-sub-menu .sub-menu {\n  display: none;\n  list-style-type: none;\n  background: 0 0;\n  padding: 0 0 0 15px;\n}\n\n.float-sub-menu-container .float-sub-menu-arrow {\n  position: absolute;\n  top: 20px;\n  width: 28px;\n  height: 2px;\n  background: #2d353c;\n  left: 0;\n}\n\n.float-sub-menu-container .float-sub-menu-line {\n  position: absolute;\n  top: 20px;\n  width: 2px;\n  background: #2d353c;\n  left: 26px;\n}\n\n.float-sub-menu-container .foat-sub-menu-arrow:after,\n.float-sub-menu-container .foat-sub-menu-arrow:before,\n.page-sidebar-minified .sidebar .nav > li > a span {\n  display: none;\n}\n\n.boxed-layout {\n  height: 100%;\n  background-image: url(images/cover-pattern.png);\n}\n\n.boxed-layout .top-menu {\n  max-width: 1280px;\n  width: 100%;\n  left: 50%;\n  margin-left: -640px;\n  position: absolute;\n}\n\n@media (max-width: 767.98px) {\n  .boxed-layout .top-menu {\n    position: relative;\n    left: 0;\n    margin: 0;\n  }\n}\n\n.boxed-layout .pace {\n  width: 1280px;\n  left: 50%;\n  margin-left: -640px;\n  position: absolute;\n}\n\n.boxed-layout .page-container {\n  max-width: 1280px;\n  width: 100%;\n  margin: 0 auto;\n  min-height: 100%;\n  background: #d9e0e7;\n  position: relative;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);\n}\n\n.boxed-layout .header {\n  max-width: 1280px;\n  width: 100%;\n  right: auto;\n  left: auto;\n}\n\n@media (min-width: 768px) {\n  .boxed-layout .sidebar,\n  .boxed-layout .sidebar-bg {\n    left: auto;\n    right: auto;\n  }\n}\n\n@media (max-width: 1280px) {\n  .boxed-layout .top-menu {\n    left: 0;\n    margin-left: 0;\n  }\n}\n\n.page-content-full-height {\n  height: 100%;\n}\n\n@media (min-width: 768px) {\n  .page-content-full-height .content {\n    position: absolute;\n    top: 50px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n.page-header-fixed {\n  padding-top: 50px;\n}\n\n@media (max-width: 767.98px) {\n  .page-header-fixed {\n    padding-top: 101px;\n  }\n}\n\n/* .page-header-fixed .header,\n.page-sidebar-fixed .sidebar {\n    position: fixed\n} */\n\n@media (max-width: 767.98px) {\n  .page-with-two-sidebar .sidebar-right.sidebar,\n  .page-with-two-sidebar .sidebar-right.sidebar-bg {\n    position: fixed;\n    right: -220px;\n    left: auto;\n  }\n\n  .page-with-two-sidebar .header .navbar-brand {\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n\n  .page-with-two-sidebar.page-right-sidebar-toggled .sidebar-right.sidebar,\n  .page-with-two-sidebar.page-right-sidebar-toggled .sidebar-right.sidebar-bg,\n  .page-with-two-sidebar.page-with-wide-sidebar.page-right-sidebar-toggled\n    .sidebar-right.sidebar,\n  .page-with-two-sidebar.page-with-wide-sidebar.page-right-sidebar-toggled\n    .sidebar-right.sidebar-bg {\n    right: 0;\n    left: auto;\n    -webkit-animation: sidebarSlideInRight 0.2s;\n    -moz-animation: sidebarSlideInRight 0.2s;\n    -ms-animation: sidebarSlideInRight 0.2s;\n    -o-animation: sidebarSlideInRight 0.2s;\n    animation: sidebarSlideInRight 0.2s;\n  }\n\n  .page-with-two-sidebar.page-with-wide-sidebar .sidebar-right.sidebar,\n  .page-with-two-sidebar.page-with-wide-sidebar .sidebar-right.sidebar-bg {\n    right: -250px;\n    left: auto;\n  }\n}\n\n.page-sidebar-minified .sidebar {\n  width: 60px;\n  position: absolute;\n}\n\n.page-sidebar-minified .sidebar .nav > li > a {\n  padding: 10px 20px;\n}\n\n.media-messaging .media p,\n.page-sidebar-minified .sidebar .nav > li > a i {\n  margin: 0;\n}\n\n.page-sidebar-minified .sidebar .nav li.has-sub > .sub-menu,\n.page-sidebar-minified .sidebar .nav-profile.expand,\n.page-sidebar-minified .sidebar .slimScrollDiv .slimScrollBar,\n.page-sidebar-minified .sidebar .slimScrollDiv .slimScrollRail {\n  display: none !important;\n}\n\n.checkbox.checkbox-css input,\n.page-sidebar-minified .sidebar .nav-header,\n.page-sidebar-minified .sidebar .nav-profile,\n.radio.radio-css input,\n.switcher input {\n  display: none;\n}\n\n.page-sidebar-minified .sidebar .caret {\n  position: absolute;\n  top: 10px;\n  right: 5px;\n}\n\n.page-sidebar-minified .sidebar .caret:before {\n  -webkit-transform: rotate(0deg) !important;\n  -moz-transform: rotate(0deg) !important;\n  -ms-transform: rotate(0deg) !important;\n  -o-transform: rotate(0deg) !important;\n  transform: rotate(0deg) !important;\n}\n\n.page-sidebar-minified .sidebar.sidebar-right .slimScrollDiv,\n.page-sidebar-minified .sidebar.sidebar-right .slimScrollDiv > div {\n  overflow: hidden !important;\n}\n\n.page-sidebar-minified .sidebar.sidebar-right .slimScrollBar {\n  display: block !important;\n}\n\n.page-sidebar-minified .sidebar-bg {\n  width: 60px;\n}\n\n.page-sidebar-minified .content {\n  margin-left: 60px;\n}\n\n@media (max-width: 767.98px) {\n  .page-sidebar-minified .content {\n    margin-left: 0;\n  }\n}\n\n.page-sidebar-minified .footer {\n  margin-left: 90px;\n}\n\n@media (max-width: 767.98px) {\n  .page-sidebar-minified .footer {\n    margin-left: 20px;\n  }\n}\n\n.page-sidebar-minified .sidebar-minify-btn i:before {\n  content: \"\\f101\";\n}\n\n@media (min-width: 768px) {\n  .page-sidebar-minified .map {\n    left: 60px;\n  }\n\n  .page-sidebar-minified.page-with-right-sidebar {\n    right: 60px;\n    left: 0;\n  }\n}\n\n.page-sidebar-minified.page-with-right-sidebar .content {\n  margin-right: 60px;\n  margin-left: 0;\n}\n\n@media (max-width: 767.98px) {\n  .page-sidebar-minified.page-with-right-sidebar .content {\n    margin-right: 0;\n  }\n}\n\n.page-sidebar-minified.page-with-right-sidebar .footer {\n  margin-right: 90px;\n  margin-left: 30px;\n}\n\n@media (max-width: 767.98px) {\n  .page-sidebar-minified.page-with-right-sidebar .footer {\n    margin-right: 20px;\n  }\n}\n\n.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > a .icon-img,\n.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > a i {\n  float: none;\n  width: auto;\n  margin: 0 0 0 5px;\n}\n\n.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > a .caret {\n  position: absolute;\n  right: auto;\n  left: 3px;\n}\n\n.page-sidebar-minified.page-with-right-sidebar\n  .sidebar\n  .nav\n  > li\n  > a\n  .caret:before,\n.page-with-right-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li\n  > a\n  .caret:before {\n  content: \"\\f053\";\n}\n\n.page-sidebar-minified.page-with-right-sidebar .sidebar .nav > li > .sub-menu {\n  padding: 10px 30px 10px 0;\n}\n\n.page-sidebar-minified.page-with-right-sidebar .sidebar-minify-btn i:before {\n  content: \"\\f100\";\n}\n\n.page-sidebar-minified.page-sidebar-fixed .sidebar {\n  position: fixed;\n}\n\n.page-sidebar-minified.page-sidebar-fixed .sidebar .slimScrollDiv,\n.page-sidebar-minified.page-sidebar-fixed .sidebar .slimScrollDiv > div {\n  overflow: hidden !important;\n}\n\n.page-sidebar-minified:not(.page-sidebar-fixed) .sidebar .slimScrollDiv,\n.page-sidebar-minified:not(.page-sidebar-fixed) .sidebar .slimScrollDiv > div {\n  overflow: visible !important;\n  height: auto !important;\n}\n\n@media (max-width: 767.98px) {\n  .page-sidebar-toggled .sidebar,\n  .page-sidebar-toggled .sidebar-bg {\n    left: 0;\n    -webkit-animation: sidebarSlideInLeft 0.2s;\n    -moz-animation: sidebarSlideInLeft 0.2s;\n    -ms-animation: sidebarSlideInLeft 0.2s;\n    -o-animation: sidebarSlideInLeft 0.2s;\n    animation: sidebarSlideInLeft 0.2s;\n  }\n\n  .page-sidebar-toggled .sidebar-bg {\n    position: fixed;\n  }\n\n  .page-sidebar-toggled.page-with-right-sidebar .sidebar,\n  .page-sidebar-toggled.page-with-right-sidebar .sidebar-bg,\n  .page-sidebar-toggled.page-with-right-sidebar.page-sidebar-minified .sidebar,\n  .page-sidebar-toggled.page-with-right-sidebar.page-sidebar-minified\n    .sidebar-bg {\n    left: auto;\n    right: 0;\n    -webkit-animation: sidebarSlideInRight 0.2s;\n    -moz-animation: sidebarSlideInRight 0.2s;\n    -ms-animation: sidebarSlideInRight 0.2s;\n    -o-animation: sidebarSlideInRight 0.2s;\n    animation: sidebarSlideInRight 0.2s;\n  }\n\n  .page-sidebar-toggled.page-with-two-sidebar .sidebar-right.sidebar,\n  .page-sidebar-toggled.page-with-two-sidebar .sidebar-right.sidebar-bg {\n    -webkit-animation: none;\n    -moz-animation: none;\n    -ms-animation: none;\n    -o-animation: none;\n    animation: none;\n  }\n\n  .page-sidebar-toggled.page-sidebar-minified.sidebar,\n  .page-sidebar-toggled.page-sidebar-minified.sidebar-bg {\n    position: fixed;\n    left: 0;\n    -webkit-animation: sidebarSlideInLeft 0.2s;\n    -moz-animation: sidebarSlideInLeft 0.2s;\n    -ms-animation: sidebarSlideInLeft 0.2s;\n    -o-animation: sidebarSlideInLeft 0.2s;\n    animation: sidebarSlideInLeft 0.2s;\n  }\n}\n\n.page-with-light-sidebar .sidebar,\n.page-with-light-sidebar .sidebar-bg {\n  background: #fff;\n}\n\n.page-with-light-sidebar .sidebar .nav > li > a {\n  color: #6f8293;\n  font-weight: 600;\n}\n\n.page-with-light-sidebar .sidebar .nav > li > a:focus,\n.page-with-light-sidebar .sidebar .nav > li > a:hover {\n  color: #2d353c;\n}\n\n.page-with-light-sidebar .sidebar .nav > li.active > a {\n  color: #2d353c;\n  background: #f2f3f4;\n}\n\n.page-with-light-sidebar .sidebar .nav > li.active > a:focus,\n.page-with-light-sidebar .sidebar .nav > li.active > a:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.today:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.today:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.today:hover {\n  color: #2d353c;\n  background: #f2f3f4;\n}\n\n.page-with-light-sidebar .sidebar .nav > li.nav-header,\n.page-with-light-sidebar .sidebar .sub-menu > li > a .caret {\n  color: #6f8293;\n}\n\n.page-with-light-sidebar .sidebar .nav > li.nav-profile.active > a,\n.page-with-light-sidebar .sidebar .nav > li.nav-profile > a {\n  color: #fff !important;\n}\n\n.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn {\n  background: #f2f3f4;\n  color: #2d353c;\n}\n\n.breadcrumb .breadcrumb-item + .breadcrumb-item:before,\n.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn i {\n  color: #9ba8b4;\n}\n\n.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:focus,\n.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:hover {\n  background: #f2f3f4 !important;\n  color: #2d353c !important;\n}\n\n.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:focus i,\n.page-with-light-sidebar .sidebar .nav .sidebar-minify-btn:hover i {\n  color: #2d353c !important;\n}\n\n.page-with-light-sidebar .sidebar .nav.nav-profile {\n  border-color: #f2f3f4;\n}\n\n.page-with-light-sidebar .sidebar .sub-menu > li > a {\n  color: #6f8293;\n  font-weight: 600 !important;\n}\n\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a:focus,\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a:hover,\n.page-with-light-sidebar .sidebar .sub-menu > li > a:focus,\n.page-with-light-sidebar .sidebar .sub-menu > li > a:hover {\n  color: #2d353c;\n}\n\n.page-with-light-sidebar .sidebar .sub-menu > li.has-sub > a:before,\n.page-with-light-sidebar .sidebar .sub-menu > li:before,\n.page-with-light-sidebar .sidebar .sub-menu > li > a:after {\n  background: #dde0e2;\n}\n\n.page-with-light-sidebar .sidebar .sub-menu > li:after {\n  border-width: 2px;\n  border-color: #dde0e2;\n  background: #fff;\n}\n\n.page-with-light-sidebar .sidebar .sub-menu > li.active:after {\n  border-color: #00acac;\n}\n\n.page-with-light-sidebar .slimScrollDiv .slimScrollBar {\n  background: #000 !important;\n}\n\n.page-with-light-sidebar .float-sub-menu-container,\n.page-with-light-sidebar.page-sidebar-minified .sidebar .nav > li.active > a {\n  background: #f2f3f4;\n}\n\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li:before,\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a:after,\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu-arrow,\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu-line {\n  background: #dde0e2;\n}\n\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li > a {\n  color: #6f8293;\n  font-weight: 600;\n}\n\n.page-with-light-sidebar .float-sub-menu-container .float-sub-menu li:after {\n  background: #f2f3f4;\n  border-color: #dde0e2;\n  border-width: 2px;\n}\n\n.breadcrumb .breadcrumb-item a,\n.page-with-light-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li.active\n  > a,\n.page-with-light-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li.expand\n  > a,\n.page-with-light-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li.expanding\n  > a {\n  color: #2d353c;\n}\n\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu-line {\n  left: auto;\n  right: 26px;\n}\n\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu li:after,\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu-arrow,\n.page-with-right-sidebar .sidebar,\n.page-with-right-sidebar .sidebar-bg {\n  left: auto;\n  right: 0;\n}\n\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu {\n  padding-left: 0;\n  padding-right: 39px;\n  text-align: right;\n}\n\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu li > a {\n  padding-left: 15px;\n  padding-right: 20px;\n}\n\n.page-with-right-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li\n  > a\n  .caret {\n  float: left;\n}\n\n.page-with-right-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li\n  > a:after {\n  right: -11px;\n  left: auto;\n}\n\n.page-with-right-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li.active\n  > a\n  .caret:before,\n.page-with-right-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li.expand\n  > a\n  .caret:before,\n.page-with-right-sidebar\n  .float-sub-menu-container\n  .float-sub-menu\n  li.expanding\n  > a\n  .caret:before {\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu li:before {\n  right: -13px;\n  left: auto;\n}\n\n.page-with-right-sidebar .float-sub-menu-container .float-sub-menu .sub-menu {\n  padding-left: 0;\n  padding-right: 15px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar .sidebar,\n  .page-with-right-sidebar .sidebar-bg {\n    right: -220px;\n  }\n}\n\n.page-with-right-sidebar .content {\n  margin-left: 0;\n  margin-right: 220px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar .content {\n    margin-right: 0;\n  }\n}\n\n.page-with-right-sidebar .footer {\n  margin-left: 30px;\n  margin-right: 250px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar .footer {\n    margin-right: 30px;\n  }\n}\n\n.page-with-right-sidebar .btn-scroll-to-top {\n  left: 25px;\n  right: auto;\n}\n\n@media (min-width: 768px) {\n  .page-with-right-sidebar .map {\n    right: 220px;\n    left: 0;\n  }\n}\n\n.page-with-right-sidebar.page-with-wide-sidebar .content {\n  margin-right: 250px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar.page-with-wide-sidebar .content {\n    margin-right: 0;\n  }\n}\n\n.page-with-right-sidebar.page-with-wide-sidebar .footer {\n  margin-right: 280px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar.page-with-wide-sidebar .footer {\n    margin-right: 20px;\n  }\n}\n\n.page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified .content {\n  margin-right: 60px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified\n    .content {\n    margin-right: 0;\n  }\n}\n\n.page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified .footer {\n  margin-right: 90px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-right-sidebar.page-with-wide-sidebar.page-sidebar-minified\n    .footer {\n    margin-right: 20px;\n  }\n}\n\n@media (min-width: 768px) {\n  .page-with-top-menu,\n  .page-with-top-menu .sidebar,\n  .page-with-top-menu.page-header-fixed {\n    padding-top: 90px;\n  }\n\n  .page-with-two-sidebar .sidebar-right.sidebar,\n  .page-with-two-sidebar .sidebar-right.sidebar-bg {\n    right: 0;\n    left: auto;\n  }\n\n  .page-with-two-sidebar .content {\n    margin-right: 220px;\n  }\n\n  .page-with-two-sidebar .footer {\n    margin-right: 250px;\n  }\n}\n\n.page-with-two-sidebar.page-sidebar-minified .sidebar-right.sidebar,\n.page-with-two-sidebar.page-sidebar-minified .sidebar-right.sidebar-bg {\n  width: 220px;\n}\n\n.page-with-two-sidebar.page-sidebar-minified.page-with-wide-sidebar\n  .sidebar-right.sidebar,\n.page-with-two-sidebar.page-sidebar-minified.page-with-wide-sidebar\n  .sidebar-right.sidebar-bg,\n.page-with-wide-sidebar .sidebar,\n.page-with-wide-sidebar .sidebar-bg {\n  width: 250px;\n}\n\n@media (min-width: 768px) {\n  .page-with-two-sidebar.page-with-wide-sidebar .footer {\n    margin-right: 280px;\n  }\n}\n\n.page-with-two-sidebar.page-sidebar-fixed .sidebar.sidebar-right {\n  position: fixed;\n}\n\n.page-with-two-sidebar.page-right-sidebar-collapsed .sidebar-right.sidebar,\n.page-with-two-sidebar.page-right-sidebar-collapsed .sidebar-right.sidebar-bg {\n  right: -220px;\n}\n\n.page-with-two-sidebar.page-right-sidebar-collapsed .content {\n  margin-right: 0;\n}\n\n.page-with-two-sidebar.page-right-sidebar-collapsed.page-with-wide-sidebar\n  .sidebar-right.sidebar,\n.page-with-two-sidebar.page-right-sidebar-collapsed.page-with-wide-sidebar\n  .sidebar-right.sidebar-bg {\n  right: -250px;\n}\n\n@media (max-width: 767.98px) {\n  .page-with-wide-sidebar .sidebar,\n  .page-with-wide-sidebar .sidebar-bg {\n    width: 250px;\n    left: -250px;\n  }\n}\n\n@media (min-width: 768px) {\n  .page-with-wide-sidebar .content {\n    margin-left: 250px;\n  }\n\n  .page-with-wide-sidebar .footer {\n    margin-left: 280px;\n  }\n\n  .page-with-wide-sidebar .map {\n    left: 250px;\n  }\n\n  .page-with-wide-sidebar.page-with-right-sidebar .content {\n    margin-left: 0;\n    margin-right: 250px;\n  }\n\n  .page-with-wide-sidebar.page-with-right-sidebar .footer {\n    margin-left: 30px;\n    margin-right: 280px;\n  }\n\n  .page-with-wide-sidebar.page-with-right-sidebar .map {\n    right: 250px;\n    left: 0;\n  }\n\n  .page-with-wide-sidebar.page-with-two-sidebar .content {\n    margin-right: 250px;\n    margin-left: 250px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .page-with-wide-sidebar.page-with-two-sidebar.page-right-sidebar-toggled\n    .sidebar,\n  .page-with-wide-sidebar.page-with-two-sidebar.page-right-sidebar-toggled\n    .sidebar-bg {\n    left: auto;\n    right: 0;\n    -webkit-animation: wideSidebarSlideInRight 0.2s;\n    -moz-animation: wideSidebarSlideInRight 0.2s;\n    -ms-animation: wideSidebarSlideInRight 0.2s;\n    -o-animation: wideSidebarSlideInRight 0.2s;\n    animation: wideSidebarSlideInRight 0.2s;\n  }\n}\n\n.page-with-wide-sidebar.page-sidebar-minified .sidebar,\n.page-with-wide-sidebar.page-sidebar-minified .sidebar + .sidebar-bg {\n  width: 60px;\n}\n\n.page-with-wide-sidebar.page-sidebar-minified .sidebar-right.sidebar,\n.page-with-wide-sidebar.page-sidebar-minified .sidebar-right.sidebar-bg {\n  width: 250px;\n}\n\n@media (min-width: 768px) {\n  .page-with-wide-sidebar.page-sidebar-minified:not(.page-with-right-sidebar)\n    .content {\n    margin-left: 60px;\n  }\n\n  .page-with-wide-sidebar.page-sidebar-minified:not(.page-with-right-sidebar)\n    .footer {\n    margin-left: 90px;\n    margin-right: 280px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .page-with-wide-sidebar.page-sidebar-toggled .sidebar,\n  .page-with-wide-sidebar.page-sidebar-toggled .sidebar-bg {\n    left: 0;\n    -webkit-animation: wideSidebarSlideInLeft 0.2s;\n    -moz-animation: wideSidebarSlideInLeft 0.2s;\n    -ms-animation: wideSidebarSlideInLeft 0.2s;\n    -o-animation: wideSidebarSlideInLeft 0.2s;\n    animation: wideSidebarSlideInLeft 0.2s;\n  }\n\n  .page-with-wide-sidebar.page-sidebar-toggled.page-with-right-sidebar .sidebar,\n  .page-with-wide-sidebar.page-sidebar-toggled.page-with-right-sidebar\n    .sidebar-bg {\n    left: auto;\n    right: 0;\n    -webkit-animation: wideSidebarSlideInRight 0.2s;\n    -moz-animation: wideSidebarSlideInRight 0.2s;\n    -ms-animation: wideSidebarSlideInRight 0.2s;\n    -o-animation: wideSidebarSlideInRight 0.2s;\n    animation: wideSidebarSlideInRight 0.2s;\n  }\n}\n\n.page-without-sidebar .content {\n  margin-left: 0;\n}\n\n.page-without-sidebar .footer {\n  margin-left: 30px;\n}\n\n@media (max-width: 767.98px) {\n  .page-without-sidebar .header .navbar-brand {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n}\n\n.alert.alert-primary {\n  color: #10416d;\n  background-color: #cce3f8;\n  border-color: #348fe2;\n}\n\n.alert.alert-primary hr {\n  border-top-color: #2083dd;\n}\n\n.alert.alert-primary .alert-link {\n  color: #092641;\n}\n\n.alert.alert-secondary {\n  color: #25282b;\n  background-color: #dadddf;\n  border-color: #6c757d;\n}\n\n.alert.alert-secondary hr {\n  border-top-color: #60686f;\n}\n\n.alert.alert-secondary .alert-link {\n  color: #0d0f10;\n}\n\n.alert.alert-success {\n  color: #001313;\n  background-color: #bfeaea;\n  border-color: #00acac;\n}\n\n.alert.alert-success hr {\n  border-top-color: #009393;\n}\n\n.alert.alert-success .alert-link {\n  color: #000;\n}\n\n.alert.alert-info {\n  color: #195a6d;\n  background-color: #d2edf5;\n  border-color: #49b6d6;\n}\n\n.alert.alert-info hr {\n  border-top-color: #34aed1;\n}\n\n.alert.alert-info .alert-link {\n  color: #0f3844;\n}\n\n.alert.alert-warning {\n  color: #714505;\n  background-color: #fde6c6;\n  border-color: #f59c1a;\n}\n\n.alert.alert-warning hr {\n  border-top-color: #eb900a;\n}\n\n.alert.alert-warning .alert-link {\n  color: #402703;\n}\n\n.alert.alert-danger {\n  color: #bd0500;\n  background-color: #ffd6d5;\n  border-color: #ff5b57;\n}\n\n.alert.alert-danger hr {\n  border-top-color: #ff423e;\n}\n\n.alert.alert-danger .alert-link {\n  color: #8a0300;\n}\n\n.alert.alert-inverse {\n  color: #000;\n  background-color: #cbcdce;\n  border-color: #2d353c;\n}\n\n.alert.alert-inverse hr {\n  border-top-color: #22282d;\n}\n\n.alert.alert-inverse .alert-link {\n  color: #000;\n}\n\n.alert.alert-grey {\n  color: #627884;\n  background-color: #edf0f2;\n  border-color: #b6c2c9;\n}\n\n.alert.alert-grey hr {\n  border-top-color: #a7b6be;\n}\n\n.alert.alert-grey .alert-link {\n  color: #4c5d67;\n}\n\n.alert.alert-blue {\n  color: #10416d;\n  background-color: #cce3f8;\n  border-color: #348fe2;\n}\n\n.alert.alert-blue hr {\n  border-top-color: #2083dd;\n}\n\n.alert.alert-blue .alert-link {\n  color: #092641;\n}\n\n.alert.alert-indigo {\n  color: #3f1880;\n  background-color: #e1d4f7;\n  border-color: #8753de;\n}\n\n.alert.alert-indigo hr {\n  border-top-color: #783eda;\n}\n\n.alert.alert-indigo .alert-link {\n  color: #2a1055;\n}\n\n.alert.alert-purple {\n  color: #31375e;\n  background-color: #dcdeed;\n  border-color: #727cb6;\n}\n\n.alert.alert-purple hr {\n  border-top-color: #616cad;\n}\n\n.alert.alert-purple .alert-link {\n  color: #1f243d;\n}\n\n.alert.alert-pink {\n  color: #b3044a;\n  background-color: #fed5e5;\n  border-color: #fb5597;\n}\n\n.alert.alert-pink hr {\n  border-top-color: #fa3c88;\n}\n\n.alert.alert-pink .alert-link {\n  color: #810335;\n}\n\n.alert.alert-red {\n  color: #bd0500;\n  background-color: #ffd6d5;\n  border-color: #ff5b57;\n}\n\n.alert.alert-red hr {\n  border-top-color: #ff423e;\n}\n\n.alert.alert-red .alert-link {\n  color: #8a0300;\n}\n\n.alert.alert-orange {\n  color: #714505;\n  background-color: #fde6c6;\n  border-color: #f59c1a;\n}\n\n.alert.alert-orange hr {\n  border-top-color: #eb900a;\n}\n\n.alert.alert-orange .alert-link {\n  color: #402703;\n}\n\n.alert.alert-yellow {\n  color: #665700;\n  background-color: #fff6bf;\n  border-color: #ffd900;\n}\n\n.alert.alert-yellow hr {\n  border-top-color: #e6c300;\n}\n\n.alert.alert-yellow .alert-link {\n  color: #332b00;\n}\n\n.alert.alert-green {\n  color: #0f330f;\n  background-color: #cceacc;\n  border-color: #32a932;\n}\n\n.alert.alert-green hr {\n  border-top-color: #2c952c;\n}\n\n.alert.alert-green .alert-link {\n  color: #030c03;\n}\n\n.alert.alert-teal {\n  color: #001313;\n  background-color: #bfeaea;\n  border-color: #00acac;\n}\n\n.alert.alert-teal hr {\n  border-top-color: #009393;\n}\n\n.alert.alert-teal .alert-link {\n  color: #000;\n}\n\n.alert.alert-cyan {\n  color: #195a6d;\n  background-color: #d2edf5;\n  border-color: #49b6d6;\n}\n\n.alert.alert-cyan hr {\n  border-top-color: #34aed1;\n}\n\n.alert.alert-cyan .alert-link {\n  color: #0f3844;\n}\n\n.alert.alert-white {\n  color: #b3b3b3;\n  background-color: #fff;\n  border-color: #fff;\n}\n\n.alert.alert-white hr {\n  border-top-color: #f2f2f2;\n}\n\n.alert.alert-white .alert-link {\n  color: #999;\n}\n\n.alert.alert-gray {\n  color: #25282b;\n  background-color: #dadddf;\n  border-color: #6c757d;\n}\n\n.alert.alert-gray hr {\n  border-top-color: #60686f;\n}\n\n.alert.alert-gray .alert-link {\n  color: #0d0f10;\n}\n\n.alert.alert-gray-dark {\n  color: #000;\n  background-color: #cccecf;\n  border-color: #343a40;\n}\n\n.alert.alert-gray-dark hr {\n  border-top-color: #292d32;\n}\n\n.alert.alert-black .alert-link,\n.alert.alert-dark .alert-link,\n.alert.alert-dark-darker .alert-link,\n.alert.alert-gray-dark .alert-link {\n  color: #000;\n}\n\n.alert.alert-black {\n  color: #000;\n  background-color: #bfbfbf;\n  border-color: #000;\n}\n\n.alert.alert-black hr {\n  border-top-color: #000;\n}\n\n.alert.alert-dark {\n  color: #000;\n  background-color: #cbcdce;\n  border-color: #2d353c;\n}\n\n.alert.alert-dark hr {\n  border-top-color: #22282d;\n}\n\n.alert.alert-dark-darker {\n  color: #000;\n  background-color: #c6c8ca;\n  border-color: #1a2229;\n}\n\n.alert.alert-dark-darker hr {\n  border-top-color: #101519;\n}\n\n.alert.alert-lime {\n  color: #41601c;\n  background-color: #e3f2d2;\n  border-color: #90ca4b;\n}\n\n.alert.alert-lime hr {\n  border-top-color: #84c239;\n}\n\n.alert.alert-lime .alert-link {\n  color: #263811;\n}\n\n.alert.alert-light {\n  color: #9fa7ae;\n  background-color: #fcfcfc;\n  border-color: #f2f3f4;\n}\n\n.alert.alert-light hr {\n  border-top-color: #e4e6e8;\n}\n\n.alert.alert-light .alert-link {\n  color: #848d97;\n}\n\n.alert.alert-silver {\n  color: #627884;\n  background-color: #edf0f2;\n  border-color: #b6c2c9;\n}\n\n.alert.alert-silver hr {\n  border-top-color: #a7b6be;\n}\n\n.alert.alert-silver .alert-link {\n  color: #4c5d67;\n}\n\n.alert.alert-muted {\n  color: #21282c;\n  background-color: #d8dde0;\n  border-color: #627884;\n}\n\n.alert.alert-muted hr {\n  border-top-color: #576a76;\n}\n\n.alert.alert-muted .alert-link {\n  color: #0b0e0f;\n}\n\n.alert.alert-aqua {\n  color: #195a6d;\n  background-color: #d2edf5;\n  border-color: #49b6d6;\n}\n\n.alert.alert-aqua hr {\n  border-top-color: #34aed1;\n}\n\n.alert.alert-aqua .alert-link {\n  color: #0f3844;\n}\n\n.badge {\n  font-size: 75%;\n  font-weight: 600;\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: #777;\n  -webkit-border-radius: 12px;\n  border-radius: 12px;\n}\n\n.badge.badge-primary {\n  background: #348fe2;\n}\n\n.badge.badge-secondary {\n  background: #6c757d;\n}\n\n.badge.badge-success {\n  background: #00acac;\n}\n\n.badge.badge-info {\n  background: #49b6d6;\n}\n\n.badge.badge-warning {\n  background: #f59c1a;\n}\n\n.badge.badge-danger {\n  background: #ff5b57;\n}\n\n.badge.badge-light {\n  color: #2d353c;\n}\n\n.badge.badge-inverse {\n  background: #2d353c;\n}\n\n.badge.badge-grey,\n.badge.badge-muted {\n  background: #b6c2c9;\n}\n\n.badge.badge-blue {\n  background: #348fe2;\n}\n\n.badge.badge-indigo {\n  background: #8753de;\n}\n\n.badge.badge-purple {\n  background: #727cb6;\n}\n\n.badge.badge-pink {\n  background: #fb5597;\n}\n\n.badge.badge-red {\n  background: #ff5b57;\n}\n\n.badge.badge-orange {\n  background: #f59c1a;\n}\n\n.badge.badge-yellow {\n  background: #ffd900;\n}\n\n.badge.badge-green {\n  background: #32a932;\n}\n\n.badge.badge-teal {\n  background: #00acac;\n}\n\n.badge.badge-cyan {\n  background: #49b6d6;\n}\n\n.badge.badge-white {\n  background: #fff;\n}\n\n.badge.badge-gray {\n  background: #6c757d;\n}\n\n.badge.badge-gray-dark {\n  background: #343a40;\n}\n\n.badge.badge-black {\n  background: #000;\n}\n\n.badge.badge-dark {\n  background: #2d353c;\n}\n\n.badge.badge-dark-darker {\n  background: #1a2229;\n}\n\n.badge.badge-lime {\n  background: #90ca4b;\n}\n\n.badge.badge-light {\n  background: #f2f3f4;\n}\n\n.badge.badge-silver {\n  background: #b6c2c9;\n}\n\n.badge.badge-muted {\n  background: #627884;\n}\n\n.badge.badge-aqua {\n  background: #49b6d6;\n}\n\n.badge.badge-square {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.badge.badge-default,\n.inbox .nav-inbox > li.active > a {\n  background: #e4e7ea;\n  color: #2d353c;\n}\n\n.breadcrumb {\n  padding: 0;\n  margin: 0;\n  background: 0 0;\n}\n\n.breadcrumb .breadcrumb-item {\n  line-height: 32px;\n}\n\n.btn-scroll-to-top {\n  position: fixed;\n  bottom: 20px;\n  right: 25px;\n  z-index: 1020;\n}\n\n.btn {\n  font-weight: 600;\n}\n\n.btn.btn-circle,\n.btn.btn-rounded {\n  -webkit-border-radius: 200px;\n  border-radius: 200px;\n}\n\n.btn.btn-icon {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  line-height: 28px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.btn.btn-icon.btn-xs {\n  width: 16px;\n  height: 16px;\n  font-size: 8px;\n  line-height: 16px;\n}\n\n.btn-group-sm > .btn.btn-icon,\n.btn.btn-icon.btn-sm {\n  width: 22px;\n  height: 22px;\n  font-size: 11px;\n  line-height: 22px;\n}\n\n.btn-group-lg > .btn.btn-icon,\n.btn.btn-icon.btn-lg {\n  width: 34px;\n  height: 34px;\n  font-size: 17px;\n  line-height: 34px;\n}\n\n.btn.btn-theme {\n  padding: 12px 30px;\n  font-weight: 700;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.btn.btn-xs {\n  font-size: 12px;\n  line-height: 18px;\n  padding: 1px 5px;\n}\n\n.btn.btn-white.btn-white-without-border {\n  border-color: #fff;\n}\n\n.btn.btn-white.btn-white-without-border:not(.active):focus,\n.btn.btn-white.btn-white-without-border:not(.active):hover {\n  border-color: #f2f4f5 !important;\n  background: #f2f4f5 !important;\n}\n\n.btn.btn-white.btn-white-without-border.active {\n  border-color: #e4e7ea !important;\n}\n\n.btn-default {\n  color: #212529;\n  background-color: #f1f3f4;\n  border-color: #f1f3f4;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-default:hover {\n  color: #212529;\n  background-color: #d3dadf;\n  border-color: #d3dadf;\n}\n\n.btn-default.focus,\n.btn-default:focus {\n  box-shadow: 0 0 0 0 rgba(209, 212, 214, 0.5);\n}\n\n.btn-default.disabled,\n.btn-default:disabled {\n  color: #212529;\n  background-color: #f1f3f4;\n  border-color: #f1f3f4;\n}\n\n.btn-default:not(:disabled):not(.disabled).active,\n.btn-default:not(:disabled):not(.disabled):active,\n.show > .btn-default.dropdown-toggle {\n  color: #212529;\n  background-color: #d3dadf;\n  border-color: #d3dadf;\n}\n\n.btn-default:not(:disabled):not(.disabled).active:focus,\n.btn-default:not(:disabled):not(.disabled):active:focus,\n.show > .btn-default.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(209, 212, 214, 0.5);\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #348fe2;\n  border-color: #348fe2;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #1c75c7;\n  border-color: #1c75c7;\n}\n\n.btn-primary.focus,\n.btn-primary:focus {\n  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n  color: #fff;\n  background-color: #348fe2;\n  border-color: #348fe2;\n}\n\n.btn-primary:not(:disabled):not(.disabled).active,\n.btn-primary:not(:disabled):not(.disabled):active,\n.show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #1c75c7;\n  border-color: #1c75c7;\n}\n\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #545b62;\n}\n\n.btn-secondary.focus,\n.btn-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);\n}\n\n.btn-secondary.disabled,\n.btn-secondary:disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-secondary:not(:disabled):not(.disabled).active,\n.btn-secondary:not(:disabled):not(.disabled):active,\n.show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #545b62;\n}\n\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\n.show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);\n}\n\n.btn-success {\n  color: #000;\n  background-color: #f5f9fd;\n  border-color: #f5f9fd;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  font-size: 15px;\n  padding-top: 10px;\n}\n\n.btn-success:hover {\n  color: #000;\n  background-color: #f5f9fd;\n  border-color: #f5f9fd;\n}\n\n.btn-success.focus,\n.btn-success:focus {\n  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);\n}\n\n.btn-success.disabled,\n.btn-success:disabled {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-success:not(:disabled):not(.disabled).active,\n.btn-success:not(:disabled):not(.disabled):active,\n.show > .btn-success.dropdown-toggle {\n  color: #000;\n  background-color: #f5f9fd;\n  border-color: #f5f9fd;\n}\n\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);\n}\n\n.btn-info {\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  color: #fff;\n}\n\n.btn-info:hover {\n  color: #fff;\n  background-color: #2b9fc1;\n  border-color: #2b9fc1;\n}\n\n.btn-info.focus,\n.btn-info:focus {\n  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);\n}\n\n.btn-info.disabled,\n.btn-info:disabled {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-info:not(:disabled):not(.disabled).active,\n.btn-info:not(:disabled):not(.disabled):active,\n.show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #2b9fc1;\n  border-color: #2b9fc1;\n}\n\n.btn-info:not(:disabled):not(.disabled).active:focus,\n.btn-info:not(:disabled):not(.disabled):active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);\n}\n\n.btn-warning {\n  background-color: #f59c1a;\n  border-color: #f59c1a;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  color: #fff;\n}\n\n.btn-warning:hover {\n  color: #fff;\n  background-color: #d38109;\n  border-color: #d38109;\n}\n\n.btn-warning.focus,\n.btn-warning:focus {\n  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);\n}\n\n.btn-warning.disabled,\n.btn-warning:disabled {\n  color: #212529;\n  background-color: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.btn-warning:not(:disabled):not(.disabled).active,\n.btn-warning:not(:disabled):not(.disabled):active,\n.show > .btn-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #d38109;\n  border-color: #d38109;\n}\n\n.btn-warning:not(:disabled):not(.disabled).active:focus,\n.btn-warning:not(:disabled):not(.disabled):active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #ff5b57;\n  border-color: #ff5b57;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #ff2924;\n  border-color: #ff2924;\n}\n\n.btn-danger.focus,\n.btn-danger:focus {\n  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);\n}\n\n.btn-danger.disabled,\n.btn-danger:disabled {\n  color: #fff;\n  background-color: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.btn-danger:not(:disabled):not(.disabled).active,\n.btn-danger:not(:disabled):not(.disabled):active,\n.show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #ff2924;\n  border-color: #ff2924;\n}\n\n.btn-danger:not(:disabled):not(.disabled).active:focus,\n.btn-danger:not(:disabled):not(.disabled):active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);\n}\n\n.btn-inverse {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-inverse:hover {\n  color: #fff;\n  background-color: #171b1f;\n  border-color: #171b1f;\n}\n\n.btn-inverse.focus,\n.btn-inverse:focus {\n  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);\n}\n\n.btn-inverse.disabled,\n.btn-inverse:disabled {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-inverse:not(:disabled):not(.disabled).active,\n.btn-inverse:not(:disabled):not(.disabled):active,\n.show > .btn-inverse.dropdown-toggle {\n  color: #fff;\n  background-color: #171b1f;\n  border-color: #171b1f;\n}\n\n.btn-inverse:not(:disabled):not(.disabled).active:focus,\n.btn-inverse:not(:disabled):not(.disabled):active:focus,\n.show > .btn-inverse.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);\n}\n\n.btn-grey {\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  color: #fff;\n}\n\n.btn-grey:hover {\n  color: #212529;\n  background-color: #99aab3;\n  border-color: #99aab3;\n}\n\n.btn-grey.focus,\n.btn-grey:focus {\n  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);\n}\n\n.btn-grey.disabled,\n.btn-grey:disabled {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-grey:not(:disabled):not(.disabled).active,\n.btn-grey:not(:disabled):not(.disabled):active,\n.show > .btn-grey.dropdown-toggle {\n  color: #212529;\n  background-color: #99aab3;\n  border-color: #99aab3;\n}\n\n.btn-grey:not(:disabled):not(.disabled).active:focus,\n.btn-grey:not(:disabled):not(.disabled):active:focus,\n.show > .btn-grey.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);\n}\n\n.btn-grey:focus,\n.btn-grey:hover {\n  color: #fff;\n}\n\n.btn-blue {\n  color: #fff;\n  background-color: #348fe2;\n  border-color: #348fe2;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-blue:hover {\n  color: #fff;\n  background-color: #1c75c7;\n  border-color: #1c75c7;\n}\n\n.btn-blue.focus,\n.btn-blue:focus {\n  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);\n}\n\n.btn-blue.disabled,\n.btn-blue:disabled {\n  color: #fff;\n  background-color: #348fe2;\n  border-color: #348fe2;\n}\n\n.btn-blue:not(:disabled):not(.disabled).active,\n.btn-blue:not(:disabled):not(.disabled):active,\n.show > .btn-blue.dropdown-toggle {\n  color: #fff;\n  background-color: #1c75c7;\n  border-color: #1c75c7;\n}\n\n.btn-blue:not(:disabled):not(.disabled).active:focus,\n.btn-blue:not(:disabled):not(.disabled):active:focus,\n.show > .btn-blue.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82, 160, 230, 0.5);\n}\n\n.btn-indigo {\n  color: #fff;\n  background-color: #8753de;\n  border-color: #8753de;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-indigo:hover {\n  color: #fff;\n  background-color: #6929d5;\n  border-color: #6929d5;\n}\n\n.btn-indigo.focus,\n.btn-indigo:focus {\n  box-shadow: 0 0 0 0 rgba(153, 109, 227, 0.5);\n}\n\n.btn-indigo.disabled,\n.btn-indigo:disabled {\n  color: #fff;\n  background-color: #8753de;\n  border-color: #8753de;\n}\n\n.btn-indigo:not(:disabled):not(.disabled).active,\n.btn-indigo:not(:disabled):not(.disabled):active,\n.show > .btn-indigo.dropdown-toggle {\n  color: #fff;\n  background-color: #6929d5;\n  border-color: #6929d5;\n}\n\n.btn-indigo:not(:disabled):not(.disabled).active:focus,\n.btn-indigo:not(:disabled):not(.disabled):active:focus,\n.show > .btn-indigo.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(153, 109, 227, 0.5);\n}\n\n.btn-purple {\n  color: #fff;\n  background-color: #727cb6;\n  border-color: #727cb6;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-purple:hover {\n  color: #fff;\n  background-color: #545fa1;\n  border-color: #545fa1;\n}\n\n.btn-purple.focus,\n.btn-purple:focus {\n  box-shadow: 0 0 0 0 rgba(135, 144, 193, 0.5);\n}\n\n.btn-purple.disabled,\n.btn-purple:disabled {\n  color: #fff;\n  background-color: #727cb6;\n  border-color: #727cb6;\n}\n\n.btn-purple:not(:disabled):not(.disabled).active,\n.btn-purple:not(:disabled):not(.disabled):active,\n.show > .btn-purple.dropdown-toggle {\n  color: #fff;\n  background-color: #545fa1;\n  border-color: #545fa1;\n}\n\n.btn-purple:not(:disabled):not(.disabled).active:focus,\n.btn-purple:not(:disabled):not(.disabled):active:focus,\n.show > .btn-purple.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(135, 144, 193, 0.5);\n}\n\n.btn-pink {\n  color: #fff;\n  background-color: #fb5597;\n  border-color: #fb5597;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-pink:hover {\n  color: #fff;\n  background-color: #fa2379;\n  border-color: #fa2379;\n}\n\n.btn-pink.focus,\n.btn-pink:focus {\n  box-shadow: 0 0 0 0 rgba(252, 111, 167, 0.5);\n}\n\n.btn-pink.disabled,\n.btn-pink:disabled {\n  color: #fff;\n  background-color: #fb5597;\n  border-color: #fb5597;\n}\n\n.btn-pink:not(:disabled):not(.disabled).active,\n.btn-pink:not(:disabled):not(.disabled):active,\n.show > .btn-pink.dropdown-toggle {\n  color: #fff;\n  background-color: #fa2379;\n  border-color: #fa2379;\n}\n\n.btn-pink:not(:disabled):not(.disabled).active:focus,\n.btn-pink:not(:disabled):not(.disabled):active:focus,\n.show > .btn-pink.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(252, 111, 167, 0.5);\n}\n\n.btn-red {\n  color: #fff;\n  background-color: #ff5b57;\n  border-color: #ff5b57;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-red:hover {\n  color: #fff;\n  background-color: #ff2924;\n  border-color: #ff2924;\n}\n\n.btn-red.focus,\n.btn-red:focus {\n  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);\n}\n\n.btn-red.disabled,\n.btn-red:disabled {\n  color: #fff;\n  background-color: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.btn-red:not(:disabled):not(.disabled).active,\n.btn-red:not(:disabled):not(.disabled):active,\n.show > .btn-red.dropdown-toggle {\n  color: #fff;\n  background-color: #ff2924;\n  border-color: #ff2924;\n}\n\n.btn-red:not(:disabled):not(.disabled).active:focus,\n.btn-red:not(:disabled):not(.disabled):active:focus,\n.show > .btn-red.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 116, 112, 0.5);\n}\n\n.btn-orange {\n  background-color: #f59c1a;\n  border-color: #f59c1a;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  color: #fff;\n}\n\n.btn-orange:hover {\n  color: #fff;\n  background-color: #d38109;\n  border-color: #d38109;\n}\n\n.btn-orange.focus,\n.btn-orange:focus {\n  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);\n}\n\n.btn-orange.disabled,\n.btn-orange:disabled {\n  color: #212529;\n  background-color: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.btn-orange:not(:disabled):not(.disabled).active,\n.btn-orange:not(:disabled):not(.disabled):active,\n.show > .btn-orange.dropdown-toggle {\n  color: #fff;\n  background-color: #d38109;\n  border-color: #d38109;\n}\n\n.btn-orange:not(:disabled):not(.disabled).active:focus,\n.btn-orange:not(:disabled):not(.disabled):active:focus,\n.show > .btn-orange.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(213, 138, 28, 0.5);\n}\n\n.btn-yellow {\n  color: #212529;\n  background-color: #ffd900;\n  border-color: #ffd900;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-yellow:hover {\n  color: #212529;\n  background-color: #ccae00;\n  border-color: #ccae00;\n}\n\n.btn-yellow.focus,\n.btn-yellow:focus {\n  box-shadow: 0 0 0 0 rgba(222, 190, 6, 0.5);\n}\n\n.btn-yellow.disabled,\n.btn-yellow:disabled {\n  color: #212529;\n  background-color: #ffd900;\n  border-color: #ffd900;\n}\n\n.btn-yellow:not(:disabled):not(.disabled).active,\n.btn-yellow:not(:disabled):not(.disabled):active,\n.show > .btn-yellow.dropdown-toggle {\n  color: #212529;\n  background-color: #ccae00;\n  border-color: #ccae00;\n}\n\n.btn-yellow:not(:disabled):not(.disabled).active:focus,\n.btn-yellow:not(:disabled):not(.disabled):active:focus,\n.show > .btn-yellow.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(222, 190, 6, 0.5);\n}\n\n.btn-green {\n  color: #fff;\n  background-color: #32a932;\n  border-color: #32a932;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-green:hover {\n  color: #fff;\n  background-color: #268226;\n  border-color: #268226;\n}\n\n.btn-green.focus,\n.btn-green:focus {\n  box-shadow: 0 0 0 0 rgba(81, 182, 81, 0.5);\n}\n\n.btn-green.disabled,\n.btn-green:disabled {\n  color: #fff;\n  background-color: #32a932;\n  border-color: #32a932;\n}\n\n.btn-green:not(:disabled):not(.disabled).active,\n.btn-green:not(:disabled):not(.disabled):active,\n.show > .btn-green.dropdown-toggle {\n  color: #fff;\n  background-color: #268226;\n  border-color: #268226;\n}\n\n.btn-green:not(:disabled):not(.disabled).active:focus,\n.btn-green:not(:disabled):not(.disabled):active:focus,\n.show > .btn-green.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(81, 182, 81, 0.5);\n}\n\n.btn-teal {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-teal:hover {\n  color: #fff;\n  background-color: #007979;\n  border-color: #007979;\n}\n\n.btn-teal.focus,\n.btn-teal:focus {\n  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);\n}\n\n.btn-teal.disabled,\n.btn-teal:disabled {\n  color: #fff;\n  background-color: #00acac;\n  border-color: #00acac;\n}\n\n.btn-teal:not(:disabled):not(.disabled).active,\n.btn-teal:not(:disabled):not(.disabled):active,\n.show > .btn-teal.dropdown-toggle {\n  color: #fff;\n  background-color: #007979;\n  border-color: #007979;\n}\n\n.btn-teal:not(:disabled):not(.disabled).active:focus,\n.btn-teal:not(:disabled):not(.disabled):active:focus,\n.show > .btn-teal.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(38, 184, 184, 0.5);\n}\n\n.btn-cyan {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-cyan:hover {\n  color: #fff;\n  background-color: #2b9fc1;\n  border-color: #2b9fc1;\n}\n\n.btn-cyan.focus,\n.btn-cyan:focus {\n  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);\n}\n\n.btn-cyan.disabled,\n.btn-cyan:disabled {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-cyan:not(:disabled):not(.disabled).active,\n.btn-cyan:not(:disabled):not(.disabled):active,\n.show > .btn-cyan.dropdown-toggle {\n  color: #fff;\n  background-color: #2b9fc1;\n  border-color: #2b9fc1;\n}\n\n.btn-cyan:not(:disabled):not(.disabled).active:focus,\n.btn-cyan:not(:disabled):not(.disabled):active:focus,\n.show > .btn-cyan.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);\n}\n\n.btn-white,\n.btn-white:hover {\n  color: #212529;\n  border-color: #d5dbe0;\n}\n\n.btn-white {\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  background-color: #fff;\n}\n\n.btn-white:hover {\n  background-color: #f2f4f5;\n}\n\n.btn-white.focus,\n.btn-white:focus {\n  box-shadow: 0 0 0 0 rgba(186, 191, 196, 0.5);\n}\n\n.btn-white.disabled,\n.btn-white:disabled {\n  color: #212529;\n  background-color: #fff;\n  border-color: #d5dbe0;\n}\n\n.btn-white:not(:disabled):not(.disabled).active,\n.btn-white:not(:disabled):not(.disabled):active,\n.show > .btn-white.dropdown-toggle {\n  color: #212529;\n  background-color: #e4e7ea;\n  border-color: #d5dbe0;\n}\n\n.btn-white:not(:disabled):not(.disabled).active:focus,\n.btn-white:not(:disabled):not(.disabled):active:focus,\n.show > .btn-white.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(186, 191, 196, 0.5);\n}\n\n.btn-gray {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-gray:hover {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #545b62;\n}\n\n.btn-gray.focus,\n.btn-gray:focus {\n  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);\n}\n\n.btn-gray.disabled,\n.btn-gray:disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-gray:not(:disabled):not(.disabled).active,\n.btn-gray:not(:disabled):not(.disabled):active,\n.show > .btn-gray.dropdown-toggle {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #545b62;\n}\n\n.btn-gray:not(:disabled):not(.disabled).active:focus,\n.btn-gray:not(:disabled):not(.disabled):active:focus,\n.show > .btn-gray.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(130, 138, 145, 0.5);\n}\n\n.btn-gray-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-gray-dark:hover {\n  color: #fff;\n  background-color: #1d2124;\n  border-color: #1d2124;\n}\n\n.btn-gray-dark.focus,\n.btn-gray-dark:focus {\n  box-shadow: 0 0 0 0 rgba(82, 88, 93, 0.5);\n}\n\n.btn-gray-dark.disabled,\n.btn-gray-dark:disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-gray-dark:not(:disabled):not(.disabled).active,\n.btn-gray-dark:not(:disabled):not(.disabled):active,\n.show > .btn-gray-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #1d2124;\n  border-color: #1d2124;\n}\n\n.btn-gray-dark:not(:disabled):not(.disabled).active:focus,\n.btn-gray-dark:not(:disabled):not(.disabled):active:focus,\n.show > .btn-gray-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82, 88, 93, 0.5);\n}\n\n.btn-black {\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-black,\n.btn-black:hover {\n  color: #fff;\n  background-color: #000;\n  border-color: #000;\n}\n\n.btn-black.focus,\n.btn-black:focus {\n  box-shadow: 0 0 0 0 rgba(38, 38, 38, 0.5);\n}\n\n.btn-black.disabled,\n.btn-black:disabled {\n  color: #fff;\n  background-color: #000;\n  border-color: #000;\n}\n\n.btn-black:not(:disabled):not(.disabled).active,\n.btn-black:not(:disabled):not(.disabled):active,\n.show > .btn-black.dropdown-toggle {\n  color: #fff;\n  background-color: #000;\n  border-color: #000;\n}\n\n.btn-black:not(:disabled):not(.disabled).active:focus,\n.btn-black:not(:disabled):not(.disabled):active:focus,\n.show > .btn-black.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(38, 38, 38, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-dark:hover {\n  color: #fff;\n  background-color: #171b1f;\n  border-color: #171b1f;\n}\n\n.btn-dark.focus,\n.btn-dark:focus {\n  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);\n}\n\n.btn-dark.disabled,\n.btn-dark:disabled {\n  color: #fff;\n  background-color: #2d353c;\n  border-color: #2d353c;\n}\n\n.btn-dark:not(:disabled):not(.disabled).active,\n.btn-dark:not(:disabled):not(.disabled):active,\n.show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #171b1f;\n  border-color: #171b1f;\n}\n\n.btn-dark:not(:disabled):not(.disabled).active:focus,\n.btn-dark:not(:disabled):not(.disabled):active:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(77, 83, 89, 0.5);\n}\n\n.btn-dark-darker {\n  color: #fff;\n  background-color: #1a2229;\n  border-color: #1a2229;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-dark-darker:hover {\n  color: #fff;\n  background-color: #06080a;\n  border-color: #06080a;\n}\n\n.btn-dark-darker.focus,\n.btn-dark-darker:focus {\n  box-shadow: 0 0 0 0 rgba(60, 67, 73, 0.5);\n}\n\n.btn-dark-darker.disabled,\n.btn-dark-darker:disabled {\n  color: #fff;\n  background-color: #1a2229;\n  border-color: #1a2229;\n}\n\n.btn-dark-darker:not(:disabled):not(.disabled).active,\n.btn-dark-darker:not(:disabled):not(.disabled):active,\n.show > .btn-dark-darker.dropdown-toggle {\n  color: #fff;\n  background-color: #06080a;\n  border-color: #06080a;\n}\n\n.btn-dark-darker:not(:disabled):not(.disabled).active:focus,\n.btn-dark-darker:not(:disabled):not(.disabled):active:focus,\n.show > .btn-dark-darker.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(60, 67, 73, 0.5);\n}\n\n.btn-lime {\n  background-color: #90ca4b;\n  border-color: #90ca4b;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  color: #fff;\n}\n\n.btn-lime:hover {\n  color: #fff;\n  background-color: #76af33;\n  border-color: #76af33;\n}\n\n.btn-lime.focus,\n.btn-lime:focus {\n  box-shadow: 0 0 0 0 rgba(127, 177, 70, 0.5);\n}\n\n.btn-lime.disabled,\n.btn-lime:disabled {\n  color: #212529;\n  background-color: #90ca4b;\n  border-color: #90ca4b;\n}\n\n.btn-lime:not(:disabled):not(.disabled).active,\n.btn-lime:not(:disabled):not(.disabled):active,\n.show > .btn-lime.dropdown-toggle {\n  color: #fff;\n  background-color: #76af33;\n  border-color: #76af33;\n}\n\n.btn-lime:not(:disabled):not(.disabled).active:focus,\n.btn-lime:not(:disabled):not(.disabled):active:focus,\n.show > .btn-lime.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(127, 177, 70, 0.5);\n}\n\n.btn-lime:focus,\n.btn-lime:hover {\n  color: #fff;\n}\n\n.btn-light {\n  color: #212529;\n  background-color: #f2f3f4;\n  border-color: #f2f3f4;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-light:hover {\n  color: #212529;\n  background-color: #d6dadd;\n  border-color: #d6dadd;\n}\n\n.btn-light.focus,\n.btn-light:focus {\n  box-shadow: 0 0 0 0 rgba(211, 212, 214, 0.5);\n}\n\n.btn-light.disabled,\n.btn-light:disabled {\n  color: #212529;\n  background-color: #f2f3f4;\n  border-color: #f2f3f4;\n}\n\n.btn-light:not(:disabled):not(.disabled).active,\n.btn-light:not(:disabled):not(.disabled):active,\n.show > .btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: #d6dadd;\n  border-color: #d6dadd;\n}\n\n.btn-light:not(:disabled):not(.disabled).active:focus,\n.btn-light:not(:disabled):not(.disabled):active:focus,\n.show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(211, 212, 214, 0.5);\n}\n\n.btn-silver {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-silver:hover {\n  color: #212529;\n  background-color: #99aab3;\n  border-color: #99aab3;\n}\n\n.btn-silver.focus,\n.btn-silver:focus {\n  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);\n}\n\n.btn-silver.disabled,\n.btn-silver:disabled {\n  color: #212529;\n  background-color: #b6c2c9;\n  border-color: #b6c2c9;\n}\n\n.btn-silver:not(:disabled):not(.disabled).active,\n.btn-silver:not(:disabled):not(.disabled):active,\n.show > .btn-silver.dropdown-toggle {\n  color: #212529;\n  background-color: #99aab3;\n  border-color: #99aab3;\n}\n\n.btn-silver:not(:disabled):not(.disabled).active:focus,\n.btn-silver:not(:disabled):not(.disabled):active:focus,\n.show > .btn-silver.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(160, 170, 177, 0.5);\n}\n\n.btn-muted {\n  color: #fff;\n  background-color: #627884;\n  border-color: #627884;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n}\n\n.btn-muted:hover {\n  color: #fff;\n  background-color: #4c5d67;\n  border-color: #4c5d67;\n}\n\n.btn-muted.focus,\n.btn-muted:focus {\n  box-shadow: 0 0 0 0 rgba(121, 140, 151, 0.5);\n}\n\n.btn-muted.disabled,\n.btn-muted:disabled {\n  color: #fff;\n  background-color: #627884;\n  border-color: #627884;\n}\n\n.btn-muted:not(:disabled):not(.disabled).active,\n.btn-muted:not(:disabled):not(.disabled):active,\n.show > .btn-muted.dropdown-toggle {\n  color: #fff;\n  background-color: #4c5d67;\n  border-color: #4c5d67;\n}\n\n.btn-muted:not(:disabled):not(.disabled).active:focus,\n.btn-muted:not(:disabled):not(.disabled):active:focus,\n.show > .btn-muted.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(121, 140, 151, 0.5);\n}\n\n.btn-aqua {\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n  -webkit-box-shadow: 0;\n  box-shadow: 0;\n  color: #fff;\n}\n\n.btn-aqua:hover {\n  color: #fff;\n  background-color: #2b9fc1;\n  border-color: #2b9fc1;\n}\n\n.btn-aqua.focus,\n.btn-aqua:focus {\n  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);\n}\n\n.btn-aqua.disabled,\n.btn-aqua:disabled {\n  color: #212529;\n  background-color: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.btn-aqua:not(:disabled):not(.disabled).active,\n.btn-aqua:not(:disabled):not(.disabled):active,\n.show > .btn-aqua.dropdown-toggle {\n  color: #fff;\n  background-color: #2b9fc1;\n  border-color: #2b9fc1;\n}\n\n.btn-aqua:not(:disabled):not(.disabled).active:focus,\n.btn-aqua:not(:disabled):not(.disabled):active:focus,\n.show > .btn-aqua.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(67, 160, 188, 0.5);\n}\n\n.btn-group .btn-default + .btn-default,\n.input-group-append .btn-default + .btn-default,\n.input-group-prepend .btn-default + .btn-default {\n  border-left-color: #d3dadf;\n}\n\n.btn-group .btn-primary + .btn-primary,\n.input-group-append .btn-primary + .btn-primary,\n.input-group-prepend .btn-primary + .btn-primary {\n  border-left-color: #1c75c7;\n}\n\n.btn-group .btn-secondary + .btn-secondary,\n.input-group-append .btn-secondary + .btn-secondary,\n.input-group-prepend .btn-secondary + .btn-secondary {\n  border-left-color: #545b62;\n}\n\n.btn-group .btn-success + .btn-success,\n.input-group-append .btn-success + .btn-success,\n.input-group-prepend .btn-success + .btn-success {\n  border-left-color: #007979;\n}\n\n.btn-group .btn-info + .btn-info,\n.input-group-append .btn-info + .btn-info,\n.input-group-prepend .btn-info + .btn-info {\n  border-left-color: #2b9fc1;\n}\n\n.btn-group .btn-warning + .btn-warning,\n.input-group-append .btn-warning + .btn-warning,\n.input-group-prepend .btn-warning + .btn-warning {\n  border-left-color: #d38109;\n}\n\n.btn-group .btn-danger + .btn-danger,\n.input-group-append .btn-danger + .btn-danger,\n.input-group-prepend .btn-danger + .btn-danger {\n  border-left-color: #ff2924;\n}\n\n.btn-group .btn-inverse + .btn-inverse,\n.input-group-append .btn-inverse + .btn-inverse,\n.input-group-prepend .btn-inverse + .btn-inverse {\n  border-left-color: #171b1f;\n}\n\n.btn-group .btn-grey + .btn-grey,\n.input-group-append .btn-grey + .btn-grey,\n.input-group-prepend .btn-grey + .btn-grey {\n  border-left-color: #99aab3;\n}\n\n.btn-group .btn-blue + .btn-blue,\n.input-group-append .btn-blue + .btn-blue,\n.input-group-prepend .btn-blue + .btn-blue {\n  border-left-color: #1c75c7;\n}\n\n.btn-group .btn-indigo + .btn-indigo,\n.input-group-append .btn-indigo + .btn-indigo,\n.input-group-prepend .btn-indigo + .btn-indigo {\n  border-left-color: #6929d5;\n}\n\n.btn-group .btn-purple + .btn-purple,\n.input-group-append .btn-purple + .btn-purple,\n.input-group-prepend .btn-purple + .btn-purple {\n  border-left-color: #545fa1;\n}\n\n.btn-group .btn-pink + .btn-pink,\n.input-group-append .btn-pink + .btn-pink,\n.input-group-prepend .btn-pink + .btn-pink {\n  border-left-color: #fa2379;\n}\n\n.btn-group .btn-red + .btn-red,\n.input-group-append .btn-red + .btn-red,\n.input-group-prepend .btn-red + .btn-red {\n  border-left-color: #ff2924;\n}\n\n.btn-group .btn-orange + .btn-orange,\n.input-group-append .btn-orange + .btn-orange,\n.input-group-prepend .btn-orange + .btn-orange {\n  border-left-color: #d38109;\n}\n\n.btn-group .btn-yellow + .btn-yellow,\n.input-group-append .btn-yellow + .btn-yellow,\n.input-group-prepend .btn-yellow + .btn-yellow {\n  border-left-color: #ccae00;\n}\n\n.btn-group .btn-green + .btn-green,\n.input-group-append .btn-green + .btn-green,\n.input-group-prepend .btn-green + .btn-green {\n  border-left-color: #268226;\n}\n\n.btn-group .btn-teal + .btn-teal,\n.input-group-append .btn-teal + .btn-teal,\n.input-group-prepend .btn-teal + .btn-teal {\n  border-left-color: #007979;\n}\n\n.btn-group .btn-cyan + .btn-cyan,\n.input-group-append .btn-cyan + .btn-cyan,\n.input-group-prepend .btn-cyan + .btn-cyan {\n  border-left-color: #2b9fc1;\n}\n\n.btn-group .btn-white + .btn-white,\n.input-group-append .btn-white + .btn-white,\n.input-group-prepend .btn-white + .btn-white {\n  border-left-color: #d5dbe0;\n}\n\n.btn-group .btn-gray + .btn-gray,\n.input-group-append .btn-gray + .btn-gray,\n.input-group-prepend .btn-gray + .btn-gray {\n  border-left-color: #545b62;\n}\n\n.btn-group .btn-gray-dark + .btn-gray-dark,\n.input-group-append .btn-gray-dark + .btn-gray-dark,\n.input-group-prepend .btn-gray-dark + .btn-gray-dark {\n  border-left-color: #1d2124;\n}\n\n.btn-group .btn-black + .btn-black,\n.input-group-append .btn-black + .btn-black,\n.input-group-prepend .btn-black + .btn-black {\n  border-left-color: #000;\n}\n\n.btn-group .btn-dark + .btn-dark,\n.input-group-append .btn-dark + .btn-dark,\n.input-group-prepend .btn-dark + .btn-dark {\n  border-left-color: #171b1f;\n}\n\n.btn-group .btn-dark-darker + .btn-dark-darker,\n.input-group-append .btn-dark-darker + .btn-dark-darker,\n.input-group-prepend .btn-dark-darker + .btn-dark-darker {\n  border-left-color: #06080a;\n}\n\n.btn-group .btn-lime + .btn-lime,\n.input-group-append .btn-lime + .btn-lime,\n.input-group-prepend .btn-lime + .btn-lime {\n  border-left-color: #76af33;\n}\n\n.btn-group .btn-light + .btn-light,\n.input-group-append .btn-light + .btn-light,\n.input-group-prepend .btn-light + .btn-light {\n  border-left-color: #d6dadd;\n}\n\n.btn-group .btn-silver + .btn-silver,\n.input-group-append .btn-silver + .btn-silver,\n.input-group-prepend .btn-silver + .btn-silver {\n  border-left-color: #99aab3;\n}\n\n.btn-group .btn-muted + .btn-muted,\n.input-group-append .btn-muted + .btn-muted,\n.input-group-prepend .btn-muted + .btn-muted {\n  border-left-color: #4c5d67;\n}\n\n.btn-group .btn-aqua + .btn-aqua,\n.input-group-append .btn-aqua + .btn-aqua,\n.input-group-prepend .btn-aqua + .btn-aqua {\n  border-left-color: #2b9fc1;\n}\n\n.btn-group > .btn-group:not(:first-child),\n.btn-group > .btn:not(:first-child) {\n  margin-left: 0;\n  margin-right: -1px;\n}\n\n.card .card-header .card-header-tabs {\n  margin-top: -5px;\n}\n\n.card .card-header .card-header-pills {\n  margin-top: -8px;\n  margin-bottom: -8px;\n}\n\n.card > .widget-list .widget-list-item {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid\\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n\n.carousel .carousel-control .fa {\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 30px;\n  height: 30px;\n  margin-top: -15px;\n  text-align: center;\n  line-height: 30px;\n  margin-left: -15px;\n  z-index: 5;\n}\n\n.carousel .carousel-control.left .fa {\n  margin-left: 15px;\n}\n\n.chats {\n  list-style-type: none;\n  margin: 0;\n  padding: 12px 15px 15px;\n}\n\n.chats > div + div,\n.chats > li + li {\n  margin-top: 15px;\n}\n\n.chats .name {\n  color: #2d353c;\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.chats .name .label {\n  font-size: 8px;\n  padding: 1px 4px 2px;\n  margin-left: 3px;\n  position: relative;\n  top: -1px;\n}\n\n.chats .date-time {\n  font-size: 10px;\n  display: block;\n  float: right;\n  color: #6f8293;\n  margin-top: 3px;\n  font-weight: 600;\n}\n\n.chats .image {\n  float: left;\n  width: 60px;\n  height: 60px;\n  overflow: hidden;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.chats .image img,\n.inbox .attached-document > li img {\n  max-width: 100%;\n}\n\n.chats .image + .message {\n  margin-left: 75px;\n}\n\n.chats .message {\n  padding: 7px 12px;\n  font-size: 12px;\n  position: relative;\n  background: #fff;\n  -webkit-border-radius: 12px;\n  border-radius: 12px;\n}\n\n.chats .message:before {\n  content: \"\";\n  position: absolute;\n  left: -13px;\n  top: 15px;\n  border: 7px solid transparent;\n  border-right-color: #fff;\n}\n\n.chats .right .name {\n  text-align: right;\n}\n\n.chats .right .date-time {\n  float: left;\n}\n\n.chats .right .image {\n  float: right;\n}\n\n.chats .right .image + .message {\n  margin-left: 0;\n  margin-right: 75px;\n}\n\n.chats .right .message {\n  text-align: right;\n}\n\n.chats .right .message:before {\n  left: auto;\n  right: -13px;\n  border-right-color: transparent;\n  border-left-color: #fff;\n}\n\n.panel-body .chats,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table tbody tr td,\nbody .datetimepicker.dropdown-menu .datetimepicker-minutes table tbody tr td,\nbody .datetimepicker.dropdown-menu .datetimepicker-months table tbody tr td,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table tbody tr td {\n  padding: 0;\n}\n\n.slimScrollDiv .chats {\n  padding-right: 15px;\n}\n\n.has-success .checkbox.checkbox-css label,\n.has-success.checkbox.checkbox-css label,\n.is-valid .checkbox.checkbox-css label,\n.is-valid.checkbox.checkbox-css label {\n  color: #009393;\n}\n\n.has-success .checkbox.checkbox-css label:before,\n.has-success.checkbox.checkbox-css label:before,\n.is-valid .checkbox.checkbox-css label:before,\n.is-valid.checkbox.checkbox-css label:before {\n  background: rgba(0, 172, 172, 0.5);\n}\n\n.has-error .checkbox.checkbox-css label,\n.has-error.checkbox.checkbox-css label,\n.is-invalid .checkbox.checkbox-css label,\n.is-invalid.checkbox.checkbox-css label {\n  color: #ff423e;\n}\n\n.has-error .checkbox.checkbox-css label:before,\n.has-error.checkbox.checkbox-css label:before,\n.is-invalid .checkbox.checkbox-css label:before,\n.is-invalid.checkbox.checkbox-css label:before {\n  background: rgba(255, 91, 87, 0.5);\n}\n\n.checkbox.checkbox-css {\n  line-height: 16px;\n  padding-top: 7px;\n}\n\n.checkbox.checkbox-css label {\n  padding-left: 24px;\n  margin: 0;\n  position: relative;\n}\n\n.checkbox.checkbox-css label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 16px;\n  height: 16px;\n  background: #d5dbe0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.checkbox.checkbox-css input:checked + label:before {\n  background: #348fe2;\n  border-color: #348fe2;\n}\n\n.checkbox.checkbox-css input:checked + label:after {\n  content: \"\";\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: #fff;\n  height: 16px;\n  width: 16px;\n  text-align: center;\n}\n\n.checkbox.checkbox-css.checkbox-inline {\n  padding-left: 0;\n  display: inline-block;\n}\n\n.checkbox.checkbox-css.checkbox-inline + .checkbox-inline {\n  margin-left: 15px;\n}\n\n.checkbox.checkbox-css.checkbox-success input:checked + label:before {\n  background: #00acac;\n  border-color: #00acac;\n}\n\n.checkbox.checkbox-css.checkbox-lime input:checked + label:before {\n  background: #90ca4b;\n  border-color: #90ca4b;\n}\n\n.checkbox.checkbox-css.checkbox-indigo input:checked + label:before {\n  background: #8753de;\n  border-color: #8753de;\n}\n\n.checkbox.checkbox-css.checkbox-purple input:checked + label:before {\n  background: #727cb6;\n  border-color: #727cb6;\n}\n\n.checkbox.checkbox-css.checkbox-inverse input:checked + label:before {\n  background: #2d353c;\n  border-color: #2d353c;\n}\n\n.checkbox.checkbox-css.checkbox-warning input:checked + label:before {\n  background: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.checkbox.checkbox-css.checkbox-danger input:checked + label:before {\n  background: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.checkbox.checkbox-css.checkbox-info input:checked + label:before {\n  background: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.checkbox.checkbox-css.checkbox-pink input:checked + label:before {\n  background: #fb5597;\n  border-color: #fb5597;\n}\n\n.checkbox.checkbox-css.checkbox-yellow input:checked + label:before {\n  background: #ffd900;\n  border-color: #ffd900;\n}\n\n.close {\n  margin-left: 15px;\n  text-shadow: none;\n  line-height: 14px;\n}\n\n.inverse-mode code,\ncode.inverse-mode {\n  background: #2d353c;\n  color: #fda0c5;\n}\n\n.coming-soon .brand {\n  line-height: 40px;\n  font-size: 28px;\n  font-weight: 300;\n  margin-bottom: 10px;\n  color: #fff;\n  text-align: center;\n}\n\n.coming-soon .brand .logo {\n  border: 25px solid transparent;\n  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);\n  background: #00acac;\n  position: relative;\n  width: 0;\n  height: 0;\n  display: block;\n  margin: 0 auto 15px;\n  vertical-align: middle;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon .brand .logo {\n    border-width: 20px;\n  }\n}\n\n.coming-soon .coming-soon-header {\n  background: url(images/coming-soon.jpg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 100px 50px 50px;\n  position: relative;\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon .coming-soon-header {\n    padding: 50px 25px 25px;\n  }\n}\n\n.coming-soon .coming-soon-header .desc {\n  position: relative;\n  z-index: 10;\n  text-align: center;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.5);\n  letter-spacing: 0.5px;\n  margin-bottom: 50px;\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon .coming-soon-header .desc {\n    font-size: 12px;\n    letter-spacing: 0.25px;\n    margin-bottom: 15px;\n  }\n}\n\n.coming-soon .coming-soon-header .timer {\n  position: relative;\n  z-index: 10;\n  margin-bottom: 0;\n  padding: 10px 0;\n}\n\n.coming-soon .coming-soon-header .timer:after,\n.coming-soon .coming-soon-header .timer:before,\n.inbox .list-email > li.list-group-item:after,\n.inbox .list-email > li.list-group-item:before,\n.pager:after,\n.pager:before,\n.panel .panel-body:after,\n.panel .panel-body:before,\n.profile-content:after,\n.profile-content:before,\n.result-list:after,\n.result-list:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.coming-soon .coming-soon-header .timer .is-countdown {\n  background: 0 0;\n  border: 0;\n  margin: 0 auto;\n  width: 720px;\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon .coming-soon-header .timer .is-countdown {\n    width: 520px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .coming-soon .coming-soon-header .timer .is-countdown {\n    width: 480px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .coming-soon .coming-soon-header .timer .is-countdown {\n    width: auto;\n  }\n}\n\n.coming-soon .coming-soon-header .timer .is-countdown .countdown-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.coming-soon .coming-soon-header .timer .is-countdown .countdown-section {\n  padding: 0 10px;\n  float: none;\n}\n\n.coming-soon\n  .coming-soon-header\n  .timer\n  .is-countdown\n  .countdown-section\n  + .countdown-section {\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.coming-soon\n  .coming-soon-header\n  .timer\n  .is-countdown\n  .countdown-section\n  .countdown-amount {\n  font-size: 36px;\n  color: #fff;\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon\n    .coming-soon-header\n    .timer\n    .is-countdown\n    .countdown-section\n    .countdown-amount {\n    font-size: 24px;\n  }\n}\n\n.coming-soon\n  .coming-soon-header\n  .timer\n  .is-countdown\n  .countdown-section\n  .countdown-period {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon\n    .coming-soon-header\n    .timer\n    .is-countdown\n    .countdown-section\n    .countdown-period {\n    font-size: 12px;\n  }\n}\n\n.coming-soon .coming-soon-header .brand {\n  position: relative;\n  z-index: 10;\n}\n\n.coming-soon .coming-soon-header .bg-cover {\n  background: -moz-linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.5) 0%,\n    rgba(0, 0, 0, 0.75) 100%\n  );\n  background: -webkit-linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.5) 0%,\n    rgba(0, 0, 0, 0.75) 100%\n  );\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.5) 0%,\n    rgba(0, 0, 0, 0.75) 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#bf000000', GradientType=0);\n  position: absolute;\n  right: 0;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.coming-soon .coming-soon-content {\n  color: #2d353c;\n  text-align: center;\n  padding: 25px;\n}\n\n.coming-soon .coming-soon-content .desc {\n  margin-bottom: 25px;\n  font-size: 13px;\n}\n\n.coming-soon .coming-soon-content .input-group {\n  width: 480px;\n  margin: 0 auto 10px;\n}\n\n@media (max-width: 991.98px) {\n  .coming-soon .coming-soon-content .input-group {\n    width: 360px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .coming-soon .coming-soon-content .input-group {\n    width: 300px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .coming-soon .coming-soon-content .input-group {\n    width: auto;\n  }\n}\n\n.dropdown-menu {\n  font-size: 12px;\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n}\n\n.dropdown-item {\n  padding: 5px 15px;\n  font-weight: 600;\n  color: #4e5c68;\n  text-decoration: none;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n  color: #2d353c;\n  background: #f2f4f5;\n}\n\n.error,\n.error .error-code {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.error {\n  margin: 0 auto;\n  text-align: center;\n  height: 100vh;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.error .error-code,\n.error .error-content {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -o-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n.error .error-code {\n  color: #2d353c;\n  font-size: 200px;\n  line-height: 1;\n  text-shadow: 10px 10px 0 rgba(45, 53, 60, 0.2);\n  padding: 30px;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n\n@media (max-width: 767.98px) {\n  .error .error-code {\n    font-size: 160px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .error .error-code {\n    font-size: 120px;\n  }\n}\n\n.error .error-content {\n  top: 50%;\n  bottom: 0;\n  padding: 30px;\n  background: #2d353c;\n  background-image: url(images/error-page-pattern.png);\n}\n\n.error .error-message {\n  color: #fff;\n  font-size: 24px;\n  letter-spacing: 0.5px;\n  margin-bottom: 5px;\n}\n\n.error .error-desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  letter-spacing: 0.5px;\n}\n\n.form-horizontal.form-bordered .form-group {\n  border-bottom: 1px solid #e4e7ea;\n  margin: 0;\n}\n\n.form-horizontal.form-bordered .form-group .col-form-label {\n  padding: 15px;\n  font-weight: 600;\n  color: #4e5c68;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 991.98px) {\n  .form-horizontal.form-bordered .form-group .col-form-label {\n    padding-bottom: 8px;\n  }\n}\n\n.form-horizontal.form-bordered .form-group .col-form-label + div {\n  border-left: 1px solid #e4e7ea;\n}\n\n@media (max-width: 991.98px) {\n  .form-horizontal.form-bordered .form-group .col-form-label + div {\n    border-left: none;\n    padding-top: 0;\n  }\n}\n\n.form-horizontal.form-bordered .form-group > div {\n  padding: 15px;\n}\n\n.form-horizontal.form-bordered .form-group:last-child {\n  border-bottom: 0;\n}\n\n.gallery {\n  margin: -5px;\n}\n\n.gallery .image {\n  width: 25%;\n  display: block;\n  overflow: hidden;\n  padding: 5px;\n}\n\n@media (max-width: 1199.98px) {\n  .gallery .image {\n    width: 33.33%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .gallery .image {\n    width: 50%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .gallery .image {\n    width: 100%;\n  }\n}\n\n.gallery .image a {\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.gallery .image a:focus,\n.gallery .image a:hover {\n  opacity: 0.8;\n}\n\n.gallery .image .img,\n.gallery .image img {\n  width: 100%;\n  height: 200px;\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\n.gallery .image .img {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.gallery .image .image-inner {\n  position: relative;\n  background: #fff;\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\n.gallery .image .image-caption {\n  position: absolute;\n  top: 15px;\n  left: 0;\n  background: rgba(26, 34, 41, 0.75);\n  color: #fff;\n  font-weight: 600;\n  padding: 5px 15px;\n  margin: 0;\n}\n\n.gallery .image .image-info {\n  background: #fff;\n  padding: 15px;\n  color: #4e5c68;\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.gallery .image .image-info .title {\n  margin: 0 0 10px;\n  line-height: 20px;\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #2d353c;\n}\n\n.gallery .image .image-info .rating {\n  line-height: 20px;\n  margin: 0 0 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.gallery .image .image-info .rating span.star {\n  margin-right: 1px;\n}\n\n.gallery .image .image-info .rating span.star:before {\n  content: \"\\f005\";\n  color: #d5dbe0;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.gallery .image .image-info .rating span.star.active:before {\n  color: #f59c1a;\n}\n\n.gallery .image .image-info .desc {\n  line-height: 17px;\n  font-size: 12px;\n  height: 51px;\n  overflow: hidden;\n}\n\n.gallery-option-set {\n  display: block;\n  margin-bottom: -5px;\n}\n\n.gallery-option-set .btn,\n.inbox .email-content .wysihtml5-toolbar > li {\n  margin: 0 5px 5px 0;\n}\n\n.inbox .nav-title {\n  font-size: 11px;\n  color: #9ba8b4;\n  padding: 15px 15px 7px;\n}\n\n.inbox .nav-inbox {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: block;\n}\n\n.inbox .nav-inbox > li + li {\n  margin-top: 0;\n}\n\n.inbox .nav-inbox > li > a {\n  display: block;\n  text-decoration: none;\n  border-radius: 0;\n  padding: 8px 20px;\n  color: #2d353c;\n  font-weight: 600;\n}\n\n.inbox .nav-inbox > li > a i {\n  width: 20px;\n}\n\n.inbox .nav-inbox > li > a .badge {\n  background: #6f8293;\n  color: #fff;\n  padding: 4px 8px;\n  font-size: 10px;\n  line-height: 11px;\n}\n\n.inbox .float-right-link {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.inbox .email-to {\n  position: relative;\n}\n\n.inbox .email-to .form-control,\n.inbox .email-to .tagit {\n  border: 0 !important;\n  border-bottom: 1px solid #d5dbe0 !important;\n  padding: 10px 12px 10px 45px !important;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.inbox .email-to .tagit input {\n  font-weight: 500;\n}\n\n.inbox .email-to .control-label {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  line-height: 16px;\n  padding-left: 10px;\n  width: 45px;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.inbox .email-subject .form-control {\n  border: 0 !important;\n  border-bottom: 1px solid #d5dbe0 !important;\n  padding: 10px 12px !important;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.inbox .email-subject .form-control:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.inbox .email-content {\n  padding: 0;\n  margin: 0;\n}\n\n.inbox .email-content .wysihtml5-toolbar {\n  padding: 10px 0 0;\n}\n\n.inbox .email-content .wysihtml5-toolbar .btn {\n  font-size: 12px;\n  margin-bottom: 5px;\n}\n\n.inbox .email-content .wysihtml5-toolbar .btn-group {\n  margin-bottom: 5px;\n}\n\n.inbox .email-content .wysihtml5-toolbar .btn-group .btn {\n  margin-bottom: 0;\n}\n\n.inbox .email-content .wysihtml5-sandbox {\n  padding: 15px !important;\n  border: 1px solid #d5dbe0 !important;\n  -webkit-border-radius: 0 !important;\n  border-radius: 0 !important;\n}\n\n.inbox .attached-document {\n  list-style-type: none;\n  margin: 15px 0 0;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.inbox .attached-document > li {\n  width: 180px;\n  background: #fff;\n  color: #2d353c;\n  font-weight: 600;\n  position: relative;\n  margin-right: 15px;\n  margin-bottom: 15px;\n  border: 1px solid #d5dbe0;\n}\n\n.inbox .attached-document > li:before {\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  font-size: 12px;\n  background: #d5dbe0;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.inbox .attached-document > li .document-name {\n  padding: 5px 10px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: #f2f3f4;\n  border-top: 1px solid #d5dbe0;\n}\n\n.inbox .attached-document > li .document-name a {\n  color: #2d353c;\n}\n\n.inbox .attached-document > li .document-file {\n  height: 70px;\n  background: 0 0;\n  overflow: hidden;\n  text-align: center;\n  line-height: 70px;\n  font-size: 32px;\n  margin: -1px;\n}\n\n.inbox .list-email {\n  border-bottom: 1px solid #e4e7ea;\n  margin: -1px 0;\n}\n\n.inbox .list-email > li.list-group-item {\n  border: 0;\n  margin-bottom: 0;\n  padding: 15px;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.inbox .list-email,\n.inbox .list-email > li.list-group-item + li.list-group-item {\n  border-top: 1px solid #e4e7ea;\n}\n\n.inbox .list-email > li.list-group-item a {\n  color: #2d353c;\n  text-decoration: none;\n}\n\n.inbox .list-email > li.list-group-item .email-info {\n  max-width: calc(100% - 46px);\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.inbox .list-email > li.list-group-item .email-info > a {\n  margin-top: -15px;\n  margin-right: -15px;\n  margin-bottom: -15px;\n  padding: 15px;\n  max-width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 767.98px) {\n  .inbox .list-email > li.list-group-item .email-info > a {\n    display: block;\n  }\n}\n\n.inbox .list-email > li.list-group-item .email-user {\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  overflow: hidden;\n  font-size: 18px;\n  line-height: 30px;\n  text-align: center;\n  color: #6f8293;\n  background: #c6ced5;\n  margin: -5px 0;\n  -webkit-border-radius: 30px;\n  border-radius: 30px;\n}\n\n.inbox .list-email > li.list-group-item .email-user img,\n.timeline img {\n  max-width: 100%;\n  display: block;\n}\n\n.inbox .list-email > li.list-group-item .email-sender {\n  display: block;\n  width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 1199.98px) {\n  .inbox .list-email > li.list-group-item .email-sender {\n    width: 160px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .inbox .list-email > li.list-group-item .email-sender {\n    width: 120px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .inbox .list-email > li.list-group-item .email-sender {\n    width: auto;\n    font-size: 14px;\n    padding-right: 90px;\n  }\n}\n\n.inbox .list-email > li.list-group-item .email-title {\n  display: block;\n  line-height: 20px;\n  width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (min-width: 768px) {\n  .inbox .list-email > li.list-group-item .email-title {\n    padding-left: 15px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .inbox .list-email > li.list-group-item .email-title {\n    width: auto;\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n  }\n}\n\n@media (min-width: 768px) {\n  .inbox .list-email > li.list-group-item .email-title + .email-desc {\n    padding-left: 20px;\n  }\n\n  .inbox .list-email > li.list-group-item .email-title + .email-desc:before {\n    content: \"\";\n    position: absolute;\n    left: 6px;\n    top: 8px;\n    width: 4px;\n    height: 4px;\n    background: #9ba8b4;\n    -webkit-border-radius: 6px;\n    border-radius: 6px;\n  }\n}\n\n.inbox .list-email > li.list-group-item .email-desc {\n  display: block;\n  position: relative;\n  color: #4e5c68;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n@media (max-width: 1199.98px) {\n  .inbox .list-email > li.list-group-item .email-desc {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .inbox .list-email > li.list-group-item .email-desc {\n    display: block;\n    padding-right: 0;\n  }\n}\n\n.inbox .list-email > li.list-group-item .email-time,\n.input-group-addon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.inbox .list-email > li.list-group-item .email-time {\n  display: block;\n  width: 100px;\n  position: absolute;\n  right: 0;\n  top: 15px;\n  height: 20px;\n  background: #fff;\n  -webkit-box-pack: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  padding: 0 15px 0 0;\n  font-size: 11px;\n  font-weight: 500;\n  color: #6f8293;\n  text-align: right;\n}\n\n@media (max-width: 1199.98px) {\n  .inbox .list-email > li.list-group-item .email-time {\n    width: 90px;\n  }\n}\n\n.inbox .list-email > li.list-group-item .email-checkbox .custom-checkbox {\n  width: 16px;\n  padding-left: 16px;\n}\n\n.inbox\n  .list-email\n  > li.list-group-item\n  .email-checkbox\n  .custom-checkbox\n  .custom-control-label::after,\n.inbox\n  .list-email\n  > li.list-group-item\n  .email-checkbox\n  .custom-checkbox\n  .custom-control-label::before {\n  left: -16px;\n}\n\n.inbox .list-email > li.list-group-item .email-checkbox + .email-user {\n  margin-left: 15px;\n}\n\n.inbox .list-email > li.list-group-item.unread .email-title {\n  font-weight: 600;\n  color: #2d353c;\n}\n\n.inbox .list-email > li.list-group-item.unread .email-sender {\n  font-weight: 600;\n}\n\n.inbox .list-email > li.list-group-item.selected,\n.inbox .list-email > li.list-group-item.selected .email-time {\n  background: #fffceb;\n}\n\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #2d353c;\n  text-align: center;\n  background: #d5dbe0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.input-group-addon:focus,\nbody table.dataTable thead tr th:focus {\n  outline: 0;\n}\n\n.form-control + .input-group-addon {\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n  -webkit-border-bottom-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-prepend .input-group-addon {\n  -webkit-border-top-right-radius: 0;\n  border-top-right-radius: 0;\n  -webkit-border-bottom-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.invoice {\n  background: #fff;\n  padding: 20px;\n}\n\n.invoice > div:not(.invoice-footer) {\n  margin-bottom: 20px;\n}\n\n.invoice .invoice-company {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.invoice .invoice-header {\n  margin: 0 -20px;\n  background: #f2f3f4;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n@media (max-width: 991.98px) {\n  .invoice .invoice-header {\n    display: block;\n  }\n\n  .invoice .invoice-header > div + div {\n    border-top: 1px solid #e6e7e8;\n  }\n}\n\n.invoice .invoice-date,\n.invoice .invoice-from,\n.invoice .invoice-to {\n  padding: 20px;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.invoice .invoice-date .date,\n.invoice .invoice-from strong,\n.invoice .invoice-to strong,\n.label {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.invoice .invoice-date {\n  text-align: right;\n}\n\n@media (max-width: 991.98px) {\n  .invoice .invoice-date {\n    text-align: left;\n  }\n}\n\n.invoice .invoice-price {\n  background: #f2f3f4;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n@media (max-width: 575.98px) {\n  .invoice .invoice-price {\n    display: block;\n  }\n}\n\n.invoice .invoice-price small {\n  font-size: 12px;\n  font-weight: 400;\n  display: block;\n}\n\n.invoice .invoice-price .invoice-price-right {\n  margin-left: auto;\n  padding: 20px;\n  font-size: 28px;\n  font-weight: 300;\n  position: relative;\n  vertical-align: bottom;\n  text-align: right;\n  color: #fff;\n  background: #2d353c;\n  min-width: 25%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.invoice .invoice-price .invoice-price-right small {\n  display: block;\n  opacity: 0.6;\n  position: absolute;\n  top: 15px;\n  left: 20px;\n  font-size: 12px;\n}\n\n.invoice .invoice-price .invoice-price-left {\n  padding: 20px;\n  font-size: 20px;\n  font-weight: 600;\n  position: relative;\n  vertical-align: middle;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.invoice .invoice-price .invoice-price-left .invoice-price-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 575.98px) {\n  .invoice .invoice-price .invoice-price-left .invoice-price-row {\n    display: block;\n    text-align: center;\n  }\n}\n\n.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {\n  padding: 0 20px;\n}\n\n@media (max-width: 991.98px) {\n  .invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {\n    padding: 0;\n  }\n\n  .invoice\n    .invoice-price\n    .invoice-price-left\n    .invoice-price-row\n    .sub-price\n    + .sub-price {\n    padding-left: 20px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .invoice\n    .invoice-price\n    .invoice-price-left\n    .invoice-price-row\n    .sub-price\n    + .sub-price {\n    padding-left: 0;\n  }\n}\n\n.invoice .invoice-footer {\n  border-top: 1px solid #d5dbe0;\n  padding-top: 15px;\n  font-size: 11px;\n  color: #4e5c68;\n}\n\n.invoice .invoice-note {\n  color: #4e5c68;\n  margin-top: 80px;\n  font-size: 11px;\n  line-height: 1.75;\n}\n\n.invoice .table-invoice {\n  font-size: 13px;\n}\n\n@media (max-width: 991.98px) {\n  .invoice .table-invoice {\n    white-space: nowrap;\n  }\n}\n\n.label {\n  display: inline;\n  padding: 3px 6px 4px;\n  font-size: 75%;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.label.label-primary {\n  background: #348fe2;\n}\n\n.label.label-secondary {\n  background: #6c757d;\n}\n\n.label.label-success {\n  background: #00acac;\n}\n\n.label.label-info {\n  background: #49b6d6;\n}\n\n.label.label-warning {\n  background: #f59c1a;\n}\n\n.label.label-danger {\n  background: #ff5b57;\n}\n\n.label.label-light {\n  background: #fff;\n  color: #2d353c;\n}\n\n.label.label-inverse {\n  background: #2d353c;\n}\n\n.label.label-grey,\n.label.label-muted {\n  background: #b6c2c9;\n}\n\n.label.label-blue {\n  background: #348fe2;\n}\n\n.label.label-indigo {\n  background: #8753de;\n}\n\n.label.label-purple {\n  background: #727cb6;\n}\n\n.label.label-pink {\n  background: #fb5597;\n}\n\n.label.label-red {\n  background: #ff5b57;\n}\n\n.label.label-orange {\n  background: #f59c1a;\n}\n\n.label.label-yellow {\n  color: #2d353c;\n  background: #ffd900;\n}\n\n.label.label-green {\n  background: #32a932;\n}\n\n.label.label-teal {\n  background: #00acac;\n}\n\n.label.label-cyan {\n  background: #49b6d6;\n}\n\n.label.label-white {\n  background: #fff;\n}\n\n.label.label-gray {\n  background: #6c757d;\n}\n\n.label.label-gray-dark {\n  background: #343a40;\n}\n\n.label.label-black {\n  background: #000;\n}\n\n.label.label-dark {\n  background: #2d353c;\n}\n\n.label.label-dark-darker,\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse .next-button > a,\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse .prev-button > a {\n  background: #1a2229;\n}\n\n.label.label-lime {\n  background: #90ca4b;\n}\n\n.label.label-light {\n  background: #f2f3f4;\n}\n\n.label.label-silver {\n  background: #b6c2c9;\n}\n\n.label.label-muted {\n  background: #627884;\n}\n\n.label.label-aqua {\n  background: #49b6d6;\n}\n\n.label.label-square {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.label.label-default {\n  background: #e4e7ea;\n  color: #2d353c;\n}\n\n.lead {\n  margin-bottom: 15px;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n\n.list-group-item.list-group-item-inverse {\n  background: #1a2229;\n  border-color: #2d353c;\n  color: #fff;\n}\n\n.list-group-item.list-group-item-inverse .badge-inverse,\n.list-group-item.list-group-item-inverse .label-inverse {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.list-group-item.list-group-item-inverse:focus,\n.list-group-item.list-group-item-inverse:hover {\n  color: #fff;\n  background: #202a32;\n  text-decoration: none;\n}\n\n.login.login-v1,\n.login.login-v1 .login-container .login-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.login.login-v1 {\n  height: 100vh;\n  width: 100%;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 {\n    background: #2d353c;\n  }\n}\n\n.login.login-v1 .login-container {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.login.login-v1 .login-container .login-header {\n  width: 400px;\n  padding: 0;\n  margin: 0 auto 15px;\n  font-weight: 300;\n  position: relative;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-header {\n    width: auto;\n    left: 0;\n    margin: 0;\n    padding: 0 30px;\n  }\n}\n\n.login.login-v1 .login-container .login-header .brand {\n  padding: 0;\n  font-size: 28px;\n  color: #2d353c;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-header .brand {\n    color: #fff;\n    font-size: 24px;\n  }\n}\n\n.login.login-v1 .login-container .login-header .brand .logo {\n  border: 14px solid transparent;\n  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);\n  background-color: #00acac;\n  width: 28px;\n  height: 28px;\n  position: relative;\n  font-size: 0;\n  margin-right: 10px;\n  top: -11px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-header .brand .logo {\n    width: 24px;\n    height: 24px;\n    top: -9px;\n  }\n}\n\n.login.login-v1 .login-container .login-header .brand small {\n  font-size: 14px;\n  display: block;\n  color: #4e5c68;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-header .brand small {\n    font-size: 12px;\n    color: #969a9e;\n  }\n}\n\n.login.login-v1 .login-container .login-header .icon {\n  margin-left: auto;\n  color: rgba(45, 53, 60, 0.15);\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-header .icon {\n    color: rgba(255, 255, 255, 0.15);\n  }\n}\n\n.login.login-v1 .login-container .login-header .icon i {\n  font-size: 64px;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-header .icon i {\n    font-size: 36px;\n  }\n}\n\n.login.login-v1 .login-container .login-body {\n  padding: 30px;\n  background: #2d353c;\n}\n\n.login.login-v1 .login-container .login-body .login-content {\n  padding: 0;\n  color: #c6ced5;\n  width: 400px;\n  margin: 0 auto;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v1 .login-container .login-body .login-content {\n    width: auto;\n  }\n}\n\n.login.login-v1 .login-container .login-body .login-content .form-control {\n  border-color: transparent;\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n}\n\n.login.login-v1\n  .login-container\n  .login-body\n  .login-content\n  .form-control:focus {\n  -webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n}\n\n.login.login-v2 {\n  width: 400px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: 0 0 0 -200px;\n  left: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v2 {\n    position: relative;\n    margin: 0;\n    left: 0;\n    width: auto;\n    padding: 30px 0;\n    height: 100vh;\n  }\n}\n\n.login.login-v2 a {\n  color: #fff;\n}\n\n.login.login-v2 label {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.login.login-v2 .login-header {\n  padding: 0 20px;\n  color: #fff;\n  position: relative;\n}\n\n.login.login-v2 .login-header .brand {\n  padding: 0;\n  font-size: 28px;\n  color: #fff;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v2 .login-header .brand {\n    font-size: 24px;\n  }\n}\n\n.login.login-v2 .login-header .brand .logo,\n.login.login-with-news-feed .right-content .login-header .brand .logo {\n  border: 14px solid transparent;\n  border-color: transparent rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.3);\n  background-color: #00acac;\n  width: 28px;\n  height: 28px;\n  position: relative;\n  font-size: 0;\n  margin-right: 10px;\n  top: -11px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v2 .login-header .brand .logo {\n    width: 24px;\n    height: 24px;\n    border-width: 12px;\n    top: -9px;\n  }\n}\n\n.login.login-v2 .login-header .brand small {\n  font-size: 14px;\n  display: block;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v2 .login-header .brand small {\n    font-size: 12px;\n  }\n}\n\n.login.login-v2 .login-header .icon {\n  position: absolute;\n  right: 20px;\n  top: 0;\n  bottom: 0;\n  color: rgba(255, 255, 255, 0.85);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.login.login-v2 .login-header .icon i,\n.login.login-with-news-feed .right-content .login-header .icon i {\n  font-size: 56px;\n}\n\n@media (max-width: 575.98px) {\n  .login.login-v2 .login-header .icon i {\n    font-size: 36px;\n  }\n}\n\n.login.login-v2 .login-content {\n  padding: 20px;\n  color: #9ba8b4;\n}\n\n.login.login-v2 .login-content .form-control {\n  border: 1px solid transparent;\n}\n\n.login.login-v2 .login-content .form-control:focus {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);\n}\n\n.login.login-with-news-feed {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.login.login-with-news-feed .news-feed {\n  position: fixed;\n  left: 0;\n  right: 500px;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -o-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n@media (max-width: 1199.98px) {\n  .login.login-with-news-feed .news-feed {\n    right: 400px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login.login-with-news-feed .news-feed {\n    position: relative;\n    right: 0;\n    display: none;\n  }\n}\n\n.login.login-with-news-feed .news-feed .news-image {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.login.login-with-news-feed .news-feed .news-caption {\n  color: rgba(255, 255, 255, 0.85);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 60px 60px 30px;\n  font-size: 18px;\n  letter-spacing: 0.25px;\n  z-index: 20;\n  font-weight: 300;\n  background: -moz-linear-gradient(to bottom, transparent 0%, black 100%);\n  background: -webkit-linear-gradient(to bottom, transparent 0%, black 100%);\n  background: linear-gradient(to bottom, transparent 0%, #000 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);\n}\n\n@media (max-width: 1199.98px) {\n  .login.login-with-news-feed .news-feed .news-caption {\n    padding: 45px 45px 30px;\n    font-size: 16px;\n  }\n}\n\n.login.login-with-news-feed .news-feed .news-caption .caption-title {\n  font-weight: 300;\n  color: #fff;\n  font-size: 36px;\n}\n\n@media (max-width: 1199.98px) {\n  .login.login-with-news-feed .news-feed .news-caption .caption-title {\n    font-size: 28px;\n  }\n}\n\n.login.login-with-news-feed .right-content {\n  min-height: 100%;\n  background: #fff;\n  width: 500px;\n  margin-left: auto;\n  padding: 60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n@media (max-width: 1199.98px) {\n  .login.login-with-news-feed .right-content {\n    width: 400px;\n    padding: 45px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login.login-with-news-feed .right-content {\n    width: auto;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .login.login-with-news-feed .right-content {\n    padding: 30px;\n  }\n}\n\n.login.login-with-news-feed .right-content .login-content {\n  width: auto;\n}\n\n.login.login-with-news-feed .right-content .login-header {\n  position: relative;\n}\n\n.login.login-with-news-feed .right-content .login-header + .login-content {\n  padding-top: 30px;\n}\n\n.login.login-with-news-feed .right-content .login-header .brand {\n  padding: 0;\n  font-size: 28px;\n  color: #1a2229;\n}\n\n@media (max-width: 767.98px) {\n  .login.login-with-news-feed .right-content .login-header .brand {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login.login-with-news-feed .right-content .login-header .brand .logo {\n    width: 20px;\n    height: 20px;\n    border-width: 10px;\n    top: -7px;\n  }\n}\n\n.login.login-with-news-feed .right-content .login-header .brand small {\n  font-size: 14px;\n  display: block;\n  color: #557087;\n}\n\n@media (max-width: 1199.98px) {\n  .login.login-with-news-feed .right-content .login-header .brand small {\n    font-size: 12px;\n    line-height: 18px;\n  }\n}\n\n.login.login-with-news-feed .right-content .login-header .icon {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  color: #dae1e8;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 767.98px) {\n  .login.login-with-news-feed .right-content .login-header .icon i {\n    font-size: 36px;\n  }\n}\n\n.login-cover,\n.login-cover .login-cover-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.login-cover {\n  -webkit-transition: background 0.2s linear;\n  -moz-transition: background 0.2s linear;\n  -ms-transition: background 0.2s linear;\n  -o-transition: background 0.2s linear;\n  transition: background 0.2s linear;\n}\n\n.login-cover .login-cover-bg {\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.45) 0%,\n    rgba(0, 0, 0, 0.9)\n  );\n}\n\n.login-bg-list > li a,\n.login-cover .login-cover-bg,\n.login-cover .login-cover-image {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.login-cover .login-cover-image {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.login-bg-list {\n  list-style-type: none;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n  margin: 0;\n  padding: 0 0 0 20px;\n  z-index: 1020;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.login-bg-list > li {\n  width: 66px;\n  height: 66px;\n  overflow: hidden;\n  border: 3px solid transparent;\n  -webkit-border-radius: 66px;\n  border-radius: 66px;\n}\n\n@media (max-width: 575.98px) {\n  .login-bg-list > li {\n    width: 46px;\n    height: 46px;\n  }\n}\n\n.login-bg-list > li a {\n  display: block;\n  height: 60px;\n  overflow: hidden;\n}\n\n.login-bg-list > li img {\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.login-bg-list > li:focus,\n.login-bg-list > li:hover {\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.login-bg-list > li.active {\n  border-color: #fff;\n  z-index: 1020;\n  position: relative;\n}\n\n.map {\n  position: absolute;\n  top: 50px;\n  bottom: 0;\n  left: 220px;\n  right: 0;\n  z-index: 0;\n  overflow: hidden;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -o-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n@media (max-width: 767.98px) {\n  .map {\n    left: 0;\n    top: 101px;\n  }\n}\n\n.map .map-float-table {\n  position: absolute;\n  right: 25px;\n  bottom: 25px;\n  background: rgba(26, 34, 41, 0.8);\n}\n\n.map-content {\n  padding: 0 30px;\n  z-index: 10;\n  position: relative;\n}\n\n.media-list {\n  padding-left: 0;\n  padding-right: 0;\n  list-style: none;\n}\n\n.media-list.media-list-with-divider .media + .media {\n  border-top: 1px solid #d5dbe0;\n  padding-top: 15px;\n}\n\n.dropdown-menu.media-list {\n  max-width: 360px;\n  padding: 0;\n}\n\n.dropdown-menu.media-list .media {\n  border-top: 1px solid #e4e7ea;\n  border-bottom: 1px solid #e4e7ea;\n  margin-top: 0;\n  margin-bottom: -1px;\n}\n\n.dropdown-menu.media-list .media .media-object {\n  height: 48px;\n  width: 48px;\n  line-height: 48px;\n  font-size: 18px;\n  color: #fff;\n  text-align: center;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.dropdown-menu.media-list .media .media-object-icon {\n  position: absolute;\n  margin-left: 30px;\n  border: 2px solid #fff;\n  background: #fff;\n  margin-top: -11px;\n  display: block;\n  width: 22px;\n  height: 22px;\n  text-align: center;\n  font-size: 18px;\n  line-height: 18px;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.dropdown-menu.media-list .media .media-left {\n  padding-right: 12px;\n}\n\n.dropdown-menu.media-list .media .media-right {\n  padding-left: 12px;\n}\n\n.dropdown-menu.media-list .media .media-heading {\n  color: #2d353c;\n  margin-bottom: 0;\n  font-size: 12.5px;\n  line-height: 18px;\n}\n\n.dropdown-menu.media-list .media p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-bottom: 5px;\n  line-height: 14px;\n  max-width: 270px;\n  color: #4e5c68;\n  font-size: 11px;\n}\n\n.dropdown-menu.media-list .dropdown-header {\n  font-weight: 700;\n  color: #2d353c;\n  font-size: 10px;\n  background: #f2f3f4;\n  padding: 10px 15px;\n}\n\n.dropdown-menu.media-list .dropdown-footer,\n.dropdown-menu.media-list .dropdown-item {\n  padding: 10px 15px;\n}\n\n.media-messaging .media {\n  padding: 15px;\n}\n\n.media-messaging .media + .media {\n  margin-top: 0;\n  padding-top: 15px;\n}\n\n.media-messaging .media:first-child {\n  padding-top: 0;\n}\n\n.media-messaging .media:last-child {\n  padding-bottom: 0;\n}\n\n.media,\nbody div.dt-autofill-list ul > li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.media + .media,\n.timeline .timeline-body > div + div {\n  margin-top: 15px;\n}\n\n.media .media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n.media .media-object {\n  width: 128px;\n}\n\n.media.media-lg .media-object {\n  width: 256px;\n}\n\n.media.media-sm .media-object {\n  width: 64px;\n}\n\n.media.media-xs .media-object {\n  width: 32px;\n}\n\n.media > .media-left,\n.media > .pull-left {\n  padding-right: 15px;\n}\n\n.media > .media-right,\n.media > .pull-right {\n  padding-left: 15px;\n}\n\n.modal .modal-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.modal.modal-message .modal-dialog {\n  width: 100%;\n  max-width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.modal.modal-message .modal-content {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.modal.modal-message .modal-body,\n.modal.modal-message .modal-footer,\n.modal.modal-message .modal-header {\n  width: 60%;\n  border: 0;\n  margin: 0 auto;\n}\n\n@media (max-width: 767.98px) {\n  .modal.modal-message .modal-body,\n  .modal.modal-message .modal-footer,\n  .modal.modal-message .modal-header {\n    width: 90%;\n  }\n}\n\n.nav.nav-pills .nav-item .nav-link,\n.nav.nav-tabs .nav-item .nav-link {\n  padding: 10px 15px;\n  font-weight: 600;\n  color: #6f8293;\n}\n\n.nav.nav-tabs .nav-item .nav-link.active,\n.nav.nav-tabs .nav-item .nav-link:focus,\n.nav.nav-tabs .nav-item .nav-link:hover {\n  color: #2d353c;\n}\n\n.nav.nav-tabs.nav-tabs-inverse {\n  background: #1a2229;\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\n.nav.nav-tabs.nav-tabs-inverse .nav-item .nav-link {\n  color: #c6ced5;\n}\n\n.nav.nav-tabs.nav-tabs-inverse .nav-item .nav-link.active {\n  color: #2d353c;\n}\n\n.nav.nav-tabs + .tab-content {\n  padding: 15px;\n  background: #fff;\n  margin-bottom: 20px;\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.bootstrap-calendar .calendar .table.header td .icon-arrow-left:focus,\n.bootstrap-calendar .calendar .table.header td .icon-arrow-left:hover,\n.bootstrap-calendar .calendar .table.header td .icon-arrow-right:focus,\n.bootstrap-calendar .calendar .table.header td .icon-arrow-right:hover,\n.nav.nav-pills .nav-item .nav-link:focus,\n.nav.nav-pills .nav-item .nav-link:hover,\nbody\n  .datepicker\n  .datepicker-centuries\n  table\n  thead\n  tr\n  th.datepicker-switch:focus:before,\nbody\n  .datepicker\n  .datepicker-centuries\n  table\n  thead\n  tr\n  th.datepicker-switch:hover:before,\nbody .datepicker .datepicker-centuries table thead tr th.next:focus:before,\nbody .datepicker .datepicker-centuries table thead tr th.next:hover:before,\nbody .datepicker .datepicker-centuries table thead tr th.prev:focus:before,\nbody .datepicker .datepicker-centuries table thead tr th.prev:hover:before,\nbody\n  .datepicker\n  .datepicker-days\n  table\n  thead\n  tr\n  th.datepicker-switch:focus:before,\nbody\n  .datepicker\n  .datepicker-days\n  table\n  thead\n  tr\n  th.datepicker-switch:hover:before,\nbody .datepicker .datepicker-days table thead tr th.next:focus:before,\nbody .datepicker .datepicker-days table thead tr th.next:hover:before,\nbody .datepicker .datepicker-days table thead tr th.prev:focus:before,\nbody .datepicker .datepicker-days table thead tr th.prev:hover:before,\nbody\n  .datepicker\n  .datepicker-decades\n  table\n  thead\n  tr\n  th.datepicker-switch:focus:before,\nbody\n  .datepicker\n  .datepicker-decades\n  table\n  thead\n  tr\n  th.datepicker-switch:hover:before,\nbody .datepicker .datepicker-decades table thead tr th.next:focus:before,\nbody .datepicker .datepicker-decades table thead tr th.next:hover:before,\nbody .datepicker .datepicker-decades table thead tr th.prev:focus:before,\nbody .datepicker .datepicker-decades table thead tr th.prev:hover:before,\nbody\n  .datepicker\n  .datepicker-months\n  table\n  thead\n  tr\n  th.datepicker-switch:focus:before,\nbody\n  .datepicker\n  .datepicker-months\n  table\n  thead\n  tr\n  th.datepicker-switch:hover:before,\nbody .datepicker .datepicker-months table thead tr th.next:focus:before,\nbody .datepicker .datepicker-months table thead tr th.next:hover:before,\nbody .datepicker .datepicker-months table thead tr th.prev:focus:before,\nbody .datepicker .datepicker-months table thead tr th.prev:hover:before,\nbody\n  .datepicker\n  .datepicker-years\n  table\n  thead\n  tr\n  th.datepicker-switch:focus:before,\nbody\n  .datepicker\n  .datepicker-years\n  table\n  thead\n  tr\n  th.datepicker-switch:hover:before,\nbody .datepicker .datepicker-years table thead tr th.next:focus:before,\nbody .datepicker .datepicker-years table thead tr th.next:hover:before,\nbody .datepicker .datepicker-years table thead tr th.prev:focus:before,\nbody .datepicker .datepicker-years table thead tr th.prev:hover:before {\n  color: #2d353c;\n}\n\n.nav.nav-pills .nav-item .nav-link.active {\n  color: #fff;\n}\n\n.note,\n.note .note-content {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.note,\n.note .note-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.note {\n  margin-bottom: 20px;\n  border-left: 3px solid;\n  position: relative;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.note .note-icon {\n  width: 80px;\n  font-size: 56px;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.note .note-content {\n  padding: 15px;\n}\n\n.note .note-content h1,\n.note .note-content h2,\n.note .note-content h3,\n.note .note-content h4,\n.note .note-content h5,\n.note .note-content h6 {\n  color: inherit;\n}\n\n.note.note-with-right-icon {\n  border-left: none;\n  border-right: 3px solid;\n}\n\n.note.note-primary {\n  background: #61a8e8;\n  color: #10416d;\n}\n\n.note.note-secondary {\n  border-color: #6c757d;\n  background: #868e96;\n  color: #25282b;\n}\n\n.note.note-success {\n  border-color: #00acac;\n  background: #00dfdf;\n  color: #001313;\n}\n\n.note.note-info {\n  border-color: #49b6d6;\n  background: #73c7df;\n  color: #195a6d;\n}\n\n.note.note-warning {\n  border-color: #f59c1a;\n  background: #f7b14b;\n  color: #714505;\n}\n\n.note.note-danger {\n  border-color: #ff5b57;\n  background: #ff8d8a;\n  color: #bd0500;\n}\n\n.note.note-light {\n  color: #2d353c;\n}\n\n.pager > li > a,\n.pager > li > span,\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse > li > a.active {\n  background: #fff;\n  color: #2d353c;\n}\n\n.note.note-dark,\n.note.note-inverse {\n  background: #434f59;\n  color: #000;\n}\n\n.note.note-inverse {\n  border-color: #2d353c;\n}\n\n.note.note-black {\n  background: #1a1a1a;\n  color: #000;\n}\n\n.note.note-white {\n  color: #b3b3b3;\n}\n\n.note.note-grey {\n  border-color: #b6c2c9;\n}\n\n.note.note-grey,\n.note.note-muted,\n.note.note-silver {\n  background: #d3dadf;\n  color: #627884;\n}\n\n.note.note-lime {\n  background: #a8d672;\n  color: #41601c;\n}\n\n.note.note-aqua {\n  background: #73c7df;\n  color: #195a6d;\n}\n\n.note.note-blue {\n  border-color: #348fe2;\n  background: #77b4ec;\n}\n\n.note.note-indigo {\n  border-color: #8753de;\n  background: #b493ea;\n}\n\n.note.note-purple {\n  border-color: #727cb6;\n  background: #a4abd0;\n}\n\n.note.note-pink {\n  border-color: #fb5597;\n  background: #fda0c5;\n}\n\n.note.note-red {\n  border-color: #ff5b57;\n  background: #ffa6a4;\n}\n\n.note.note-orange {\n  border-color: #f59c1a;\n  background: #f8bc63;\n}\n\n.note.note-yellow {\n  border-color: #ffd900;\n  background: #ffe44d;\n}\n\n.note.note-green {\n  border-color: #32a932;\n  background: #59ce59;\n}\n\n.note.note-teal {\n  border-color: #00acac;\n  background: #00f9f9;\n}\n\n.note.note-cyan {\n  border-color: #49b6d6;\n  background: #87cfe4;\n}\n\n.note.note-white {\n  border-color: #fff;\n  background: #fff;\n}\n\n.note.note-gray {\n  border-color: #6c757d;\n  background: #939ba2;\n}\n\n.note.note-gray-dark {\n  border-color: #343a40;\n  background: #56606a;\n}\n\n.note.note-black {\n  border-color: #000;\n  background: #262626;\n}\n\n.note.note-dark {\n  border-color: #2d353c;\n  background: #4e5c68;\n}\n\n.note.note-dark-darker {\n  border-color: #1a2229;\n  background: #384958;\n}\n\n.note.note-lime {\n  border-color: #90ca4b;\n  background: #b4db86;\n}\n\n.note.note-light {\n  border-color: #f2f3f4;\n  background: #fff;\n}\n\n.note.note-silver {\n  border-color: #b6c2c9;\n  background: #e2e7ea;\n}\n\n.note.note-muted {\n  border-color: #627884;\n  background: #8a9da8;\n}\n\n.note.note-aqua {\n  border-color: #49b6d6;\n  background: #87cfe4;\n}\n\n.page-header {\n  font-size: 24px;\n  margin: 0 0 15px;\n  padding: 0;\n  border: 0;\n  line-height: 32px;\n  font-weight: 500;\n}\n\n.page-header small {\n  line-height: 20px;\n}\n\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  text-align: center;\n  list-style: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.pager > li + li,\n.pagination .page-item + .page-item,\n.panel .panel-heading .panel-heading-btn > a + a,\n.result-list > li .result-info .btn-row a + a,\n.theme-panel .theme-list > li + li {\n  margin-left: 5px;\n}\n\n.pager > li > a,\n.pager > li > span {\n  display: block;\n  padding: 5px 14px;\n  border: 1px solid #d5dbe0;\n  text-decoration: none;\n  font-weight: 600;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.pager > li.previous {\n  margin-right: auto;\n}\n\n.pager > li.next {\n  margin-left: auto;\n}\n\n.pager > li.disabled > a,\n.pager > li.disabled > span {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pager.pager-without-border > li > a,\n.pager.pager-without-border > li > span {\n  border: 0;\n}\n\n.pagination .page-item .page-link {\n  font-weight: 600;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.pagination.pagination-lg .page-item .page-link {\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.pagination.pagination-sm .page-item .page-link,\n.panel {\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.panel {\n  margin-bottom: 20px;\n  background: #fff;\n  border: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n  margin-bottom: 0;\n}\n\n.panel > .form-control + .panel-footer,\n.panel > .table-bordered > thead > tr > th,\n.panel > .table-responsive > .table-bordered > thead > tr > th {\n  border-top: none;\n}\n\n.panel > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-bordered > thead > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:first-child {\n  border-left: none;\n}\n\n.panel > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-bordered > thead > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:last-child {\n  border-right: none;\n}\n\n.panel > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n.panel > .form-control {\n  border-right: 0;\n  border-left: 0;\n  padding: 15px;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.panel > .alert,\n.panel > .note {\n  margin: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.panel > .list-group,\n.panel > .tab-content,\n.panel > .table {\n  margin-bottom: 0;\n}\n\n.panel > .tab-content {\n  -webkit-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n\n.panel > .list-group:last-child .list-group-item {\n  border-width: 1px 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.panel > .list-group:last-child .list-group-item:last-child {\n  border-bottom: 0;\n  -webkit-border-bottom-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-border-bottom-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.panel > .widget-list .widget-list-item {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.panel > .table-responsive > .table > tbody > tr > td:first-child,\n.panel > .table-responsive > .table > tbody > tr > th:first-child,\n.panel > .table-responsive > .table > thead > tr > td:first-child,\n.panel > .table-responsive > .table > thead > tr > th:first-child,\n.panel > .table > tbody > tr > td:first-child,\n.panel > .table > tbody > tr > th:first-child,\n.panel > .table > thead > tr > td:first-child,\n.panel > .table > thead > tr > th:first-child,\n.widget-list .widget-list-item > div:first-child {\n  padding-left: 15px;\n}\n\n.panel > .table-responsive > .table > tbody > tr > td:last-child,\n.panel > .table-responsive > .table > tbody > tr > th:last-child,\n.panel > .table-responsive > .table > thead > tr > td:last-child,\n.panel > .table-responsive > .table > thead > tr > th:last-child,\n.panel > .table > tbody > tr > td:last-child,\n.panel > .table > tbody > tr > th:last-child,\n.panel > .table > thead > tr > td:last-child,\n.panel > .table > thead > tr > th:last-child,\n.widget-list .widget-list-item > div:last-child {\n  padding-right: 15px;\n}\n\n.panel .panel-heading {\n  padding: 10px 15px;\n  border: 0;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-border-top-left-radius: 3px;\n  border-top-left-radius: 3px;\n  -webkit-border-top-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.panel .panel-heading .panel-title {\n  line-height: 20px;\n  font-size: 12px;\n  margin-top: 0;\n  margin-bottom: 0;\n  color: inherit;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.panel .panel-heading .panel-title > a {\n  color: inherit;\n  display: block;\n}\n\n.panel .panel-heading .panel-title .pull-right {\n  line-height: 20px;\n}\n\n.panel .panel-heading,\n.panel .panel-heading .panel-heading-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.panel .panel-heading .panel-heading-btn .btn-icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.panel .panel-heading .btn-group .btn {\n  margin-top: -7px;\n  margin-bottom: -7px;\n}\n\n.panel .panel-heading .btn-group .btn-group-sm > .btn,\n.panel .panel-heading .btn-group .btn.btn-sm {\n  margin-top: -5px;\n  margin-bottom: -5px;\n}\n\n.panel .panel-heading .btn-group .btn.btn-xs {\n  margin-top: -1px;\n  margin-bottom: -1px;\n}\n\n.panel .panel-heading .progress {\n  min-width: 120px;\n}\n\n.panel .panel-body {\n  padding: 15px;\n}\n\n.panel .panel-body.no-padding,\n.panel .panel-body.panel-form,\n.panel .panel-body.panel-full-width,\n.panel .panel-body.panel-table {\n  padding: 0 !important;\n}\n\n.panel .panel-body.no-border {\n  border: 0 !important;\n}\n\n.panel .panel-body[class^=\"bg-\"] {\n  -webkit-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n\n.panel .panel-footer,\n.panel .panel-toolbar {\n  padding: 10px 15px;\n  background: #fff;\n}\n\n.panel .panel-footer {\n  border-top: 1px solid #d5dbe0;\n  -webkit-border-bottom-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-border-bottom-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.panel [class^=\"col-\"].ui-sortable {\n  min-height: 0;\n}\n\n.panel.panel-default > .panel-heading {\n  background: #f2f4f5;\n  color: #4e5c68;\n}\n\n.panel.panel-inverse > .panel-heading {\n  background: #1d2226;\n  color: #fff;\n}\n\n.panel.panel-success > .panel-heading {\n  background: #008686;\n  color: #fff;\n}\n\n.panel.panel-warning > .panel-heading {\n  background: #df880a;\n  color: #fff;\n}\n\n.panel.panel-danger > .panel-heading {\n  background: #ff3631;\n  color: #fff;\n}\n\n.panel.panel-primary > .panel-heading {\n  background: #1e7cd2;\n  color: #fff;\n}\n\n.panel.panel-info > .panel-heading {\n  background: #2ea7cb;\n  color: #fff;\n}\n\n.panel.panel-loading .panel-body {\n  position: relative;\n  z-index: 0;\n}\n\n.panel.panel-loading .panel-body .panel-loader {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #fff;\n  opacity: 0.9;\n  z-index: 10;\n  -webkit-animation: fadeIn 0.2s;\n  -moz-animation: fadeIn 0.2s;\n  -ms-animation: fadeIn 0.2s;\n  -o-animation: fadeIn 0.2s;\n  animation: fadeIn 0.2s;\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.panel.panel-expand {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n  overflow: hidden;\n  z-index: 1080;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.panel.panel-expand,\n.panel.panel-expand > .panel-body,\n.panel.panel-expand > .panel-footer,\n.panel.panel-expand > .panel-heading {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.panel.panel-expand > .panel-body {\n  overflow-x: scroll;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.panel.panel-expand > .panel-body > .slimScrollDiv {\n  height: 100% !important;\n}\n\n.panel.panel-expand\n  > .panel-body\n  > .slimScrollDiv\n  > div:not(.slimScrollBar):not(.slimScrollRail) {\n  height: 100% !important;\n}\n\n.panel.panel-expand > .panel-heading {\n  -webkit-box-flex: 0;\n  -ms-flex: 0;\n  flex: 0;\n}\n\n.panel.panel-expand > .panel-heading .fa-expand:before {\n  content: \"\\f066\";\n}\n\n.panel.panel-hover-icon .panel-heading .panel-heading-btn .btn i {\n  visibility: hidden;\n}\n\n.panel.panel-hover-icon .panel-heading:focus .panel-heading-btn .btn i,\n.panel.panel-hover-icon .panel-heading:hover .panel-heading-btn .btn i {\n  visibility: visible;\n}\n\n.panel.panel-no-rounded-corner .panel-body,\n.panel.panel-no-rounded-corner .panel-footer,\n.panel.panel-no-rounded-corner .panel-header {\n  -webkit-border-radius: 0 !important;\n  border-radius: 0 !important;\n}\n\n.panel.panel-with-tabs .panel-heading {\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.panel.panel-with-tabs .panel-heading > .nav-tabs {\n  margin-top: -5px;\n  margin-bottom: -11px;\n  border-bottom: none;\n}\n\n.panel.panel-with-tabs .panel-heading > .nav-tabs .nav-item .nav-link {\n  border: 0;\n  margin: 0;\n}\n\n.panel-group .panel {\n  margin-bottom: 0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n\n.panel-expand .header,\n.panel-expand .sidebar,\n.panel-expand .sidebar-bg,\n.panel-expand .top-menu {\n  z-index: 0;\n}\n\n.panel-expand .content .row [class^=\"col-\"] {\n  position: inherit;\n}\n\n.panel-expand .content .panel-expand .row > [class^=\"col-\"],\n.profile-header {\n  position: relative;\n}\n\n.panel-expand .vertical-box .vertical-box-column {\n  display: table-cell;\n}\n\n.panel-expand .page-content-full-height .content {\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n\n.mission-list {\n  margin-bottom: 15px;\n}\n\n.profile-header {\n  overflow: hidden;\n}\n\n.profile-header .profile-header-cover {\n  background-image: url(images/profile-cover.jpg);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.profile-header .profile-header-cover:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, transparent 0%, #000 100%);\n}\n\n.profile-header .profile-header-content {\n  color: #fff;\n  padding: 30px;\n  position: relative;\n}\n\n@media (max-width: 991.98px) {\n  .profile-header .profile-header-content {\n    padding: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n}\n\n.profile-header .profile-header-img {\n  float: left;\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  position: relative;\n  z-index: 10;\n  margin: -10px 0 -20px;\n  padding: 3px;\n  background: #fff;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n@media (max-width: 991.98px) {\n  .profile-header .profile-header-img {\n    margin: 0;\n    width: 80px;\n    height: 80px;\n  }\n}\n\n.profile-header .profile-header-img + .profile-header-info {\n  margin-left: 140px;\n}\n\n@media (max-width: 991.98px) {\n  .profile-header .profile-header-img + .profile-header-info {\n    margin-left: 20px;\n  }\n}\n\n.profile-header .profile-header-img img {\n  max-width: 100%;\n}\n\n.profile-header .profile-header-info h4 {\n  font-weight: 600;\n  color: #fff;\n}\n\n.profile-header .profile-header-tab {\n  position: relative;\n  background: #fff;\n  list-style-type: none;\n  margin: -10px 0 0;\n  padding: 0 0 0 150px;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n@media (max-width: 991.98px) {\n  .profile-header .profile-header-tab {\n    padding: 0;\n    margin: 0;\n    overflow: scroll;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n\n.profile-header .profile-header-tab .nav-item {\n  display: inline-block;\n  margin: 0;\n}\n\n.profile-header .profile-header-tab .nav-item .nav-link {\n  display: block;\n  color: #6f8293;\n  line-height: 20px;\n  padding: 10px 20px;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 12px;\n  border: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.profile-header .profile-header-tab .nav-item .nav-link:focus,\n.profile-header .profile-header-tab .nav-item .nav-link:hover {\n  background: 0 0;\n  color: #4e5c68;\n}\n\n.profile-header .profile-header-tab .nav-item .nav-link.active {\n  color: #2d353c;\n  background: 0 0;\n}\n\n.profile-content {\n  padding: 25px;\n}\n\n.profile-content .tab-content,\n.profile-content .tab-pane {\n  background: 0 0;\n}\n\n.profile-content .table.table-profile > thead > tr > th {\n  border: 0;\n  border-bottom: none !important;\n  color: #2d353c;\n  background: 0 0;\n}\n\n.profile-content .table.table-profile > thead > tr > th h4 {\n  font-size: 20px;\n  margin-top: 0;\n}\n\n.profile-content .table.table-profile > thead > tr > th h4 small {\n  display: block;\n  font-size: 12px;\n  font-weight: 400;\n  margin-top: 5px;\n}\n\n.profile-content .table.table-profile tbody > tr td {\n  border: 0;\n  color: #2d353c;\n  background: 0 0;\n}\n\n.profile-content .table.table-profile tbody > tr td .form-control {\n  border-color: #c8cfd6;\n}\n\n.profile-content .table.table-profile tbody > tr td .form-control:focus {\n  border-color: #5db0ff;\n}\n\n.profile-content .table.table-profile tbody > tr td.field {\n  width: 20%;\n  text-align: right;\n  font-weight: 600;\n  color: #2d353c;\n}\n\n@media (max-width: 991.98px) {\n  .profile-content .table.table-profile tbody > tr td.field {\n    width: 35%;\n  }\n}\n\n.profile-content .table.table-profile tbody > tr.highlight > td {\n  border-top: 1px solid #c8cfd6;\n  border-bottom: 1px solid #c8cfd6;\n}\n\n.profile-content .table.table-profile tbody > tr.divider > td {\n  padding: 0 !important;\n  height: 10px;\n}\n\n.progress .progress-bar {\n  font-weight: 600;\n}\n\n.progress.progress-xs {\n  height: 5px;\n}\n\n.progress.progress-xs .progress-bar {\n  line-height: 5px;\n}\n\n.progress.progress-sm {\n  height: 10px;\n}\n\n.progress.progress-sm .progress-bar {\n  line-height: 10px;\n}\n\n.progress.progress-lg {\n  height: 30px;\n}\n\n.progress.progress-lg .progress-bar {\n  line-height: 30px;\n}\n\n.has-success .radio.radio-css label,\n.has-success.radio.radio-css label,\n.is-valid .radio.radio-css label,\n.is-valid.radio.radio-css label {\n  color: #009393;\n}\n\n.has-success .radio.radio-css label:before,\n.has-success.radio.radio-css label:before,\n.is-valid .radio.radio-css label:before,\n.is-valid.radio.radio-css label:before {\n  background: rgba(0, 172, 172, 0.5);\n}\n\n.has-error .radio.radio-css label,\n.has-error.radio.radio-css label,\n.is-invalid .radio.radio-css label,\n.is-invalid.radio.radio-css label {\n  color: #ff423e;\n}\n\n.has-error .radio.radio-css label:before,\n.has-error.radio.radio-css label:before,\n.is-invalid .radio.radio-css label:before,\n.is-invalid.radio.radio-css label:before {\n  background: rgba(255, 91, 87, 0.5);\n}\n\n.radio.radio-css {\n  position: relative;\n  line-height: 16px;\n  padding-top: 7px;\n}\n\n.radio.radio-css label {\n  padding-left: 24px;\n  margin: 0;\n  position: relative;\n}\n\n.radio.radio-css label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 16px;\n  height: 16px;\n  background: #d5dbe0;\n  -webkit-border-radius: 16px;\n  border-radius: 16px;\n}\n\n.radio.radio-css input:checked + label:before {\n  background: #348fe2;\n  border-color: #348fe2;\n}\n\n.radio.radio-css input:checked + label:after {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  width: 6px;\n  height: 6px;\n  background: #fff;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.radio.radio-css.radio-inline {\n  padding-left: 0;\n  display: inline-block;\n}\n\n.radio.radio-css.radio-inline + .radio-inline {\n  margin-left: 15px;\n}\n\n.radio.radio-css.radio-success input:checked + label:before,\n.switcher.switcher-success input:checked + label:before {\n  background: #00acac;\n  border-color: #00acac;\n}\n\n.radio.radio-css.radio-lime input:checked + label:before,\n.switcher.switcher-lime input:checked + label:before {\n  background: #90ca4b;\n  border-color: #90ca4b;\n}\n\n.radio.radio-css.radio-indigo input:checked + label:before,\n.switcher.switcher-indigo input:checked + label:before {\n  background: #8753de;\n  border-color: #8753de;\n}\n\n.radio.radio-css.radio-purple input:checked + label:before,\n.switcher.switcher-purple input:checked + label:before {\n  background: #727cb6;\n  border-color: #727cb6;\n}\n\n.radio.radio-css.radio-inverse input:checked + label:before,\n.switcher.switcher-inverse input:checked + label:before {\n  background: #2d353c;\n  border-color: #2d353c;\n}\n\n.radio.radio-css.radio-warning input:checked + label:before,\n.switcher.switcher-warning input:checked + label:before {\n  background: #f59c1a;\n  border-color: #f59c1a;\n}\n\n.radio.radio-css.radio-danger input:checked + label:before,\n.switcher.switcher-danger input:checked + label:before {\n  background: #ff5b57;\n  border-color: #ff5b57;\n}\n\n.radio.radio-css.radio-info input:checked + label:before,\n.switcher.switcher-info input:checked + label:before {\n  background: #49b6d6;\n  border-color: #49b6d6;\n}\n\n.radio.radio-css.radio-pink input:checked + label:before,\n.switcher.switcher-pink input:checked + label:before {\n  background: #fb5597;\n  border-color: #fb5597;\n}\n\n.radio.radio-css.radio-yellow input:checked + label:before,\n.switcher.switcher-yellow input:checked + label:before {\n  background: #ffd900;\n  border-color: #ffd900;\n}\n\n.register.register-with-news-feed {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.register.register-with-news-feed .news-feed {\n  position: fixed;\n  left: 0;\n  right: 500px;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -o-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n@media (max-width: 1199.98px) {\n  .register.register-with-news-feed .news-feed {\n    right: 400px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .register.register-with-news-feed .news-feed {\n    position: relative;\n    right: 0;\n    display: none;\n  }\n}\n\n.register.register-with-news-feed .news-feed .news-image {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.register.register-with-news-feed .news-feed .news-caption {\n  color: rgba(255, 255, 255, 0.85);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 60px 60px 30px;\n  font-size: 18px;\n  letter-spacing: 0.25px;\n  z-index: 20;\n  font-weight: 300;\n  background: -moz-linear-gradient(to bottom, transparent 0%, black 100%);\n  background: -webkit-linear-gradient(to bottom, transparent 0%, black 100%);\n  background: linear-gradient(to bottom, transparent 0%, #000 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);\n}\n\n@media (max-width: 1199.98px) {\n  .register.register-with-news-feed .news-feed .news-caption {\n    padding: 45px 45px 30px;\n    font-size: 16px;\n  }\n}\n\n.register.register-with-news-feed .news-feed .news-caption .caption-title {\n  font-weight: 300;\n  color: #fff;\n  font-size: 36px;\n}\n\n@media (max-width: 1199.98px) {\n  .register.register-with-news-feed .news-feed .news-caption .caption-title {\n    font-size: 28px;\n  }\n}\n\n.register.register-with-news-feed .right-content {\n  min-height: 100%;\n  background: #fff;\n  width: 500px;\n  margin-left: auto;\n  padding: 60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n@media (max-width: 1199.98px) {\n  .register.register-with-news-feed .right-content {\n    width: 400px;\n    padding: 45px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .register.register-with-news-feed .right-content {\n    width: auto;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .register.register-with-news-feed .right-content {\n    padding: 30px;\n  }\n}\n\n.register.register-with-news-feed .right-content .register-content {\n  width: auto;\n}\n\n.register.register-with-news-feed .right-content .register-header {\n  position: relative;\n  font-size: 32px;\n}\n\n@media (max-width: 1199.98px) {\n  .register.register-with-news-feed .right-content .register-header {\n    font-size: 24px;\n  }\n}\n\n.register.register-with-news-feed\n  .right-content\n  .register-header\n  + .register-content {\n  padding-top: 15px;\n}\n\n.register.register-with-news-feed .right-content .register-header small {\n  color: #6f8293;\n  display: block;\n  font-size: 14px;\n  margin-top: 10px;\n  line-height: 20px;\n}\n\n@media (max-width: 1199.98px) {\n  .register.register-with-news-feed .right-content .register-header small {\n    font-size: 12px;\n    line-height: 18px;\n  }\n}\n\n.registered-users-list {\n  list-style-type: none;\n  margin: 7.5px;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.registered-users-list > li {\n  width: 25%;\n  font-size: 12px;\n  padding: 7.5px;\n  color: #2d353c;\n}\n\n.registered-users-list > li > a {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.registered-users-list > li img {\n  max-width: 100%;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.registered-users-list > li .username {\n  font-size: 12px;\n  color: #2d353c;\n  margin-bottom: 0;\n  font-weight: 600;\n}\n\n.registered-users-list > li .username small {\n  display: block;\n  font-size: 11px;\n  color: #6f8293;\n  line-height: 15px;\n}\n\n.result-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.result-list > li {\n  background: #fff;\n  overflow: hidden;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.result-list > li .result-info .btn-row:after,\n.result-list > li .result-info .btn-row:before,\n.result-list > li:after,\n.result-list > li:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n@media (max-width: 991.98px) {\n  .result-list > li {\n    padding-top: 160px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .result-list > li {\n    display: block;\n  }\n}\n\n.result-list > li + li {\n  margin-top: 10px;\n}\n\n.result-list > li .result-image {\n  width: 240px;\n  padding: 0;\n  overflow: hidden;\n  background: #2d353c;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n@media (max-width: 1199.98px) {\n  .result-list > li .result-image {\n    width: 180px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .result-list > li .result-image {\n    width: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 160px;\n  }\n}\n\n.result-list > li .result-image a,\nbody .datetimepicker.dropdown-menu > ul > li.collapse.in {\n  display: block;\n}\n\n.result-list > li .result-image img,\nbody .datetimepicker.dropdown-menu > ul > li.picker-switch {\n  width: 100%;\n}\n\n.result-list > li .result-image:focus,\n.result-list > li .result-image:hover {\n  opacity: 0.8;\n}\n\n.result-list > li .result-info {\n  padding: 20px;\n  position: relative;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n@media (max-width: 1199.98px) {\n  .result-list > li .result-info {\n    padding: 15px;\n  }\n}\n\n.result-list > li .result-info .title {\n  margin: 0 0 5px;\n  font-size: 18px;\n  line-height: 22px;\n}\n\n@media (max-width: 991.98px) {\n  .result-list > li .result-info .title {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.result-list > li .result-info .title a,\n.theme-panel .theme-list > li.active > a.bg-white:before {\n  color: #2d353c;\n}\n\n.result-list > li .result-info .location {\n  color: #6f8293;\n  margin-bottom: 15px;\n}\n\n.result-list > li .result-info .decs {\n  margin-bottom: 20px;\n  max-height: 32px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 16px;\n}\n\n.result-list > li .result-info .btn-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.result-list > li .result-info .btn-row a {\n  color: #2d353c;\n  background: #f2f3f4;\n  font-size: 14px;\n  line-height: 18px;\n  padding: 8px 10px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.result-list > li .result-info .btn-row a:focus,\n.result-list > li .result-info .btn-row a:hover {\n  background: #d5dbe0;\n}\n\n.result-list > li .result-price {\n  width: 240px;\n  font-size: 28px;\n  text-align: center;\n  background: #f2f3f4;\n  color: #2d353c;\n  padding: 20px;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 1199.98px) {\n  .result-list > li .result-price {\n    width: 180px;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .result-list > li .result-price {\n    width: auto;\n  }\n}\n\n.result-list > li .result-price small {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6f8293;\n}\n\n.result-list > li .result-price .btn {\n  margin-top: 30px;\n}\n\n@media (max-width: 575.98px) {\n  .result-list > li .result-price .btn {\n    margin-top: 15px;\n  }\n}\n\n.row > [class^=\"col-\"].ui-sortable {\n  min-height: 50px;\n}\n\n.spinner,\n.spinner-small {\n  height: 36px;\n  width: 36px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -18px 0 0 -18px;\n  border: 2px solid rgba(45, 53, 60, 0.85);\n  border-top: 2px solid #fff;\n  -webkit-border-radius: 36px;\n  border-radius: 36px;\n  -webkit-animation: rotation 0.6s infinite linear;\n  -moz-animation: rotation 0.6s infinite linear;\n  -ms-animation: rotation 0.6s infinite linear;\n  -o-animation: rotation 0.6s infinite linear;\n  animation: rotation 0.6s infinite linear;\n}\n\n.spinner-small {\n  height: 28px;\n  width: 28px;\n  margin: -15px 0 0 -15px;\n  -webkit-border-radius: 30px;\n  border-radius: 30px;\n}\n\n.switcher {\n  display: inline-block;\n}\n\n.switcher label {\n  display: block;\n  margin: 0;\n  width: 46px;\n  height: 28px;\n  position: relative;\n}\n\n.switcher label:after,\n.switcher label:before {\n  content: \"\";\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.switcher label:before {\n  display: block;\n  background: #d5dbe0;\n  border: 1px solid #d5dbe0;\n  width: 46px;\n  height: 28px;\n  -webkit-border-radius: 46px;\n  border-radius: 46px;\n}\n\n.switcher label:after {\n  height: 24px;\n  width: 24px;\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  background: #fff;\n  -webkit-border-radius: 24px;\n  border-radius: 24px;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n.switcher input:checked + label:before {\n  background: #348fe2;\n  border: 2px solid #348fe2;\n}\n\n.switcher input:checked + label:after {\n  left: 20px;\n}\n\n.tab-overflow {\n  position: relative;\n  overflow: hidden;\n  -webkit-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n\n.tab-overflow .nav.nav-tabs {\n  white-space: nowrap;\n  display: table;\n  margin: 0;\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\n.tab-overflow .nav.nav-tabs > li {\n  display: table-cell;\n  float: none;\n}\n\n.tab-overflow .nav.nav-tabs > li > a {\n  margin-left: -1px;\n}\n\n.tab-overflow .nav.nav-tabs .next-button,\n.tab-overflow .nav.nav-tabs .prev-button {\n  position: absolute;\n  top: 0;\n  z-index: 10;\n  display: none !important;\n  opacity: 0;\n  -webkit-box-shadow: 0 0 15px rgba(45, 53, 60, 0.25);\n  box-shadow: 0 0 15px rgba(45, 53, 60, 0.25);\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.tab-overflow .nav.nav-tabs .prev-button {\n  left: 0;\n}\n\n.tab-overflow .nav.nav-tabs .prev-button a {\n  margin: 0;\n  background: #f2f3f4;\n  -webkit-border-radius: 4px 0 0;\n  border-radius: 4px 0 0;\n}\n\n.tab-overflow .nav.nav-tabs .next-button {\n  right: 0;\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.tab-overflow .nav.nav-tabs .next-button a {\n  margin: 0;\n  background: #f2f3f4;\n}\n\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse > li > a {\n  background: 0 0;\n}\n\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse .next-button,\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse .prev-button {\n  -webkit-box-shadow: 0 0 15px #000;\n  box-shadow: 0 0 15px #000;\n}\n\n.tab-overflow .nav.nav-tabs .next-button a,\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse .next-button + li > a.active,\n.tab-overflow .nav.nav-tabs.nav-tabs-inverse .prev-button + li > a.active {\n  -webkit-border-radius: 0 4px 0 0;\n  border-radius: 0 4px 0 0;\n}\n\n.tab-overflow.overflow-left .nav.nav-tabs .prev-button,\n.tab-overflow.overflow-right .nav.nav-tabs .next-button {\n  display: block !important;\n  opacity: 1;\n  background: 0 0;\n}\n\n.flat-black .tab-overflow .next-button a,\n.flat-black .tab-overflow .prev-button a {\n  background: #d2d2d2;\n}\n\n.table thead tr th {\n  font-weight: 600;\n  border-bottom: 1px solid #b8c1ca;\n}\n\n.table tbody tr td.with-btn,\n.table tbody tr td.with-btn-group,\n.table tbody tr td.with-checkbox,\n.table tbody tr td.with-form-control,\n.table tbody tr td.with-img,\n.table tbody tr td.with-input-group,\n.table tbody tr td.with-radio,\n.table tbody tr th.with-btn,\n.table tbody tr th.with-btn-group,\n.table tbody tr th.with-checkbox,\n.table tbody tr th.with-form-control,\n.table tbody tr th.with-img,\n.table tbody tr th.with-input-group,\n.table tbody tr th.with-radio,\n.table tfoot tr td.with-btn,\n.table tfoot tr td.with-btn-group,\n.table tfoot tr td.with-checkbox,\n.table tfoot tr td.with-form-control,\n.table tfoot tr td.with-img,\n.table tfoot tr td.with-input-group,\n.table tfoot tr td.with-radio,\n.table tfoot tr th.with-btn,\n.table tfoot tr th.with-btn-group,\n.table tfoot tr th.with-checkbox,\n.table tfoot tr th.with-form-control,\n.table tfoot tr th.with-img,\n.table tfoot tr th.with-input-group,\n.table tfoot tr th.with-radio,\n.table thead tr td.with-btn,\n.table thead tr td.with-btn-group,\n.table thead tr td.with-checkbox,\n.table thead tr td.with-form-control,\n.table thead tr td.with-img,\n.table thead tr td.with-input-group,\n.table thead tr td.with-radio,\n.table thead tr th.with-btn,\n.table thead tr th.with-btn-group,\n.table thead tr th.with-checkbox,\n.table thead tr th.with-form-control,\n.table thead tr th.with-img,\n.table thead tr th.with-input-group,\n.table thead tr th.with-radio {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.legend > table tbody tr + tr td,\n.table tbody tr td.with-checkbox .checkbox,\n.table tbody tr td.with-checkbox .radio,\n.table tbody tr td.with-radio .checkbox,\n.table tbody tr td.with-radio .radio,\n.table tbody tr th.with-checkbox .checkbox,\n.table tbody tr th.with-checkbox .radio,\n.table tbody tr th.with-radio .checkbox,\n.table tbody tr th.with-radio .radio,\n.table tfoot tr td.with-checkbox .checkbox,\n.table tfoot tr td.with-checkbox .radio,\n.table tfoot tr td.with-radio .checkbox,\n.table tfoot tr td.with-radio .radio,\n.table tfoot tr th.with-checkbox .checkbox,\n.table tfoot tr th.with-checkbox .radio,\n.table tfoot tr th.with-radio .checkbox,\n.table tfoot tr th.with-radio .radio,\n.table thead tr td.with-checkbox .checkbox,\n.table thead tr td.with-checkbox .radio,\n.table thead tr td.with-radio .checkbox,\n.table thead tr td.with-radio .radio,\n.table thead tr th.with-checkbox .checkbox,\n.table thead tr th.with-checkbox .radio,\n.table thead tr th.with-radio .checkbox,\n.table thead tr th.with-radio .radio {\n  padding-top: 0;\n}\n\n.table.table-transparent {\n  color: rgba(255, 255, 255, 0.75);\n  background: 0 0;\n}\n\n.table.table-transparent tbody tr td,\n.table.table-transparent tbody tr th,\n.table.table-transparent tfoot tr td,\n.table.table-transparent tfoot tr th,\n.table.table-transparent thead tr td,\n.table.table-transparent thead tr th {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.table.table-transparent thead tr th {\n  border-bottom-color: rgba(255, 255, 255, 0.5);\n}\n\n.table:not(.table-bordered) thead tr th {\n  border-top: none;\n}\n\n.theme-panel {\n  position: fixed;\n  right: -175px;\n  top: 150px;\n  z-index: 1020;\n  background: #fff;\n  padding: 15px;\n  width: 175px;\n  -webkit-transition: right 0.2s linear;\n  -moz-transition: right 0.2s linear;\n  -ms-transition: right 0.2s linear;\n  -o-transition: right 0.2s linear;\n  transition: right 0.2s linear;\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\n.theme-panel .theme-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.theme-panel .theme-list + .theme-list {\n  margin-top: 10px;\n}\n\n.theme-panel .theme-list > li > a {\n  width: 20px;\n  height: 20px;\n  display: block;\n  text-decoration: none;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.theme-panel .theme-list > li > a:focus,\n.theme-panel .theme-list > li > a:hover {\n  opacity: 0.6;\n}\n\n.theme-panel .theme-list > li.active > a,\n.timeline,\n.timeline > li {\n  position: relative;\n}\n\n.theme-panel .theme-list > li.active > a:before,\n.theme-panel .theme-version a span {\n  font-size: 14px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  text-align: center;\n}\n\n.theme-panel .theme-list > li.active > a:before {\n  content: \"\\f00c\";\n  color: #fff;\n  opacity: 0.4;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  font-weight: 900;\n}\n\n.theme-panel .theme-collapse-btn {\n  position: absolute;\n  left: -30px;\n  top: 10%;\n  margin-top: -15px;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  font-size: 18px;\n  color: #2d353c;\n  background: #fff;\n  text-align: center;\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n\n@media (max-width: 767.98px) {\n  .theme-panel .theme-collapse-btn {\n    top: 35%;\n  }\n}\n\n.theme-panel .theme-panel-content {\n  margin: -15px;\n  padding: 15px;\n  background: #fff;\n  position: relative;\n  z-index: 10;\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\n.theme-panel .theme-version {\n  margin: 0 0 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.theme-panel .theme-version a {\n  width: calc(50% - 2.5px);\n  padding-top: 35%;\n  position: relative;\n  text-decoration: none;\n}\n\n.theme-panel .theme-version a + a {\n  margin-left: 5px;\n}\n\n.theme-panel .theme-version a span {\n  font-weight: 700;\n  margin: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top left;\n}\n\n.theme-panel .theme-version a.active:before,\n.theme-panel .theme-version a:hover:before {\n  content: \"\";\n  position: absolute;\n  border: 12px solid transparent;\n  left: 0;\n  top: 0;\n  z-index: 10;\n}\n\n.theme-panel .theme-version a:hover:before {\n  border-left-color: #9ba8b4;\n  border-top-color: #9ba8b4;\n}\n\n.theme-panel .theme-version a.active:after,\n.theme-panel .theme-version a:hover:after {\n  content: \"\\f00c\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: #fff;\n  z-index: 10;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  font-size: 10px;\n  text-align: center;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.theme-panel .theme-version a.active:before {\n  border-left-color: #007aff;\n  border-top-color: #007aff;\n}\n\n.theme-panel .control-label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.theme-panel .divider {\n  height: 1px;\n  margin: 15px 0;\n  background: #d5dbe0;\n}\n\n.theme-panel.active {\n  right: 0;\n  -webkit-box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);\n}\n\n.theme-panel.active .theme-collapse-btn .fa:before {\n  content: \"\\f00d\";\n}\n\n.theme-panel.active a.bg-white {\n  border: 1px solid #c6ced5;\n}\n\n.theme-panel.theme-panel-lg {\n  top: 0;\n  bottom: 0;\n  width: 260px;\n  right: -260px;\n}\n\n.theme-panel.theme-panel-lg .theme-list {\n  margin-bottom: -3px;\n}\n\n.theme-panel.theme-panel-lg .theme-list > li {\n  margin-right: 3px;\n  margin-bottom: 3px;\n}\n\n.theme-panel.theme-panel-lg .theme-list > li + li {\n  margin-left: 0;\n}\n\n.theme-panel.theme-panel-lg .theme-list > li > a {\n  width: 28px;\n  height: 28px;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.theme-panel.theme-panel-lg .theme-list > li > a:before {\n  line-height: 28px;\n}\n\n.theme-panel.theme-panel-lg .theme-version {\n  margin: 0 0 5px;\n}\n\n.theme-panel.theme-panel-lg .theme-panel-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: scroll;\n  margin: 0;\n  padding: 20px;\n}\n\n.theme-panel.theme-panel-lg .theme-collapse-btn {\n  top: 30%;\n}\n\n@media (max-width: 767.98px) {\n  .theme-panel.theme-panel-lg .theme-collapse-btn {\n    top: 35%;\n  }\n}\n\n.theme-panel.theme-panel-lg.active {\n  right: 0;\n}\n\n.timeline {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.timeline:before {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  bottom: 5px;\n  width: 5px;\n  background: #2d353c;\n  left: 20%;\n  margin-left: -2.5px;\n}\n\n@media (max-width: 991.98px) {\n  .timeline:before {\n    left: 15%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .timeline:before {\n    left: 50%;\n  }\n}\n\n.timeline > li {\n  min-height: 50px;\n  padding: 20px 0;\n}\n\n.timeline .timeline-time {\n  position: absolute;\n  left: 0;\n  width: 18%;\n  text-align: right;\n  top: 30px;\n}\n\n@media (max-width: 991.98px) {\n  .timeline .timeline-time {\n    width: 12%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .timeline .timeline-time {\n    width: 50%;\n    text-align: right;\n    padding-right: 20px;\n  }\n}\n\n.timeline .timeline-time .date {\n  display: block;\n  font-weight: 600;\n  line-height: 16px;\n  font-size: 12px;\n}\n\n.timeline .timeline-time .time {\n  display: block;\n  font-weight: 600;\n  line-height: 24px;\n  font-size: 20px;\n  color: #2d353c;\n}\n\n.timeline .timeline-icon {\n  left: 15%;\n  position: absolute;\n  width: 10%;\n  text-align: center;\n  top: 40px;\n}\n\n@media (max-width: 991.98px) {\n  .timeline .timeline-icon {\n    left: 10%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .timeline .timeline-icon {\n    left: 45%;\n  }\n}\n\n.timeline .timeline-icon a {\n  text-decoration: none;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background: #d9e0e7;\n  line-height: 10px;\n  color: #fff;\n  font-size: 14px;\n  border: 5px solid #2d353c;\n  -webkit-transition: border-color 0.2s linear;\n  -moz-transition: border-color 0.2s linear;\n  -ms-transition: border-color 0.2s linear;\n  -o-transition: border-color 0.2s linear;\n  transition: border-color 0.2s linear;\n  -webkit-border-radius: 24px;\n  border-radius: 24px;\n}\n\n.timeline .timeline-header {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #d5dbe0;\n  line-height: 30px;\n}\n\n.timeline .timeline-header .userimage {\n  float: left;\n  width: 34px;\n  height: 34px;\n  overflow: hidden;\n  margin: -2px 10px -2px 0;\n  -webkit-border-radius: 36px;\n  border-radius: 36px;\n}\n\n.timeline .timeline-header .username {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2d353c;\n}\n\n.timeline .timeline-header .username a {\n  color: #2d353c;\n}\n\n.timeline .timeline-header .views {\n  float: right;\n  color: #6f8293;\n  font-weight: 600;\n}\n\n.timeline .timeline-body {\n  margin-left: 23%;\n  margin-right: 17%;\n  background: #fff;\n  position: relative;\n  padding: 20px 25px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n@media (max-width: 1199.98px) {\n  .timeline .timeline-body {\n    margin-left: 25%;\n    margin-right: 10%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .timeline .timeline-body {\n    margin-left: 20%;\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .timeline .timeline-body {\n    margin-left: 0;\n    margin-top: 60px;\n    padding: 15px;\n  }\n}\n\n.timeline .timeline-body:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border: 10px solid transparent;\n  border-right-color: #fff;\n  left: -20px;\n  top: 20px;\n}\n\n@media (max-width: 575.98px) {\n  .timeline .timeline-body:before {\n    border-right-color: transparent;\n    border-bottom-color: #fff;\n    left: 50%;\n    margin-left: -10px;\n    top: -20px;\n  }\n}\n\n.timeline .timeline-body > div + div:last-child {\n  margin-bottom: -20px;\n  padding-bottom: 20px;\n  -webkit-border-radius: 0 0 6px 6px;\n  border-radius: 0 0 6px 6px;\n}\n\n@media (max-width: 575.98px) {\n  .timeline .timeline-body > div + div:last-child {\n    margin-bottom: -15px;\n    padding-bottom: 15px;\n  }\n}\n\n.timeline .timeline-content {\n  letter-spacing: 0.25px;\n  line-height: 18px;\n  font-size: 13px;\n}\n\n.timeline .timeline-content:after,\n.timeline .timeline-content:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.timeline .timeline-title {\n  margin-top: 0;\n}\n\n.timeline .timeline-footer {\n  background: #fff;\n  border-top: 1px solid #d5dbe0;\n  padding-top: 15px;\n  font-weight: 600;\n}\n\n.timeline .timeline-footer a:not(.btn) {\n  color: #6f8293;\n}\n\n.timeline .timeline-footer a:not(.btn):focus,\n.timeline .timeline-footer a:not(.btn):hover {\n  color: #2d353c;\n}\n\n.timeline .timeline-likes {\n  color: #6f8293;\n  font-weight: 600;\n  font-size: 12px;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.timeline .timeline-likes .stats-right {\n  margin-left: auto;\n}\n\n.timeline .timeline-likes,\n.timeline .timeline-likes .stats {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.timeline .timeline-likes .stats .stats-icon {\n  font-size: 9px;\n}\n\n.timeline .timeline-likes .stats-total {\n  margin-left: 3px;\n  line-height: 20px;\n}\n\n.timeline .timeline-likes .stats-text {\n  line-height: 20px;\n}\n\n.timeline .timeline-likes .stats-text + .stats-text {\n  margin-left: 10px;\n}\n\n.timeline .timeline-comment-box {\n  background: #f2f3f4;\n  margin-left: -25px;\n  margin-right: -25px;\n  padding: 20px 25px;\n}\n\n@media (max-width: 575.98px) {\n  .timeline .timeline-comment-box {\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 15px;\n  }\n}\n\n.timeline .timeline-comment-box .user {\n  float: left;\n  width: 34px;\n  height: 34px;\n  overflow: hidden;\n  -webkit-border-radius: 36px;\n  border-radius: 36px;\n}\n\n.timeline .timeline-comment-box .user + .input {\n  margin-left: 44px;\n}\n\n.todolist {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.todolist > li {\n  border-bottom: 1px solid #e4e7ea;\n}\n\n.todolist > li > a {\n  display: block;\n  color: #2d353c;\n}\n\n.todolist > li > a .todolist-input,\n.todolist > li > a .todolist-title {\n  display: table-cell;\n  padding: 10px;\n}\n\n.todolist > li > a .todolist-input {\n  text-align: center;\n  font-size: 14px;\n  border-right: 1px solid #e4e7ea;\n  color: #e4e7ea;\n}\n\n.todolist > li > a .todolist-input i {\n  display: block;\n  width: 14px;\n  text-align: center;\n}\n\n.todolist > li > a:focus,\n.todolist > li > a:hover {\n  background: #f2f3f4;\n  text-decoration: none;\n}\n\n.todolist > li > a:focus .todolist-input i:before,\n.todolist > li > a:hover .todolist-input i:before {\n  content: \"\\f14a\";\n  color: rgba(45, 53, 60, 0.4);\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.todolist > li.active > a .todolist-title {\n  text-decoration: line-through;\n}\n\n.todolist > li.active > a i:before {\n  content: \"\\f14a\";\n  color: #00acac;\n}\n\n.todolist > li.active > a:focus i:before,\n.todolist > li.active > a:hover i:before {\n  color: #00acac;\n}\n\n@media (min-width: 992px) {\n  .vertical-box {\n    display: table;\n    table-layout: fixed;\n    border-spacing: 0;\n    height: 100%;\n    width: 100%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .vertical-box .vertical-box-column {\n    width: 100% !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .vertical-box-column {\n    display: table-cell;\n    vertical-align: top;\n    height: 100%;\n  }\n\n  .vertical-box-row {\n    display: table-row;\n    height: 100%;\n  }\n}\n\n.vertical-box-row > .vertical-box-cell {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  float: none;\n}\n\n@media (min-width: 992px) {\n  .vertical-box-row > .vertical-box-cell > .vertical-box-inner-cell {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: hidden;\n  }\n\n  .vertical-box.with-grid > .vertical-box-column + .vertical-box-column {\n    border-left: 1px solid #d5dbe0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .vertical-box.with-grid > .vertical-box-column + .vertical-box-column {\n    border-top: 1px solid #d5dbe0;\n  }\n}\n\n.vertical-box.with-border-top,\n.vertical-box.with-grid,\n.vertical-box.with-grid .vertical-box-row + .vertical-box-row > div,\n.vertical-box.with-grid .vertical-box-row + .wrapper,\n.vertical-box.with-grid .wrapper + .vertical-box-row > div,\n.vertical-box.with-grid .wrapper + .wrapper,\ndiv + .widget-input {\n  border-top: 1px solid #d5dbe0;\n}\n\n.vertical-box.with-border-bottom,\nbody table.dataTable.collapsed tbody tr td .dtr-details > li {\n  border-bottom: 1px solid #d5dbe0;\n}\n\n.widget-card {\n  position: relative;\n  margin-bottom: 15px;\n  display: block;\n  text-decoration: none !important;\n}\n\n.widget-card .widget-card-content {\n  padding: 15px;\n  position: relative;\n}\n\n.widget-card .widget-card-cover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: #fff;\n}\n\n.widget-card .widget-card-cover .widget-card-cover-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 40%;\n  height: 40%;\n  margin: -20% 0 0 -20%;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.75);\n  color: #fff;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.widget-card .widget-card-cover .widget-card-cover-icon .fa {\n  font-size: 1.5vw;\n  line-height: 1.5vw;\n}\n\n.widget-card.widget-card-rounded .widget-card-content,\n.widget-card.widget-card-rounded .widget-card-cover,\n.widget-chart {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-card.square {\n  padding-top: 100%;\n  overflow: hidden;\n}\n\n.widget-card.square .widget-card-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.widget-card.square .widget-card-content.bottom {\n  top: auto;\n}\n\n.inverse-mode .widget-card,\n.inverse-mode.widget-card,\n.widget-chart .widget-chart-sidebar .chart-legend > li {\n  color: #fff;\n}\n\n.inverse-mode .widget-card .widget-card-cover,\n.inverse-mode.widget-card .widget-card-cover {\n  background-color: #2d353c;\n}\n\n.widget-chart {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n@media (min-width: 576px) {\n  .widget-chart {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n\n.widget-chart .chart-title {\n  font-size: 16px !important;\n  line-height: 20px;\n  color: #fff;\n  font-weight: 600 !important;\n  margin: 2px 5px 5px;\n}\n\n.widget-chart .widget-chart-content {\n  padding: 15px;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n@media (min-width: 768px) {\n  .widget-chart .widget-chart-content + .widget-chart-sidebar {\n    -webkit-border-radius: 0 4px 4px 0;\n    border-radius: 0 4px 4px 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .widget-chart .widget-chart-content + .widget-chart-sidebar {\n    -webkit-border-radius: 0 0 4px 4px;\n    border-radius: 0 0 4px 4px;\n  }\n}\n\n.widget-chart .widget-chart-full-width {\n  margin: 0 -15px;\n}\n\n.widget-chart .widget-chart-sidebar {\n  padding: 15px;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n@media (min-width: 768px) {\n  .widget-chart .widget-chart-sidebar {\n    width: 230px;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .widget-chart .widget-chart-sidebar {\n    width: 200px;\n  }\n}\n\n.widget-chart .widget-chart-sidebar .chart-number {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #fff;\n}\n\n.widget-chart .chart-title small,\n.widget-chart .widget-chart-sidebar .chart-number small {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 3px;\n  color: #9ba8b4;\n  display: block;\n  font-weight: 400;\n}\n\n.widget-chart .widget-chart-sidebar .chart-legend {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.widget-chart .widget-chart-sidebar .chart-legend > li span {\n  color: #9ba8b4;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.widget-chart .widget-chart-sidebar .chart-legend > li + li {\n  margin-top: 5px;\n}\n\n.widget-chart-info {\n  color: #2d353c;\n}\n\n.widget-chart-info .widget-chart-info-title {\n  margin: 0 0 5px;\n  font-size: 14px;\n}\n\n.widget-chart-info .widget-chart-info-desc {\n  font-size: 11px;\n  color: #4e5c68;\n  margin-bottom: 20px;\n}\n\n.widget-chart-info .widget-chart-info-progress {\n  font-size: 11px;\n  margin-bottom: 5px;\n}\n\n.widget-chart-info .widget-chart-info-progress .progress {\n  margin-bottom: 0;\n}\n\n.widget-chart-content {\n  padding: 10px;\n  background: #f2f3f4;\n}\n\n.inverse-mode .widget-chart-content {\n  background: #1d2226;\n}\n\n.inverse-mode .widget-chart-info {\n  color: #c6ced5;\n}\n\n.inverse-mode .widget-chart-info .widget-chart-info-desc {\n  color: #9ba8b4;\n}\n\n.inverse-mode .nvd3 text {\n  fill: rgba(255, 255, 255, 0.75);\n}\n\n.inverse-mode .nvd3 .nv-axis line,\n.inverse-mode .nvd3 .nv-axis path {\n  stroke: rgba(255, 255, 255, 0.15);\n}\n\n.widget-chat {\n  background: #fff;\n}\n\n.widget-chat .widget-chat-header {\n  display: table;\n  width: 100%;\n  border-bottom: 1px solid #d5dbe0;\n}\n\n.widget-chat .widget-chat-header > div + div,\n.widget-list .widget-list-item .widget-list-action + div,\n.widget-list .widget-list-item .widget-list-content + div,\n.widget-list .widget-list-item .widget-list-media + div,\n.widget-todolist .widget-todolist-item .widget-todolist-input + div {\n  padding-left: 0;\n}\n\n.widget-chat .widget-chat-header .widget-chat-header-icon {\n  width: 1%;\n}\n\n.widget-chat .widget-chat-header .widget-chat-header-content,\n.widget-chat .widget-chat-header .widget-chat-header-icon {\n  padding: 12px 15px;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.widget-chat .widget-chat-header .widget-chat-header-title {\n  font-size: 14px;\n  margin: 0;\n}\n\n.widget-chat .widget-chat-header .widget-chat-header-desc {\n  font-size: 12px;\n  margin: 0;\n}\n\n.widget-chat .widget-chat-body {\n  padding: 15px;\n  background: #e4e7ea;\n}\n\n.widget-chat .widget-chat-item {\n  color: #2d353c;\n  position: relative;\n  min-height: 38px;\n  padding: 3px 0;\n}\n\n.widget-chat .widget-chat-media {\n  width: 38px;\n  height: 38px;\n  position: absolute;\n  bottom: 3px;\n  left: 0;\n  overflow: hidden;\n  text-align: center;\n  line-height: 38px;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.widget-chat .widget-chat-media img {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n}\n\n.widget-chat .widget-chat-info-container {\n  background: #fff;\n  display: inline-block;\n  padding: 8px 12px;\n  position: relative;\n  color: #fff;\n  -webkit-border-radius: 16px;\n  border-radius: 16px;\n}\n\n.widget-chat .widget-chat-message {\n  font-weight: 600;\n  color: #2d353c;\n}\n\n.widget-chat .widget-chat-message:before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: -24px;\n  border: 0 solid transparent;\n  border-top-width: 15px;\n  border-right-width: 10px;\n  border-right-color: #fff;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  -webkit-transform: rotate(10deg);\n  -moz-transform: rotate(10deg);\n  -ms-transform: rotate(10deg);\n  -o-transform: rotate(10deg);\n  transform: rotate(10deg);\n}\n\n.widget-chat .widget-chat-message:after {\n  content: \"\";\n  display: inline-block;\n  width: 60px;\n  height: 12px;\n}\n\n.widget-chat .widget-chat-name {\n  font-weight: 600;\n}\n\n.widget-chat .widget-chat-time {\n  position: absolute;\n  right: 12px;\n  bottom: 8px;\n  font-style: italic;\n  color: #9ba8b4;\n  font-weight: 600;\n  font-size: 10px;\n}\n\n.widget-chat .with-media .widget-chat-info {\n  margin-left: 53px;\n  min-width: 60%;\n}\n\n.widget-chat .with-media .right .widget-chat-info {\n  margin-right: 53px;\n}\n\n.widget-chat .right .widget-chat-media {\n  left: auto;\n  right: 0;\n}\n\n.widget-chat .right .widget-chat-info {\n  margin-left: 0;\n  text-align: right;\n}\n\n.widget-chat .right .widget-chat-time {\n  right: auto;\n  left: 12px;\n}\n\n.widget-chat .right .widget-chat-message:after {\n  float: left;\n}\n\n.widget-chat .right .widget-chat-message:before {\n  left: auto;\n  right: -24px;\n  bottom: -5px;\n  border-right-width: 0;\n  border-right-color: transparent;\n  border-left-width: 10px;\n  border-left-color: #fff;\n}\n\n.widget-chat.widget-chat-rounded {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-chat.widget-chat-rounded.widget-chat-input {\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\n.inverse-mode.widget-chat {\n  background: #2d353c;\n}\n\n.inverse-mode.widget-chat .widget-chat-header {\n  border-color: #2d353c;\n}\n\n.inverse-mode.widget-chat .widget-chat-header-title {\n  color: #fff;\n}\n\n.inverse-mode.widget-chat .widget-chat-header-desc {\n  color: #c6ced5;\n}\n\n.inverse-mode.widget-chat .widget-chat-body {\n  background: #1a2229;\n}\n\n.widget-icon,\n.widget-img {\n  overflow: hidden;\n  width: 40px;\n  height: 40px;\n}\n\n.widget-icon {\n  position: relative;\n  font-size: 28px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.widget-icon.user {\n  font-size: 36px;\n}\n\n.widget-icon.user i {\n  display: block;\n  margin: 0 auto;\n  padding-top: 38%;\n}\n\n.widget-icon.widget-icon-xs {\n  width: 20px;\n  height: 20px;\n  font-size: 14px;\n}\n\n.widget-icon.widget-icon-xs.user {\n  font-size: 18px;\n}\n\n.widget-icon.widget-icon-sm {\n  width: 30px;\n  height: 30px;\n  font-size: 21px;\n}\n\n.widget-icon.widget-icon-sm.user {\n  font-size: 27px;\n}\n\n.widget-icon.widget-icon-lg {\n  width: 60px;\n  height: 60px;\n  font-size: 42px;\n}\n\n.widget-icon.widget-icon-lg.user {\n  font-size: 54px;\n}\n\n.widget-icon.widget-icon-xl {\n  width: 80px;\n  height: 80px;\n  font-size: 56px;\n}\n\n.widget-icon.widget-icon-xl.user {\n  font-size: 72px;\n}\n\n.widget-img {\n  line-height: 40px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.widget-img.widget-img-xl {\n  width: 80px;\n  height: 80px;\n  line-height: 80px;\n}\n\n.widget-img.widget-img-lg {\n  width: 60px;\n  height: 60px;\n  line-height: 60px;\n}\n\n.widget-img.widget-img-sm {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n\n.widget-img.widget-img-xs {\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n\ndiv + .widget-input.widget-input-rounded {\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.widget-input {\n  position: relative;\n  background: #fff;\n}\n\n.widget-input.widget-input-rounded {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-input-container {\n  display: table;\n  width: 100%;\n}\n\n.widget-input-container .widget-input-icon {\n  display: table-cell;\n  vertical-align: middle;\n  width: 1%;\n  padding: 0 5px;\n}\n\n.widget-input-container .widget-input-icon a {\n  display: block;\n  padding: 10px;\n  font-size: 18px;\n}\n\n.widget-input-container .widget-input-box {\n  display: table-cell;\n  vertical-align: middle;\n  padding: 5px 0;\n}\n\n.widget-input-container .widget-input-box .form-control {\n  border-color: #f2f4f5;\n  background: #f2f4f5;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.widget-input-container .widget-input-box .form-control:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.widget-input-container .widget-input-divider {\n  display: table-cell;\n  vertical-align: middle;\n  width: 1px;\n}\n\n.widget-input-container .widget-input-divider:after {\n  content: \"\";\n  width: 1px;\n  height: 26px;\n  background: #d5dbe0;\n  display: block;\n}\n\n.inverse-mode .widget-input,\n.inverse-mode.widget-input {\n  background: #2d353c;\n}\n\n.inverse-mode .widget-input-box .form-control {\n  background: #3d4852;\n  border-color: #3d4852;\n  color: #fff;\n}\n\n.inverse-mode .widget-input-box .form-control::-webkit-input-placeholder,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  .widget-todolist-content\n  .form-control::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.inverse-mode .widget-input-box .form-control::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.inverse-mode .widget-input-box .form-control:-ms-input-placeholder,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  .widget-todolist-content\n  .form-control:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.inverse-mode .widget-input-box .form-control:-moz-placeholder,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  .widget-todolist-content\n  .form-control:-moz-placeholder,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  .widget-todolist-content\n  .form-control::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.inverse-mode .widget-input-divider:after,\n.widget.inverse-mode hr {\n  background: #4e5c68;\n}\n\n.inverse-mode div + .widget-input,\ndiv + .widget-input.inverse-mode {\n  border-color: #2d353c;\n}\n\n.widget-list .widget-list-item {\n  display: table;\n  width: 100%;\n  background: #fff;\n  text-decoration: none;\n  color: #2d353c;\n}\n\n.widget-list .widget-list-item + .widget-list-item .widget-list-action,\n.widget-list .widget-list-item + .widget-list-item .widget-list-content {\n  border-top: 1px solid #e4e7ea;\n}\n\n.widget-list .widget-list-item .widget-list-media {\n  width: 70px;\n  height: 60px;\n}\n\n.widget-list .widget-list-item .widget-list-media.icon {\n  width: 30px;\n  height: 30px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.widget-list .widget-list-item .widget-list-media.icon i {\n  display: block;\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  line-height: 30px;\n  font-size: 14px;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\n.widget-list .widget-list-item .widget-list-content,\n.widget-list .widget-list-item .widget-list-media {\n  padding: 10px;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.widget-list .widget-list-item .widget-list-action {\n  display: table-cell;\n  vertical-align: middle;\n  width: 10%;\n  padding: 10px 10px 10px 15px;\n  text-align: center;\n}\n\n.widget-list .widget-list-item .widget-list-title {\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n}\n\n.widget-list .widget-list-item .widget-list-desc {\n  font-size: 11px;\n  margin: 0;\n  color: #6f8293;\n}\n\n.widget-list.widget-list-rounded .widget-list-item:first-child,\n.widget-list.widget-list-rounded.widget-list-item:first-child {\n  -webkit-border-top-right-radius: 4px;\n  border-top-right-radius: 4px;\n  -webkit-border-top-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.widget-list.widget-list-rounded .widget-list-item:last-child,\n.widget-list.widget-list-rounded.widget-list-item:last-child {\n  -webkit-border-bottom-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  -webkit-border-bottom-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.inverse-mode .widget-list-item,\n.inverse-mode.widget-list-item {\n  background: #2d353c;\n}\n\n.inverse-mode .widget-list-item + .widget-list-item .widget-list-action,\n.inverse-mode .widget-list-item + .widget-list-item .widget-list-content,\n.inverse-mode.widget-list-item + .widget-list-item .widget-list-action,\n.inverse-mode.widget-list-item + .widget-list-item .widget-list-content {\n  border-color: #3d4852;\n}\n\n.inverse-mode .widget-list-item .widget-list-title,\n.inverse-mode.widget-list-item .widget-list-title,\n.widget-table.table.inverse-mode thead th {\n  color: #fff;\n}\n\n.inverse-mode .widget-list-item .widget-list-desc,\n.inverse-mode.widget-list-item .widget-list-desc {\n  color: #c6ced5;\n}\n\n.widget-map {\n  background: #fff;\n}\n\n.widget-map.widget-map-rounded {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-map.inverse-mode {\n  background: #2d353c;\n}\n\n.widget-stats,\n.widget.widget-stats {\n  position: relative;\n  color: #fff;\n  padding: 15px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-stats .stats-info h4,\n.widget.widget-stats .stats-info h4 {\n  font-size: 12px;\n  margin: 5px 0;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-stats .stats-info p,\n.widget.widget-stats .stats-info p {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.widget-stats .stats-link a,\n.widget.widget-stats .stats-link a {\n  display: block;\n  margin: 15px -15px -15px;\n  padding: 7px 15px;\n  background: rgba(0, 0, 0, 0.4);\n  text-align: right;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n}\n\n.widget-stats .stats-link a:focus,\n.widget-stats .stats-link a:hover,\n.widget.widget-stats .stats-link a:focus,\n.widget.widget-stats .stats-link a:hover {\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n}\n\n.widget-stats .stats-icon,\n.widget.widget-stats .stats-icon {\n  font-size: 42px;\n  height: 56px;\n  width: 56px;\n  text-align: center;\n  line-height: 56px;\n  color: rgba(0, 0, 0, 0.15);\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  margin-left: 15px;\n}\n\n.widget-stats .stats-icon.stats-icon-lg,\n.widget.widget-stats .stats-icon.stats-icon-lg {\n  font-size: 128px;\n  top: 15px;\n  right: 0;\n  color: #fff;\n  width: 128px;\n  height: 50px;\n  line-height: 50px;\n  text-shadow: 3px 7px rgba(0, 0, 0, 0.25);\n  opacity: 0.15;\n}\n\n.widget-stats .stats-icon.stats-icon-square,\n.widget.widget-stats .stats-icon.stats-icon-square {\n  opacity: 1;\n  font-size: 42px;\n  top: 15px;\n  right: 15px;\n  height: 56px;\n  width: 56px;\n  text-align: center;\n  line-height: 56px;\n  margin-left: 15px;\n  -webkit-border-radius: 16px;\n  border-radius: 16px;\n}\n\n.widget-stats .stats-content,\n.widget-stats .stats-icon.stats-icon-lg i,\n.widget.widget-stats .stats-content,\n.widget.widget-stats .stats-icon.stats-icon-lg i {\n  position: relative;\n}\n\n.widget-stats .stats-title,\n.widget.widget-stats .stats-title {\n  position: relative;\n  margin: 0 0 2px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-stats .stats-desc,\n.widget.widget-stats .stats-desc {\n  margin: -5px 0 -3px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.widget-stats .stats-number,\n.widget.widget-stats .stats-number {\n  font-size: 24px;\n  margin-bottom: 15px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n\n.widget-stats .stats-progress,\n.widget.widget-stats .stats-progress {\n  background: rgba(0, 0, 0, 0.5);\n  height: 2px;\n  margin: 0 0 15px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-stats .stats-progress .progress-bar,\n.widget.widget-stats .stats-progress .progress-bar {\n  background: #fff;\n  -webkit-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n}\n\n.widget-stats .stats-progress.stats-progress-light,\n.widget.widget-stats .stats-progress.stats-progress-light {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.widget-stats.text-inverse.stats-desc,\n.widget.widget-stats.text-inverse.stats-desc {\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.widget-stats.text-inverse.stats-title,\n.widget.widget-stats.text-inverse.stats-title {\n  font-weight: 700;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.widget-stats.text-inverse.stats-number,\n.widget.widget-stats.text-inverse.stats-number {\n  letter-spacing: 0;\n  font-weight: 400;\n}\n\n.widget-stats.bg-white .stats-progress,\n.widget.widget-stats.bg-white .stats-progress {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.widget-stats.bg-white .stats-progress .progress-bar,\n.widget.widget-stats.bg-white .stats-progress .progress-bar {\n  background: #2d353c;\n}\n\n.widget-table.table {\n  background: #fff;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-table.table .widget-table-img {\n  width: 100px;\n  height: 60px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget-table.table .widget-table-title {\n  font-size: 14px;\n  margin: 0;\n  line-height: 20px;\n}\n\n.widget-table.table .widget-table-desc {\n  margin: 0;\n  font-size: 11px;\n  line-height: 16px;\n  color: #4e5c68;\n}\n\n.widget-table.table.table-bordered {\n  border: 0;\n}\n\n.widget-table.table.table-bordered > tbody > tr td:first-child,\n.widget-table.table.table-bordered > thead > tr th:first-child {\n  border-left: none;\n}\n\n.widget-table.table.table-bordered > tbody > tr td:last-child,\n.widget-table.table.table-bordered > thead > tr th:last-child {\n  border-right: none;\n}\n\n.widget-table.table.table-bordered > tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n.widget-table.table.table-bordered > thead:first-child > tr:first-child > td,\n.widget-table.table.table-bordered > thead:first-child > tr:first-child > th {\n  border-top: none;\n}\n\n.widget-table.table.inverse-mode {\n  background: #2d353c;\n  color: #c6ced5;\n}\n\n.widget-table.table.inverse-mode .widget-table-desc {\n  color: #9ba8b4;\n}\n\n.widget-table.table.inverse-mode thead > tr > th {\n  border-bottom-color: #4e5c68 !important;\n}\n\n.widget-table.table.inverse-mode tbody tr td,\n.widget-table.table.inverse-mode tbody tr th,\n.widget-table.table.inverse-mode tfoot tr td,\n.widget-table.table.inverse-mode tfoot tr th,\n.widget-table.table.inverse-mode thead tr td,\n.widget-table.table.inverse-mode thead tr th {\n  border-color: #3d4852;\n}\n\n.widget-todolist {\n  background: #fff;\n}\n\n.widget-todolist:after,\n.widget-todolist:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.widget-todolist .widget-todolist-header {\n  display: table;\n  width: 100%;\n}\n\n.widget-todolist .widget-todolist-header .widget-todolist-header-left,\n.widget-todolist .widget-todolist-header .widget-todolist-header-right {\n  display: table-cell;\n  vertical-align: middle;\n  padding: 10px 15px;\n}\n\n.widget-todolist .widget-todolist-header .widget-todolist-header-right {\n  width: 1%;\n  text-align: center;\n}\n\n.widget-todolist .widget-todolist-header .widget-todolist-header-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.widget-todolist .widget-todolist-header .widget-todolist-header-total {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2d353c;\n}\n\n.widget-todolist .widget-todolist-header .widget-todolist-header-total small {\n  display: block;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.widget-todolist .widget-todolist-body {\n  padding: 3px 0;\n  border-top: 1px solid #e4e7ea;\n  border-bottom: 1px solid #e4e7ea;\n  margin-bottom: 20px;\n}\n\n.widget-todolist .widget-todolist-item {\n  display: table;\n  width: 100%;\n}\n\n.widget-todolist .widget-todolist-item .widget-todolist-icon {\n  display: table-cell;\n  padding: 10px 15px;\n  vertical-align: middle;\n  width: 1%;\n  text-align: center;\n  border-top: 1px solid #d5dbe0;\n}\n\n.widget-todolist .widget-todolist-item .widget-todolist-input {\n  display: table-cell;\n  padding: 10px 15px;\n  vertical-align: middle;\n  width: 45px;\n  text-align: center;\n}\n\n.widget-todolist .widget-todolist-item .widget-todolist-content {\n  display: table-cell;\n  padding: 10px 15px;\n  vertical-align: middle;\n  border-top: 1px solid #e4e7ea;\n}\n\n.widget-todolist .widget-todolist-item .widget-todolist-content .form-control {\n  margin: -5px 0;\n  border: 0 !important;\n  padding-left: 0;\n  background: 0 0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  -webkit-border-radius: 0 !important;\n  border-radius: 0 !important;\n}\n\n.widget-todolist .widget-todolist-item .widget-todolist-desc,\n.widget-todolist .widget-todolist-item .widget-todolist-title {\n  font-size: 12px;\n  margin: 0;\n}\n\n.widget-todolist .widget-todolist-item:first-child .widget-todolist-content,\n.widget-todolist .widget-todolist-item:first-child .widget-todolist-icon {\n  border-top: none;\n}\n\n.widget-todolist.widget-todolist-rounded {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.inverse-mode.widget-todolist {\n  background: #2d353c;\n}\n\n.bootstrap-calendar .calendar .table.daysmonth tr td.event a,\n.inverse-mode.widget-todolist\n  .widget-todolist-header\n  .widget-todolist-header-title,\n.inverse-mode.widget-todolist\n  .widget-todolist-header\n  .widget-todolist-header-total,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  .widget-todolist-content\n  .form-control,\n.inverse-mode.widget-todolist .widget-todolist-item .widget-todolist-title {\n  color: #fff;\n}\n\n.inverse-mode.widget-todolist .widget-todolist-body,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  + .widget-todolist-item\n  .widget-todolist-content,\n.inverse-mode.widget-todolist\n  .widget-todolist-item\n  + .widget-todolist-item\n  .widget-todolist-icon {\n  border-color: #3d4852;\n}\n\n.inverse-mode.widget-todolist .widget-todolist-item .widget-todolist-desc {\n  color: #c6ced5;\n}\n\n.widget {\n  overflow: hidden;\n  margin-bottom: 20px;\n  background: #fff;\n  color: inherit;\n  padding: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.widget .widget-header {\n  display: table;\n  width: 100%;\n}\n\n.widget .widget-header .widget-header-title {\n  font-size: 12px;\n  margin: 0;\n  line-height: 20px;\n  width: 100%;\n  display: table-cell;\n  padding: 10px 15px;\n}\n\n.widget .widget-header .widget-header-icon {\n  width: 1%;\n  display: table-cell;\n  padding: 10px 15px;\n}\n\n.widget .widget-header .widget-header-icon + .widget-header-icon {\n  padding-left: 0;\n}\n\n.widget .widget-body {\n  padding: 15px;\n}\n\n.widget.widget-rounded {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.widget.inverse-mode {\n  background: #2d353c;\n}\n\n.widget.inverse-mode .vertical-box.with-border-top,\n.widget.inverse-mode\n  .vertical-box.with-grid\n  > .vertical-box-column\n  + .vertical-box-column {\n  border-color: #4e5c68;\n}\n\n.apexcharts-canvas .apexcharts-tooltip {\n  border: 0 !important;\n  font-size: inherit;\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n}\n\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {\n  font-family: inherit !important;\n  padding: 6px 12px;\n  margin: 0;\n  border: 0 !important;\n  font-weight: 600;\n}\n\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-marker {\n  width: 8px;\n  height: 8px;\n  margin-right: 5px;\n}\n\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.apexcharts-canvas\n  .apexcharts-tooltip\n  .apexcharts-tooltip-series-group\n  .apexcharts-tooltip-y-group {\n  padding: 6px 0;\n}\n\n.apexcharts-canvas\n  .apexcharts-tooltip\n  .apexcharts-tooltip-series-group\n  + .apexcharts-tooltip-series-group {\n  margin-top: -6px;\n}\n\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group.active,\n.apexcharts-canvas\n  .apexcharts-tooltip\n  .apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 0;\n}\n\n.apexcharts-canvas .apexcharts-tooltip.light .apexcharts-tooltip-title {\n  background: #f2f3f4;\n}\n\n.apexcharts-canvas .apexcharts-tooltip.dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip,\n.apexcharts-canvas .apexcharts-yaxistooltip {\n  border: 0 !important;\n  font-size: inherit;\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip:after,\n.apexcharts-canvas .apexcharts-yaxistooltip:after,\nbody .datetimepicker .next:before,\nbody .datetimepicker .prev:before {\n  display: none;\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip.light,\n.apexcharts-canvas .apexcharts-yaxistooltip.light {\n  background: #fff;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-top:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-top:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-top:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-top:before {\n  border-top-color: #fff;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-bottom:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-bottom:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-bottom:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-bottom:before {\n  border-bottom-color: #fff;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-left:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-left:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-left:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-left:before {\n  border-left-color: #fff;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-xaxistooltip-right:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.light.apexcharts-yaxistooltip-right:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-xaxistooltip-right:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.light.apexcharts-yaxistooltip-right:before {\n  border-right-color: #fff;\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip.dark,\n.apexcharts-canvas .apexcharts-yaxistooltip.dark {\n  background: #1a2229;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-top:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-top:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-top:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-top:before {\n  border-top-color: #1a2229;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-bottom:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-bottom:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-bottom:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-bottom:before {\n  border-bottom-color: #1a2229;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-left:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-left:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-left:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-left:before {\n  border-left-color: #1a2229;\n}\n\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-xaxistooltip-right:before,\n.apexcharts-canvas\n  .apexcharts-xaxistooltip.dark.apexcharts-yaxistooltip-right:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-xaxistooltip-right:before,\n.apexcharts-canvas\n  .apexcharts-yaxistooltip.dark.apexcharts-yaxistooltip-right:before {\n  border-right-color: #1a2229;\n}\n\n.apexcharts-canvas .apexcharts-legend.center .apexcharts-legend-series,\n.apexcharts-canvas .apexcharts-legend.left .apexcharts-legend-series,\n.apexcharts-canvas .apexcharts-legend.right .apexcharts-legend-series {\n  padding: 5px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.apexcharts-canvas\n  .apexcharts-legend.center\n  .apexcharts-legend-series\n  .apexcharts-legend-marker,\n.apexcharts-canvas\n  .apexcharts-legend.left\n  .apexcharts-legend-series\n  .apexcharts-legend-marker,\n.apexcharts-canvas\n  .apexcharts-legend.right\n  .apexcharts-legend-series\n  .apexcharts-legend-marker {\n  margin-right: 5px;\n  width: 8px !important;\n  height: 8px !important;\n}\n\n.bootstrap-calendar .calendar {\n  background: #fff;\n  border: 0;\n  padding: 7px 0 10px;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.bootstrap-calendar .calendar .table.header {\n  padding: 0;\n  margin: 0 0 2px;\n  position: relative;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.bootstrap-calendar .calendar .table.header td {\n  width: 45px;\n  padding: 5px 15px;\n  vertical-align: middle;\n  border: 0;\n}\n\n.bootstrap-calendar .calendar .table.header td.year {\n  width: calc(100% - 90px);\n}\n\n.bootstrap-calendar .calendar .table.header td .icon-arrow-left,\n.bootstrap-calendar .calendar .table.header td .icon-arrow-right,\n.bootstrap-calendar .calendar .table.header td .visualmonthyear {\n  height: 100%;\n  font-size: 16px;\n  font-weight: 600;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.bootstrap-calendar .calendar .table.header td .icon-arrow-left,\n.bootstrap-calendar .calendar .table.header td .icon-arrow-right {\n  cursor: pointer;\n  font-size: 14px;\n  color: #c6ced5;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.bootstrap-calendar .calendar .table.header td .icon-arrow-left:before {\n  content: \"\\f060\";\n}\n\n.bootstrap-calendar .calendar .table.header td .icon-arrow-right:before {\n  content: \"\\f061\";\n}\n\n.bootstrap-calendar .calendar .table.daysmonth {\n  margin: 0;\n}\n\n.bootstrap-calendar .calendar .table.daysmonth tr td {\n  border: 0;\n  padding: 7px 10px;\n  font-weight: 600;\n  color: #6f8293;\n}\n\n.bootstrap-calendar .calendar .table.daysmonth tr td a {\n  display: block;\n  text-shadow: none;\n  width: 26px;\n  height: 26px;\n  line-height: 26px;\n  margin: -4px auto;\n  -webkit-border-radius: 20px;\n  border-radius: 20px;\n}\n\n.bootstrap-calendar .calendar .table.daysmonth tr td.event {\n  background: 0 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.bootstrap-calendar .calendar .table.daysmonth tr.week_days td {\n  background: 0 0;\n  color: #4e5c68;\n  font-weight: 700;\n}\n\nbody .bootstrap-colorpalette .btn-color {\n  width: 19px;\n  height: 19px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody .bootstrap-colorpalette .btn-color:focus,\nbody .bootstrap-colorpalette .btn-color:hover {\n  outline: 0;\n  border: 1px solid rgba(0, 0, 0, 0.5) !important;\n}\n\nbody .datetimepicker .datetimepicker-hours table,\nbody .datetimepicker .datetimepicker-minutes table {\n  min-width: 220px;\n}\n\nbody .datetimepicker .glyphicon {\n  font-size: 14px;\n  color: #2d353c;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody .datetimepicker .glyphicon.glyphicon-chevron-up:before {\n  content: \"\\f106\";\n}\n\nbody .datetimepicker .glyphicon.glyphicon-chevron-down:before {\n  content: \"\\f107\";\n}\n\nbody .datetimepicker .glyphicon.icon-arrow-left:before {\n  content: \"\\f104\";\n}\n\nbody .datetimepicker .glyphicon.icon-arrow-right:before {\n  content: \"\\f105\";\n}\n\nbody .datetimepicker .glyphicon.glyphicon-time:before {\n  content: \"\\f017\";\n}\n\nbody .datetimepicker .glyphicon.glyphicon-calendar:before {\n  content: \"\\f133\";\n}\n\nbody .datetimepicker.dropdown-menu {\n  max-width: 320px;\n  min-width: 200px;\n  width: auto;\n  padding: 5px;\n  color: #2d353c;\n  overflow: hidden;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n@media (max-width: 575.98px) {\n  body .datetimepicker.dropdown-menu {\n    max-width: 250px;\n  }\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.next,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.picker-switch,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.prev,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.next,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tfoot\n  tr\n  th.switch,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.today,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.next,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.today,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table tfoot tr th.next,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table tfoot tr th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tfoot\n  tr\n  th.today,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table thead tr th.next,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table thead tr th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.next,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.next,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.next,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tfoot\n  tr\n  th.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.today,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table tfoot tr th.next,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table tfoot tr th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tfoot\n  tr\n  th.today,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table thead tr th.next,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table thead tr th.prev,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.today {\n  padding: 5px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tfoot tr th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table thead tr th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table tfoot tr th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table thead tr th.dow,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tfoot\n  tr\n  th.dow,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  thead\n  tr\n  th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-months table tfoot tr th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-months table thead tr th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table tfoot tr th.dow,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table thead tr th.dow,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-hours,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-minutes,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-picker {\n  padding: 5px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td .hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td .year,\nbody .datetimepicker.dropdown-menu .datetimepicker-days table tbody tr td.day,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year,\nbody .datetimepicker.dropdown-menu .datetimepicker-hours table tbody tr td.day,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year,\nbody .datetimepicker.dropdown-menu .datetimepicker-months table tbody tr td.day,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year,\nbody .datetimepicker.dropdown-menu .datetimepicker-years table tbody tr td.day {\n  padding: 7px 9px;\n  height: auto;\n  line-height: 16px !important;\n  color: #6f8293;\n  font-weight: 600;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.active {\n  color: #fff;\n  background: #348fe2 !important;\n  text-shadow: none;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.active:hover {\n  text-shadow: none;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .hour.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .minute.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.timepicker-second {\n  border: 1px solid #d5dbe0;\n  display: block;\n  width: 80px;\n  margin: 0 auto;\n  line-height: 22px;\n  height: auto;\n  padding: 6px 15px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.today,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.today {\n  background: #e4e7ea;\n  color: #2d353c;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.today:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.today:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.today:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.today:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.today:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.today:before {\n  border-bottom-color: #9ba8b4;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.today.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.today.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.today.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.today.active,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.today.active {\n  color: #fff;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.today.active:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.today.active:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.today.active:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-minutes\n  table\n  tbody\n  tr\n  td.day.today.active:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.today.active:before,\nbody\n  .datetimepicker.dropdown-menu\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.today.active:before {\n  border-bottom-color: #bad9f5;\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .datepicker {\n  padding: 5px;\n  width: 320px;\n}\n\n@media (max-width: 575.98px) {\n  body .datetimepicker.dropdown-menu > ul > li .datepicker {\n    width: 250px;\n  }\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .timepicker {\n  width: auto;\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .timepicker .timepicker-picker {\n  width: 200px;\n  margin: 0 auto;\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td {\n  padding: 0;\n  height: auto;\n  line-height: inherit;\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td .btn span,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.hour,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.minute {\n  padding: 10px;\n  height: auto;\n  line-height: 16px !important;\n  color: #6f8293;\n  font-weight: 600;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.picker-switch:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.picker-switch:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.prev:hover,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.hour:focus,\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute:hover {\n  color: #2d353c;\n  background: #f2f3f4;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.active,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.active {\n  color: #fff;\n  background: #2d353c !important;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.active:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.active:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.active:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.active:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.active:hover {\n  text-shadow: none;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.timepicker-second,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.timepicker-second {\n  border: 1px solid #d5dbe0;\n  display: block;\n  width: 80px;\n  margin: 0 auto;\n  line-height: 22px;\n  height: auto;\n  padding: 6px 15px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td.separator {\n  width: 1%;\n}\n\nbody .datetimepicker.dropdown-menu > ul > li .timepicker table tr td .btn {\n  padding: 0;\n  border: 0;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.next:focus,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.next:hover,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.prev:focus,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.prev:hover,\nbody .daterangepicker.show-ranges .ranges ul li:focus,\nbody .daterangepicker.show-ranges .ranges ul li:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span:hover {\n  background: #f2f3f4;\n  color: #2d353c;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.active {\n  color: #fff;\n  background: #2d353c !important;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.timepicker-minute,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.timepicker-second {\n  border: 1px solid #d5dbe0;\n  display: block;\n  width: 80px;\n  margin: 0 auto;\n  line-height: 22px;\n  height: auto;\n  padding: 6px 15px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn.btn-primary {\n  padding: 5px 15px;\n  background: #9ba8b4;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn.btn-primary:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn.btn-primary:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn.btn-primary:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn.btn-primary:hover {\n  background: #6f8293;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-hour,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-minute {\n  height: auto;\n  line-height: 30px;\n  border: 1px solid #d5dbe0;\n}\n\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-hour:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-hour:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-minute:focus,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-minute:hover {\n  background: 0 0;\n  border-color: #9ba8b4;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li.picker-switch\n  table\n  tbody\n  tr\n  td\n  span,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li.picker-switch\n  table\n  tbody\n  tr\n  td\n  span {\n  display: block;\n  width: auto;\n  margin: -1px 0 0;\n  background: #f2f3f4;\n  height: 36px;\n  line-height: 36px;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li.picker-switch\n  table\n  tbody\n  tr\n  td\n  span:hover,\nbody\n  .datetimepicker.dropdown-menu\n  > ul\n  > li.picker-switch\n  table\n  tbody\n  tr\n  td\n  span:hover {\n  background: #eceff1;\n}\n\nbody .colorpicker:before,\nbody .datetimepicker.dropdown-menu.bottom:before {\n  display: none;\n}\n\nbody .datetimepicker.dropdown-menu.bottom:after {\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #fff;\n  top: -7px;\n  left: 15px;\n}\n\nbody .datetimepicker.dropdown-menu.bottom.pull-right:after {\n  left: auto;\n  right: 15px;\n}\n\nbody .datetimepicker + .input-group-addon {\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n  -webkit-border-bottom-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\ndiv .bootstrap-select .btn:active,\ndiv .bootstrap-select .btn:focus {\n  outline: 0 !important;\n}\n\ndiv .bootstrap-select .btn.dropdown-toggle:after {\n  content: \"\";\n  border: 5px solid transparent;\n  border-top-color: rgba(255, 255, 255, 0.5);\n  position: relative;\n  top: 3px;\n}\n\ndiv .bootstrap-select .btn.btn-light,\ndiv .bootstrap-select .btn.btn-white {\n  color: #7e8f9e !important;\n}\n\ndiv .bootstrap-select .btn.btn-light.dropdown-toggle:after,\ndiv .bootstrap-select .btn.btn-white.dropdown-toggle:after {\n  border-top-color: rgba(45, 53, 60, 0.5);\n}\n\ndiv .bootstrap-select .btn.bs-placeholder {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\ndiv .bootstrap-select .btn.bs-placeholder:active,\ndiv .bootstrap-select .btn.bs-placeholder:focus,\ndiv .bootstrap-select .btn.bs-placeholder:hover {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\ndiv .bootstrap-select .dropdown-menu .bs-searchbox {\n  padding: 0 8px 8px;\n}\n\n.icon-eye-close,\n.icon-eye-open {\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.icon-eye-open:before {\n  content: \"\\f06e\";\n}\n\n.icon-eye-close:before {\n  content: \"\\f070\";\n}\n\n.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-hour,\n.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-meridian,\n.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-minute {\n  width: 40px;\n  height: 34px;\n  border: 1px solid #d5dbe0;\n  padding: 6px;\n  background: #fff;\n  color: #2d353c;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.bootstrap-timepicker-widget table tbody tr td .bootstrap-timepicker-hour:focus,\n.bootstrap-timepicker-widget\n  table\n  tbody\n  tr\n  td\n  .bootstrap-timepicker-meridian:focus,\n.bootstrap-timepicker-widget\n  table\n  tbody\n  tr\n  td\n  .bootstrap-timepicker-minute:focus {\n  border-color: #5db0ff;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n}\n\n.bootstrap-timepicker-widget table tbody tr td .glyphicon {\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.bootstrap-timepicker-widget\n  table\n  tbody\n  tr\n  td\n  .glyphicon.glyphicon-chevron-up:before {\n  content: \"\\f077\";\n}\n\n.bootstrap-timepicker-widget\n  table\n  tbody\n  tr\n  td\n  .glyphicon.glyphicon-chevron-down:before {\n  content: \"\\f078\";\n}\n\n.bootstrap-timepicker-widget table tbody tr td a {\n  border: 0;\n  color: #6f8293;\n  padding: 5px;\n  -webkit-border-radius: 4px !important;\n  border-radius: 4px !important;\n}\n\n.bootstrap-timepicker-widget table tbody tr td a:focus,\n.bootstrap-timepicker-widget table tbody tr td a:hover {\n  background: #e4e7ea;\n  color: #2d353c;\n}\n\n.bootstrap-timepicker-widget table tbody tr td.separator {\n  padding: 0 5px;\n}\n\n.bootstrap-timepicker-widget.dropdown-menu {\n  padding: 5px !important;\n  -webkit-border-radius: 6px !important;\n  border-radius: 6px !important;\n  -webkit-box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2) !important;\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2) !important;\n}\n\n.bootstrap-timepicker-widget:before,\n.dropzone .dz-preview .dz-error-mark svg,\n.sw-main.sw-theme-default .step-anchor > li > a:after {\n  display: none !important;\n}\n\n.bootstrap-timepicker-widget:after {\n  left: 12px !important;\n  top: -7px !important;\n  border-width: 7px !important;\n}\n\n.bootstrap-timepicker-widget.timepicker-orient-bottom:after {\n  top: auto !important;\n  bottom: -7px;\n}\n\n.cke,\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_scroll\n  .dataTables_scrollBody\n  .dataTable\n  thead\n  tr\n  th,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_scroll\n  .dataTables_scrollBody\n  .dataTable\n  thead\n  tr\n  th,\nbody .DTFC_ScrollWrapper .DTFC_LeftBodyWrapper .dataTable thead tr th,\nbody .DTFC_ScrollWrapper .DTFC_RightBodyWrapper .dataTable thead tr th,\nbody .DTFC_ScrollWrapper .dataTables_scrollBody .dataTable thead tr th {\n  border: 0 !important;\n}\n\n.cke .cke_bottom,\n.cke .cke_top {\n  border-color: #d5dbe0;\n  background: #f2f4f5;\n}\n\n.cke .cke_top .cke_button_off:focus,\n.cke .cke_top .cke_button_off:hover,\n.cke .cke_top .cke_combo_button:focus,\n.cke .cke_top .cke_combo_button:hover {\n  border-color: #d5dbe0;\n  background: #d5dbe0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.cke .cke_top .cke_button_on,\n.cke .cke_top .cke_combo_on {\n  background: #fff;\n  border-color: #d5dbe0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.cke .cke_bottom .cke_resizer {\n  border-right-color: #9ba8b4;\n}\n\nbody .colorpicker {\n  border: 0;\n  padding: 5px;\n  z-index: 1010;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody .colorpicker .colorpicker-hue {\n  margin-bottom: 5px;\n  margin-left: 5px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody .colorpicker .colorpicker-alpha {\n  margin-bottom: 5px;\n  margin-left: 5px;\n}\n\nbody .colorpicker .colorpicker-saturation {\n  margin-bottom: 5px;\n}\n\nbody .colorpicker .colorpicker-saturation i {\n  border-color: rgba(0, 0, 0, 0.25);\n}\n\nbody .colorpicker .colorpicker-alpha,\nbody .colorpicker .colorpicker-alpha div,\nbody .colorpicker .colorpicker-bar,\nbody .colorpicker .colorpicker-bar div,\nbody .colorpicker .colorpicker-color,\nbody .colorpicker .colorpicker-color div,\nbody .colorpicker .colorpicker-saturation {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody .colorpicker .colorpicker-bar {\n  margin-top: 5px;\n}\n\nbody .colorpicker:after {\n  border-width: 7px;\n  top: -7px;\n}\n\nbody .colorpicker.colorpicker-left:after {\n  left: 12px;\n}\n\nbody .colorpicker.colorpicker-right:after {\n  right: 12px;\n}\n\nbody .colorpicker.colorpicker-with-alpha {\n  width: 168px;\n}\n\nbody .colorpicker-component .input-group-addon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\nbody .colorpicker-bs-popover .popover-body {\n  padding: 5px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td,\nbody\n  .colorpicker-bs-popover\n  .popover-body\n  .colorpicker-popup.colorpicker-bs-popover-content {\n  padding: 0;\n}\n\n.combobox + .input-group-addon,\n.combobox + .typeahead + .input-group-addon {\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n  -webkit-border-bottom-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.combobox-container {\n  width: 100%;\n}\n\n.combobox-container .input-group .combobox {\n  width: auto;\n  border: 1px solid #d5dbe0;\n  background: #fff;\n  display: block;\n  height: 34px;\n  padding: 6px 12px;\n  color: #2d353c;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.combobox-container .input-group .combobox:focus {\n  outline: 0;\n  border-color: #5db0ff !important;\n  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n}\n\n.combobox-container .input-group .input-group-addon {\n  width: 35px;\n}\n\n.combobox-container .input-group .input-group-addon .caret {\n  margin: 0;\n}\n\n.combobox-container .input-group .input-group-addon .glyphicon,\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button\n  .fc-icon\n  .fc-icon-left-single-arrow,\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button\n  .fc-icon\n  .fc-icon-right-single-arrow {\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.combobox-container\n  .input-group\n  .input-group-addon\n  .glyphicon.glyphicon-remove:before {\n  content: \"\\f00d\";\n}\n\n.combobox-container .input-group .input-group-addon.dropdown-toggle:before,\nbody .datepicker .datepicker-centuries table thead tr th.next i,\nbody .datepicker .datepicker-centuries table thead tr th.prev i,\nbody .datepicker .datepicker-days table thead tr th.next i,\nbody .datepicker .datepicker-days table thead tr th.prev i,\nbody .datepicker .datepicker-decades table thead tr th.next i,\nbody .datepicker .datepicker-decades table thead tr th.prev i,\nbody .datepicker .datepicker-months table thead tr th.next i,\nbody .datepicker .datepicker-months table thead tr th.prev i,\nbody .datepicker .datepicker-years table thead tr th.next i,\nbody .datepicker .datepicker-years table thead tr th.prev i,\nbody .datepicker.dropdown-menu:before,\nbody .daterangepicker:before,\nbody table.dataTable thead tr th.sorting:before,\nbody table.dataTable thead tr th.sorting_asc:before,\nbody table.dataTable thead tr th.sorting_desc:before {\n  display: none;\n}\n\n.combobox-container .input-group .typeahead.dropdown-menu > li > a {\n  padding: 5px 15px;\n  font-weight: 600;\n  color: #4e5c68;\n  text-decoration: none;\n  display: block;\n}\n\n.combobox-container .input-group .typeahead.dropdown-menu > li > a:focus,\n.combobox-container .input-group .typeahead.dropdown-menu > li > a:hover,\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_paginate\n  .pagination\n  .paginate_button\n  a:focus,\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_paginate\n  .pagination\n  .paginate_button\n  a:hover,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_paginate\n  .pagination\n  .paginate_button\n  a:focus,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_paginate\n  .pagination\n  .paginate_button\n  a:hover {\n  color: #2d353c;\n  background: #f2f4f5;\n}\n\nbody div.dt-autofill-background,\nbody table.dataTable.fixedHeader-floating {\n  z-index: 1030;\n}\n\nbody div.dt-autofill-list {\n  z-index: 1040;\n  border: 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody div.dt-autofill-list ul > li .dt-autofill-question {\n  padding: 15px;\n  border-color: #d5dbe0;\n  font-weight: 600;\n  color: #4e5c68;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\nbody div.dt-autofill-list ul > li .dt-autofill-button {\n  padding: 15px;\n  width: 120px;\n  border-color: #d5dbe0;\n}\n\nbody div.dt-autofill-list ul > li .dt-autofill-button .btn {\n  display: block;\n  width: 100%;\n  position: relative;\n  color: transparent;\n  background: #348fe2;\n  border-color: #348fe2;\n}\n\nbody div.dt-autofill-list ul > li .dt-autofill-button .btn:focus,\nbody div.dt-autofill-list ul > li .dt-autofill-button .btn:hover {\n  background: #1968b0;\n  border-color: #1968b0;\n}\n\nbody div.dt-autofill-list ul > li .dt-autofill-button .btn:before {\n  content: \"Fill This\";\n  color: #fff;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\nbody div.dt-autofill-list ul > li:first-child {\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\nbody div.dt-autofill-list ul > li:last-child {\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.century:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.century:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.decade:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.decade:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.hour:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.hour:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.month:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.month:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.year:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.year:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.switch:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.switch:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.century:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.century:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.decade:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.decade:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.hour:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.hour:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.month:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.month:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.year:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.year:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.century:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.century:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.decade:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.decade:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.hour:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.hour:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.month:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.month:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.year:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.year:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.switch:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.switch:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.century:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.century:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.decade:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.decade:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.hour:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.hour:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.month:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.month:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.year:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.year:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.century:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.century:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.decade:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.decade:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.hour:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.hour:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.month:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.month:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.year:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.year:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.century:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.century:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.decade:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.decade:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.hour:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.hour:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.month:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.month:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.year:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.year:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch:hover,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  table\n  tfoot\n  .today:focus,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  table\n  tfoot\n  .today:hover,\nbody .datepicker .datepicker-centuries table tbody tr td span.century:focus,\nbody .datepicker .datepicker-centuries table tbody tr td span.century:hover,\nbody .datepicker .datepicker-centuries table tbody tr td span.decade:focus,\nbody .datepicker .datepicker-centuries table tbody tr td span.decade:hover,\nbody .datepicker .datepicker-centuries table tbody tr td span.month:focus,\nbody .datepicker .datepicker-centuries table tbody tr td span.month:hover,\nbody .datepicker .datepicker-centuries table tbody tr td span.year:focus,\nbody .datepicker .datepicker-centuries table tbody tr td span.year:hover,\nbody\n  .datepicker\n  .datepicker-centuries\n  table\n  thead\n  tr\n  th.datepicker-switch:focus,\nbody\n  .datepicker\n  .datepicker-centuries\n  table\n  thead\n  tr\n  th.datepicker-switch:hover,\nbody .datepicker .datepicker-centuries table thead tr th.next:focus,\nbody .datepicker .datepicker-centuries table thead tr th.next:hover,\nbody .datepicker .datepicker-centuries table thead tr th.prev:focus,\nbody .datepicker .datepicker-centuries table thead tr th.prev:hover,\nbody .datepicker .datepicker-days table tbody tr td span.century:focus,\nbody .datepicker .datepicker-days table tbody tr td span.century:hover,\nbody .datepicker .datepicker-days table tbody tr td span.decade:focus,\nbody .datepicker .datepicker-days table tbody tr td span.decade:hover,\nbody .datepicker .datepicker-days table tbody tr td span.month:focus,\nbody .datepicker .datepicker-days table tbody tr td span.month:hover,\nbody .datepicker .datepicker-days table tbody tr td span.year:focus,\nbody .datepicker .datepicker-days table tbody tr td span.year:hover,\nbody .datepicker .datepicker-days table thead tr th.datepicker-switch:focus,\nbody .datepicker .datepicker-days table thead tr th.datepicker-switch:hover,\nbody .datepicker .datepicker-days table thead tr th.next:focus,\nbody .datepicker .datepicker-days table thead tr th.next:hover,\nbody .datepicker .datepicker-days table thead tr th.prev:focus,\nbody .datepicker .datepicker-days table thead tr th.prev:hover,\nbody .datepicker .datepicker-decades table tbody tr td span.century:focus,\nbody .datepicker .datepicker-decades table tbody tr td span.century:hover,\nbody .datepicker .datepicker-decades table tbody tr td span.decade:focus,\nbody .datepicker .datepicker-decades table tbody tr td span.decade:hover,\nbody .datepicker .datepicker-decades table tbody tr td span.month:focus,\nbody .datepicker .datepicker-decades table tbody tr td span.month:hover,\nbody .datepicker .datepicker-decades table tbody tr td span.year:focus,\nbody .datepicker .datepicker-decades table tbody tr td span.year:hover,\nbody .datepicker .datepicker-decades table thead tr th.datepicker-switch:focus,\nbody .datepicker .datepicker-decades table thead tr th.datepicker-switch:hover,\nbody .datepicker .datepicker-decades table thead tr th.next:focus,\nbody .datepicker .datepicker-decades table thead tr th.next:hover,\nbody .datepicker .datepicker-decades table thead tr th.prev:focus,\nbody .datepicker .datepicker-decades table thead tr th.prev:hover,\nbody .datepicker .datepicker-months table tbody tr td span.century:focus,\nbody .datepicker .datepicker-months table tbody tr td span.century:hover,\nbody .datepicker .datepicker-months table tbody tr td span.decade:focus,\nbody .datepicker .datepicker-months table tbody tr td span.decade:hover,\nbody .datepicker .datepicker-months table tbody tr td span.month:focus,\nbody .datepicker .datepicker-months table tbody tr td span.month:hover,\nbody .datepicker .datepicker-months table tbody tr td span.year:focus,\nbody .datepicker .datepicker-months table tbody tr td span.year:hover,\nbody .datepicker .datepicker-months table thead tr th.datepicker-switch:focus,\nbody .datepicker .datepicker-months table thead tr th.datepicker-switch:hover,\nbody .datepicker .datepicker-months table thead tr th.next:focus,\nbody .datepicker .datepicker-months table thead tr th.next:hover,\nbody .datepicker .datepicker-months table thead tr th.prev:focus,\nbody .datepicker .datepicker-months table thead tr th.prev:hover,\nbody .datepicker .datepicker-years table tbody tr td span.century:focus,\nbody .datepicker .datepicker-years table tbody tr td span.century:hover,\nbody .datepicker .datepicker-years table tbody tr td span.decade:focus,\nbody .datepicker .datepicker-years table tbody tr td span.decade:hover,\nbody .datepicker .datepicker-years table tbody tr td span.month:focus,\nbody .datepicker .datepicker-years table tbody tr td span.month:hover,\nbody .datepicker .datepicker-years table tbody tr td span.year:focus,\nbody .datepicker .datepicker-years table tbody tr td span.year:hover,\nbody .datepicker .datepicker-years table thead tr th.datepicker-switch:focus,\nbody .datepicker .datepicker-years table thead tr th.datepicker-switch:hover,\nbody .datepicker .datepicker-years table thead tr th.next:focus,\nbody .datepicker .datepicker-years table thead tr th.next:hover,\nbody .datepicker .datepicker-years table thead tr th.prev:focus,\nbody .datepicker .datepicker-years table thead tr th.prev:hover,\nbody .datepicker table tfoot .today:focus,\nbody .datepicker table tfoot .today:hover,\nbody div.dt-autofill-list ul > li:focus,\nbody div.dt-autofill-list ul > li:hover {\n  background: #f2f4f5;\n}\n\nbody div.dt-button-info {\n  border: 0;\n  padding: 15px;\n  background: rgba(45, 53, 60, 0.95);\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody div.dt-button-info h2 {\n  border: 0;\n  background: 0 0;\n  padding: 0;\n  font-weight: 600;\n  margin: 0;\n  font-size: 24px;\n  color: #e4e7ea;\n}\n\nbody div.dt-button-info > div {\n  padding: 0;\n  margin-top: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ba8b4;\n}\n\nbody div.DTCR_pointer {\n  width: 2px;\n  background: #348fe2;\n  margin-left: -1px;\n}\n\nbody table.dataTable {\n  border-collapse: collapse !important;\n}\n\nbody table.dataTable thead tr th.sorting:after {\n  color: #c6ced5;\n}\n\nbody table.dataTable thead tr th.sorting:after,\nbody table.dataTable thead tr th.sorting_asc:after,\nbody table.dataTable thead tr th.sorting_desc:after {\n  opacity: 1;\n  bottom: 8px;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody table.dataTable thead tr th.sorting:after {\n  content: \"\\f0dc\";\n}\n\nbody table.dataTable thead tr th.sorting_asc:after {\n  content: \"\\f0dd\";\n  color: #348fe2;\n}\n\nbody table.dataTable thead tr th.sorting_desc:after {\n  content: \"\\f0de\";\n  color: #348fe2;\n}\n\nbody table.dataTable tbody tr td.focus {\n  outline: 0;\n  z-index: 10;\n  position: relative;\n  -webkit-box-shadow: inset 0 0 0 2px #348fe2;\n  box-shadow: inset 0 0 0 2px #348fe2;\n}\n\nbody table.dataTable tbody tr td:focus {\n  outline: 0;\n}\n\nbody table.dataTable tbody tr.selected td {\n  background: #fff7cc;\n  color: #665700;\n  font-weight: 600;\n}\n\nbody table.dataTable tbody tr.dt-rowReorder-moving {\n  outline: 2px solid #9ba8b4;\n}\n\nbody table.dataTable.dt-rowReorder-float {\n  outline: 2px solid #348fe2;\n}\n\nbody table.dataTable.collapsed tbody tr td:first-child:before {\n  background: #d5dbe0 !important;\n  color: #4e5c68 !important;\n  border: 0 !important;\n  top: 10px !important;\n  left: 8px !important;\n  line-height: 16px !important;\n  font-weight: 700 !important;\n  height: 16px !important;\n  width: 16px !important;\n  text-align: center !important;\n  text-indent: 0 !important;\n  font-size: 14px !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  -webkit-border-radius: 3px !important;\n  border-radius: 3px !important;\n}\n\nbody .DTFC_ScrollWrapper {\n  margin: 0 0 15px;\n}\n\nbody .DTFC_ScrollWrapper .DTFC_LeftWrapper .dataTable,\nbody .DTFC_ScrollWrapper .DTFC_RightWrapper .dataTable,\nbody .DTFC_ScrollWrapper .dataTables_scroll .dataTable {\n  margin: 0 !important;\n}\n\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_scroll\n  .dataTables_scrollBody\n  .dataTable,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_scroll\n  .dataTables_scrollBody\n  .dataTable,\nbody .DTFC_ScrollWrapper .DTFC_LeftBodyWrapper .dataTable,\nbody .DTFC_ScrollWrapper .DTFC_RightBodyWrapper .dataTable,\nbody .DTFC_ScrollWrapper .dataTables_scrollBody .dataTable {\n  border-bottom: none !important;\n}\n\n.dataTables_wrapper.dt-bootstrap.DTS .dataTables_scroll .dataTables_scrollBody,\n.dataTables_wrapper.dt-bootstrap4.DTS .dataTables_scroll .dataTables_scrollBody,\nbody .DTFC_ScrollWrapper .dataTables_scroll {\n  border-bottom: 1px solid #e4e7ea;\n}\n\n.dataTables_wrapper.dt-bootstrap,\n.dataTables_wrapper.dt-bootstrap4 {\n  display: block;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_length,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_length {\n  margin-bottom: 15px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_length .custom-select,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_length .custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n@media (min-width: 576px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_length,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_length {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n  }\n}\n\n@media (min-width: 768px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_length + .dt-buttons,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_length + .dt-buttons {\n    margin-left: 10px;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_length label .form-control,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_length label .form-control {\n  display: block;\n  margin: 0 8px;\n  height: 34px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_filter,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_filter {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_filter,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_filter {\n    float: right;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_filter label,\n.dataTables_wrapper.dt-bootstrap .dataTables_length label,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_filter label,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_length label {\n  color: #4e5c68;\n  font-weight: 600;\n  margin: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_filter label .form-control,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_filter label .form-control {\n  display: block;\n  margin-left: 8px;\n  width: 260px;\n  height: 34px;\n}\n\n@media (max-width: 991.98px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_filter label .form-control,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_filter label .form-control {\n    width: 100%;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTable,\n.dataTables_wrapper.dt-bootstrap4 .dataTable {\n  margin: 0 0 15px !important;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_info,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_info {\n  font-weight: 600;\n  color: #6f8293;\n}\n\n@media (max-width: 575.98px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_info,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_info {\n    padding-bottom: 8px;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_paginate,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_paginate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n@media (min-width: 576px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_paginate .pagination,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_paginate .pagination {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .dataTables_wrapper.dt-bootstrap .dataTables_paginate .pagination,\n  .dataTables_wrapper.dt-bootstrap4 .dataTables_paginate .pagination {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_paginate\n  .pagination\n  .paginate_button\n  a,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_paginate\n  .pagination\n  .paginate_button\n  a {\n  position: relative;\n  display: block;\n  padding: 8px 12px;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #6f8293;\n  background-color: #fff;\n  border: 1px solid #d5dbe0;\n  font-weight: 600;\n  text-decoration: none;\n  outline: 0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_paginate\n  .pagination\n  .paginate_button.active\n  a,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_paginate\n  .pagination\n  .paginate_button.active\n  a {\n  border-color: #348fe2;\n  background: #348fe2;\n  color: #fff;\n}\n\n.dataTables_wrapper.dt-bootstrap\n  .dataTables_paginate\n  .pagination\n  .paginate_button.disabled\n  a,\n.dataTables_wrapper.dt-bootstrap4\n  .dataTables_paginate\n  .pagination\n  .paginate_button.disabled\n  a {\n  color: #9ba8b4 !important;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff !important;\n  border-color: #d5dbe0 !important;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-autofill-handle,\n.dataTables_wrapper.dt-bootstrap4 .dt-autofill-handle {\n  background: #348fe2;\n  border-color: #348fe2;\n  margin-left: 1px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-autofill-select,\n.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select {\n  background: #348fe2;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-autofill-select.left,\n.dataTables_wrapper.dt-bootstrap .dt-autofill-select.top,\n.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.left,\n.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.top {\n  margin-left: 1px;\n  margin-top: 0;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-autofill-select.right,\n.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.right {\n  margin-left: -1px;\n  margin-top: 0;\n  margin-bottom: -1px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-autofill-select.bottom,\n.dataTables_wrapper.dt-bootstrap4 .dt-autofill-select.bottom {\n  margin-left: 1px;\n  margin-top: -2px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-buttons,\n.dataTables_wrapper.dt-bootstrap4 .dt-buttons {\n  margin-bottom: 15px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dt-buttons .btn,\n.dataTables_wrapper.dt-bootstrap4 .dt-buttons .btn {\n  padding: 6px 12px;\n  line-height: 20px;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_scroll,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_scroll {\n  margin: 0 0 15px !important;\n}\n\n.dataTables_wrapper.dt-bootstrap .dataTables_scroll .dataTable,\n.dataTables_wrapper.dt-bootstrap4 .dataTables_scroll .dataTable {\n  margin: 0 !important;\n}\n\nbody .datepicker {\n  color: #2d353c;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\nbody .datepicker table {\n  width: 100%;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch,\nbody .datepicker .datepicker-centuries table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-centuries table thead tr th.next,\nbody .datepicker .datepicker-centuries table thead tr th.prev,\nbody .datepicker .datepicker-days table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-days table thead tr th.next,\nbody .datepicker .datepicker-days table thead tr th.prev,\nbody .datepicker .datepicker-decades table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-decades table thead tr th.next,\nbody .datepicker .datepicker-decades table thead tr th.prev,\nbody .datepicker .datepicker-months table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-months table thead tr th.next,\nbody .datepicker .datepicker-months table thead tr th.prev,\nbody .datepicker .datepicker-years table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-years table thead tr th.next,\nbody .datepicker .datepicker-years table thead tr th.prev {\n  line-height: 20px;\n  padding: 5px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody .datepicker .datepicker-centuries table thead tr th.next,\nbody .datepicker .datepicker-centuries table thead tr th.prev,\nbody .datepicker .datepicker-days table thead tr th.next,\nbody .datepicker .datepicker-days table thead tr th.prev,\nbody .datepicker .datepicker-decades table thead tr th.next,\nbody .datepicker .datepicker-decades table thead tr th.prev,\nbody .datepicker .datepicker-months table thead tr th.next,\nbody .datepicker .datepicker-months table thead tr th.prev,\nbody .datepicker .datepicker-years table thead tr th.next,\nbody .datepicker .datepicker-years table thead tr th.prev {\n  color: transparent;\n  width: 14.28%;\n  position: relative;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody .datepicker .datepicker-centuries table thead tr th.next:before,\nbody .datepicker .datepicker-centuries table thead tr th.prev:before,\nbody .datepicker .datepicker-days table thead tr th.next:before,\nbody .datepicker .datepicker-days table thead tr th.prev:before,\nbody .datepicker .datepicker-decades table thead tr th.next:before,\nbody .datepicker .datepicker-decades table thead tr th.prev:before,\nbody .datepicker .datepicker-months table thead tr th.next:before,\nbody .datepicker .datepicker-months table thead tr th.prev:before,\nbody .datepicker .datepicker-years table thead tr th.next:before,\nbody .datepicker .datepicker-years table thead tr th.prev:before {\n  color: #6f8293;\n  position: absolute;\n  font-size: 14px;\n  height: 14px;\n  top: 50%;\n  margin-top: -7px;\n  line-height: 1;\n}\n\nbody .datepicker .datepicker-centuries table thead tr th.prev:before,\nbody .datepicker .datepicker-days table thead tr th.prev:before,\nbody .datepicker .datepicker-decades table thead tr th.prev:before,\nbody .datepicker .datepicker-months table thead tr th.prev:before,\nbody .datepicker .datepicker-years table thead tr th.prev:before {\n  content: \"\\f104\";\n}\n\nbody .datepicker .datepicker-centuries table thead tr th.next:before,\nbody .datepicker .datepicker-days table thead tr th.next:before,\nbody .datepicker .datepicker-decades table thead tr th.next:before,\nbody .datepicker .datepicker-months table thead tr th.next:before,\nbody .datepicker .datepicker-years table thead tr th.next:before {\n  content: \"\\f105\";\n}\n\nbody .datepicker .datepicker-centuries table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-days table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-decades table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-months table thead tr th.datepicker-switch,\nbody .datepicker .datepicker-years table thead tr th.datepicker-switch {\n  width: auto;\n}\n\nbody .datepicker .datepicker-centuries table thead tr th.dow,\nbody .datepicker .datepicker-days table thead tr th.dow,\nbody .datepicker .datepicker-decades table thead tr th.dow,\nbody .datepicker .datepicker-months table thead tr th.dow,\nbody .datepicker .datepicker-years table thead tr th.dow {\n  padding: 5px 0;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  thead\n  tr\n  th.dow,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  .timepicker-hours,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  .timepicker-minutes,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  .timepicker-picker,\nbody .datepicker .datepicker-centuries table tbody tr td,\nbody .datepicker .datepicker-days table tbody tr td,\nbody .datepicker .datepicker-decades table tbody tr td,\nbody .datepicker .datepicker-months table tbody tr td,\nbody .datepicker .datepicker-years table tbody tr td {\n  padding: 5px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.century,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.decade,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.hour,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.month,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.year,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.century,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.decade,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.hour,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.month,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.year,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.century,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.decade,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.hour,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.month,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.year,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.century,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.decade,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.hour,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.month,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.year,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.century,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.decade,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.hour,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.month,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.year,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.century,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.decade,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.hour,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.month,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.year,\nbody .datepicker .datepicker-centuries table tbody tr td span.century,\nbody .datepicker .datepicker-centuries table tbody tr td span.decade,\nbody .datepicker .datepicker-centuries table tbody tr td span.month,\nbody .datepicker .datepicker-centuries table tbody tr td span.year,\nbody .datepicker .datepicker-days table tbody tr td span.century,\nbody .datepicker .datepicker-days table tbody tr td span.decade,\nbody .datepicker .datepicker-days table tbody tr td span.month,\nbody .datepicker .datepicker-days table tbody tr td span.year,\nbody .datepicker .datepicker-decades table tbody tr td span.century,\nbody .datepicker .datepicker-decades table tbody tr td span.decade,\nbody .datepicker .datepicker-decades table tbody tr td span.month,\nbody .datepicker .datepicker-decades table tbody tr td span.year,\nbody .datepicker .datepicker-months table tbody tr td span.century,\nbody .datepicker .datepicker-months table tbody tr td span.decade,\nbody .datepicker .datepicker-months table tbody tr td span.month,\nbody .datepicker .datepicker-months table tbody tr td span.year,\nbody .datepicker .datepicker-years table tbody tr td span.century,\nbody .datepicker .datepicker-years table tbody tr td span.decade,\nbody .datepicker .datepicker-years table tbody tr td span.month,\nbody .datepicker .datepicker-years table tbody tr td span.year {\n  font-weight: 600;\n  color: #6f8293;\n  text-shadow: none;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td span.century.focused,\nbody .datepicker .datepicker-centuries table tbody tr td span.decade.focused,\nbody .datepicker .datepicker-centuries table tbody tr td span.month.focused,\nbody .datepicker .datepicker-centuries table tbody tr td span.year.focused,\nbody .datepicker .datepicker-days table tbody tr td span.century.focused,\nbody .datepicker .datepicker-days table tbody tr td span.decade.focused,\nbody .datepicker .datepicker-days table tbody tr td span.month.focused,\nbody .datepicker .datepicker-days table tbody tr td span.year.focused,\nbody .datepicker .datepicker-decades table tbody tr td span.century.focused,\nbody .datepicker .datepicker-decades table tbody tr td span.decade.focused,\nbody .datepicker .datepicker-decades table tbody tr td span.month.focused,\nbody .datepicker .datepicker-decades table tbody tr td span.year.focused,\nbody .datepicker .datepicker-months table tbody tr td span.century.focused,\nbody .datepicker .datepicker-months table tbody tr td span.decade.focused,\nbody .datepicker .datepicker-months table tbody tr td span.month.focused,\nbody .datepicker .datepicker-months table tbody tr td span.year.focused,\nbody .datepicker .datepicker-years table tbody tr td span.century.focused,\nbody .datepicker .datepicker-years table tbody tr td span.decade.focused,\nbody .datepicker .datepicker-years table tbody tr td span.month.focused,\nbody .datepicker .datepicker-years table tbody tr td span.year.focused {\n  background: #e4e7ea;\n  color: #2d353c;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td span.century.active,\nbody .datepicker .datepicker-centuries table tbody tr td span.decade.active,\nbody .datepicker .datepicker-centuries table tbody tr td span.month.active,\nbody .datepicker .datepicker-centuries table tbody tr td span.year.active,\nbody .datepicker .datepicker-days table tbody tr td span.century.active,\nbody .datepicker .datepicker-days table tbody tr td span.decade.active,\nbody .datepicker .datepicker-days table tbody tr td span.month.active,\nbody .datepicker .datepicker-days table tbody tr td span.year.active,\nbody .datepicker .datepicker-decades table tbody tr td span.century.active,\nbody .datepicker .datepicker-decades table tbody tr td span.decade.active,\nbody .datepicker .datepicker-decades table tbody tr td span.month.active,\nbody .datepicker .datepicker-decades table tbody tr td span.year.active,\nbody .datepicker .datepicker-months table tbody tr td span.century.active,\nbody .datepicker .datepicker-months table tbody tr td span.decade.active,\nbody .datepicker .datepicker-months table tbody tr td span.month.active,\nbody .datepicker .datepicker-months table tbody tr td span.year.active,\nbody .datepicker .datepicker-years table tbody tr td span.century.active,\nbody .datepicker .datepicker-years table tbody tr td span.decade.active,\nbody .datepicker .datepicker-years table tbody tr td span.month.active,\nbody .datepicker .datepicker-years table tbody tr td span.year.active {\n  background: #348fe2 !important;\n  color: #fff;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day,\nbody .datepicker .datepicker-centuries table tbody tr td.day,\nbody .datepicker .datepicker-days table tbody tr td.day,\nbody .datepicker .datepicker-decades table tbody tr td.day,\nbody .datepicker .datepicker-months table tbody tr td.day,\nbody .datepicker .datepicker-years table tbody tr td.day {\n  font-weight: 600;\n  color: #4e5c68;\n  padding: 5px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td.day.highlighted,\nbody .datepicker .datepicker-centuries table tbody tr td.day.range,\nbody .datepicker .datepicker-centuries table tbody tr td.day.selected,\nbody .datepicker .datepicker-centuries table tbody tr td.day:focus,\nbody .datepicker .datepicker-centuries table tbody tr td.day:hover,\nbody .datepicker .datepicker-days table tbody tr td.day.highlighted,\nbody .datepicker .datepicker-days table tbody tr td.day.range,\nbody .datepicker .datepicker-days table tbody tr td.day.selected,\nbody .datepicker .datepicker-days table tbody tr td.day:focus,\nbody .datepicker .datepicker-days table tbody tr td.day:hover,\nbody .datepicker .datepicker-decades table tbody tr td.day.highlighted,\nbody .datepicker .datepicker-decades table tbody tr td.day.range,\nbody .datepicker .datepicker-decades table tbody tr td.day.selected,\nbody .datepicker .datepicker-decades table tbody tr td.day:focus,\nbody .datepicker .datepicker-decades table tbody tr td.day:hover,\nbody .datepicker .datepicker-months table tbody tr td.day.highlighted,\nbody .datepicker .datepicker-months table tbody tr td.day.range,\nbody .datepicker .datepicker-months table tbody tr td.day.selected,\nbody .datepicker .datepicker-months table tbody tr td.day:focus,\nbody .datepicker .datepicker-months table tbody tr td.day:hover,\nbody .datepicker .datepicker-years table tbody tr td.day.highlighted,\nbody .datepicker .datepicker-years table tbody tr td.day.range,\nbody .datepicker .datepicker-years table tbody tr td.day.selected,\nbody .datepicker .datepicker-years table tbody tr td.day:focus,\nbody .datepicker .datepicker-years table tbody tr td.day:hover {\n  background: #f2f4f5;\n  text-shadow: none;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day.today,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.today,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day.today,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.today,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.today,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.today,\nbody .datepicker .datepicker-centuries table tbody tr td.day.today,\nbody .datepicker .datepicker-days table tbody tr td.day.today,\nbody .datepicker .datepicker-decades table tbody tr td.day.today,\nbody .datepicker .datepicker-months table tbody tr td.day.today,\nbody .datepicker .datepicker-years table tbody tr td.day.today {\n  background: #e4e7ea !important;\n  color: #2d353c;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.active,\nbody .datepicker .datepicker-centuries table tbody tr td.day.active,\nbody .datepicker .datepicker-days table tbody tr td.day.active,\nbody .datepicker .datepicker-decades table tbody tr td.day.active,\nbody .datepicker .datepicker-months table tbody tr td.day.active,\nbody .datepicker .datepicker-years table tbody tr td.day.active {\n  background: #348fe2 !important;\n  color: #fff;\n  text-shadow: none !important;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td.day.range,\nbody .datepicker .datepicker-days table tbody tr td.day.range,\nbody .datepicker .datepicker-decades table tbody tr td.day.range,\nbody .datepicker .datepicker-months table tbody tr td.day.range,\nbody .datepicker .datepicker-years table tbody tr td.day.range {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td.day.range-start,\nbody .datepicker .datepicker-days table tbody tr td.day.range-start,\nbody .datepicker .datepicker-decades table tbody tr td.day.range-start,\nbody .datepicker .datepicker-months table tbody tr td.day.range-start,\nbody .datepicker .datepicker-years table tbody tr td.day.range-start {\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\n.datepicker .input-daterange .input-group-addon + .form-control,\nbody .datepicker .datepicker-centuries table tbody tr td.day.range-end,\nbody .datepicker .datepicker-days table tbody tr td.day.range-end,\nbody .datepicker .datepicker-decades table tbody tr td.day.range-end,\nbody .datepicker .datepicker-months table tbody tr td.day.range-end,\nbody .datepicker .datepicker-years table tbody tr td.day.range-end {\n  -webkit-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td.day.old,\nbody .datepicker .datepicker-days table tbody tr td.day.old,\nbody .datepicker .datepicker-decades table tbody tr td.day.old,\nbody .datepicker .datepicker-months table tbody tr td.day.old,\nbody .datepicker .datepicker-years table tbody tr td.day.old {\n  color: #c6ced5;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td.day.new,\nbody .datepicker .datepicker-days table tbody tr td.day.new,\nbody .datepicker .datepicker-decades table tbody tr td.day.new,\nbody .datepicker .datepicker-months table tbody tr td.day.new,\nbody .datepicker .datepicker-years table tbody tr td.day.new {\n  color: #9ba8b4;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day.old,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.old,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day.old,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.old,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.old,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.old,\nbody .datepicker .datepicker-centuries table tbody tr td.day.disabled,\nbody .datepicker .datepicker-days table tbody tr td.day.disabled,\nbody .datepicker .datepicker-decades table tbody tr td.day.disabled,\nbody .datepicker .datepicker-months table tbody tr td.day.disabled,\nbody .datepicker .datepicker-years table tbody tr td.day.disabled {\n  color: #c6ced5;\n}\n\nbody .datepicker .datepicker-centuries table tbody tr td.day.disabled:focus,\nbody .datepicker .datepicker-centuries table tbody tr td.day.disabled:hover,\nbody .datepicker .datepicker-days table tbody tr td.day.disabled:focus,\nbody .datepicker .datepicker-days table tbody tr td.day.disabled:hover,\nbody .datepicker .datepicker-decades table tbody tr td.day.disabled:focus,\nbody .datepicker .datepicker-decades table tbody tr td.day.disabled:hover,\nbody .datepicker .datepicker-months table tbody tr td.day.disabled:focus,\nbody .datepicker .datepicker-months table tbody tr td.day.disabled:hover,\nbody .datepicker .datepicker-years table tbody tr td.day.disabled:focus,\nbody .datepicker .datepicker-years table tbody tr td.day.disabled:hover {\n  background: 0 0;\n}\n\nbody .datepicker.datepicker-inline {\n  display: block;\n  width: auto;\n  padding: 0;\n}\n\nbody .datepicker.dropdown-menu {\n  min-width: 250px;\n  width: 320px;\n  border: 0;\n  font-family: inherit;\n  font-size: 12px;\n  -webkit-box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);\n}\n\n@media (max-width: 575.98px) {\n  body .datepicker.dropdown-menu {\n    width: 250px;\n  }\n}\n\nbody .datepicker.dropdown-menu.datepicker-orient-left:after {\n  left: 15px;\n}\n\nbody .datepicker.dropdown-menu.datepicker-orient-right:after {\n  right: 15px;\n}\n\nbody .datepicker.dropdown-menu.datepicker-orient-top {\n  margin-bottom: 7px;\n}\n\nbody .datepicker.dropdown-menu.datepicker-orient-bottom {\n  margin-top: 7px;\n}\n\n.datepicker .input-daterange .input-group-addon,\nbody .input-daterange .input-group-addon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.datepicker .input-daterange .input-group-addon {\n  margin: 0;\n  font-weight: 600;\n  background: #d5dbe0;\n  color: #6f8293;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\nbody .input-daterange .input-group-addon {\n  font-size: 12px;\n  line-height: 1;\n  min-width: 30px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\nbody .daterangepicker {\n  z-index: 1020;\n  border: 0;\n  font-family: inherit;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);\n}\n\nbody .daterangepicker:after {\n  border-width: 7px;\n  top: -7px;\n  left: 10px;\n}\n\nbody .daterangepicker .drp-calendar {\n  max-width: inherit;\n  padding: 15px;\n}\n\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th {\n  min-width: auto;\n  width: auto;\n  height: auto;\n  line-height: 1;\n  padding: 7px;\n  color: #2d353c;\n  font-weight: 700;\n  border: 0;\n}\n\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th.next span,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.prev\n  span {\n  border-color: #2d353c;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.month\n  .monthselect,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.month\n  .yearselect {\n  border-color: #d5dbe0;\n  background: #fff;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.month\n  .monthselect:focus,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr\n  th.month\n  .yearselect:focus {\n  outline: 0;\n  border-color: #5db0ff;\n  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  thead\n  tr:last-child\n  th {\n  padding-bottom: 14px;\n}\n\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td {\n  min-width: auto;\n  width: auto;\n  height: auto;\n  line-height: 1;\n  padding: 7px 9px;\n  font-weight: 600;\n  color: #2d353c;\n  border: 0;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available:focus,\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available:hover {\n  background: #f2f3f4;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available.in-range {\n  background: #e7f1fc;\n  color: #10416d;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available.active {\n  background: #348fe2;\n  color: #fff;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available.start-date {\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\nbody\n  .daterangepicker\n  .drp-calendar\n  .calendar-table\n  table\n  tbody\n  tr\n  td.available.end-date {\n  -webkit-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n}\n\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.off {\n  background: 0 0;\n  color: #c6ced5;\n}\n\nbody .daterangepicker .drp-calendar.left {\n  padding: 10px !important;\n}\n\nbody .daterangepicker .drp-calendar.left .calendar-table {\n  padding: 0 !important;\n}\n\nbody .daterangepicker .drp-calendar.right {\n  padding: 10px !important;\n  border-left: 1px solid #d5dbe0;\n}\n\n@media (max-width: 575.98px) {\n  body .daterangepicker .drp-calendar.right {\n    border-left: none;\n    border-top: 1px solid #d5dbe0;\n  }\n}\n\nbody .daterangepicker .drp-buttons {\n  padding: 10px;\n  border-color: #d5dbe0;\n}\n\nbody .daterangepicker .drp-buttons .drp-selected,\nbody .daterangepicker.show-ranges .ranges ul li {\n  font-weight: 600;\n  color: #6f8293;\n}\n\nbody .bootstrap-datetimepicker-widget .next:before,\nbody .bootstrap-datetimepicker-widget .prev:before,\nbody .daterangepicker .ranges {\n  display: none;\n}\n\nbody .daterangepicker.show-ranges .ranges {\n  position: relative;\n  display: block;\n}\n\n@media (max-width: 991.98px) {\n  body .daterangepicker.show-ranges .ranges {\n    float: none;\n    margin: 0;\n    padding: 10px;\n    border-bottom: 1px solid #d5dbe0;\n    overflow: scroll;\n    max-width: 560px;\n  }\n\n  body .daterangepicker.show-ranges .ranges ul {\n    width: auto;\n    white-space: nowrap;\n    padding-right: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n\n@media (max-width: 991.98px) {\n  body .daterangepicker.show-ranges .ranges ul li {\n    margin-right: 10px !important;\n    -webkit-border-radius: 4px;\n    border-radius: 4px;\n  }\n}\n\nbody .daterangepicker.show-ranges .ranges ul li.active {\n  background: #348fe2;\n  color: #fff;\n  margin-right: -1px;\n}\n\nbody .daterangepicker.show-ranges .drp-calendar.left {\n  border-left: 1px solid #d5dbe0;\n}\n\n@media (max-width: 991.98px) {\n  body .daterangepicker.show-ranges .drp-calendar.left {\n    border-left: none;\n  }\n}\n\n.dropzone {\n  border: 2px dashed #c6ced5 !important;\n}\n\n.dropzone .dz-message {\n  font-weight: 300 !important;\n  color: inherit !important;\n  font-size: 28px !important;\n  text-align: center !important;\n  margin: 45px 0 !important;\n}\n\n.dropzone .dz-message .dz-note {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  margin-top: 20px;\n  color: #6f8293;\n}\n\n.dropzone .dz-preview .dz-image {\n  -webkit-border-radius: 6px !important;\n  border-radius: 6px !important;\n}\n\n.dropzone .dz-preview .dz-error-message {\n  background: #ff5b57 !important;\n}\n\n.dropzone .dz-preview .dz-error-message:after {\n  border-bottom-color: #ff5b57 !important;\n}\n\n.dropzone,\n.dropzone .dz-preview .dz-details .dz-filename span,\n.dropzone .dz-preview .dz-details .dz-size span {\n  background: 0 0 !important;\n}\n\n.dropzone .dz-preview .dz-error-mark {\n  z-index: 1020 !important;\n}\n\n.dropzone .dz-preview .dz-error-mark:before {\n  content: \"\\f00d\";\n  width: 54px;\n  height: 54px;\n  background: #c6ced5;\n  font-size: 28px;\n  color: #6f8293;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.dropzone .dz-preview .dz-error-mark:focus:before,\n.dropzone .dz-preview .dz-error-mark:hover:before {\n  background: #9ba8b4;\n  color: #4e5c68;\n}\n\n.dropzone .dz-preview.dz-file-preview .dz-image {\n  background: #f2f3f4 !important;\n  -webkit-border-radius: 4px !important;\n  border-radius: 4px !important;\n}\n\n.dropzone .dz-preview.dz-image-preview {\n  background: 0 0 !important;\n}\n\n.dropzone.dz-clickable:focus,\n.dropzone.dz-clickable:hover {\n  background: #f2f3f4 !important;\n}\n\n.dropzone.dz-clickable .dz-message,\n.dropzone.dz-clickable .dz-message * {\n  cursor: pointer;\n}\n\n.dropzone.dz-clickable.dz-started:focus,\n.dropzone.dz-clickable.dz-started:hover {\n  background: 0 0 !important;\n}\n\n.inverse-mode .dropzone {\n  border-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.inverse-mode .dropzone .dz-clickable:focus,\n.inverse-mode .dropzone .dz-clickable:hover {\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n\n.inverse-mode .dropzone .dz-message {\n  color: inherit !important;\n}\n\n.inverse-mode .dropzone .dz-message .dz-note {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\nbody .bootstrap-datetimepicker-widget .glyphicon {\n  font-size: 14px;\n  color: #2d353c;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody .bootstrap-datetimepicker-widget .glyphicon.glyphicon-chevron-up:before {\n  content: \"\\f106\";\n}\n\nbody .bootstrap-datetimepicker-widget .glyphicon.glyphicon-chevron-down:before {\n  content: \"\\f107\";\n}\n\nbody .bootstrap-datetimepicker-widget .glyphicon.glyphicon-chevron-left:before {\n  content: \"\\f104\";\n}\n\nbody\n  .bootstrap-datetimepicker-widget\n  .glyphicon.glyphicon-chevron-right:before {\n  content: \"\\f105\";\n}\n\nbody .bootstrap-datetimepicker-widget .glyphicon.glyphicon-time:before {\n  content: \"\\f017\";\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .add-on\n  i:before,\nbody .bootstrap-datetimepicker-widget .glyphicon.glyphicon-calendar:before {\n  content: \"\\f133\";\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu {\n  max-width: 320px;\n  min-width: 200px;\n  width: auto;\n  padding: 0;\n  color: #2d353c;\n  overflow: hidden;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n@media (max-width: 575.98px) {\n  body .bootstrap-datetimepicker-widget.dropdown-menu {\n    max-width: 250px;\n  }\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu > ul > li .datepicker {\n  padding: 5px;\n  width: 320px;\n}\n\n@media (max-width: 575.98px) {\n  body .bootstrap-datetimepicker-widget.dropdown-menu > ul > li .datepicker {\n    width: 250px;\n  }\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade.active,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month.active,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year.active,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.active,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute.active {\n  color: #fff;\n  background: #348fe2 !important;\n  text-shadow: none;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .decade.timepicker-second,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .month.timepicker-second,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td\n  .year.timepicker-second,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.timepicker-second,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.minute.timepicker-second {\n  border: 1px solid #d5dbe0;\n  display: block;\n  width: 80px;\n  margin: 0 auto;\n  line-height: 22px;\n  height: auto;\n  padding: 6px 15px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.century.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.decade.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.hour.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.month.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.year.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.century.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.decade.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.hour.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.month.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.year.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.century.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.decade.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.hour.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.month.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.year.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.century.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.decade.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.hour.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.month.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.year.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.century.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.decade.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.hour.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.month.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.year.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.century.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.decade.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.hour.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.month.focused,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.year.focused,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.today {\n  background: #e4e7ea;\n  color: #2d353c;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .datepicker\n  table\n  tbody\n  tr\n  td.day.today.active {\n  color: #fff;\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu > ul > li .timepicker {\n  width: auto;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  .timepicker-picker {\n  width: 200px;\n  margin: 0 auto;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td {\n  padding: 0;\n  height: auto;\n  line-height: inherit;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute {\n  padding: 10px;\n  height: auto;\n  line-height: 16px !important;\n  color: #6f8293;\n  font-weight: 600;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute:hover {\n  color: #2d353c;\n  background: #f2f3f4;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.active,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.active {\n  color: #fff;\n  background: #2d353c !important;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.hour.timepicker-second,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.minute.timepicker-second {\n  border: 1px solid #d5dbe0;\n  display: block;\n  width: 80px;\n  margin: 0 auto;\n  line-height: 22px;\n  height: auto;\n  padding: 6px 15px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td.separator {\n  width: 1%;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn {\n  padding: 0;\n  border: 0;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span:hover {\n  background: #f2f3f4;\n  color: #2d353c;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.active {\n  color: #fff;\n  background: #2d353c !important;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.timepicker-minute,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn\n  span.timepicker-second {\n  border: 1px solid #d5dbe0;\n  display: block;\n  width: 80px;\n  margin: 0 auto;\n  line-height: 22px;\n  height: auto;\n  padding: 6px 15px;\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .btn.btn-primary {\n  padding: 5px 15px;\n  background: #9ba8b4;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-hour,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-minute {\n  height: auto;\n  line-height: 30px;\n  border: 1px solid #d5dbe0;\n}\n\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-hour:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-hour:hover,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-minute:focus,\nbody\n  .bootstrap-datetimepicker-widget.dropdown-menu\n  > ul\n  > li\n  .timepicker\n  table\n  tr\n  td\n  .timepicker-minute:hover {\n  background: 0 0;\n  border-color: #9ba8b4;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  table,\nbody .bootstrap-datetimepicker-widget.dropdown-menu > ul > li.picker-switch {\n  width: 100%;\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu > ul > li.collapse.in {\n  display: block;\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\n  display: none;\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #fff;\n  top: -7px;\n  left: 15px;\n}\n\nbody .bootstrap-datetimepicker-widget.dropdown-menu.bottom.pull-right:after {\n  left: auto;\n  right: 15px;\n}\n\nbody .bootstrap-datetimepicker-widget + .input-group-addon {\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n  -webkit-border-bottom-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.legend > table tbody tr td {\n  padding: 4px 0 5px;\n}\n\n.legend > table tbody tr td.legendColorBox {\n  padding-left: 5px !important;\n}\n\n.legend > table tbody tr td.legendColorBox > div {\n  margin-right: 5px !important;\n  border: 0 !important;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\n.legend > table tbody tr td.legendColorBox > div > div {\n  border-width: 4px !important;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\n.legend > table tbody tr td.legendLabel {\n  padding-right: 10px;\n  color: #fff;\n  font-size: 11px;\n}\n\n.flot-tooltip,\n.legend > div {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.legend > div {\n  background: #1a2229 !important;\n}\n\n.flot-text .tickLabel {\n  color: #2d353c;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.flot-tooltip {\n  position: absolute;\n  display: none;\n  border: 0;\n  padding: 6px 10px;\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 600;\n  font-size: 11px;\n  background: rgba(26, 34, 41, 0.85);\n  z-index: 10000 !important;\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 0;\n}\n\n.fc .fc-toolbar.fc-header-toolbar:after,\n.fc .fc-toolbar.fc-header-toolbar:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.fc .fc-toolbar.fc-header-toolbar h2 {\n  font-size: 20px;\n  line-height: 30px;\n  margin-bottom: 10px;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group {\n  margin-bottom: 10px;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button {\n  text-shadow: none;\n  background: #fff;\n  text-transform: capitalize;\n  font-weight: 600;\n  border: 0;\n  padding: 6px 12px;\n  height: auto;\n  color: #9ba8b4;\n  margin: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  -ms-transition: all 0.1s linear;\n  -o-transition: all 0.1s linear;\n  transition: all 0.1s linear;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button + .fc-button {\n  margin-left: 1px;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button .fc-icon {\n  margin: 0 -3px;\n  top: 0;\n}\n\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button\n  .fc-icon\n  .fc-icon-left-single-arrow:after {\n  content: \"\\f0d9\";\n}\n\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button\n  .fc-icon\n  .fc-icon-right-single-arrow:after {\n  content: \"\\f0da\";\n}\n\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button.fc-state-disabled {\n  opacity: 1;\n  color: #9ba8b4;\n  cursor: not-allowed;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-state-active {\n  background: #f2f4f5;\n  color: #2d353c;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button:focus,\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button:hover {\n  color: #2d353c;\n  outline: 0;\n}\n\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-next-button,\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-prev-button,\n.fc .fc-toolbar.fc-header-toolbar .fc-button-group .fc-button.fc-today-button {\n  color: #2d353c;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.switch:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.switch:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.switch:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.switch:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:hover:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch:focus:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch:hover:before,\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button.fc-next-button:focus,\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button.fc-next-button:hover,\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button.fc-prev-button:focus,\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button.fc-prev-button:hover,\n.sw-main.sw-theme-default .step-anchor > li > a:focus,\n.sw-main.sw-theme-default .step-anchor > li > a:hover,\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.gritter-light\n  .gritter-close:focus:before,\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.gritter-light\n  .gritter-close:hover:before {\n  color: #2d353c;\n}\n\n.fc\n  .fc-toolbar.fc-header-toolbar\n  .fc-button-group\n  .fc-button.fc-today-button.fc-state-disabled {\n  color: #9ba8b4;\n  cursor: not-allowed;\n}\n\n.fc .fc-view-container {\n  background: #fff;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th,\n.fc .fc-view-container .fc-body > tr > td.fc-widget-content,\n.fc .fc-view-container .fc-head .fc-head-container {\n  border: 0;\n}\n\n.fc .fc-view-container .fc-head .fc-head-container .fc-widget-header {\n  border-bottom: 1px solid #e4e7ea;\n}\n\n.fc .fc-view-container .fc-head .fc-head-container .fc-widget-header th {\n  background: #f2f4f5;\n  font-weight: 600;\n  color: #2d353c;\n  padding: 2px 15px;\n  border-color: #e4e7ea;\n}\n\n.fc\n  .fc-view-container\n  .fc-head\n  .fc-head-container\n  .fc-widget-header\n  th.fc-axis {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n.fc .fc-view-container .fc-body > tr > td.fc-widget-content .fc-divider {\n  background: #f2f4f5;\n  border-color: #e4e7ea;\n}\n\n.fc .fc-view-container .fc-body .fc-bg td,\n.fc .fc-view-container .fc-body > tr > td.fc-widget-content .fc-widget-content {\n  border-color: #e4e7ea;\n}\n\n.fc .fc-view-container .fc-body .fc-bg td.fc-highlight {\n  background: #d5dbe0;\n}\n\n.fc .fc-view-container .fc-body .fc-bg td.fc-today {\n  background: #fffadb;\n}\n\n.fc .fc-view-container .fc-body .fc-bg td:first-child {\n  border-left: none;\n}\n\n.fc .fc-view-container .fc-body .fc-content-skeleton .fc-day-number {\n  font-weight: 600;\n}\n\n.fc\n  .fc-view-container\n  .fc-body\n  .fc-content-skeleton\n  .fc-event-container\n  .fc-event {\n  border: 0;\n  background: #4e5c68;\n  font-weight: 600;\n  color: #fff;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.fc\n  .fc-view-container\n  .fc-body\n  .fc-content-skeleton\n  .fc-event-container\n  .fc-event.fc-day-grid-event {\n  padding: 1px 2px;\n}\n\n.fc .fc-view-container .fc-body .fc-highlight-skeleton .fc-highlight,\n.jstree\n  .jstree-container-ul\n  .jstree-node\n  .jstree-anchor\n  .jstree-icon.jstree-checkbox.jstree-undetermined:after {\n  background: #d5dbe0;\n}\n\n.fc .fc-scroller {\n  overflow: initial;\n  height: auto !important;\n}\n\n.fc .fc-axis,\n.fc .fc-time {\n  font-weight: 600;\n}\n\n.fc .fc-event,\n.fc a.fc-event {\n  border: 0;\n  background: #4e5c68;\n  font-weight: 600;\n  color: #fff;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.fc .fc-event:focus,\n.fc .fc-event:hover,\n.fc a.fc-event:focus,\n.fc a.fc-event:hover {\n  color: #fff;\n  opacity: 0.85;\n}\n\n.fc .fc-event.fc-day-grid-event,\n.fc a.fc-event.fc-day-grid-event {\n  padding: 1px 2px;\n}\n\n.fc-event-list .fc-event {\n  background: 0 0;\n  border: 0;\n  color: #2d353c;\n  padding: 7px 10px 7px 35px;\n  font-size: 12px;\n  line-height: 16px;\n  position: relative;\n  background: #fff;\n  margin-bottom: 5px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.fc-event-list .fc-event + .fc-event {\n  margin-top: 0;\n}\n\n.fc-event-list .fc-event .fc-event-icon {\n  float: right;\n  margin-left: 10px;\n}\n\n.fc-event-list .fc-event .fc-event-icon i {\n  float: left;\n  line-height: 18px;\n}\n\n.fc-event-list .fc-event.ui-draggable-dragging {\n  border: 1px dashed #d5dbe0;\n}\n\n.fc-event-list .fc-event:before {\n  content: \"\\f0b2\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 25px;\n  text-align: center;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  background: #f2f4f5;\n  color: #c6ced5;\n  font-size: 14px;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\n.fc-event-list .fc-event:focus,\n.fc-event-list .fc-event:hover {\n  color: #2d353c;\n  cursor: pointer;\n  background: #fff;\n}\n\n.fc-event-list .fc-event:focus:before,\n.fc-event-list .fc-event:hover:before {\n  color: #6f8293;\n}\n\nbody #gritter-notice-wrapper {\n  width: 420px;\n  z-index: 1030;\n}\n\n@media (max-width: 575.98px) {\n  body #gritter-notice-wrapper {\n    width: 320px;\n  }\n}\n\n@media (max-width: 359.98px) {\n  body #gritter-notice-wrapper {\n    width: 280px;\n  }\n}\n\nbody #gritter-notice-wrapper .gritter-item-wrapper {\n  background: 0 0;\n  background: rgba(26, 34, 41, 0.9);\n  -webkit-border-radius: 6px;\n  border-radius: 6px;\n}\n\nbody #gritter-notice-wrapper .gritter-item-wrapper .gritter-bottom,\nbody #gritter-notice-wrapper .gritter-item-wrapper .gritter-top {\n  background: 0 0;\n  display: none;\n}\n\nbody #gritter-notice-wrapper .gritter-item-wrapper .gritter-item {\n  font-family: inherit;\n  padding: 12px 95px 12px 15px;\n  background: 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n@media (max-width: 575.98px) {\n  body #gritter-notice-wrapper .gritter-item-wrapper .gritter-item {\n    padding: 10px 70px 10px 10px;\n  }\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-with-image,\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-without-image {\n  float: none;\n  width: auto;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-image {\n  margin: 0 15px 0 0;\n  height: auto;\n  -webkit-border-radius: 80px;\n  border-radius: 80px;\n}\n\n@media (max-width: 575.98px) {\n  body\n    #gritter-notice-wrapper\n    .gritter-item-wrapper\n    .gritter-item\n    .gritter-image {\n    width: 36px;\n    margin-right: 10px;\n  }\n}\n\n@media (max-width: 359.98px) {\n  body\n    #gritter-notice-wrapper\n    .gritter-item-wrapper\n    .gritter-item\n    .gritter-image {\n    width: 24px;\n  }\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-title {\n  font-size: 14px;\n  line-height: 20px;\n  padding-bottom: 0;\n  font-weight: 600;\n  color: #fff;\n  text-shadow: none;\n}\n\n@media (max-width: 575.98px) {\n  body\n    #gritter-notice-wrapper\n    .gritter-item-wrapper\n    .gritter-item\n    .gritter-title {\n    font-size: 12px;\n    line-height: 18px;\n  }\n}\n\nbody #gritter-notice-wrapper .gritter-item-wrapper .gritter-item p {\n  font-size: 11px;\n  line-height: 16px;\n  letter-spacing: 0.15px;\n  color: #c6ced5;\n}\n\n@media (max-width: 575.98px) {\n  body #gritter-notice-wrapper .gritter-item-wrapper .gritter-item p {\n    font-size: 10px;\n    line-height: 14px;\n    letter-spacing: 0;\n  }\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-close {\n  left: auto;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: 0 0;\n  width: 80px;\n  height: auto;\n  display: block !important;\n  font-family: inherit;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  color: #9ba8b4;\n}\n\n@media (max-width: 575.98px) {\n  body\n    #gritter-notice-wrapper\n    .gritter-item-wrapper\n    .gritter-item\n    .gritter-close {\n    width: 60px;\n  }\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-close:before {\n  content: \"Close\";\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  right: 0;\n  left: 0;\n  color: inherit;\n  z-index: 10;\n  text-indent: 0;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 12px;\n  margin-top: -6px;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-close:focus,\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper\n  .gritter-item\n  .gritter-close:hover {\n  color: #fff;\n  outline: 0;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.gritter-light\n  .gritter-bottom,\nbody #gritter-notice-wrapper .gritter-item-wrapper.gritter-light .gritter-item,\nbody #gritter-notice-wrapper .gritter-item-wrapper.gritter-light .gritter-top {\n  background: rgba(255, 255, 255, 0.95);\n  color: #6f8293;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.gritter-light\n  .gritter-item\n  .gritter-title {\n  color: #2d353c;\n  font-weight: 600;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.gritter-light\n  .gritter-item\n  p {\n  color: #4e5c68;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.gritter-light\n  .gritter-close {\n  border-color: #d5dbe0;\n  color: #6f8293;\n}\n\nbody\n  #gritter-notice-wrapper\n  .gritter-item-wrapper.without-rounded-img\n  .gritter-item\n  .gritter-image {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.hljs-wrapper {\n  background: #f2f3f4;\n  position: relative;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.hljs-wrapper pre,\n.hljs-wrapper pre .hljs,\n.hljs-wrapper pre.hljs {\n  border: 0;\n  padding: 0;\n  background: 0 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.hljs-wrapper pre .hljs,\n.hljs-wrapper pre.hljs {\n  padding: 15px;\n  display: block;\n  overflow-x: auto;\n  font-size: 12px;\n  color: #2d353c;\n}\n\n.hljs-wrapper pre .hljs .hljs-deletion,\n.hljs-wrapper pre .hljs .hljs-name,\n.hljs-wrapper pre .hljs .hljs-section,\n.hljs-wrapper pre .hljs .hljs-selector-tag,\n.hljs-wrapper pre .hljs .hljs-subst,\n.hljs-wrapper pre .hljs .hljs-tag,\n.hljs-wrapper pre.hljs .hljs-deletion,\n.hljs-wrapper pre.hljs .hljs-name,\n.hljs-wrapper pre.hljs .hljs-section,\n.hljs-wrapper pre.hljs .hljs-selector-tag,\n.hljs-wrapper pre.hljs .hljs-subst,\n.hljs-wrapper pre.hljs .hljs-tag {\n  color: #1968b0;\n}\n\n.hljs-wrapper pre .hljs .hljs-attr,\n.hljs-wrapper pre .hljs .hljs-number,\n.hljs-wrapper pre .hljs .hljs-selector-attr,\n.hljs-wrapper pre .hljs .hljs-selector-class,\n.hljs-wrapper pre .hljs .hljs-selector-pseudo,\n.hljs-wrapper pre .hljs .hljs-template-variable,\n.hljs-wrapper pre .hljs .hljs-type,\n.hljs-wrapper pre .hljs .hljs-variable,\n.hljs-wrapper pre.hljs .hljs-attr,\n.hljs-wrapper pre.hljs .hljs-number,\n.hljs-wrapper pre.hljs .hljs-selector-attr,\n.hljs-wrapper pre.hljs .hljs-selector-class,\n.hljs-wrapper pre.hljs .hljs-selector-pseudo,\n.hljs-wrapper pre.hljs .hljs-template-variable,\n.hljs-wrapper pre.hljs .hljs-type,\n.hljs-wrapper pre.hljs .hljs-variable {\n  color: #4a9be5;\n}\n\n.hljs-wrapper pre .hljs .hljs-addition,\n.hljs-wrapper pre .hljs .hljs-attribute,\n.hljs-wrapper pre .hljs .hljs-meta-string,\n.hljs-wrapper pre .hljs .hljs-regexp,\n.hljs-wrapper pre .hljs .hljs-string,\n.hljs-wrapper pre.hljs .hljs-addition,\n.hljs-wrapper pre.hljs .hljs-attribute,\n.hljs-wrapper pre.hljs .hljs-meta-string,\n.hljs-wrapper pre.hljs .hljs-regexp,\n.hljs-wrapper pre.hljs .hljs-string {\n  color: #ff3631;\n}\n\n.hljs-wrapper pre .hljs .hljs-comment,\n.hljs-wrapper pre.hljs .hljs-comment {\n  color: #8c9ba9;\n}\n\n.hljs-wrapper .btn-clipboard {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.panel-body + .hljs-wrapper {\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.modal .hljs-wrapper {\n  margin-top: -1px;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.modal .hljs-wrapper + .modal-footer {\n  border-top: none;\n}\n\nbody .introjs-hint .introjs-hint-dot {\n  border-color: rgba(45, 53, 60, 0.3);\n}\n\nbody .introjs-hint .introjs-hint-pulse {\n  background-color: rgba(45, 53, 60, 0.15);\n  border-color: rgba(45, 53, 60, 0.15);\n}\n\nbody .introjs-hint:hover .introjs-hint-pulse {\n  border-color: rgba(45, 53, 60, 0.3);\n  background-color: rgba(45, 53, 60, 0.3);\n}\n\nbody .introjs-overlay {\n  background: #2d353c;\n}\n\nbody .introjs-bullets ul li a {\n  background: #c6ced5;\n}\n\nbody .introjs-helperNumberLayer {\n  font-size: 36px;\n  background: 0 0;\n  color: #fff;\n  font-family: inherit;\n  border: 0;\n  text-shadow: none;\n  padding: 0;\n  text-align: center;\n  width: 36px;\n  height: 36px;\n  line-height: 36px;\n  left: -46px;\n  top: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody .introjs-helperLayer {\n  border: 0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody .introjs-tooltip {\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\nbody .introjs-button {\n  background: #f2f3f4;\n  border-color: #f2f3f4;\n  text-shadow: none;\n  color: #2d353c;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody .introjs-button:focus,\nbody .introjs-button:hover {\n  background: #d5dbe0;\n  border-color: #d5dbe0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody .introjs-button.introjs-nextbutton {\n  border-left-color: #d5dbe0;\n}\n\nbody .introjs-button.introjs-disabled,\nbody .introjs-button.introjs-disabled:focus,\nbody .introjs-button.introjs-disabled:hover {\n  color: #9ba8b4;\n  background: #f2f3f4;\n  border-color: #f2f3f4;\n}\n\nbody .introjs-tooltipbuttons,\nbody ul.wysihtml5-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.irs {\n  font-family: inherit !important;\n}\n\n.irs .irs .irs-line {\n  height: 4px;\n  top: 27px;\n}\n\n.irs .irs .irs-line .irs-line-left,\n.irs .irs .irs-line .irs-line-mid,\n.irs .irs .irs-line .irs-line-right {\n  background: #e4e7ea;\n  height: 4px;\n}\n\n.irs .irs .irs-line .irs-line-left,\n.irs .irs-bar-edge {\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\n.irs .irs .irs-line .irs-line-right {\n  -webkit-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n}\n\n.irs .irs .irs-from,\n.irs .irs .irs-single,\n.irs .irs .irs-to {\n  background: #2d353c;\n}\n\n.irs .irs-bar-edge {\n  background: #e4e7ea;\n  border-right: 1px solid #fff;\n  top: 27px;\n  height: 4px;\n}\n\n.irs .irs-bar {\n  background: #348fe2;\n  height: 4px;\n  top: 27px;\n}\n\n.irs .irs-max,\n.irs .irs-min {\n  font-size: 0.75rem;\n  background: #f2f4f5;\n  color: #4e5c68;\n  font-weight: 600;\n}\n\n.irs .irs-slider {\n  background: #fff;\n  cursor: pointer;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.irs.irs--flat .irs-bar {\n  height: 4px;\n  top: 27px;\n  background: #348fe2;\n}\n\n.irs.irs--flat .irs-handle {\n  height: 14px;\n}\n\n.irs.irs--flat .irs-handle > i:first-child {\n  background: #348fe2;\n  width: 4px;\n}\n\n.irs.irs--flat .irs-handle.state_hover > i:first-child,\n.irs.irs--flat .irs-handle:focus > i:first-child,\n.irs.irs--flat .irs-handle:hover > i:first-child {\n  background: #1a4871;\n}\n\n.irs.irs--big,\n.irs.irs--modern,\n.irs.irs--round,\n.irs.irs--sharp,\n.irs.irs--square {\n  height: 40px;\n}\n\n.irs.irs--big .irs .irs-line {\n  background: #e4e7ea;\n  border: 0;\n}\n\n.irs.irs--big .irs-bar {\n  height: 4px;\n  top: 27px;\n  background: #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--big .irs-handle {\n  top: 20px;\n  width: 20px;\n  height: 20px;\n  background: #fff;\n  border: 0;\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n}\n\n.irs.irs--big .irs-handle.state_hover,\n.irs.irs--big .irs-handle:focus,\n.irs.irs--big .irs-handle:hover {\n  background: #fff;\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);\n}\n\n.irs.irs--modern .irs .irs-line {\n  background: #e4e7ea;\n  border: 0;\n}\n\n.irs.irs--modern .irs-bar {\n  height: 4px;\n  top: 27px;\n  background: #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--modern .irs-handle {\n  width: 12px;\n  border: 0;\n  background: #b6c2c9;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.irs.irs--modern .irs-handle > i:nth-child(1) {\n  background: 0 0;\n  border: 6px solid transparent;\n  border-bottom-color: #b6c2c9;\n  top: -12px;\n  left: 0;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n\n.irs.irs--modern .irs-handle > i:nth-child(2) {\n  background: #b6c2c9;\n  left: 1px;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.irs.irs--modern .irs-handle > i:nth-child(3) {\n  top: 2px;\n  left: 4px;\n  width: 4px;\n  height: 8px;\n  border-color: #edf0f2;\n}\n\n.irs.irs--modern .irs-handle.state_hover,\n.irs.irs--modern .irs-handle:focus,\n.irs.irs--modern .irs-handle:hover {\n  background: #b6c2c9;\n}\n\n.irs.irs--modern .irs-handle.state_hover > i:nth-child(1),\n.irs.irs--modern .irs-handle:focus > i:nth-child(1),\n.irs.irs--modern .irs-handle:hover > i:nth-child(1) {\n  border: 6px solid transparent;\n  border-bottom-color: #b6c2c9;\n}\n\n.irs.irs--modern .irs-handle.state_hover > i:nth-child(2),\n.irs.irs--modern .irs-handle:focus > i:nth-child(2),\n.irs.irs--modern .irs-handle:hover > i:nth-child(2) {\n  background: #b6c2c9;\n}\n\n.irs.irs--modern .irs-handle.state_hover > i:nth-child(3),\n.irs.irs--modern .irs-handle:focus > i:nth-child(3),\n.irs.irs--modern .irs-handle:hover > i:nth-child(3) {\n  border-color: #5b6165;\n}\n\n.irs.irs--sharp .irs .irs-line {\n  background: #e4e7ea;\n  border: 0;\n}\n\n.irs.irs--sharp .irs-bar {\n  height: 4px;\n  top: 27px;\n  background: #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--sharp .irs-handle {\n  top: 23px;\n  background: #67abe9;\n}\n\n.irs.irs--sharp .irs-handle > i:first-child {\n  border-top-color: #67abe9;\n}\n\n.irs.irs--sharp .irs-handle.state_hover,\n.irs.irs--sharp .irs-handle:focus,\n.irs.irs--sharp .irs-handle:hover {\n  background: #2d353c;\n}\n\n.irs.irs--sharp .irs-handle.state_hover > i:first-child,\n.irs.irs--sharp .irs-handle:focus > i:first-child,\n.irs.irs--sharp .irs-handle:hover > i:first-child {\n  border-top-color: #2d353c;\n}\n\n.irs.irs--round .irs-bar {\n  height: 4px;\n  top: 27px;\n  background: #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--round .irs-handle {\n  top: 20px;\n  width: 20px;\n  height: 20px;\n  border: 3px solid #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--square .irs-bar {\n  height: 4px;\n  top: 27px;\n  background: #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--square .irs-handle {\n  top: 21px;\n  width: 16px;\n  height: 16px;\n  border: 3px solid #348fe2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.irs.irs--big .irs-from,\n.irs.irs--big .irs-single,\n.irs.irs--big .irs-to,\n.irs.irs--flat .irs-from,\n.irs.irs--flat .irs-single,\n.irs.irs--flat .irs-to,\n.irs.irs--modern .irs-from,\n.irs.irs--modern .irs-single,\n.irs.irs--modern .irs-to,\n.irs.irs--round .irs-from,\n.irs.irs--round .irs-single,\n.irs.irs--round .irs-to,\n.irs.irs--sharp .irs-from,\n.irs.irs--sharp .irs-single,\n.irs.irs--sharp .irs-to,\n.irs.irs--square .irs-from,\n.irs.irs--square .irs-single,\n.irs.irs--square .irs-to {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.irs.irs--big .irs-from:before,\n.irs.irs--big .irs-single:before,\n.irs.irs--big .irs-to:before,\n.irs.irs--flat .irs-from:before,\n.irs.irs--flat .irs-single:before,\n.irs.irs--flat .irs-to:before,\n.irs.irs--modern .irs-from:before,\n.irs.irs--modern .irs-single:before,\n.irs.irs--modern .irs-to:before,\n.irs.irs--round .irs-from:before,\n.irs.irs--round .irs-single:before,\n.irs.irs--round .irs-to:before,\n.irs.irs--sharp .irs-from:before,\n.irs.irs--sharp .irs-single:before,\n.irs.irs--sharp .irs-to:before,\n.irs.irs--square .irs-from:before,\n.irs.irs--square .irs-single:before,\n.irs.irs--square .irs-to:before {\n  border-top-color: #2d353c;\n}\n\n.irs.irs--big .irs-max,\n.irs.irs--big .irs-min,\n.irs.irs--flat .irs-max,\n.irs.irs--flat .irs-min,\n.irs.irs--modern .irs-max,\n.irs.irs--modern .irs-min,\n.irs.irs--round .irs-max,\n.irs.irs--round .irs-min,\n.irs.irs--sharp .irs-max,\n.irs.irs--sharp .irs-min,\n.irs.irs--square .irs-max,\n.irs.irs--square .irs-min {\n  color: #2d353c;\n  font-size: 11px;\n  font-weight: 600;\n  background: #dbe1e4;\n}\n\n.ui-widget {\n  font-family: inherit;\n}\n\n.ui-widget.ui-autocomplete {\n  padding: 5px 0;\n  border: 0;\n  font-size: 12px;\n  -webkit-box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n  -webkit-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n}\n\n.ui-widget.ui-autocomplete .ui-menu-item-wrapper {\n  padding: 5px 12px;\n}\n\n.ui-widget.ui-autocomplete .ui-menu-item-wrapper.ui-state-active {\n  background: #348fe2;\n  border: 0;\n  color: #fff;\n  margin: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.sw-main.sw-theme-default {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.sw-main.sw-theme-default .step-anchor {\n  background: #f2f3f4;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-border-radius: 4px 4px 0 0;\n  border-radius: 4px 4px 0 0;\n}\n\n@media (max-width: 1199.98px) {\n  .sw-main.sw-theme-default .step-anchor {\n    overflow: scroll;\n    white-space: nowrap;\n  }\n}\n\n.sw-main.sw-theme-default .step-anchor > li {\n  display: block;\n  float: none;\n  padding: 0;\n  margin: 0;\n}\n\n@media (min-width: 992px) {\n  .sw-main.sw-theme-default .step-anchor > li {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n  }\n}\n\n.sw-main.sw-theme-default .step-anchor > li > a {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  padding: 20px !important;\n  margin: 0;\n  color: #2d353c;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n@media (max-width: 1199.98px) {\n  .sw-main.sw-theme-default .step-anchor > li > a {\n    padding: 15px !important;\n  }\n}\n\n.sw-main.sw-theme-default .step-anchor > li > a .number {\n  padding: 0;\n  height: 24px;\n  width: 24px;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  margin-right: 10px;\n  background: #d5dbe0;\n  color: #2d353c;\n  font-weight: 700;\n  position: relative;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.sw-main.sw-theme-default .step-anchor > li > a small {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #6f8293;\n}\n\n.sw-main.sw-theme-default .step-anchor > li.active {\n  background: #348fe2 !important;\n}\n\n.sw-main.sw-theme-default .step-anchor > li.active > a {\n  color: #fff !important;\n}\n\n.sw-main.sw-theme-default .step-anchor > li.active > a .number {\n  background: #276baa;\n  color: #fff;\n}\n\n.sw-main.sw-theme-default .step-anchor > li.active > a small {\n  color: #9ac7f1;\n}\n\n.sw-main.sw-theme-default .step-anchor > li.done > a .number {\n  background: #2d353c !important;\n}\n\n.sw-main.sw-theme-default .step-anchor > li.done > a .number:before {\n  content: \"\\f00c\";\n  background: #2d353c !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: #fff;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n.sw-main.sw-theme-default .sw-container {\n  margin: 0 !important;\n  padding: 0;\n  -webkit-border-radius: 0 !important;\n  border-radius: 0 !important;\n}\n\n.sw-main.sw-theme-default .sw-container .step-content {\n  background: #fff;\n  padding: 20px 30px;\n  border: 0 !important;\n}\n\n@media (max-width: 767.98px) {\n  .sw-main.sw-theme-default .sw-container .step-content {\n    padding: 20px;\n  }\n}\n\n.sw-main.sw-theme-default .sw-toolbar {\n  background: #f2f3f4;\n  padding: 15px;\n}\n\n.sw-main.sw-theme-default .sw-toolbar:after,\n.sw-main.sw-theme-default .sw-toolbar:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.sw-main.sw-theme-default .sw-toolbar .sw-btn-group {\n  margin: 0;\n}\n\n.sw-main.sw-theme-default .sw-toolbar .sw-btn-group .btn {\n  min-width: 100px;\n  -webkit-border-radius: 4px !important;\n  border-radius: 4px !important;\n}\n\n.sw-main.sw-theme-default .sw-toolbar .sw-btn-group .btn + .btn {\n  margin-left: 10px;\n  border-left: none;\n}\n\n.ui-sortable .panel-heading {\n  cursor: move;\n}\n\n.ui-sortable .ui-sortable-placeholder {\n  border: 1px dashed #9ba8b4 !important;\n  visibility: visible !important;\n  background: 0 0 !important;\n  margin: 0 !important;\n}\n\n.ui-sortable .ui-sortable-placeholder.panel {\n  margin: -1px -1px 19px !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.ui-sortable.ui-sortable-disabled .panel-heading {\n  cursor: default;\n}\n\n.jstree .jstree-container-ul .jstree-node {\n  position: relative;\n  background: 0 0 !important;\n}\n\n.jstree .jstree-container-ul .jstree-node:before {\n  content: \"\";\n  position: absolute;\n  left: 10px;\n  top: 0;\n  bottom: 1px;\n  border-left: 1px dotted #c6ced5;\n}\n\n.jstree .jstree-container-ul .jstree-node:last-child:before {\n  bottom: 11px;\n}\n\n.jstree .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl {\n  position: relative;\n  background: 0 0;\n}\n\n.jstree .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  right: 1px;\n  top: 50%;\n  border-top: 1px dotted #c6ced5;\n}\n\n.jstree .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -3px;\n  margin-top: -3px;\n  border: 5px solid transparent;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.jstree .jstree-container-ul .jstree-node .jstree-anchor {\n  color: #6f8293;\n  font-weight: 600;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node\n  .jstree-anchor\n  .jstree-icon.jstree-checkbox {\n  background: 0 0;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node\n  .jstree-anchor\n  .jstree-icon.jstree-checkbox:before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  right: 4px;\n  bottom: 4px;\n  border: 1px solid #d5dbe0;\n  display: block;\n  background: #fff;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node\n  .jstree-anchor\n  .jstree-icon.jstree-checkbox:after {\n  content: \"\";\n  position: absolute;\n  left: 7px;\n  top: 7px;\n  right: 7px;\n  bottom: 7px;\n  display: block;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.jstree .jstree-container-ul .jstree-node .jstree-anchor.jstree-clicked {\n  color: #2d353c;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node\n  .jstree-anchor.jstree-clicked\n  .jstree-icon.jstree-checkbox:after {\n  content: \"\\f00c\";\n  font-size: 10px;\n  line-height: 15px;\n  color: #2d353c;\n  top: 5px;\n  left: 5px;\n  right: 5px;\n  bottom: 5px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td.day.new,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td.day.new,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td.day.new,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td.day.new,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td.day.new,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td.day.new,\n.jstree .jstree-container-ul .jstree-node .jstree-anchor.jstree-disabled {\n  color: #9ba8b4;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node\n  .jstree-anchor.jstree-disabled\n  > .jstree-icon {\n  opacity: 0.4;\n  -webkit-filter: none;\n  filter: none;\n}\n\n.jstree .jstree-container-ul .jstree-node .jstree-hovered,\n.jstree .jstree-container-ul .jstree-node .jstree-wholerow-hovered {\n  background: 0 0;\n  color: #2d353c;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.jstree .jstree-container-ul .jstree-node .jstree-clicked,\n.jstree .jstree-container-ul .jstree-node .jstree-wholerow-clicked {\n  background: #f2f3f4;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node.jstree-open\n  .jstree-anchor\n  > .fa-folder:before {\n  content: \"\\f07c\";\n  color: #9ba8b4;\n}\n\n.jstree\n  .jstree-container-ul\n  .jstree-node.jstree-open\n  .jstree-anchor.jstree-clicked\n  > .fa-folder:before {\n  color: #2d353c;\n}\n\n.jstree .jstree-container-ul .jstree-node.jstree-open > .jstree-ocl:after {\n  border-left-color: #9ba8b4;\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.jstree .jstree-container-ul .jstree-node.jstree-closed > .jstree-ocl:after {\n  border-left-color: #9ba8b4;\n  margin-top: -5px;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n\n.jvectormap-container .jvectormap-zoomin,\n.jvectormap-container .jvectormap-zoomout {\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  line-height: 16px;\n  left: 15px;\n  color: #2d353c;\n  background: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.jvectormap-container .jvectormap-label {\n  padding: 3px 6px;\n  border: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.jvectormap-tip {\n  padding: 3px 6px !important;\n  border: 0 !important;\n  background: rgba(0, 0, 0, 0.6) !important;\n}\n\n.map .jvectormap-zoomin,\n.map .jvectormap-zoomout {\n  width: 20px !important;\n  height: 20px !important;\n  font-size: 14px;\n  line-height: 20px !important;\n  left: 30px !important;\n}\n\n@media (max-width: 767.98px) {\n  .map .jvectormap-zoomin,\n  .map .jvectormap-zoomout {\n    left: 20px !important;\n  }\n}\n\n.map .jvectormap-zoomin {\n  top: 70px;\n}\n\n@media (max-width: 1199.98px) {\n  .map .jvectormap-zoomin {\n    top: 100px;\n  }\n}\n\n.map .jvectormap-zoomout {\n  top: 95px;\n}\n\n@media (max-width: 1199.98px) {\n  .map .jvectormap-zoomout {\n    top: 125px;\n  }\n}\n\n.material-icons {\n  text-rendering: optimizeLegibility;\n}\n\n.morris-hover {\n  z-index: 0 !important;\n}\n\n.morris-hover.morris-default-style {\n  padding: 6px 10px;\n  color: #2d353c;\n  background: #f2f3f4;\n  border: 0;\n  font-family: inherit;\n  font-size: 12px;\n  text-align: center;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\n.morris-inverse .morris-hover {\n  background: rgba(26, 34, 41, 0.85) !important;\n  border: 0 !important;\n  padding: 10px !important;\n  color: #fff !important;\n  -webkit-border-radius: 8px !important;\n  border-radius: 8px !important;\n}\n\nhtml .nvd3-svg {\n  direction: ltr;\n}\n\nhtml .nvtooltip {\n  font-family: inherit;\n  font-size: 12px;\n  border: 0;\n  padding: 5px 10px;\n  background: rgba(255, 255, 255, 0.95);\n  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\nhtml .nvtooltip table thead tr th strong {\n  text-decoration: underline;\n}\n\nhtml .nvtooltip table tbody td.legend-color-guide div {\n  border: 0;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\nhtml .nvd3-inverse-mode .nvd3 line.nv-guideline {\n  stroke: rgba(255, 255, 255, 0.5);\n}\n\nhtml .nvd3-inverse-mode .nvd3 .nv-bars text {\n  fill: #fff;\n}\n\nhtml .nvd3-inverse-mode .nvd3 .nv-axis line,\nhtml .nvd3-inverse-mode .nvd3 .nv-axis path {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.15);\n}\n\nhtml .nvd3-inverse-mode .nvd3 .nv-legend-text,\nhtml .nvd3-inverse-mode .nvd3 .nv-x text,\nhtml .nvd3-inverse-mode .nvd3 .nv-y text {\n  font-family: inherit;\n  fill: rgba(255, 255, 255, 0.75);\n  font-size: 11px;\n  font-weight: 600;\n}\n\nhtml .nvd3-inverse-mode .nvd3 .nv-label text {\n  fill: rgba(255, 255, 255, 0.75) !important;\n}\n\nhtml .nvd3-inverse-mode .nvd3 .nv-legend-symbol {\n  r: 3;\n}\n\nhtml .nvd3-inverse-mode .nvd3.nv-pie .nv-pie-title {\n  fill: rgba(255, 255, 255, 0.75);\n}\n\nhtml .nvd3-inverse-mode .nvd3.nv-pie path {\n  stroke: rgba(0, 0, 0, 0.2);\n}\n\n.pace-top .pace .pace-progress {\n  top: 0 !important;\n}\n\n.pace-top .pace .pace-activity {\n  top: 15px !important;\n}\n\n.pace {\n  background: 0 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1030;\n  opacity: 1;\n  -webkit-transition: opacity 1s;\n  -moz-transition: opacity 1s;\n  -ms-transition: opacity 1s;\n  -o-transition: opacity 1s;\n  transition: opacity 1s;\n}\n\n.pace .pace-progress {\n  top: 50px;\n  height: 3px;\n  background: #00acac;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n@media (max-width: 767.98px) {\n  .pace .pace-progress {\n    top: 101px;\n  }\n}\n\n.pace .pace-progress .pace-progress-inner {\n  display: none;\n}\n\n.pace .pace-activity {\n  display: block;\n  position: fixed;\n  z-index: 1030;\n  top: 63px;\n  right: 10px;\n  width: 15px;\n  height: 15px;\n  border: 2px solid transparent;\n  border-top-color: #00acac;\n  border-left-color: #00acac;\n  -webkit-animation: pace-spinner 400ms linear infinite;\n  -moz-animation: pace-spinner 400ms linear infinite;\n  -ms-animation: pace-spinner 400ms linear infinite;\n  -o-animation: pace-spinner 400ms linear infinite;\n  animation: pace-spinner 400ms linear infinite;\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n}\n\n@media (max-width: 767.98px) {\n  .pace .pace-activity {\n    top: 113px;\n  }\n}\n\n.pace.pace-inactive {\n  display: block;\n  opacity: 0;\n}\n\n.pace-done .pace.pace-inactive {\n  display: block;\n}\n\n.parsley-error {\n  background: #fff !important;\n  border-color: #ff5b57 !important;\n  color: #2d353c !important;\n}\n\n.parsley-error:focus {\n  border-color: #ff5b57 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.125rem rgba(255, 91, 87, 0.3) !important;\n  box-shadow: 0 0 0 0.125rem rgba(255, 91, 87, 0.3) !important;\n}\n\n.parsley-success {\n  background: #fff !important;\n  border-color: #00acac !important;\n  color: #2d353c !important;\n}\n\n.parsley-success:focus {\n  border-color: #00acac !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.125rem rgba(0, 172, 172, 0.3) !important;\n  box-shadow: 0 0 0 0.125rem rgba(0, 172, 172, 0.3) !important;\n}\n\n.parsley-errors-list {\n  padding: 0 !important;\n  list-style-type: none !important;\n  margin: 0 !important;\n  color: #ff100b;\n  font-size: 12px !important;\n  line-height: inherit !important;\n}\n\n.parsley-errors-list.filled {\n  margin-top: 5px !important;\n}\n\n.slider-wrapper {\n  padding: 15px 30px;\n}\n\n.slider-wrapper .range-bar {\n  background: #e4e7ea;\n}\n\n.slider-wrapper .range-bar .range-max,\n.slider-wrapper .range-bar .range-min {\n  color: #2d353c;\n}\n\n.slider-wrapper .range-bar .range-handle {\n  cursor: pointer;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n}\n\n.slider-wrapper .range-bar .range-quantity {\n  background: #348fe2;\n}\n\n.slider-wrapper.red .range-bar .range-quantity {\n  background: #ff5b57;\n}\n\n.slider-wrapper.teal .range-bar .range-quantity {\n  background: #00acac;\n}\n\n.slider-wrapper.purple .range-bar .range-quantity {\n  background: #727cb6;\n}\n\n.slider-wrapper.orange .range-bar .range-quantity {\n  background: #f59c1a;\n}\n\n.slider-wrapper.black .range-bar .range-quantity {\n  background: #2d353c;\n}\n\n.slider-wrapper.slider-without-range {\n  padding: 15px 0;\n}\n\n.slider-wrapper.slider-vertical {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.pwstrength-progress .progress {\n  height: 12px;\n  -webkit-border-radius: 60px;\n  border-radius: 60px;\n}\n\n.pwstrength-progress .progress .progress-bar {\n  min-width: 10% !important;\n}\n\nbody .select2-container .select2-choice {\n  height: auto !important;\n  line-height: 18px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  background: 0 0 !important;\n  margin-right: -5px;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\nbody .select2-container .select2-choice .select2-chosen {\n  font-weight: 600;\n  color: #9ba8b4;\n}\n\nbody .select2-container .select2-choice .select2-search-choice-close {\n  background: #e4e7ea !important;\n  font-size: 9px;\n  text-align: center;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  color: #9ba8b4;\n  top: 1px;\n  right: 20px;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  -webkit-border-radius: 20px;\n  border-radius: 20px;\n}\n\nbody .select2-container .select2-choice .select2-search-choice-close:before {\n  content: \"\\f00d\";\n}\n\nbody .select2-container .select2-choice .select2-search-choice-close:focus,\nbody .select2-container .select2-choice .select2-search-choice-close:hover {\n  background: #c6ced5 !important;\n  color: #6f8293;\n}\n\nbody .select2-container .select2-choice .select2-arrow {\n  background: 0 0;\n  border: 0;\n  display: block;\n  width: 14px;\n  text-align: center;\n  right: -1px;\n  top: 1px;\n}\n\nbody .select2-container .select2-choice .select2-arrow b,\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-choice\n  .select2-search-choice-close {\n  background: 0 0 !important;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody .select2-container .select2-choice .select2-arrow b:before {\n  content: \"\\f078\";\n  color: #c6ced5;\n}\n\nbody .select2-container.select2-container-multi .select2-choices {\n  padding: 0;\n  border: 0;\n  background: 0 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-choice {\n  margin: 0 5px 5px 0;\n  background: #e4e7ea;\n  color: #6f8293;\n  font-weight: 600;\n  border: 0;\n  padding: 3px 3px 3px 6px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-choice\n  .select2-search-choice-close {\n  position: relative;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin-left: 5px;\n  color: #c6ced5;\n}\n\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-choice\n  .select2-search-choice-close:before {\n  content: \"\\f00d\";\n  font-size: 12px;\n}\n\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-choice\n  .select2-search-choice-close:focus,\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-choice\n  .select2-search-choice-close:hover {\n  color: #6f8293;\n  text-decoration: none;\n}\n\nbody\n  .select2-container.select2-container-multi\n  .select2-choices\n  .select2-search-field\n  input {\n  padding: 0 !important;\n  height: 19px !important;\n}\n\nbody .select2-drop {\n  margin-top: -3px;\n}\n\nbody .select2-drop .select2-results {\n  padding: 0;\n  margin: 5px 0;\n}\n\nbody .select2-drop .select2-results .select2-result {\n  font-weight: 600;\n  color: #2d353c;\n}\n\nbody .select2-drop .select2-results .select2-result.select2-highlighted {\n  background: #d5dbe0 !important;\n  color: #2d353c;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date,\nbody .select2-drop .select2-search {\n  position: relative;\n}\n\nbody .select2-drop .select2-search input {\n  border: 1px solid #d5dbe0;\n  background: 0 0 !important;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\nbody .select2-drop .select2-search input:focus {\n  border-color: #5db0ff;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\nbody .select2-drop .select2-search:before {\n  content: \"\\f002\";\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  margin-top: -5px;\n  font-size: 12px;\n  line-height: 14px;\n  color: #c6ced5;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody .select2-drop.select2-drop-active {\n  border-color: #d5dbe0;\n}\n\nbody .select2-drop.select2-drop-above {\n  margin-top: 3px;\n  border-top-color: #d5dbe0 !important;\n}\n\n.select2.select2-container {\n  display: block;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple,\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--single {\n  border-color: #d5dbe0;\n  outline: 0;\n  height: 34px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple {\n  height: auto;\n  min-height: 34px;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--single\n  .select2-selection__rendered {\n  padding: 6px 12px;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered,\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--single\n  .select2-selection__rendered {\n  line-height: 1;\n  font-weight: 600;\n  color: #2d353c;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__arrow,\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--single\n  .select2-selection__arrow {\n  height: auto;\n  width: auto;\n  position: relative;\n  top: 0;\n  right: 0;\n  padding: 6px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__arrow\n  b,\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--single\n  .select2-selection__arrow\n  b {\n  position: relative;\n  top: 0;\n  left: 0;\n  margin: 0;\n  border: 0;\n  color: #2d353c;\n  width: auto;\n  height: auto;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__arrow\n  b:before,\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--single\n  .select2-selection__arrow\n  b:before {\n  content: \"\\f0d7\";\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered {\n  padding: 6px 12px 1px;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered\n  .select2-search--inline {\n  float: none;\n  min-width: 100px;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered\n  .select2-search--inline\n  .select2-search__field {\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-weight: 600;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered\n  .select2-search--inline\n  .select2-search__field::-webkit-input-placeholder {\n  color: #6f8293;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered\n  .select2-search--inline\n  .select2-search__field::-moz-placeholder {\n  color: #6f8293;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered\n  .select2-search--inline\n  .select2-search__field:-ms-input-placeholder {\n  color: #6f8293;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__rendered\n  .select2-search--inline\n  .select2-search__field:-moz-placeholder {\n  color: #6f8293;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__choice {\n  border: 0;\n  background: #e4e7ea;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  margin-top: 0;\n  padding: 4px 8px;\n  color: #4e5c68;\n  float: none;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.select2.select2-container\n  .selection\n  .select2-selection.select2-selection--multiple\n  .select2-selection__choice\n  .select2-selection__choice__remove {\n  color: #9ba8b4;\n  font-size: 13px;\n  margin-right: 0;\n  margin-left: 5px;\n  margin-bottom: -1px;\n  float: right;\n}\n\n.select2.select2-container.select2-container--above.select2-container--open\n  .selection\n  .select2-selection.select2-selection--single\n  .select2-selection__arrow\n  b:before {\n  content: \"\\f0d8\";\n}\n\n.select2-container .select2-dropdown {\n  border: 0;\n  -webkit-box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.select2-container .select2-dropdown .select2-search--dropdown {\n  padding: 6px;\n}\n\n.select2-container .select2-dropdown .select2-search--dropdown input {\n  border-color: #d5dbe0;\n  height: 34px;\n  padding: 6px 12px;\n  outline: 0;\n  color: #2d353c;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.select2-container .select2-dropdown .select2-search--dropdown input:focus {\n  border-color: #5db0ff;\n  -webkit-box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n  box-shadow: 0 0 0 0.125rem rgba(93, 176, 255, 0.3);\n}\n\n.select2-container\n  .select2-dropdown\n  .select2-results\n  .select2-results__options\n  .select2-results__option {\n  font-weight: 600;\n  color: #4e5c68;\n}\n\n.select2-container\n  .select2-dropdown\n  .select2-results\n  .select2-results__options\n  .select2-results__option\n  .select2-results__group {\n  padding: 15px 6px 6px;\n  color: #2d353c;\n  font-size: 11px;\n}\n\n.select2-container\n  .select2-dropdown\n  .select2-results\n  .select2-results__options\n  .select2-results__option\n  .select2-results__option {\n  padding: 6px 15px;\n}\n\n.select2-container\n  .select2-dropdown\n  .select2-results\n  .select2-results__options\n  .select2-results__option.select2-results__option--highlighted {\n  background: #f2f3f4;\n  color: #2d353c;\n}\n\n.select2-container\n  .select2-dropdown\n  .select2-results\n  .select2-results__options\n  .select2-results__option.select2-results__message {\n  font-weight: 600;\n  font-size: 11px;\n  color: #6f8293;\n  padding: 6px;\n}\n\n.select2-container\n  .select2-dropdown\n  .select2-results\n  .select2-results__options\n  .select2-results__option[aria-selected=\"true\"] {\n  background: #348fe2;\n  color: #fff;\n}\n\n.select2-container .select2-dropdown.select2-dropdown--above {\n  -webkit-box-shadow: 0 -8px 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 -8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.simplecolorpicker {\n  z-index: 1010 !important;\n}\n\n.simplecolorpicker .color,\n.simplecolorpicker .icon,\n.simplecolorpicker.icon {\n  width: 20px;\n  height: 20px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.simplecolorpicker .color:focus,\n.simplecolorpicker .icon:focus,\n.simplecolorpicker.icon:focus {\n  outline: 0 !important;\n}\n\n.simplecolorpicker.fontawesome .color[data-selected]:after,\n.simplecolorpicker.glyphicons .color[data-selected]:after {\n  display: block;\n  text-align: center;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.simplecolorpicker.glyphicons .color[data-selected]:after {\n  content: \"\\f00c\" !important;\n  margin-left: 2px !important;\n  top: 0 !important;\n}\n\n.simplecolorpicker.inline {\n  padding: 5px 0 0 !important;\n}\n\n.simplecolorpicker.picker {\n  border: 0 !important;\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175) !important;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.simplecolorpicker.picker .color {\n  width: 20px;\n  height: 20px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.slimScrollDiv .slimScrollBar,\n.slimScrollDiv .slimScrollRail {\n  width: 6px !important;\n  right: 2px !important;\n}\n\n.slimScrollDiv .slimScrollBar {\n  background: 0 0 !important;\n}\n\n.slimScrollDiv .slimScrollBar:before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  bottom: 2px;\n  left: 0;\n  background: #2d353c !important;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\n.inverse-mode .slimScrollDiv .slimScrollBar:before {\n  background: rgba(255, 255, 255, 0.5) !important;\n}\n\nbody .jqstooltip {\n  border: 0;\n  width: auto !important;\n  height: auto !important;\n  background: rgba(45, 53, 60, 0.9);\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.note-editor .note-toolbar {\n  background: #2d353c;\n  padding: 10px 15px !important;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.note-editor .note-toolbar.panel-heading .note-btn-group {\n  margin-top: 0 !important;\n}\n\n.note-editor .note-toolbar.panel-heading .note-btn-group .btn {\n  margin: 0 !important;\n}\n\n.note-editor .note-toolbar .dropdown-menu > li > a {\n  display: block;\n  padding: 5px 15px;\n  color: #2d353c;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.note-editor .note-editing-area .note-editable,\n.note-editor .note-placeholder {\n  padding: 15px !important;\n}\n\n.note-editor .modal .modal-header {\n  display: block;\n}\n\n.note-editor .modal .modal-header .close {\n  margin-top: -10px;\n}\n\n.note-editor.note-frame {\n  border: 0 !important;\n  margin: 0 !important;\n  background: 0 0;\n}\n\n.note-editor.fullscreen .note-toolbar-wrapper,\n.note-popover.popover,\n.superbox.superbox-active .superbox-list .superbox-img img,\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-quote:before {\n  display: none;\n}\n\n.note-popover.popover .note-toolbar,\n.note-popover.popover .popover-content {\n  padding: 10px 15px !important;\n  background: #2d353c;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.note-toolbar .dropdown-toggle:after {\n  display: none !important;\n}\n\n.superbox.superbox-active {\n  font-size: 0;\n  margin: -1px -1px 0 0;\n}\n\n.superbox.superbox-active .superbox-list {\n  display: inline-block;\n  position: relative;\n  background: 0 0;\n}\n\n.superbox.superbox-active .superbox-list .superbox-img {\n  width: 100%;\n  cursor: pointer;\n  display: block;\n  padding-top: 75%;\n  position: relative;\n}\n\n.superbox.superbox-active .superbox-list .superbox-img span {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  right: 1px;\n  bottom: 1px;\n  background-size: cover !important;\n  background-position: center !important;\n}\n\n.superbox.superbox-active .superbox-list .superbox-img:hover {\n  opacity: 0.8;\n}\n\n.superbox.superbox-active .superbox-list.superbox-O {\n  z-index: 10;\n}\n\n.superbox.superbox-active .superbox-list.superbox-O:after,\n.superbox.superbox-active .superbox-list.superbox-O:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  border: 10px solid transparent;\n  border-bottom-color: #d9e0e7;\n  margin-left: -10px;\n  z-index: 10;\n}\n\n.superbox.superbox-active .superbox-list.superbox-O:after {\n  bottom: -3px;\n  border-bottom-color: #2d353c;\n  z-index: 20;\n}\n\n.superbox.superbox-active .superbox-show {\n  background: #2d353c !important;\n  margin: 1px 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.superbox.superbox-active .superbox-show .superbox-current-img {\n  max-width: 100%;\n  border: 0;\n  -webkit-box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);\n}\n\n.superbox.superbox-active .superbox-close {\n  cursor: pointer;\n  position: absolute;\n  top: 15px;\n  right: 25px;\n  width: 35px;\n  height: 35px;\n}\n\n.swal-overlay .swal-modal .swal-icon--success,\n.swal-overlay .swal-modal .swal-icon--success__ring {\n  border-color: rgba(0, 172, 172, 0.2);\n}\n\n.swal-overlay .swal-modal .swal-icon--success__line--long,\n.swal-overlay .swal-modal .swal-icon--success__line--tip {\n  background-color: #00acac;\n}\n\n.swal-overlay .swal-modal .swal-icon--info {\n  border-color: #49b6d6;\n}\n\n.swal-overlay .swal-modal .swal-icon--info:after,\n.swal-overlay .swal-modal .swal-icon--info:before {\n  background-color: #49b6d6;\n}\n\n.swal-overlay .swal-modal .swal-icon--warning {\n  border-color: #f59c1a;\n}\n\n.swal-overlay .swal-modal .swal-icon--warning .swal-icon--warning__body,\n.swal-overlay .swal-modal .swal-icon--warning .swal-icon--warning__dot {\n  background-color: #f59c1a;\n}\n\n.swal-overlay .swal-modal .swal-icon--error {\n  border-color: #ff5b57;\n}\n\n.swal-overlay .swal-modal .swal-icon--error .swal-icon--error__line {\n  background-color: #ff5b57;\n}\n\n.tagit.ui-widget {\n  border: 1px solid #d5dbe0;\n  background: #fff;\n  padding: 3px 6px;\n  margin-bottom: 0;\n  font-family: inherit;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.tagit.ui-widget li,\nbody ul.wysihtml5-toolbar > li {\n  float: none;\n}\n\n.tagit.ui-widget li.tagit-choice {\n  background: #d5dbe0;\n  border: 0;\n  color: #4e5c68;\n  padding: 2px 24px 2px 6px;\n  font-weight: 600;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.tagit.ui-widget li.tagit-choice .tagit-close {\n  right: 2px;\n  line-height: 24px;\n  text-align: center;\n  top: 0;\n  margin: 0;\n}\n\n.tagit.ui-widget li.tagit-choice .tagit-close .ui-icon-close {\n  background: 0 0;\n  height: 24px;\n  width: 16px;\n  text-indent: 0;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.tagit.ui-widget li.tagit-choice .tagit-close .ui-icon-close:before {\n  content: \"\\f00d\";\n  font-size: 10px;\n  color: inherit;\n}\n\n.tagit.ui-widget li.tagit-choice .tagit-close:focus .ui-icon-close:before,\n.tagit.ui-widget li.tagit-choice .tagit-close:hover .ui-icon-close:before {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.tagit.ui-widget li.tagit-new {\n  padding: 2px 0;\n}\n\n.tagit.ui-widget.inverse li.tagit-choice {\n  background: #2d353c;\n  color: #fff;\n}\n\n.tagit.ui-widget.inverse\n  li.tagit-choice\n  .tagit-close:focus\n  .ui-icon-close:before,\n.tagit.ui-widget.inverse\n  li.tagit-choice\n  .tagit-close:hover\n  .ui-icon-close:before {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .twitter-typeahead\n  .tt-dropdown-menu\n  .tt-suggestion.tt-is-under-cursor,\n.tagit.ui-widget.primary li.tagit-choice {\n  background: #348fe2;\n  color: #fff;\n}\n\n.tagit.ui-widget.info li.tagit-choice {\n  background: #49b6d6;\n  color: #fff;\n}\n\n.tagit.ui-widget.success li.tagit-choice {\n  background: #00acac;\n  color: #fff;\n}\n\n.tagit.ui-widget.warning li.tagit-choice {\n  background: #f59c1a;\n  color: #fff;\n}\n\n.tagit.ui-widget.danger li.tagit-choice {\n  background: #ff5b57;\n  color: #fff;\n}\n\n.wysihtml5-sandbox {\n  width: 100% !important;\n  border-color: #d5dbe0 !important;\n  padding: 15px !important;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .add-on\n  i,\nbody ul.wysihtml5-toolbar .glyphicon {\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-quote:after {\n  content: \"\\f10d\";\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-list:before {\n  content: \"\\f03a\";\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-indent-right:before {\n  content: \"\\f038\";\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-indent-left:before {\n  content: \"\\f036\";\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-th-list:before {\n  content: \"\\f00b\";\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-share:before {\n  content: \"\\f064\";\n}\n\nbody ul.wysihtml5-toolbar .glyphicon.glyphicon-picture:before {\n  content: \"\\f03e\";\n}\n\n.panel-form .wysihtml5-toolbar {\n  padding: 15px 15px 5px;\n}\n\n.panel-form .wysihtml5-sandbox {\n  -webkit-border-radius: 0 0 4px 4px !important;\n  border-radius: 0 0 4px 4px !important;\n}\n\n.editable-container,\n.editable-container .editableform .form-group > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.editable-container .editableform {\n  display: block;\n}\n\n.editable-container .editableform .form-group > div {\n  margin-bottom: -5px;\n  -ms-flex-flow: row wrap;\n  flex-flow: row wrap;\n}\n\n.editable-container .editableform .form-group > div .editable-input {\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .editable-clear-x {\n  right: 12px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .editable-checklist\n  > div\n  > label {\n  -webkit-box-pack: left;\n  -ms-flex-pack: left;\n  justify-content: left;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .editable-checklist\n  > div\n  > label\n  input {\n  margin-right: 5px;\n  height: inherit;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .form-control {\n  margin-top: -1px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .add-on {\n  background: #d5dbe0;\n  padding: 5px 10px;\n  min-height: 34px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .add-on\n  i {\n  width: auto;\n  height: auto;\n  margin: 0;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker {\n  width: 300px;\n  color: #2d353c;\n  -webkit-border-radius: 8px;\n  border-radius: 8px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev {\n  color: transparent;\n  width: 14.28%;\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:before {\n  color: #6f8293;\n  position: absolute;\n  font-size: 14px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.prev:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.prev:before {\n  content: \"\\f104\";\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.next:before,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.next:before {\n  content: \"\\f105\";\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.switch,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.switch {\n  width: auto;\n  font-weight: 700;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  thead\n  tr\n  th.dow,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  thead\n  tr\n  th.dow,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  thead\n  tr\n  th.dow,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  thead\n  tr\n  th.dow,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  thead\n  tr\n  th.dow,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  thead\n  tr\n  th.dow {\n  padding: 5px 0;\n  border: 0;\n  font-weight: 700;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.century.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.decade.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.hour.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.month.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-centuries\n  table\n  tbody\n  tr\n  td\n  span.year.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.century.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.decade.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.hour.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.month.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-days\n  table\n  tbody\n  tr\n  td\n  span.year.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.century.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.decade.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.hour.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.month.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-decades\n  table\n  tbody\n  tr\n  td\n  span.year.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.century.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.decade.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.hour.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.month.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-hours\n  table\n  tbody\n  tr\n  td\n  span.year.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.century.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.decade.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.hour.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.month.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-months\n  table\n  tbody\n  tr\n  td\n  span.year.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.century.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.decade.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.hour.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.month.active,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .input-append.date\n  .datetimepicker\n  .datetimepicker-years\n  table\n  tbody\n  tr\n  td\n  span.year.active {\n  background: #348fe2 !important;\n  color: #fff;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .editable-address\n  input {\n  border: 1px solid #d5dbe0;\n  padding: 6px 10px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .editable-address\n  input:focus {\n  outline: 0;\n  border-color: #5db0ff;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n  box-shadow: 0 0 0 0.2rem rgba(52, 143, 226, 0.25);\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .twitter-typeahead\n  .tt-hint {\n  line-height: 22px;\n  padding: 5px 11px;\n  opacity: 0.6;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .twitter-typeahead\n  .tt-dropdown-menu {\n  border: 0;\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-input\n  .twitter-typeahead\n  .tt-dropdown-menu\n  .tt-suggestion {\n  padding: 5px 12px;\n}\n\n.editable-container .editableform .form-group > div .editable-buttons {\n  margin-left: 0;\n  margin-bottom: 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.editable-container .editableform .form-group > div .editable-buttons .btn {\n  width: 34px;\n  height: 34px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons\n  .btn\n  + .btn {\n  margin-left: 5px;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons\n  .btn\n  .glyphicon-ok,\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons\n  .btn\n  .glyphicon-remove {\n  font-family: Font Awesome\\5 Free, Font Awesome\\5 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons\n  .btn\n  .glyphicon-ok:before {\n  content: \"\\f00c\";\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons\n  .btn\n  .glyphicon-remove:before {\n  content: \"\\f00d\";\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons.editable-buttons-bottom {\n  display: block;\n}\n\n.editable-container\n  .editableform\n  .form-group\n  > div\n  .editable-buttons.editable-buttons-bottom\n  .btn {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.editable-container .editableform .form-group.has-error .form-control {\n  border-color: #ec5450;\n  background: #ffefee;\n}\n\n.editable-container .editableform .form-group.has-error .editable-error-block {\n  margin: 0 0 0 10px;\n  white-space: nowrap;\n  color: #d94d4a;\n}\n\n.row.row-space-0 > [class*=\"col-\"] {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.row.row-space-2 > [class*=\"col-\"] {\n  padding-left: 1;\n  padding-right: 1;\n}\n\n.row.row-space-4 > [class*=\"col-\"] {\n  padding-left: 2;\n  padding-right: 2;\n}\n\n.row.row-space-6 > [class*=\"col-\"] {\n  padding-left: 3;\n  padding-right: 3;\n}\n\n.row.row-space-8 > [class*=\"col-\"] {\n  padding-left: 4;\n  padding-right: 4;\n}\n\n.row.row-space-10 > [class*=\"col-\"] {\n  padding-left: 5;\n  padding-right: 5;\n}\n\n.row.row-space-12 > [class*=\"col-\"] {\n  padding-left: 6;\n  padding-right: 6;\n}\n\n.row.row-space-14 > [class*=\"col-\"] {\n  padding-left: 7;\n  padding-right: 7;\n}\n\n.row.row-space-16 > [class*=\"col-\"] {\n  padding-left: 8;\n  padding-right: 8;\n}\n\n.row.row-space-18 > [class*=\"col-\"] {\n  padding-left: 9;\n  padding-right: 9;\n}\n\n.row.row-space-20 > [class*=\"col-\"] {\n  padding-left: 10;\n  padding-right: 10;\n}\n\n.row.row-space-22 > [class*=\"col-\"] {\n  padding-left: 11;\n  padding-right: 11;\n}\n\n.row.row-space-24 > [class*=\"col-\"] {\n  padding-left: 12;\n  padding-right: 12;\n}\n\n.row.row-space-26 > [class*=\"col-\"] {\n  padding-left: 13;\n  padding-right: 13;\n}\n\n.row.row-space-28 > [class*=\"col-\"] {\n  padding-left: 14;\n  padding-right: 14;\n}\n\n.row.row-space-30 > [class*=\"col-\"] {\n  padding-left: 15;\n  padding-right: 15;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 1px !important;\n}\n\n.m-2 {\n  margin: 2px !important;\n}\n\n.m-3 {\n  margin: 3px !important;\n}\n\n.m-4 {\n  margin: 4px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.m-t-auto {\n  margin-top: auto !important;\n}\n\n.m-t-0 {\n  margin-top: 0 !important;\n}\n\n.m-t-1 {\n  margin-top: 1px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-25 {\n  margin-top: 25px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-35 {\n  margin-top: 35px !important;\n}\n\n.m-t-40 {\n  margin-top: 40px !important;\n}\n\n.m-r-auto {\n  margin-right: auto !important;\n}\n\n.m-r-0 {\n  margin-right: 0 !important;\n}\n\n.m-r-1 {\n  margin-right: 1px !important;\n}\n\n.m-r-2 {\n  margin-right: 2px !important;\n}\n\n.m-r-3 {\n  margin-right: 3px !important;\n}\n\n.m-r-4 {\n  margin-right: 4px !important;\n}\n\n.m-r-5 {\n  margin-right: 5px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-15 {\n  margin-right: 15px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-25 {\n  margin-right: 25px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-35 {\n  margin-right: 35px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n.m-b-auto {\n  margin-bottom: auto !important;\n}\n\n.m-b-0 {\n  margin-bottom: 0 !important;\n}\n\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-3 {\n  margin-bottom: 3px !important;\n}\n\n.m-b-4 {\n  margin-bottom: 4px !important;\n}\n\n.m-b-5 {\n  margin-bottom: 5px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-15 {\n  margin-bottom: 15px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-25 {\n  margin-bottom: 25px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-35 {\n  margin-bottom: 35px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-0 {\n  margin-left: 0 !important;\n}\n\n.m-l-1 {\n  margin-left: 1px !important;\n}\n\n.m-l-2 {\n  margin-left: 2px !important;\n}\n\n.m-l-3 {\n  margin-left: 3px !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-10 {\n  /* margin-left: 10px !important */\n}\n\n.m-l-15 {\n  margin-left: 15px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-25 {\n  margin-left: 25px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.p-auto {\n  padding: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 1px !important;\n}\n\n.p-2 {\n  padding: 2px !important;\n}\n\n.p-3 {\n  padding: 3px !important;\n}\n\n.p-4 {\n  padding: 4px !important;\n}\n\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-10 {\n  padding: 10px !important;\n}\n\n.p-15 {\n  padding: 15px !important;\n}\n\n.p-20 {\n  padding: 20px !important;\n}\n\n.p-25 {\n  padding: 25px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-35 {\n  padding: 35px !important;\n}\n\n.p-40 {\n  padding: 40px !important;\n}\n\n.p-t-auto {\n  padding-top: auto !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-1 {\n  padding-top: 1px !important;\n}\n\n.p-t-2 {\n  padding-top: 2px !important;\n}\n\n.p-t-3 {\n  padding-top: 3px !important;\n}\n\n.p-t-4 {\n  padding-top: 4px !important;\n}\n\n.p-t-5 {\n  padding-top: 5px !important;\n}\n\n.p-t-10 {\n  padding-top: 10px !important;\n}\n\n/* .p-t-10 li:nth-child(5) {\n    position: fixed;\n    bottom: 100px;\n    width: 100%;\n} */\n\n.navbar-cloud {\n  position: fixed;\n  bottom: 20px;\n  width: 100%;\n}\n\n.p-t-15 {\n  padding-top: 15px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-25 {\n  padding-top: 25px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-35 {\n  padding-top: 35px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-r-auto {\n  padding-right: auto !important;\n}\n\n.p-r-0 {\n  padding-right: 0 !important;\n}\n\n.p-r-1 {\n  padding-right: 1px !important;\n}\n\n.p-r-2 {\n  padding-right: 2px !important;\n}\n\n.p-r-3 {\n  padding-right: 3px !important;\n}\n\n.p-r-4 {\n  padding-right: 4px !important;\n}\n\n.p-r-5 {\n  padding-right: 5px !important;\n}\n\n.p-r-10 {\n  padding-right: 10px !important;\n}\n\n.p-r-15 {\n  padding-right: 15px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-25 {\n  padding-right: 25px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-35 {\n  padding-right: 35px !important;\n}\n\n.p-r-40 {\n  padding-right: 40px !important;\n}\n\n.p-b-auto {\n  padding-bottom: auto !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-1 {\n  padding-bottom: 1px !important;\n}\n\n.p-b-2 {\n  padding-bottom: 2px !important;\n}\n\n.p-b-3 {\n  padding-bottom: 3px !important;\n}\n\n.p-b-4 {\n  padding-bottom: 4px !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-15 {\n  padding-bottom: 15px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-35 {\n  padding-bottom: 35px !important;\n}\n\n.p-b-40 {\n  padding-bottom: 40px !important;\n}\n\n.p-l-auto {\n  padding-left: auto !important;\n}\n\n.p-l-0 {\n  padding-left: 0 !important;\n}\n\n.p-l-1 {\n  padding-left: 1px !important;\n}\n\n.p-l-2 {\n  padding-left: 2px !important;\n}\n\n.p-l-3 {\n  padding-left: 3px !important;\n}\n\n.p-l-4 {\n  padding-left: 4px !important;\n}\n\n.p-l-5 {\n  padding-left: 5px !important;\n}\n\n.p-l-10 {\n  padding-left: 10px !important;\n}\n\n.p-l-15 {\n  padding-left: 15px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-25 {\n  padding-left: 25px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-35 {\n  padding-left: 35px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.f-s-8 {\n  font-size: 8px !important;\n}\n\n.f-s-9 {\n  font-size: 9px !important;\n}\n\n.f-s-10 {\n  font-size: 10px !important;\n}\n\n.f-s-11 {\n  font-size: 11px !important;\n}\n\n.f-s-12 {\n  font-size: 12px !important;\n}\n\n.f-s-13 {\n  font-size: 13px !important;\n}\n\n.f-s-14 {\n  font-size: 14px !important;\n}\n\n.f-s-15 {\n  font-size: 15px !important;\n}\n\n.f-s-16 {\n  font-size: 16px !important;\n}\n\n.f-s-17 {\n  font-size: 17px !important;\n}\n\n.f-s-18 {\n  font-size: 18px !important;\n}\n\n.f-s-19 {\n  font-size: 19px !important;\n}\n\n.f-s-20 {\n  font-size: 20px !important;\n}\n\n.f-s-21 {\n  font-size: 21px !important;\n}\n\n.f-s-22 {\n  font-size: 22px !important;\n}\n\n.f-s-23 {\n  font-size: 23px !important;\n}\n\n.f-s-24 {\n  font-size: 24px !important;\n}\n\n.f-s-25 {\n  font-size: 25px !important;\n}\n\n.f-s-26 {\n  font-size: 26px !important;\n}\n\n.f-s-27 {\n  font-size: 27px !important;\n}\n\n.f-s-28 {\n  font-size: 28px !important;\n}\n\n.f-s-29 {\n  font-size: 29px !important;\n}\n\n.f-s-30 {\n  font-size: 30px !important;\n}\n\n.f-s-31 {\n  font-size: 31px !important;\n}\n\n.f-s-32 {\n  font-size: 32px !important;\n}\n\n.f-s-33 {\n  font-size: 33px !important;\n}\n\n.f-s-34 {\n  font-size: 34px !important;\n}\n\n.f-s-35 {\n  font-size: 35px !important;\n}\n\n.f-s-36 {\n  font-size: 36px !important;\n}\n\n.f-s-37 {\n  font-size: 37px !important;\n}\n\n.f-s-38 {\n  font-size: 38px !important;\n}\n\n.f-s-39 {\n  font-size: 39px !important;\n}\n\n.f-s-40 {\n  font-size: 40px !important;\n}\n\n.f-s-41 {\n  font-size: 41px !important;\n}\n\n.f-s-42 {\n  font-size: 42px !important;\n}\n\n.f-s-43 {\n  font-size: 43px !important;\n}\n\n.f-s-44 {\n  font-size: 44px !important;\n}\n\n.f-s-45 {\n  font-size: 45px !important;\n}\n\n.f-s-46 {\n  font-size: 46px !important;\n}\n\n.f-s-47 {\n  font-size: 47px !important;\n}\n\n.f-s-48 {\n  font-size: 48px !important;\n}\n\n.f-s-49 {\n  font-size: 49px !important;\n}\n\n.f-s-50 {\n  font-size: 50px !important;\n}\n\n.f-s-51 {\n  font-size: 51px !important;\n}\n\n.f-s-52 {\n  font-size: 52px !important;\n}\n\n.f-s-53 {\n  font-size: 53px !important;\n}\n\n.f-s-54 {\n  font-size: 54px !important;\n}\n\n.f-s-55 {\n  font-size: 55px !important;\n}\n\n.f-s-56 {\n  font-size: 56px !important;\n}\n\n.f-s-57 {\n  font-size: 57px !important;\n}\n\n.f-s-58 {\n  font-size: 58px !important;\n}\n\n.f-s-59 {\n  font-size: 59px !important;\n}\n\n.f-s-60 {\n  font-size: 60px !important;\n}\n\n.f-s-61 {\n  font-size: 61px !important;\n}\n\n.f-s-62 {\n  font-size: 62px !important;\n}\n\n.f-s-63 {\n  font-size: 63px !important;\n}\n\n.f-s-64 {\n  font-size: 64px !important;\n}\n\n.f-s-65 {\n  font-size: 65px !important;\n}\n\n.f-s-66 {\n  font-size: 66px !important;\n}\n\n.f-s-67 {\n  font-size: 67px !important;\n}\n\n.f-s-68 {\n  font-size: 68px !important;\n}\n\n.f-s-69 {\n  font-size: 69px !important;\n}\n\n.f-s-70 {\n  font-size: 70px !important;\n}\n\n.f-s-71 {\n  font-size: 71px !important;\n}\n\n.f-s-72 {\n  font-size: 72px !important;\n}\n\n.f-s-73 {\n  font-size: 73px !important;\n}\n\n.f-s-74 {\n  font-size: 74px !important;\n}\n\n.f-s-75 {\n  font-size: 75px !important;\n}\n\n.f-s-76 {\n  font-size: 76px !important;\n}\n\n.f-s-77 {\n  font-size: 77px !important;\n}\n\n.f-s-78 {\n  font-size: 78px !important;\n}\n\n.f-s-79 {\n  font-size: 79px !important;\n}\n\n.f-s-80 {\n  font-size: 80px !important;\n}\n\n.f-w-100 {\n  font-weight: 100 !important;\n}\n\n.f-w-200 {\n  font-weight: 200 !important;\n}\n\n.f-w-300 {\n  font-weight: 300 !important;\n}\n\n.f-w-400 {\n  font-weight: 400 !important;\n}\n\n.f-w-500 {\n  font-weight: 500 !important;\n}\n\n.f-w-600 {\n  font-weight: 600 !important;\n}\n\n.f-w-700 {\n  font-weight: 700 !important;\n}\n\n.f-w-800 {\n  font-weight: 800 !important;\n}\n\n.clearfix:after,\n.clearfix:before {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-ellipsis,\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-ellipsis {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.text-underline {\n  text-decoration: underline !important;\n}\n\n.line-height-1 {\n  line-height: 1 !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.row.row-col-border > [class^=\"col-\"] + [class^=\"col-\"] {\n  border-left: 1px solid #d5dbe0;\n}\n\n.pull-left {\n  float: left !important;\n}\n\n.pull-right {\n  float: right !important;\n}\n\n.pull-none {\n  float: none !important;\n}\n\n.rounded-corner {\n  border-radius: 100px !important;\n}\n\n.table-td-valign-middle td,\n.table-th-valign-middle th,\n.table-valign-middle td,\n.table-valign-middle th {\n  vertical-align: middle !important;\n}\n\n.table-td-valign-top td,\n.table-th-valign-top th,\n.table-valign-top td,\n.table-valign-top th {\n  vertical-align: top !important;\n}\n\n.table-td-valign-bottom td,\n.table-th-valign-bottom th,\n.table-valign-bottom td,\n.table-valign-bottom th {\n  vertical-align: bottom !important;\n}\n\n.table-th-without-border th {\n  border-left: none !important;\n  border-right: none !important;\n}\n\n.table-td-without-border td {\n  border: 0 !important;\n}\n\n.table-td-bg-animate {\n  -webkit-transition: background 0.3s linear;\n  -moz-transition: background 0.3s linear;\n  -ms-transition: background 0.3s linear;\n  -o-transition: background 0.3s linear;\n  transition: background 0.3s linear;\n}\n\n.valign-middle-container {\n  display: table;\n  height: 100%;\n  width: 100%;\n}\n\n.valign-middle-inner-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.loading {\n  cursor: progress;\n}\n\n.bg-theme {\n  background-color: #00acac !important;\n}\n\n.label-theme {\n  background-color: #00acac;\n}\n\n.text-theme {\n  color: #00acac;\n}\n\n.text-primary {\n  color: #00acac !important;\n}\n\n.text-primary-lighter {\n  color: #40c1c1 !important;\n}\n\n.text-primary-darker {\n  color: #008181 !important;\n}\n\n.app-theme-primary .app-sidebar .nav > li.active > a,\n.bg-primary {\n  background-color: #00acac !important;\n}\n\n.bg-primary-lighter {\n  background-color: #40c1c1 !important;\n}\n\n.bg-primary-darker {\n  background-color: #008181 !important;\n}\n\n.app-theme-gradient-primary .app-sidebar .nav > li.active > a,\n.bg-gradient-primary {\n  background: #00acac !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #00dfdf 0%,\n    #009393 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #00dfdf 0%,\n    #009393 100%\n  ) !important;\n  background: linear-gradient(to bottom, #00dfdf 0%, #009393 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-primary-transparent-1 {\n  background-color: rgba(0, 172, 172, 0.1) !important;\n}\n\n.text-primary-transparent-1 {\n  color: rgba(0, 172, 172, 0.1) !important;\n}\n\n.bg-primary-transparent-2 {\n  background-color: rgba(0, 172, 172, 0.2) !important;\n}\n\n.text-primary-transparent-2 {\n  color: rgba(0, 172, 172, 0.2) !important;\n}\n\n.bg-primary-transparent-3 {\n  background-color: rgba(0, 172, 172, 0.3) !important;\n}\n\n.text-primary-transparent-3 {\n  color: rgba(0, 172, 172, 0.3) !important;\n}\n\n.bg-primary-transparent-4 {\n  background-color: rgba(0, 172, 172, 0.4) !important;\n}\n\n.text-primary-transparent-4 {\n  color: rgba(0, 172, 172, 0.4) !important;\n}\n\n.bg-primary-transparent-5 {\n  background-color: rgba(0, 172, 172, 0.5) !important;\n}\n\n.text-primary-transparent-5 {\n  color: rgba(0, 172, 172, 0.5) !important;\n}\n\n.bg-primary-transparent-6 {\n  background-color: rgba(0, 172, 172, 0.6) !important;\n}\n\n.text-primary-transparent-6 {\n  color: rgba(0, 172, 172, 0.6) !important;\n}\n\n.bg-primary-transparent-7 {\n  background-color: rgba(0, 172, 172, 0.7) !important;\n}\n\n.text-primary-transparent-7 {\n  color: rgba(0, 172, 172, 0.7) !important;\n}\n\n.bg-primary-transparent-8 {\n  background-color: rgba(0, 172, 172, 0.8) !important;\n}\n\n.text-primary-transparent-8 {\n  color: rgba(0, 172, 172, 0.8) !important;\n}\n\n.bg-primary-transparent-9 {\n  background-color: rgba(0, 172, 172, 0.9) !important;\n}\n\n.text-primary-transparent-9 {\n  color: rgba(0, 172, 172, 0.9) !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\n.text-secondary-lighter {\n  color: #91989e !important;\n}\n\n.text-secondary-darker {\n  color: #51585e !important;\n}\n\n.app-theme-secondary .app-sidebar .nav > li.active > a,\n.bg-secondary {\n  background-color: #6c757d !important;\n}\n\n.bg-secondary-lighter {\n  background-color: #91989e !important;\n}\n\n.bg-secondary-darker {\n  background-color: #51585e !important;\n}\n\n.app-theme-gradient-secondary .app-sidebar .nav > li.active > a,\n.bg-gradient-secondary {\n  background: #6c757d !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #868e96 0%,\n    #60686f 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #868e96 0%,\n    #60686f 100%\n  ) !important;\n  background: linear-gradient(to bottom, #868e96 0%, #60686f 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-secondary-transparent-1 {\n  background-color: rgba(108, 117, 125, 0.1) !important;\n}\n\n.text-secondary-transparent-1 {\n  color: rgba(108, 117, 125, 0.1) !important;\n}\n\n.bg-secondary-transparent-2 {\n  background-color: rgba(108, 117, 125, 0.2) !important;\n}\n\n.text-secondary-transparent-2 {\n  color: rgba(108, 117, 125, 0.2) !important;\n}\n\n.bg-secondary-transparent-3 {\n  background-color: rgba(108, 117, 125, 0.3) !important;\n}\n\n.text-secondary-transparent-3 {\n  color: rgba(108, 117, 125, 0.3) !important;\n}\n\n.bg-secondary-transparent-4 {\n  background-color: rgba(108, 117, 125, 0.4) !important;\n}\n\n.text-secondary-transparent-4 {\n  color: rgba(108, 117, 125, 0.4) !important;\n}\n\n.bg-secondary-transparent-5 {\n  background-color: rgba(108, 117, 125, 0.5) !important;\n}\n\n.text-secondary-transparent-5 {\n  color: rgba(108, 117, 125, 0.5) !important;\n}\n\n.bg-secondary-transparent-6 {\n  background-color: rgba(108, 117, 125, 0.6) !important;\n}\n\n.text-secondary-transparent-6 {\n  color: rgba(108, 117, 125, 0.6) !important;\n}\n\n.bg-secondary-transparent-7 {\n  background-color: rgba(108, 117, 125, 0.7) !important;\n}\n\n.text-secondary-transparent-7 {\n  color: rgba(108, 117, 125, 0.7) !important;\n}\n\n.bg-secondary-transparent-8 {\n  background-color: rgba(108, 117, 125, 0.8) !important;\n}\n\n.text-secondary-transparent-8 {\n  color: rgba(108, 117, 125, 0.8) !important;\n}\n\n.bg-secondary-transparent-9 {\n  background-color: rgba(108, 117, 125, 0.9) !important;\n}\n\n.text-secondary-transparent-9 {\n  color: rgba(108, 117, 125, 0.9) !important;\n}\n\n.text-success {\n  color: #00acac !important;\n}\n\n.text-success-lighter {\n  color: #40c1c1 !important;\n}\n\n.text-success-darker {\n  color: #008181 !important;\n}\n\n.app-theme-success .app-sidebar .nav > li.active > a,\n.bg-success {\n  background-color: #00acac !important;\n}\n\n.bg-success-lighter {\n  background-color: #40c1c1 !important;\n}\n\n.bg-success-darker {\n  background-color: #008181 !important;\n}\n\n.app-theme-gradient-success .app-sidebar .nav > li.active > a,\n.bg-gradient-success {\n  background: #00acac !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #00dfdf 0%,\n    #009393 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #00dfdf 0%,\n    #009393 100%\n  ) !important;\n  background: linear-gradient(to bottom, #00dfdf 0%, #009393 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-success-transparent-1 {\n  background-color: rgba(0, 172, 172, 0.1) !important;\n}\n\n.text-success-transparent-1 {\n  color: rgba(0, 172, 172, 0.1) !important;\n}\n\n.bg-success-transparent-2 {\n  background-color: rgba(0, 172, 172, 0.2) !important;\n}\n\n.text-success-transparent-2 {\n  color: rgba(0, 172, 172, 0.2) !important;\n}\n\n.bg-success-transparent-3 {\n  background-color: rgba(0, 172, 172, 0.3) !important;\n}\n\n.text-success-transparent-3 {\n  color: rgba(0, 172, 172, 0.3) !important;\n}\n\n.bg-success-transparent-4 {\n  background-color: rgba(0, 172, 172, 0.4) !important;\n}\n\n.text-success-transparent-4 {\n  color: rgba(0, 172, 172, 0.4) !important;\n}\n\n.bg-success-transparent-5 {\n  background-color: rgba(0, 172, 172, 0.5) !important;\n}\n\n.text-success-transparent-5 {\n  color: rgba(0, 172, 172, 0.5) !important;\n}\n\n.bg-success-transparent-6 {\n  background-color: rgba(0, 172, 172, 0.6) !important;\n}\n\n.text-success-transparent-6 {\n  color: rgba(0, 172, 172, 0.6) !important;\n}\n\n.bg-success-transparent-7 {\n  background-color: rgba(0, 172, 172, 0.7) !important;\n}\n\n.text-success-transparent-7 {\n  color: rgba(0, 172, 172, 0.7) !important;\n}\n\n.bg-success-transparent-8 {\n  background-color: rgba(0, 172, 172, 0.8) !important;\n}\n\n.text-success-transparent-8 {\n  color: rgba(0, 172, 172, 0.8) !important;\n}\n\n.bg-success-transparent-9 {\n  background-color: rgba(0, 172, 172, 0.9) !important;\n}\n\n.text-success-transparent-9 {\n  color: rgba(0, 172, 172, 0.9) !important;\n}\n\n.text-info {\n  color: #49b6d6 !important;\n}\n\n.text-info-lighter {\n  color: #77c8e0 !important;\n}\n\n.text-info-darker {\n  color: #3789a1 !important;\n}\n\n.app-theme-info .app-sidebar .nav > li.active > a,\n.bg-info {\n  background-color: #49b6d6 !important;\n}\n\n.bg-info-lighter {\n  background-color: #77c8e0 !important;\n}\n\n.bg-info-darker {\n  background-color: #3789a1 !important;\n}\n\n.app-theme-gradient-info .app-sidebar .nav > li.active > a,\n.bg-gradient-info {\n  background: #49b6d6 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #73c7df 0%,\n    #34aed1 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #73c7df 0%,\n    #34aed1 100%\n  ) !important;\n  background: linear-gradient(to bottom, #73c7df 0%, #34aed1 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-info-transparent-1 {\n  background-color: rgba(73, 182, 214, 0.1) !important;\n}\n\n.text-info-transparent-1 {\n  color: rgba(73, 182, 214, 0.1) !important;\n}\n\n.bg-info-transparent-2 {\n  background-color: rgba(73, 182, 214, 0.2) !important;\n}\n\n.text-info-transparent-2 {\n  color: rgba(73, 182, 214, 0.2) !important;\n}\n\n.bg-info-transparent-3 {\n  background-color: rgba(73, 182, 214, 0.3) !important;\n}\n\n.text-info-transparent-3 {\n  color: rgba(73, 182, 214, 0.3) !important;\n}\n\n.bg-info-transparent-4 {\n  background-color: rgba(73, 182, 214, 0.4) !important;\n}\n\n.text-info-transparent-4 {\n  color: rgba(73, 182, 214, 0.4) !important;\n}\n\n.bg-info-transparent-5 {\n  background-color: rgba(73, 182, 214, 0.5) !important;\n}\n\n.text-info-transparent-5 {\n  color: rgba(73, 182, 214, 0.5) !important;\n}\n\n.bg-info-transparent-6 {\n  background-color: rgba(73, 182, 214, 0.6) !important;\n}\n\n.text-info-transparent-6 {\n  color: rgba(73, 182, 214, 0.6) !important;\n}\n\n.bg-info-transparent-7 {\n  background-color: rgba(73, 182, 214, 0.7) !important;\n}\n\n.text-info-transparent-7 {\n  color: rgba(73, 182, 214, 0.7) !important;\n}\n\n.bg-info-transparent-8 {\n  background-color: rgba(73, 182, 214, 0.8) !important;\n}\n\n.text-info-transparent-8 {\n  color: rgba(73, 182, 214, 0.8) !important;\n}\n\n.bg-info-transparent-9 {\n  background-color: rgba(73, 182, 214, 0.9) !important;\n}\n\n.text-info-transparent-9 {\n  color: rgba(73, 182, 214, 0.9) !important;\n}\n\n.text-warning {\n  color: #f59c1a !important;\n}\n\n.text-warning-lighter {\n  color: #f8b553 !important;\n}\n\n.text-warning-darker {\n  color: #b87514 !important;\n}\n\n.app-theme-warning .app-sidebar .nav > li.active > a,\n.bg-warning {\n  background-color: #f59c1a !important;\n}\n\n.bg-warning-lighter {\n  background-color: #f8b553 !important;\n}\n\n.bg-warning-darker {\n  background-color: #b87514 !important;\n}\n\n.app-theme-gradient-warning .app-sidebar .nav > li.active > a,\n.bg-gradient-warning {\n  background: #f59c1a !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #f7b14b 0%,\n    #eb900a 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #f7b14b 0%,\n    #eb900a 100%\n  ) !important;\n  background: linear-gradient(to bottom, #f7b14b 0%, #eb900a 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-warning-transparent-1 {\n  background-color: rgba(245, 156, 26, 0.1) !important;\n}\n\n.text-warning-transparent-1 {\n  color: rgba(245, 156, 26, 0.1) !important;\n}\n\n.bg-warning-transparent-2 {\n  background-color: rgba(245, 156, 26, 0.2) !important;\n}\n\n.text-warning-transparent-2 {\n  color: rgba(245, 156, 26, 0.2) !important;\n}\n\n.bg-warning-transparent-3 {\n  background-color: rgba(245, 156, 26, 0.3) !important;\n}\n\n.text-warning-transparent-3 {\n  color: rgba(245, 156, 26, 0.3) !important;\n}\n\n.bg-warning-transparent-4 {\n  background-color: rgba(245, 156, 26, 0.4) !important;\n}\n\n.text-warning-transparent-4 {\n  color: rgba(245, 156, 26, 0.4) !important;\n}\n\n.bg-warning-transparent-5 {\n  background-color: rgba(245, 156, 26, 0.5) !important;\n}\n\n.text-warning-transparent-5 {\n  color: rgba(245, 156, 26, 0.5) !important;\n}\n\n.bg-warning-transparent-6 {\n  background-color: rgba(245, 156, 26, 0.6) !important;\n}\n\n.text-warning-transparent-6 {\n  color: rgba(245, 156, 26, 0.6) !important;\n}\n\n.bg-warning-transparent-7 {\n  background-color: rgba(245, 156, 26, 0.7) !important;\n}\n\n.text-warning-transparent-7 {\n  color: rgba(245, 156, 26, 0.7) !important;\n}\n\n.bg-warning-transparent-8 {\n  background-color: rgba(245, 156, 26, 0.8) !important;\n}\n\n.text-warning-transparent-8 {\n  color: rgba(245, 156, 26, 0.8) !important;\n}\n\n.bg-warning-transparent-9 {\n  background-color: rgba(245, 156, 26, 0.9) !important;\n}\n\n.text-warning-transparent-9 {\n  color: rgba(245, 156, 26, 0.9) !important;\n}\n\n.text-danger {\n  color: #ff5b57 !important;\n}\n\n.text-danger-lighter {\n  color: #ff8481 !important;\n}\n\n.text-danger-darker {\n  color: #bf4441 !important;\n}\n\n.app-theme-danger .app-sidebar .nav > li.active > a,\n.bg-danger {\n  background-color: #ff5b57 !important;\n}\n\n.bg-danger-lighter {\n  background-color: #ff8481 !important;\n}\n\n.bg-danger-darker {\n  background-color: #bf4441 !important;\n}\n\n.app-theme-gradient-danger .app-sidebar .nav > li.active > a,\n.bg-gradient-danger {\n  background: #ff5b57 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #ff8d8a 0%,\n    #ff423e 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #ff8d8a 0%,\n    #ff423e 100%\n  ) !important;\n  background: linear-gradient(to bottom, #ff8d8a 0%, #ff423e 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-danger-transparent-1 {\n  background-color: rgba(255, 91, 87, 0.1) !important;\n}\n\n.text-danger-transparent-1 {\n  color: rgba(255, 91, 87, 0.1) !important;\n}\n\n.bg-danger-transparent-2 {\n  background-color: rgba(255, 91, 87, 0.2) !important;\n}\n\n.text-danger-transparent-2 {\n  color: rgba(255, 91, 87, 0.2) !important;\n}\n\n.bg-danger-transparent-3 {\n  background-color: rgba(255, 91, 87, 0.3) !important;\n}\n\n.text-danger-transparent-3 {\n  color: rgba(255, 91, 87, 0.3) !important;\n}\n\n.bg-danger-transparent-4 {\n  background-color: rgba(255, 91, 87, 0.4) !important;\n}\n\n.text-danger-transparent-4 {\n  color: rgba(255, 91, 87, 0.4) !important;\n}\n\n.bg-danger-transparent-5 {\n  background-color: rgba(255, 91, 87, 0.5) !important;\n}\n\n.text-danger-transparent-5 {\n  color: rgba(255, 91, 87, 0.5) !important;\n}\n\n.bg-danger-transparent-6 {\n  background-color: rgba(255, 91, 87, 0.6) !important;\n}\n\n.text-danger-transparent-6 {\n  color: rgba(255, 91, 87, 0.6) !important;\n}\n\n.bg-danger-transparent-7 {\n  background-color: rgba(255, 91, 87, 0.7) !important;\n}\n\n.text-danger-transparent-7 {\n  color: rgba(255, 91, 87, 0.7) !important;\n}\n\n.bg-danger-transparent-8 {\n  background-color: rgba(255, 91, 87, 0.8) !important;\n}\n\n.text-danger-transparent-8 {\n  color: rgba(255, 91, 87, 0.8) !important;\n}\n\n.bg-danger-transparent-9 {\n  background-color: rgba(255, 91, 87, 0.9) !important;\n}\n\n.text-danger-transparent-9 {\n  color: rgba(255, 91, 87, 0.9) !important;\n}\n\n.text-inverse {\n  color: #2d353c !important;\n}\n\n.text-inverse-lighter {\n  color: #62686d !important;\n}\n\n.text-inverse-darker {\n  color: #22282d !important;\n}\n\n.app-theme-inverse .app-sidebar .nav > li.active > a,\n.bg-inverse {\n  background-color: #2d353c !important;\n}\n\n.bg-inverse-lighter {\n  background-color: #62686d !important;\n}\n\n.bg-inverse-darker {\n  background-color: #22282d !important;\n}\n\n.app-theme-gradient-inverse .app-sidebar .nav > li.active > a,\n.bg-gradient-inverse {\n  background: #2d353c !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #434f59 0%,\n    #22282d 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #434f59 0%,\n    #22282d 100%\n  ) !important;\n  background: linear-gradient(to bottom, #434f59 0%, #22282d 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-inverse-transparent-1 {\n  background-color: rgba(45, 53, 60, 0.1) !important;\n}\n\n.text-inverse-transparent-1 {\n  color: rgba(45, 53, 60, 0.1) !important;\n}\n\n.bg-inverse-transparent-2 {\n  background-color: rgba(45, 53, 60, 0.2) !important;\n}\n\n.text-inverse-transparent-2 {\n  color: rgba(45, 53, 60, 0.2) !important;\n}\n\n.bg-inverse-transparent-3 {\n  background-color: rgba(45, 53, 60, 0.3) !important;\n}\n\n.text-inverse-transparent-3 {\n  color: rgba(45, 53, 60, 0.3) !important;\n}\n\n.bg-inverse-transparent-4 {\n  background-color: rgba(45, 53, 60, 0.4) !important;\n}\n\n.text-inverse-transparent-4 {\n  color: rgba(45, 53, 60, 0.4) !important;\n}\n\n.bg-inverse-transparent-5 {\n  background-color: rgba(45, 53, 60, 0.5) !important;\n}\n\n.text-inverse-transparent-5 {\n  color: rgba(45, 53, 60, 0.5) !important;\n}\n\n.bg-inverse-transparent-6 {\n  background-color: rgba(45, 53, 60, 0.6) !important;\n}\n\n.text-inverse-transparent-6 {\n  color: rgba(45, 53, 60, 0.6) !important;\n}\n\n.bg-inverse-transparent-7 {\n  background-color: rgba(45, 53, 60, 0.7) !important;\n}\n\n.text-inverse-transparent-7 {\n  color: rgba(45, 53, 60, 0.7) !important;\n}\n\n.bg-inverse-transparent-8 {\n  background-color: rgba(45, 53, 60, 0.8) !important;\n}\n\n.text-inverse-transparent-8 {\n  color: rgba(45, 53, 60, 0.8) !important;\n}\n\n.bg-inverse-transparent-9 {\n  background-color: rgba(45, 53, 60, 0.9) !important;\n}\n\n.text-inverse-transparent-9 {\n  color: rgba(45, 53, 60, 0.9) !important;\n}\n\n.text-grey {\n  color: #b6c2c9 !important;\n}\n\n.text-grey-lighter {\n  color: #c8d1d7 !important;\n}\n\n.text-grey-darker {\n  color: #899297 !important;\n}\n\n.app-theme-grey .app-sidebar .nav > li.active > a,\n.bg-grey {\n  background-color: #b6c2c9 !important;\n}\n\n.bg-grey-lighter {\n  background-color: #c8d1d7 !important;\n}\n\n.bg-grey-darker {\n  background-color: #899297 !important;\n}\n\n.app-theme-gradient-grey .app-sidebar .nav > li.active > a,\n.bg-gradient-grey {\n  background: #b6c2c9 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #d3dadf 0%,\n    #a7b6be 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #d3dadf 0%,\n    #a7b6be 100%\n  ) !important;\n  background: linear-gradient(to bottom, #d3dadf 0%, #a7b6be 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-grey-transparent-1 {\n  background-color: rgba(182, 194, 201, 0.1) !important;\n}\n\n.text-grey-transparent-1 {\n  color: rgba(182, 194, 201, 0.1) !important;\n}\n\n.bg-grey-transparent-2 {\n  background-color: rgba(182, 194, 201, 0.2) !important;\n}\n\n.text-grey-transparent-2 {\n  color: rgba(182, 194, 201, 0.2) !important;\n}\n\n.bg-grey-transparent-3 {\n  background-color: rgba(182, 194, 201, 0.3) !important;\n}\n\n.text-grey-transparent-3 {\n  color: rgba(182, 194, 201, 0.3) !important;\n}\n\n.bg-grey-transparent-4 {\n  background-color: rgba(182, 194, 201, 0.4) !important;\n}\n\n.text-grey-transparent-4 {\n  color: rgba(182, 194, 201, 0.4) !important;\n}\n\n.bg-grey-transparent-5 {\n  background-color: rgba(182, 194, 201, 0.5) !important;\n}\n\n.text-grey-transparent-5 {\n  color: rgba(182, 194, 201, 0.5) !important;\n}\n\n.bg-grey-transparent-6 {\n  background-color: rgba(182, 194, 201, 0.6) !important;\n}\n\n.text-grey-transparent-6 {\n  color: rgba(182, 194, 201, 0.6) !important;\n}\n\n.bg-grey-transparent-7 {\n  background-color: rgba(182, 194, 201, 0.7) !important;\n}\n\n.text-grey-transparent-7 {\n  color: rgba(182, 194, 201, 0.7) !important;\n}\n\n.bg-grey-transparent-8 {\n  background-color: rgba(182, 194, 201, 0.8) !important;\n}\n\n.text-grey-transparent-8 {\n  color: rgba(182, 194, 201, 0.8) !important;\n}\n\n.bg-grey-transparent-9 {\n  background-color: rgba(182, 194, 201, 0.9) !important;\n}\n\n.text-grey-transparent-9 {\n  color: rgba(182, 194, 201, 0.9) !important;\n}\n\n.app-theme-gradient-muted .app-sidebar .nav > li.active > a,\n.bg-gradient-muted {\n  background: #b6c2c9 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #d3dadf 0%,\n    #a7b6be 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #d3dadf 0%,\n    #a7b6be 100%\n  ) !important;\n  background: linear-gradient(to bottom, #d3dadf 0%, #a7b6be 100%) !important;\n}\n\n.text-blue {\n  color: #348fe2 !important;\n}\n\n.text-blue-lighter {\n  color: #67abe9 !important;\n}\n\n.text-blue-darker {\n  color: #276baa !important;\n}\n\n.app-theme-blue .app-sidebar .nav > li.active > a,\n.bg-blue {\n  background-color: #348fe2 !important;\n}\n\n.bg-blue-lighter {\n  background-color: #67abe9 !important;\n}\n\n.bg-blue-darker {\n  background-color: #276baa !important;\n}\n\n.app-theme-gradient-blue .app-sidebar .nav > li.active > a,\n.bg-gradient-blue {\n  background: #348fe2 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #61a8e8 0%,\n    #2083dd 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #61a8e8 0%,\n    #2083dd 100%\n  ) !important;\n  background: linear-gradient(to bottom, #61a8e8 0%, #2083dd 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-blue-transparent-1 {\n  background-color: rgba(52, 143, 226, 0.1) !important;\n}\n\n.text-blue-transparent-1 {\n  color: rgba(52, 143, 226, 0.1) !important;\n}\n\n.bg-blue-transparent-2 {\n  background-color: rgba(52, 143, 226, 0.2) !important;\n}\n\n.text-blue-transparent-2 {\n  color: rgba(52, 143, 226, 0.2) !important;\n}\n\n.bg-blue-transparent-3 {\n  background-color: rgba(52, 143, 226, 0.3) !important;\n}\n\n.text-blue-transparent-3 {\n  color: rgba(52, 143, 226, 0.3) !important;\n}\n\n.bg-blue-transparent-4 {\n  background-color: rgba(52, 143, 226, 0.4) !important;\n}\n\n.text-blue-transparent-4 {\n  color: rgba(52, 143, 226, 0.4) !important;\n}\n\n.bg-blue-transparent-5 {\n  background-color: rgba(52, 143, 226, 0.5) !important;\n}\n\n.text-blue-transparent-5 {\n  color: rgba(52, 143, 226, 0.5) !important;\n}\n\n.bg-blue-transparent-6 {\n  background-color: rgba(52, 143, 226, 0.6) !important;\n}\n\n.text-blue-transparent-6 {\n  color: rgba(52, 143, 226, 0.6) !important;\n}\n\n.bg-blue-transparent-7 {\n  background-color: rgba(52, 143, 226, 0.7) !important;\n}\n\n.text-blue-transparent-7 {\n  color: rgba(52, 143, 226, 0.7) !important;\n}\n\n.bg-blue-transparent-8 {\n  background-color: rgba(52, 143, 226, 0.8) !important;\n}\n\n.text-blue-transparent-8 {\n  color: rgba(52, 143, 226, 0.8) !important;\n}\n\n.bg-blue-transparent-9 {\n  background-color: rgba(52, 143, 226, 0.9) !important;\n}\n\n.text-blue-transparent-9 {\n  color: rgba(52, 143, 226, 0.9) !important;\n}\n\n.text-indigo {\n  color: #8753de !important;\n}\n\n.text-indigo-lighter {\n  color: #a57ee6 !important;\n}\n\n.text-indigo-darker {\n  color: #653ea7 !important;\n}\n\n.app-theme-indigo .app-sidebar .nav > li.active > a,\n.bg-indigo {\n  background-color: #8753de !important;\n}\n\n.bg-indigo-lighter {\n  background-color: #a57ee6 !important;\n}\n\n.bg-indigo-darker {\n  background-color: #653ea7 !important;\n}\n\n.app-theme-gradient-indigo .app-sidebar .nav > li.active > a,\n.bg-gradient-indigo {\n  background: #8753de !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #a57ee6 0%,\n    #783eda 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #a57ee6 0%,\n    #783eda 100%\n  ) !important;\n  background: linear-gradient(to bottom, #a57ee6 0%, #783eda 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-indigo-transparent-1 {\n  background-color: rgba(135, 83, 222, 0.1) !important;\n}\n\n.text-indigo-transparent-1 {\n  color: rgba(135, 83, 222, 0.1) !important;\n}\n\n.bg-indigo-transparent-2 {\n  background-color: rgba(135, 83, 222, 0.2) !important;\n}\n\n.text-indigo-transparent-2 {\n  color: rgba(135, 83, 222, 0.2) !important;\n}\n\n.bg-indigo-transparent-3 {\n  background-color: rgba(135, 83, 222, 0.3) !important;\n}\n\n.text-indigo-transparent-3 {\n  color: rgba(135, 83, 222, 0.3) !important;\n}\n\n.bg-indigo-transparent-4 {\n  background-color: rgba(135, 83, 222, 0.4) !important;\n}\n\n.text-indigo-transparent-4 {\n  color: rgba(135, 83, 222, 0.4) !important;\n}\n\n.bg-indigo-transparent-5 {\n  background-color: rgba(135, 83, 222, 0.5) !important;\n}\n\n.text-indigo-transparent-5 {\n  color: rgba(135, 83, 222, 0.5) !important;\n}\n\n.bg-indigo-transparent-6 {\n  background-color: rgba(135, 83, 222, 0.6) !important;\n}\n\n.text-indigo-transparent-6 {\n  color: rgba(135, 83, 222, 0.6) !important;\n}\n\n.bg-indigo-transparent-7 {\n  background-color: rgba(135, 83, 222, 0.7) !important;\n}\n\n.text-indigo-transparent-7 {\n  color: rgba(135, 83, 222, 0.7) !important;\n}\n\n.bg-indigo-transparent-8 {\n  background-color: rgba(135, 83, 222, 0.8) !important;\n}\n\n.text-indigo-transparent-8 {\n  color: rgba(135, 83, 222, 0.8) !important;\n}\n\n.bg-indigo-transparent-9 {\n  background-color: rgba(135, 83, 222, 0.9) !important;\n}\n\n.text-indigo-transparent-9 {\n  color: rgba(135, 83, 222, 0.9) !important;\n}\n\n.text-purple {\n  color: #727cb6 !important;\n}\n\n.text-purple-lighter {\n  color: #959dc8 !important;\n}\n\n.text-purple-darker {\n  color: #565d89 !important;\n}\n\n.app-theme-purple .app-sidebar .nav > li.active > a,\n.bg-purple {\n  background-color: #727cb6 !important;\n}\n\n.bg-purple-lighter {\n  background-color: #959dc8 !important;\n}\n\n.bg-purple-darker {\n  background-color: #565d89 !important;\n}\n\n.app-theme-gradient-purple .app-sidebar .nav > li.active > a,\n.bg-gradient-purple {\n  background: #727cb6 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #949bc7 0%,\n    #616cad 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #949bc7 0%,\n    #616cad 100%\n  ) !important;\n  background: linear-gradient(to bottom, #949bc7 0%, #616cad 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-purple-transparent-1 {\n  background-color: rgba(114, 124, 182, 0.1) !important;\n}\n\n.text-purple-transparent-1 {\n  color: rgba(114, 124, 182, 0.1) !important;\n}\n\n.bg-purple-transparent-2 {\n  background-color: rgba(114, 124, 182, 0.2) !important;\n}\n\n.text-purple-transparent-2 {\n  color: rgba(114, 124, 182, 0.2) !important;\n}\n\n.bg-purple-transparent-3 {\n  background-color: rgba(114, 124, 182, 0.3) !important;\n}\n\n.text-purple-transparent-3 {\n  color: rgba(114, 124, 182, 0.3) !important;\n}\n\n.bg-purple-transparent-4 {\n  background-color: rgba(114, 124, 182, 0.4) !important;\n}\n\n.text-purple-transparent-4 {\n  color: rgba(114, 124, 182, 0.4) !important;\n}\n\n.bg-purple-transparent-5 {\n  background-color: rgba(114, 124, 182, 0.5) !important;\n}\n\n.text-purple-transparent-5 {\n  color: rgba(114, 124, 182, 0.5) !important;\n}\n\n.bg-purple-transparent-6 {\n  background-color: rgba(114, 124, 182, 0.6) !important;\n}\n\n.text-purple-transparent-6 {\n  color: rgba(114, 124, 182, 0.6) !important;\n}\n\n.bg-purple-transparent-7 {\n  background-color: rgba(114, 124, 182, 0.7) !important;\n}\n\n.text-purple-transparent-7 {\n  color: rgba(114, 124, 182, 0.7) !important;\n}\n\n.bg-purple-transparent-8 {\n  background-color: rgba(114, 124, 182, 0.8) !important;\n}\n\n.text-purple-transparent-8 {\n  color: rgba(114, 124, 182, 0.8) !important;\n}\n\n.bg-purple-transparent-9 {\n  background-color: rgba(114, 124, 182, 0.9) !important;\n}\n\n.text-purple-transparent-9 {\n  color: rgba(114, 124, 182, 0.9) !important;\n}\n\n.text-pink {\n  color: #fb5597 !important;\n}\n\n.text-pink-lighter {\n  color: #fc80b1 !important;\n}\n\n.text-pink-darker {\n  color: #bc4071 !important;\n}\n\n.app-theme-pink .app-sidebar .nav > li.active > a,\n.bg-pink {\n  background-color: #fb5597 !important;\n}\n\n.bg-pink-lighter {\n  background-color: #fc80b1 !important;\n}\n\n.bg-pink-darker {\n  background-color: #bc4071 !important;\n}\n\n.app-theme-gradient-pink .app-sidebar .nav > li.active > a,\n.bg-gradient-pink {\n  background: #fb5597 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #fc87b5 0%,\n    #fa3c88 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #fc87b5 0%,\n    #fa3c88 100%\n  ) !important;\n  background: linear-gradient(to bottom, #fc87b5 0%, #fa3c88 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-pink-transparent-1 {\n  background-color: rgba(251, 85, 151, 0.1) !important;\n}\n\n.text-pink-transparent-1 {\n  color: rgba(251, 85, 151, 0.1) !important;\n}\n\n.bg-pink-transparent-2 {\n  background-color: rgba(251, 85, 151, 0.2) !important;\n}\n\n.text-pink-transparent-2 {\n  color: rgba(251, 85, 151, 0.2) !important;\n}\n\n.bg-pink-transparent-3 {\n  background-color: rgba(251, 85, 151, 0.3) !important;\n}\n\n.text-pink-transparent-3 {\n  color: rgba(251, 85, 151, 0.3) !important;\n}\n\n.bg-pink-transparent-4 {\n  background-color: rgba(251, 85, 151, 0.4) !important;\n}\n\n.text-pink-transparent-4 {\n  color: rgba(251, 85, 151, 0.4) !important;\n}\n\n.bg-pink-transparent-5 {\n  background-color: rgba(251, 85, 151, 0.5) !important;\n}\n\n.text-pink-transparent-5 {\n  color: rgba(251, 85, 151, 0.5) !important;\n}\n\n.bg-pink-transparent-6 {\n  background-color: rgba(251, 85, 151, 0.6) !important;\n}\n\n.text-pink-transparent-6 {\n  color: rgba(251, 85, 151, 0.6) !important;\n}\n\n.bg-pink-transparent-7 {\n  background-color: rgba(251, 85, 151, 0.7) !important;\n}\n\n.text-pink-transparent-7 {\n  color: rgba(251, 85, 151, 0.7) !important;\n}\n\n.bg-pink-transparent-8 {\n  background-color: rgba(251, 85, 151, 0.8) !important;\n}\n\n.text-pink-transparent-8 {\n  color: rgba(251, 85, 151, 0.8) !important;\n}\n\n.bg-pink-transparent-9 {\n  background-color: rgba(251, 85, 151, 0.9) !important;\n}\n\n.text-pink-transparent-9 {\n  color: rgba(251, 85, 151, 0.9) !important;\n}\n\n.text-red {\n  color: #ff5b57 !important;\n}\n\n.text-red-lighter {\n  color: #ff8481 !important;\n}\n\n.text-red-darker {\n  color: #bf4441 !important;\n}\n\n.app-theme-red .app-sidebar .nav > li.active > a,\n.bg-red {\n  background-color: #ff5b57 !important;\n}\n\n.bg-red-lighter {\n  background-color: #ff8481 !important;\n}\n\n.bg-red-darker {\n  background-color: #bf4441 !important;\n}\n\n.app-theme-gradient-red .app-sidebar .nav > li.active > a,\n.bg-gradient-red {\n  background: #ff5b57 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #ff8d8a 0%,\n    #ff423e 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #ff8d8a 0%,\n    #ff423e 100%\n  ) !important;\n  background: linear-gradient(to bottom, #ff8d8a 0%, #ff423e 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-red-transparent-1 {\n  background-color: rgba(255, 91, 87, 0.1) !important;\n}\n\n.text-red-transparent-1 {\n  color: rgba(255, 91, 87, 0.1) !important;\n}\n\n.bg-red-transparent-2 {\n  background-color: rgba(255, 91, 87, 0.2) !important;\n}\n\n.text-red-transparent-2 {\n  color: rgba(255, 91, 87, 0.2) !important;\n}\n\n.bg-red-transparent-3 {\n  background-color: rgba(255, 91, 87, 0.3) !important;\n}\n\n.text-red-transparent-3 {\n  color: rgba(255, 91, 87, 0.3) !important;\n}\n\n.bg-red-transparent-4 {\n  background-color: rgba(255, 91, 87, 0.4) !important;\n}\n\n.text-red-transparent-4 {\n  color: rgba(255, 91, 87, 0.4) !important;\n}\n\n.bg-red-transparent-5 {\n  background-color: rgba(255, 91, 87, 0.5) !important;\n}\n\n.text-red-transparent-5 {\n  color: rgba(255, 91, 87, 0.5) !important;\n}\n\n.bg-red-transparent-6 {\n  background-color: rgba(255, 91, 87, 0.6) !important;\n}\n\n.text-red-transparent-6 {\n  color: rgba(255, 91, 87, 0.6) !important;\n}\n\n.bg-red-transparent-7 {\n  background-color: rgba(255, 91, 87, 0.7) !important;\n}\n\n.text-red-transparent-7 {\n  color: rgba(255, 91, 87, 0.7) !important;\n}\n\n.bg-red-transparent-8 {\n  background-color: rgba(255, 91, 87, 0.8) !important;\n}\n\n.text-red-transparent-8 {\n  color: rgba(255, 91, 87, 0.8) !important;\n}\n\n.bg-red-transparent-9 {\n  background-color: rgba(255, 91, 87, 0.9) !important;\n}\n\n.text-red-transparent-9 {\n  color: rgba(255, 91, 87, 0.9) !important;\n}\n\n.text-orange {\n  color: #f59c1a !important;\n}\n\n.text-orange-lighter {\n  color: #f8b553 !important;\n}\n\n.text-orange-darker {\n  color: #b87514 !important;\n}\n\n.app-theme-orange .app-sidebar .nav > li.active > a,\n.bg-orange {\n  background-color: #f59c1a !important;\n}\n\n.bg-orange-lighter {\n  background-color: #f8b553 !important;\n}\n\n.bg-orange-darker {\n  background-color: #b87514 !important;\n}\n\n.app-theme-gradient-orange .app-sidebar .nav > li.active > a,\n.bg-gradient-orange {\n  background: #f59c1a !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #f7b14b 0%,\n    #eb900a 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #f7b14b 0%,\n    #eb900a 100%\n  ) !important;\n  background: linear-gradient(to bottom, #f7b14b 0%, #eb900a 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-orange-transparent-1 {\n  background-color: rgba(245, 156, 26, 0.1) !important;\n}\n\n.text-orange-transparent-1 {\n  color: rgba(245, 156, 26, 0.1) !important;\n}\n\n.bg-orange-transparent-2 {\n  background-color: rgba(245, 156, 26, 0.2) !important;\n}\n\n.text-orange-transparent-2 {\n  color: rgba(245, 156, 26, 0.2) !important;\n}\n\n.bg-orange-transparent-3 {\n  background-color: rgba(245, 156, 26, 0.3) !important;\n}\n\n.text-orange-transparent-3 {\n  color: rgba(245, 156, 26, 0.3) !important;\n}\n\n.bg-orange-transparent-4 {\n  background-color: rgba(245, 156, 26, 0.4) !important;\n}\n\n.text-orange-transparent-4 {\n  color: rgba(245, 156, 26, 0.4) !important;\n}\n\n.bg-orange-transparent-5 {\n  background-color: rgba(245, 156, 26, 0.5) !important;\n}\n\n.text-orange-transparent-5 {\n  color: rgba(245, 156, 26, 0.5) !important;\n}\n\n.bg-orange-transparent-6 {\n  background-color: rgba(245, 156, 26, 0.6) !important;\n}\n\n.text-orange-transparent-6 {\n  color: rgba(245, 156, 26, 0.6) !important;\n}\n\n.bg-orange-transparent-7 {\n  background-color: rgba(245, 156, 26, 0.7) !important;\n}\n\n.text-orange-transparent-7 {\n  color: rgba(245, 156, 26, 0.7) !important;\n}\n\n.bg-orange-transparent-8 {\n  background-color: rgba(245, 156, 26, 0.8) !important;\n}\n\n.text-orange-transparent-8 {\n  color: rgba(245, 156, 26, 0.8) !important;\n}\n\n.bg-orange-transparent-9 {\n  background-color: rgba(245, 156, 26, 0.9) !important;\n}\n\n.text-orange-transparent-9 {\n  color: rgba(245, 156, 26, 0.9) !important;\n}\n\n.text-yellow {\n  color: #ffd900 !important;\n}\n\n.text-yellow-lighter {\n  color: #ffe340 !important;\n}\n\n.text-yellow-darker {\n  color: #bfa300 !important;\n}\n\n.app-theme-yellow .app-sidebar .nav > li.active > a,\n.bg-yellow {\n  background-color: #ffd900 !important;\n}\n\n.bg-yellow-lighter {\n  background-color: #ffe340 !important;\n}\n\n.bg-yellow-darker {\n  background-color: #bfa300 !important;\n}\n\n.app-theme-gradient-yellow .app-sidebar .nav > li.active > a,\n.bg-gradient-yellow {\n  background: #ffd900 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #ffe133 0%,\n    #e6c300 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #ffe133 0%,\n    #e6c300 100%\n  ) !important;\n  background: linear-gradient(to bottom, #ffe133 0%, #e6c300 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-yellow-transparent-1 {\n  background-color: rgba(255, 217, 0, 0.1) !important;\n}\n\n.text-yellow-transparent-1 {\n  color: rgba(255, 217, 0, 0.1) !important;\n}\n\n.bg-yellow-transparent-2 {\n  background-color: rgba(255, 217, 0, 0.2) !important;\n}\n\n.text-yellow-transparent-2 {\n  color: rgba(255, 217, 0, 0.2) !important;\n}\n\n.bg-yellow-transparent-3 {\n  background-color: rgba(255, 217, 0, 0.3) !important;\n}\n\n.text-yellow-transparent-3 {\n  color: rgba(255, 217, 0, 0.3) !important;\n}\n\n.bg-yellow-transparent-4 {\n  background-color: rgba(255, 217, 0, 0.4) !important;\n}\n\n.text-yellow-transparent-4 {\n  color: rgba(255, 217, 0, 0.4) !important;\n}\n\n.bg-yellow-transparent-5 {\n  background-color: rgba(255, 217, 0, 0.5) !important;\n}\n\n.text-yellow-transparent-5 {\n  color: rgba(255, 217, 0, 0.5) !important;\n}\n\n.bg-yellow-transparent-6 {\n  background-color: rgba(255, 217, 0, 0.6) !important;\n}\n\n.text-yellow-transparent-6 {\n  color: rgba(255, 217, 0, 0.6) !important;\n}\n\n.bg-yellow-transparent-7 {\n  background-color: rgba(255, 217, 0, 0.7) !important;\n}\n\n.text-yellow-transparent-7 {\n  color: rgba(255, 217, 0, 0.7) !important;\n}\n\n.bg-yellow-transparent-8 {\n  background-color: rgba(255, 217, 0, 0.8) !important;\n}\n\n.text-yellow-transparent-8 {\n  color: rgba(255, 217, 0, 0.8) !important;\n}\n\n.bg-yellow-transparent-9 {\n  background-color: rgba(255, 217, 0, 0.9) !important;\n}\n\n.text-yellow-transparent-9 {\n  color: rgba(255, 217, 0, 0.9) !important;\n}\n\n.text-green {\n  color: #32a932 !important;\n}\n\n.text-green-lighter {\n  color: #65bf65 !important;\n}\n\n.text-green-darker {\n  color: #267f26 !important;\n}\n\n.app-theme-green .app-sidebar .nav > li.active > a,\n.bg-green {\n  background-color: #32a932 !important;\n}\n\n.bg-green-lighter {\n  background-color: #65bf65 !important;\n}\n\n.bg-green-darker {\n  background-color: #267f26 !important;\n}\n\n.app-theme-gradient-green .app-sidebar .nav > li.active > a,\n.bg-gradient-green {\n  background: #32a932 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #46c846 0%,\n    #2c952c 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #46c846 0%,\n    #2c952c 100%\n  ) !important;\n  background: linear-gradient(to bottom, #46c846 0%, #2c952c 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-green-transparent-1 {\n  background-color: rgba(50, 169, 50, 0.1) !important;\n}\n\n.text-green-transparent-1 {\n  color: rgba(50, 169, 50, 0.1) !important;\n}\n\n.bg-green-transparent-2 {\n  background-color: rgba(50, 169, 50, 0.2) !important;\n}\n\n.text-green-transparent-2 {\n  color: rgba(50, 169, 50, 0.2) !important;\n}\n\n.bg-green-transparent-3 {\n  background-color: rgba(50, 169, 50, 0.3) !important;\n}\n\n.text-green-transparent-3 {\n  color: rgba(50, 169, 50, 0.3) !important;\n}\n\n.bg-green-transparent-4 {\n  background-color: rgba(50, 169, 50, 0.4) !important;\n}\n\n.text-green-transparent-4 {\n  color: rgba(50, 169, 50, 0.4) !important;\n}\n\n.bg-green-transparent-5 {\n  background-color: rgba(50, 169, 50, 0.5) !important;\n}\n\n.text-green-transparent-5 {\n  color: rgba(50, 169, 50, 0.5) !important;\n}\n\n.bg-green-transparent-6 {\n  background-color: rgba(50, 169, 50, 0.6) !important;\n}\n\n.text-green-transparent-6 {\n  color: rgba(50, 169, 50, 0.6) !important;\n}\n\n.bg-green-transparent-7 {\n  background-color: rgba(50, 169, 50, 0.7) !important;\n}\n\n.text-green-transparent-7 {\n  color: rgba(50, 169, 50, 0.7) !important;\n}\n\n.bg-green-transparent-8 {\n  background-color: rgba(50, 169, 50, 0.8) !important;\n}\n\n.text-green-transparent-8 {\n  color: rgba(50, 169, 50, 0.8) !important;\n}\n\n.bg-green-transparent-9 {\n  background-color: rgba(50, 169, 50, 0.9) !important;\n}\n\n.text-green-transparent-9 {\n  color: rgba(50, 169, 50, 0.9) !important;\n}\n\n.text-teal {\n  color: #00acac !important;\n}\n\n.text-teal-lighter {\n  color: #40c1c1 !important;\n}\n\n.text-teal-darker {\n  color: #008181 !important;\n}\n\n.app-theme-teal .app-sidebar .nav > li.active > a,\n.bg-teal {\n  background-color: #00acac !important;\n}\n\n.bg-teal-lighter {\n  background-color: #40c1c1 !important;\n}\n\n.bg-teal-darker {\n  background-color: #008181 !important;\n}\n\n.app-theme-gradient-teal .app-sidebar .nav > li.active > a,\n.bg-gradient-teal {\n  background: #00acac !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #00dfdf 0%,\n    #009393 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #00dfdf 0%,\n    #009393 100%\n  ) !important;\n  background: linear-gradient(to bottom, #00dfdf 0%, #009393 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-teal-transparent-1 {\n  background-color: rgba(0, 172, 172, 0.1) !important;\n}\n\n.text-teal-transparent-1 {\n  color: rgba(0, 172, 172, 0.1) !important;\n}\n\n.bg-teal-transparent-2 {\n  background-color: rgba(0, 172, 172, 0.2) !important;\n}\n\n.text-teal-transparent-2 {\n  color: rgba(0, 172, 172, 0.2) !important;\n}\n\n.bg-teal-transparent-3 {\n  background-color: rgba(0, 172, 172, 0.3) !important;\n}\n\n.text-teal-transparent-3 {\n  color: rgba(0, 172, 172, 0.3) !important;\n}\n\n.bg-teal-transparent-4 {\n  background-color: rgba(0, 172, 172, 0.4) !important;\n}\n\n.text-teal-transparent-4 {\n  color: rgba(0, 172, 172, 0.4) !important;\n}\n\n.bg-teal-transparent-5 {\n  background-color: rgba(0, 172, 172, 0.5) !important;\n}\n\n.text-teal-transparent-5 {\n  color: rgba(0, 172, 172, 0.5) !important;\n}\n\n.bg-teal-transparent-6 {\n  background-color: rgba(0, 172, 172, 0.6) !important;\n}\n\n.text-teal-transparent-6 {\n  color: rgba(0, 172, 172, 0.6) !important;\n}\n\n.bg-teal-transparent-7 {\n  background-color: rgba(0, 172, 172, 0.7) !important;\n}\n\n.text-teal-transparent-7 {\n  color: rgba(0, 172, 172, 0.7) !important;\n}\n\n.bg-teal-transparent-8 {\n  background-color: rgba(0, 172, 172, 0.8) !important;\n}\n\n.text-teal-transparent-8 {\n  color: rgba(0, 172, 172, 0.8) !important;\n}\n\n.bg-teal-transparent-9 {\n  background-color: rgba(0, 172, 172, 0.9) !important;\n}\n\n.text-teal-transparent-9 {\n  color: rgba(0, 172, 172, 0.9) !important;\n}\n\n.text-cyan {\n  color: #49b6d6 !important;\n}\n\n.text-cyan-lighter {\n  color: #77c8e0 !important;\n}\n\n.text-cyan-darker {\n  color: #3789a1 !important;\n}\n\n.app-theme-cyan .app-sidebar .nav > li.active > a,\n.bg-cyan {\n  background-color: #49b6d6 !important;\n}\n\n.bg-cyan-lighter {\n  background-color: #77c8e0 !important;\n}\n\n.bg-cyan-darker {\n  background-color: #3789a1 !important;\n}\n\n.app-theme-gradient-cyan .app-sidebar .nav > li.active > a,\n.bg-gradient-cyan {\n  background: #49b6d6 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #73c7df 0%,\n    #34aed1 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #73c7df 0%,\n    #34aed1 100%\n  ) !important;\n  background: linear-gradient(to bottom, #73c7df 0%, #34aed1 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-cyan-transparent-1 {\n  background-color: rgba(73, 182, 214, 0.1) !important;\n}\n\n.text-cyan-transparent-1 {\n  color: rgba(73, 182, 214, 0.1) !important;\n}\n\n.bg-cyan-transparent-2 {\n  background-color: rgba(73, 182, 214, 0.2) !important;\n}\n\n.text-cyan-transparent-2 {\n  color: rgba(73, 182, 214, 0.2) !important;\n}\n\n.bg-cyan-transparent-3 {\n  background-color: rgba(73, 182, 214, 0.3) !important;\n}\n\n.text-cyan-transparent-3 {\n  color: rgba(73, 182, 214, 0.3) !important;\n}\n\n.bg-cyan-transparent-4 {\n  background-color: rgba(73, 182, 214, 0.4) !important;\n}\n\n.text-cyan-transparent-4 {\n  color: rgba(73, 182, 214, 0.4) !important;\n}\n\n.bg-cyan-transparent-5 {\n  background-color: rgba(73, 182, 214, 0.5) !important;\n}\n\n.text-cyan-transparent-5 {\n  color: rgba(73, 182, 214, 0.5) !important;\n}\n\n.bg-cyan-transparent-6 {\n  background-color: rgba(73, 182, 214, 0.6) !important;\n}\n\n.text-cyan-transparent-6 {\n  color: rgba(73, 182, 214, 0.6) !important;\n}\n\n.bg-cyan-transparent-7 {\n  background-color: rgba(73, 182, 214, 0.7) !important;\n}\n\n.text-cyan-transparent-7 {\n  color: rgba(73, 182, 214, 0.7) !important;\n}\n\n.bg-cyan-transparent-8 {\n  background-color: rgba(73, 182, 214, 0.8) !important;\n}\n\n.text-cyan-transparent-8 {\n  color: rgba(73, 182, 214, 0.8) !important;\n}\n\n.bg-cyan-transparent-9 {\n  background-color: rgba(73, 182, 214, 0.9) !important;\n}\n\n.text-cyan-transparent-9 {\n  color: rgba(73, 182, 214, 0.9) !important;\n}\n\n.text-white,\n.text-white-lighter {\n  color: #fff !important;\n}\n\n.text-white-darker {\n  color: #bfbfbf !important;\n}\n\n.app-theme-white .app-sidebar .nav > li.active > a,\n.bg-white,\n.bg-white-lighter {\n  background-color: #fff !important;\n}\n\n.bg-white-darker {\n  background-color: #bfbfbf !important;\n}\n\n.app-theme-gradient-white .app-sidebar .nav > li.active > a,\n.bg-gradient-white {\n  background: #fff !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    white 0%,\n    #f2f2f2 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    white 0%,\n    #f2f2f2 100%\n  ) !important;\n  background: linear-gradient(to bottom, #fff 0%, #f2f2f2 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-white-transparent-1 {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.text-white-transparent-1 {\n  color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.bg-white-transparent-2 {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.text-white-transparent-2 {\n  color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.bg-white-transparent-3 {\n  background-color: rgba(255, 255, 255, 0.3) !important;\n}\n\n.text-white-transparent-3 {\n  color: rgba(255, 255, 255, 0.3) !important;\n}\n\n.bg-white-transparent-4 {\n  background-color: rgba(255, 255, 255, 0.4) !important;\n}\n\n.text-white-transparent-4 {\n  color: rgba(255, 255, 255, 0.4) !important;\n}\n\n.bg-white-transparent-5 {\n  background-color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-white-transparent-5 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.bg-white-transparent-6 {\n  background-color: rgba(255, 255, 255, 0.6) !important;\n}\n\n.text-white-transparent-6 {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n\n.bg-white-transparent-7 {\n  background-color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.text-white-transparent-7 {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.bg-white-transparent-8 {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n\n.text-white-transparent-8 {\n  color: rgba(255, 255, 255, 0.8) !important;\n}\n\n.bg-white-transparent-9 {\n  background-color: rgba(255, 255, 255, 0.9) !important;\n}\n\n.text-white-transparent-9 {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n\n.text-gray {\n  color: #6c757d !important;\n}\n\n.text-gray-lighter {\n  color: #91989e !important;\n}\n\n.text-gray-darker {\n  color: #51585e !important;\n}\n\n.app-theme-gray .app-sidebar .nav > li.active > a,\n.bg-gray {\n  background-color: #6c757d !important;\n}\n\n.bg-gray-lighter {\n  background-color: #91989e !important;\n}\n\n.bg-gray-darker {\n  background-color: #51585e !important;\n}\n\n.app-theme-gradient-gray .app-sidebar .nav > li.active > a,\n.bg-gradient-gray {\n  background: #6c757d !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #868e96 0%,\n    #60686f 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #868e96 0%,\n    #60686f 100%\n  ) !important;\n  background: linear-gradient(to bottom, #868e96 0%, #60686f 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-gray-transparent-1 {\n  background-color: rgba(108, 117, 125, 0.1) !important;\n}\n\n.text-gray-transparent-1 {\n  color: rgba(108, 117, 125, 0.1) !important;\n}\n\n.bg-gray-transparent-2 {\n  background-color: rgba(108, 117, 125, 0.2) !important;\n}\n\n.text-gray-transparent-2 {\n  color: rgba(108, 117, 125, 0.2) !important;\n}\n\n.bg-gray-transparent-3 {\n  background-color: rgba(108, 117, 125, 0.3) !important;\n}\n\n.text-gray-transparent-3 {\n  color: rgba(108, 117, 125, 0.3) !important;\n}\n\n.bg-gray-transparent-4 {\n  background-color: rgba(108, 117, 125, 0.4) !important;\n}\n\n.text-gray-transparent-4 {\n  color: rgba(108, 117, 125, 0.4) !important;\n}\n\n.bg-gray-transparent-5 {\n  background-color: rgba(108, 117, 125, 0.5) !important;\n}\n\n.text-gray-transparent-5 {\n  color: rgba(108, 117, 125, 0.5) !important;\n}\n\n.bg-gray-transparent-6 {\n  background-color: rgba(108, 117, 125, 0.6) !important;\n}\n\n.text-gray-transparent-6 {\n  color: rgba(108, 117, 125, 0.6) !important;\n}\n\n.bg-gray-transparent-7 {\n  background-color: rgba(108, 117, 125, 0.7) !important;\n}\n\n.text-gray-transparent-7 {\n  color: rgba(108, 117, 125, 0.7) !important;\n}\n\n.bg-gray-transparent-8 {\n  background-color: rgba(108, 117, 125, 0.8) !important;\n}\n\n.text-gray-transparent-8 {\n  color: rgba(108, 117, 125, 0.8) !important;\n}\n\n.bg-gray-transparent-9 {\n  background-color: rgba(108, 117, 125, 0.9) !important;\n}\n\n.text-gray-transparent-9 {\n  color: rgba(108, 117, 125, 0.9) !important;\n}\n\n.text-gray-dark {\n  color: #343a40 !important;\n}\n\n.text-gray-dark-lighter {\n  color: #676b70 !important;\n}\n\n.text-gray-dark-darker {\n  color: #272c30 !important;\n}\n\n.app-theme-gray-dark .app-sidebar .nav > li.active > a,\n.bg-gray-dark {\n  background-color: #343a40 !important;\n}\n\n.bg-gray-dark-lighter {\n  background-color: #676b70 !important;\n}\n\n.bg-gray-dark-darker {\n  background-color: #272c30 !important;\n}\n\n.app-theme-gradient-gray-dark .app-sidebar .nav > li.active > a,\n.bg-gradient-gray-dark {\n  background: #343a40 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #4b545c 0%,\n    #292d32 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #4b545c 0%,\n    #292d32 100%\n  ) !important;\n  background: linear-gradient(to bottom, #4b545c 0%, #292d32 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-gray-dark-transparent-1 {\n  background-color: rgba(52, 58, 64, 0.1) !important;\n}\n\n.text-gray-dark-transparent-1 {\n  color: rgba(52, 58, 64, 0.1) !important;\n}\n\n.bg-gray-dark-transparent-2 {\n  background-color: rgba(52, 58, 64, 0.2) !important;\n}\n\n.text-gray-dark-transparent-2 {\n  color: rgba(52, 58, 64, 0.2) !important;\n}\n\n.bg-gray-dark-transparent-3 {\n  background-color: rgba(52, 58, 64, 0.3) !important;\n}\n\n.text-gray-dark-transparent-3 {\n  color: rgba(52, 58, 64, 0.3) !important;\n}\n\n.bg-gray-dark-transparent-4 {\n  background-color: rgba(52, 58, 64, 0.4) !important;\n}\n\n.text-gray-dark-transparent-4 {\n  color: rgba(52, 58, 64, 0.4) !important;\n}\n\n.bg-gray-dark-transparent-5 {\n  background-color: rgba(52, 58, 64, 0.5) !important;\n}\n\n.text-gray-dark-transparent-5 {\n  color: rgba(52, 58, 64, 0.5) !important;\n}\n\n.bg-gray-dark-transparent-6 {\n  background-color: rgba(52, 58, 64, 0.6) !important;\n}\n\n.text-gray-dark-transparent-6 {\n  color: rgba(52, 58, 64, 0.6) !important;\n}\n\n.bg-gray-dark-transparent-7 {\n  background-color: rgba(52, 58, 64, 0.7) !important;\n}\n\n.text-gray-dark-transparent-7 {\n  color: rgba(52, 58, 64, 0.7) !important;\n}\n\n.bg-gray-dark-transparent-8 {\n  background-color: rgba(52, 58, 64, 0.8) !important;\n}\n\n.text-gray-dark-transparent-8 {\n  color: rgba(52, 58, 64, 0.8) !important;\n}\n\n.bg-gray-dark-transparent-9 {\n  background-color: rgba(52, 58, 64, 0.9) !important;\n}\n\n.text-gray-dark-transparent-9 {\n  color: rgba(52, 58, 64, 0.9) !important;\n}\n\n.text-black {\n  color: #000 !important;\n}\n\n.text-black-lighter {\n  color: #404040 !important;\n}\n\n.text-black-darker {\n  color: #000 !important;\n}\n\n.bg-black {\n  background-color: #000 !important;\n}\n\n.bg-black-lighter {\n  background-color: #404040 !important;\n}\n\n.app-theme-black .app-sidebar .nav > li.active > a,\n.bg-black-darker {\n  background-color: #000 !important;\n}\n\n.app-theme-gradient-black .app-sidebar .nav > li.active > a,\n.bg-gradient-black {\n  background: #000 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #1a1a1a 0%,\n    black 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #1a1a1a 0%,\n    black 100%\n  ) !important;\n  background: linear-gradient(to bottom, #1a1a1a 0%, #000 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-black-transparent-1 {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n.text-black-transparent-1 {\n  color: rgba(0, 0, 0, 0.1) !important;\n}\n\n.bg-black-transparent-2 {\n  background-color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.text-black-transparent-2 {\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.bg-black-transparent-3 {\n  background-color: rgba(0, 0, 0, 0.3) !important;\n}\n\n.text-black-transparent-3 {\n  color: rgba(0, 0, 0, 0.3) !important;\n}\n\n.bg-black-transparent-4 {\n  background-color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.text-black-transparent-4 {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.bg-black-transparent-5 {\n  background-color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-black-transparent-5 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.bg-black-transparent-6 {\n  background-color: rgba(0, 0, 0, 0.6) !important;\n}\n\n.text-black-transparent-6 {\n  color: rgba(0, 0, 0, 0.6) !important;\n}\n\n.bg-black-transparent-7 {\n  background-color: rgba(0, 0, 0, 0.7) !important;\n}\n\n.text-black-transparent-7 {\n  color: rgba(0, 0, 0, 0.7) !important;\n}\n\n.bg-black-transparent-8 {\n  background-color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.text-black-transparent-8 {\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.bg-black-transparent-9 {\n  background-color: rgba(0, 0, 0, 0.9) !important;\n}\n\n.text-black-transparent-9 {\n  color: rgba(0, 0, 0, 0.9) !important;\n}\n\n.text-dark {\n  color: #2d353c !important;\n}\n\n.text-dark-lighter {\n  color: #62686d !important;\n}\n\n.app-theme-dark .app-sidebar .nav > li.active > a,\n.bg-dark {\n  background-color: #2d353c !important;\n}\n\n.bg-dark-lighter {\n  background-color: #62686d !important;\n}\n\n.app-theme-gradient-dark .app-sidebar .nav > li.active > a,\n.bg-gradient-dark {\n  background: #2d353c !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #434f59 0%,\n    #22282d 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #434f59 0%,\n    #22282d 100%\n  ) !important;\n  background: linear-gradient(to bottom, #434f59 0%, #22282d 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-dark-transparent-1 {\n  background-color: rgba(45, 53, 60, 0.1) !important;\n}\n\n.text-dark-transparent-1 {\n  color: rgba(45, 53, 60, 0.1) !important;\n}\n\n.bg-dark-transparent-2 {\n  background-color: rgba(45, 53, 60, 0.2) !important;\n}\n\n.text-dark-transparent-2 {\n  color: rgba(45, 53, 60, 0.2) !important;\n}\n\n.bg-dark-transparent-3 {\n  background-color: rgba(45, 53, 60, 0.3) !important;\n}\n\n.text-dark-transparent-3 {\n  color: rgba(45, 53, 60, 0.3) !important;\n}\n\n.bg-dark-transparent-4 {\n  background-color: rgba(45, 53, 60, 0.4) !important;\n}\n\n.text-dark-transparent-4 {\n  color: rgba(45, 53, 60, 0.4) !important;\n}\n\n.bg-dark-transparent-5 {\n  background-color: rgba(45, 53, 60, 0.5) !important;\n}\n\n.text-dark-transparent-5 {\n  color: rgba(45, 53, 60, 0.5) !important;\n}\n\n.bg-dark-transparent-6 {\n  background-color: rgba(45, 53, 60, 0.6) !important;\n}\n\n.text-dark-transparent-6 {\n  color: rgba(45, 53, 60, 0.6) !important;\n}\n\n.bg-dark-transparent-7 {\n  background-color: rgba(45, 53, 60, 0.7) !important;\n}\n\n.text-dark-transparent-7 {\n  color: rgba(45, 53, 60, 0.7) !important;\n}\n\n.bg-dark-transparent-8 {\n  background-color: rgba(45, 53, 60, 0.8) !important;\n}\n\n.text-dark-transparent-8 {\n  color: rgba(45, 53, 60, 0.8) !important;\n}\n\n.bg-dark-transparent-9 {\n  background-color: rgba(45, 53, 60, 0.9) !important;\n}\n\n.text-dark-transparent-9 {\n  color: rgba(45, 53, 60, 0.9) !important;\n}\n\n.text-dark-darker {\n  color: #1a2229 !important;\n}\n\n.text-dark-darker-lighter {\n  color: #53595f !important;\n}\n\n.text-dark-darker-darker {\n  color: #141a1f !important;\n}\n\n.app-theme-dark-darker .app-sidebar .nav > li.active > a,\n.bg-dark-darker {\n  background-color: #1a2229 !important;\n}\n\n.bg-dark-darker-lighter {\n  background-color: #53595f !important;\n}\n\n.bg-dark-darker-darker {\n  background-color: #141a1f !important;\n}\n\n.app-theme-gradient-dark-darker .app-sidebar .nav > li.active > a,\n.bg-gradient-dark-darker {\n  background: #1a2229 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #2e3c48 0%,\n    #101519 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #2e3c48 0%,\n    #101519 100%\n  ) !important;\n  background: linear-gradient(to bottom, #2e3c48 0%, #101519 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-dark-darker-transparent-1 {\n  background-color: rgba(26, 34, 41, 0.1) !important;\n}\n\n.text-dark-darker-transparent-1 {\n  color: rgba(26, 34, 41, 0.1) !important;\n}\n\n.bg-dark-darker-transparent-2 {\n  background-color: rgba(26, 34, 41, 0.2) !important;\n}\n\n.text-dark-darker-transparent-2 {\n  color: rgba(26, 34, 41, 0.2) !important;\n}\n\n.bg-dark-darker-transparent-3 {\n  background-color: rgba(26, 34, 41, 0.3) !important;\n}\n\n.text-dark-darker-transparent-3 {\n  color: rgba(26, 34, 41, 0.3) !important;\n}\n\n.bg-dark-darker-transparent-4 {\n  background-color: rgba(26, 34, 41, 0.4) !important;\n}\n\n.text-dark-darker-transparent-4 {\n  color: rgba(26, 34, 41, 0.4) !important;\n}\n\n.bg-dark-darker-transparent-5 {\n  background-color: rgba(26, 34, 41, 0.5) !important;\n}\n\n.text-dark-darker-transparent-5 {\n  color: rgba(26, 34, 41, 0.5) !important;\n}\n\n.bg-dark-darker-transparent-6 {\n  background-color: rgba(26, 34, 41, 0.6) !important;\n}\n\n.text-dark-darker-transparent-6 {\n  color: rgba(26, 34, 41, 0.6) !important;\n}\n\n.bg-dark-darker-transparent-7 {\n  background-color: rgba(26, 34, 41, 0.7) !important;\n}\n\n.text-dark-darker-transparent-7 {\n  color: rgba(26, 34, 41, 0.7) !important;\n}\n\n.bg-dark-darker-transparent-8 {\n  background-color: rgba(26, 34, 41, 0.8) !important;\n}\n\n.text-dark-darker-transparent-8 {\n  color: rgba(26, 34, 41, 0.8) !important;\n}\n\n.bg-dark-darker-transparent-9 {\n  background-color: rgba(26, 34, 41, 0.9) !important;\n}\n\n.text-dark-darker-transparent-9 {\n  color: rgba(26, 34, 41, 0.9) !important;\n}\n\n.text-lime {\n  color: #90ca4b !important;\n}\n\n.text-lime-lighter {\n  color: #acd778 !important;\n}\n\n.text-lime-darker {\n  color: #6c9838 !important;\n}\n\n.app-theme-lime .app-sidebar .nav > li.active > a,\n.bg-lime {\n  background-color: #90ca4b !important;\n}\n\n.bg-lime-lighter {\n  background-color: #acd778 !important;\n}\n\n.bg-lime-darker {\n  background-color: #6c9838 !important;\n}\n\n.app-theme-gradient-lime .app-sidebar .nav > li.active > a,\n.bg-gradient-lime {\n  background: #90ca4b !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #a8d672 0%,\n    #84c239 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #a8d672 0%,\n    #84c239 100%\n  ) !important;\n  background: linear-gradient(to bottom, #a8d672 0%, #84c239 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-lime-transparent-1 {\n  background-color: rgba(144, 202, 75, 0.1) !important;\n}\n\n.text-lime-transparent-1 {\n  color: rgba(144, 202, 75, 0.1) !important;\n}\n\n.bg-lime-transparent-2 {\n  background-color: rgba(144, 202, 75, 0.2) !important;\n}\n\n.text-lime-transparent-2 {\n  color: rgba(144, 202, 75, 0.2) !important;\n}\n\n.bg-lime-transparent-3 {\n  background-color: rgba(144, 202, 75, 0.3) !important;\n}\n\n.text-lime-transparent-3 {\n  color: rgba(144, 202, 75, 0.3) !important;\n}\n\n.bg-lime-transparent-4 {\n  background-color: rgba(144, 202, 75, 0.4) !important;\n}\n\n.text-lime-transparent-4 {\n  color: rgba(144, 202, 75, 0.4) !important;\n}\n\n.bg-lime-transparent-5 {\n  background-color: rgba(144, 202, 75, 0.5) !important;\n}\n\n.text-lime-transparent-5 {\n  color: rgba(144, 202, 75, 0.5) !important;\n}\n\n.bg-lime-transparent-6 {\n  background-color: rgba(144, 202, 75, 0.6) !important;\n}\n\n.text-lime-transparent-6 {\n  color: rgba(144, 202, 75, 0.6) !important;\n}\n\n.bg-lime-transparent-7 {\n  background-color: rgba(144, 202, 75, 0.7) !important;\n}\n\n.text-lime-transparent-7 {\n  color: rgba(144, 202, 75, 0.7) !important;\n}\n\n.bg-lime-transparent-8 {\n  background-color: rgba(144, 202, 75, 0.8) !important;\n}\n\n.text-lime-transparent-8 {\n  color: rgba(144, 202, 75, 0.8) !important;\n}\n\n.bg-lime-transparent-9 {\n  background-color: rgba(144, 202, 75, 0.9) !important;\n}\n\n.text-lime-transparent-9 {\n  color: rgba(144, 202, 75, 0.9) !important;\n}\n\n.text-light {\n  color: #f2f3f4 !important;\n}\n\n.text-light-lighter {\n  color: #f5f6f7 !important;\n}\n\n.text-light-darker {\n  color: #b6b6b7 !important;\n}\n\n.app-theme-light .app-sidebar .nav > li.active > a,\n.bg-light {\n  background-color: #f2f3f4 !important;\n}\n\n.bg-light-lighter {\n  background-color: #f5f6f7 !important;\n}\n\n.bg-light-darker {\n  background-color: #b6b6b7 !important;\n}\n\n.app-theme-gradient-light .app-sidebar .nav > li.active > a,\n.bg-gradient-light {\n  background: #f2f3f4 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    white 0%,\n    #e4e6e8 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    white 0%,\n    #e4e6e8 100%\n  ) !important;\n  background: linear-gradient(to bottom, #fff 0%, #e4e6e8 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-light-transparent-1 {\n  background-color: rgba(242, 243, 244, 0.1) !important;\n}\n\n.text-light-transparent-1 {\n  color: rgba(242, 243, 244, 0.1) !important;\n}\n\n.bg-light-transparent-2 {\n  background-color: rgba(242, 243, 244, 0.2) !important;\n}\n\n.text-light-transparent-2 {\n  color: rgba(242, 243, 244, 0.2) !important;\n}\n\n.bg-light-transparent-3 {\n  background-color: rgba(242, 243, 244, 0.3) !important;\n}\n\n.text-light-transparent-3 {\n  color: rgba(242, 243, 244, 0.3) !important;\n}\n\n.bg-light-transparent-4 {\n  background-color: rgba(242, 243, 244, 0.4) !important;\n}\n\n.text-light-transparent-4 {\n  color: rgba(242, 243, 244, 0.4) !important;\n}\n\n.bg-light-transparent-5 {\n  background-color: rgba(242, 243, 244, 0.5) !important;\n}\n\n.text-light-transparent-5 {\n  color: rgba(242, 243, 244, 0.5) !important;\n}\n\n.bg-light-transparent-6 {\n  background-color: rgba(242, 243, 244, 0.6) !important;\n}\n\n.text-light-transparent-6 {\n  color: rgba(242, 243, 244, 0.6) !important;\n}\n\n.bg-light-transparent-7 {\n  background-color: rgba(242, 243, 244, 0.7) !important;\n}\n\n.text-light-transparent-7 {\n  color: rgba(242, 243, 244, 0.7) !important;\n}\n\n.bg-light-transparent-8 {\n  background-color: rgba(242, 243, 244, 0.8) !important;\n}\n\n.text-light-transparent-8 {\n  color: rgba(242, 243, 244, 0.8) !important;\n}\n\n.bg-light-transparent-9 {\n  background-color: rgba(242, 243, 244, 0.9) !important;\n}\n\n.text-light-transparent-9 {\n  color: rgba(242, 243, 244, 0.9) !important;\n}\n\n.text-silver {\n  color: #b6c2c9 !important;\n}\n\n.text-silver-lighter {\n  color: #c8d1d7 !important;\n}\n\n.text-silver-darker {\n  color: #899297 !important;\n}\n\n.app-theme-silver .app-sidebar .nav > li.active > a,\n.bg-silver {\n  background-color: #b6c2c9 !important;\n}\n\n.bg-silver-lighter {\n  background-color: #c8d1d7 !important;\n}\n\n.bg-silver-darker {\n  background-color: #899297 !important;\n}\n\n.app-theme-gradient-silver .app-sidebar .nav > li.active > a,\n.bg-gradient-silver {\n  background: #b6c2c9 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #d3dadf 0%,\n    #a7b6be 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #d3dadf 0%,\n    #a7b6be 100%\n  ) !important;\n  background: linear-gradient(to bottom, #d3dadf 0%, #a7b6be 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-silver-transparent-1 {\n  background-color: rgba(182, 194, 201, 0.1) !important;\n}\n\n.text-silver-transparent-1 {\n  color: rgba(182, 194, 201, 0.1) !important;\n}\n\n.bg-silver-transparent-2 {\n  background-color: rgba(182, 194, 201, 0.2) !important;\n}\n\n.text-silver-transparent-2 {\n  color: rgba(182, 194, 201, 0.2) !important;\n}\n\n.bg-silver-transparent-3 {\n  background-color: rgba(182, 194, 201, 0.3) !important;\n}\n\n.text-silver-transparent-3 {\n  color: rgba(182, 194, 201, 0.3) !important;\n}\n\n.bg-silver-transparent-4 {\n  background-color: rgba(182, 194, 201, 0.4) !important;\n}\n\n.text-silver-transparent-4 {\n  color: rgba(182, 194, 201, 0.4) !important;\n}\n\n.bg-silver-transparent-5 {\n  background-color: rgba(182, 194, 201, 0.5) !important;\n}\n\n.text-silver-transparent-5 {\n  color: rgba(182, 194, 201, 0.5) !important;\n}\n\n.bg-silver-transparent-6 {\n  background-color: rgba(182, 194, 201, 0.6) !important;\n}\n\n.text-silver-transparent-6 {\n  color: rgba(182, 194, 201, 0.6) !important;\n}\n\n.bg-silver-transparent-7 {\n  background-color: rgba(182, 194, 201, 0.7) !important;\n}\n\n.text-silver-transparent-7 {\n  color: rgba(182, 194, 201, 0.7) !important;\n}\n\n.bg-silver-transparent-8 {\n  background-color: rgba(182, 194, 201, 0.8) !important;\n}\n\n.text-silver-transparent-8 {\n  color: rgba(182, 194, 201, 0.8) !important;\n}\n\n.bg-silver-transparent-9 {\n  background-color: rgba(182, 194, 201, 0.9) !important;\n}\n\n.text-silver-transparent-9 {\n  color: rgba(182, 194, 201, 0.9) !important;\n}\n\n.text-muted {\n  color: #627884 !important;\n}\n\n.text-muted-lighter {\n  color: #8999a3 !important;\n}\n\n.text-muted-darker {\n  color: #495a63 !important;\n}\n\n.app-theme-muted .app-sidebar .nav > li.active > a,\n.bg-muted {\n  background-color: #627884 !important;\n}\n\n.bg-muted-lighter {\n  background-color: #8999a3 !important;\n}\n\n.bg-muted-darker {\n  background-color: #495a63 !important;\n}\n\n.app-theme-gradient-muted .app-sidebar .nav > li.active > a,\n.bg-gradient-muted {\n  background: #627884 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #7b919e 0%,\n    #576a76 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #7b919e 0%,\n    #576a76 100%\n  ) !important;\n  background: linear-gradient(to bottom, #7b919e 0%, #576a76 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-muted-transparent-1 {\n  background-color: rgba(98, 120, 132, 0.1) !important;\n}\n\n.text-muted-transparent-1 {\n  color: rgba(98, 120, 132, 0.1) !important;\n}\n\n.bg-muted-transparent-2 {\n  background-color: rgba(98, 120, 132, 0.2) !important;\n}\n\n.text-muted-transparent-2 {\n  color: rgba(98, 120, 132, 0.2) !important;\n}\n\n.bg-muted-transparent-3 {\n  background-color: rgba(98, 120, 132, 0.3) !important;\n}\n\n.text-muted-transparent-3 {\n  color: rgba(98, 120, 132, 0.3) !important;\n}\n\n.bg-muted-transparent-4 {\n  background-color: rgba(98, 120, 132, 0.4) !important;\n}\n\n.text-muted-transparent-4 {\n  color: rgba(98, 120, 132, 0.4) !important;\n}\n\n.bg-muted-transparent-5 {\n  background-color: rgba(98, 120, 132, 0.5) !important;\n}\n\n.text-muted-transparent-5 {\n  color: rgba(98, 120, 132, 0.5) !important;\n}\n\n.bg-muted-transparent-6 {\n  background-color: rgba(98, 120, 132, 0.6) !important;\n}\n\n.text-muted-transparent-6 {\n  color: rgba(98, 120, 132, 0.6) !important;\n}\n\n.bg-muted-transparent-7 {\n  background-color: rgba(98, 120, 132, 0.7) !important;\n}\n\n.text-muted-transparent-7 {\n  color: rgba(98, 120, 132, 0.7) !important;\n}\n\n.bg-muted-transparent-8 {\n  background-color: rgba(98, 120, 132, 0.8) !important;\n}\n\n.text-muted-transparent-8 {\n  color: rgba(98, 120, 132, 0.8) !important;\n}\n\n.bg-muted-transparent-9 {\n  background-color: rgba(98, 120, 132, 0.9) !important;\n}\n\n.text-muted-transparent-9 {\n  color: rgba(98, 120, 132, 0.9) !important;\n}\n\n.text-aqua {\n  color: #49b6d6 !important;\n}\n\n.text-aqua-lighter {\n  color: #77c8e0 !important;\n}\n\n.text-aqua-darker {\n  color: #3789a1 !important;\n}\n\n.app-theme-aqua .app-sidebar .nav > li.active > a,\n.bg-aqua {\n  background-color: #49b6d6 !important;\n}\n\n.bg-aqua-lighter {\n  background-color: #77c8e0 !important;\n}\n\n.bg-aqua-darker {\n  background-color: #3789a1 !important;\n}\n\n.app-theme-gradient-aqua .app-sidebar .nav > li.active > a,\n.bg-gradient-aqua {\n  background: #49b6d6 !important;\n  background: -moz-linear-gradient(\n    to bottom,\n    #73c7df 0%,\n    #34aed1 100%\n  ) !important;\n  background: -webkit-linear-gradient(\n    to bottom,\n    #73c7df 0%,\n    #34aed1 100%\n  ) !important;\n  background: linear-gradient(to bottom, #73c7df 0%, #34aed1 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)', GradientType=0) !important;\n}\n\n.bg-aqua-transparent-1 {\n  background-color: rgba(73, 182, 214, 0.1) !important;\n}\n\n.text-aqua-transparent-1 {\n  color: rgba(73, 182, 214, 0.1) !important;\n}\n\n.bg-aqua-transparent-2 {\n  background-color: rgba(73, 182, 214, 0.2) !important;\n}\n\n.text-aqua-transparent-2 {\n  color: rgba(73, 182, 214, 0.2) !important;\n}\n\n.bg-aqua-transparent-3 {\n  background-color: rgba(73, 182, 214, 0.3) !important;\n}\n\n.text-aqua-transparent-3 {\n  color: rgba(73, 182, 214, 0.3) !important;\n}\n\n.bg-aqua-transparent-4 {\n  background-color: rgba(73, 182, 214, 0.4) !important;\n}\n\n.text-aqua-transparent-4 {\n  color: rgba(73, 182, 214, 0.4) !important;\n}\n\n.bg-aqua-transparent-5 {\n  background-color: rgba(73, 182, 214, 0.5) !important;\n}\n\n.text-aqua-transparent-5 {\n  color: rgba(73, 182, 214, 0.5) !important;\n}\n\n.bg-aqua-transparent-6 {\n  background-color: rgba(73, 182, 214, 0.6) !important;\n}\n\n.text-aqua-transparent-6 {\n  color: rgba(73, 182, 214, 0.6) !important;\n}\n\n.bg-aqua-transparent-7 {\n  background-color: rgba(73, 182, 214, 0.7) !important;\n}\n\n.text-aqua-transparent-7 {\n  color: rgba(73, 182, 214, 0.7) !important;\n}\n\n.bg-aqua-transparent-8 {\n  background-color: rgba(73, 182, 214, 0.8) !important;\n}\n\n.text-aqua-transparent-8 {\n  color: rgba(73, 182, 214, 0.8) !important;\n}\n\n.bg-aqua-transparent-9 {\n  background-color: rgba(73, 182, 214, 0.9) !important;\n}\n\n.text-aqua-transparent-9 {\n  color: rgba(73, 182, 214, 0.9) !important;\n}\n\n.no-bg {\n  background: 0 0 !important;\n}\n\n.bg-gradient-red-pink,\n.bg-gradient-red-pink-diagonal-down,\n.bg-gradient-red-pink-diagonal-up,\n.bg-gradient-red-pink-to-right {\n  background: #ff5b57;\n}\n\n.bg-gradient-red-pink {\n  background: -moz-linear-gradient(to bottom, #ff5b57 0%, #fb5597 100%);\n  background: -webkit-linear-gradient(to bottom, #ff5b57 0%, #fb5597 100%);\n  background: linear-gradient(to bottom, #ff5b57 0%, #fb5597 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-red-pink-to-right,\n.bg-gradient-red-pink-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-red-pink-to-right {\n  background: -moz-linear-gradient(to right, #ff5b57 0%, #fb5597 100%);\n  background: -webkit-linear-gradient(to right, #ff5b57 0%, #fb5597 100%);\n  background: linear-gradient(to right, #ff5b57 0%, #fb5597 100%);\n}\n\n.bg-gradient-red-pink-to-top {\n  background: -moz-linear-gradient(to top, #ff5b57 0%, #fb5597 100%);\n  background: -webkit-linear-gradient(to top, #ff5b57 0%, #fb5597 100%);\n  background: linear-gradient(to top, #ff5b57 0%, #fb5597 100%);\n}\n\n.bg-gradient-red-pink-to-left {\n  background: -moz-linear-gradient(to left, #ff5b57 0%, #fb5597 100%);\n  background: -webkit-linear-gradient(to left, #ff5b57 0%, #fb5597 100%);\n  background: linear-gradient(to left, #ff5b57 0%, #fb5597 100%);\n}\n\n.bg-gradient-red-pink-diagonal-down,\n.bg-gradient-red-pink-diagonal-up,\n.bg-gradient-red-pink-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-red-pink-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #ff5b57 0%, #fb5597 100%);\n  background: -webkit-linear-gradient(-45deg, #ff5b57 0%, #fb5597 100%);\n  background: linear-gradient(-45deg, #ff5b57 0%, #fb5597 100%);\n}\n\n.bg-gradient-red-pink-diagonal-up {\n  background: -moz-linear-gradient(45deg, #ff5b57 0%, #fb5597 100%);\n  background: -webkit-linear-gradient(45deg, #ff5b57 0%, #fb5597 100%);\n  background: linear-gradient(45deg, #ff5b57 0%, #fb5597 100%);\n}\n\n.bg-gradient-orange-red,\n.bg-gradient-orange-red-diagonal-down,\n.bg-gradient-orange-red-diagonal-up,\n.bg-gradient-orange-red-to-right {\n  background: #f59c1a;\n}\n\n.bg-gradient-orange-red {\n  background: -moz-linear-gradient(to bottom, #f59c1a 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to bottom, #f59c1a 0%, #ff5b57 100%);\n  background: linear-gradient(to bottom, #f59c1a 0%, #ff5b57 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-orange-red-to-right,\n.bg-gradient-orange-red-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-orange-red-to-right {\n  background: -moz-linear-gradient(to right, #f59c1a 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to right, #f59c1a 0%, #ff5b57 100%);\n  background: linear-gradient(to right, #f59c1a 0%, #ff5b57 100%);\n}\n\n.bg-gradient-orange-red-to-top {\n  background: -moz-linear-gradient(to top, #f59c1a 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to top, #f59c1a 0%, #ff5b57 100%);\n  background: linear-gradient(to top, #f59c1a 0%, #ff5b57 100%);\n}\n\n.bg-gradient-orange-red-to-left {\n  background: -moz-linear-gradient(to left, #f59c1a 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to left, #f59c1a 0%, #ff5b57 100%);\n  background: linear-gradient(to left, #f59c1a 0%, #ff5b57 100%);\n}\n\n.bg-gradient-orange-red-diagonal-down,\n.bg-gradient-orange-red-diagonal-up,\n.bg-gradient-orange-red-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-orange-red-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #f59c1a 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(-45deg, #f59c1a 0%, #ff5b57 100%);\n  background: linear-gradient(-45deg, #f59c1a 0%, #ff5b57 100%);\n}\n\n.bg-gradient-orange-red-diagonal-up {\n  background: -moz-linear-gradient(45deg, #f59c1a 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(45deg, #f59c1a 0%, #ff5b57 100%);\n  background: linear-gradient(45deg, #f59c1a 0%, #ff5b57 100%);\n}\n\n.bg-gradient-yellow-orange,\n.bg-gradient-yellow-orange-diagonal-down,\n.bg-gradient-yellow-orange-diagonal-up,\n.bg-gradient-yellow-orange-to-right {\n  background: #ffd900;\n}\n\n.bg-gradient-yellow-orange {\n  background: -moz-linear-gradient(to bottom, #ffd900 0%, #f59c1a 100%);\n  background: -webkit-linear-gradient(to bottom, #ffd900 0%, #f59c1a 100%);\n  background: linear-gradient(to bottom, #ffd900 0%, #f59c1a 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-yellow-orange-to-right,\n.bg-gradient-yellow-orange-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-yellow-orange-to-right {\n  background: -moz-linear-gradient(to right, #ffd900 0%, #f59c1a 100%);\n  background: -webkit-linear-gradient(to right, #ffd900 0%, #f59c1a 100%);\n  background: linear-gradient(to right, #ffd900 0%, #f59c1a 100%);\n}\n\n.bg-gradient-yellow-orange-to-top {\n  background: -moz-linear-gradient(to top, #ffd900 0%, #f59c1a 100%);\n  background: -webkit-linear-gradient(to top, #ffd900 0%, #f59c1a 100%);\n  background: linear-gradient(to top, #ffd900 0%, #f59c1a 100%);\n}\n\n.bg-gradient-yellow-orange-to-left {\n  background: -moz-linear-gradient(to left, #ffd900 0%, #f59c1a 100%);\n  background: -webkit-linear-gradient(to left, #ffd900 0%, #f59c1a 100%);\n  background: linear-gradient(to left, #ffd900 0%, #f59c1a 100%);\n}\n\n.bg-gradient-yellow-orange-diagonal-down,\n.bg-gradient-yellow-orange-diagonal-up,\n.bg-gradient-yellow-orange-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-yellow-orange-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #ffd900 0%, #f59c1a 100%);\n  background: -webkit-linear-gradient(-45deg, #ffd900 0%, #f59c1a 100%);\n  background: linear-gradient(-45deg, #ffd900 0%, #f59c1a 100%);\n}\n\n.bg-gradient-yellow-orange-diagonal-up {\n  background: -moz-linear-gradient(45deg, #ffd900 0%, #f59c1a 100%);\n  background: -webkit-linear-gradient(45deg, #ffd900 0%, #f59c1a 100%);\n  background: linear-gradient(45deg, #ffd900 0%, #f59c1a 100%);\n}\n\n.bg-gradient-yellow-red,\n.bg-gradient-yellow-red-diagonal-down,\n.bg-gradient-yellow-red-diagonal-up,\n.bg-gradient-yellow-red-to-right {\n  background: #ffd900;\n}\n\n.bg-gradient-yellow-red {\n  background: -moz-linear-gradient(to bottom, #ffd900 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to bottom, #ffd900 0%, #ff5b57 100%);\n  background: linear-gradient(to bottom, #ffd900 0%, #ff5b57 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-yellow-red-to-right,\n.bg-gradient-yellow-red-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-yellow-red-to-right {\n  background: -moz-linear-gradient(to right, #ffd900 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to right, #ffd900 0%, #ff5b57 100%);\n  background: linear-gradient(to right, #ffd900 0%, #ff5b57 100%);\n}\n\n.bg-gradient-yellow-red-to-top {\n  background: -moz-linear-gradient(to top, #ffd900 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to top, #ffd900 0%, #ff5b57 100%);\n  background: linear-gradient(to top, #ffd900 0%, #ff5b57 100%);\n}\n\n.bg-gradient-yellow-red-to-left {\n  background: -moz-linear-gradient(to left, #ffd900 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(to left, #ffd900 0%, #ff5b57 100%);\n  background: linear-gradient(to left, #ffd900 0%, #ff5b57 100%);\n}\n\n.bg-gradient-yellow-red-diagonal-down,\n.bg-gradient-yellow-red-diagonal-up,\n.bg-gradient-yellow-red-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-yellow-red-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #ffd900 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(-45deg, #ffd900 0%, #ff5b57 100%);\n  background: linear-gradient(-45deg, #ffd900 0%, #ff5b57 100%);\n}\n\n.bg-gradient-yellow-red-diagonal-up {\n  background: -moz-linear-gradient(45deg, #ffd900 0%, #ff5b57 100%);\n  background: -webkit-linear-gradient(45deg, #ffd900 0%, #ff5b57 100%);\n  background: linear-gradient(45deg, #ffd900 0%, #ff5b57 100%);\n}\n\n.bg-gradient-teal-green,\n.bg-gradient-teal-green-diagonal-down,\n.bg-gradient-teal-green-diagonal-up,\n.bg-gradient-teal-green-to-right {\n  background: #00acac;\n}\n\n.bg-gradient-teal-green {\n  background: -moz-linear-gradient(to bottom, #00acac 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to bottom, #00acac 0%, #32a932 100%);\n  background: linear-gradient(to bottom, #00acac 0%, #32a932 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-teal-green-to-right,\n.bg-gradient-teal-green-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-teal-green-to-right {\n  background: -moz-linear-gradient(to right, #00acac 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to right, #00acac 0%, #32a932 100%);\n  background: linear-gradient(to right, #00acac 0%, #32a932 100%);\n}\n\n.bg-gradient-teal-green-to-top {\n  background: -moz-linear-gradient(to top, #00acac 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to top, #00acac 0%, #32a932 100%);\n  background: linear-gradient(to top, #00acac 0%, #32a932 100%);\n}\n\n.bg-gradient-teal-green-to-left {\n  background: -moz-linear-gradient(to left, #00acac 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to left, #00acac 0%, #32a932 100%);\n  background: linear-gradient(to left, #00acac 0%, #32a932 100%);\n}\n\n.bg-gradient-teal-green-diagonal-down,\n.bg-gradient-teal-green-diagonal-up,\n.bg-gradient-teal-green-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-teal-green-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #00acac 0%, #32a932 100%);\n  background: -webkit-linear-gradient(-45deg, #00acac 0%, #32a932 100%);\n  background: linear-gradient(-45deg, #00acac 0%, #32a932 100%);\n}\n\n.bg-gradient-teal-green-diagonal-up {\n  background: -moz-linear-gradient(45deg, #00acac 0%, #32a932 100%);\n  background: -webkit-linear-gradient(45deg, #00acac 0%, #32a932 100%);\n  background: linear-gradient(45deg, #00acac 0%, #32a932 100%);\n}\n\n.bg-gradient-yellow-green,\n.bg-gradient-yellow-green-diagonal-down,\n.bg-gradient-yellow-green-diagonal-up,\n.bg-gradient-yellow-green-to-right {\n  background: #ffd900;\n}\n\n.bg-gradient-yellow-green {\n  background: -moz-linear-gradient(to bottom, #ffd900 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to bottom, #ffd900 0%, #32a932 100%);\n  background: linear-gradient(to bottom, #ffd900 0%, #32a932 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-yellow-green-to-right,\n.bg-gradient-yellow-green-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-yellow-green-to-right {\n  background: -moz-linear-gradient(to right, #ffd900 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to right, #ffd900 0%, #32a932 100%);\n  background: linear-gradient(to right, #ffd900 0%, #32a932 100%);\n}\n\n.bg-gradient-yellow-green-to-top {\n  background: -moz-linear-gradient(to top, #ffd900 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to top, #ffd900 0%, #32a932 100%);\n  background: linear-gradient(to top, #ffd900 0%, #32a932 100%);\n}\n\n.bg-gradient-yellow-green-to-left {\n  background: -moz-linear-gradient(to left, #ffd900 0%, #32a932 100%);\n  background: -webkit-linear-gradient(to left, #ffd900 0%, #32a932 100%);\n  background: linear-gradient(to left, #ffd900 0%, #32a932 100%);\n}\n\n.bg-gradient-yellow-green-diagonal-down,\n.bg-gradient-yellow-green-diagonal-up,\n.bg-gradient-yellow-green-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-yellow-green-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #ffd900 0%, #32a932 100%);\n  background: -webkit-linear-gradient(-45deg, #ffd900 0%, #32a932 100%);\n  background: linear-gradient(-45deg, #ffd900 0%, #32a932 100%);\n}\n\n.bg-gradient-yellow-green-diagonal-up {\n  background: -moz-linear-gradient(45deg, #ffd900 0%, #32a932 100%);\n  background: -webkit-linear-gradient(45deg, #ffd900 0%, #32a932 100%);\n  background: linear-gradient(45deg, #ffd900 0%, #32a932 100%);\n}\n\n.bg-gradient-blue-purple,\n.bg-gradient-blue-purple-diagonal-down,\n.bg-gradient-blue-purple-diagonal-up,\n.bg-gradient-blue-purple-to-right {\n  background: #348fe2;\n}\n\n.bg-gradient-blue-purple {\n  background: -moz-linear-gradient(to bottom, #348fe2 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to bottom, #348fe2 0%, #727cb6 100%);\n  background: linear-gradient(to bottom, #348fe2 0%, #727cb6 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-blue-purple-to-right,\n.bg-gradient-blue-purple-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-blue-purple-to-right {\n  background: -moz-linear-gradient(to right, #348fe2 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to right, #348fe2 0%, #727cb6 100%);\n  background: linear-gradient(to right, #348fe2 0%, #727cb6 100%);\n}\n\n.bg-gradient-blue-purple-to-top {\n  background: -moz-linear-gradient(to top, #348fe2 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to top, #348fe2 0%, #727cb6 100%);\n  background: linear-gradient(to top, #348fe2 0%, #727cb6 100%);\n}\n\n.bg-gradient-blue-purple-to-left {\n  background: -moz-linear-gradient(to left, #348fe2 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to left, #348fe2 0%, #727cb6 100%);\n  background: linear-gradient(to left, #348fe2 0%, #727cb6 100%);\n}\n\n.bg-gradient-blue-purple-diagonal-down,\n.bg-gradient-blue-purple-diagonal-up,\n.bg-gradient-blue-purple-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-blue-purple-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #348fe2 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(-45deg, #348fe2 0%, #727cb6 100%);\n  background: linear-gradient(-45deg, #348fe2 0%, #727cb6 100%);\n}\n\n.bg-gradient-blue-purple-diagonal-up {\n  background: -moz-linear-gradient(45deg, #348fe2 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(45deg, #348fe2 0%, #727cb6 100%);\n  background: linear-gradient(45deg, #348fe2 0%, #727cb6 100%);\n}\n\n.bg-gradient-cyan-blue,\n.bg-gradient-cyan-blue-diagonal-down,\n.bg-gradient-cyan-blue-diagonal-up,\n.bg-gradient-cyan-blue-to-right {\n  background: #49b6d6;\n}\n\n.bg-gradient-cyan-blue {\n  background: -moz-linear-gradient(to bottom, #49b6d6 0%, #348fe2 100%);\n  background: -webkit-linear-gradient(to bottom, #49b6d6 0%, #348fe2 100%);\n  background: linear-gradient(to bottom, #49b6d6 0%, #348fe2 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-cyan-blue-to-right,\n.bg-gradient-cyan-blue-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-cyan-blue-to-right {\n  background: -moz-linear-gradient(to right, #49b6d6 0%, #348fe2 100%);\n  background: -webkit-linear-gradient(to right, #49b6d6 0%, #348fe2 100%);\n  background: linear-gradient(to right, #49b6d6 0%, #348fe2 100%);\n}\n\n.bg-gradient-cyan-blue-to-top {\n  background: -moz-linear-gradient(to top, #49b6d6 0%, #348fe2 100%);\n  background: -webkit-linear-gradient(to top, #49b6d6 0%, #348fe2 100%);\n  background: linear-gradient(to top, #49b6d6 0%, #348fe2 100%);\n}\n\n.bg-gradient-cyan-blue-to-left {\n  background: -moz-linear-gradient(to left, #49b6d6 0%, #348fe2 100%);\n  background: -webkit-linear-gradient(to left, #49b6d6 0%, #348fe2 100%);\n  background: linear-gradient(to left, #49b6d6 0%, #348fe2 100%);\n}\n\n.bg-gradient-cyan-blue-diagonal-down,\n.bg-gradient-cyan-blue-diagonal-up,\n.bg-gradient-cyan-blue-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-cyan-blue-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #49b6d6 0%, #348fe2 100%);\n  background: -webkit-linear-gradient(-45deg, #49b6d6 0%, #348fe2 100%);\n  background: linear-gradient(-45deg, #49b6d6 0%, #348fe2 100%);\n}\n\n.bg-gradient-cyan-blue-diagonal-up {\n  background: -moz-linear-gradient(45deg, #49b6d6 0%, #348fe2 100%);\n  background: -webkit-linear-gradient(45deg, #49b6d6 0%, #348fe2 100%);\n  background: linear-gradient(45deg, #49b6d6 0%, #348fe2 100%);\n}\n\n.bg-gradient-cyan-purple,\n.bg-gradient-cyan-purple-diagonal-down,\n.bg-gradient-cyan-purple-diagonal-up,\n.bg-gradient-cyan-purple-to-right {\n  background: #49b6d6;\n}\n\n.bg-gradient-cyan-purple {\n  background: -moz-linear-gradient(to bottom, #49b6d6 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to bottom, #49b6d6 0%, #727cb6 100%);\n  background: linear-gradient(to bottom, #49b6d6 0%, #727cb6 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-cyan-purple-to-right,\n.bg-gradient-cyan-purple-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-cyan-purple-to-right {\n  background: -moz-linear-gradient(to right, #49b6d6 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to right, #49b6d6 0%, #727cb6 100%);\n  background: linear-gradient(to right, #49b6d6 0%, #727cb6 100%);\n}\n\n.bg-gradient-cyan-purple-to-top {\n  background: -moz-linear-gradient(to top, #49b6d6 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to top, #49b6d6 0%, #727cb6 100%);\n  background: linear-gradient(to top, #49b6d6 0%, #727cb6 100%);\n}\n\n.bg-gradient-cyan-purple-to-left {\n  background: -moz-linear-gradient(to left, #49b6d6 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(to left, #49b6d6 0%, #727cb6 100%);\n  background: linear-gradient(to left, #49b6d6 0%, #727cb6 100%);\n}\n\n.bg-gradient-cyan-purple-diagonal-down,\n.bg-gradient-cyan-purple-diagonal-up,\n.bg-gradient-cyan-purple-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-cyan-purple-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #49b6d6 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(-45deg, #49b6d6 0%, #727cb6 100%);\n  background: linear-gradient(-45deg, #49b6d6 0%, #727cb6 100%);\n}\n\n.bg-gradient-cyan-purple-diagonal-up {\n  background: -moz-linear-gradient(45deg, #49b6d6 0%, #727cb6 100%);\n  background: -webkit-linear-gradient(45deg, #49b6d6 0%, #727cb6 100%);\n  background: linear-gradient(45deg, #49b6d6 0%, #727cb6 100%);\n}\n\n.bg-gradient-cyan-indigo,\n.bg-gradient-cyan-indigo-diagonal-down,\n.bg-gradient-cyan-indigo-diagonal-up,\n.bg-gradient-cyan-indigo-to-right {\n  background: #49b6d6;\n}\n\n.bg-gradient-cyan-indigo {\n  background: -moz-linear-gradient(to bottom, #49b6d6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to bottom, #49b6d6 0%, #8753de 100%);\n  background: linear-gradient(to bottom, #49b6d6 0%, #8753de 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-cyan-indigo-to-right,\n.bg-gradient-cyan-indigo-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-cyan-indigo-to-right {\n  background: -moz-linear-gradient(to right, #49b6d6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to right, #49b6d6 0%, #8753de 100%);\n  background: linear-gradient(to right, #49b6d6 0%, #8753de 100%);\n}\n\n.bg-gradient-cyan-indigo-to-top {\n  background: -moz-linear-gradient(to top, #49b6d6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to top, #49b6d6 0%, #8753de 100%);\n  background: linear-gradient(to top, #49b6d6 0%, #8753de 100%);\n}\n\n.bg-gradient-cyan-indigo-to-left {\n  background: -moz-linear-gradient(to left, #49b6d6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to left, #49b6d6 0%, #8753de 100%);\n  background: linear-gradient(to left, #49b6d6 0%, #8753de 100%);\n}\n\n.bg-gradient-cyan-indigo-diagonal-down,\n.bg-gradient-cyan-indigo-diagonal-up,\n.bg-gradient-cyan-indigo-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-cyan-indigo-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #49b6d6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(-45deg, #49b6d6 0%, #8753de 100%);\n  background: linear-gradient(-45deg, #49b6d6 0%, #8753de 100%);\n}\n\n.bg-gradient-cyan-indigo-diagonal-up {\n  background: -moz-linear-gradient(45deg, #49b6d6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(45deg, #49b6d6 0%, #8753de 100%);\n  background: linear-gradient(45deg, #49b6d6 0%, #8753de 100%);\n}\n\n.bg-gradient-blue-indigo,\n.bg-gradient-blue-indigo-diagonal-down,\n.bg-gradient-blue-indigo-diagonal-up,\n.bg-gradient-blue-indigo-to-right {\n  background: #348fe2;\n}\n\n.bg-gradient-blue-indigo {\n  background: -moz-linear-gradient(to bottom, #348fe2 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to bottom, #348fe2 0%, #8753de 100%);\n  background: linear-gradient(to bottom, #348fe2 0%, #8753de 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-blue-indigo-to-right,\n.bg-gradient-blue-indigo-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-blue-indigo-to-right {\n  background: -moz-linear-gradient(to right, #348fe2 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to right, #348fe2 0%, #8753de 100%);\n  background: linear-gradient(to right, #348fe2 0%, #8753de 100%);\n}\n\n.bg-gradient-blue-indigo-to-top {\n  background: -moz-linear-gradient(to top, #348fe2 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to top, #348fe2 0%, #8753de 100%);\n  background: linear-gradient(to top, #348fe2 0%, #8753de 100%);\n}\n\n.bg-gradient-blue-indigo-to-left {\n  background: -moz-linear-gradient(to left, #348fe2 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to left, #348fe2 0%, #8753de 100%);\n  background: linear-gradient(to left, #348fe2 0%, #8753de 100%);\n}\n\n.bg-gradient-blue-indigo-diagonal-down,\n.bg-gradient-blue-indigo-diagonal-up,\n.bg-gradient-blue-indigo-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-blue-indigo-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #348fe2 0%, #8753de 100%);\n  background: -webkit-linear-gradient(-45deg, #348fe2 0%, #8753de 100%);\n  background: linear-gradient(-45deg, #348fe2 0%, #8753de 100%);\n}\n\n.bg-gradient-blue-indigo-diagonal-up {\n  background: -moz-linear-gradient(45deg, #348fe2 0%, #8753de 100%);\n  background: -webkit-linear-gradient(45deg, #348fe2 0%, #8753de 100%);\n  background: linear-gradient(45deg, #348fe2 0%, #8753de 100%);\n}\n\n.bg-gradient-purple-indigo,\n.bg-gradient-purple-indigo-diagonal-down,\n.bg-gradient-purple-indigo-diagonal-up,\n.bg-gradient-purple-indigo-to-right {\n  background: #727cb6;\n}\n\n.bg-gradient-purple-indigo {\n  background: -moz-linear-gradient(to bottom, #727cb6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to bottom, #727cb6 0%, #8753de 100%);\n  background: linear-gradient(to bottom, #727cb6 0%, #8753de 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-purple-indigo-to-right,\n.bg-gradient-purple-indigo-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-purple-indigo-to-right {\n  background: -moz-linear-gradient(to right, #727cb6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to right, #727cb6 0%, #8753de 100%);\n  background: linear-gradient(to right, #727cb6 0%, #8753de 100%);\n}\n\n.bg-gradient-purple-indigo-to-top {\n  background: -moz-linear-gradient(to top, #727cb6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to top, #727cb6 0%, #8753de 100%);\n  background: linear-gradient(to top, #727cb6 0%, #8753de 100%);\n}\n\n.bg-gradient-purple-indigo-to-left {\n  background: -moz-linear-gradient(to left, #727cb6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(to left, #727cb6 0%, #8753de 100%);\n  background: linear-gradient(to left, #727cb6 0%, #8753de 100%);\n}\n\n.bg-gradient-purple-indigo-diagonal-down,\n.bg-gradient-purple-indigo-diagonal-up,\n.bg-gradient-purple-indigo-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-purple-indigo-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #727cb6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(-45deg, #727cb6 0%, #8753de 100%);\n  background: linear-gradient(-45deg, #727cb6 0%, #8753de 100%);\n}\n\n.bg-gradient-purple-indigo-diagonal-up {\n  background: -moz-linear-gradient(45deg, #727cb6 0%, #8753de 100%);\n  background: -webkit-linear-gradient(45deg, #727cb6 0%, #8753de 100%);\n  background: linear-gradient(45deg, #727cb6 0%, #8753de 100%);\n}\n\n.bg-gradient-silver-black,\n.bg-gradient-silver-black-diagonal-down,\n.bg-gradient-silver-black-diagonal-up,\n.bg-gradient-silver-black-to-right {\n  background: #b6c2c9;\n}\n\n.bg-gradient-silver-black {\n  background: -moz-linear-gradient(to bottom, #b6c2c9 0%, #000 100%);\n  background: -webkit-linear-gradient(to bottom, #b6c2c9 0%, #000 100%);\n  background: linear-gradient(to bottom, #b6c2c9 0%, #000 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=0);\n}\n\n.bg-gradient-silver-black-to-right,\n.bg-gradient-silver-black-to-top {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-silver-black-to-right {\n  background: -moz-linear-gradient(to right, #b6c2c9 0%, #000 100%);\n  background: -webkit-linear-gradient(to right, #b6c2c9 0%, #000 100%);\n  background: linear-gradient(to right, #b6c2c9 0%, #000 100%);\n}\n\n.bg-gradient-silver-black-to-top {\n  background: -moz-linear-gradient(to top, #b6c2c9 0%, #000 100%);\n  background: -webkit-linear-gradient(to top, #b6c2c9 0%, #000 100%);\n  background: linear-gradient(to top, #b6c2c9 0%, #000 100%);\n}\n\n.bg-gradient-silver-black-to-left {\n  background: -moz-linear-gradient(to left, #b6c2c9 0%, #000 100%);\n  background: -webkit-linear-gradient(to left, #b6c2c9 0%, #000 100%);\n  background: linear-gradient(to left, #b6c2c9 0%, #000 100%);\n}\n\n.bg-gradient-silver-black-diagonal-down,\n.bg-gradient-silver-black-diagonal-up,\n.bg-gradient-silver-black-to-left {\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='$from', endColorstr='$to', GradientType=1);\n}\n\n.bg-gradient-silver-black-diagonal-down {\n  background: -moz-linear-gradient(-45deg, #b6c2c9 0%, #000 100%);\n  background: -webkit-linear-gradient(-45deg, #b6c2c9 0%, #000 100%);\n  background: linear-gradient(-45deg, #b6c2c9 0%, #000 100%);\n}\n\n.bg-gradient-silver-black-diagonal-up {\n  background: -moz-linear-gradient(45deg, #b6c2c9 0%, #000 100%);\n  background: -webkit-linear-gradient(45deg, #b6c2c9 0%, #000 100%);\n  background: linear-gradient(45deg, #b6c2c9 0%, #000 100%);\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-9 {\n  opacity: 0.9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.with-shadow {\n  box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.1) !important;\n}\n\n.hide {\n  display: none !important;\n}\n\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n.img-rounded {\n  border-radius: 0.375rem;\n}\n\n.img-circle {\n  border-radius: 50%;\n}\n\n.valign-top {\n  vertical-align: top !important;\n}\n\n.valign-bottom {\n  vertical-align: bottom !important;\n}\n\n.valign-middle {\n  vertical-align: middle !important;\n}\n\n.table-no-border-left tbody tr td,\n.table-no-border-left tbody tr th,\n.table-no-border-left thead tr td,\n.table-no-border-left thead tr th {\n  border-left: none;\n}\n\n.table-no-border-right tbody tr td,\n.table-no-border-right tbody tr th,\n.table-no-border-right thead tr td,\n.table-no-border-right thead tr th {\n  border-right: none;\n}\n\n.text-gradient {\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n}\n\n.row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.row > [class^=\"col-\"] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.row.row-space-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.row.row-space-2 {\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.row.row-space-4 {\n  margin-left: -2px;\n  margin-right: -2px;\n}\n\n.row.row-space-6 {\n  margin-left: -3px;\n  margin-right: -3px;\n}\n\n.row.row-space-8 {\n  margin-left: -4px;\n  margin-right: -4px;\n}\n\n.row.row-space-10 {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.row.row-space-12 {\n  margin-left: -6px;\n  margin-right: -6px;\n}\n\n.row.row-space-14 {\n  margin-left: -7px;\n  margin-right: -7px;\n}\n\n.row.row-space-16 {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n\n.row.row-space-18 {\n  margin-left: -9px;\n  margin-right: -9px;\n}\n\n.row.row-space-20 {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.row.row-space-22 {\n  margin-left: -11px;\n  margin-right: -11px;\n}\n\n.row.row-space-24 {\n  margin-left: -12px;\n  margin-right: -12px;\n}\n\n.row.row-space-26 {\n  margin-left: -13px;\n  margin-right: -13px;\n}\n\n.row.row-space-28 {\n  margin-left: -14px;\n  margin-right: -14px;\n}\n\n.row.row-space-30 {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.row.row-space-0 > [class^=\"col-\"] {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.row.row-space-2 > [class^=\"col-\"] {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n\n.row.row-space-4 > [class^=\"col-\"] {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.row.row-space-6 > [class^=\"col-\"] {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.row.row-space-8 > [class^=\"col-\"] {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n.row.row-space-10 > [class^=\"col-\"] {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.row.row-space-12 > [class^=\"col-\"] {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.row.row-space-14 > [class^=\"col-\"] {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\n.row.row-space-16 > [class^=\"col-\"] {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.row.row-space-18 > [class^=\"col-\"] {\n  padding-left: 9px;\n  padding-right: 9px;\n}\n\n.row.row-space-20 > [class^=\"col-\"] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.row.row-space-22 > [class^=\"col-\"] {\n  padding-left: 11px;\n  padding-right: 11px;\n}\n\n.row.row-space-24 > [class^=\"col-\"] {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.row.row-space-26 > [class^=\"col-\"] {\n  padding-left: 13px;\n  padding-right: 13px;\n}\n\n.row.row-space-28 > [class^=\"col-\"] {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n\n.row.row-space-30 > [class^=\"col-\"] {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.height-xs {\n  height: 150px !important;\n}\n\n.height-sm {\n  height: 300px !important;\n}\n\n.height-md {\n  height: 450px !important;\n}\n\n.height-lg {\n  height: 600px !important;\n}\n\n.height-full {\n  height: 100% !important;\n}\n\n.height-0 {\n  height: 0 !important;\n}\n\n.height-10 {\n  height: 10px !important;\n}\n\n.height-20 {\n  height: 20px !important;\n}\n\n.height-30 {\n  height: 30px !important;\n}\n\n.height-40 {\n  height: 40px !important;\n}\n\n.height-50 {\n  height: 50px !important;\n}\n\n.height-60 {\n  height: 60px !important;\n}\n\n.height-70 {\n  height: 70px !important;\n}\n\n.height-80 {\n  height: 80px !important;\n}\n\n.height-90 {\n  height: 90px !important;\n}\n\n.height-100 {\n  height: 100px !important;\n}\n\n.height-150 {\n  height: 150px !important;\n}\n\n.height-200 {\n  height: 200px !important;\n}\n\n.height-250 {\n  height: 250px !important;\n}\n\n.height-300 {\n  height: 300px !important;\n}\n\n.height-350 {\n  height: 350px !important;\n}\n\n.height-400 {\n  height: 400px !important;\n}\n\n.height-450 {\n  height: 450px !important;\n}\n\n.height-500 {\n  height: 500px !important;\n}\n\n.height-550 {\n  height: 550px !important;\n}\n\n.height-600 {\n  height: 600px !important;\n}\n\n.wrapper {\n  padding: 15px;\n}\n\n.width-xs {\n  width: 150px !important;\n}\n\n.width-sm {\n  width: 300px !important;\n}\n\n.width-md {\n  width: 450px !important;\n}\n\n.width-lg {\n  width: 600px !important;\n}\n\n.width-full {\n  width: 100% !important;\n}\n\n.width-0 {\n  width: 0 !important;\n}\n\n.width-10 {\n  width: 10px !important;\n}\n\n.width-20 {\n  width: 20px !important;\n}\n\n.width-30 {\n  width: 30px !important;\n}\n\n.width-40 {\n  width: 40px !important;\n}\n\n.width-50 {\n  width: 50px !important;\n}\n\n.width-60 {\n  width: 60px !important;\n}\n\n.width-70 {\n  width: 70px !important;\n}\n\n.width-80 {\n  width: 80px !important;\n}\n\n.width-90 {\n  width: 90px !important;\n}\n\n.width-100 {\n  width: 100px !important;\n}\n\n.width-150 {\n  width: 150px !important;\n}\n\n.width-200 {\n  width: 200px !important;\n}\n\n.width-250 {\n  width: 250px !important;\n}\n\n.width-300 {\n  width: 300px !important;\n}\n\n.width-350 {\n  width: 350px !important;\n}\n\n.width-400 {\n  width: 400px !important;\n}\n\n.width-450 {\n  width: 450px !important;\n}\n\n.width-500 {\n  width: 500px !important;\n}\n\n.width-550 {\n  width: 550px !important;\n}\n\n.width-600 {\n  width: 600px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
